module.exports={
"label_emailtocloudcc_department":`Dipartimento`,
"label.wei.weiresearch":`Micro voto`,
"message.error.appsecret.null":`La password della chiave segreta non può essere nulla!`,
"label.file.orderbylastmodifydate":`Ordinato in base all'ultima volta che è stato modificato`,
"label.minus":`-Minus`,
"label.horizontalbar":`Linee orizzontali`,
"label.emailobject.emailsentfailed":`La posta non è stata inviata!`,
"assignedresource.check":`Questa risorsa di servizio è stata assegnata a un appuntamento di servizio. Si prega di non aggiungere ripetutamente.`,
"label.finish":`Completa`,
"label.document.history":`Scaricare la storia`,
"label.customfields.number.numberLengthHelpText":`1.Inserire la lunghezza del numero e il numero di cifre decimali. Per esempio, un numero con una lunghezza di 8 e 2 cifre decimali può accettare valori fino a "12345678.90".`,
"label.standard.buttonandlink.info":`Sovrascrivere i pulsanti e i link standard cambia il significato dell'URL CloudCC.com e qualsiasi chiamata a quell'URL come una pagina personalizzata CloudCC.com, un collegamento del browser o un sistema esterno. Puoi sostituire l'URL CloudCC.com per un pulsante o un link standard con una pagina personalizzata.`,
"front-epwechat-module-v1-contacts-desc":`Quando è abilitato, l'oggetto dei Contatti WeCom sarà aggiunto nel sistema CloudCC, le informazioni del cliente da WeCom saranno sincronizzate con questo oggetto.`,
"label.mr.caption.contact.result":`Trova i duplicati e unisci: Risultati per la ricerca di duplicati di contatti`,
"label.ems.selectaccount":`Seleziona l'account`,
"label.group.no.activity":`Non ci sono gruppi attivi corrispondenti.`,
"label.call.for":`Invitato da`,
"label.newreportguide":`Nuova guida ai rapporti`,
"component.telerecord.label.name":`Nomi`,
"vue.add.dashboard.component":`Aggiungere il componente {titleName}`,
"label.chatter.sendEmailToGroupMember.check.V":`Visualizza i voti`,
"UG.ST.002":`Determinare`,
"label.setting.intergrationmanage":`Gestione dell'integrazione`,
"label.field.apiname.validate":`Inserisci un numero tra 0 e 6.`,
"label.emailmerge.list.deletefolder":`Cancellare la cartella`,
"vue_label_pool_received":`Ricevuto`,
"label_emailtocloudcc_step1_case1":`Email al caso`,
"message.sumlength":`La somma della lunghezza e del numero di cifre decimali non può superare i 18 pesi.`,
"vue_label_approve_reassignapproval":`{nome} ha riassegnato questa approvazione a {persone}`,
"label.specify.time":`Ora: 13:00 giugno, 21 giugno 2016`,
"vue_label_report_sortdown":`Ordina in ordine decrescente`,
"chatter.login.now":`Caricamento...`,
"label.import.page2.notsuited":`Unmapped`,
"label.please.fill.out":`Si prega di compilare`,
"label.recordtype.edit.description":`Seleziona un valore da "Valori disponibili", poi aggiungilo a "Valori selezionati" e rendilo un valore di picklist per questo tipo di record. Nota che l'eliminazione di un valore dalla picklist non rimuove questo valore da nessun record esistente. Infine, seleziona il valore predefinito dell'elenco di selezione per il tipo di record.`,
"label.customer.tab.new":`Scheda Nuovo Cliente`,
"label.sameas":`Uguale a`,
"front-filter-module-v1-filter-a-week-ago":`Una settimana fa`,
"label.processsetting.disable.process.failed":`Impossibile disattivare il processo!`,
"label.summaryreport.2018.step4":`Passo 4 Selezionare i criteri del rapporto`,
"label.secrecyinfo":`Informazioni riservate, non diffondere`,
"label.custom.page.component.general.settings":`Impostazioni generali dei componenti`,
"label.ccpeak.folder":`Cartelle di classe non archiviate`,
"vue_label_homepage_select_button_operation":`Seleziona il pulsante`,
"message.pleaseinputrightdistance":`Inserisci i giorni di intervallo corretti`,
"label.mobile.phone.required.short":`è richiesto`,
"vue_label_account_equityseructure":`Struttura azionaria`,
"label.file.library.error1":`Questo file è già presente in questa libreria.`,
"fliter.nextmonth":`Mese successivo`,
"label.mr.descreption.oneGroupNote2":`insieme di informazioni aziendali, ci sono`,
"label.allfolderdashboard":`Tutte le cartelle del cruscotto`,
"lable.opppdt.selPdt.bykeywords":`Per parola chiave`,
"setup_layout_label_selectedfield":`Seleziona i campi`,
"label.file.preview.convert.firstpage.failure":`Si è verificato un errore durante il preveiw, si prega di fare clic su dettagli di anteprima o scaricare per visualizzare`,
"vue_label_systemSettings_companie":`Impostazione dell'azienda`,
"label.loginhis.recently":`Storia di accesso recente`,
"label.permission.visualpagepermission.edit":`Assegnazione pagina personalizzata`,
"label.ccservice.validate.email":`Il formato del valore corrispondente {2} del campo {1} sotto l'oggetto API {0} non è corretto.`,
"label.sms.companyname.gm":`Impostazione SMS-2`,
"lable.opppdt.addpdt.table.discount":`Sconto (% di sconto)`,
"Lead.Scoring.Setting.LevelSetting":`Impostazioni di popolarità del piombo`,
"message.duplication.label.duplicationremark":`è l'operazione di interrogazione dei dati duplicati quando i record nuovi o modificati`,
"label.file.preview.error":`Si è verificato un errore durante il preveiw, si prega di scaricare per visualizzare`,
"label.imgfield.type.input":`Inserisci immagine`,
"label.file.share.email.content1":`Nome del file: #nomefile`,
"vue_label_notice_batchedit_fail":`L'aggiornamento dei dati con id {0} fallisce con motivo di fallimento {1}`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.four":`Quattro`,
"label.view.sortview.printview":`Stampa`,
"label.projectManagement.Addposttask":`Aggiungere il post-task`,
"vue_label_commonobjects_view_fail":`Impossibile impostare la vista predefinita`,
"label.dayinweek":`Settimana`,
"label.layout.notexist":`Il layout non esiste.`,
"label.brief.total":`Registra il {totale}`,
"label.dashboardSetup.tz.bb":`Vai ai rapporti`,
"label_emailtocloudcc_select3":`Seleziona il proprietario del disco`,
"label.input.least.string":`Inserisci almeno {0} caratteri`,
"label.app.step2":`Passo 2 Inserire i dettagli`,
"lable.account.LastWeek":`La settimana scorsa`,
"label.notifications":`Notifiche`,
"label.tabpage.viewname":`Visualizza il nome`,
"label.knowledge.language.italian":`Italiano`,
"label.sendmail.step2.introduce":`Scegliere un modello di e-mail`,
"label_enable_or_no":`Vuoi abilitare ?`,
"pagecreator_button_save":`Salva`,
"template.chart.cplb":`Categoria di prodotto`,
"label.knowledge.publish":`Non può essere pubblicato perché non è qualificato.`,
"label.name.required":`Il campo nome è richiesto`,
"component.chatter.label.myfans":`I miei seguaci`,
"label.rejectoperate":`Azioni di rifiuto`,
"label.report.action.addtodashboard3":`Seleziona Dashboard`,
"label.icon.101":`Libro di testo`,
"label.data.exp.su.ok":`Esportazione di`,
"label.appupload.component.type.layout":`Layout di pagina`,
"template.chart.yscb":`Costo preventivato`,
"label.tabularreport.selectorder":`Determinare l'ordine di visualizzazione di ogni colonna del rapporto`,
"email.title.one":`Recuperare la password`,
"label.case.copy.link":`Copia collegamento web`,
"label.mr.descreption.oneGroupReData4":`gruppo, sta rimanendo`,
"label.newprocess5.error.des":`Si possono inserire solo numeri.`,
"label.partnerCloud.loginButton":`Pulsante di accesso`,
"label.interfaceconstraint.adminonly":`Solo gli amministratori possono usare questa interfaccia.`,
"label.campaign.channel.input.date":`2. Imposta il periodo di validità per il tuo canale di marketing:`,
"label.clientwebsiteentranceprofile":`Profilo del portale del cliente`,
"UG.opportunity.011":`Importazione di transazioni`,
"label.page.copy.value.paste.template":`Copia e incolla il valore del campo merge nel tuo modello qui sotto.`,
"label.notselect":`No Seleziona`,
"label.weixin.input.password":`Inserisci la tua password.`,
"label.email.select.template":`Seleziona il modello`,
"label_chatter_ok":`Confermare`,
"permissionService.error":`L'assegnazione del set di autorizzazioni non è riuscita, controlla se la licenza dell'applicazione è scaduta o se l'assegnazione ha raggiunto il limite superiore.`,
"label.webtocloudcc.sorry":`Spiacente, errore di pagina, riprova o contatta il tuo amministratore.`,
"UG.opportunity.007":`Ruolo di contatto`,
"label.manageAll.forapproval":`Punti da approvare`,
"label.imgfield.type.ref":`Formula Immagine`,
"label.profile.setcustomtab":`Impostazioni della scheda personalizzata`,
"label.tabpage.datatyoez":`Tipo di dati`,
"label.partnerCloud.basicSetting.editPersonal":`Permettere agli utenti del cloud partner di modificare le informazioni personali`,
"label.mr.caption.account":`Trova i duplicati e unisci: Codizioni per la ricerca di duplicati di conti`,
"message.serviceterritoryMe.time.violation":`Violazione del tempo di invio: il periodo di invio non rientra nell'intervallo di tempo dei membri regionali.`,
"pagecreator_page_message_publish_success":`Pagina pubblicata con successo`,
"label.field.formula.timezonetip":`Notate il supporto per i fusi orari multipli nella gestione delle funzioni di tipo data/ora. quando si usa la funzione di sistema come sysdate in una formula per ottenere l'ora corrente, dovrebbe essere sostituita dalla sua corrispondente funzione per i fusi orari multipli, come current_date.`,
"label.marketseamemset.specialuser":`Membro speciale`,
"label.staticresource.message":`Dettaglio risorsa statica`,
"label.workflow.rulecondition":`Criteri della regola`,
"component_salesperformance_label_nodata":`Aggiungi la tua opportunità di business e torna qui per visualizzare il grafico delle prestazioni.`,
"label.customfields.textarea.tip":`Permette agli utenti di inserire più righe di testo, fino a 4000 caratteri.`,
"font-evaluate-module-v1-template":`Modello personalizzato`,
"label.step3.total5":`Passo 3 di 5`,
"label.customfields.formula.percent.tip":`Calcola una percentuale e aggiunge automaticamente il segno di percentuale al numero.`,
"label.sortdesc":`Scendere`,
"lable.PowerProcess.edit":`Modifica del processo di abilitazione`,
"label.dongshifang.description":`Configura le informazioni del Dongshifang per soddisfare le esigenze dei servizi di invio e ricezione di SMS della tua organizzazione.`,
"label.chatter.addressee":`Destinatario`,
"vue_label_systemSettings_obj2":`Console di gestione degli oggetti`,
"label.selectreporttype.tip":`Scegli il tipo di dati che vuoi includere in questo rapporto`,
"label.version.enterprise":`Edizione Impresa`,
"label.area.add":`Aggiungere il territorio`,
"label.h5.bookmarked":`Segnalibri`,
"label.step5.total7":`Passo 5 di 7`,
"front-lightning-module-v1-title-quotation":`Anteprima Preventivo`,
"label.search.onlymyrecords":`Limitare agli oggetti che possiedo`,
"vue_label_commonobjects_noduplication":`Duplicato di {字段} in {记录}`,
"label.customerpage.edit":`Modificare le schede sulle pagine personalizzate`,
"message.please.choose.user":`Seleziona l'utente`,
"label.approval.his.currentactor":`Approvazione corrente`,
"label.field.duplicate.error.msg3":`Si possono creare al massimo 3 campi di proprietà unici.`,
"label.page_url":`URL della pagina`,
"label.permission.goback":`Torna a Set di autorizzazioni`,
"vue_label_commonobjects_view_kanban_notice2":`Per visualizzare tutti i record, usa la vista elenco o la vista a schermo diviso`,
"label.group.no.recent.searchs":`Non ci sono gruppi visualizzati di recente che corrispondono.`,
"label.event.fiducial.point":`puntuale`,
"label.integrations.mailchimp.addtolist":`Aggiungi i lead e i contatti selezionati dal tuo account CloudCC alla tua lista Mailchimp`,
"label.workflow.configrule.introduce":`Inserisci il nome, la descrizione e i criteri per attivare la regola del flusso di lavoro. Nel passo successivo, associa le azioni del flusso di lavoro a questa regola del flusso di lavoro.`,
"label.icon.161":`Valigia`,
"label.recordtype.enable":`Attivo`,
"label_mailboxes_limit":`Il numero di mailbox supera il limite.`,
"label.notification.time3":`{0} ore fa`,
"label.setsharerule.step2":`Passo 2 Selezionare i record da condividere`,
"vue_label_homepage_somecomponents":`Attenzione! Dopo aver aggiunto il componente, l'altezza supera il limite e causa una visualizzazione incompleta. Si prega di eliminare alcuni componenti`,
"label.icon.63":`Pozzo sotterraneo`,
"label.use.standard.sharerules":`Utilizzare le regole di condivisione standard`,
"label.button.step2.select.required.field":`Passo 2 Selezionare i campi richiesti`,
"lable.Confirm.collect.potential.customers":`Conferma la raccolta di lead {nome}`,
"label.version.sum.custompage":`pagina(e) personalizzata(e)`,
"label.file.ccchat.changefile":`Cambiare il file`,
"label.mobile.phone.phone.call":`Chiama`,
"label.appupload.managed.img":`Controllato`,
"vue_label_chatter_comment":`commento`,
"label.central.european.time":`Ora dell'Europa centrale`,
"label.three.quarter":`Terzo trimestre`,
"label.service.newBuildDialog.filter.editor":`Editor di filtri`,
"pagecreator_systemstyle_funcpath":`/ costruttore / libreria di stile di marca`,
"label_chatter_collect":`Segnalibro`,
"label.custom.page.component.window.settings":`Impostazioni della finestra dei componenti`,
"component_chatter_file_label_title":`Caricamento dei file`,
"label.marketsea.button.discard":`Scartare`,
"label.Batch.input":`Ingresso batch`,
"vue_label_campaign_market_members":`Membri del mercato esistenti`,
"label.salescloud.salesdashboard":`Cruscotti di vendita`,
"message.summaryconditionrepeated":`Spiacente, le condizioni di riepilogo sono duplicate, si prega di riselezionare i dati!`,
"label.tianyancha.h5.companycode":`Codice azienda`,
"label.quickbooks.description":`Tieni traccia delle tue fatture, pagamenti e stime di QuickBooks Online.`,
"label.colombia.time":`Tempo di Colombia`,
"label.usermanage.unknown.license":`Licenza non valida, e non puoi creare nuovi utenti, contatta il tuo amministratore.`,
"label.operatedata.selectoperateandobject":`Selezionare l'operazione (Importazione o Esportazione) e gli oggetti`,
"message.setup.field.picklist.valuerepeated":`I valori della lista non possono essere ripetuti, si prega di reinserirli.`,
"label.editerror.list":`L'elenco dei dati non è stato modificato.`,
"pagecreator_page_message_save_success":`Pagina salvata con successo`,
"label.icon.154":`Computer`,
"label.emailsync.setting":`Impostazioni e-mail personali`,
"label.startuploadfile.step2":`Passo 3 Fare clic su "start upload" per caricare i file`,
"label.dashboard.notmeet.conditions":`Non sono state trovate informazioni corrispondenti e il cruscotto non è stato configurato.`,
"label.temp.del.conf":`Sei sicuro di voler cancellare?`,
"label.sms.authkey":`Password di autenticazione`,
"lable.oppt.jieduan.choosejieduan":`Selezionare la fase chiusa`,
"label.tabpage.viewNamez":`Inserisci il nome della vista`,
"label.totalQuotation":`Totale del preventivo`,
"label.tabpage.hoursagoz":`Ore`,
"label.receiveadminnews":`Ricevi il notiziario dell'amministratore`,
"label.field.is.lookup":`Il campo è collegato al campo di ricerca?`,
"label.any_changes":`Qualsiasi modifica fatta qui aggiornerà anche il tuo piè di pagina in`,
"lable.products.to.assets":`Confermare il trasferimento del prodotto all'attività?`,
"label.dashboard.compare":`Confronto`,
"vue_label_chatter_notice1":`Dopo aver cancellato il gruppo, tutte le informazioni nel gruppo saranno cancellate, ma i file del gruppo non saranno cancellati`,
"label_tabpage_exitz":`Logout`,
"label.potentialcustomerflow":`Processi di guida`,
"label.longtext":`Area di testo (lunga)`,
"october":`Ottobre`,
"label.customer.email":`Email`,
"label.partnerCloud.productSet.addChildren":`Aggiungere un sottolivello`,
"label.defaultline.cannot.greater":`Il numero predefinito di linee non dovrebbe superare le 30.`,
"front-detail-module-v1-view-report":`Visualizza il rapporto`,
"label.knowledge.setting.hint.sixteen":`Salvare la conoscenza e continuare a trasmettere`,
"label.page.use.merged.field":`Con campo Merge`,
"label.salescloud.salescloud.continuerecover":`se continua, l'eliminazione sarà fatta e scopribile`,
"front-project-module-v1-from-template-create":`Creare da un modello`,
"label.exportall":`Esportare tutti i record di tutti gli oggetti`,
"label.weixin.recalculate.shared.results":`Ricalcolare i risultati della regola di condivisione`,
"label.components.isTemplate":`Dati del modello`,
"label_emailsync_status":`Stato dell'e-mail dell'utente`,
"label.file.library.delete":`Sei sicuro di voler cancellare {librayrname}？`,
"label.integrations.username":`Nome utente`,
"front-lightningset-module-v1-detail-page-report-chart":`Segnalare i grafici nella pagina dei dettagli`,
"label_tabular":`Layout dell'elenco`,
"label.approverecords":`Approvare`,
"vue_label_helpcenter_topic":`Uso e aiuto della versione Lightning`,
"label.h5.date.none":`Nessuno`,
"lable.outlook.mcto.allrecord":`Tutti i record`,
"label.readandwrite":`Lettura/Scrittura`,
"label.allfold":`Spacca tutto`,
"AD":`Indirizzo`,
"message.custom.field.donotdelete.reporttype":`Il campo è referenziato dall'origine dati del rapporto`,
"label.escalation.setup.newaction.title":`Azione di escalation Modifica`,
"label.dashboard.snapshot.settings":`Impostazioni delle istantanee del cruscotto`,
"label.attendance.inner":`Lavoratore d'ufficio`,
"chatter.ns":`Nuovo messaggio`,
"label.validate.nowork":`Errore: campo non valido, riselezionare la posizione del messaggio di errore.`,
"label.custom.EmptyCanvas":`Tela trasparente`,
"label.service.miniProgram.fillImageOrder":`Inserisci l'ordine del carosello.`,
"label.icon.16":`Servizio`,
"label.selected":`Selezionato`,
"component_chatter_link_label_name":`Nome del link`,
"label.reportsSubscriptionPage.schedulereport.starttime":`Ora di inizio preferita`,
"label.file.uploadNewVersion":`Carica la nuova versione`,
"chatter.group.theMembership":`Iscrizione`,
"label.knowledge.recommended.articles":`Articoli suggeriti`,
"label.appupload.install.parentobj":`Oggetto genitore`,
"label.file.recent":`Recente`,
"vue_label_helpcenter_quote":`Il preventivo rappresenta il prezzo suggerito dei prodotti e servizi della tua azienda. Puoi creare preventivi dalle opportunità e dai loro prodotti.<br>Nell'angolo in alto a destra delle informazioni dettagliate, puoi usare il pulsante per sincronizzare il preventivo dall'opportunità commerciale, o sincronizzare il preventivo all'opportunità commerciale. Quando il preventivo è sincronizzato con l'opportunità, qualsiasi modifica alla linea del preventivo sarà sincronizzata con il prodotto dell'opportunità, e viceversa. Ogni opportunità commerciale può avere più citazioni associate, ognuna delle quali può essere sincronizzata con l'opportunità commerciale.<br>Nell'angolo in alto a destra delle informazioni dettagliate, è possibile generare pdf e visualizzare in anteprima la citazione, e si può direttamente stampare, scaricare o salvare.`,
"message.error.field.default":`Il valore predefinito deve essere un intero positivo.`,
"label.campaignmember.main.importmember.contacts.desc":`Importazione dei contatti della campagna da file.`,
"vue_label_calendar_show_only_this_calendar":`Mostra solo questo calendario`,
"vue_label_quot_syncfrom":`Sincronizzazione da opportunità di business`,
"label.data.expnode.e_desc2":`2. Esportazione per modello: gli utenti possono selezionare il modello per esportare i dati.`,
"label.login.verification.mfa.desc1":`È necessario installare un'applicazione MFA sul tuo dispositivo intelligente per continuare.Applicazioni comuni che supportano MFA su dispositivi intelligenti sono: Cipolle, Google Authenticator.`,
"label.jiandangfenpei.desc":`Assegna l'accesso della pagina personalizzata corrente al profilo. Gli amministratori hanno accesso a tutte le pagine personalizzate.`,
"label_tabpage_thisrecord":`Questo record`,
"lable.SalesCommitmentKanBan.totalPaymentAmount":`Importo delle ricevute di rollup`,
"message.error.object.notvalidcurrency":`Valuta non valida`,
"label.edit.discount":`Modifica sconto`,
"label.setup.mobile.offlinecache.setenable":`Abilita la funzione offline sul lato mobile`,
"UG.ST.005":`Ho capito, non mostrarmi più questa pagina e accedi direttamente la prossima volta.`,
"label.assignedapprover":`Approvatore assegnato`,
"template.chart.htlx":`Statistiche del tipo di contratto`,
"scope":`Nell'ambito del campo di applicazione`,
"label.workmate.search":`Cerca colleghi`,
"message.validation.isnotdigits":`Si prega di inserire il numero non valido`,
"label.ccpeak.use.class.time.page":`Se la classe è chiamata da una pagina personalizzata, chiama il metodo invoker() nella classe PageClsInvoker.`,
"setup_mainpage_label_welcome27":`La piattaforma cloud CloudCC fornisce funzioni come l'importazione, l'esportazione, la cancellazione in batch e il trasferimento in batch di tutti i dati degli oggetti nel sistema.`,
"front-epwechat-module-v1-epwechat-integrate":`Integrazione WeCom`,
"label.file.publiclink":`Collegamento pubblico`,
"front-epwechat-module-v1-input-name":`Inserire il nome dell'impresa`,
"lable.Number.of.columns":`Colonne`,
"message.error.dev.service.duplicateparameter":`Parametri di servizio duplicati.`,
"label.projectManagement.percent.complete":`Percentuale di completamento`,
"label.chatter.nextSevenday":`Prossimi 7 giorni`,
"chatter.feed.myfollowers":`I miei seguaci`,
"label.bacchtransfer.pleaseselecttouser":`Trasferimento a`,
"label_partner_workspace_member_memo":`Tutti gli utenti con il profilo selezionato e il set di permessi possono accedere a questo cloud partner.`,
"label.marketsea.chosen.member":`Membri selezionati`,
"label.marketsea.assignment.setup":`Impostazioni di assegnazione`,
"label.myaccount":`I miei conti`,
"label.schedulejob.setup.schedule.executedate":`Tempo di esecuzione`,
"label.uploadaccessory":`Caricamento degli allegati`,
"Homepage.News.004":`Nessuna notizia recente.`,
"label.marketsea.name":`Nome del pool di piombo`,
"label.pending.task":`Compiti aperti`,
"label.report.details":`Dettagli`,
"UG.homepage.008":`Comprendere lo stato attuale del business (briefing di vendita, classifiche, funnel di vendita, ecc.), visualizzare le opportunità di business che possono essere problematiche, prevedere le prestazioni future, accettare e assegnare tempestivamente le questioni importanti e prendere decisioni informate.`,
"label.h5.similar.opportunity.clear.all":`Cancella tutto`,
"label.tabpage.noz":`No`,
"label.report.recent.all.reports":`Tutti i rapporti`,
"vue_label_lead_to_score":`Clicca su Punteggio per segnare le tracce nella vista corrente.`,
"vue_label_normal_receivable_sf":`Crediti`,
"label.layout.edittabdistribute":`Modifica del layout delle schede`,
"label.validate.function.funcFormat.PRIORVALUE":`PRIORVALUE(campo)`,
"label.salescloud.field.editoptionlist":`Modifica della lista di scelta`,
"APPIntegration.Dropbox.01":`Seleziona i file da Dropbox`,
"label.campaign.channel.step2":`Passo 2: Impostare i valori di default dei campi lead di questo canale di marketing`,
"label_partner_new_function":`Descrizione della funzione`,
"vue_label_chat_no_search_results":`Nessun risultato di ricerca`,
"vue_label_commonobjects_detail_visitstate":`Visita lo stato`,
"label.sendemail.send.testemail":`Questa è un'email di prova, se puoi ricevere questa email, puoi usare questa casella di posta per inviare email.`,
"label.attendance.clear.position":`Punti di riferimento chiari`,
"chatter.write.n":`Commenta questo post`,
"label_chatter_sendmail":`Inviare e-mail`,
"label.remindertime":`Tempo di promemoria`,
"label.app.elegantgray":`Grigio elegante`,
"label.tabpage.ownedz":`Totalmente`,
"label.select.approval":`Seleziona l'approvatore`,
"UG.Lead.007":`Sincronizzazione con Google`,
"chatter.emailSetUp":`La mia configurazione di CCChat Remind`,
"label.default.censor":`Esaminatore predefinito`,
"vue_label_notice_uploadavatar_success":`Avatar caricato con successo`,
"label.sms.title":`Informazioni sull'interfaccia SMS`,
"front-console-choose-contact":`Scegliere il contatto`,
"label.field.edit.des":`Un punteggio più alto mostra più icone a forma di stella, e il punteggio massimo è 100.`,
"label.pw.big.letter":`Maiuscolo`,
"label.select.time.dimension":`Scegliere la dimensione temporale`,
"UG_Campaign_004":`Campagna di importazione`,
"label.dashboard.summary":`Metrico`,
"label.ems.yahoo":`Yahoo!`,
"label.leadscore.rule.name":`Nome della regola del punteggio del piombo`,
"vue_label_calendar_object_name":`Nome dell'oggetto`,
"label.icon.69":`Macchina`,
"label.reporttotal":`Totali`,
"lable.SalesCommitmentKanBan.theActualContract":`Importo effettivo del contratto`,
"label.project.member.data":`Questo utente è già membro del progetto corrente!`,
"label.cloudccclass.list.viewremark":`Aiuto per questa pagina`,
"label.deleteObject.isNotAdministrator":`Non sei un amministratore e non puoi cancellare gli oggetti.`,
"lable.edit.queue.nameandemail":`Nome della coda e indirizzo e-mail`,
"label.recordtype.tabname":`Tipi di record`,
"label.file.is.ok":`Va bene`,
"label.knowledge.language.german":`Tedesco`,
"label.layout.realityapprover":`Approvatore effettivo`,
"label.ems.with7day":`Entro 7 giorni`,
"label.autoRegister.changepwd.setpwd.setpwd.button":`Impostazione`,
"label.weixin.edit.polls":`Cambia voto`,
"label.layout.mobile.default.tab":`Selezionare la scheda predefinita in Mobile App`,
"vue_label_report_deletegroupcolumn":`Elimina la colonna del gruppo`,
"label.group.archived.success":`Archiviare con successo`,
"label.customfields.formula.returntype":`Formula Tipo di ritorno`,
"label.file.followers":`Seguaci`,
"label.textmessage.new.templates.message1":`Il nome del modello non può essere vuoto!`,
"label.selected.field.length":`Non più di 10 file selezionati`,
"ObjectDetailed_ViewKeyInformation_Layout":`Modifica delle informazioni chiave`,
"label.paging.totalofpage":`Un totale di {0} pagine`,
"label.ccchat.message.new.error41":`Per parlare con più persone, prova a usare i gruppi`,
"message.recordtype.detail.noselectlist":`Nessuna lista di scelta può essere visualizzata`,
"label.conditiontag.lookup.title":`Seleziona i valori dell'elenco di scelta qui sotto da aggiungere.`,
"label_partner_setup":`Impostazioni della nuvola del partner`,
"front-epwechat-module-v1-android-packname":`Android Nome del pacchetto:`,
"lable.custom.Current.CY":`Corrente CY`,
"label.newprocess2.desc":`Se lo sconto è maggiore di 0,3%, valuta a true.`,
"label.operatedata.selectobjectfields":`Selezionare i campi dell'oggetto esportato`,
"report_reportdatasource_label":`Fonte dei dati del rapporto`,
"label.chosesubject.others":`Altre attività`,
"label.list.desc2":`Puoi generare una pagina PC per l'accesso dal lato PC o una pagina mobile per l'accesso dal lato dispositivo mobile.`,
"vue_group_several_groups":`{totalSize} gruppi`,
"label.page.button.linkurl":`Pulsante o URL del link`,
"show.week":`Mostra il fine settimana`,
"label.gotocalendar.new":`Vai al calendario e crea eventi`,
"button.reset.advancedsearch":`Cancella le condizioni di ricerca avanzata`,
"label.h5.chatter.feedandcomnum":`Pubblicare e lasciare un messaggio`,
"lable.opppdt.addpdt.table.unitprice":`Prezzo di vendita`,
"label.dataimport.validate":`Selezionare la verifica da eseguire`,
"label.lead.score":`Punteggio di piombo`,
"vue_label_help_product":`Opuscolo prodotti e prezzi`,
"label.role.select":`Seleziona i ruoli`,
"lable.opppdt.selPdt.searchproduct":`Trova i prodotti`,
"component_event_label_newevent":`Nuovi eventi`,
"front-invoice-online-payment-setup-configure-button":`Configura ora`,
"label.stdashbord.xsld.business.img2":`Quantità totale della fase di opportunità con probabilità 1%-99%`,
"label.event.moveup.2week":`2 settimane avanti`,
"label.partnerCloud.priceOfManual.allCustomer":`Tutti i conti`,
"lable.account.dep":`Clicca sul pulsante Nuovo per definire un nuovo anno fiscale.`,
"label.dataimport.insertdata.error.null.update":`Il valore di $schemefield_name$ in questo record è nullo e non può essere aggiornato. Il record ha ignorato l'importazione`,
"label_component_helper_businesschange_0activity":`30 giorni senza alcuna attività`,
"lable.account.NextbbDays":`Prossimi 60 giorni`,
"label_scope_length":`Range-Length`,
"label.customfields.operation":`eseguire un'esportazione di dati`,
"serviceappointment.save.workorder":`Scegli un ordine di lavoro associato alla voce dell'ordine di lavoro.`,
"label.field.update.hide.editor":`Nascondere l'editor di formule`,
"button.partner.new":`Nuova nuvola di partner`,
"label.stdashbord.xsld.business.oppdetails":`Dettagli sull'opportunità`,
"message.pleasewaitingnextversion":`Questa caratteristica sarà disponibile nella prossima release.`,
"label_tabpage_potentialcustomersz":`Porta`,
"label_emailtocloudcc_step2":`Passo 2`,
"label.weixin.username":`Nome`,
"label.quickbooks.viewlist.type":`TIPO`,
"front-kefu-moudle-v1-Select-seats":`Scegliere l'agente`,
"label.customsetting.manage":`Gestire`,
"label.tabpage.field":`Campo`,
"label.custom.page.button.icon.URL":`Icona del pulsante URL`,
"font-evaluate-module-v1-evaluation-link":`Aggiungere il link di valutazione:`,
"vue_label_salesfunnel_notice3":`Quantità di opportunità di business con una probabilità dell'1% - 99%`,
"front-email-payment-describe":`Grazie per il vostro sostegno alla nostra attività. Puoi pagare online attraverso il seguente link, e visualizzare, stampare e scaricare le fatture in formato PDF.`,
"label.productsales.today.noevttskaddevt":`Non ci sono eventi aperti e compiti in scadenza, puoi cliccare " " nell'angolo in alto a destra per aggiungere un nuovo evento.`,
"component.setup.iframe.label.memo":`Cliccate sull'icona delle impostazioni e inserite l'indirizzo dell'url incorporato.`,
"front-email-payment-select-country":`Inserisci il paese`,
"label.ems.starred":`Messaggi stellari`,
"component_setup_label_object":`Oggetti`,
"label.query.detail.viewpartneruser":`Visualizza l'utente partner`,
"this.year":`Quest'anno`,
"serviceresource.isactive.notactive":`Questo servizio non è abilitato.`,
"label.marketing.message.recipientisnull":`Il destinatario non può essere vuoto`,
"label.unfold":`Espandi`,
"label.service.assetBOM.view.tip":`Non hai il permesso di visualizzare la distinta degli asset. Contatta l'amministratore.`,
"label.validate.function.funcExplain.ISCHANGED":`Controlla che il valore del campo sia diverso dal valore precedente. Se non lo è, restituisce TRUE, altrimenti restituisce FALSE.`,
"label.validate.function.funcExplain.NOW":`Restituisce un datet e un ime che rappresenta il momento corrente`,
"label.phoenix.islands.time":`Phoenix è. Tempo`,
"vue_label_checkduplicate_complete_filter_rules":`Si prega di completare le condizioni del filtro`,
"vue_label_report_rowcount":`Conteggio delle righe`,
"chatter.p":`persona`,
"label.umeng.activity.distributetask":`ti ha assegnato un compito.`,
"UG_quota_05":`Bisync con le opportunità`,
"june":`Giugno`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.tuesday":`Martedì`,
"vue_label_commonobjects_view_chart_upto5":`Fino a 5 gruppi`,
"vue_label_opportunity_contactrole_searchallcontacts":`Cerca tutti i contatti`,
"label.custom.field.task.notice":`Notifica del compito`,
"label.weixin.insert.address":`Inserire la posizione`,
"label.attachementNew.desc":`Archivia l'allegato a un documento, e l'allegato non può essere cancellato.`,
"setup_mainpage_label_welcome18":`Le impostazioni dei permessi a livello aziendale di CloudCC ti permettono di controllare i diritti d'uso dei singoli utenti mentre lavorano con i dati e i moduli. Le impostazioni dei permessi basati sui ruoli includono anche posizioni utente, gruppi, ruoli, regole di condivisione dei dati e controlli di sicurezza a livello di campo per consentire la condivisione dei dati tra diverse persone e reparti dell'azienda.`,
"front-kefu-instance-noarea":`Nessuna istanza è stata creata per quest'area, riseleziona`,
"label.please.ChooseMax":`Si prega di scegliere fino a {a} opzioni di prodotto.`,
"label.businesschance":`Opportunità`,
"label.verticalline-group":`Colonne verticali - Raggruppamento di colonne`,
"label.ordering.platform":``,
"label.product.pricebooks.ples":`Si prega di selezionare Price Book`,
"vue_label_norm_addcomponent":`Nuovo componente`,
"label.ServiceCloud.Installation.address":`Indirizzo di installazione`,
"vue_label_report_groupcolumn":`Colonna del gruppo`,
"label.ccchat.person.invite.notallsucc":`{0} gli indirizzi e-mail sono stati salvati ma non inviati. per inviare un invito, correggi il seguente errore e clicca su invia.`,
"label.customfields.optionlist.tip":`Permette agli utenti di selezionare un valore da una lista definita da voi.`,
"UG.activity.07":`Creare un compito`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.last":`Ultimo`,
"label.permission.accessname":`Nome di accesso`,
"lable.custom.year.stadate":`Anno personalizzato Data di inizio`,
"label.ems.inputmails":`Ricevere il server di posta elettronica (i)`,
"label.cpq.quote.transfer.order.already":`Questa quotazione è trasferita su un ordine. Si prega di cancellare l'ordine originale, poi di rigenerare un ordine.`,
"label.sendletter.status":`Stato di membro della campagna`,
"vue_label_commonobjects_view_save_as_view":`Salva come vista`,
"message.mobilechooseatmostfive":`Seleziona fino a 5 campi`,
"label.errormessage.batchedit.nopermission":`Nessun record di dati di cui hai il permesso di modifica.`,
"label.dataoperate.tip":`Seleziona l'operazione e gli oggetti.`,
"label.enableoperate":`Azioni disponibili`,
"label.ems.usernamepassword.error":`Errore dell'account o della password della mailbox.`,
"label.campaignmember.selectmember.deletemember":`Rimuovere i membri da`,
"label.Tab":`Schede`,
"label.emailobject.template.message1":`Seleziona un campo e clicca su "Inserisci". Con il ">" significa cliccare per visualizzare altri campi disponibili.`,
"label.approvalstep3.tip":`Specifica l'utente che dovrebbe approvare i record che entrano in questo passo. Facoltativamente, scegli se il delegato dell'approvatore è anche autorizzato ad approvare queste richieste.`,
"label.inusing":`Attivo`,
"label.edit.select.tre":`Elenco delle caselle di controllo`,
"label.appointmentconfirmail.wizard.title1":`Ciao {0}`,
"label.partnerCloud.financeSetting.setAlipay":`Impostare Alipay`,
"lable.edit.queue.avobj":`Oggetti disponibili`,
"vue_label_checkduplicate_verify_all_characters":`Verifica tutti i caratteri`,
"label.huntingzone":`Gamma di ricerca`,
"label.request.approved":`La richiesta è stata approvata, non ripetere.`,
"label.sharerule.msgerror":`Errore interno del server`,
"front-epwechat-module-v1-tick-unbound":`Si prega di spuntare e accettare le informazioni non vincolanti di cui sopra`,
"label.console.step6":`Passo 6 Scegliere come visualizzare le liste`,
"label.multilang.micropost.vote":`{0} biglietto(i)`,
"message.error.appid.null":`La chiave segreta non può essere nulla!`,
"lable.product.delq":`Cancellare i problemi`,
"label.h5.approval.leixing":`Tipo di approvazione`,
"label.edit.field.select.style1":`Piastrellare ogni opzione`,
"label.passwordPolicy.setup.alpandnum":`Deve mescolare caratteri alfa e numerici`,
"label.ems.close2":`Chiudere`,
"label.report.reporttypetitle":`Fonte dei dati`,
"label.umeng.approval.approvalsuccess":`è stato presentato per l'approvazione.`,
"label.page.showamount":`Registrazioni totali per pagina:`,
"label.copy.asset.successfully":`Copiare asset BOM con successo.`,
"vue_label_homepage_bigscreen_dark":`Scuro`,
"vue_label_email_selected_members":`Membri selezionati`,
"label.file.preview":`Anteprima`,
"label.partner.new.step3.name":`Nome`,
"label.forecast.settings.periods.ago":`ciclo(i) fa`,
"label.evaluation.praise":`Buono`,
"label.cloudccsite.edit":`Modifica del sito`,
"label.knowledgebase.advanced.filtering":`Filtro avanzato`,
"label.knowledgebase.framework":`Telaio`,
"vue_label_pool_ownedpool":`Piscina principale`,
"label.exchange.sync.setting.license":`Con questa funzione abilitata, alcuni dei tuoi dati organizzativi possono essere salvati sul server Microsoft Exchange in forma di distribuzione interna o di cloud-base ed elaborati attraverso il server Microsoft Exchange.`,
"front-console-conversation-btn2":`Risposta via email`,
"label.projectManagement.thelastone":`Questo è l'ultimo disco.`,
"message.duplication.confirmscript.mergeoperation":`Questi record vengono uniti in un unico record attraverso i valori selezionati. Nota: l'azione di fusione non può essere revocata. Sei sicuro di voler unire i record?`,
"lable.outlook.detail.nosyn":`Fuori sincrono`,
"label.iscopy":`Permettere la copia`,
"message.matrixReportSetupStage.row":`Seleziona 【Specifica intestazioni di riga】 base subtotale, e devi selezionare una base subtotale almeno in due basi subtotali.`,
"label.forecast.forehistory.possibility":`Probabilità`,
"label.timetrigger.validate":`Il valore inserito deve essere un numero intero positivo, e il sistema eseguirà automaticamente le azioni del flusso di lavoro quando il deve essere un numero intero positivo, che è il momento in cui la dipendenza del flusso di lavoro è soddisfatta, il sistema eseguirà automaticamente l'operazione del flusso di lavoro.`,
"member.name.choice.field":`Il nome del membro è un campo obbligatorio!`,
"label.undone_external page":`Questo è irreversibile, quindi si prega di confermare. Questo modulo non è usato in nessuna pagina di login, ma può essere usato altrove. Per esempio, potresti aver usato il codice embed per inserirlo in una pagina esterna.`,
"UG_Lead_012":`Importazione di indizi`,
"component_chatter_label_fans":`Seguaci`,
"label.systeminfo":`Informazioni sul sistema`,
"label.mr.descreption.oneGroupNote1":`Seleziona almeno due dati e clicca su [Load Selected Information] per passare alla pagina di fusione dei dati.<br>Questa è la`,
"label.wtd.changefields.selfields":`Seleziona i campi da includere nel tuo modulo Web-to-CloudCC:`,
"message.error.fileinfoid.null":`fileinfoid non può essere vuoto! Informazioni sul file id`,
"label_tabpage_cownerz":`Cambia proprietario`,
"setup_layout_button_save":`Salva`,
"Dashboard.View.Createdbyme":``,
"label.escalation.setup.detail.order":`Ordina`,
"button.partner.start":`Iniziare a usare`,
"label.htyj.remark1":`La tua edizione attuale non supporta la visualizzazione dell'oggetto contratto`,
"component.event.label.person":`Persona assegnata`,
"label.appointmentconfirmail.wizard.subtitle3":`Posizione`,
"label.emailtocloudcc.filed.username":`Indirizzo e-mail`,
"label.vlidaterule.remark":`Definisci una regola di convalida specificando una condizione di errore e un messaggio di errore corrispondente. L'utente può correggere l'errore e riprovare.`,
"message.duplication.label.insertoption":`Azione su Crea`,
"front-web-module-v1-detail-comment-toast":`Si prega di completare tutte le valutazioni`,
"label.import.page2.notsuitedfiledwillbenotimport":`Avviso: Il sistema non importerà i campi non mappati`,
"label.h5.similar.opportunity.enable":`Abilitare opportunità simili`,
"label.allunfold":`Espandi tutto`,
"component_setup_iframe_label_inputurl":`Inserisci l'indirizzo url`,
"label.manage.all":`Gestisci tutti`,
"label.mobile.side.tab.cs":`Funzioni comuni`,
"label.datamanage.contact.information":`Informazioni di contatto`,
"lable.outlook.edit.sel":`Selezionare un valore`,
"label.imgfield.type.url.tip2":`Per esempio: http://www.cloudcc.com/images/logo.png&cimgSize=50,50`,
"setup.layout.label.areasetup":`Proprietà della sezione`,
"label.date":`Data`,
"vue_label_commonobjects_detail_openfilter":`Espandi filtro`,
"label.loginip.pagecue":`Inserisci la gamma di indirizzi IP validi da cui gli utenti con questo profilo possono accedere.`,
"vue_label_email_not_valid":`L'email che hai inserito non è un indirizzo email valido`,
"label.page.step5.add.application":`Passo 5 Aggiungere alle applicazioni personalizzate`,
"label.dashboard.donot.delete":`Non puoi cancellare questa cartella perché ci sono dei cruscotti in essa.`,
"label.visitAPPexchange":`CloudCC App Store (Nuova finestra)`,
"label.generate.location":`Genera i dati di latitudine e longitudine del cliente.`,
"lable.quote.syncing.syncingbutton":`Sync`,
"label.pw.error.text":`Le due password che hai digitato non corrispondono.`,
"label_partner_setup_Enable":`Verifica`,
"label.file.preview.unav":`Anteprima unavaliabled`,
"label.sms.tip":`Da Internet`,
"setup.mainpage.label.welcome21":`La piattaforma cloud CloudCC fornisce la funzione di modello di e-mail definito dall'utente, che è comodo da usare per gli utenti e migliora l'efficienza del lavoro.`,
"label.trigger.for.example":`Per esempio: aggiornare l'opportunità nel trigger di aggiornamento del conto, aggiornare il trigger di aggiornamento del conto nell'opportunità e attivare il trigger di aggiornamento del conto. Se non c'è un controllo condizionale if no nel trigger, allora il sistema permette fino a 3 chiamate circolari di questo tipo.`,
"setup.layout.button.layoutprop":`Proprietà`,
"component.chatter.label.fans":`Seguaci`,
"lable.PowerProcess.event.edit":`Modifica pietra miliare`,
"label.detailintro":`Voci Descrizione`,
"vue_label_report_nosearchresults":`Nessun risultato di ricerca`,
"error.name.repeat":`Il nome non può essere ripetuto.`,
"label.emailEncoding":`Codifica delle e-mail`,
"label.partnerCloud.financeSetting.enableAccount":`Attivare il conto del rimborso`,
"label_emailtocloudcc_clear":`Chiaro`,
"setup_mainpage_label_welcome12":`L'utente può completare la definizione del rapporto cliccando con il mouse, senza programmare, e seguendo i passi del sistema. Il sistema può scegliere tra un rapporto a lista, un rapporto di riepilogo e un rapporto a matrice. Sono anche disponibili opzioni di visualizzazione per tutti i campi. Rimuove le informazioni di campo non necessarie. Allo stesso tempo, fornisce una varietà di visualizzazioni grafiche tra cui strisce, linee di piegatura, anelli, imbuti e torte, in modo che gli utenti possano vedere a colpo d'occhio.`,
"lable.SalesCommitmentKanBan.contractStartDate":`Data di inizio del contratto`,
"front-starter-v1-potential-customer-tips-success":`Attivare con successo il Lead Pool`,
"UG_Forcast_02":`Le previsioni sono stime delle vendite previste per un dato periodo, e i modelli di previsione possono aiutare a determinare la domanda di prodotti e le entrate delle vendite in un certo periodo. I manager possono usare le previsioni per fissare gli obiettivi e misurare i progressi del team. La previsione generale dell'organizzazione può riflettere il riassunto di tutte le vendite per rappresentante di vendita (indipendentemente dallo stadio di completamento delle vendite, dalla fase di pipeline alla fase chiusa).`,
"label.escalation.setup.detail.ruleentries":`Voci della regola`,
"lable.SalesCommitmentKanBan.allComplete":`Importo totale completo`,
"label.appupload.install.apicanuse":`Il nome dell'api è disponibile`,
"label.organiza.field":`Campi di organizzazione`,
"button.partner.workspace.manage":`Gestione`,
"lable.PowerProcess.setevent":`Impostazione delle pietre miliari`,
"label.emailobject.groupemail.msg2":`L'indirizzo e-mail è mancante. Questo impedirà l'invio dell'email a questo destinatario.`,
"label.h5.orderbyname":`Ordinati per nome`,
"vue_label_salesadvance_opportunities":`Numero di opportunità`,
"label.appointment.disable.cancel":`Disattivare la cancellazione`,
"label.trigger.folder.edit":`Pagina di attivazione: Modifica cartella`,
"label.customfields.new.step2.opration.unique.info.v2":`Trattare "ABC" e "abc" come valori diversi (case sensitive)`,
"label.icon.40":`Posizionamento`,
"label.eventmenuandlink":`Pulsanti e link di eventi`,
"label.service.gantt.candidate":`Candidato`,
"label.top.userphoto":`Foto dell'utente`,
"label.appointmentconfirmail.wizard.btn2":`Cancellare la riunione`,
"label.print":`Stampa`,
"saveandreturn":`Salva e torna indietro`,
"lable.account.CurrentandNextCY":`Attuale e prossimo CY`,
"label.group.no.recent1":`Non hai visto nessun gruppo attivo.`,
"lable.Asset.conversion":`Generare l'asset secondo "Asset Transition" del prodotto dell'ordine quando si trasferiscono gli asset.`,
"label.emailtocloudcc.button.sure":`Confermare`,
"label.Path.List":`Elenco dei percorsi`,
"label.please.rule.name":`Inserisci il nome delle regole.`,
"label.knowledge.category.hint.six":`Gruppo di categoria disponibile`,
"setup_mainpage_label_welcome28":`Istruzioni: Clicca sul menu sul lato sinistro di questa pagina → Gestisci impostazioni → Gestione dati → Importazione ed esportazione dati, Trasferimento batch, Eliminazione batch.`,
"vue_label_commonobjects_view_chart_editchart":`Modifica grafico`,
"label.permission.detail.app.object":`Impostazione dell'oggetto`,
"label.multilang.totalpage":`di`,
"label.marketsea.button.return":`Ritorna`,
"Click.to.load.more":`Clicca per caricare di più`,
"label.validate.globalvariable":`Variabile globale`,
"label.marketsea.iseditseabymanager":`Permettere agli amministratori di cambiare il pool di piombo a cui appartiene.`,
"label.price.yuan":`Prezzo (Yuan)`,
"label.service.resource.uesr.tip":`Seleziona un utente per creare risorse di servizio e il tipo di risorse non può essere l'equipaggio.`,
"vue_label_help_viewusageguide":`Visualizza la guida utente della versione Lightning`,
"label.autoRegister.changepwd.setpwd.too.long":`Troppo lungo`,
"label.campagin.roi.fwsl":`Numero di visite`,
"label.campaign.mobile":`App mobile`,
"UG.Lead.012":`Importazione di indizi`,
"link.recordtype.detail.backtoobject":`Torna a Oggetti personalizzati`,
"front-kefu-moudle-callcentrt-hasclose":`Il call center ha chiuso`,
"label.category.5":`IT Alta tecnologia`,
"label.import.page1.selectwayofdealdata":`Selezionare la modalità di elaborazione dei dati`,
"chatter.emailReceiveEmail":`Ricevi promemoria CCChat`,
"vue_label_file_manage_lib_members":`Gestire i membri della libreria di file`,
"label.appupload.upload.overview":`Ricapitolazione`,
"label.service.miniProgram.inputNumber":`Si prega di inserire un numero compreso tra 0 e 999.`,
"label.emailtemplate.finishdetailinfo":`Compilare i dettagli del modello di e-mail.`,
"label.weixin.fmu.before.day":`{0} giorni prima`,
"label.integrations.login":`Accesso`,
"label.dashboard.setUpHomePage":`La homepage è stata impostata per visualizzare`,
"label_partner_common_webSit":`Dominio`,
"front-epwechat-module-v1-unbound-user":`Utenti non vincolati`,
"label.partnerCloud.basicSetting.offline":`Attivare il pagamento offline`,
"label.start.loginip":`Indirizzo IP iniziale`,
"label.projectManagement.delete.subtasks":`Anche tutte le informazioni relative a questo sottocompito saranno cancellate se si elimina questo sottocompito, e i dati non possono essere recuperati. Sei sicuro di confermare la cancellazione?`,
"label.message.batchapp":`Approvazione di massa`,
"message.duplication.label.ruletitle":`Regole duplicate`,
"label.all_networks":`Tutta la rete`,
"label.select_columns":`Seleziona le colonne che vorresti vedere per i tuoi invii di moduli`,
"vue_label_notice_uploadavatar_exceed":`La dimensione dell'immagine avatar caricata non può superare i 2MB`,
"message.error.get.failed":`Impossibile ottenere informazioni!`,
"label.quickbooks.viewlist.duedate":`DATA SCADENZA`,
"label.ccchat.topic.search":`Cerca argomento`,
"label.forecast.shre.manager":`Assegnazione del manager`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.thursday":`Giovedì`,
"lable.product.pricebooks.copy":`Clonare da un libro dei prezzi esistente`,
"label.instrumentPanel.minLabelname":`Questo valore deve essere positivo e inferiore al valore del breakpoint 1.`,
"front-market-form-createdsecond":`Campo di riempimento automatico nella pagina di registrazione`,
"label.submission_detail":`Dettaglio della presentazione`,
"label.customfields.checkbox.tip":`Permette agli utenti di selezionare un valore Vero (controllato) o Falso (non controllato).`,
"label.escalation.setup.list.description":`È possibile determinare automaticamente le azioni quando i casi soddisfano i criteri e oltre il tempo specificato. Quando si esegue l'escalation di un caso, è possibile scegliere di notificare automaticamente l'utente e riassegnare il caso a un nuovo utente.`,
"UG.Forcast.05":`Impostazioni di previsione: passo {0}/{1}`,
"label.data.import":`Importazione di dati`,
"label.upload.error.cause":`caricamento fallito a causa di`,
"label.search.change.remark":`Si applica alle impostazioni degli oggetti visualizzati nella barra di ricerca sul lato sinistro della homepage`,
"serviceappointment.edit.status.limitwithstatus":`Lo stato dell'appuntamento di servizio non può essere cambiato da {0} a {1}`,
"label.department.operation":`Operazione`,
"label.textmessage.vonage.message3":`Per cercare la chiave API e il segreto API, puoi accedere al tuo account Vonage API e andare su "Impostazioni" sotto il nome del tuo account. Per cercare i numeri di telefono che hai nel tuo account Vonage API, puoi andare su Numeri sotto Prodotti, e cliccare su "I tuoi numeri" per vedere tutti i numeri di telefono che hai.`,
"label.privacystatement.dialog":`Dichiarazione sulla privacy (Nuova finestra)`,
"label.datamanage.import.leadfield":`Nella seguente lista, seleziona i campi del file di importazione che devono importare i lead. Poi clicca su avanti:`,
"label.appupload.upload.install.failar":`Installazione non riuscita`,
"label.viewall":`Vedi tutto`,
"label.sendemail.chat.addComentsfavoritesubject":`CloudCC CCChat risponde a Bookmarked`,
"lable.custom.dp":`Questa pagina permette di definire degli anni personalizzati.`,
"label.mobile.more.share":`Condividi con colleghi o gruppi`,
"lable.name.cannot.be.empty":`Il nome non può essere vuoto`,
"label.autoRegister.changepwd.setpwd.password":`La tua password`,
"label.multipleactivity.aevents":`Evento/i`,
"label.many.dayline.lastday":`Ultimo giorno`,
"lable.Please.bind.the.QuickBooks.record.first":`Si prega di legare prima i record di quickbook.`,
"vue_no_related_dashboards":`Nessun cruscotto rilevante!`,
"label.newdashboardpage.name":`Nome`,
"vue_label_commonobjects_detail_network":`Rete di relazioni`,
"label.tianyancha.reginstitute":`Autorità di registrazione`,
"label.the.lower.bound.of.each.level.must.be.equal.to.the.upper.bound.of.the.upper.level.":`Il limite inferiore di ogni livello deve essere uguale al limite superiore del livello superiore quando si calcola il prezzo per blocchi.`,
"label.chat.file.upload.info":`Caricare i file`,
"label.appexchange.vlidaterule":`Regole di convalida`,
"label.salescloud.salesdashboard.current.business":`Opportunità attuali`,
"label.app.step4.homeisfrist":`La pagina iniziale deve essere la prima scheda e non può essere rimossa.`,
"label.weixin.micro.research.optionname":`Scelta del microsondaggio Nome`,
"label.paging.totalofnbsp":`Un totale di {0}`,
"label.opportunity.perm.title":`Richiesta di accesso`,
"front-kefu-moudle-v1-zhyzcw-reinput":`Errore di verifica del locatario. Si prega di reinserire`,
"label.unsaved_changes":`Se continuate l'operazione, le modifiche non salvate andranno perse.`,
"label_partner_all_description":`Descrizione`,
"lable.account.Next.CQ":`Prossimo CQ`,
"chatter.feed.menutype.feed.me":`A me`,
"label.sourcetranstemp":`Source - Produce un file che contiene tutto il testo che è traducibile`,
"label.apply.newuser.validate":`Registrazione CloudCC di un nuovo utente, codice di convalida:`,
"label.user.password.error":`Errore del nome utente o della password, o utente non valido!`,
"label.there.is.no.quotation.line.item.in.this.quotation.line.group.at.present.":`Non ci sono voci di preventivo in questo gruppo di quote. Si prega di cliccare su "Aggiungi prodotto" per aggiungere.`,
"lable.PowerProcess.time.filed":`In base al campo data e ora di {detailInterestType}`,
"label.file.default.value.is.integer":`Si possono inserire solo numeri interi`,
"label.processsetting.please.select.field":`Si prega di selezionare i campi.`,
"label.app.step3.introduce":`La dimensione del file del logo di un'app personalizzata deve essere inferiore a 20 KB. Le dimensioni dell'immagine devono essere al massimo di 300 pixel di larghezza per 55 pixel di altezza per ottenere i migliori risultati. Le immagini più grandi saranno ridimensionate e potrebbero apparire distorte.`,
"button_partner_save":`Salva`,
"label.marketingmanagement":`Marketing`,
"label.isEnableVisualpage_new.leftlist":`Pagine personalizzate disponibili`,
"label.salescloud.teamrole.optionlist.choose.correct":`La stessa voce esiste nella lista, si prega di modificare.`,
"System_ChangeUser_Info_001":`Proprietario cambiato e clicca per tornare alla pagina precedente.`,
"front-console-no-contact":`Nessun contatto`,
"component.assistant.label.overduetask":`Opportunità con compiti in ritardo`,
"label.roleofpartner":`Ruolo di partner`,
"label.appointmentconfirmpage.wizard.subtitle4-1":`Tu e {0}`,
"front-template-V1-Please-select-a-picture":`Per favore scegli un'immagine`,
"lable.SalesCommitmentKanBan.allsignedCommitmentRate":`Tasso di impegno totale firmato`,
"label.h5.similar.opportunity.step2.conment":`Seleziona da 3 a 10 campi o liste correlate da confrontare quando trovi opportunità simili.`,
"label.projectManagement.alert.frequency.will.not.work":`Quando si seleziona No, il promemoria non funziona.`,
"vue_label_fllscreen":`Visualizzazione a tutto schermo`,
"label.customfields.selectcontainfieldlayout":`Seleziona i layout di pagina che devono includere questo campo.`,
"label.appointment.wizard.subtitle1-4":`45 min`,
"label.tianyancha.businessverify.unagree":`Non sono d'accordo`,
"label.unique":`Unico`,
"setup_mainpage_label_welcome10":`Istruzioni: Fare clic sul menu sul lato sinistro della pagina → Impostazioni applicazione → Crea → Oggetto → Nome oggetto → Layout personalizzato.`,
"vue_label_account_subsidiary":`Filiale`,
"label.dataimport.format.error":`Errore di formato, si prega di utilizzare il formato come MM/GG/AAAA o AAAA-MM-GG.`,
"label.email.new":`Nuova e-mail`,
"label.log.descri":`Operare Descrizione`,
"vue_label_dashboard_componentname":`Inserisci il nome del componente`,
"label.weixin.quick.reply":`Risposta rapida`,
"label.productsales.payment.badversion":`La tua edizione attuale non supporta la visualizzazione dell'oggetto contratto, quindi non puoi visualizzare l'elenco dei pagamenti.`,
"label.position":`Posizione`,
"label.Annex.Conditions":`Aggiungere filtri logici per condizioni aggiuntive (per esempio: 1 E 2 O 3)`,
"label_tabpage_endz":`Fine`,
"label.setup.mobile.bottombutton.prompt":`Avviso: Salvare queste impostazioni cambierà le impostazioni originali dell'utente del primo livello dell'applicazione mobile.`,
"lable.Edit.template":`Modifica il modello del rapporto di servizio`,
"vue_label_report_onlydisplay2000":`Visualizza solo i dati 2000`,
"label.salescloud.salesdashboard.sign.account.top5":`I 5 migliori account firmati`,
"label.weixin.ontime":`Puntuale`,
"font-evaluate-module-v1-disappoint":`Mi dispiace deludervi!`,
"chatter.sel.addre":`Si possono selezionare fino a 5 destinatari!`,
"label.mobile.phone.month.summary":`Riassunto mensile`,
"label.partnerCloud.priceOfManual.selected":`Conto selezionato`,
"label.south.georgia.time":`Ora solare della Georgia del Sud`,
"label.create.ccdocument":`Aggiungi allegato`,
"label.chatter.to":`A`,
"label.ems.minute":`Verbale`,
"label.mobile.phone.submit.tome":`Inviato a me`,
"label.approvalstep1":`Passo 1 Inserire il nome e la descrizione`,
"label.h5.similar.opportunity.last.months9":`Recenti 6-9 mesi`,
"Opportunity_Detailed_Phase_Label_003":`Fase di cambiamento`,
"lable.PowerProcess.time.input":`Si prega di inserire un orario.`,
"label.stdashbord.xsld.business.yqzsr":`Importo totale previsto`,
"label.icon.64":`Searchlight`,
"label.data.choses.i_desc":`Secondo le vostre esigenze, importate i dati da un singolo oggetto.`,
"label.integrations.mainlandchinaleads":`Lead della Cina continentale`,
"vue_label_notice_savemenu_success":`Menu salvato con successo`,
"front-kefu-moudle-v1-xzhxzxkf-online":`Scegliere il servizio online di Easemob`,
"label_chatter_name":`Nome`,
"label.Viewon_Linkedin":`Vista da LinkedIn`,
"lable.PowerProcess.chioce.event":`Si prega di selezionare la pietra miliare.`,
"component.chatter.file.label.maxsize":`La dimensione massima del file è di 20m`,
"label.validate.function.funcExplain.SECOND":`Restituisce il secondo del giorno (dai campi data/ora)`,
"label.data.downpage.i.title.num4":`4. Se hai un campo di relazione lookup e un campo di relazione master-detail nell'oggetto che vuoi importare, il valore per quel campo deve essere ID, altrimenti non è valido.`,
"label.icon.139":`Valuta`,
"label.app.step4.atleastone":`La scheda Home non può essere rimossa.`,
"label.weixin.input.telephone":`Inserisci il numero di cellulare`,
"label.setup.mobile.bottombutton.remark":`Un'organizzazione potrebbe configurare le impostazioni iniziali della pagina di primo livello secondo il processo aziendale.`,
"label.file.searchs":`Cerca file...`,
"vue_label_email_there_is_no_draft_yet":`Non c'è ancora una bozza`,
"front-kefu-moudle-v1-bind-seats":`Legare l'agente`,
"label.customfields.lookupmuti.tip":`Crea una relazione che collega questo oggetto ad un altro oggetto. Il campo di relazione permette agli utenti di cliccare su un'icona di ricerca per selezionare più valori da un elenco a comparsa. L'altro oggetto è la fonte dei valori nella lista.`,
"label.integrations.password":`Password`,
"label.data.newtemplate.t_conditions":`Condizioni del modello`,
"message.error.repeatsubmit":`L'invio viene ripetuto o vengono aperte più finestre di modifica nella stessa pagina. In quest'ultimo caso, si prega di inviare nella nuova finestra aperta.`,
"label.umeng.approval.approvalreassign":`La richiesta di approvazione per l'#obj è riassegnata. #objname`,
"lable.edit.queue.selobj":`Errore: La coda deve avere almeno un oggetto selezionato`,
"label.compact.layout.frame":`Cornice del layout di pagina`,
"label.sms.companyname.dsf.infor":`Questo servizio supporta solo la Cina continentale`,
"template.report.individual.case.source":`Fonte del caso`,
"pagecreator.button.pcpage":`Fine Pc`,
"vue_label_commonobject_selectdatatime":`Scegliere data e ora`,
"label.icon.181":`File`,
"label.loginip.setup.please":`Si prega di specificare l'intervallo IP.`,
"vue_label_dashboard_?secondarygroup":`Seleziona un gruppo secondario`,
"lable.outlook.mcto.pleasedes":`Inserisci i domini di posta elettronica che non vuoi associare, e separali con ",".`,
"DetailedInfo_Activity_EmailMessage_01":`{0} invia un'email a {1}.`,
"label.sendmail.step4":`Passo 4 Le e-mail che hai inviato vengono elaborate.`,
"label.monitorsys.delete.source":`Descrizione`,
"label.monitorsys.log.datetime":`Scarica il registro di controllo delle operazioni chiave nell'intervallo di tempo di ricerca (Excel.xls)`,
"component_chatter_label_myfans":`I miei seguaci`,
"label.tianyancha.h5.registereddate":`Data di registrazione`,
"label.multilang.feedtrack.operatecreate":`{0} record è stato creato：`,
"label.console.step6.no":`Scegliere come visualizzare le liste`,
"four":`Quattro`,
"message.confirmsetpwdforuser":`Resettare la password per i nuovi utenti?`,
"label.cape.verde.time":`Tempo di Capo Verde`,
"label.queue.new":`Nuova coda`,
"label.cloudccsite.start":`Home page del sito attivo`,
"label.data.exp.way":`Metodo di esportazione`,
"label.lock.record.donot.delete":`Non è possibile cancellare i record bloccati.`,
"label_emailtocloudcc_filed_type":`Provider`,
"frame_personinfo_label_minipic":`Immagine in miniatura`,
"label.checkfield.choosetab":`Seleziona i campi per trovare i depliant`,
"component.setup.tabs.label.default":`Pagina predefinita`,
"page.404.button.toknowmore":`Per saperne di più`,
"vue_label_SMS_message_sent_cannot_be_empty":`Il contenuto del messaggio inviato non può essere vuoto`,
"label.lookupreplaceselectvalue":`Trova e sostituisci elenco di scelta`,
"pagecreator_layout_button_new":`Nuovo layout`,
"label.mobile.more.upload":`Carica la nuova versione`,
"front-kefu-moudle-v1-Connection-failure":`Connessione fallita`,
"label.version.support.unlimited":`Supporto illimitato`,
"message.error.notmarketseamember":`Non è un membro del pool di piombo`,
"label.taskandincident":`Compiti ed eventi`,
"label.report.export.print.title":`Stampa le viste dei rapporti`,
"label.file.publicview.error2":`Il link pubblico non è corretto, per favore usa un nuovo link pubblico`,
"label_chatter_cancel":`Cancella`,
"front-web-module-v1-detail-comment-satisfied":`Livello di soddisfazione`,
"label.knowledge.delete.topic":`Errore durante la cancellazione dell'argomento usato in questo articolo di conoscenza.`,
"label.forecast.forehistory.all":`Tutti`,
"label.displaybutton":`Pulsanti visualizzati`,
"label.icon.148":`Robot`,
"label_tabpage_ok":`Confermare`,
"label.checkfield.merge.mainrecord":`Record principale`,
"label.notification.arketsea.restored":`{5} restaurato {2}  {0}：{1}`,
"setup.mainpage.label.welcome31":`Istruzioni: Clicca sul menu a sinistra di questa pagina → Gestisci impostazioni → Crea → Applicazione`,
"front-kefu-moudle-v1-jtrrt-connect":`Associare gli utenti di CloudCC alle estensioni di TRRT`,
"vue_label_calendar_please_select":`Seleziona il campo visualizzato`,
"setup.layout.label.pagename":`Nome del layout di pagina`,
"template.chart.schdywjhz":`Valore dell'opportunità della campagna`,
"label.access_report":`Chi può accedere a questo rapporto?`,
"label.assignment.layout.section.optional":`Disponibile`,
"label_chatter_recently":`Recentemente`,
"lable.chat.advanced.setting":`Impostazione avanzata`,
"label.knowledge.category.hint.eight":`Gruppo di categoria`,
"message.error.facebookuid.null":`L'ID utente di Facebook non può essere vuoto!`,
"label.step5.total6":`Passo 5 di 6`,
"label.is.cancel.delete":`Annullare la cancellazione?`,
"setup_mainpage_label_welcome11":`Rapporto personalizzato`,
"label.answers":`Risposte`,
"label.approvalstep1.tip":`Inserisci un nome, una descrizione e un numero di passo per il tuo nuovo passo di approvazione.`,
"template.chart.htjeph":`Importo del contratto Classifica`,
"label.campaigns.onsiteregistration":`Registrazione in loco`,
"front-epwechat-module-v1-input-agentid":`Per favore inserisci agentId`,
"label.emailobject.wizard.desc2":`Traccia le email aperte e i tempi di apertura`,
"label.multilang.chatterdetial.vote":`{0} biglietto(i)`,
"label.customsetting.manage.value":`Dati personalizzati`,
"front-electronic-export-listCount":`{totalView} dati in totale nella vista corrente, selezionare i dati importati`,
"label.dashboard.create.prompt":`Non è possibile creare dashboard su rapporti tabellari.`,
"label_tabpage_askz":`Cosa vorresti chiedere`,
"label.ems.sentmail":`Outbox`,
"label.reportlist.untop":`Non fissato`,
"label.owner.h5.plzchose":`Seleziona il proprietario e salva`,
"label.callcenter.addup.10.pieces":`Aggiungere 10 dati una volta al massimo`,
"label.ccdocument.save":`Salva documento`,
"label.productcannotnull":`Il prodotto non può essere vuoto`,
"label_tabpage_enabletomobile":`Se abilitare il lato mobile`,
"lable.account.CYAgo":`2 CY fa`,
"lable.Select.the.returned.high.seas.pool":`Seleziona il pool restituito`,
"tuesday":`Martedì`,
"label.partnerCloud.basicSetting.partnerPayment":`Attivare il fondo per i partner`,
"label.validate.function.funcExplain.WEEKDAY":`Restituisce uno specifico giorno della settimana. 1 rappresenta la domenica e 7 il sabato`,
"label.query.detail.manageexuser":`Gestire gli utenti esterni`,
"vue_label_systemSettings_environment":`Ambiente`,
"component_setup_tabs_label_delete":`Cancellare`,
"label.weixin.delete.ccchat":`Sei sicuro di voler cancellare questo post?`,
"label.lanxin.title":`Lanxin-H5Micro App`,
"label.layout.editcondition.morethanten":`Puoi selezionare fino a 10 campi come criteri di ricerca.`,
"label.project.hit.fourteen":`Avviso di aggiornamento delle pietre miliari`,
"label.createby":`Creato da`,
"label.moreoperation":`Più Operare`,
"label.lock.tip":`Blocca i record dall'essere modificati`,
"label.check.input.condition.three":`Il tipo di campo della formula e il riepilogo rollup non sono supportati per inserire`,
"label.quote.dingjia":`Prezzi`,
"label.currentuseremail":`L'attuale indirizzo e-mail dell'utente`,
"UG_homepage_004":`Automazione`,
"chatter.link":`Link`,
"label.new.zealand.standard.time":`Ora legale della Nuova Zelanda`,
"APPIntegration.Dropbox.setting.02":`Disabile`,
"label.version.searchandmerge":`Duplicazione e unione degli assegni`,
"label.allmenus.showmsg.nomenu":`Non ha trovato il menu!`,
"front-template-V1-Enable-disable":`Attivare | Disattivare`,
"label.marketing.setting4":`La registrazione con successo ritorna all'URL predefinito`,
"UG.Forcast.07":`Permettere la previsione`,
"vue_label_systemSettings_correlation":`Modalità di visualizzazione della lista correlata`,
"label.cloudccsite.remark.length":`Permette agli utenti di inserire fino a 255 caratteri`,
"label.favorite":`Segnalibro`,
"template.report.converted.leads":`Leads convertiti`,
"label.campaignmember.main.description":`Usa questa pagina per gestire i membri della campagna. Puoi aggiungere nuovi membri della campagna o aggiornare lo stato degli attuali membri della campagna.`,
"label.salescloud.teamrole.account.organization":`I membri del team possono avere un livello di accesso più alto a questo account rispetto alle impostazioni di accesso predefinite dalla tua organizzazione.`,
"label.permission.modifyAppPermission.canselectapp":`App disponibili`,
"front-epwechat-module-v1-self":`Impostazione dell'app autocreata`,
"message.duplication.label.matchexactletters":`Esattamente`,
"label.appointmentdetail.wizard.title18":`Piano del venerdì`,
"label.area":`Territori`,
"label.sso.saml.sp.username":`Nome utente`,
"lable.outlook.new":`Nuova configurazione di sincronizzazione di Exchange`,
"label.custom.field.close.conversion":`Chiuso - Convertito`,
"lable.outlook.detail.tmaping":`Mappa dei campi dell'attività`,
"label.emailobject.emaildetail.nextactivity.event":`Aggiungere un evento`,
"vue_label_commonobjects_detail_date":`La data di fine non può essere inferiore alla data di inizio`,
"vue_label_email_mark?as":`Segna come`,
"label.guestgroup":`Squadre di account`,
"label_emailtocloudcc_filed_server":`Server`,
"label.icon.186":`Consulenza`,
"label.department.user.edit":`Modifica`,
"label.custom.page.component.button.settings":`Impostazioni dei pulsanti dei componenti`,
"label.partnerCloud.orderingPlatform.nextProduct":`Vuoi salvare la configurazione attuale del prodotto e configurare il prodotto successivo?`,
"vue_label_appstore_cloud_platform":`piattaforma ufficiale cloud`,
"label.page.previous":`Precedente`,
"label.direct.dashboard.week.report":`Nuova nota di lavoro settimanale`,
"label.ServiceCloud.prompt.warning":`Nessuna statistica di distribuzione delle risorse per indirizzo.`,
"label.emailtocloudcc.position":`Posizione`,
"vue_label_email_please_enter_the_message_content":`Inserisci il contenuto della mail`,
"labal_About_to_jump":`È presto per reindirizzare.`,
"label_profile_mobile_setup_stand":`Homepage standard`,
"label.visualpage.component.n3":`3.Parametri. Il parametro è scritto nei propertiti args ,args="name:'zhang', age:26" Nota le doppie virgolette singole.`,
"vue_label_report_operationmode":`Modalità di funzionamento del rapporto`,
"label.reportsSubscription.select.attached.file":`Seleziona il tipo di file allegato.`,
"label.afghanistan.time":`Tempo dell'Afghanistan`,
"label.vlidaterule.formulatrue":`Se questa espressione di formula è vera, visualizza il testo definito nell'area Messaggio di errore`,
"label.ccchat.person.invite.erroremail":`Il formato dell'indirizzo e-mail non è corretto.`,
"label.viewDashboard":`Vai all'elenco dei cruscotti`,
"label.at":`su`,
"label.notification.arketsea.beforeretrieve":`Il tuo {0}：{1} sarà riciclato in {2}， tempo rimanente: {6} giorni`,
"label.field.update.show.editor":`Mostra l'editor delle formule`,
"label.weixin.polls.time":`Data del voto`,
"vue_label_commonobjects_detail_activity_nostarttime":`Nessuna ora di inizio`,
"label.direct.dashboard.me.not.approval70":`Articoli in attesa di approvazione presentati da me`,
"label.data.setok.t_desc3":`, Operazione.`,
"label.view.edit.search.describe":`Cerca dopo aver inserito le parole chiave`,
"label.importsourcefiletip":`Prima di importare il tuo file tradotto, assicurati di quanto segue: <span><ul><li>1.Crea un file separato per ogni lingua che vorresti importare e che contiene solo il nome e la traduzione.</li><li>2.L'attributo della lingua all'inizio di ogni file è richiesto. (Importazione cinese non supportata).L'attributo della lingua assomiglia a questo\uff1aLanguage=it_US.</li><li>3.Assicurati che i tuoi file di importazione siano salvati in codifica UTF-8 prima di importare.</li>4.Assicurati di inserire il line feed alla fine del file che vuoi importare.</li></ul></span>`,
"UG.Case.01":`Caso`,
"label.weixin.report.filters":`Filtri`,
"vue_label_homepage_profilehomepageassignment":`Assegnazione della pagina iniziale del profilo`,
"label_tabpage_editview":`Modifica vista`,
"label.tabpage.allpotentialcustomers":`Tutte le piste`,
"label.sendemail.send.standbyemail":`(posta in uscita di riserva)`,
"errormessage.email.atleastonereceiver.z":`Devi selezionare o modificare un indirizzo di ricezione.`,
"workflow.action.tasks.assignortype.ownertype":`Tipo di proprietario`,
"label.list.userinterface.new.page.setup":`Nuova pagina`,
"chatter.seladress":`Si prega di selezionare almeno un destinatario.`,
"Pagelayout_Setup_004":`Si possono impostare fino a 4 campi`,
"label.mobile.home.page.tenbig.opp":`Le 10 migliori opportunità nei prossimi 30 giorni`,
"label.wtd.changefields.newpc":`Generare la pagina del PC`,
"label.opportunity.perm.remark":`Questa è un'opportunità privata, si prega di contattare il proprietario per ottenere l'accesso.`,
"label.data.exp.tempdes":`Descrizione del modello`,
"label.appointment.wizard.subtitle2-1":`Da`,
"lable.currencyManage.button.manageexchangeRate":`Gestire i tassi di cambio datati`,
"label.file.viewinfo":`Visualizza i dettagli del file`,
"label.integrations.mailchimp.export.failed":`L'esportazione dei dati non è riuscita, controlla la tua connessione di rete e riprova`,
"pagecreator_page_button_edit":`Modifica`,
"label.icon.86":`Cartella`,
"label.exchange.sync.reset":`Ripristinare la sincronizzazione`,
"label.customfields.lookupfilter":`Puoi creare un filtro per limitare i record che sono disponibili per l'utente nel campo Lookup.`,
"label.component.hotdeal.nopermission":`Per vedere i dati relativi alle tue opportunità commerciali, contatta il tuo amministratore CloudCC.`,
"label.address.province":`Stato`,
"lable.PowerProcess.3digit.input":`Non più di tre cifre.`,
"label.asset":`Attività`,
"label.passwordPolicy.setup.nopwdremember":`Nessuna password ricordata`,
"front-electronic-signature-setting-intro2":`Prima di avviare un contratto, preimpostare il modello sulla piattaforma DocuSign. Quando si avvia la firma, è possibile selezionare il modello di contratto preimpostato.`,
"pagecreator.page.button.new":`Nuova pagina`,
"label.tabpage.step2":`Passo 2 specificare le condizioni del filtro`,
"label_switch_two_column_or_responsive_layout":`Passare al layout a due colonne o reattivo`,
"label.batchDelete":`Eliminazione di massa`,
"chatter.edit.ct":`Modifica le tue informazioni di contatto.`,
"UG_ST_003":`Non hai il permesso di creare {0}, contatta l'amministratore, clicca su conferma per andare direttamente all'interfaccia {0}.`,
"label.timzone.tip.info2":`Quando si usa simpledateformat per formattare la data, è necessario impostare i fusi orari per le istanze di simpledateformat, come SimpleDateFormat myDateFormat=new SimpleDateFormat("yyyy-MM-dd");myDateFormat.setTimeZone(TimeUtil.getUserTimeZone(userInfo));o ottenere un'istanza usando il metodo fornito da TimeUtil, SimpleDateFormat myDateFormat=TimeUtil.getSimpleDateFormat("yyyy-MM-dd",userInfo);`,
"label.ems.firstsynchistory":`Sincronizzare per la prima volta le mail da quanto tempo`,
"label.currency.invalid":`Valute inattive`,
"label.mask.custom":`Personalizza`,
"lable.opppdt.addpdt.title":`Seleziona il prodotto`,
"label.appointment.wizard.subtitle3-3":`Mercoledì`,
"label.weixin.report.criteria":`Raggruppati per`,
"label.appupload.upload.install.uninstall":`Impossibile installare`,
"label.compact.layout.frame.split":`Visualizzazione su schermo separato`,
"label.email.attach.complete.info":`Dopo che il caricamento è completo, il file verrà visualizzato nell'elenco degli allegati qui sotto`,
"label.Receivables":`Crediti`,
"label.linkedin.title.setting":`Informazioni integrate di LinkedIn`,
"label.companynotice":`Annuncio dell'azienda`,
"label.emailobject.discard":`Scartare`,
"label.selected.searchfield":`Campo dei risultati di ricerca selezionati`,
"front-electronic-signature-explainDocusign":`Descrizione della firma elettronica DocuSign:`,
"chatter.link.name":`Nome del link`,
"label.low":`Basso`,
"label.verticalline":`Colonne verticali`,
"label.approval.isallowed.reject.label":`Permettere il rifiuto quando si approvano dati singoli?`,
"label.emailtocloudcc.button.enable":`Attivo`,
"label.dashboardSetup.showdw.d5":`Unità intera`,
"label.usermanage.not.authority":`Non hai i permessi sufficienti per farlo.`,
"label.customobjects.track.introduce0":`Questa pagina permette di selezionare quali campi tracciare nella lista correlata {0} "Field Tracking". Ogni volta che un utente modifica uno dei campi selezionati di seguito, il vecchio valore del campo e il nuovo valore del campo, così come la data, l'ora, le caratteristiche del cambiamento e l'utente che effettua il cambiamento vengono aggiunti alla lista correlata "Monitoraggio del campo".`,
"canlendarmonth":`Mese di calendario`,
"vue_label_dashboard_minimum":`Inserisci il minimo`,
"label.salescloud.optionlist.inputname.linealone":`Inserisci uno o più valori dell'elenco di scelta qui sotto, con ogni valore separato da una nuova linea.`,
"message.error.organuzation.information.null":`Le informazioni sull'organizzazione non esistono.`,
"label.tabpage.maxfilez":`La dimensione massima del file è`,
"message.validation.apiname":`Deve iniziare con una lettera, deve contenere solo lettere, numeri e underscore, deve contenere solo lettere maiuscole e minuscole, numeri e underscore, e la lunghezza massima è di 50 caratteri, la lunghezza minima è di 2 caratteri.`,
"report.type.label.contractPayment":`Contratti e crediti`,
"label.limiting.choose.three.files":`È possibile selezionare 3 file, selezionati ora.`,
"label.reportTypeFocus":`Rapporto Fonte di dati Focus`,
"Report_Delete_Confirm_Title":`Si prega di confermare`,
"front-gantt-module-reorder-milestones":`Riordinare le pietre miliari`,
"front-starter-v1-customer-tips-success":`Attivare il pool di account con successo`,
"label.tabpage.isdeleteview":`Sei sicuro di voler cancellare questa vista?`,
"label.favorite.title":`Piattaforma CloudCC`,
"page.layout.sysinfo":`Informazioni sul sistema`,
"label.tabpage.pleaseSelectz":`Per favore seleziona`,
"label.smsnotice":`Notifiche SMS`,
"label.forecast.customforecast.foretype.Pipeline":`Pipeline`,
"label.rejectbehaviour":`Rifiuta il comportamento`,
"label.searchlayout.view.example.new":`Vedi esempio (Nuova finestra)`,
"vue_label_homepage_notice2":`È possibile assegnare manualmente il layout della homepage, rendendo più facile per i dipendenti completare i loro compiti quotidiani in modo efficace`,
"label.import.index.chooseidorother":`3. È possibile scegliere di utilizzare l'ID o il nome per abbinare il record e compilare il campo di ricerca. Se hai bisogno di acquisire l'ID del record corrispondente e altre informazioni, puoi creare un rapporto e impostare il nome del record e l'ID del record come colonne del gruppo, e poi esportare il rapporto.`,
"label.westem.european.summer.time":`Ora dell'Europa occidentale`,
"label.brackets":`Parentesi`,
"asset.serialnumber.unique":`Il numero di serie della risorsa esiste già, per favore non aggiungerlo ripetutamente.`,
"label.callcenter.access.keyID":`ID della chiave segreta di accesso`,
"label.calendar.month.view":`Vista del mese`,
"label.realdelete":`Cancellare definitivamente`,
"label.partnerCloud.orderingPlatform.amountPaid:":`Da pagare:`,
"label.reportTypName":`rapporto fonte di dati Nome`,
"lable.newtabpage.opensearchresult":`Espandi i risultati della ricerca`,
"front-kefu-moudle-v1-Session-duration":`Durata della sessione:`,
"label.import.index.ignore":`Ignora`,
"label.customfields.url.tip":`Quando gli utenti cliccano sul campo, l'URL si aprirà in una nuova finestra o nella finestra corrente secondo le impostazioni degli utenti, e l'impostazione predefinita è di aprire l'URL in una nuova finestra.`,
"label.projectManagement.editMilestone":`Modifica pietra miliare`,
"front-gantt-module-v1-project-gantt-list":`Elenco dei progetti`,
"label.validate.remark":`Le regole di convalida aiutano a migliorare la qualità dei dati impedendo agli utenti di salvare dati errati. Si possono definire una o più regole di convalida che consistono in una condizione di errore e nel corrispondente messaggio di errore. Le regole di convalida vengono eseguite al momento del salvataggio del record. Se si verifica una condizione di errore, il salvataggio viene interrotto e viene visualizzato un messaggio di errore.`,
"front-kefu-moudle-v1-sjgsbzq-reinput":`Il formato del numero di telefono non è corretto. Si prega di reinserire`,
"label.channel.name":`Nome del canale`,
"label.weixin.cloudcc.user.message":`Informazioni per gli utenti CloudCC`,
"label.icon.59":`Workshop`,
"label.ccpeak.function":`Metodo`,
"lable.opppdt.selPdt.leastten.fields":`Si prega di selezionare fino a 5 campi`,
"label.deadline":`Scadenza`,
"label.product.sel":`Selezione del libro dei prezzi`,
"vue_label_helpcenter_detail2":`Tutti gli eventi: Mostra tutti gli eventi a cui hai accesso, anche se non stai partecipando.<br>    Puoi anche filtrare i record di attività che vuoi visualizzare in base all'intervallo di date e al tipo di attività.<br>    4. Dinamico<br>    Tutte le persone che possono visualizzare questo record possono lasciare un messaggio e un post sotto la colonna "Dinamico" del record, ed è anche possibile visualizzare tutte le modifiche delle informazioni, le ultime attività, e i commenti di altre persone e post su questo record. Questa colonna facilita la comunicazione lavorativa online e la collaborazione tra voi e i vostri colleghi, aiutando a migliorare il lavoro di squadra e l'efficienza.<br>Posting<br>    Fase 1: Fare clic sulla barra di distacco e inserire il contenuto di distacco<br>    Fase 2: Fare clic sul pulsante File/Link per aggiungere un file/link come necessario<br>     Fase 3: Fare clic su "Condividi" per finire il distacco. <br> Visualizza il post<br>    Dopo che il post è pubblicato con successo, è possibile vedere il micro-post appena pubblicato qui sotto. Il micro-post è composto dalle seguenti parti: avatar, nome della persona, contenuto del micro-post e metodi di interazione (like/comment/edit/delete post). <br> Ordinamento e ricerca dei post<br>     Clicca sull'elenco a discesa a destra di "Ordina" per cambiare l'ordinamento dei post. <br>    Ordinamento "Ultima attività": ordina in base al tempo di interazione più recente dei micro-post;<br>     "Ultimo post "Ordina: Organizza in base al tempo di pubblicazione dei micro-post;<br>    Visualizza diversi tipi di micro-post<br>    Micro-post di testo semplice: Sfoglia l'intero contenuto direttamente nell'area di pubblicazione del micro-post;<br>     Micro-posts contenenti file: clicca sul pulsante di download del file per scaricare il file in locale per la visualizzazione;<br>    Micro-posts contenenti link: clicca sul link nel micro-post per aprirlo;<br> Commentare e apprezzare i micro-post<br>    Commentare<br>   Passo 1: Clicca su "Commenta" sotto ogni micro-post <br>     Passo 2: Inserisci il commento nella casella di testo che si apre<br>   Passo 3: Aggiungi il file/link al commento come necessario Passo 4: Clicca su "Comment" sotto la casella di testo per completare l'operazione<br>    Elimina commento<br>    L'editore del commento può cancellare il contenuto del commento. Clicca sul pulsante a destra del commento e seleziona "Elimina" nella casella a discesa.`,
"pagecreator_layout_button_mergecell":`Unire le celle`,
"Lead_Scoring_Setting_Rule_Setup_Active":`Attivo`,
"label.query.detail.loginbypartneruser":`Accesso per utente partner`,
"label.view.selectrenderfields":`Seleziona i campi da visualizzare`,
"label.code.add":`Aggiungi informazioni sul link del codice QR`,
"label.appointmentconfirmpage.wizard.title1":`RIUNIONE PROGRAMMATA`,
"label.timzone.tip.title":`Quando si ha a che fare con le date usando new date() o calendar, si dovrebbe fare attenzione a gestire i corrispondenti problemi di fusi orari multipli. inoltre, la classe di strumenti timeutil fornisce una serie di strumenti che supportano i fusi orari multipli.`,
"label.tag.addtags.visibility":`Visibilità`,
"label.appointmentconfirmpage.wizard.title3":`Sei sicuro di voler cancellare l'appuntamento esistente e farne uno nuovo?`,
"lable.outlook.detail.oldest":`Il più vecchio`,
"label.account.custom.quarter.timeerror":`La data di inizio del trimestre personalizzato o la data di fine del trimestre personalizzato è tra i trimestri personalizzati della storia, per favore controlla e ripristina`,
"label.sendsms.idea":`Rispettato`,
"label.manageAll.pagenum2":`Questa è l'ultima pagina.`,
"serviceterritory.isactive.notactive":`Questo territorio di servizio non è abilitato.`,
"label.userinfo.newpwd.notnull":`Inserisci la tua nuova password.`,
"vue_label_dashboard_nolinkagedashboard":`Nessun cruscotto di collegamento`,
"message.cannotdeleteapproval":`Non è possibile cancellare questo processo di approvazione.`,
"label.wtd.detail.m":`Mobile`,
"label.app.step4.introduce":`Scegli le schede da includere in questa app personalizzata.`,
"label.ccchat.error.permission":`Nessun accesso`,
"UG_opportunity_009":`Oppure`,
"label.Receivables.TheActualAmountOfMoney":`Entrate effettive`,
"label.callcenter.no.search":`Nessuna domanda pertinente alle informazioni`,
"label.user.introduce":`Utenti`,
"message.datalocked.addpdt":`Questo record di opportunità è bloccato, non puoi aggiungere Pruduct.`,
"label.sendsms.step1":`Step1: Specificare i destinatari`,
"label.brief.contracts":`Contratti`,
"label.setup.mini.swap":`Impostazione del carosello`,
"label.emailobject.wizard.desc1":`Collega la tua email, invia la posta qui e sincronizza automaticamente il record`,
"label.login.verification.mfa.desc2":`Se non sei in grado di verificare per qualche motivo, come le app MFA perse o cancellate per errore sul tuo telefono, potresti aver sentito l'amministratore disassociare l'MFA.`,
"label.notification.receiveSms.message":`Hai ricevuto un messaggio di testo da {!fromaddress}, clicca per vedere più dettagli`,
"label.emailmerge.mergeFolder.publicfolder":`Modelli di unione di e-mail pubbliche non archiviate`,
"label.password.update.false":`Impossibile cambiare la password, contatta l'amministratore!`,
"label_tabpage_systemz":`Sistema/i`,
"label.dataimport.objectid.null":`L'ID dell'oggetto è vuoto e non può essere importato`,
"label.currency.type":`Tipo di valuta`,
"component_setup_button_appurl":`Url del sistema`,
"label.appointmentconfirmail.wizard.title2":`Hai un programma {0}`,
"lable.product.please.enter":`Per favore, inserisci`,
"label.escalation.setup.title":`Regole di escalation del caso`,
"label.create_failure":`Impossibile creare il modulo`,
"label.weixin.brand.model":`Modello di marca`,
"label.layout.nameoftestobj2":`Nome dell'oggetto di prova due`,
"vue_label_filters_number":`Sono supportati 10 compilatori per ogni rapporto.`,
"label.file.following":`Seguendo`,
"vue_label_account_all_contracts":`Trasferire tutti i contratti dei proprietari dei clienti`,
"label.service.please.select.cycle.type":`Selezionare il tipo di ciclo`,
"label.weixin.weipoll.optionname":`Scelta del micro voto Nome`,
"label.data.newtemplate.null":`Nessuno`,
"message.passwordPolicy.validate.complexReq1":`Errore:La tua password deve avere un mix di lettere e numeri`,
"label.forecast.shre.editmanager":`Modifica del manager`,
"label.emailtemplate.tip":`Sotto c'è una lista di tutti i tuoi modelli di e-mail nella cartella selezionata. Clicca sul pulsante nuovo per creare un nuovo modello di email di testo o HTML. Puoi usare questi modelli di email quando invii singole email.`,
"label.tag.manage.button":`Gestire i tag`,
"label.changepw":`Cambiare la password`,
"label.sso.saml.sp.idsource.nameid":`L'identità è nell'elemento NameIdentifier della dichiarazione Subject`,
"label.salescloud.teamrole.addmember":`Aggiungere i membri del gruppo di opportunità CloudCC`,
"label.h5.similar.opportunity.last.months6":`Recenti 3-6 mesi`,
"message.save.opportunity.role.save.failed":`Impossibile salvare il ruolo di contatto`,
"vue_label_report_formulainformation":`Informazioni sulla formula`,
"label.area.assignuser.remark":`Assegnare gli utenti al territorio`,
"label.multilang.viewlist.total":`{0} Selezionato`,
"label.newprocessstep4":`Passo 4 Selezionare i modelli di notifica e-mail`,
"label.permission.objectpermission.open":`Aprire`,
"label.service.gantt.close.list":`Chiudi Elenco`,
"label.standarduserfield":`Campi utente standard`,
"vue_label_commonobjects_detail_the_administrator":`Il record è stato bloccato, per favore contatta l'amministratore.`,
"label.exchange.sync.account":`Credenziali dell'account del servizio Exchange`,
"label.mr.title.button.back":`indietro e reimpostare i criteri di ricerca`,
"label.notsetup.operation":`Errore di condizione della linea, nessun operatore è stato impostato.`,
"label.notifications_center":`Centro notifiche`,
"label.event.moveup.5hour":`5 ore avanti`,
"report_label_pleaseinput":`Inserisci ciò che vuoi cercare`,
"label.batchadd.newbatchpage.errorlist":`Aggiunta di dati non riuscita`,
"label.quickbooks.invoices":`Fatture`,
"chatter.feed.usingchatter":`Attiva CCChat, i tuoi utenti possono seguire alcune persone o record e postare.`,
"label.all.marketing.activities":`Proprietario della campagna di mercato`,
"label.lookup.finish":`Completamento automatico della ricerca`,
"label.weixin.unbind":`Sblocca`,
"front-console-closeTime":`Tempo di chiusura`,
"label.service.rest.time":`Tempo rimanente`,
"label.mr.descreption.condition1":`Inserisci l'ambito e le regole per trovare i record duplicati. Clicca su [Trova duplicati] per ottenere record duplicati qualificati.`,
"label.group.new":`Nuovo gruppo`,
"vue_label_SMS_sending_please_wait":`Invio, attendere prego`,
"label.Standardobj.tab":`Schede oggetto standard`,
"label_chatter_pastEvents":`Attività passate`,
"label.chatter.priority":`Priorità`,
"select.nullvalue":`-Nessuno-`,
"setup_layout_group_pagecomponent":`Componenti della pagina`,
"label.dataimport.dataerror.check":`Errore nei dati, si prega di controllare i dati.`,
"label.permission.detail.app.pagesetting.tip":`Escludere le impostazioni di autorizzazione delle pagine personalizzate`,
"label.knowledge.language.polish":`Polacco`,
"label.project.hit.two":`Promemoria della scadenza del sottocompito`,
"label.customerapp":`App personalizzata`,
"label.reportsSubscriptionPage.condition.value":`Valore`,
"label.tabpage.no2z":`No2`,
"lable.system.administrator":`Spiacente, non hai l'accesso per operare. Si prega di contattare l'amministratore.`,
"homepage.layout.buttion":`Assegnazione del layout di pagina`,
"label.notification.event.overlapEvent":`L'utente delegato è già stato assegnato a un evento {subject} da {begintime}-{endtime}, vuoi creare comunque questo evento`,
"label.customfields":`Campi personalizzati`,
"label.data.downpage.e.title":`Fasi di esportazione dei dati`,
"label.notification.serviceappointment.remove":`L'ordine di lavoro spedito {0} è stato annullato, si prega di organizzare il lavoro in modo ragionevole.`,
"label.campagin.roi.zhuangtai":`Stato della campagna`,
"label.applt.updown":`Scaricare Miniprogramma QR Code`,
"label.customfields.new.step1.tip":`Specifica il tipo di informazione che il campo personalizzato conterrà.`,
"label.staticresource.upload.limit":`Solo i file in questi formati possono essere caricati: png, jpg, gif, js, css, zip.`,
"chatter.edit.user.p":`Cambiare la foto dell'utente`,
"label.icon.32":`Computer`,
"vue_label_homepage_notice_cantset":`La homepage del profilo non è configurata per questo profilo, la homepage predefinita del profilo non può essere modificata`,
"front-epwechat-module-v1-agree-unbound":`Accettare le informazioni non vincolanti di cui sopra`,
"label.version.chatter.cooperation":`CCChat`,
"label.customer.tab.step1.selectstyle":`Si prega di scegliere uno stile di scheda.`,
"label.select.an.asset":`Si prega di selezionare una risorsa.`,
"label.search.sizer.field":`Campi del filtro di ricerca`,
"label.emailmerge.mergeFolder.lastone":`Si prega di selezionare almeno un modello.`,
"label_tabpage_step2":`Passo 2 specificare le condizioni del filtro`,
"label.version.lead.automatic.allocation":`Regole di assegnazione del piombo`,
"label.projectManagement.update.succeeded":`Aggiornare con successo`,
"label_tabpage_bar":`Bar`,
"label.appupload.component.type.tab":`Scheda`,
"label.pigeonhole.sel.f":`Scegliere le cartelle da archiviare`,
"homepage.components.status":`Stato dei componenti`,
"label.currency.edit.new":`Modifica valuta: nuova valuta`,
"label.input.new.password":`Inserisci la nuova password corretta`,
"chatter.group.membersName":`Nome dell'utente`,
"label.myinfo.modify":`Modifica delle informazioni personali`,
"label_tabpage_next":`Prossimo passo`,
"vue_label_homepage_card_closedopportunities":`Opportunità chiuse`,
"label.permission.edit":`Modifica delle proprietà`,
"message.error.searchfield.objid.null":`L'id dell'oggetto richiesto dal campo query non può essere vuoto`,
"label.partnerCloud.productSet":`Impostazione del prodotto`,
"label.emailtocloudcc.filed.emailto":`Email a`,
"label.service.miniProgram.uploadingImage":`Si prega di caricare l'immagine del carosello.`,
"label.sso.saml.idp.description1":`App connesse`,
"label.event.moveup.10minutes":`10 minuti avanti`,
"label.quote.createby":`Preparatore`,
"label.workflow.baseontimeoparate":`Azioni del flusso di lavoro dipendenti dal tempo`,
"label.searchall.r":`Cerca di nuovo`,
"vue_label_homepage_differentprofiles":`Assegnare homepage diverse a profili diversi`,
"label.campaign.channel.step1":`Passo1: Informazioni`,
"label.event.moveup.2hour":`2 ore avanti`,
"font-evaluate-module-v1-cancle-reply":`Annullamento della risposta automatica`,
"message.datalocked.delete":`Non puoi cancellare questo record perché è stato bloccato. Se vuoi cancellarlo, contatta l'amministratore.`,
"label.sso.listOfKey":`Elenco delle chiavi`,
"label_chatter_newtask":`Nuovo compito`,
"label_emailsync_form_seversetting":`Impostazione`,
"label.partner.new.function":`Descrizione delle caratteristiche`,
"vue_label_notice_homepage_pleaceentername":`Inserisci il nome della homepage`,
"message.please.choose.opportunity":`Si prega di selezionare l'opportunità di business`,
"label_file_use_most_user":`Utenti con il maggior spazio di archiviazione utilizzato`,
"label.htyj.remark2":`quindi non è possibile visualizzare gli importi dei contratti`,
"label.formula.message":`quando la formula è valutata come falsa, la richiesta di fallimento dell'invio`,
"UG_Case_04":`Assegnazione del caso`,
"label.displaycolumn":`Mostrare le colonne`,
"vue_label_campaign_selected_member_status":`Aggiornamento allo stato di membro selezionato`,
"label.workflow.operate":`Azioni del flusso di lavoro`,
"label_chatter_mail":`Posta`,
"label.setup.mini.setting":`Impostazione dello sfondo dei mini programmi`,
"vue_label_chat_invitetojoin":`Hai invitato "{invito}" a partecipare alla chat di gruppo`,
"setup.object.field.dependency.label.linkedfieldvalue":`Campo dipendente`,
"vue_label_email_update_template":`Aggiornare il modello`,
"label.email.template.private.mail":`Cartella di modelli di email esclusivi`,
"lable.Confirm .potential.customers":`Conferma di riciclare il piombo {nome}`,
"vue_label_leadpool":`Piscina di piombo`,
"label.ems.hostorpost.error":`Errore di configurazione del server o della porta, si prega di controllare.`,
"label.search.saveok":`Salvato con successo`,
"label.custom.field.cannot.maping":`Impossibile mappare questo campo più volte`,
"label.projectManagement.dispatched":`Inviato`,
"time":`Tempo`,
"label.choose_socialnetwork":`Scegliere un social network per iniziare`,
"label.vlidaterule.checkedtrue":`Se la formula è una casella di controllo, non c'è bisogno delle doppie virgolette`,
"label.appointmentconfirmail.wizard.btn1":`Riprogrammare`,
"front-kefu-moudle-v1-maxchars-input":`Si possono inserire fino a {0} caratteri`,
"setup.mainpage.label.welcome10":`Istruzioni: Fare clic sul menu sul lato sinistro della pagina → Impostazioni applicazione → Crea → Oggetto → Nome oggetto → Layout personalizzato.`,
"label.ems.company.setup.title":`Impostare la casella di posta elettronica dell'azienda`,
"label.channel":`Canali`,
"label.textmessage.groupsms":`SMS di gruppo`,
"label.asset.deleted.successfully":`Elimina la distinta degli asset con successo.`,
"label.knowledgebase.new.workspace":`Nuovo spazio di lavoro`,
"label.ServiceCloud.diliweizhi":`Posizione`,
"label.private_me":`Privato al proprietario (io)`,
"label.service.miniProgram.imageLink":`Collegamento al carosello`,
"label.area.assigned":`Utenti assegnati`,
"label.weixin..xsld.name":`Nome dell'opportunità`,
"label.campaign.matchway.select.name":`Nome`,
"label.installedsoft":`Pacchetti installati`,
"label.projectManagement.spare.time":`Tempo disponibile`,
"label.user.select.custom.text.sendemail":`Seleziona il formato di testo personalizzato per inviare direttamente l'e-mail`,
"label_chatter_chatter":`CCChat`,
"label.approveorrefuse":`Approvare/Rifiutare`,
"startdate.enddate.time.illegal":`La data di inizio dovrebbe essere inferiore o uguale alla data di fine.`,
"label.project.hit.eight":`Promemoria dei compiti quotidiani`,
"message.duplication.label.uncheck":`Noo-verifica`,
"label.allocation.role":`Assegnare gli utenti`,
"label.sendemail.lead.scoreinfo":`Caro #username:\r\n il sistema ha assegnato un punteggio a tutti i lead delle viste lead che hai selezionato "#viewlabel" in base alle regole del lead scoring. ci vuole #timestr.\r\n per favore effettua il login e apri la vista per controllare i risultati.\Attenzione: se non riesci a visualizzare il punteggio dei lead che hai valutato, per favore modifica la vista e aggiungi "lead scoring" al campo da visualizzare per vedere il risultato del punteggio.`,
"lable.oppt.jieduan.closejieduan":`Chiudi questa opportunità`,
"label.ems.verify":`Verifica`,
"message.error.startdate":`La data di inizio deve essere precedente alla data di fine`,
"label.campaignmember.main.deletelead":`Rimuovere i lead esistenti dei membri`,
"label.partnerCloud.financeSetting.account":`Dopo l'attivazione del fondo partner, vengono aggiunti gli oggetti del fondo partner e l'estratto conto del fondo. Gli utenti partner possono utilizzare il conto in CloudCC per pagare gli ordini.`,
"message.datalocked":`il suo record è bloccato. Se hai bisogno di modificarlo, contatta il tuo amministratore.`,
"lable.opppdt.selPbk.pricebook":`Prezzo Libri`,
"label.knowledgebase.restore.article":`Ripristinare l'articolo?`,
"label.object.batchadd":`Batch Add {objName}`,
"label.what_happen":`Pagina dopo l'invio del modulo`,
"label.roleandunderling":`Ruoli e subordinati`,
"label.knowledge.language.russian":`Russo`,
"front-electronic-signature-explain-first":`Prima di vincolare la firma elettronica, si raccomanda di registrarsi e certificarsi sulla piattaforma Fadada.`,
"component.sendmail.label.subject":`Tema`,
"month":`Mese`,
"label_chatter_save":`Salva`,
"label.view.sortview.sectiontitle":`La vista sarà visualizzata nell'ordine selezionato`,
"label.mobile.home.page.major.project":`Progetti chiave`,
"label.weixin.input.filename":`Inserisci il nome del file`,
"label.pagelayout.remark":`Questa pagina permette di creare diversi layout di pagina per visualizzare`,
"label.service.miniProgram.store":`Storia del marchio`,
"label.recordtype.edit.selected":`Valore selezionato`,
"message.selectgroupcondition":`Selezionare le condizioni per il raggruppamento`,
"label.y.axis.cannot.empty":`L'asse Y non può essere nullo`,
"label.textmessage.vonage.connected.count":`Conta come contattato`,
"setup.layout.label.readonly":`Di sola lettura`,
"front-kefu-moudle-service-agent":`Servizio clienti`,
"message.login.mfaverification.page.invalid":`La pagina non è valida, si prega di aggiornare.`,
"label.central.standard.time":`Ora solare centrale`,
"label.processnoticepic":`Attenzione immagine del processo di approvazione`,
"vue_label_helpcenter_calendar1.2":`Regole di visualizzazione delle voci del calendario: le voci del calendario saranno visualizzate nella griglia del calendario, e l'area della griglia dove si trova la voce del calendario rappresenta l'intervallo di tempo del record. Le voci del calendario che coprono più di 24 ore saranno visualizzate in cima alla scala temporale nelle viste giorno, settimana e disponibilità. Se ci sono più voci di calendario in una griglia nella vista mese, puoi cliccare " More" per visualizzarle. Il lato sinistro o destro della voce del calendario è un semicerchio, il che significa che non c'è un record simile nel giorno precedente o successivo della griglia. Il lato sinistro o destro della voce del calendario è arrotondato ad angolo retto, indicando che c'è ancora questo record nel giorno precedente o successivo della griglia. <br> Individua rapidamente la data nella vista calendario: Puoi localizzare l'intervallo di date visualizzato nella vista calendario a sinistra selezionando l'ora sul piccolo calendario sul lato destro della pagina del calendario. Puoi anche cliccare le icone "<" e ">" in alto a destra della pagina del calendario per cambiare rapidamente le date. Se l'ora della tua vista calendario non è l'ora corrente, puoi cliccare sull'icona "Oggi" in alto a destra della pagina del calendario per tornare rapidamente a oggi. <br> Vista elenco<br> Passa dalla vista calendario alla vista elenco: Clicca l'icona "calendario" in alto a destra della vista calendario e seleziona "tabella" per passare alla vista elenco eventi. <br> Uso della vista elenco: Per visualizzare eventi specifici o più eventi allo stesso tempo, apri la vista tabella. Ci sono delle viste elenco preimpostate nella vista elenco. Fai clic sull'icona "pulsante a discesa" nell'angolo superiore sinistro della vista elenco per visualizzare tutte le viste elenco a cui hai accesso. Puoi anche personalizzare la vista elenco degli eventi per soddisfare le tue esigenze. <br> 2. Il mio calendario e altri calendari<br> Il mio calendario<br> Il mio calendario contiene il mio calendario eventi e il calendario oggetti. <br> Il mio calendario eventi: Visualizza tutti i record di eventi in cui la persona assegnata è la tua nella vista calendario. Il mio calendario eventi non può essere rimosso, modificato o cambiato di colore. Puoi condividere "Il mio calendario eventi" con i tuoi colleghi.`,
"label.approval.end":`Fine`,
"vue_label_report_notice_cannotdelete":`Ci sono rapporti in questa cartella che non possono essere cancellati`,
"label.sso.saml.idp.loginurl":`URL di accesso idP`,
"label.emailtocloudcc.filed.port":`Porto`,
"label.directdashboard.righttitle":`Cruscotti di analisi delle vendite`,
"label.knowledge.case.suggest.article":`Articoli suggeriti in casi`,
"label.version.maxcount":`oltre il limite.`,
"label.weixin..xsld.yjqyrq":`Data di chiusura`,
"front-project-module-v1-unmarket-is-template":`Deselezionare il modello`,
"label.mobile.quickcreate.default.map":`Mappa`,
"chatter.click.p":`Clicca per vedere l'anteprima`,
"label.chat.topic.all.topic":`Tutti gli argomenti`,
"label.channel.head":`Supervisore del canale`,
"lable.edit.queue.emaildes":`Inserisci il nome della coda e l'indirizzo email da utilizzare per inviare le notifiche (per esempio, quando un caso è stato messo in coda). L'indirizzo email può essere per un individuo o una lista di distribuzione. Quando un oggetto viene assegnato a una coda, solo i membri della coda riceveranno una notifica.`,
"label.tag.filter":`Filtro Tag`,
"label_chatter_filterTimeLine":`Linea temporale di filtraggio`,
"label.dashboard.show.value":`Mostra i valori`,
"vue_label_normal_solution_sf":`Soluzione`,
"label.customfields.location.tip":`Permette all'utente di definire la posizione. include componenti di longitudine e dimensione che possono essere utilizzati per calcolare le distanze.`,
"label.weixin.copyright":`Copyright© 2008-2022 CloudCC.com,inc. Tutti i diritti riservati da CloudCC.com`,
"label.icon.33":`Computer`,
"label.mr.title.opportunityName":`Nome dell'opportunità`,
"template.report.sales.month":`Vendite di questo mese`,
"chatter.group.lookingForPeople":`Iniziare a digitare un nome`,
"label_tabpage_userz":`Utenti`,
"label.reportsSubscriptionPage.email.formatselection":`Seleziona il formato del rapporto che vuoi ricevere via e-mail`,
"lable.product.plist":`Prezzo di listino`,
"label.multilang.activity.monthline":`Settimana {0}`,
"label.ccchat.whose.name.contains2":`Membri di qualsiasi gruppo della campagna`,
"label.mobile.phone.day.report":`Note di lavoro quotidiane`,
"label.processsetting.set.files":`Impostare i campi`,
"label.systemlog.s":`Successo`,
"label.tabpage.uploadsz":`Carica`,
"serviceterritory.member.time.conflict":`In questo intervallo di tempo, le risorse di servizio sono diventate membri di un altro territorio di servizio.`,
"label_chatter_startDate":`Dati di partenza`,
"label.search.at.least.two":`I termini di ricerca non devono essere inferiori a 2 caratteri.`,
"label.approval.ressign.project":`Elementi da assegnare`,
"lable.custom.Previous.CY":`Precedente CY`,
"label_chatter_link":`Link`,
"label.weixin.group.name":`Nome`,
"label.partnerCloud.basicSetting.domainName":`L'operazione è irreversibile e il nome del dominio non può essere cambiato dopo l'inizializzazione. Sei sicuro di confermare l'operazione?`,
"lable.SalesCommitmentKanBan.targetContract":`Importo target del contratto`,
"label.currency.new":`Nuova valuta aziendale`,
"message.passwordPolicy.validate.complexReq3":`Errore: La tua password deve avere un mix di numeri e lettere maiuscole e minuscole, e caratteri speciali.`,
"label.icon.127":`Medici`,
"label.customfields.fieldname.tip":`Il nome del campo è un riferimento interno e viene utilizzato per scopi di integrazione come l'API.`,
"chatter.feed.menutype.feed":`Riassunto`,
"label.home.standard.dashboard.role":`Non hai informazioni sui ruoli, quindi non puoi visualizzare il cruscotto degli impegni di vendita.`,
"label.customfields.fielddependency.button":`Fare clic sul pulsante per includere o escludere i valori selezionati dalla lista di selezione dipendente:\uff1a`,
"label.recentprojects":`Articoli recenti`,
"label.appupload.logo.introduce":`Il logo del pacchetto deve essere più piccolo di 20KB. Le dimensioni dell'immagine devono essere al massimo di 60 pixel di larghezza per 60 pixel di altezza per ottenere i migliori risultati. Le immagini più grandi saranno ridimensionate e potrebbero apparire distorte.`,
"label.integrations.northamericanleads":`I leader nordamericani`,
"label.sms.balance":`Saldo (yuan)`,
"label.ccchat.message.num":`Notizie`,
"label.embed_website":`Per incorporare questo modulo, basta copiare e incollare il codice qui sotto nel codice HTML del tuo sito web.`,
"label.trigger.check.error":`Controllo della sintassi del trigger fallito.`,
"label.bmap.baidu.maps":`Mappe Baidu`,
"label.nextapproverauto":`Prossimo approvatore automatico determinato da`,
"label.customfields.date.tip":`Permette agli utenti di inserire una data o di scegliere una data da un calendario a comparsa.`,
"button.partner.back":`Ritorna`,
"label.layout.editcondition.tip":`Seleziona i campi che vuoi usare come criteri di ricerca. Nota che puoi selezionare fino a 10 campi.`,
"label.stacked.area":`Area impilata`,
"font-evaluate-module-v1-case-closed":`Solo quando il caso è chiuso`,
"label_emailsync_status_log":`Registro delle connessioni`,
"label.version.area.and.sales":`Gestione dei territori e team di vendita`,
"label.service.booking.sessions":`Ora dell'appuntamento di servizio`,
"label.untransfile":`Non tradotto`,
"label.textmessage.sentfail":`Fallito l'invio`,
"label.emailtemplate.detailinfo":`Dettagli del modello`,
"setup_mainpage_label_welcome13":`Istruzioni: Clicca sul menu in alto → Rapporti → Nuovo`,
"label.ccchat.error.nullid":`L'ID non può essere vuoto`,
"label.partnerCloud.partnerAccount.rebate":`Sconto Revenu`,
"label.appupload.component.type.scheme":`Campo`,
"front-kefu-moudle-phonein":`Chiamata in arrivo`,
"label.emailmerge.list.description":`I modelli di unione della posta sono documenti MicroSoft Word con campi di unione che fanno riferimento ai campi di CloudCC.com.`,
"vue_label_commonobjects_detail_select_first":`Si prega di selezionare prima gli articoli correlati`,
"label_emailsync_form_action":`Azione`,
"label.customfieldrelation":`Campi personalizzati e relazioni`,
"label.ems.other.msg":`Si prega di contenere CloudCC admin(<a href='mailto:admin@cloudcc.com' style='text-decoration: underline;'>admin@cloudcc.com</a>), avviare il servizio di sincronizzazione della posta.`,
"label.appointment.wizard.subtitle4-3-4":`1 h`,
"label.service.miniProgram.isOpen":``,
"equal":`è uguale a`,
"label.partnerCloud.financeSetting.merchantInformation":`Percorso di accesso: Piattaforma commerciante  Centro account  Informazioni commerciante`,
"vue_label_calendar_displayed_field_name":`Nome del campo visualizzato`,
"UG_opportunity_002":`Definisci il tuo ciclo di vendita, configura la fase`,
"label.tag.addtags.button1":`Salva`,
"label.explain":`Istruzioni`,
"label.icon.166":`Padiglione`,
"label.exchange.sync.setting.use":`Abilitare la sincronizzazione di Exchange`,
"label.chatter.assignPerson":`Persona assegnata`,
"lable.PowerProcess.event.condition":`Condizioni delle pietre miliari`,
"label.addattachment.step1":`Passo 1 Selezionare il file`,
"label.account.fiscal.quarter.timeerror":`La data di inizio del trimestre fiscale o la data di fine del trimestre fiscale si trova tra i trimestri fiscali della storia, si prega di controllare e reimpostare`,
"label.URL":`URL di riferimento`,
"label.icon.134":`Dati`,
"label.forecast.customforecast.foredis.sq":`Migliaia`,
"label.custom.field.number.decimal":`Numero errato di cifre.`,
"label.version.history.track.error":`La tua versione supporta solo la selezione di <=5 campi, non può selezionare più campi.`,
"label.log.os":`Sistema operativo`,
"label.partner.workspace.tab.option":`Schede disponibili`,
"label.partnerCloud.partnerAccount.accountWater":`Dichiarazione del fondo`,
"setup_layout_label_norelatedlist":`Nessuna lista correlata`,
"label.import.page1.nextstep":`Prossimo`,
"label.emailobject.view.attached":`Email con allegati`,
"label.SalesCommitmentKanBan.allTask":`Importo totale del compito`,
"label.eastem.daylight.time":`Ora legale orientale`,
"label.create_engaging":`Creare un post attraente per connettersi al mondo.`,
"label.area.adduser":`Aggiungere o eliminare un utente`,
"label.timezone.importtimezone.user":`Usa il fuso orario dell'utente di login`,
"label.passwordPolicy.setup.pwdremember1":`1 password ricordata`,
"label.query.detail.openpartneruser":`Abilita l'utente partner`,
"label.senduser":`Invia da`,
"Pagelayout_Setup_001":`Seleziona gli elenchi correlati che verrebbero visualizzati sul layout hover.`,
"label.mobile.parameter.setup":`Impostazioni dell'applicazione mobile`,
"message.device.not.bound.mfa":`Dispositivi MFA non vincolati`,
"setup.layout.label.buttonarea":`Area dei pulsanti`,
"chatter.email.reply.like":`Commenti su un articolo che mi piace`,
"label.chatter.day":`Giorno`,
"label.sendemail.chat.addComentspraisesubject":`CloudCC CCChat risponde al post piace`,
"label.field.remark2":`pagina.`,
"label.ggReleaseRange.release":`Pubblicare la gamma`,
"lebel.alreadyback":`Richiamato`,
"label.appupload.install.appname":`Nome dell'applicazione`,
"label.selectnewadeckertag":`Seleziona l'etichetta per il nuovo campo gerarchia`,
"label.cliententrancewebsiteadmin":`Amministratore del portale clienti`,
"label.checkbox.checked":`Selezionato`,
"UG.Case.03":`Aggiornamento automatico della cassa`,
"vue_label_dashboard_group":`Seleziona un gruppo`,
"label.import.index.preparedata":`Preparare i dati da importare`,
"vue_label_member_notice1":`Puoi caricare file JPG, GIF o PNG, la dimensione massima del file è 2M`,
"message.modify.success":`Modifica riuscita.`,
"label.userquotas":`Quote`,
"label.appointmentpage.wizard.subtitle3-1":`Nome`,
"label.import.index.maxdata2":`2. Prima di importare, assicurati di importare prima tutti i record correlati. Per esempio, se c'è una relazione di lookup tra l'oggetto che stai importando e i contatti, per favore importa prima quei contatti, e poi importa i tuoi dati. Se hai bisogno di ottenere l'ID del record corrispondente e altre informazioni, puoi creare un rapporto e impostare il nome del record e l'ID del record come colonna di gruppo, e poi esportare il rapporto.`,
"label.pc.sectionpart":`Sezione PC`,
"template.chart.wcldqzkh":`Leads non elaborati`,
"label.save.the.block.pricing.information.of.the.current.price.manual":`Vuoi salvare le informazioni sui prezzi in blocco del libro dei prezzi corrente?`,
"label.partnerCloud.financeSetting.payments":`Permettere il pagamento online`,
"lable.account.ThisWeek":`Questa settimana`,
"label.validate.function.funcFormat.RIGHT":`RIGHT(testo, num_chars)`,
"label.app.select.bgcolor":`Seleziona il colore di sfondo`,
"label.planned.work":`Lavori pianificati`,
"label.passwordPolicy.setup.nolimit":`Nessun limite`,
"label.vlidaterule.s":`Se si disabilita la valuta utilizzata dall'utente, la valuta dell'utente sarà impostata alla Corporate Currency.`,
"label.paging.totalofrecords":`Un totale di {0} record`,
"label.customobjects.behaviour":`Azioni`,
"vue_label_ccchat_notice_deletecommentsuccess":`Commento cancellato con successo`,
"label.lock.record.dele":`Il record è bloccato, non puoi cancellarlo.`,
"label.data.expnode.e.desc3":`3. Creazione del modello: l'utente può fare il modello secondo i campi e le condizioni che saranno esportati per soddisfare le vostre esigenze, che è comodo da usare la prossima volta.`,
"label.button.step3.create.page":`Passo 3 Generazione della pagina`,
"label.sharer":`Condividi da`,
"label.service.cycle.type":`Tipo di ciclo`,
"lable.SalesCommitmentKanBan.allreceivingCommitmentRate":`Entrate totali Tasso di impegno`,
"label.formuladate":`Formato della data: yyyy-MM-DD hh:mm:ss o MM/DD/YYYYYhh:mm:ss, come ad esempio: 2007-12-25 12:25:30 o 12/25/2007 12:25:30. Potete anche usare today() o now();`,
"front-template-V1-addImg":`Aggiungi immagine`,
"label.basecontrol":`Accesso di base`,
"label.forecast.settings.lable1":`Aggregazione dei dati di previsione`,
"message.error.file.null":`Il file di caricamento non può essere vuoto`,
"label.multiply":`*Moltiplicare`,
"message.duplication.label.targetobject":`Oggetto`,
"label.addattachment":`Aggiungi allegato`,
"vue_label_dashboard_notice_editcertification":`Sei sicuro di voler modificare il componente {nome}?`,
"label.notification.tip2":`Nessuna nuova notifica`,
"lable.quote.syncingfrom.firstsync":`Inizialmente, l'opportunità di fare un preventivo`,
"label.createtasktip":`Crea un'attività da associare a una o più regole del flusso di lavoro, processi di approvazione o processi di autorizzazione. Quando si modifica un compito, qualsiasi modifica verrà applicata a tutte le regole, approvazioni o processi di abilitazione associati ad esso.`,
"label.leave":`Lascia`,
"front-invoice-online-payment-setup-china":`Applicare ai conti cinesi`,
"label.appointment.wizard.subtitle4-1-2":`30 min`,
"label.projectManagement.the.person.not.be.informed":`Quando si seleziona No, la persona responsabile non può essere avvisata!`,
"label.campagin.roi.name":`Nome della campagna`,
"label.import.page1.newcreate":`Creare`,
"label.data.downpage.i.title.num2":`2. Prima di iniziare l'importazione, assicurarsi che il nome del campo nel file che si vuole importare corrisponda al nome del campo dell'oggetto nel CloudCC.`,
"label.callcenter.call.in":`Chiama in`,
"label.weixin.activity.phone":`Attività: Chiama`,
"label.forecast.customforecast.type.role":`Per ruolo`,
"label.moscow.standard.time":`Ora solare di Mosca`,
"label.profile.setcustomobjectrecordtype":`Impostazioni personalizzate del tipo di record`,
"lable.edit.queue.new":`Nuova coda`,
"label.newAPPexchange":`Nuova applicazione...`,
"message.custom.field.donotdelete.fieldupdate":`Questo campo è referenziato da un aggiornamento di campo in un altro flusso di lavoro o processo di approvazione.`,
"label.chatter.state":`Stato`,
"label.subject_line":``,
"template.report.folder.active":`Analisi delle campagne e delle azioni`,
"label.icon.114":`Casa`,
"label.assignment.setup.newentries.step3":`Passo 3 Selezionare l'utente a cui assegnare il comando`,
"label.salescloud.salesdashboard.sales.behavior.rankings":`Panoramica sul comportamento personale`,
"label.weixin.optiontwo":`Scelta 2`,
"label.sso.saml.idp.config.sp":`Fornitori di servizi`,
"System_TimeField_Description":`Permette agli utenti di inserire un'ora locale. Per esempio, "2:40 PM", "14:40" e "14:40:00" sono tutti orari validi per questo campo.`,
"label.knowledgebase.draft":`Bozza`,
"label.chat.topic.no.more.suggestions":`Nessun altro suggerimento`,
"label.quote.product":`Prodotto`,
"label.cryptographictext":`Testo crittografato`,
"label.custom.unlock":`Sblocca`,
"label.assignment.setup.newentries.step2":`Passo 2 Selezionare i criteri per questa voce di regola`,
"label.tabularreport.selectline":`Seleziona le colonne che vuoi includere nel rapporto.`,
"label.exchange.sync.state.contact.m2":`Registrazioni sincronizzate negli ultimi 60 minuti:`,
"label.codeType":`Tipo di codice`,
"saturday":`Sabato`,
"label.mask.type":`Tipi di maschere`,
"label.schedulejob.setup.schedule.Monthly":`Mensile`,
"label.import.page2.totalfiled{{20}}，{{4}}notsuited":`文件中共{{20}}个字段，剩余{{20}}个未映射

{{20}} campi nel file , {{20}} non mappati`,
"label.projectManagement.delete.item":`Tutte le informazioni relative a questo progetto saranno cancellate se si elimina il progetto, e i dati non possono essere recuperati. Sei sicuro di confermare la cancellazione?`,
"label.page.general.us.and.western.europe":`Lingue generali degli Stati Uniti e dell'Europa occidentale`,
"label.reportsSubscription.status":`Sottoscritto`,
"label.discount.baifenbi":`Sconto (%)`,
"font-evaluate-module-v1-web-page-evaluation-settings":`Impostazione valutazione web`,
"message.error.searchwork":`Le parole chiave inserite devono avere 2 o più caratteri.`,
"label.weixin.option.setting":`Impostazioni di scelta (fino a 10 scelte)`,
"label.lead.score.prompt1":`Il punteggio di un singolo lead record viene assegnato automaticamente quando si crea o si modifica. Ma è necessario assegnare manualmente un punteggio a più record di lead, quando si importa in batch o si crea tramite interfaccia.`,
"label.exception.must.try.throw":`L'eccezione deve essere lanciata in un blocco di staement.`,
"label.activity.plan":`Piano`,
"label.partnerCloud.productSet.editor":`Modifica opzione`,
"label.mobile.quickcreate.default.signinnew":`Accedi`,
"label.summaryreport.2018.step6.new":`Passo 6 Seleziona il tipo di grafico e l'elemento da evidenziare`,
"vue_label_homepage_owner":`La mia Homepage`,
"vue_label_dashboard_editfoldersuccessfully":`Modifica della cartella con successo`,
"label.quickbooks.view.overdueinvoices":`Fatture scadute`,
"label.emailtocloudcc.redmessage4":`Si prega di inserire i dettagli della porta`,
"label.tabpage.equalz":`Uguale a`,
"lable.quote.syncing.firstsync":`Inizialmente, la quota iniziale diuff1a all'opportunità`,
"label.download.CloudCCAPP":`Scarica l'applicazione CloudCC`,
"label.icon.6":`Valuta`,
"label.list.serial.number":`Numero di serie`,
"label.profile.setstandardobjectrecordtype":`Impostazioni del tipo di record standard`,
"label.customize.memory.function.sorting.error":`Il tempo di risposta della query è troppo lungo e causa il timeout della pagina. Può essere perché la memoria dell'ordinamento dell'intestazione è attivata. Per favore vai alle impostazioni personali e disattiva questa funzione.`,
"message.view.addtoallusers":`Visibilità degli utenti correlati`,
"label.globaloperation.operationtype.record.phone":`Registrare una chiamata`,
"lable.opppdt.selPdt.searchresult":`Risultati della ricerca`,
"label.import":`Importazione`,
"label.service.gantt.work.based.resources":`Risorsa basata sulle ore di lavoro`,
"label_partner_template_detailimage":`Immagine`,
"label.cpq.product.feature.option.count":`Il minimo delle opzioni del prodotto non può essere maggiore del massimo delle opzioni del prodotto`,
"label.chatter.newtask":`Nuovo compito`,
"font-trade-module-v1-invoice-total-price":`Pagamenti totali previsti`,
"setup_mainpage_label_welcome29":`Integrazione API standard con prodotti di terze parti`,
"label.data.exportall.all.btn":`Esportare tutti i dati`,
"front-epwechat-module-v1-unbound-WeChat":`Sbloccare WeCom`,
"label.salescloud.salesdashboard.performance.rankings":`Classifica dei contratti di vendita a squadre`,
"label.import.page1.newcreateandupdate":`Aggiornare e iniziare un nuovo`,
"component.chatter.post.button.file":`Aggiungere allegati`,
"label.partnerCloud.orderingPlatform.createOrder":`Nuovo ordine`,
"label.lookup.multiple.data":`Trovati più dati, selezionare manualmente`,
"button.partner.save":`Salva`,
"label.service.add.timeslot":`Aggiungi una fascia oraria`,
"label.campaign.matchway.select.email":`Email`,
"front-sales-button-fromQB":`Aggiornamento da QuickBooks`,
"label.icon.108":`Freccia`,
"lable.outlook.edit.efmapping":`Modifica delle mappature dei campi`,
"label_tabpage_refreshz":`Aggiorna`,
"chatter.follow.cancel":`Smettila di seguire`,
"label.totals.sum":`Totale`,
"label.noRequest":`Nessun requisito`,
"vue_label_homepage_fixedcomponent":`Seleziona un componente fisso`,
"label.knowledge.delete.case":`Errore durante la cancellazione dell'articolo sul caso.`,
"label.weixin..xsld.yjwc":`Entrate previste`,
"label.customcomponent.page.index.console.btn":`Console per sviluppatori`,
"label.sendsms.batch":`SMS di massa`,
"vue_label_chat_onlychosechat":`Solo gli utenti del team possono essere selezionati per la chat`,
"label.tabpage.page":`Pagina`,
"label.cyen.note":`Abilita valuta. Si noti che l'azione di valuta abilitata è irreversibile.`,
"label.weixin.againsend":`Reinvia`,
"label.processnumber":`Passo No.`,
"label.emailobject.to":`A:`,
"label.event.today":`Oggi`,
"label.dashboard.dispalyPosition":`Posizione dissipata`,
"message.error.recalculate.dupoperate":`Ricalcolo, si prega di non operare frequentemente.`,
"vue_label_email_linkrecordsuccess":`Record associato con successo`,
"label.updateoutboundnews":`Aggiornare i messaggi in uscita`,
"label_emailtocloudcc_exists2":`Questa casella di posta è stata impostata su Email to Case. Non ripetere le impostazioni.`,
"label.tag.addtags.button2":`Cancella`,
"label.stdashbord.xsld.business.role":`Questo ruolo è preso dai ruoli di abilitazione nelle gerarchie delle previsioni`,
"label.commonnew":`Nuovo normale`,
"label.validate.remark2":`Esempio d'uso:`,
"label.reportsSubscriptionPage.condition.checkbox":`Aggiungere condizioni a questo rapporto`,
"label.globalselect":`Set di valori dell'elenco delle opzioni globali`,
"label.partnerCloud.partnerAccount.available":`Importo disponibile`,
"label_tabpage_nothingz":`Niente`,
"label.version.webtolead":`We to Lead`,
"label.projectManagement.heat.map":`Mappa di calore`,
"message.error.pleasecorrectdata":`Si prega di rivedere tutti i seguenti messaggi di errore per correggere i dati.`,
"label.hight.tip":`Quando il filtro avanzato non è abilitato, la relazione tra le diverse condizioni del filtro è "and", cioè un record che soddisfa le caratteristiche comuni di 1 e 2.`,
"label.workflow.estimatecondition3":`Creato o ogni volta che viene modificato`,
"AssetRelationship.time.limit.error":`La data di inizio deve essere precedente o uguale alla data di scadenza.`,
"label.multilang.workflow.dayinmonth":`Il {1} ogni {0} mese(i)`,
"label.reportsSubscriptionPage.schedulereport.daily":`Quotidiano`,
"label.emailtocloudcc.step1.name":`Scegliere la funzione`,
"label.follow_up":`Email di followup`,
"label.price.list.price.cannot.be.empty":`Il prezzo di listino non può essere vuoto.`,
"label.chatter.link":`Link`,
"label.ccpeak.condition.return.record":`Restituisce i record per condizione e supporta le comuni condizioni "dove".`,
"pagecreator.layout.message.canntdelete":`Il layout corrente non può essere cancellato`,
"label.compact.layout.main":`Layout delle principali informazioni chiave`,
"label.testandupdate":`Controlla l'aggiornamento`,
"button_partner_cancel":`Cancella`,
"label.activity":`Attività`,
"label.knowledge.setting.hint.fourteen":`Preparatevi a scrivere!`,
"vue_label_commonobjects_view_open_from_list":`Aprire dall'elenco per iniziare`,
"front-electronic-export-intro":`2000 record possono essere esportati in Mailchimp per una volta`,
"label.chosen.all":`Tutti i campi`,
"label.file.extension":`Estensione del file`,
"vue_label_systemSettings_server_miniprogram":`Miniprogramma di servizio`,
"label.weixin.no.pending.wdgz.qin.today":`Nessun programma di lavoro per oggi.`,
"label_tabpage_issuez":`Emissione`,
"label.staticresource.tip":`Usa le risorse statiche per caricare il contenuto a cui vuoi fare riferimento in una pagina personalizzata, compresi .zip, immagini, fogli di stile, JavaScript e altri file.`,
"label.approvalstep":`Fasi di approvazione`,
"label.china.standard.time":`Ora solare cinese`,
"label.appexchange.download.tiaoguo":`Ignora`,
"label.callcenter.link.Amazon.connect":`Amazon Connect`,
"vue.dashboard.notRequired.notConformToTheRules":`Impossibile inviare! Le voci richieste non sono compilate o non sono conformi alle regole.`,
"label.appointment.wizard.title1":`Definire la disponibilità`,
"label.chat.remove.bookmark":`Rimuovi segnalibro`,
"label.tabpage.advancedsearch":`Ricerca avanzata`,
"batch.ranf.f":`Registrazioni di trasferimento di massa non riuscite`,
"label.appointment.wizard.subtitle4-1-4":`1 h`,
"label.brief.account":`Conti`,
"component.chatter.link.label.url":`Link url`,
"label_emailtocloudcc_redmessage8":`Errore di parametro, si prega di contattare l'amministratore.`,
"label.object.create.two.number.field":`Si possono creare fino a 2 campi Auto-Number personalizzati per oggetto.`,
"label.salecommit.not.roleinformation":`Non hai ruoli e non puoi visualizzare i cruscotti degli impegni di vendita.`,
"label.defautline.cannot.less":`Il numero predefinito di linee non dovrebbe essere inferiore a 1.`,
"label.selectedproducts":`Numero di prodotti selezionati`,
"label.productsales.today.notskadd":`Non ci sono compiti in scadenza, puoi cliccare " " nell'angolo in alto a destra per aggiungere un nuovo compito.`,
"lable.account.year.stadate":`Anno fiscale Data di inizio`,
"label.mobile.phone.month.plan2":`Compiti di questo mese`,
"label.ccpeakfolder":`Cartelle di classe`,
"setup_mainpage_label_welcome21":`La piattaforma cloud CloudCC fornisce la funzione di modello di e-mail definito dall'utente, che è comodo da usare per gli utenti e migliora l'efficienza del lavoro.`,
"label.modify.layout":`Modifica del layout`,
"report.label.folder":`Cartelle`,
"label.tianyancha.businessverify.rewritename":`Nome del conto di riempimento`,
"lable.currencyAdv.dao":`a`,
"label.mobilelayout":`Layout mobile`,
"label.the.current.model.is.enabled.and.cannot.be.edited.":`Il modello corrente è attivato e non modificabile.`,
"label_partner_all_disable":`Disattivare`,
"label.ownerapproverfield":`Campo approvatore del proprietario`,
"label.emailobject.template.message4":`Alcuni dei campi inseriti nel messaggio sono nulli, per favore modifica e reinvia!`,
"label.productsales.today.notsk":`Non ci sono compiti in scadenza.`,
"label.multilang.document.upload.success":`{0} i file sono stati caricati con successolt e {1} i file sono falliti`,
"label.manageAll.sta3":`Rifiutato`,
"vue_label_calendar_week_view":`Vista calendario-settimana`,
"setup_layout_label_nocustompage":`Nessuna pagina personalizzata`,
"label.weixin.wdyj.jxdcl":`Tasso di rendimento personale`,
"label.donot.update":`Non avete il permesso di modificare!`,
"setup.mainpage.label.welcome14":`Gestione dei processi di personalizzazione del flusso di lavoro, approvazione`,
"UG_Campaign_002":`Pianificare, eseguire e monitorare l'efficacia delle attività di mercato.`,
"label.layout2":`Layout due`,
"label.app.looup":`Trova le applicazioni`,
"label.projectManagement.selectitem":`Seleziona il progetto`,
"label.field.relating.rule":`Regole di associazione dei campi di ricerca`,
"vue_label_commonobjects_detail_selectname":`Seleziona prima un nome`,
"front-email-payment-Invoice-select-pay":`Seleziona Paga con:`,
"label.customfields.formula.numberexample":`Fahrenheit = 1,8 * Celsius__c 32`,
"component_event_label_enddate":`*Tempo di fine`,
"label.partnerCloud.partnerAccount.lineOfCredit":`Limite di credito`,
"label.chatter.newpost":`Ultimo messaggio`,
"label.report_dashboard":`Questo rapporto sarà salvato nei tuoi rapporti. Puoi anche aggiungerlo a un dashboard.`,
"label.assigned":`Assegnato a`,
"Homepage_News_002":`Il componente notizie non è attualmente disponibile.`,
"label.approval.select.relatedobj":`Per selezionare l'elemento pertinente, deve scegliere un tipo`,
"label.service.miniProgram.isTop":`Appiccicoso in cima`,
"message.error.object.datatoolang":`La lunghezza dei dati è troppo lunga, massimo {!lunghezza} caratteri.`,
"label.importsourcetip":`L'importazione è progettata per accettare i file prodotti dal nostro processo di esportazione. Se non hai fatto un'esportazione, vai ora alla pagina di esportazione.`,
"label.select.deadlineplease.deadline":`Si prega di selezionare la scadenza.`,
"vue_label_account_equityrelationship":`Rapporto di equità`,
"label.account.Calendar.month":`Mese di calendario`,
"label.appointment.wizard.subtitle3-4":`Giovedì`,
"font-evaluate-module-v1-smaller-500":`Il file deve essere inferiore a 500KB`,
"label.reportsSubscriptionPage.email.tome":`Inviato a me`,
"label.ccchat.person.invite.existpers":`Sta già tracciando:`,
"label.appointment.wizard.subtitle1-3":`30 min`,
"front-kefu-moudle-connected":`Collegato`,
"label.campaignmember.main.duplicatelist.tip":`Il sistema troverà i lead duplicati e i membri della campagna in base alle impostazioni qui.`,
"label.visualpage.such.tags.double":`Questi tag appariranno in coppia`,
"label.sendsms.batch.step2.introduce":`Selezioni un modello di SMS.`,
"Account_News_Setting_002":`Usa le impostazioni dell'account qui sotto per specificare il comportamento predefinito dell'account per la tua organizzazione.`,
"message.encryptchange.alert":`Stai per convertire {{!fieldapi}} da un campo di testo criptato (Storage Encrypted) a un campo di testo criptato (Display Encrypted), dopo una conversione riuscita, questo campo sarà memorizzato in testo chiaro nel database, che può essere visualizzato in testo chiaro o criptato secondo le impostazioni del profilo. I campi sono ricercabili. Questa operazione è irreversibile, vuoi continuare?`,
"label.mainpageset.description":`Configura la tua homepage a livello di organizzazione in base alle tue reali esigenze aziendali.<br>I componenti nella configurazione predefinita che non sono rilevanti per il tuo business possono essere disabilitati o disattivati.<br>Abilita: i componenti abilitati vengono visualizzati sulla homepage di tutti i membri.<br>Disabilita: componenti disattivati non vengono visualizzati sulla homepage di tutti i membri, né verranno visualizzati nell'elenco di "Configurare la mia Homepage" in app.<br>Spegnere: componenti disattivati non vengono visualizzati sulle homepage di tutti i membri per impostazione predefinita, e gli utenti possono attivare loro da "Configurare la mia Homepage" in app.`,
"label_tabpage_linknamez":`Nome del link`,
"label.companyname":`CloudCC.com Ltd. Co`,
"label.currency.current":`Valuta aziendale corrente`,
"label.campaignmember.main.duplicatelist.html.title":`Impostazione della rimozione dei duplicati mediante scansione del codice`,
"label.sendsms.batch.step3.plan":`Piano della data di consegna`,
"label.profile":`Profilo`,
"label.canceluploadfile.step":`Fare clic sul pulsante Annulla per cancellare tutti i file mostrati nell'area superiore`,
"message.newreport":`Nuovo rapporto`,
"label.service.newBuildDialog.date.selection":`Seleziona la data`,
"label.lookup":`Cercare`,
"label.file.editinfo":`Modifica i dettagli del file`,
"component_assistant_label_nodata":`Nessun evento oggi, controlla più tardi.`,
"label.tianyancha.businessverify.msg4":`Questa funzione utilizza servizi di terze parti ed è attualmente disponibile per gli utenti gratuitamente.ma CloudCC non garantisce che le terze parti forniranno sempre il servizio agli utenti gratuitamente. se le terze parti fanno pagare una tassa, CloudCC ha il diritto di addebitare o impedire all'utente di utilizzare questa funzione.`,
"label.noequal":`!=Non uguale`,
"vue_label_metric_column":`La tabella deve avere almeno 1 colonna di valutazione.`,
"label_reportType_chose_and_form":`Seleziona l'origine dati del rapporto e un formato di rapporto`,
"vue_label_pool_reasondescription":`{0} descrizione del motivo`,
"label.isusing":`Attivo`,
"label.passwordPolicy.setup.pwdremember5":`5 password ricordate`,
"label.cancel":`Cancella`,
"vue_label_helpcenter_detail1.1":`attività, e dinamiche di ogni record, e piegare o dispiegare le informazioni corrispondenti nell'angolo in alto a destra del modulo. Puoi anche visualizzare e gestire i dati associati al record attraverso la lista correlata.<br> 1. Visualizza e gestisci un singolo dato<br>Puoi modificare, copiare, cancellare o condividere i dati per altro personale attraverso i pulsanti in alto a destra.<br>Visualizza le informazioni dettagliate dell'utente, e puoi modificare direttamente alcuni campi della pagina per cambiare il proprietario o il tipo di record dei dati.<br>Visualizza e gestisci i dati associati al record attraverso l'elenco correlato. Nella lista correlata al file, caricare il file registrato, o fare clic sul nome del file per scaricare e visualizzare il file corrispondente.<br> 2. Elenchi correlati<br>Collegamento rapido attraverso l'elenco correlato, e utilizza la finestra fluttuante per visualizzare fino a 10 record correlati. Fare clic per entrare nella vista elenco, visualizzare tutti i record correlati e modificare in linea.<br>Utilizzare il layout della scheda per visualizzare e gestire i record correlati sotto.<br> 3. Attività<br> Nella pagina dei dettagli registrati, la versione Lightning non mostra le due liste correlate di "attività non elaborate" o "storia dell'attività". Invece, viene visualizzata la timeline dell'attività.<br>Activity timeline che visualizza il contenuto<br> La timeline dell'attività può visualizzare tutte le attività che dal futuro al passato nel record corrente. Le attività in ritardo e le attività ed eventi imminenti sono visualizzate nel modulo "In ritardo e in arrivo" della timeline dell'attività. Le attività passate o attualmente completate, gli eventi, le chiamate registrate, le e-mail e i messaggi di testo saranno visualizzati nel mese corrispondente.<br>`,
"registration.page.preview":`Anteprima della pagina di registrazione`,
"label.quickbooks.search":`Cerca`,
"label.setup.mobile.bottombutton.tab.show":`Visualizzazione delle schede sul fondo`,
"lable.want.to.delete.tem":`Sei sicuro di voler eliminare il modello di rapporto di servizio {currentTelmplateName}?`,
"label.multilang.fielddtrack.dealkey":`Modifica {0} da {1} a {2}`,
"vue_label_pool_return":`Ritorna`,
"vue_label_calendar_failed_to_share_calendar":`Impossibile condividere il calendario`,
"label.less":`< Meno di`,
"label.email.form.html":`Html`,
"label.tag.nodata":`Nessun record`,
"label.setarticlecon":`Specificare i criteri di ingresso`,
"label.searchlayout.displayrow":`Colonne da visualizzare`,
"label.change.task":`Vista del compito`,
"lable.quote.editqtpdt.title":`Modifica delle voci del preventivo`,
"label.appointment.wizard.subtitle4-4":`Quanto lontano nel futuro si può prenotare?`,
"label.custom.page.button.css":`Pulsante CSS`,
"label.input.documentmessage":`Inserisci i dettagli`,
"vue_label_commonobjects_detail_email_address":`Indirizzo del destinatario`,
"label.chatter.filterTimeLine":`Linea temporale di filtraggio`,
"label.must.select.twoorthree.records":`Devi selezionare due o tre record da unire`,
"label.mobile.setup":`Impostazione dell'applicazione mobile`,
"vue_label_commonobjects_detail_key_field":`Campi chiave`,
"label.chatter.relateitem":`Relativo a`,
"label.customobjects.tip":`Una volta creato un oggetto personalizzato, è possibile creare una scheda personalizzata, elenchi correlati personalizzati, report e dashboard per gli utenti per interagire con i dati dell'oggetto personalizzato. Si può anche accedere ai dati dell'oggetto personalizzato attraverso l'API.`,
"label.sso.saml.idp.config":`Fornitore di identità`,
"label.knowledgebase.affect.article.version":`La modifica influenzerà la traduzione esistente? Se è così, puoi segnare la traduzione preziosa come "Scaduta" e generare una lista di traduzioni in sospeso per i fornitori di traduzioni.`,
"message.error.record":`Il record corrispondente non è stato trovato!`,
"message.duplication.label.fieldname":`Campo`,
"setup.layout.button.cancel":`Cancella`,
"label_radar_map_function":`Usate grafici a radar con metriche multiple per misurare il ruolo dei contatti nella catena decisionale delle vendite.`,
"label.campagin.roi.fss":`Num Inviato`,
"label.emailobject.template.giveup":`Cancella`,
"label.apiname.exists":`Il nome dell'API esiste già.`,
"message.failtoreaddata":`Lettura dei dati fallita`,
"label.file.versionedit":`Modificatore di contenuto`,
"template.report.lost.business.opportunity":`Opportunità perse`,
"label.ccchat.group.allowgd":`Permettere ai gruppi di archiviare`,
"label.fieldaccesslimit":`Accessibilità del campo`,
"label_target_model":`Modello target`,
"message.validation.isnoturl":`URL non valido`,
"servicecrew.member.time.conflict":`In questo intervallo di tempo, le risorse di servizio sono diventate membri di altre squadre di servizio.`,
"label.knowledgebase.delete.details":`Cancellerà qualsiasi informazione sull'assegnazione.`,
"vue_label_normal_bottom":`In basso`,
"label.custombutton.editerror":`Modifica fallita`,
"label.dashboardSetup.showdw.d6":`Automatico`,
"message.error.field.decimalPlaces":`Errore nel formato di input decimale.`,
"label.tabpage.busoppnamez":`Nome dell'opportunità di business`,
"label.insertfield.intro":`Seleziona un campo e clicca su "Inserisci". Con il ">" significa cliccare per visualizzare altri campi disponibili.`,
"setup.layout.label.nocustompage":`Nessuna pagina personalizzata`,
"front-gantt-module-project-has-only":`Questo progetto ha solo {n} pietre miliari`,
"label.weixin.fmu.am":`{0} AM`,
"label.emailsync.status.connectaccounts":`Account e-mail collegato`,
"label.customcomponent.check.name.same":`Questo nome esiste già.`,
"label.validate.function.funcFormat.HOUR":`ORA(data)`,
"label.approvepagelayout4":`Copia il layout della pagina precedente`,
"label.knowledge.category.hint.nine":`Attivare il gruppo di categorie`,
"label.report.sorting.column":`Ordinamento a colonne`,
"label.hours":`Orologio`,
"label.email.clearAllemail":`Vuoi svuotare tutte le e-mail sincronizzate nella casella di posta?`,
"font-evaluate-module-v1-satisfaction":`Valutazione soddisfatta`,
"label.service.hide.more.info":`Nascondi maggiori informazioni`,
"label.area.list.intro":`Puoi modificare le informazioni sul territorio in questa pagina.`,
"label.sendemail.chat.addPostat":`Caro #nome:\nonno ciao! #nomeUtente ti ha menzionato in un micropost.`,
"label.data.newtemplate.e_seltype.desc":`Ci sono due tipi di dati derivati</li><li class="titledesc1">1.uno è il formato CSV(il default)</li><li class="titledesc1">2.l'altro è il formato di compressione. La modalità di formato di compressione è divisa in due tipi</li><li class="titledesc1">2.1.un tipo è la generazione automatica della password dei file compressi, la password generata automaticamente sarà inviata all'utente dopo aver esportato con successo i dati nella mailbox</li><li class="titledesc1">2.2.un altro è quello di inserire manualmente la password dei file compressi, la password di input manuale non sarà inviata alla mailbox dell'utente, quindi la necessità per gli utenti di ricordare la password.se non si entra, il default è nessuna password.`,
"message.passwordPolicy.validate.minlengths":`Errore:La tua password deve essere almeno`,
"message.save":`Sei sicuro di voler salvare?`,
"label.marketsea.notfollowdays1":`Dopo aver ottenuto`,
"label.app.step1":`Passo 1 Selezionare il tipo`,
"message.error.pageid.null":`L'ID del social network Facebook non può essere vuoto!`,
"label.weixin.input.lookupfield":`Inserisci le parole chiave per trovare il micro voto corrispondente`,
"label.whChatAccount":`Conto WeChat`,
"label.tabpage.groupingitem":`Voce di raggruppamento`,
"label.callboard.introduce":`Tutti gli annunci della vostra azienda sono elencati qui sotto.`,
"label.financial.services.seminar":`Seminario di pianificazione finanziaria`,
"label.data.file.i_title.num1":`1. Il file importato deve essere un file in formato CSV. Il file deve contenere un titolo e non può essere importato senza titolo.`,
"label.visualpage.filename.exist":`Il nome del file esiste già.`,
"front-kefu-moudle-v1-new-chats":`Nuovo agente`,
"label.console.step5.tab":`scheda aperta`,
"vue_label_opportunity_contactrole_edit":`Modifica i ruoli dei contatti`,
"label.projectManagement.delete.return":`Tornerà alla pagina precedente dopo aver cancellato gli ultimi dati.`,
"registration.page.designs":`Impostazione dell'aspetto della pagina di registrazione`,
"label.console.step6.heigth":`Altezza`,
"label.objectRelationshipAtLeast":`hanno un record almeno relativo a`,
"label.knowledge.delete.viewstat":`Erroe durante la cancellazione dei dati di navigazione dell'articolo di conoscenza`,
"label.direct.dashboard.month.report":`Nuova nota di lavoro mensile`,
"label_tabpage_lookatmorez":`Vedere di più`,
"label.setup.rights.management":`Gestione dei diritti`,
"label.campaign.channel.clear.img":`Immagine chiara`,
"label.calendar":`Calendario`,
"label.biaoqingfaxian.username":`Conto`,
"label.weixin.wdyj.jxht":`Prestazioni personali-vendite-contratti`,
"label.emailtocloudcc.exists1":`Questa casella di posta è stata impostata su Email to Lead. Non ripetere le impostazioni.`,
"label.emailtocloudcc.filed.password":`Password`,
"label.what_create":`Che tipo di forma volete creare?`,
"vue_label_report_onlydisplaypart":`È possibile visualizzare un massimo di 50 dati e visualizzare tutti i dati dopo l'esecuzione.`,
"label.up":`Su`,
"label.addattachment.edit":`Modifica dell'allegato`,
"label.ccchat.message.search.desc5":`Le parole di ricerca non possono essere inferiori a 2 caratteri`,
"label.chose.nonotice":`Seleziona il record che non ti ricorda più`,
"UG_activity_06":`Vuoi seguire i conti`,
"label.set_contactsmarketing":`Imposta come contatto della campagna`,
"pagecreator.layout.button.horizontal":`Smontaggio laterale`,
"label.brief.opportunity2":`Opportunità che si prevede di chiudere`,
"label.ems.nomsg":`Non impostato`,
"label.fieldupdate.tip":`Gli aggiornamenti dei campi permettono di cambiare automaticamente il valore di un campo con uno specificato dall'utente. Gli aggiornamenti dei campi sono azioni associate alle regole del flusso di lavoro e ai processi di approvazione.`,
"label.sso.saml.sp.federationid":`ID Federazione`,
"label.import.page2.suited":`Mappato`,
"message.error.appexchange.integrity":`Assicurare l'integrità dei componenti nel pacchetto di caricamento.`,
"label.fielddatatype":`Campo Tipo di dati`,
"message.approval.cannotsubmit.detail2":`Il record deve soddisfare i seguenti criteri o la formula viene valutata come vera, altrimenti la richiesta di approvazione non può essere presentata, si prega di ripresentarla dopo la modifica.`,
"vue_label_commonobjects_detail_cloud_as_a_user":``,
"label.summaryreport.selectlinetogroup":`Seleziona la colonna su cui si basa il raggruppamento del rapporto`,
"label.tabpage.norecordtypez":`Tipo di record inutilizzabile`,
"label.icon.141":`Valuta`,
"label.addattachment.step3.intruduce":`Se stai caricando, questo annullerà il caricamento in corso.`,
"label.trigger.recursive.call.three":`I trigger possono essere chiamati in modo interattivo, il numero di loop è limitato a 3 volte, se più di 3 volte il sistema avrà un messaggio di errore.`,
"maintenanceplan.workorder.type.asset.workorder":`Scegliete "Un ordine di lavoro per ogni bene" come tipo di generazione di ordine di lavoro.`,
"label.emailtocloudcc.select1":`Si prega di scegliere`,
"label.system.log":`Registro di controllo della configurazione`,
"vue_homepage_dashboard_not_support_fullscreen":`Spiacente, il tuo navigatore non supporta lo schermo intero.`,
"label.projectManagement.nodata.resource":`Non ancora coinvolto in nessun progetto. Aggiungi le informazioni del progetto 'My' ai membri per visualizzare l'allocazione del tempo dei membri del team.`,
"label.exchange.sync.state.contact":`Contatti`,
"label.field.type":`Tipo di campo`,
"label.selected.object":`Oggetto Selezionato`,
"label.customfields.new.step2":`Passo 2 Inserire i dettagli`,
"label.monitorsys.delete.style":`Tipi di operazione`,
"label.projectcondition":`Criteri di ingresso`,
"potential.customers.field.default":`Impostazione predefinita dei cavi`,
"message.password.nosame":`Le password non corrispondono.`,
"label.validate.function.funcExplain.MONTH":`Restituisce il mese, che è un numero tra 1 (gennaio) e 12 (dicembre)`,
"label.project.user.project.count":`Numero di progetti a cui hanno partecipato gli utenti`,
"chatter.to":`a`,
"vue_label_commonobjects_detail_activity_owntask":`compito di proprietà`,
"label.generate.mobile.page":`La pagina mobile è completata.`,
"label.escalation.setup.newentries.step1":`Passo 1 Impostare l'ordine in cui questa voce di regola sarà processata`,
"label.email_footer":`Piè di pagina dell'email`,
"label_partner_workspace_member_profile":`Profili disponibili`,
"label.loginhis.between":`La data di inizio e di fine non può superare i 2 mesi`,
"label.user.verficationcode.error":`Codice di verifica errato.`,
"label.email_notifications":`Invia un'email di notifica della presentazione`,
"APPIntegration_Dropbox_01":`Seleziona i file da Dropbox`,
"label.projectManagement.Selectweek":`Seleziona la settimana`,
"wednesday":`Mercoledì`,
"message.atleastonereceiver":`Seleziona almeno un destinatario`,
"label.applt.link.text":`Abbiamo collegato la vostra azienda al mini programma del portale. Copia l'indirizzo del portale del mini programma dedicato alla tua azienda, metti l'indirizzo del mini programma nel link di salto al menu dell'accout ufficiale della tua azienda, poi i clienti possono cliccare sul menu per usare il mini programma. (Menu personalizzato dell'account ufficiale < Salta al mini programma< Percorso del mini programma)`,
"label.wait.for.a.moment":`Si prega di attendere un momento mentre si imposta la lingua...`,
"vue_label_chatter_only_group_members_look":`Solo i membri del gruppo hanno accesso alla visualizzazione, puoi provare a chiedere di unirti al gruppo`,
"label.knowledgebase.last.release":`Ultimo pubblicato`,
"component.setup.label.pagesize":`Articoli per pagina`,
"label.paging.totalofpages":`Un totale di {0} pagine`,
"label.globaloperation.successmessage":`Messaggio di successo`,
"label.logout":`Logout`,
"label.partner.common.enable":`Abilitare il cloud dei partner`,
"label.permission.objectpermission.goback":`Torna alla lista: Set di autorizzazioni`,
"label.approvalstep5.required":`Richiesto`,
"component_chatter_label_to":`A`,
"message.please.choose.role":`Seleziona il ruolo`,
"maintenanceasset.servicecontract.contractlineitem.illegal":`È necessario selezionare la voce del contratto sotto il contratto di servizio associato al piano di manutenzione.`,
"label.projectManagement.Resource.usage.view":`Visualizzazione dell'uso delle risorse`,
"label.smsmainbody":`Testo del messaggio`,
"label.ccchat.error.nullname":`Il nome è richiesto`,
"label.appupload.upload.version":`Numero di versione`,
"label.data.setok.t_desc2":`Torna alla pagina del modello di dati`,
"vue_label_pool_allocationstatus":`Stato di assegnazione`,
"label.tianyancha.orgapprovedinstitute":`Istituto approvato dall'organizzazione`,
"label.quickbooks.searchlist.startdate":`Data di inizio`,
"label.setapp":`Impostazioni dell'app`,
"chatter.about":`Su di me`,
"label.layoutname":`Nome del layout di pagina`,
"label.icon.160":`Terra`,
"label.tabpage.Rolesz":`Ruoli e subordinati`,
"label.console.step5.introduce":`Scegliere come visualizzare`,
"label.customfields.totalsummary.gettogetherfield":`Campo da aggregare`,
"message.appexchange.addtopackage.profile":`Si può aggiungere un solo componente di profilo in un pacchetto!`,
"vue_label_file_user_header_pic":`Avatar`,
"font-trade-module-v1-invoice-detail-price":`Pagamenti dettagliati`,
"homepage.components.three":`Passo 3 Inserire il contenuto del display dei componenti personalizzati`,
"nine":`Nove`,
"label.marketsea.button.restore":`Ripristinare`,
"label.forecast.editshrepage.desc2":`La condivisione individuale può essere utilizzata solo per garantire un maggiore accesso ai dati, non per limitare l'accesso.`,
"label.cloudccsite.list":`Siti`,
"label.icon.35":`Cloud`,
"vue_label_pricebook_price":`Aggiungi il prezzo standard`,
"label.version.sum.addressfield":`Campo(i) indirizzo`,
"label.projectManagement.Gotomilestone":`Girare alla pietra miliare`,
"label.dataimport.name.length":`Errore: la lunghezza del nome è troppo lunga.`,
"label_alculation_method":`Metodo di cacolazione`,
"label.uploadfile":`Caricare il file`,
"label.ems.otheraccount":`Altro conto`,
"vue_label_commonobjects_detail_group_opportunitystrategy":`Sei sicuro di unirti a questa squadra`,
"message.error.chatter.img.nodata":`Errore: il file immagine non esiste e non può essere catturato.`,
"component.chatter.file.button.files":`Seleziona un documento`,
"label.salescloud.teamrole.optionlist.choose.null":`Il nome del ruolo è richiesto`,
"label.yourexportsuc":`La sua richiesta di esportazione è stata elaborata, la preghiamo di visualizzare la sua e-mail.`,
"pagecreator_systemstyle_label_modifycolor":`Modifica colore`,
"label_partner_setup_title":`Impostazioni`,
"label.chat.topic.topic":`Argomento`,
"file.error.nottype":`Errore: tipo non valido. i tipi di file che possono essere caricati sono txt, doc, excel, ppt, pdf, jpg, jpeg!`,
"label.all_time":`Tutto il tempo`,
"homepage_componet_approval_label":`Punti da approvare`,
"label.partnerCloud.financeSetting.merchantNumber":`WeChat Pay Merchant No.`,
"label.user.resetpw":`Ripristina la password`,
"label.exchange.sync1":`Dopo aver impostato un account di servizio con permessi di impersonificazione per gli utenti in Microsoft©Exchange, inserisci le credenziali dell'account di servizio per permettere a CloudCC di comunicare con il server Exchange.`,
"label.import.index.editfield":`Modifica della mappatura dei campi`,
"and":`E`,
"label.partnerCloud.cloudInfrastructure":`Configurazione di base di Partner Cloud`,
"label.escalation.setup.newentries.createdate":`Quando il caso viene creato`,
"Pagelayout.Setup.002":`Hai selezionato 3 liste correlate, e l'aggiunta di altre liste correlate influenzerà il layout della pagina.`,
"label.customfields.file.tip":`Permettere all'utente di caricare file tra 1 e N.`,
"label.tianyancha.businessverify.accname":`Interrogazione del nome del cliente in tempo reale`,
"label.Additional.Conditions":`Appuntamento di servizio del filtro secondo le condizioni supplementari.`,
"label.emailtocloudcc.filed.type":`Provider`,
"vue_label_homepage_fixedcomponents":`Componente standard`,
"label.visualpage.delerror":`Cancellazione non riuscita, riprova più tardi.`,
"label.tabpage.filetypez":`Tipo di file`,
"label.emailobject.search.input":`Cerca`,
"label.createprocessstep2":`Passo 2 Specificare i criteri di ingresso`,
"label.weixin.inhead":`Elaborazione`,
"component.recdetail.label.title":`Informazioni dettagliate`,
"label.weixin.telephone":`Numero di telefono`,
"label.web.link":`Collegamento web`,
"label.partnerCloud.paySuccess":`Pagato con successo`,
"label.case.adress.link":`Portale del servizio clienti`,
"label.emailobject.view.connectopp":`Email collegate a opportunità aperte`,
"front-kefu-moudle-think-again":`Lasciami pensare di nuovo`,
"label.Button":`Pulsante`,
"chatter.pt.most":`La dimensione massima del file è di 20 MB.`,
"label.service.newBuildDialog.numberdays.horizontal":`Giorni prima della data del livello`,
"label.ems.relatedobj":`Oggetto correlato`,
"label.notification.insert.approval":`[提交人] presenta [对象] per la tua approvazione`,
"label.setting.codeSet":`Set di codici`,
"vue_label_report_rowlevelformula":`Formula a livello di riga`,
"label.validate.function.funcFormat.TIMENOW":`TIMENOW()`,
"label.copyright":`Copyright © 2008-2022 CloudCC Inc. Tutti i diritti riservati.`,
"component.setup.button.save":`Salva`,
"label.emailsync.button.sure":`Confermare`,
"label.multilang.dupicatecheck.getdatalist":`Il {0}-esimo gruppo di dati duplicati, ha un totale di {1} record:`,
"label.ccchat.person.invite.tochat":`Invita le persone a CCChat`,
"label_partner_all_maxNum":`Dati massimi della nuvola del partner:`,
"label.checkfield":`Impostazioni del campo per trovare i duplicati`,
"label.sales.dashboard.income":`Obiettivo delle entrate`,
"label.setup":`Impostazione`,
"label.dashboardSetup.center":`Medio`,
"lable.quote.syncing.finished":`Sync Completed`,
"vue_label_helpcenter_dashboard1":`Per aiutarti a visualizzare i dati statistici in modo più intuitivo, CloudCC Sales Cloud Lightning dashboard ti fornisce potenti capacità di produzione di grafici.<br> CloudCC Sales Cloud Lightning versione dashboard ha le seguenti caratteristiche<br>In grado di utilizzare diverse fonti di dati: è possibile selezionare i dati originali in una vista sotto l'oggetto come fonte di dati, oppure è possibile selezionare i dati dopo l'elaborazione del report come fonte di dati<br>Ben 13 tipi di modelli di grafici da scegliere: supporto imbuto di vendita, misuratore di puntatori, grafico a torta, istogramma secondario raggruppato, ecc. <br> Liberamente trascinare e rilasciare per cambiare la dimensione e la posizione del grafico: il cruscotto può distinguere i dati importanti e i dati ausiliari mettendo la posizione e la dimensione dei diversi grafici, che sono completamente a voi<br>Dashboard filtraggio generale: La dashboard supporta il filtraggio dei dati del grafico incorporato con campi filtro impostati per intervallo di tempo e utente<br>Caching dei dati: i dati del grafico della dashboard possono essere memorizzati nella cache quando vengono creati per la prima volta, riducendo il tempo di caricamento secondario. <br>Penetrazione dei componenti: È possibile saltare ai dettagli del rapporto corrispondente o all'elenco dei record nella vista corrispondente dell'oggetto facendo clic sul componente<br>Collegamento dei componenti: Nella stessa dashboard, un componente può impostare altri componenti della stessa origine dati per interagire con se stesso. Cliccando sull'area dati del componente, altri componenti possono essere impostati per ricontattare i dati secondo le condizioni di filtraggio di questa area dati<br> 1. Creare un nuovo dashboard<br> Come rappresentante o manager del reparto vendite, puoi visualizzare i tuoi dati di vendita creando dei dashboard. La versione Lightning di CloudCC Sales Cloud fornisce ricche capacità per creare dashboard<br>Nota: I dati della versione Lightning del dashboard e la vecchia versione del dashboard non sono interoperabili. <br> Clicca sulla scheda "Dashboard", clicca su "New Dashboard", compila il nome del dashboard e seleziona la cartella in cui vuoi salvare questo dashboard. Puoi inserire un nuovo dashboard.`,
"label.layout.availabletab.trackrecord":`Registri delle tracce`,
"label.campaignmember.main.deletecontact":`Rimuovere i contatti esistenti dei membri`,
"lable.outlook.mcto.emaltoc":`Quando le e-mail vengono inviate a CloudCC.com`,
"label.setup.mobile.offlinecache.savesuccess":`Le impostazioni della cache offline sono state salvate con successo.`,
"label.timezone.default":`Fuso orario predefinito`,
"label.noRules.have.been.enabled":`Nessuna regola abilitata.`,
"label.ccchat.person.invite.existsend":`Alcuni degli indirizzi e-mail che hai inserito corrispondono a utenti esistenti.`,
"label.work":`Lavoro`,
"actualstarttime.actualendtime.time.illegal":`L'ora effettiva di inizio dell'appuntamento di servizio dovrebbe essere inferiore o uguale all'ora effettiva di fine.`,
"lable.product.stsp":`Setup Prezzo standard`,
"vue_label_normal_account_sf":`Conto`,
"label.finishpic":`Grafici generati`,
"label.h5.similar.opportunity.step3":`Passo 3 Selezionare i campi da visualizzare per opportunità simili`,
"label.relateobjDefault":`Record predefinito`,
"label.customcomponent.check.tag.endwith":`Il componente deve finire con l'etichetta`,
"label.related.organization":`Opportunità correlate`,
"label.recordtype.edit.selectvalue.orderby":`Opzione Elenco valori ordinamento`,
"vue_label_homepage_enter_name":`Inserisci un nome`,
"label.permission.group":`Gruppi di autorizzazioni`,
"label.emailobject.send":`Invia`,
"label.ralateuser":`Utenti correlati`,
"label.validate.function.funcFormat.ADDMONTHS":`ADDMONTHS(data,num)`,
"label.tablayoutedit.remark2":`Seleziona i campi visualizzati nella pagina iniziale della scheda.`,
"setup_mainpage_label_welcome3":`La creazione di moduli nella piattaforma cloud CloudCC si basa su database personalizzati (oggetto), gli oggetti definiti dall'utente sono tabelle di database che memorizzano dati specifici della vostra organizzazione. Le relazioni da tabella a tabella possono essere facilmente stabilite senza lo sviluppo di alcun programma.`,
"label.user.notallowed.login.scope":`Non ti è permesso di accedere entro il tempo stabilito o il tuo IP è limitato.`,
"label.tel.ten.case":`È possibile inserire fino a 10 numeri di telefono per ricevere le notifiche, ogni numero è separato da ",".`,
"front-kefu-moudle-v1-user-info":`Informazioni sull'utente`,
"label.aboutme":`Su di me`,
"label.setfieldediting.tip":`Quando si definiscono i passi di approvazione, si possono assegnare le richieste di approvazione a diversi utenti. Una delle opzioni è quella di usare un campo utente per instradare automaticamente queste richieste. Se vuoi usare questa opzione per uno qualsiasi dei tuoi passi di approvazione, seleziona un campo dalla lista sottostante. Inoltre, quando un record è nel processo di approvazione, sarà sempre bloccato: solo un amministratore potrà modificarlo. Tuttavia, puoi scegliere di permettere anche all'approvatore attualmente assegnato di modificare il record.`,
"label.existing_dashboard":`Aggiungere al cruscotto esistente`,
"label.sendemail.spotsign":`Caro #nome: il membro della campagna #cliente che hai invitato all'#attività è arrivato e si è iscritto, tieni presente che.`,
"UG_solution_01":`Fornire la soluzione`,
"label.tianyancha.estiblishtime":`Estirpare il tempo`,
"label.pc.lightningpage":`Applicazione leggera (beta)`,
"label.saveAndSync":`Salvare e sincronizzare`,
"label.state.end":`Completato`,
"label.sendemail.queue.assigninfo":`Code: [#queueName] ha assegnato #objectName: #recordName`,
"label.approvalprocessname":`Nome del processo di approvazione`,
"label.view.conditions.message":`Filtrato da {!condizioni}`,
"label.partnerCloud.financeSetting.alipayCorporate":`Conto Alipay Business`,
"label.forecast.detailforecast.de":`s`,
"label.savepayset.failure.nopay":`Si prega di configurare almeno un conto di pagamento online`,
"label.step1.total6":`Passo 1 di 6`,
"label.appointment.wizard.subtitle4-1-3":`45 min`,
"label.emailobject.markasread":`Segna come letto`,
"message.error.orgid.null":`orgid non può essere nullo!`,
"label.emailtemplate.mergefield":`Valore del campo Merge`,
"label.weixin.recent.list":`Liste viste di recente`,
"label.emailsync.form.email":`Email`,
"label.funnel":`Imbuto`,
"label.logintime.clear":`Tempo libero`,
"label.chatter.followed":`Seguito da`,
"label.ccpeak.function.field.spack":`I campi di una funzione devono avere delle linfe su entrambi i lati.`,
"label.setup.mobile.offlinecache.remark":`Dopo aver abilitato questa funzione, i membri dell'organizzazione possono creare, modificare e cancellare i record mentre sono offline con i dispositivi mobili`,
"label.product.function":`Categorie di pacchetti`,
"label.icon.14":`Martello`,
"message.report.nodata":`Nessun dato è stato restituito.`,
"label.please.ChooseMin":`Si prega di scegliere almeno {a} opzioni di prodotto`,
"label.tabpage.releaseTourz":`Pubblicare la guida`,
"vue_label_chat_opportunity":`Squadra delle opportunità`,
"vue_label_chatter_refucecertification":`Sei sicuro di rifiutare "{nome}" per entrare nella chat della squadra?`,
"label.version.unlimited":`Illimitato`,
"label.processsetting.enable.prompt":`Dopo l'abilitazione, il percorso delle impostazioni sarà nella pagina dei dettagli corrispondente alla versione del fulmine. Puoi anche salvare prima le impostazioni e abilitarle dopo.`,
"label.page.display.property":`Proprietà del display`,
"label.service.appointmentList.thisOption":`Non controllato`,
"label.register.date":`Data di registrazione`,
"label.brief.contract.amount":`Importo del contratto`,
"setup.object.field.dependency.label.actionfieldnotnull":`Si prega di selezionare prima un campo di controllo.`,
"UG_homepage_009":`Accesso CRM`,
"label.icon.98":`Cartella`,
"label.weixin.datacount":`Totale`,
"label.mobile.hasbind":`Questo numero di cellulare è stato utilizzato. L'ultimo vincolo sarà liberato se si continua a legare.`,
"label.emailtemplate.choosemorecontacts":`Seleziona più destinatari`,
"setup_layout_button_deleteitem":`Rimuovere gli elementi selezionati`,
"vue_label_account_collection_plan":`Piano di raccolta non elaborato`,
"label_chatter_maturiyDate":`Data di scadenza`,
"label.emailtocloudcc.license":`Licenza`,
"vue_label_checkduplicate_complete_check_rules":`Completare le regole di controllo dei duplicati`,
"chatter.up.type":`Puoi caricare un file jpg, gif o png.`,
"label.attendance.nocheckout":`Non Check-Out`,
"label.setup.mobile.offlinecache.remark2":`Le schede selezionate saranno abilitate sui dispositivi mobili di tutti gli utenti della tua organizzazione come schede di cache offline predefinite.Ogni utente può disabilitare le schede di cache offline delle impostazioni organizzative, o abilitare altre schede come schede di cache offline a seconda delle proprie esigenze.`,
"template.report.count.marketing.activities":`Campagna totale`,
"label.multilingual.tip4":`Se il multilinguaggio è disattivato, la lingua aziendale predefinita sarà impostata su cinese o inglese in base all'indirizzo dell'azienda, e la lingua di tutti gli utenti è impostata sulla lingua aziendale predefinita.`,
"label.settings_area":`Area delle impostazioni`,
"label_assessment_content":`Contenuto della valutazione`,
"label.top":`Top`,
"UG.Account.06":`Creare un account`,
"label.emailtocloudcc.step1.case2":`Una volta configurato, le mail ricevute in questa casella di posta saranno automaticamente registrate come record di caso in CloudCC. In base al contatto e all'account corrispondente alla casella di posta, metti in relazione il caso con il contatto e l'account corrispondente, in modo da facilitare l'accettazione e il monitoraggio dei casi.`,
"label.forecast.forehistory.best.remark":`Note sul caso migliore`,
"label.project.problem.date":`La data di emissione deve essere all'interno dell'intervallo di date della milestone o del progetto a cui appartiene.`,
"label.forecast.customforecast.foredis.wzs":`Numeri completi`,
"message.setup.field.name.value.notexists":`Il valore dell'elenco dei ruoli di squadra che hai inserito non esiste, per favore inseriscilo di nuovo.`,
"label.salescloud.teamrole.opportunity.organization":`I membri del team possono avere un accesso maggiore a questa opportunità rispetto alle impostazioni di accesso predefinite della tua organizzazione.`,
"label.sms.message.input":`Inserire il messaggio`,
"label.document.type.not.allow":`Questo tipo di documento non può essere caricato!`,
"label.customfields.totalsummary.tip":`Un campo di sola lettura che visualizza la somma, il valore minimo o massimo di un campo in una lista correlata o il conteggio di tutti i record elencati in una lista correlata.`,
"label.tabpage.filesizez":`Dimensione del file`,
"label.import.page2.filedname":`Nome del file`,
"label.same.analyze":`La mia analisi delle opportunità simili`,
"label.service.gantt.refreshData":`Aggiorna i dati dopo il refresh della pagina.`,
"label.sendsms.batch.step2.sendbycontext":`Invia per contenuto SMS personalizzato`,
"UG_Account_05":`Diagramma della struttura di contatto`,
"label_emailtocloudcc_step1total3":`Passo 1 di 3`,
"label.weixin.no.history":`Nessun record di storia`,
"label.datamanage.queryfield.error":`Errore nel campo della query.`,
"label.emailmerge.mergeFolder.emailmerge":`Modelli di Mail Merge`,
"label.workflow.estimatecondition":`Criteri di valutazione`,
"label.autonumberfield.wrong":`Inserisci un numero da 0-{0}`,
"label.data.setok.t.desc1":`Se avete bisogno di usare questo modello di dati derivati, cliccate su`,
"label.data.downpage.i.title":`Fasi di importazione dei dati:`,
"label.data.downpage.i_list.desc2":`Dopo aver importato i dati, riceverai un'e-mail che ti ricorderà che l'importazione è avvenuta con successo.`,
"label.opportunity.jieduan":`Fase attuale`,
"vue_label_commonobjects_view_sumby":`Metodo aggregato`,
"label.knowledge.setting.hint.three":`Possiamo prepararti per l'operazione. Ecco cosa ti serve per prepararti:`,
"page.activity.history":`Storia dell'attività`,
"label.cancelQuoteLineGroup":`Cancellare il gruppo di quote`,
"label.addattachment.batch.step3":`Passo 3 clicca sul pulsante per finire.`,
"label.chat.topic.follow":`Segui`,
"label.import.page1.uploadcsvfiled":`Trascinare o cliccare per caricare il file CSV`,
"label.batchtransfer.datetype.tip":`Per i campi data, inserite il valore nel seguente formato:`,
"vue_label_systemSettings_application_util":`Console di gestione delle applicazioni`,
"label.partner.workspace.member.selectedpermission":`Set di permessi selezionato`,
"label.service.appointmentList.plansToEnd":`Piano finale`,
"label.industrialandcommercialverification.contactinformation":`Chiama per l'acquisto o per domande 400-642-2008`,
"chatter.del.p":`Cancella questo post`,
"label.forecast.customforecast.replacefirst":`Sovrascritto da me`,
"Lead.Scoring.Setting.Rule.Setup.RuleName":`Nome della regola di punteggio`,
"label.weixin.appr.applicant":`Inviato da`,
"component_event_label_calendar":`Visualizza il calendario`,
"step":`Passo`,
"label.attendance.setting.position.alert":`Il lavoratore dell'ufficio deve impostare la localizzazione del punto di riferimento.`,
"label.end":`Completato`,
"label.mobile.change.owner.success":`cambiato al nuovo proprietario`,
"label.chinese":`Cinese`,
"label.textmessage.vonage.account":`Informazioni sul conto`,
"front-console-no-related-contact":`Si prega di associare prima il contatto`,
"label.dashboardSetup.seltype":`Tipo di componente opzionale`,
"chatter.follow.user":`Segui questo utente`,
"label.textmessage.sentsuccess":`Inviato con successo`,
"label.australian.gentral.standard.time":`Ora solare centrale australiana (South Australia)`,
"label.validate.function.funcFormat.AND":`AND(logical1,logical2,...)`,
"lable.SalesCommitmentKanBan.contract":`Firmato`,
"label.processsetting.basic.settings":`Impostazione di base`,
"label.escalation.setup.newentries.ifcondtions":`Esegui questa regola se il`,
"label.lookup.nofound.data":`Il valore non esiste o non corrisponde al filtro.`,
"vue_label_commonobjects_view_chart_chartname":`Nome del grafico`,
"label.dashboard.show.percent":`Mostra %`,
"label.sso.saml.sp.userid":`ID utente`,
"label_tabpage_minutesagoz":`minuti`,
"vue_label_chatter_comment_content":`Inserisci il contenuto del commento`,
"label.campaign.channel.step6.mobilepc":`Generare pagine per cellulari e PC`,
"vue_label_homepage_editprofilepage":`Modifica nome`,
"label.tabpage.crecordtypez":`Cambia tipo di record`,
"label.social.posts.type.null":`Il tipo di post non può essere vuoto`,
"label.projectManagement.groupbyuser":`Raggruppamento per utenti`,
"vue_label_email_new_template":`Salva come nuovo modello`,
"label.ems.close":`Cancella`,
"label.ccdocument.noauthority.folder":`Non hai il permesso di usare questa cartella.`,
"message.filterconditionerror":`<strong>Errore: </strong> Il tuo filtro ha citato male le condizioni del filtro:`,
"label.User.Interface":`Interfaccia utente`,
"label_tabpage_greaterz":`Maggiore di`,
"vue_label_CCChat_unfollow":`Unfollow`,
"label.selectandcontinue":`Seleziona e continua`,
"vue_label_commonobjects_detail_influence":`Influenza`,
"label.total.have.priority":`è precedente`,
"label.manageAll.sta4":`Richiamo`,
"label.setup.mobile.offlinecache.setup":`Impostazioni della cache offline sul lato mobile`,
"vue_label_chatter_cancel_adding":`Cancella`,
"vue_label_lead_select_existing":`Selezionare l'esistente`,
"front-epwechat-module-v1-contacts-sync":`Sincronizzare i contatti WeCom`,
"label.appupload.component.type.recordtype":`Tipi di record`,
"label.layout.hint":`Questa pagina non è disponibile per l'anteprima. Si prega di salvare e visualizzare nella pagina in primo piano.`,
"label.change":`Cambia`,
"setup_layout_label_detailpage":`Pagina di dettaglio`,
"label.imgfield.use.tip":`img(docid,width,height), questa funzione è usata per produrre immagini, "docid" è l'ID del documento, "width" imposta la larghezza dell'immagine (tipo Integer può essere nullo), "height" imposta l'altezza dell'immagine (tipo Integer può essere nullo).`,
"pagecreator.systemstyle.button.edit":`Modifica stile`,
"label.delete_externalpage":`L'articolo che vuoi cancellare non può essere ritirato, per favore conferma di nuovo. Il modulo non è usato in nessuna pagina di login, ma può essere usato altrove. Per esempio, potresti aver usato il codice embed per inserirlo in una pagina esterna.`,
"font-evaluate-module-v1-open-case":`Riaprire il caso:`,
"label_not_adjust":`Nessuna regolazione`,
"vue_label_title_ordernow":`Ordina ora`,
"label.notification.serviceappointment.allocation":`Le è stato inviato un nuovo ordine di lavoro {0}, lo controlli.`,
"label.objectRelationshipDescription2":`. Potete definire quali record correlati da altri oggetti vengono restituiti nei risultati del report scegliendo una relazione con un altro oggetto.`,
"vue_label_calendar_notice_createfail":`Impossibile creare il calendario`,
"label.ems.step1":`Passo 1`,
"label.ems.password":`Password`,
"label.icon.143":`Salvadanaio`,
"label.select.year":`Selezionare l'anno`,
"label.termsforusage.dialog":`Condizioni d'uso (Nuova finestra)`,
"label.tag.addtags.create":`Creare`,
"label.emailobject.groupemail.msg4":`non verrà inviato a causa di un indirizzo e-mail non valido.`,
"label.version.sum.autonumberfield":`campo(i) numero(i) automatico(i)`,
"label.projectManagement.unallocated.time":`Tempo non assegnato`,
"PageLayout.Search.MultiSearch.002":`Abilita la casella di ricerca personalizzata (Ricerca per campo singolo)`,
"label.icon.150":`VR`,
"label.SMS.edit":`Modifica della notifica SMS`,
"Opportunity.Detailed.Phase.Label.003":`Fase di cambiamento`,
"vue_label_helpcenter_all":`1. Ricerca generale<br> La ricerca generale è uno strumento che ti aiuta a trovare rapidamente ciò che ti serve. <br>?Inserisci le parole chiave nella casella di ricerca nella barra di navigazione nella parte superiore della pagina. Durante il processo di inserimento, il sistema ti consiglierà in tempo reale i contenuti rilevanti in base al contenuto inserito; <br>?Clicca su "Cerca" o premi direttamente il tasto Enter della tastiera per aprire la pagina dei risultati della ricerca; <br>?Nella pagina dei risultati, puoi filtrare l'oggetto sulla sinistra per visualizzare la lista dei risultati della ricerca sotto quell'oggetto. Nell'elenco dei risultati sono stati consigliati fino a 10 record. Puoi fare clic su "Visualizza altro" per entrare nella pagina della lista di questo oggetto per visualizzare altri risultati di ricerca; <br>Nota: Il sistema cerca per default "preventivo", "cliente", "lead", "opportunità di business", "attività di marketing", "contratto", "prodotto", "richiesta di servizio", "compito" ed "evento". <br> 2. Crea rapidamente<br> Clicca " " nella barra di navigazione, e puoi selezionare l'oggetto che vuoi creare nella finestra a discesa. <br> 3. Il mio centro<br> Clicca sull'avatar sul lato destro della barra di navigazione per aprire la finestra Il mio centro. Sono disponibili le seguenti funzioni: <br>?Entra rapidamente nella pagina delle impostazioni personali, importazione in blocco e ingresso nel cestino; <br>?Se sei nel periodo di prova, clicca su "Ordina ora" per entrare rapidamente nella pagina dell'ordine di Cloud CC; <br>?Clicca su una versione per cambiare rapidamente; <br>?Esci. <br> 4. Menu<br> Alcuni oggetti del menu sono raccomandati per te nella barra del menu. Puoi cliccare su un menu per entrare rapidamente nella pagina. Puoi anche visualizzare tutti i menu e impostare i menu di uso frequente da visualizzare nella barra dei menu. <br>Tutti i menu: Clicca su "Altro", e clicca su "Tutti i menu" in fondo al menu a tendina; <br>?Personalizza il mio menu: Fai clic sul pulsante sul lato destro del menu per aprire la finestra del menu personalizzato e imposta i menu comuni da visualizzare nella barra dei menu in tutti i menu. <br> 5. Centro di lancio delle applicazioni<br> Clicca l'icona sul lato destro della barra dei menu per passare rapidamente all'amministratore di sistema per configurare altri servizi applicativi per te. <br>Nota: Un'applicazione è un insieme di una serie di moduli funzionali (come la gestione dei lead, le opportunità commerciali, la gestione dei contratti, ecc.`,
"label.summaryreport.2018.step5.new":`Passo 5 Selezionare i criteri del rapporto`,
"label.weixin.id":`Numero`,
"chatter.pu.mess":`posto(i)`,
"label.weixin.lookup.record":`Trova i record`,
"label.ServiceCloud.statistics.by.address":`Statistiche per indirizzo`,
"label.jixiaoswitchoff":`Crollo`,
"label.savealipay.failure":`Impossibile salvare le informazioni del commerciante Alipay`,
"template.chart.khdqfb":`Conti Distribuzione regionale`,
"front-email-payment-immediate-payment":`Paga ora`,
"label.dashboard.unit5":`Unità: 100 milioni`,
"label.tabpage.greaterz":`Maggiore di`,
"vue_label_calendar_stop_sharing_calendar":`Smettere di condividere il calendario`,
"label.projectManagement.allhours":`Tutti (ore)`,
"label.currency":`Valuta`,
"label_vue_create_edit_obj_create_event_dialog_title":`Promemoria degli orari ripetitivi`,
"front-template-V1-templateSetting":`Impostazione del modello`,
"label.dashboard.away.condition":`Condizione di collasso`,
"label.replacelayout":`Sostituire il layout della pagina`,
"label.permission.detail.system.setting.tip":`Eseguire l'operazione applicata alle app. Per esempio: modificare i permessi per tutti i dati`,
"label.customfield.delete.prompt":`Etichetta di campo personalizzata`,
"label.add":`Aggiungi`,
"label.deputationalsoapprove":`Anche l'approvatore delegato può approvare questa richiesta`,
"label.leave_nosave":`Dopo l'uscita, i dati attuali non saranno salvati.`,
"label.tianyancha.title":`TianYanCha`,
"vue_label_pool_restore":`Ripristinare`,
"chatter.feed.menutype.feed.markcom":`Segnalibro Post`,
"label.query.data.error":`Fallito nell'interrogazione degli elenchi correlati`,
"label.pc.ui.2018.unpin":`Staccare la spina`,
"label.partner.template.memo":`Titolo`,
"label.weixin.cannot.gain.userinformation":`Impossibile ottenere informazioni sull'utente.`,
"label.stdashbord.xsld.department":`Dipartimento`,
"label.service.ganttBaiduMap.scheduled.starttime":`Ora di inizio prevista`,
"label.documentforms":`Documenti`,
"label.operator.insert":`Inserire l'operatore`,
"label.processsetting.select.five.fields":`Si possono selezionare fino a 5 campi.`,
"label.weixin.password":`Password`,
"vue_label_chatter_share_followers":`Condividere con i seguaci`,
"label.brief.baifang":`Visite`,
"label.emailobject.track.unopen":`Non aperto`,
"label.sendmail.immediately":`Invia ora`,
"label.partnerCloud.payTheAmount":`Importo del pagamento`,
"label.integrations.mailchimp.connect":`Collega CloudCC al tuo account`,
"label.datamove.record.sucessfully":`record trasferiti con successo.`,
"lable.outlook.edit.allocation":`Assegnare utenti e profili`,
"label.chosesubject.talk":`Pianifica un colloquio`,
"label.escalation.setup.entrydetail.escalation.time":`Escalation a`,
"label.projectManagement.must.be.less.than.24.hours":`Meno di 24 ore`,
"setup_mainpage_label_welcome15":`Le regole del flusso di lavoro della piattaforma CloudCC automatizzano il processo di supporto per le vendite, il marketing e altro. In base a una serie di regole predefinite, i record possono essere assegnati automaticamente agli utenti o convertiti da un utente a un altro. Il vantaggio principale della gestione del flusso di lavoro è quello di migliorare l'efficienza del lavoro eliminando molte operazioni inutili quando si aggiornano i record, e di migliorare i livelli di elaborazione aziendale e ottimizzare i processi di controllo standardizzando i metodi di lavoro e riducendo i costi operativi. Supporta l'approvazione infinita illimitata per qualsiasi oggetto, e può innescare e-mail di promemoria, promemoria SMS, compito, aggiornamento del campo e altre funzioni.`,
"label.mobile.phone.week.plan2":`Questa settimana`,
"label.add.newAsset":`Nuova risorsa`,
"vue_label_salesadvance_losts":`Numero di perdita`,
"vue_label_report_editcolumn":`Modifica Colonna`,
"vue_label_homepage_assignedtasks":`Compiti assegnati`,
"label.posting_from":`Pubblicato da`,
"year":`Anno`,
"label.autoRegister.changepwd.setpwd.tip.letter":`Almeno una lettera`,
"label.version.nonsupport.feature.staticresource":`Questa funzione non è temporaneamente supportata. Si prega di attendere l'aggiornamento prima di utilizzare.`,
"label.toleadmyclientandlinkman":`Importare i miei conti e contatti`,
"label.appupload.install.processcrash":`Affrontare i conflitti`,
"label.profile.setstandardtab":`Impostazioni standard della scheda`,
"template.chart.khhyfx":`Analisi dell'industria dei conti`,
"label.reportTypcrtC":`Oggetto associato (c) clicca per selezionare l'oggetto correlato`,
"vue_label_report_mayormaynothave":`L'oggetto genitore può o non può avere record relativi a questo oggetto`,
"label.service.gantt.plan.recommendation":`Programma raccomandato`,
"label.version.sum.lookupfield":`campi di relazione lookup`,
"label.builder":`Costruttore di pagine`,
"label.sharerule.remark":`Specifica la condivisione di questo record. Puoi condividere i record e i relativi dati con l'utente, il ruolo, il ruolo e i subordinati, gli utenti di un territorio, gli utenti del territorio e del sotto territorio.  La condivisione individuale può essere utilizzata solo per garantire un accesso più ampio ai dati, non per limitare l'accesso.`,
"vue_label_email_benn_added":`La casella di posta è stata aggiunta`,
"label.version.allow.sum":`ha raggiunto il limite superiore. Se necessario, si prega di aggiornare la versione di CloudCC.`,
"label.icon.130":`Valuta`,
"label.custom.new":`Nuovo`,
"label.see_allfields":`Visualizza tutti i campi`,
"front-marketing-module-v1-share-poster":`Condividi poster`,
"label.service.one":`Il tuo filtro fa riferimento a condizioni di filtro non definite:`,
"lable.outlook.edit.alprec":`Sempre preferito CloudCC.com`,
"Account_News_Setting_001":`Impostazioni dell'account`,
"label.mr.caption.opportunity.result":`Trova duplicati e unisci: Risultati per la ricerca di duplicati di opportunità`,
"label.forbidden":`Disattivare`,
"label.query.detail.openpartner":`Abilita come utente partner`,
"label.session_date":`Data della sessione`,
"label.forecast.customforecast.submit.deyuce":`Previsione`,
"label.emailtocloudcc.filed.server":`Server`,
"label.emailtocloudcc.tip2":`Dopo la cancellazione, non sarai in grado di usare Email to CloudCC, sei sicuro di voler cancellare?`,
"pagecreator_layout_message_delete_fail":`Eliminazione del layout non riuscita`,
"front-lightning-module-v1-dashborad-export-PDF":`Esportare PDF`,
"lable.quote.syncing.syncingto":`Le voci di preventivo sono state sincronizzate con i prodotti di opportunità`,
"message.error.view.lastview.update":`Impossibile eliminare l'ultima vista lista pubblica</br>Non è possibile cambiare la visibilità dell'ultima vista lista pubblica da "Visibile a tutti gli utenti" a "Visibile solo a me"<br><br>.`,
"label.weixin.select.one":`Seleziona almeno uno`,
"label.projectManagement.Pleaseenterprojectname":`Inserisci il nome del progetto...`,
"label.data.downpage.e_list.desc1":`Questa pagina mostra i file esportati con successo. Per favore scarica i file esportati in tempo secondo il link di download nella tua email.`,
"label_tabpage_notexceed25":`Il record selezionato non deve superare il 25`,
"label.campaign.channel.step5.remark":`Hai finito di impostare la pagina di registrazione.`,
"label.setup.mobile.bottombutton.profile.prompt":`Suggerimenti: il menu inferiore personalizzato del profilo sovrascriverà le impostazioni unificate del menu inferiore dell'azienda`,
"label.stdashbord.xsld.business.knx":`Probabilità`,
"label.setemailtip":`Crea un avviso e-mail da associare a una o più regole del flusso di lavoro o processi di approvazione. Quando si modifica un avviso e-mail, qualsiasi modifica verrà applicata a tutte le regole o approvazioni ad esso associate.`,
"report.button.go":`Vai a`,
"lable.the.united.arab.emirates":`Le registrazioni sono state ricevute.`,
"label.writer. name.file":`Si prega di compilare il nome del file del preventivo`,
"label.validate.function.funcExplain.ADDMONTHS":`Aggiungi il numero di mesi alla data, usando l'ultima data del mese se la data è l'ultimo giorno del mese o aggiungendo il numero di mesi ha meno giorni.`,
"vue_label_chatter_enter_shared_content":`Inserisci il contenuto condiviso`,
"message.lookup.condition":`I criteri di ricerca devono inserire più di un carattere`,
"vue_label_commonobjects_detail_customers":`I clienti che disabilitano permanentemente gli utenti esterni bandiranno tutti gli utenti esterni associati al cliente e li rimuoveranno da tutte le comunità, gruppi, team, set di autorizzazioni e regole di condivisione ad essi associati. Allo stesso tempo, i ruoli e i gruppi associati all'account saranno eliminati in modo permanente e non appariranno nel cestino. Sei sicuro?`,
"label.emailobject.view.all":`Tutte le e-mail`,
"vue_label_file_size_limit_new":`Caricamento fallito. L'allegato supera le {dimensioni}M.`,
"front-gantt-module-please-reorder-milestones":`Inserisci un numero valido per riordinare le pietre miliari`,
"label.escalation.setup.entrydetail.escalation.assingTemplate":`Email`,
"label.namespaceprefix":`Prefisso dello spazio dei nomi`,
"label.ems.delete.success":`Cancellare con successo`,
"label.partnerCloud.financeSetting.setWechatPay":`Impostare WeChat Pay`,
"front-epwechat-module-v1-input-token":`Per favore, inserisci il Token`,
"setup_object_field_dependency_button_setdependency":`Impostazioni di dipendenza dal campo`,
"chatter.group.request01":`Richiesta(i)`,
"message.error.field.number.length":`La lunghezza del formato inserito è un errore.`,
"label.tabpage.lessz":`Meno di`,
"vue_label_notice_uploadavatar_format":`L'immagine avatar caricata può essere solo in formato JPG/PNG/GIF`,
"label.project.hit.thirteen":`Promemoria delle pietre miliari quotidiane`,
"frame_personinfo_label_usethisimage":`Useremo variazioni di questa immagine in miniatura in tutta l'applicazione.`,
"label.startuploadfile.step":`Altrimenti i file non caricati con successo saranno visualizzati nell'area superiore, devono essere rimossi, quindi scegliere un nuovo file.`,
"component_assistant_label_overduetask":`Opportunità con compiti in ritardo`,
"label.partnerCloud.financeSetting.information":`Come impostare le informazioni di sottoscrizione di Alipay?`,
"label.appupload.install.package.component":`Componenti del pacchetto`,
"label.emailobject.emaildetail.nextactivity.task":`Aggiungi compito`,
"vue_label_chatter_edit_post":`Modifica del messaggio`,
"label.appupload.upload.logo":`Icona`,
"label.role.selecteduser":`Utenti selezionati`,
"label.letter.assign":`Specificare il contenuto dell'invito`,
"label.forecast.shrepage.title":`Dettagli sulla condivisione delle previsioni`,
"lable.Generate.service.appointment":`Appuntamenti di servizio generati dalla voce dell'ordine di lavoro`,
"label.productsales.nodata":`Nessun dato`,
"vue_label_email_Please_select_at_least_one_email":`Seleziona almeno un'email`,
"label.data.downpage.i_title.num4":`4. Se hai un campo di relazione lookup e un campo di relazione master-detail nell'oggetto che vuoi importare, il valore di questo campo deve essere ID, altrimenti non è valido.`,
"label.new.exchagecurrency":`Nuovi tassi di cambio`,
"label.layout.listtip":`La tabella seguente mostra l'assegnazione del layout di pagina per diversi profili.`,
"label.icon.2":`Portafoglio`,
"label.chat.topic.delete.prompt3":`Sei sicuro di voler cancellare questo argomento?`,
"UG_Lead_008":`Codice di scansione del biglietto da visita`,
"label.multilang.databatchadd.fail":`{0} i dati non sono riusciti ad essere aggiunti：`,
"front-kefu-moudle-v1-chzx-confirm":`Sei sicuro di voler eliminare l'agente?`,
"label.import.page1.matchlabel":`Modo per abbinare {{$store.state.labelName}}`,
"label.dashboardSetup.showdw.d3":`Milioni di`,
"label.version.ifnecessary":`Se necessario, aggiorna la tua versione di CloudCC.`,
"label.confirm.delete.default.tab":`Sei sicuro di voler eliminare le schede di registrazione predefinite?`,
"label.emailtemplate.mergefields.tip":`Quando gli utenti modificano il contenuto delle e-mail, possono aggiungere campi fusi per sostituire il testo nel contenuto delle e-mail. Quando le email vengono inviate, il sistema le sostituisce con del testo. Per esempio, {!Contact.name} nella tua email diventerà il nome del contatto.`,
"vue_label_chatter_decline_members_join":`Rifiutare ai membri di unirsi al gruppo`,
"label.role.no":`Nessun ruolo`,
"label.service.gantt.resources":`risorse`,
"label.knowledge.language.simplified":`Cinese semplificato`,
"label.eidt.queue.length.cannot.than":`La lunghezza del nome non può superare i 50 caratteri.`,
"label.mobile.quickcreate.default.tasks":`Compiti`,
"label.discount.yuan":`Sconto (Yuan)`,
"message.error.delete.pending":`Il record è in attesa di approvazione, non puoi cancellarlo.<br>Clicca <a href='javascript:history.back();'>qui</a> per tornare indietro.`,
"chatter.show.mostnews":`Mostra di più`,
"label.optionlist":`Picklist`,
"template.chart.cpdj":`Prezzi dei prodotti`,
"label.user.usernamepassword.error":`Controlla il tuo nome utente e la tua password.`,
"label.file.sharetype.check":`Visualizzatore`,
"label.completed.generated.page":`La pagina del PC è completata`,
"label.martrixcross":`Croce a matrice`,
"label_tabpage_entercusnamez":`Inserisci il nome del cliente`,
"lable.account.NextwDays":`Prossimi 30 giorni`,
"label.list.userinterface.dashboard.hint":`Nuovi grafici del cruscotto visualizzati rapidamente su telefoni cellulari, tablet, ecc.`,
"message.fieldtrack.operatecreate":`Creato`,
"label.service.gantt.available.plan":`Scaglioni di tempo che possono essere programmati:`,
"label.activity.setting":`Impostazioni dell'attività`,
"label.tag.manage.record":`Numero di record`,
"label.customcomponent.page.edit.title":`Modifica dei componenti personalizzati`,
"label.import.index.creationrecord":`Creare un record`,
"label.tabpage.printz":`Stampa`,
"label.appointment.wizard.subtitle4-1-5":`1.5 h`,
"label.partnerCloud.orderingPlatform.discountUnit":`Unità di sconto:`,
"label.weixin.micro.message.profile.associated":`Account ufficiale WeChat associato al profilo aziendale`,
"label.cpq.opportunity.pricebook.change":`Questa opportunità è stata collegata a una quotazione primaria e il listino non può essere cambiato`,
"vue_label_opportunity_business_opportunity":`I risultati delle opportunità commerciali chiuse e vincenti per i clienti contengono record con uno o più degli stessi campi dell'opportunità commerciale corrente.`,
"message.standardreport":`Rapporti standard`,
"vue_label_account_outstanding_business":`Trasferire tutte le opportunità di business non elaborate da altri`,
"vue_label_commonobjects_detail_field":`Seleziona il campo del filtro`,
"pagecreator_page_button_delete":`Cancellare`,
"label.leadconvers.permisson":`Nessun permesso {!operator} per il {!objectname}, contatta l'amministratore!`,
"vue_label_systemSettings_customcode":`Codice personalizzato`,
"button.partner.cancel":`Cancella`,
"label.whChatBindingState":`Stato vincolante di WeChat`,
"label.appointmentconfirmail.wizard.subtitle6":`Telefono`,
"label.recycle.dis.tip2":`Clicca su Empty Your Recycle Bin o Empty All per svuotare il cestino degli utenti o dell'organizzazione. Questo richiederà un po' di tempo, quando lo svuotamento è completo, verrai avvisato via e-mail.`,
"batch.transfer.succ":`dati di trasferimento di massa riuscito`,
"label.chat.add.bookmark":`Segnalibro`,
"label.mr.object.contact":`Contatti`,
"component_setup_label_parentobject":`Oggetto superiore`,
"label.reportsSubscriptionPage.schedulereport.weekly.tuesday":`Martedì`,
"vue_label_report_list":`Seleziona il campo da visualizzare nel titolo della lista`,
"label.checkbox.false":`No`,
"label.chatter.followers":`Essere seguiti`,
"label.mr.loadReDate":`Caricare l'elemento selezionato`,
"label.versiontype.Essential":`Essenziale`,
"front-project-module-v1-input-actual_working_hours":`Inserire le ore di lavoro`,
"label.visualpage.staticresource.p2":`2. Si noti che i tipi di file di risorse statiche supportati sono png, jpg, gif, js and css`,
"label.query.clone.detail.choose":`Scegliere le voci da clonare`,
"component.assistant.label.30daysnoact":`30 giorni senza alcuna campagna`,
"label.tianyancha.businessverify.relation":`Ha mappato`,
"vue_label_email_havent_received_the_email_yet":`Nessuna posta ricevuta ora`,
"label.isEnableVisualpage_new.title":`Abilitare l'accesso alla pagina personalizzata`,
"lable.SalesCommitmentKanBan.allContractAmount":`Importo totale del contratto`,
"label.searchall":`Cerca tutti`,
"label.h5.similar.opportunity.select.all":`Seleziona tutto`,
"label.area.tree.intro":`Puoi vedere la gerarchia dei territori qui.`,
"label.select.up.three.fields":`Attenzione: Si possono selezionare al massimo tre campi.`,
"label.leadscore.doing":`Il punteggio è iniziato, per favore non ripetere il punteggio`,
"message.choosereportobj":`Seleziona gli oggetti del rapporto`,
"button_partner_start":`Iniziare a usare`,
"label.quote.print":`Stampa preventivo`,
"label.workflowoperateselect":`Passo 3 Specificare le azioni del flusso di lavoro`,
"label.greate":`> Maggiore di`,
"lable.setting.qrcodeOrbarcode.rule":`Impostazioni delle regole per la generazione di QR Code/Bar Code`,
"label.partnerCloud.orderingPlatform.discounts":`Programma di sconto`,
"label.ems.save2draft":`Salva come bozza`,
"vue_label_homepage_editname":`Modifica il nome della home page`,
"label.ccdocument.save.error":`Il salvataggio non è riuscito e il codice di errore è`,
"label.samoa.standard.time":`Ora solare di Samoa`,
"label.tianyancha.businessverify.msg7":`3. portata del servizio`,
"vue_label_commonobjects_view_up_to_data":`L'operazione supporta fino a 200 dati`,
"label.manage":`Gestire`,
"label.tooltip":`è stata utilizzata l'origine dati del rapporto, non è possibile modificare la relazione tra gli oggetti!`,
"vue_label_calendar_edit_calendar":`Modifica calendario`,
"label.attendance.keywords":`Inserisci le parole chiave`,
"label.otherinfo":`Altre informazioni`,
"System_TAB_SeeViewAmount":`Visualizza i totali`,
"label.recordtype.remark":`Descrizione`,
"label.object.cannot.delete":`L'oggetto non può essere cancellato perché è associato alle seguenti relazioni con altri oggetti`,
"label.setup.mobile.bottombutton.saveprompt":`Seleziona 4 pagine di primo livello`,
"label.department.lastpage":`È l'ultima pagina`,
"label.emailtemplate.mergefield.use":`Copiare e incollare i valori del campo di fusione nell'e-mail`,
"vue_label_salesfunnel_notice8":`Percentuale di conversioni di successo da questa fase alla fase successiva`,
"lable.opppdt.addpdt.table.product":`Prodotti`,
"vue_label_helpcenter_report2.2":`Passo 2: Seleziona come vuoi riassumere le colonne: Totale, Media, Max, Min. <br>? Ordinare i dati nel report in ordine crescente o decrescente<br> Clicca sul simbolo ↑ o ↓ accanto a qualsiasi campo nell'intestazione del report di anteprima. I dati nel rapporto saranno ordinati in ordine crescente o decrescente in base a questo campo. <br>? <br>Mostra o nascondi le righe di dettaglio<br> Dopo il raggruppamento, puoi mostrare o nascondere le righe di dettaglio selezionando l'interruttore "Riga di dettaglio" in alto a destra del rapporto. La "Riga di dettaglio" è disattivata per impostazione predefinita. <br>? Attivare o disattivare l'anteprima di aggiornamento automatica<br> L'"Anteprima di aggiornamento automatica" in alto a destra del rapporto di anteprima ti permette di attivare o disattivare l'anteprima di aggiornamento automatica. Quando è attivata, l'impatto di ogni passo che fai sui dati viene automaticamente visualizzato nel rapporto di anteprima. ? Per filtrare i record del rapporto, clicca sui filtri<br>I filtri sono divisi in filtri standard e filtri di campo. <br>I filtri standard includono il filtro Ruolo, il filtro Mostrami e il filtro Data. <br> A. Il filtro "Ruolo" divide i dati per ruolo corrente e ruoli immediatamente subordinati, e puoi passare da un ruolo all'altro cliccando sul nome del ruolo. <br> B. Il filtro "Mostra a me" divide i dati per "Mostra a me" e "Mostra a tutti", con "Mostra a me" che mostra i dati dove il proprietario è l'utente corrente, e "Mostra a tutti" che mostra tutti i dati dove l'utente corrente ha privilegi di visualizzazione. <br> C. Il filtro "Date Range" divide i dati per data in un intervallo di tempo, come "Create Date", "End Date". <br> Il filtro di campo include sia un filtro di campo che un filtro avanzato. <br>`,
"label.validate.function.funcFormat.YEAR":`ANNO(data)`,
"label.service.gantt.timeScale":`Scegliere la scala temporale in Gantt`,
"label.data.dataexptemplate.desc1":`1. I file di esportazione dei dati hanno due formati: Formato CSV e formato compresso. Il formato predefinito è il CSV.`,
"template.chart.btjbkhqk":`Diversi livelli di clienti`,
"label.role.assign.select":`Rimuovi un utente dalla lista <b>Utenti selezionati</b> e assegna l'utente al ruolo selezionato sopra.`,
"label.event.lookupmulti.assigner":`Assegnato a`,
"label.appexchange.fieldupdata":`Aggiornamenti del campo del flusso di lavoro`,
"label.lookup.page.notexists":`La pagina non esce.`,
"label.appupload.install.error.choice3":`Unire componenti in conflitto in un unico componente`,
"vue_label_commonobjects_detail_team":`Gestione della squadra`,
"label.approvereqiest":`Richiesta di approvazione`,
"message.error.id.replace":`Le informazioni del calendario corrispondenti a {0} non sono state trovate`,
"font-evaluate-module-v1-general":`Il tipo di valutazione è Neutrale`,
"vue_label_report_whatweek":`Quale giorno`,
"vue_label_chatter_img_upload":`Puoi caricare file JPG, GIF o PNG, la dimensione massima del file è 2M`,
"label.checkbox":`Checkbox`,
"label.visualpage.component.n5":`5.Esempio. Chiamare:`,
"chatter.updat":`Aggiornamento`,
"label.ems.emailaccount":`Account e-mail`,
"label.autoRegister.changepwd.setpwd.tip1":`Imposta la password dell'account CloudCC`,
"label.import.step1.matchway":`Modo di abbinare { labelNameshow }`,
"label.manageAll.sel.one4":`Articoli che ho rifiutato`,
"label.tabpage.lookatmorez":`Vedi altro`,
"label_tabpage_addadvancedoptions":`Aggiungere opzioni avanzate`,
"message.validation.accept":`Formato non valido`,
"label.handlingnooperate":`I dati sono in fase di elaborazione, per favore non fare nient'altro, altrimenti l'elaborazione fallirà.`,
"label.mobile.buttom.homepage":`Homepage`,
"lable.account.LastaDays":`Ultimi 7 giorni`,
"label.user.notexists":`L'utente non esiste.`,
"front-electronic-signature-isclose":`Inattivo`,
"label.optional.groups":`Gruppi di linee di quotazione opzionali`,
"pagecreator.layout.label.layoutname":`Nome del layout`,
"label.error404":`La pagina che stai cercando di visualizzare non è qui, per favore riprova più tardi.`,
"label.eventtrigger":`Trigger di eventi`,
"label.projectManagement.next.page":`Pagina successiva`,
"vue_label_SMS_chosen":`Scelto`,
"label.part.cannot.empty":`Il campo non può essere nullo`,
"label.call.center.jilu":`Cronologia delle chiamate`,
"front-kefu-moudle-v1-tenant-reinput":`Inserire l'ID del locatario`,
"label.projectManagement.you.want.to.delete.this.data":`Sei sicuro di voler cancellare questo record?`,
"label.projectManagement.nocharge":`Libero`,
"System_TAB_SeeViewPageAmount":`Visualizza le pagine`,
"label.password.query.error":`Errore di interrogazione dell'utente.`,
"message.chooseatleastone":`Selezionare un valore minimo.`,
"label.sortasc":`Ascend`,
"label.stdashbord.xsld.business.jinezhb":`Importo Proporzione`,
"label.attendance.add":`Aggiungi presenze`,
"vue_label_account_invoices":`Trasferire tutte le fatture del proprietario del cliente`,
"label_delete _model":`La cancellazione di un modello cancellerà anche i dati di destinazione associati ed è irreversibile. Vuoi confermare la cancellazione?`,
"label.folder.sort。discreption":`Le cartelle saranno emesse nell'ordine selezionato.`,
"label.partnerCloud.financeSetting.merchantPlatform":`Acces Path: Piattaforma commerciante  Centro account  Sicurezza API  Segreto APIＫey`,
"label.equal":`=uguale`,
"lable.PowerProcess.Workorder":`Ordine di lavoro`,
"front-docusign-setting-error-tips":`Scegliere il campo personalizzato`,
"template.report.lead.status":`Stato dei lead`,
"label.create.remark":`Aggiungi una nota`,
"font-evaluate-module-v1-one-points":`Marchio negativo: 1 punto`,
"label.validate.function.funcExplain.DATETIMEVALUE":`Restituisce un valore di anno, mese, giorno e ora GMT (campo Data/Ora)`,
"label.report.select.group.mode":`Selezionare la modalità di raggruppamento`,
"label.h5.editmydetails":`Modifica i miei dettagli`,
"front-epwechat-module-v1-authorize":`Dominio di richiamo autorizzato`,
"label.tabpage.kanban":`Impostazione del tabellone`,
"label.emailobject.emaildetail.button.addtocontact":`Aggiungi ai contatti`,
"lable.opppdt.selPbk.description":`Seleziona un listino per questa opportunità. Puoi aggiungere solo un prodotto da un singolo listino, e cambiando il listino selezionato rimuoverai tutti i prodotti esistenti dall'opportunità.`,
"component.event.button.save":`Salva`,
"vue_label_homepage_homepage_assigned_success":`Homepage assegnata con successo`,
"message.duplication.label.blankmatch":`Corrisponde ai campi vuoti`,
"label.icon.24":`Kit di primo soccorso`,
"label.mobile.same":`Il nuovo numero di telefono è uguale al vecchio numero di telefono`,
"label.file.library.managemembers.addmember":`Aggiungere membri`,
"chatter.sp":`Mostra messaggi`,
"label.user.notlogin.range":`Fuori dall'intervallo di tempo di login.`,
"label.step3.total7":`Passo 3 di 7`,
"label.user.fullname":`Nome e cognome`,
"label.button.menubar":`Barra dei menu`,
"#label.importfilestep3":`Passo 3 Seleziona e carica il tuo o i tuoi file`,
"label.appointment.wizard.subtitle6":`Descrizione`,
"message.lostnextapprover":`Se vuoi inviare la richiesta di approvazione, compila il campo "Utente rilevante" per definire il prossimo approvatore. Il campo "Utente rilevante" non può essere vuoto. Per qualsiasi altra domanda, puoi contattare l'amministratore.`,
"label.sso.saml.sp.logoutUrl":`URL di logout singolo del fornitore di identità`,
"label.weixin.isgoon":`Le tue informazioni di iscrizione esistono già. Se continui, l'ID WeChat che lega questo numero di cellulare prima non sarà in grado di utilizzare l'account ufficiale AidMax WeChat. Sei sicuro di voler continuare?`,
"vue_label_notice_homepage1":`Si prega di inserire il valore target corretto entro 12 cifre`,
"label.umeng.activity.event.will":`sarà`,
"label.insertURL":`Inserire l'URL`,
"label.partnerCloud.orderingPlatform.administrator":`Nessun listino prezzi disponibile. Si prega di contattare l'amministratore.`,
"vue_label_systemSettings_emailtemplate":`Email Tamplate`,
"template.dashboard.market.analysis":`Analisi della campagna`,
"message.deleteapproval.tip":`Si può cancellare solo il processo di approvazione a cui non sono associati dati o record.`,
"pagecreator_page_message_delete":`Elimina la pagina correntemente selezionata?`,
"component.telerecord.label.message":`Commento`,
"front-email-payment-Invoice-preview-opening":`Contatta l'amministratore del sistema per attivare la funzione di pagamento online e configurare i parametri del metodo di pagamento corrispondente.`,
"noless":`Maggiore o uguale a`,
"label_emailtocloudcc_button_back":`Cancella`,
"lable.Please.select.a.template":`Si prega di scegliere un modello esistente.`,
"front-lightning-module-v1-details-page-chart-relevant":` Quando gli oggetti associati al rapporto selezionato contengono l'oggetto corrente, è possibile filtrare ulteriormente i dati del rapporto in base al record corrente; Impostare se consentire agli utenti di aggiornare manualmente i dati della cassa.`,
"label.object.page.head":`Intestazione della pagina`,
"label.notification.time1":`in pochi secondi`,
"label.weixin.optionnine":`Scelta 9`,
"label.approval.content.tolang":`Il contenuto che hai inserito è troppo lungo, per favore inseriscilo di nuovo.`,
"label.leadconvers":`Conversione di piombo`,
"label.compact.layout.frame.tabseq":`Visualizza l'ordine della pagina della scheda:`,
"label.permission":`Set di autorizzazioni`,
"vue_label_notice_new_success":`Creato con successo`,
"label.money":`Valuta`,
"label.ccchat.person.invite.unsuppem":`L'indirizzo email che hai inserito non supporta {0}`,
"message.profile.del":`Questo profilo è un profilo di amministratore e non può essere cancellato!`,
"vue_label_report_savelocation":`Salvare la posizione`,
"label.knowledgebase.select.lighting.target":`Scegliere l'obiettivo Fulmine`,
"label.visualpage.labelname":`Nome dell'etichetta della pagina`,
"label.notification.ccchat2":`【点赞用户名】ha apprezzato il tuo post.`,
"label.htyj.wanchenglv":`Percentuale`,
"label.weixin.report.generatedchart":`Grafico generato`,
"label.customer.tab.please.label":`Per favore, l'etichetta della scheda`,
"label.template.lookup":`Visualizza Modello`,
"label.attendance.setting.wucha":`Deviazione entro 200 metri`,
"vue_label_opportunity_product_addproduct":`Aggiungi prodotto`,
"label.data.setok.t.desc3":`, Operazione.`,
"label.emailobject.template.public":`Pubblico`,
"label.setsubmit":`Impostazioni di presentazione`,
"chatter.feed.menutype.feed.companycom":`Tutta l'azienda`,
"label.Generate.Document":`Generare un documento`,
"label.knowledge.setting.hint.six":`Organizza gli articoli in base alla classificazione dei dati.`,
"label.dashboard.show.total":`Mostra il totale`,
"attachment.select.warning.001":`L'allegato è archiviato e il pulsante Archivia non è disponibile, per favore riseleziona un allegato.`,
"message.schedulejob.error.delete":`Si è verificato un errore durante la cancellazione della base di lavoro.`,
"setup.layout.group.pagecomponent":`Componenti della pagina`,
"label_partner_new_step3_meno":`Non sei sicuro di cosa inserire? Non preoccuparti, puoi cambiarlo in qualsiasi momento.`,
"label.partnerCloud.orderingPlatform.mutex":`Mutex`,
"label.subtotalrely":`Subtotale Basi`,
"label.file.library.selectFile2Lib":`Aggiungere file`,
"label.lock.record":`Ci sono( record bloccati`,
"label.multilang.addcustomreporttypestage2.description":`Questa fonte di dati genererà un rapporto su {0}. Scegliendo un oggetto correlato ad esso,
puoi definire quali record correlati in altri oggetti saranno restituiti ai risultati dell'origine dati.`,
"message.duplication.errorinscript.greaterthan10":`Puoi selezionare fino a 10 record da unire.`,
"label.encd":`Display Crittografato`,
"UG.Account.03":`Controllare e unire proattivamente i conti duplicati`,
"label.salescloud.teamrole.main2":`Maggiore`,
"label.email.to":`Destinatario`,
"label.members.sign.notify":`Avvisare il supervisore`,
"template.report.individual.case.priority":`Priorità del caso`,
"vue_label_report_selectfolder":`Seleziona la cartella`,
"label_partner_all":`Tutti i partner cloud`,
"lable.custom.year":`Anni personalizzati`,
"label.ispigeonhole":`Archivio`,
"label.campaignmember.selectmember.steptotal":`Passo 2 di 2`,
"label.userphoto.save":`Salva`,
"label.knowledgebase.published.version.online":`Le versioni pubblicate sono ancora online fino alla pubblicazione di questa bozza.`,
"template.report.customer.level.statistics":`Statistiche a livello di account`,
"label.mobile.phone.day.plan":`Domani`,
"label.icon.95":`Insegnare`,
"label.recordphone":`Registrare una chiamata`,
"lable.currencyManage.unEnabledadvcurrency.discripation":`Disabilitando la gestione avanzata delle valute si interromperà l'uso di tutti i tassi di cambio datati per la tua organizzazione. Le conversioni dei campi di valuta su opportunità, prodotti di opportunità e rapporti associati a questi oggetti non saranno più mappati a un intervallo di date - tutte le conversioni di valuta useranno il tasso di cambio statico.`,
"label.service.gantt.is.candidate":`Candidato di`,
"label.ruleofchecktask":`Regole di convalida dei compiti`,
"label.whole.page.show":`Visualizzazione a pagina intera`,
"label.validate.function.funcFormat.ISNULL":`ISNULL(espressione)`,
"label.ccdocument.template.set":`Funzione di set di modelli`,
"label.icon.103":`Programma`,
"lable.no.products.to.assets":`Nessun prodotto può essere trasferito all'attivo.`,
"label.fristname":`Nome`,
"label.appointmentconfirmail.wizard.subtitle5":`Organizzatore`,
"label.partner.workspace.myspace":`Il mio spazio di lavoro`,
"label.tabpage.optionsz":`Opzioni`,
"component_chatter_link_button_save":`Pubblica`,
"label.validate.function.funcFormat.NOW":`ORA()`,
"label.discountPlanEditor":`Editor di piani di sconto`,
"label.weixin.fmu.pm":`{0} PM`,
"front-gantt-module-milestone-sorting":`Ordinamento delle pietre miliari`,
"label.partnerCloud.maximumNumber":`Il massimo dei siti partner:`,
"label.mobile.place.record.interval.setup":`Intervallo di condivisione della posizione`,
"label.visiblelinenumber":`Linee visibili`,
"front-kefu-moudle-nopower-calluser":`Nessun permesso, si prega di contattare l'amministratore`,
"label.field":`Campi`,
"label.projectManagement.groupbydate":`Gruppo per data`,
"label_vue_create_edit_obj_create_event_dialog_desc_deal_field":`programmato`,
"label.operation.monitoring.history":`Storia del monitor di lavoro`,
"label.data.dataexpalltype.all_desc1":`1. Puoi scegliere se generare automaticamente o inserire manualmente la password del file compresso esportato. La password generata automaticamente verrà inviata alla casella di posta elettronica degli utenti quando i dati vengono esportati con successo. La password inserita manualmente non verrà inviata alla casella di posta, quindi gli utenti devono ricordare la password che hanno inserito. Se non viene inserita, l'impostazione predefinita è nessuna password.`,
"front-web-module-v1-detail-comment-proposal":`In attesa dei vostri preziosi suggerimenti`,
"label_partner_workspace_member_selectedpermission":`Set di permessi selezionato`,
"vue_label_helpcenter_view1":`Nella vista della versione di illuminazione, è possibile visualizzare e gestire in modo intuitivo e flessibile i dati a cui si ha accesso. Attraverso la vista, è possibile realizzare funzioni di base come la visualizzazione della classificazione dei dati, la visualizzazione dei dati in più modi, l'aggiunta, la modifica e l'eliminazione dei dati, e si può anche comodamente visualizzare i rapporti e i grafici per ulteriori analisi dei dati.<br> 1. Gestisci la vista<br> Nel menu a discesa nell'angolo superiore sinistro della vista, seleziona la vista che vuoi visualizzare e seleziona la vista predefinita attraverso le impostazioni fisse. <br> Usa il menu di controllo della vista elenco per creare, modificare, cancellare o ordinare le viste. Allo stesso tempo, usa la funzione di filtro in alto a destra per modificare rapidamente e creare nuove viste. <br> 2. Visualizza i dati attraverso più viste<br> Puoi visualizzare i dati in diversi modi. Nell'angolo in alto a destra, puoi cambiare la lista, Kanban, e split screen per visualizzare i dati. <br>Nella vista elenco, alcuni tipi di campi possono modificare direttamente uno o più dati. Facendo doppio clic sulla cella da modificare o facendo clic sul pulsante di modifica, è possibile modificare direttamente i dati nella finestra pop-up. Per modificare più pezzi di dati, basta selezionare prima più pezzi di dati, e poi selezionare "Applica ai dati selezionati" nella finestra pop-up di modifica. <br> Nella vista elenco, è possibile modificare direttamente la colonna da visualizzare nell'angolo superiore sinistro, fare clic sull'intestazione della tabella per ordinare, o selezionare la colonna da bloccare attraverso la finestra fluttuante a discesa. <br> Dopo aver impostato la vista Kanban, è possibile visualizzare i dati in gruppi, e visualizzare il valore di sintesi di ogni gruppo. Nelle impostazioni della vista Kanban, puoi modificare la base di raggruppamento, la base di riepilogo e il metodo di riepilogo della vista Kanban, e puoi anche selezionare fino a quattro campi da visualizzare. Puoi cambiare rapidamente il raggruppamento dei dati trascinandoli. <br>`,
"component.task.label.priority":`Priorità`,
"label.datamanage.field.error":`Errore nel campo dell'oggetto della query.`,
"label.console.step3":`Passo 3. Seleziona la fonte dell'immagine per la console`,
"label.ems.emailsyncsetup":`Impostazione della sincronizzazione delle e-mail`,
"label_tabpage_placeenterz":`Per favore, inserisci`,
"label.getontocolumn":`Salta a Column:`,
"label.file.down.e":`Il tipo di file corrente non può essere scaricato`,
"vue_label_notificationcenter_unreadonly":`Solo non letto`,
"label.login.access.change":`Cambia`,
"label.globaloperation.operationtype.send_e-mail":`Inviare e-mail`,
"label.dashboard.refresh.hint":`Clicca su Aggiorna per caricare gli ultimi dati nel dashboard. Ci vorrà un po' di tempo per eseguire l'origine dati, sei sicuro di voler aggiornare?`,
"front-kefu-moudle-open-free":`Abilita (prova)`,
"label.lanxin.setting.appsecret":`AppSecret`,
"label.payment.manage.order":`Gestisci il tuo abbonamento`,
"label.chatter.maturiyDate":`Data di scadenza`,
"message.mobilechooseatmostthree":`La scheda per Mobile App può selezionare fino a tre campi.`,
"label.customfields.formula.tip":`Un campo di sola lettura che deriva il suo valore da un'espressione di formula definita dall'utente. Il campo formula viene aggiornato quando uno qualsiasi dei campi sorgente cambia.`,
"lable.PowerProcess.start.time":`Si prega di selezionare l'ora di inizio.`,
"label.mr.title.button.group2":`set di record duplicati, un totale di`,
"label.atlantic.standard.time":`Ora solare atlantica`,
"label.account.LengthofTime":`Durata`,
"label.ccchat.message.search.desc2":`messaggi`,
"label.pigeonhole.desc":`Archiviare l'allegato è valido solo per gli allegati non archiviati.<br/>Una volta che un allegato è archiviato, non sarà cancellato.`,
"label.partnerCloud.orderingPlatform.sure":`L'interruttore {alias} svuoterà il carrello. Sei sicuro di confermare l'operazione?`,
"label.default.value.is.positive.integer":`Il valore predefinito deve essere un intero positivo`,
"label.partnerCloud.selectOne":`Seleziona almeno un menu`,
"label.dashboard.more.condition":`Altre condizioni`,
"component.event.label.enddate":`*Tempo di fine`,
"label.forecast.settings.type":`Tipo di previsione`,
"com.cloudcc.login.error.message.licensenotstart":`La licenza non parte`,
"lable.list.queue":`Code`,
"label.mobile.app.isdisablum":`Disattivare la selezione delle foto dall'album mobile al momento del checkin`,
"label.service.gantt.filter":`Quando si filtra per abilità, solo le risorse con l'abilità selezionata saranno visualizzate sul grafico di Gantt`,
"label.potentialcustomeronline":`Web-to-Lead`,
"label.campaignmember.main.deletecontactdesc":`Rimuovere in massa tutti i contatti da questa campagna`,
"label.list.desc1":`Utilizzando Web to CloudCC, è possibile catturare informazioni di contatto e di profilo dagli utenti e generare automaticamente nuovi lead in CloudCC.com`,
"label.generatepage.title.desc3":`Il nome deve essere unico, e il nome deve iniziare con una lettera, deve contenere solo lettere maiuscole e minuscole, numeri e underscore, e non deve essere più lungo di 30 caratteri.`,
"label.emailtocloudcc.step2total3":`Passo 2 di 3`,
"label.movablemenu":`Pulsanti di attività`,
"label.partnerCloud.partnerAccount.topUp":`In alto`,
"label.data.standobject":`Oggetti standard`,
"label.frequency":`Frequenza`,
"label.schedulejob.setup.schedule.end":`Fine`,
"label.chat.topic.following":`Seguendo`,
"label.martrixreport.2018.step2":`Passo 2 Riassumere le informazioni per:`,
"label.event.moveup.11hour":`11 ore avanti`,
"label.forecast.customforecast.directorcommit":`Impegno dei subordinati diretti`,
"vue_label_homepage_card_view":`Vista della carta`,
"vue_labenl_applauncher_notice_closecertification":`I dati saranno persi dopo lo spegnimento. Sei sicuro di farlo?`,
"component_setup_button_weburl":`Url esterno`,
"label_emailtocloudcc_button_addemailaddress":`Aggiungere una cassetta postale aziendale`,
"vue_label_campaign_added_campaign_members":`Membri della campagna aggiunti con successo`,
"label_tabpage_rtemptyz":`Il tipo di record non può essere vuoto`,
"label.martrixreport.2018.step5":`Passo 5 Seleziona il tipo di grafico e l'elemento da evidenziare`,
"label.moverecord":`Record di trasferimento`,
"pagecreator_layout_label_layoutdesc":`Descrizione del layout`,
"label.knowledge.setting.data.nine":`Sì, voglio cancellare questo gruppo di categorie e le categorie sotto questo gruppo.`,
"label.icon.90":`Persone`,
"label.weixin.micro.research.name":`Nome del microsondaggio`,
"label.ccchat.micropost.allowedit":`Permettere agli utenti di modificare i post e i commenti`,
"vue_label_homepage_fixed_components":`Componente standard`,
"label.version.document":`Biblioteca di documenti`,
"label_assessment":`Valutazione (Opportunità - Importo)`,
"label.appupload.component.type.lookuplayout":`Layout di ricerca`,
"label_chatter_loadmore":`Caricare di più`,
"component_setup_tabs_label_memo":`Imposta il nome dell'etichetta della scheda`,
"label.icon.167":`Bussola`,
"vue_label_chatter_enter_content_sharing":`Inserisci il contenuto della condivisione e il gruppo di condivisione`,
"vue_label_notice_modify_success":`Modificato con successo`,
"label.sharerules":`Regole di condivisione`,
"label.field.api.exists":`Questo campo nome API esiste già.`,
"label.icon.83":`Vernice`,
"label.file":`File`,
"vue_label_report_foldernameisrequired":`Il nome della cartella è richiesto`,
"label.emailobject.wizard.btn2":`Collegato, vai a inviare l'email`,
"label.data.downpage.i_title.num3":`3. Be prima di importare, assicurati di importare tutti i record correlati. Per esempio: se c'è una relazione di ricerca tra gli oggetti che stai importando e i contatti, dovresti importare prima i contatti e poi importare i tuoi dati.`,
"label.email.original.content":`Contenuto di riferimento`,
"vue_label_campaign_add_to_campaign":`Aggiungi alla campagna`,
"label.dashboard.new":`Nuovo cruscotto`,
"label.console.detail":`Dettaglio della console`,
"label.view.desc":`Il campo data può essere uguale a "ieri", "oggi", "domani", "mese scorso", "questo mese", "mese prossimo", "settimana scorsa", "questa settimana", "settimana prossima" o "YYYY-MM-DD、MM/DD/YYYY".`,
"label.emailobject.template.insert.continue":`Continua`,
"label.notification.appointment.overlapEvent":`L'orario selezionato è in fase di programmazione, si prega di selezionare un altro orario.`,
"label.console.step6.top":`Fissa in alto e le liste sono sempre visibili.`,
"label.data.file.the_trigger":`Eseguire l'innesco`,
"message.report.error.operation":`Azione fallita, per favore ripristina il rapporto`,
"vue_label_helpcenter_detail3":`<br>   Liking e unliking<br>   Puoi mettere un like a un commento su un micro-post o solo su un micro-post. Dopo il mi piace, è possibile visualizzare il numero di mi piace per il post, e si può anche unlike. <br>? Modificare e cancellare i post<br>    L'editore di un post può ri-modificare o cancellare il post. <br>    Passo 1: Clicca il pulsante a destra del post e seleziona Modifica o Elimina nella casella a discesa<br>    Passo 2: Apri il pop-up Modifica/OK per eliminare<br>    Passo 3: Clicca Salva/OK per completare l'operazione<br>5. Storia di approvazione<br>? Invia per approvazione<br>    Il pulsante "Invia per approvazione" appare quando viene creato un nuovo record, una richiesta di approvazione viene richiamata, o un'approvazione viene infine negata. <br>    Passo 1: Clicca su "Invia per approvazione". Il sistema determina se il record e il presentatore soddisfano le condizioni del progetto e del presentatore iniziale stabilite dal processo di approvazione, e se tutte queste condizioni sono soddisfatte, l'invio ha successo. <br>    Se il passo successivo nella configurazione del processo di approvazione richiede la selezione manuale dell'approvatore, allora il passo 2 viene eseguito dopo "Invia per approvazione".<br>   Passo 2: Seleziona il prossimo approvatore e completa l'operazione di invio. <br>? Storia di approvazione<br>    A. Prima di inviare:<br>    Clicca su "Anteprima del processo di approvazione", il sistema determina se il record e l'operatore che invia soddisfano le voci impostate nel processo di approvazione e quindi se tutte queste condizioni sono soddisfatte, viene visualizzato il processo di approvazione. <br>    B. Dopo l'invio:<br>   Nella cronologia di approvazione è possibile non solo visualizzare le fasi della cronologia di approvazione e lo stato attuale di approvazione del record, ma anche l'anteprima del prossimo processo di approvazione. <br>? Ritira le richieste di approvazione<br>    Se questo processo di approvazione è impostato per ritirare le richieste di approvazione, esse possono essere ritirate in qualsiasi momento dopo averle inviate. <br>    Passo 1: Clicca "Richiama la richiesta di approvazione" nella pagina dei dettagli del record <br>    Passo 2: Apri la pagina della richiesta di approvazione ritirata e clicca "Richiama la richiesta di approvazione" per completare l'operazione`,
"Opportunity_Detailed_Phase_Label_004":`giorno/i`,
"PageLayout_Search_MultiSearch_001":`Seleziona fino a 3 campi.`,
"vue_label_systemSettings_set_business":`Impostate il layout e i campi degli oggetti in base alla vostra attività.`,
"label.compact.layout.frame.select":`Seleziona una cornice per l'impaginazione`,
"label.tabpage.rolez":`Ruolo`,
"label.weixin.appr.currentauditor":`Assegnato a`,
"label.knowledgebase.verification.status":`Stato di verifica`,
"UG_Case_05":`Creare un caso`,
"label.service.marking.completed":`Segna come completato`,
"label.notification.ccchat1":`【发出@的用户名】 ti ha menzionato.`,
"label.knowledgebase.no.action.available":`Nessuna azione disponibile`,
"label.tabpage.newlybuildz":`Nuovo`,
"label.appupload.install.error.choice2":`Rinominare i componenti locali che sono in conflitto con il pacchetto`,
"label_tabpage_as":`Come`,
"Opportunity.Detailed.Phase.Label.Popup.001":`Data di inizio della fase attuale`,
"vue_label_homepage_singlepage":`Aggiungere fino a 10 componenti a una singola pagina`,
"font-evaluate-module-v1-fair-and-bad":`Quando il tipo di valutazione è Neutro e Negativo`,
"label.partnerCloud.orderingPlatform.orderInformation":`Conferma dell'ordine`,
"label.custom.lead.conversion.notice":`Convertire lead promemoria`,
"label.re.upload":`Re-upload`,
"label.knowledgebase.top.window":`Finestra superiore`,
"label.h5.allmarkedasread":`Tutti segnati come letti`,
"vue_label_SMS_open_record_from_start_activation":`Aprire il record dalla lista da attivare.`,
"label.customer.tab.step2":`Passo 2 Aggiungere ai profili`,
"label.campaign.channel.input.owner.select2":`Persona di sollecitazione di questo canale di marketing`,
"component.task.button.save":`Salva`,
"front-kefu-moudle-v1-phone-type":`Tipo di telefono`,
"label.wedge-shapearrows":`Freccia di coda a cuneo`,
"vue_label_homepage_todaysevent":`Eventi di oggi`,
"label.data.exp.way.sel":`Selezionare la modalità di esportazione`,
"label.setting.intergrationlist.status1":`Questa integrazione non è attualmente installata.`,
"button_partner_workspace_disable":`Annullare l'attivazione`,
"label.customfields.reference":`Può essere referenziato da altri campi come formule, picklist, campi di ricerca e così via.`,
"label.publicgroups.new":`Nuovo Gruppo Pubilc`,
"label.data.setok.e_desc3":`， scaricare i dati esportati.`,
"vue_label_commonobjects_view_chart_countmode":`Modalità di conteggio`,
"label.service.appointmentList.earliest.allowedStart":`Prima data di inizio`,
"label.data.choses.e.desc":`Secondo le vostre esigenze, potete esportare tutti i dati o esportare i dati di un oggetto.`,
"label.multilang.common.fieldlist.fieldremark":`Applica ai campi che appaiono nella pagina {0}`,
"label.umeng.activity.event":`evento`,
"label.project.hit.ten":`Promemoria dell'aggiornamento della questione`,
"label.c_d_least":`Ogni record "C" deve avere almeno un record "D" correlato.`,
"label.emailobject.wizard.btn1":`Collega la tua email`,
"lable.product.pricebooks.info":`Dettagli del libro dei prezzi`,
"component_telerecord_label_message":`Commento`,
"lable.total.of.estimates":`0 stime in totale`,
"label.stdashbord.xsld.business.oppcounts":`Quantità di opportunità`,
"vue_label_commonobject_duplicatewith":`Duplicare {1} in {0}`,
"label.setpicandreport":`Impostazioni del grafico`,
"label.category.2":`Generale`,
"label.emailtocloudcc.reauthorization":`Reauthorization`,
"label.chatter.vote":`Sondaggio`,
"label_emailtocloudcc_edit":`Modifica`,
"label.pleaseinput":`Ingresso`,
"vue_label_homepage_user_particular_application":`La homepage quando l'utente usa una particolare applicazione, le assegnazioni sovrascriveranno la homepage standard`,
"label.allianceID":`ID dell'agenzia`,
"label.h5.homepage.cannot.applied.mobile.terminal":`La homepage del profilo non è configurata per questo profilo. Non è disponibile per Mobile App`,
"label.appointmentpage.wizard.notif2":`Il nome è obbligatorio!`,
"label_emailsync_status_email":`Azione eseguita Email`,
"label.icon.179":`Persone`,
"UG_Contract_03":`Creare un contratto`,
"label.cy.new":`Nuova valuta`,
"label.version.setup.controllist":`Lista di controllo di Setup`,
"label.vlidaterule":`Regole di convalida`,
"label.customer.tab.name":`Nome della scheda`,
"label.recentview.seloption1":`Visti di recente`,
"vue_label_report_notice_nameisrequired":`Il nome del rapporto è richiesto`,
"label.createapproveprocessstep":`<li>1.Leggere gli argomenti della guida</li><li>2.Creare modelli email</li><li>3.Creare modelli SMS</li><li>4.Creare un processo di approvazione utilizzando la procedura guidata Jump Start o Standard</li><li>5.Aggiungere la lista correlata "Storia di approvazione" a tutti i layout di pagina</li><li>6.Attivare il processo per distribuirlo ai vostri utenti</li>`,
"label.gotocalendar":`Vai al calendario`,
"label.import.page1.pleaseselectobj":`Seleziona prima l'oggetto`,
"label_tabpage_messagez":`Si prega di inserire un commento`,
"vue_label_homepage_profilepage":`Pagina iniziale del profilo`,
"label.tabpage.choose":`Seleziona`,
"label.campaignmember.setup.lead.field":`Campi di piste`,
"label.setalipay.null":`Le informazioni richieste per la configurazione di Alipay sono vuote.`,
"label.custom.Current.and.NextCQ":`CQ attuale e prossimo`,
"label.knowledgebase.needto.publish.articles":`Resotre articolo archiviato creerà una versione draft. Vuoi pubblicare l'articolo?`,
"pagecreator.layout.message.save.success":`Layout salvato con successo`,
"homepage.componet.approval.label":`Punti da approvare`,
"label.last_submission":`Ultimo tempo inviato`,
"lable.outlook.detail.prefo":`Lo scambio vince sempre`,
"label.projectManagement.new.subtask":`Nuovo sottocompito`,
"label.service.appointmentList.checkThe":`Controllato`,
"message.error.searchlayoutselectdefields":`Non può essere cancellato e deve essere il primo campo nel layout di ricerca.`,
"label.ems.normal":`Normale`,
"vue_label_notice_pleaseselectobject":`Seleziona un oggetto`,
"component.sendmail.button.send":`Invia`,
"label.relevant.records":`Registri correlati`,
"label.weixin.login.CloudCC":`Accedi`,
"label.tag.addtags.private":`Privato`,
"label.appointment.disable.remark":`Siamo spiacenti, la funzione è attualmente disabilitata. Se vuoi riprogrammare o cancellare la riunione, contatta il responsabile al {邮箱地址}`,
"label.campaignmember.main.addMember1":`Aggiungere membri`,
"message.error.objectnofound":`Oggetto indefinito`,
"label.employeenum":`Numero del dipendente`,
"label.search.applyfilter":`Applicare il filtro`,
"label.version.history.track.nonsupport":`Solo la versione infinita supporta la funzione di cronologia di tracciamento dei campi.`,
"label.ccpeak.direction.for.use.time":`Istruzioni per le classi programmate [Versione 2.0]`,
"label.ems.settings":`Impostazioni`,
"label_tabpage_arecordtypez":`Tipo di record disponibile`,
"vue_label_pool_assign1":`{1}{2}`,
"label.customcomponent.direction.for.use":`Istruzioni per i componenti personalizzati [ versione 2.0]`,
"label.appupload.appname":`Nome del pacchetto`,
"label.cpq.order.status.no.active":`Solo gli ordini con stato attivo possono generare contratti`,
"label.dashboard.maxlength":`Si possono inserire fino a 255 caratteri`,
"label.customize.memory.function.sorting.title2":`Memoria dell'ordinamento dell'intestazione`,
"label.report.chose.obj":`selezionare la relazione oggetto e l'origine dati del rapporto`,
"label.partner.step3":`Passo 3 Informazioni di base`,
"message.report.type.error.fail":`Origine dati del rapporto non valida.`,
"pagecreator.page.message.publish.fail":`Pubblicazione della pagina non riuscita`,
"label.minimun":`Minimo`,
"label.state":`Stato`,
"label.customcomponent.referencetype":`Tipo di riferimento`,
"label.nameandemailtemplate":`Inserisci un nome per il tuo processo nella casella sottostante e poi seleziona un modello di email per notificare l'approvatore (opzionale).`,
"label.customobjects.track.introduce":`Questa pagina ti permette di selezionare i campi che vuoi tracciare sul`,
"label.campaign.matchway.label":`Metodo di abbinamento`,
"label.redistribution":`Riassegnare`,
"label.groupmanage":`Gestione dell'organizzazione`,
"label.icon.157":`Macchina fotografica`,
"label.quickbooks.viewlist.total":`TOTALE`,
"label.file.copy.file.fail":`Copia non riuscita, per favore copiare manualmente`,
"label.outline.selectfield":`Campi selezionati in sintesi:`,
"label.datetime.maxsize":`Il ciclo di una domanda non può essere più lungo di tre mesi.`,
"label.dashboard.CustomDashboardMyHomePage":`Personalizzare le dashboard della mia homepage`,
"label.data.customobject":`Oggetti personalizzati`,
"vue_label_SMS_noselected":`Nessun record selezionato`,
"label_tabpage_value":`Valore`,
"label.quote.qianming":`Firma`,
"label.view.source":`Visualizza il codice sorgente`,
"label_popup_infoz":`Prompt`,
"label.emailtocloudcc.redmessage8":`Errore di parametro, si prega di contattare l'amministratore.`,
"label.tianyancha.Search.business":`Cerca informazioni sulla registrazione delle imprese`,
"vue_label_systemSettings_server":`Servizio`,
"vue_label_homepage_dashboard_components":`Componente del cruscotto`,
"label.search.listview":`Vista elenco`,
"label.service.gantt.distribution.success":`Assegnato con successo`,
"label.icon.4":`Portafoglio`,
"label.partnerCloud.orderingPlatform.calculate":`Calcola il prezzo`,
"label.forecast.edittotal.ycyx":`Previsione Priorità`,
"vue_label_commonobjects_detail_to_precise_search":`Ricerca accurata`,
"label.order.number":`Ordina`,
"setup.mainpage.label.welcome7":`Istruzioni: Fare clic sul menu sul lato sinistro della pagina → Impostazioni applicazione → Crea → Oggetto → Nome oggetto → Campo personalizzato.`,
"label.weixin.user.binding":`Legame con l'utente`,
"label.custom.canvas.size":`Dimensione della tela`,
"label.projectManagement.recent.projects":`Progetto recente`,
"vue_label_helpcenter_lead":`Traccia e gestisci i tuoi lead attraverso Cloud CC. Usa le regole configurate per assegnare un punteggio ai lead e convertirli in clienti, contatti e corrispondenti opportunità commerciali al momento giusto.<br>Punteggio<br> Nell'angolo in alto a destra della vista, usa il pulsante di assegnazione del punteggio per assegnare un punteggio ai lead nella vista.<br>Distribuzione<br> Quando crei o modifichi un lead, seleziona Assegna in fondo alla pagina per assegnare il lead al personale corrispondente per l'elaborazione secondo le regole esistenti.<br> Conversione<br> Al momento giusto, puoi convertire i lead in clienti e contatti cliccando il pulsante di conversione nell'angolo in alto a destra della pagina dei dettagli. Allo stesso tempo, puoi creare opportunità di business e compiti corrispondenti per facilitare il follow-up continuo delle opportunità di transazione.`,
"label.enabledprocess":`Processi di approvazione attivi`,
"label.emailobject.noemail":`Non c'è ancora posta, vai e mandane una!`,
"label.validate.remark3":`Determinare se un campo è richiesto in base al valore di un altro campo`,
"vue_label_salesadvance_retention":`Ritenzione`,
"label.product.managep":`Gestire i prezzi dei libri`,
"font-evaluate-module-v1-not-report":`Non riaprire`,
"label.emailmerge.mergepage.step1":`1.Scegliere i record da unire:`,
"front-epwechat-module-v1-epwechat-describe":`CloudCC fornisce l'integrazione con WeCom, combinando le potenti caratteristiche di WeCom con la versione leggera H5 del sistema CloudCC,<br /> aiutandoti a gestire comodamente le relazioni con i clienti, a gestire il traffico del dominio privato e a migliorare le entrate aziendali.`,
"label.partner.template.detailimage":`Immagine`,
"label.recycle.clearall":`Svuota il cestino della tua organizzazione`,
"chatter.error.nottype":`Errore: Tipo di file non valido, si prega di utilizzare file JPG, GIF o PNG.`,
"pagecreator.button.cancel":`Cancella`,
"front-market-form-quired-ziduan":`Campi richiesti nella pagina di registrazione`,
"vue_label_report_columnname":`Nome della colonna`,
"message.notdelete.type":`Non potete cancellare questo tipo di record, perché i profili seguenti usano questo tipo di record come valore predefinito.`,
"label.ccpeak.folder.all.time":`Tutte le cartelle di classe programmate`,
"label.quickbooks.searchlist.total3":`Ci sono {0} stime non collegate per un valore totale di {1}`,
"label.forecast.detailforecast.quantity":`Previsione della quantità`,
"label.knowledge.language.british":`Britannico`,
"label.vlidaterule.example.messagelocation":`Questo messaggio di errore può apparire all'inizio della pagina o sotto un campo specifico della pagina`,
"front-kefu-moudle-chf-success":`Dividere con successo`,
"vue_label_jihui_yi":`Opportunità 1`,
"label.import.step1.null":`Nessuna opzione disponibile`,
"label.console.step5.tab.subtab":`Come sottotabella di`,
"batch.edit.permission":`Nessun permesso di modifica`,
"label.weixin.fmu.before.min":`{0} minuti prima del previsto`,
"chatter.up.file":`Il caricamento dei file richiede del tempo, a seconda della dimensione del file caricato, si prega di attendere.`,
"setup.layout.group.field":`Campi`,
"label.chat.unlike":`Piaciuto`,
"vue_label_dashboard_updatefrequency":`Frequenza di aggiornamento`,
"label.trigger.folder.new":`Pagine di trigger: Nuova cartella`,
"label.process.des.app":`Clicca sul link di destra per visualizzare i dettagli del record corrente.`,
"vue_label_pool_assignselect":`Scegliere di assegnare i membri`,
"label.lookup.user":`Cerca colleghi`,
"label.mobilescreentablayoutedit.remark2":`Seleziona i campi filtro visualizzati nella pagina iniziale della scheda nella Mobile App.`,
"label.data.exp.objtemp":`Creerete il modello per esportare i dati di questo oggetto come segue cretira`,
"label.weixin.moreselect.error":`Solo 10 record che puoi selezionare`,
"label.icon.25":`Fasciatura`,
"lable.sample.text":`Testo campione`,
"label.most.setup.obj":`Si possono impostare fino a 10 oggetti.`,
"label.weixin.coming":`Arriva`,
"label.editdescription":`Nota Modifica`,
"label.multipleactivity.multiple":`Utenti multipli`,
"label.sso.saml.idp.entityid":`ID dell'entità`,
"label.SMS.pho.filed":`Campo telefonico`,
"message.serviceabsence.violation":`Violazione del periodo di assegnazione: è in conflitto con il registro delle assenze.`,
"label.forecast.settings.type.clist":`Utilizzare le famiglie di prodotti`,
"label.state.noend":`Incompleto`,
"label.sourcetemp":`Fonte`,
"vue_label_chatter_name_link":`Si prega di compilare il nome e il link`,
"label.emailobject.attach":`Allegare`,
"label.everyother":`Ogni altro`,
"label.title":`CloudCC.com`,
"vue_label_chat_haventactivate":`Non hai ancora attivato un account di chat. Vuoi attivarlo ora?`,
"pagecreator_layout_button_delete":`Cancellare il layout`,
"label.transfer.temporarily":`Chiama`,
"label.service.dispatchingUnits.search.services":`Ricerca Appuntamento di servizio`,
"customer.message.fail.chat":`Impossibile ottenere i record dei messaggi, contattare l'amministratore per aiuto`,
"label.apiname.toolong":`Il nome dell'API è troppo lungo.`,
"label.empty.filter":`Cancella i filtri`,
"label_tabpage_personalCenterz":`Centro personale`,
"label.minutes":`Minuto`,
"label.multipleactivity.atasks":`Compiti`,
"label_tabpage_deleteview":`Cancellare la vista`,
"pagecreator_layout_message_save_success":`Layout salvato con successo`,
"label.reportlineorder":`Ordine delle colonne del rapporto`,
"label.total.forecast.have.priority":`any previsione è precedente, ma i tutti che accettano altri sottopremi è precedente`,
"label.custom.quarter.subtitle":`Quartiere personalizzato`,
"label.icon.79":`Stampa`,
"label.hiddenoperate":`Nascondere le azioni`,
"label.project.hit.six":`Avviso di assegnazione del compito`,
"label.visualpageaction.errordesc":`Non hai il permesso di escludere l'operazione che hai richiesto. Contatta il proprietario del record o il tuo amministratore.`,
"label.chat.unmute":`Annullare "non distruggere"`,
"label.zhaiyao":`Abstract`,
"vue_label_commonobjects_detail_bcc":`Bcc`,
"label.customcomponent.page.index.table.version":`Versione API`,
"UG.quota.06":`Creare un preventivo`,
"label.icon.152":`Robot`,
"label.partnerCloud.partnerAccount.account":`Nome utente`,
"label.file.sharewith":`Sharer`,
"label.data.dataexptemplate.desc2":`2. Il formato di compressione è diviso in due tipi: uno è quello di generare automaticamente la password del file compresso, l'altro è quello di inserire manualmente la password del file compresso.`,
"vue_label_dashboard_newfoldersuccessfully":`Creare una nuova cartella con successo`,
"label.campaignmember.main.importmember":`Membri della campagna di importazione di massa`,
"label.htyj.completed":`Completato`,
"label.reportTypeLabel":`Etichetta del tipo di rapporto`,
"label.customer.tab.label":`Etichetta della scheda`,
"label.dashboard.component":`Componenti`,
"label.safetystatement.dialog":`Dichiarazione di sicurezza (Nuova finestra)`,
"label.forecast.settings.data":`Data di previsione`,
"label.knowledgebase.modifiedby":`Modificato da`,
"label.batchadd.remark":`Aggiungere più record`,
"button.partner.delete":`Cancellare`,
"Pagelayout_Setup_005":`Il nome deve essere messo al primo posto.`,
"label.forecast.edit.wcpxl":`Nessuna famiglia di prodotti`,
"lable.PowerProcess.seq.input":`Si prega di inserire un ordine.`,
"pagecreator.layout.message.delete.fail":`Eliminazione del layout non riuscita`,
"label.emailobject.edit":`EDIT`,
"label.weixin.million":`Diecimila yuan`,
"setup.mainpage.button.manageobject":`Gestione degli oggetti`,
"label.weixin.participants.perfect.information":`I partecipanti sono tenuti a migliorare le informazioni`,
"vue_label_campaign_campaign_members":`Aggiungere membri della campagna`,
"label.ccchat.person.invite.emplaceholder":`Inserisci gli indirizzi e-mail e separali con il punto e virgola`,
"label.mobile.phone.new":`Nuovo`,
"font-evaluate-module-v1-small-program-evaluation-settings":`Setup di valutazione del miniprogramma`,
"UG.opportunity.005":`Processo di vendita multiplo`,
"vue_label_report_polymerization":`Aggregato`,
"label.multilang.lookfiltercondition.fieldtypenotmate":`La condizione della linea {0} non è corretta, il tipo di campo non corrisponde!`,
"label.knowledgebase.delete.draft":`Cancellare la bozza?`,
"label.mr.descreption.condition3":`Regola-exact match: controlla questa voce e trova i record duplicati dagli stessi caratteri del campo. Se controllato, trova i duplicati in base ai primi caratteri.`,
"Lead.Auto.Scoring.Setting":`Impostazione del punteggio del piombo`,
"label.marketing.channel.default":`Canale di marketing (abilitato per impostazione predefinita)`,
"front-project-module-v1-select-projecttemplate":`Seleziona il modello di progetto`,
"front-email-payment-select-area":`Inserisci il distretto`,
"lable.PowerProcess.message":`Informazioni sul processo di abilitazione`,
"label.weixin.free.get.captcha":`Ottieni il codice di verifica gratis`,
"label.projectManagement.please.select.task.or.question":`Si prega di selezionare l'attività/il problema`,
"label.pacific.daylight.time":`Ora solare del Pacifico`,
"label.sendsms.batch.step1.introduce":`Seleziona una delle seguenti viste (che contiene i destinatari di questo SMS)`,
"label.same.analyze.account.name":`Nome del conto`,
"Homepage.Contract.FieldMissed.DoesntSupport":`Non ci sono campi "qdrq" e "htje" nell'oggetto contratto, quindi i dati non possono essere mostrati.`,
"label.partnerCloud.orderingPlatform.noProduct":`Non è richiesta alcuna configurazione dell'opzione di questo prodotto.`,
"label.totalsummary":`Riassunto del roll-up`,
"label.partner.workspace.tab":`Scheda`,
"label.entitlement.process.name.unique":`Questo nome esiste già. Per favore, inseriscilo di nuovo.`,
"report.label.norole":`Non hai il permesso di farlo, per favore contatta il tuo amministratore.`,
"label.password.old.error":`La vecchia password non è corretta, per favore inseriscila di nuovo.`,
"lable.account.quarter.stadate":`Giorno di inizio del trimestre fiscale`,
"label.salescloud.contactrole.choose.correct":`Contatti duplicati selezionati, si prega di correggere.`,
"label.schedulejob.setup.schedule.day":`Giorno`,
"label.communalusergroup":`Gruppi pubblici`,
"label.Display.Fields":`Campi visualizzati sulla lista di servizio Apoointment`,
"label.marketsea":`Piscina`,
"label_partner_setup_address":`Indirizzo della nuvola del partner`,
"label.industrialandcommercialverification.label.url":`URL`,
"lable.data.exp.newtemp":`Esportazione di dati e creazione di modelli`,
"label.pc.ui.2018":`Verticale`,
"label.version.free":`Edizione gratuita`,
"label.dataimport.contact.length":`Errore: la lunghezza del nome del contatto è troppo lunga`,
"label.cy.vlidate":`L'azione di valuta abilitata è irreversibile. Sei sicuro di voler abilitare la gestione della valuta?`,
"label.recycle.all":`Tutti i cestini per il riciclaggio`,
"label.message.changeaccount.isnot":`Il contatto ha abilitato partneruser, non può cambiare account`,
"label.searchlayout.exactsearch":` Suggerimento: Seleziona la casella di controllo dietro il campo di ricerca per eseguire una ricerca esatta per quel campo`,
"label.file.size.limit":`Nota: la dimensione massima del file è di 10M.`,
"label.mobileapp.modelsetting1":`Impostazioni del modulo standard mobile`,
"template.report.overall.sales.opportunities":`Periodo complessivo delle vendite (per tipo di opportunità)`,
"label.password.update.success":`Password cambiata con successo.`,
"label.import.page3.gobackhome":`Torna a casa`,
"label.phone":`Telefono`,
"label.detail.vlidaterule":`Visualizza le regole di convalida`,
"label.weixin.input.usernames":`Inserisci il tuo nome utente`,
"label.icon.85":`Trasformatore`,
"vue_label_systemSettings_partner":`Partner`,
"label.processsetting.new.process":`Nuovo processo`,
"Lead_Scoring_Setting_Rule_Setup_01":`Elenco di regole per il punteggio del piombo`,
"setup.layout.component.area":`Area`,
"label.createnewpwdinformuser":`Generare una nuova password e notificarla immediatamente all'utente`,
"label.pwinfo":`Dettagli della password`,
"label.imgfield.type.url":`Immagine di riferimento`,
"label.attendance.sxccheckincy":`Check-In dei membri della campagna`,
"lable.PowerProcess.condition.input":`Si prega di selezionare la condizione.`,
"label.partnerCloud.partnerAccount.topUpFailure":`Ricarica saldata`,
"label.document.size.too.long":`Dimensione del documento superata`,
"label.link":`Link di accesso`,
"label.partnerproduct.sort.repeat":`Il nome della famiglia di prodotti è preso.`,
"label.data.setok.e_desc2":`Esportazione della pagina dell'elenco dei dati`,
"front-project-module-v1-plase-input-project-name":`Inserisci il nome del progetto`,
"label.export":`Esportazione`,
"label.icon.45":`Caldaia`,
"label.autoRegister.changepwd.title":`Imposta la tua password di accesso`,
"label_clear_adjust":`Regolazione chiara`,
"front-kefu-moudle-return-visit":`Recensire`,
"label.ems.compose":`Comporre`,
"Pagelayout_Setup_002":`Hai selezionato 3 liste correlate, e l'aggiunta di altre liste correlate influenzerà il layout della pagina.`,
"label.service.gantt.skill.screening":`Usa il filtro delle abilità`,
"label.partnerCloud.basicSetting.enable":`Il Partner Cloud sarà disattivato. Le azioni di accesso e modifica nella tua organizzazione saranno disattivate automaticamente dal sistema.`,
"label.workbanch.setup.description":`Puoi impostare le seguenti visualizzazioni da mostrare in My Workbanch.`,
"label.category.1":`Tutti`,
"label.foldername":`Nome della cartella`,
"label.forecast.settings.shuliang":`Quantità`,
"label.emailmerge.newtemplate.word":`Si prega di caricare documenti Microsoft Word.`,
"message.error.type":`non può essere vuoto, è necessario passare il tipo public public o personnel private!`,
"label.manualallocation":`Assegnare manualmente`,
"label.addattachment.step2":`Passo 3 Fare clic su Upload File per caricare il file`,
"label.company":`Azienda`,
"label_emailsync_status_export":`Esportazione come file in formato Excel_csv`,
"label.eventreminder":`Promemoria dell'evento`,
"label.emailtemplate.lookup":`Visualizza i modelli di e-mail`,
"label.customsetting.touse.getCustomSetting":`Interrogare il tipo di "gerarchia" delle impostazioni personalizzate, restituire l'apiName e le autorizzazioni corrispondenti (l'ID è l'ID del profilo o l'ID utente), Map map = cs.getCustomSetting(String apiName, String id);`,
"label.projectManagement.Resourceuse":`Uso delle risorse`,
"label.appointment.wizard.subtitle4":`Impostazioni di buffer e tempo`,
"label.donot.close.your.browser":`Durante questo processo, per favore non cliccare su un altro link e non chiudere il tuo browser.`,
"label.multilang.customforcast.target":`Obiettivo di {0}：`,
"setup_layout_label_newarea":`Nuova area`,
"component.timeline.button.more":`Altri passi`,
"label.appointmentdetail.wizard.title3":`Durata`,
"label.help.new.features.pc":`Guida all'uso delle nuove caratteristiche del lato Pc`,
"label.mr.record":`Record`,
"label.trigger.wgd":`Trigger non compilati`,
"label.icon.72":`Cassetta degli attrezzi`,
"setup.layout.label.detailpage":`Pagina di dettaglio`,
"frame.personinfo.label.usethisimage":`Useremo variazioni di questa immagine in miniatura in tutta l'applicazione.`,
"label.multilingual.confirm.open":`Sei sicuro di abilitare? Il multilingue può essere usato dopo l'abilitazione.`,
"label.recordcreater":`Creato da`,
"label.afterfinish":`Quando hai finito, clicca su Salva`,
"label.companyinformation":`Informazioni sull'azienda`,
"step1":`Passo 1`,
"label.sales.page.dashboard.add":`Aggiungi ai cruscotti della homepage`,
"label.processsetting.process.enabled.failed":`Fallita la cancellazione del processo!`,
"label.document.history.date":`Data`,
"label.linkedin.title":`LinkedIn-H5MiniApp`,
"label.foldervisitlimit1":`Tutti gli utenti possono accedere a questa cartella`,
"april":`Aprile`,
"label_emailsync_form_disconnect":`Cancella Conncet`,
"label.appointment.wizard.subtitle4-2-6":`2 giorni`,
"vue_label_notice_follow_success":`Seguito da`,
"label.startuploadfile.success":`Quando clicchi su "Start Upload", se la barra di avanzamento raggiunge il 100%, il file viene caricato con successo e scompare nell'area superiore.`,
"message.accesstoken.acquisition.failed":`Impossibile ottenere il token di accesso!`,
"label.quickbooks.fieldlabel.fistname":`Nome`,
"label.appointment.wizard.subtitle1-5":`1 h`,
"2018UI.Homepage.DataNoAccess.Info":`Non hai il permesso di visualizzare questo record, clicca per tornare al passo precedente.`,
"label.batchaddattachments":`Aggiunta di massa dell'allegato`,
"label.ems.next":`Prossimo`,
"label.quote.zhekou":`Sconto`,
"lable.product.notdel":`Perché è ancora nel manuale con altri record del libro dei prezzi.I record correlati sono i seguenti.`,
"label.ems.action":`Azione`,
"message.error.chart.type":`I tipi di grafico non possono essere vuoti.`,
"label.conditiontag.lookup.value":`Valore`,
"label.chatter.allactivity":`Tutte le attività`,
"label.summaryreport":`Rapporti riassuntivi`,
"label.textmessage.vonage.action":`Azione`,
"label.ccpeak.must.result":`Deve usare as seguito da alias per recuperare dal risultato`,
"label.data.newtemplate.savetemp.desc":`Inserisci il nome e la descrizione del modello con attenzione per facilitare il tuo utilizzo.`,
"label.projectManagement.search.for.users":`Cerca per utente`,
"component.milestones.label.title":`Pietra miliare`,
"vue_label_applauncher_description_accountpool":`Usate l'Account Pool per gestire comodamente lo stato di follow-up all'interno dell'organizzazione e motivare il personale a completare la transazione.`,
"label.import.index.startimport":`Iniziare l'importazione`,
"page.field.masterinput2":`Ingresso Master-Detail`,
"label.mobile.change.owner.permission":`Il nuovo proprietario deve avere i permessi di "lettura" su questo tipo di record.`,
"label_partner_common_enable":`Abilitare il cloud dei partner`,
"label.log.browser":`Browser`,
"label.app.step4":`Passo 4 Scegliere le schede`,
"lable.quote.syncing.opportunity":`Opportunità`,
"label.forecast.customforecast.foredis.jqz":`Valore esatto`,
"label.forecast.forecastroleuserpage.title":`Assegnazione del manager delle previsioni`,
"label.starting.quarter":`Quartiere di partenza`,
"label-combination-record":`Record {index}`,
"label.here":`qui`,
"label.weixin.underfind.error":`Errore sconosciuto`,
"label.cloudccclass.list.tip.time":`Permettere agli sviluppatori di sviluppare classi programmate sulla piattaforma CloudCC.com, che possono essere utilizzate per programmi programmati.`,
"label.data.setok.t_desc1":`Se avete bisogno di usare questo modello di dati derivati, cliccate su`,
"label.service.gantt.break.rules":`Violazione delle regole`,
"label.weixin.no.pending.ywjh.qin":`Nessuna opportunità per i prossimi 30 giorni`,
"label.view.atleastone":`La lista non può essere vuota.`,
"label.attendance.sxccheckin":`Partecipazione alla campagna`,
"label.custom.split":`Split`,
"front-kefu-moudle-v1-yesorno-delete-templete":`Sei sicuro di voler cancellare questo modello?`,
"label_chatter_theme":`Argomenti`,
"label.partner.new.step1":`Passo 1 Scegliere il modello che ti piace`,
"vue_label_commonobjects_view_settings":`Impostazioni della vista Kanban`,
"UG_Contract_02":`Il contratto è un accordo scritto tra le parti. Molte aziende usano i contratti per definire i termini per fare affari con altre aziende. Usa CloudCC per stabilire e documentare i tuoi contratti esistenti con i tuoi clienti e le tue opportunità commerciali. Traccia il contratto attraverso il processo di approvazione. Usa i promemoria del flusso di lavoro per ricordarti il rinnovo del contratto.`,
"label.setup.mobilesetup.isenableh5newandedit":`Abilita il nuovo e la modifica di H5 nella tua applicazione mobile.`,
"label.attendance.edit":`Modifica delle presenze`,
"label.service.miniProgram.fillImageLink":`Si prega di compilare il link del carosello.`,
"label.b.c.without":`I record B possono avere o meno record "C" correlati.`,
"label.sso.key":`Codice di autorizzazione`,
"label.star_click":`Clicca per cancellare`,
"vue_label_SMS_name_or_phone_number_lookup":`ricerca del nome del record`,
"label.case.copre.text":`Puoi anche scaricare un codice QR per il portale web dedicato alla tua azienda e metterlo sul tuo sito web o dispositivo, quindi i clienti possono scansionare il codice QR per utilizzare la versione web del portale clienti.`,
"label.salescloud.forbidden.confirm":`Sei sicuro di voler disabilitare le squadre di opportunità?`,
"vue_label_chat_conformactivation":`Confermare l'attivazione`,
"label.emailtocloudcc.redmessage9":`Errore del database, si prega di contattare l'amministratore.`,
"label.sahreto":`Condividi con`,
"label.recordtype.sort":`I tipi di record sono visualizzati nell'ordine in cui sono stati salvati.`,
"label.allreport":`Tutti i rapporti`,
"front-gantt-module-drag-and-drop-subtask":`Trascinare (metterlo in un compito) per farlo diventare un sottocompito!`,
"label.permission.objlist.nopermission":`Nessun accesso`,
"label_file_num":`Quantità`,
"chatter.mostword":`Il tuo commento supera le 500 parole, per favore cancella e reinserisci.`,
"label.h5.chatter.comment":`Commento sul corpo`,
"vue_label_calendar_notice_havecreated":`Hai creato un calendario`,
"label.tabpage.loadz":`Pagina in caricamento, attendere prego...`,
"chatter.w.p":`Telefono di lavoro`,
"label.chat.topic.name.desc":`Puoi solo cambiare le maiuscole e la spaziatura dei nomi degli argomenti.`,
"label_partner_template_name":`Nome del modello`,
"label.mobile.phone.required.examines.people":`Il Revised By è richiesto.`,
"message.error.view.notexists":`View does not exist.</br> Oppure la vista potrebbe essere stata modificata da qualcun altro, clicca <a href='javascript:history.back();'> qui </a>per tornare indietro.`,
"label.custom_time":`Tempo personalizzato`,
"label_partner_workspace_member_all":`Tutti`,
"lable.custom.year.name":`Nome dell'anno personalizzato`,
"label.account.previous.M":`Ultimo mese`,
"vue_label_commonobjects_detail_locking":`Blocca`,
"label.brief.lead":`Porta`,
"label.linkedin.setting.appsecret":`Password della chiave segreta`,
"label.query.detail.closepartner":`Disattivare i partner`,
"label.isEnableVisualpage_new.rightlist":`Pagine personalizzate attive`,
"front-epwechat-module-v1-unbound-item3":` dati di informazioni autorizzate`,
"label.exchange.sync.setting.info":`Dopo aver impostato un account di servizio con permessi di impersonificazione per gli utenti in Microsoft©Exchange, inserire le credenziali dell'account di servizio per permettere al CloudCC di comunicare con il server Exchange. Se le credenziali dell'account di servizio sono state salvate, ma l'utente non è ancora in grado di sincronizzare i record, assicurarsi di aver impostato l'Exchange Sync.`,
"label.emailobject.groupemail.fail.title":`L'invio di email di gruppo CloudCC non è riuscito indirizzo email`,
"label.the.upper.bound.of.each.level.of.edit.discount.must.be.greater.than.the.lower.bound.":`Il limite superiore per la modifica di ogni livello di sconto deve essere maggiore del limite inferiore.`,
"label.visualpage.list.vpname":`Nome della pagina personalizzata`,
"label.mask.length.error.message":`Il campo di testo criptato non può essere più di 255 caratteri`,
"label.h5.approval.actorname":`Inviato da`,
"label.knowledgebase.view.translation":`Visualizza la traduzione`,
"label.ems.edit":`Modifica`,
"vue_label_commonobjects_view_reset_width":`Azzeramento della larghezza della colonna`,
"label.version.feature.controllist":`Elenco dei limiti di funzione`,
"label.setuppagelayout":`Layout di pagina`,
"vue_label_commonobjects_view_new_view":`Nuova vista`,
"label_tabpage_queuez":`Coda`,
"label.direct.dashboard.wait.me.approval":`Punti da approvare`,
"message.report.error.noRelatedField":`Non ci sono campi correlati con il rapporto. Potrebbero essere stati cancellati, contatta il tuo amministratore.`,
"label.ccchat.person.invite.notme":`Non è possibile inviare inviti al proprio indirizzo e-mail.`,
"label.weixin.jieduan.finish":`Segna lo stadio corrente come completato`,
"vue_label_commonobjects_detail_?enter_subject":`Si prega di inserire il soggetto`,
"label_starting_month":`Mese di partenza`,
"label.address_linetwo":`Linea di indirizzo 2`,
"message.error.select.contiguous.item":`Selezione di elementi rilevanti con`,
"vue_label_pricebook_enterbookname":`Inserisci il nome del listino prezzi`,
"label.cycleworkflowoperate":`Azioni periodiche del flusso di lavoro`,
"label.ems.withoneday":`Oggi`,
"component.todaytask.label.notask":`Non c'è nessun compito di scadenza oggi, prendete un caffè.`,
"label.tianyancha.id":`ID azienda`,
"label.user.illegal.login":`Accesso illegale`,
"label.withgathercondition":`Per criteri riassuntivi`,
"label.foldervisitlimit":`Permessi di accesso`,
"label.ccchat.search.conversation":`Cerca questa conversazione`,
"lable.annual.project.report":`Relazione sul conto del progetto in questo anno`,
"template.chart.qzkhzhfx":`Analisi della conversione dei lead`,
"label.my":`Il mio`,
"label.sendsms.batch.chosetemplate":`SMS di massa: Seleziona un modello o modifica il contenuto`,
"label.callcenter.enterprise.number":`Impresa No.`,
"label_last_modified_by_time":`Ultimo modificatore & tempo`,
"message.fieldtrack.operaterecord":`Cambiato <b>operatefield</b> da<b>operateold</b> a<b>operatenew</b>`,
"label.mobile.more.openin":`Aprire in...`,
"label.multilingual.tip2":`È possibile abilitare o disabilitare il multilinguaggio.`,
"label.datamanage.lead.novalue":`Nota: se il campo "lead name" è nullo, i record di contatto non saranno importati.`,
"label.custom.revoke":`Undo`,
"label_chatter_leaveword":`Commento`,
"vue_label_ccchat_group_deletedgroup":`Il gruppo è stato cancellato`,
"label.tabpage.operationz":`Campo, l'operazione non può essere vuota`,
"label.user.organization.permit.overdue":`La licenza della tua organizzazione è scaduta, per favore contatta l'amministratore!`,
"label.log.datetimeoruser.value":`Inserisci il tempo di interrogazione e il nome utente.`,
"lable.product.stsp.noavailable":`Nessun prezzo standard disponibile`,
"label.appservice.cannot.delete.app":`Non puoi cancellare questa app personalizzata, perché alcuni profili usano questa app personalizzata come app predefinita.`,
"component.event.label.newevent":`Nuovo evento`,
"label.view.sortview.exportview":`Vista Esportazione`,
"label.uploadfilemaxsize":`Il valore massimo consentito per il caricamento dei file è`,
"label.event.weekview":`Vista della settimana`,
"label.conversion_rate":`Tasso di conversione`,
"label.partnerCloud.partnerAccount.useWechat":`Usa la scansione di WeChat per pagare.`,
"UG_Forcast_05":`Impostazioni di previsione: passo {0}/{1}`,
"label.service.gantt.jobresour":`Mostra solo le risorse di lavoro`,
"vue_label_campaign_fromopprotunities":`Da {dsrjine} opportunità di business`,
"label.app.skyblue":`Blu cielo`,
"label.chinacloudcc":`Cloud Computing Cina`,
"label.connectOtherFinalNumber":`Limite di oggetti raggiunto<br/>Puoi associare fino a quattro oggetti a un'origine dati del rapporto personalizzato.`,
"label.redistributionrequest":`Riassegnare le richieste di approvazione`,
"label.knowledge.category.button.one":`Aggiungi sottocategoria`,
"label.campagin.pcandmo":`PC e mobile`,
"label.project.milestone.date":`La data della pietra miliare deve essere all'interno dell'intervallo di date del progetto a cui appartiene.`,
"assetbom.transfer.notpermission":`Non hai l'autorità per migrare la distinta dei beni. Contatta l'amministratore.`,
"label.marketing.setting1":`Canali di marketing`,
"label.select.file":`Selezionare il file`,
"message.error.object.contactadministrators":`Il sistema è anomalo, contattare l'amministratore del sistema per assistenza.`,
"label.custom.quarter.title":`Quartiere personalizzato`,
"label.knowledge.case.settings":`Casi Impostazione`,
"front-service-cloud-transfer-title":`Trasferimento del proprietario della distinta dei beni`,
"label.group.search.searchthisfeed":`Cerca questo feed`,
"label.report.action.addtodashboard5":`Aggiungi al nuovo cruscotto`,
"label.mobile.side.tab.remark2":`Quando si imposta il cursore, è possibile mettere le voci più comunemente utilizzate in prima posizione. la cronologia delle chiamate, la voce di menu può essere utilizzata solo per la versione android di CloudCC sul lato mobile.`,
"contain":`Includere`,
"label.select.template":`Selezionare il modello`,
"label.addattachment.step3.weixin":`Passo 3 Fare clic sul pulsante "Completa" e tornare alla pagina precedente.`,
"lable.Order.successfully":`Trasferire l'ordine all'attività con successo.`,
"label.user.title":`Titolo`,
"label.weixin.check.agreement":`Si prega di controllare il relativo accordo`,
"label.SMS.pfi":`Campo numero di telefono`,
"label.weixin.micro.research":`Micro indagine`,
"label.projectManagement.assigned.work":`Lavoro assegnato`,
"label.document.login.error":`Login fallito, per favore riprova.`,
"label.mobile.phone.examines.people":`Rivisto da`,
"label.safetyset":`Impostazioni di sicurezza`,
"label_function_tip":`Questa funzione non è attualmente supportata per gli utenti della Cina continentale. Apprezziamo la vostra comprensione!`,
"label.app.sort":`Ordinare le app`,
"component.sendmail.label.cc":`Cc`,
"label.titlename":`Titolo`,
"label.event.moveup.3day":`3 giorni prima`,
"label.condition":`Condizioni`,
"label.description.message":`Massimo 500 caratteri.`,
"label.ems.detailedsettings":`Impostazioni dettagliate`,
"label.repeat.condition.field.prompt":`Per favore, inserisca un numero nella casella "Secondo la lunghezza dei caratteri".`,
"label.validate.function.funcExplain.OR":`Controlla che tutti i parametri siano veri e restituisce TRUE o FALSE. Restituisce FALSO solo se tutti i parametri sono falsi.`,
"label.salecommit.allow.prediction.query":`Non puoi visualizzare i dashboard degli impegni di vendita perché non hai spuntato l'opzione Permettere le previsioni da Setup-My Personal Information-Personal Settings.`,
"front-kefu-moudle-soft-phone":`Softphone`,
"label.view":`Vedi`,
"front-gantt-module-quick-create-task":`Creare rapidamente un compito`,
"label.all_forms":`Tutte le forme`,
"front-lightning-module-v1-dashborad-statistical-dimension":`Dimensione statistica`,
"label.forecast.settings.data.chanpin":`Data del prodotto`,
"label.appointment.wizard.subtitle4-2-7":`3 giorni`,
"front-web-module-v1-detail-comment-please":`Inserisci il feedback`,
"label_chatter_nextSevenday":`Prossimi 7 giorni`,
"homepage.components.desctiption":`Questa pagina ti permette di creare e modificare i componenti che possono essere mostrati in uno o più layout della home page.`,
"label.customcomponent.page.index.table.namespace":`Prefisso dello spazio dei nomi`,
"label_emailtocloudcc_exists":`L'e-mail esiste già.`,
"label_tabpage_save":`Salva`,
"label.mergeRechecking":`Duplicazione e unione degli assegni`,
"vue_label_helpcenter_view2":`Nella visualizzazione a schermo diviso, è possibile passare rapidamente a visualizzare le informazioni dettagliate di ciascun dato. <br> 3. Analizzare rapidamente i dati di vendita<br> Nell'angolo superiore destro della vista, è possibile aprire il grafico nella vista per eseguire una semplice analisi visiva dei dati nella vista. Allo stesso tempo, è possibile visualizzare il dashboard e l'elenco dei rapporti relativi ai dati della vista per ulteriori analisi. <br>?Fare clic sul pulsante grafico nell'angolo in alto a destra, è possibile visualizzare, creare, modificare semplici grafici creati con i dati della vista, o visualizzare i cruscotti relativi alla vista corrente. <br> Passo 1: Fare clic sul pulsante del grafico in alto a destra per espandere il grafico nella pagina. È possibile visualizzare e gestire i grafici esistenti in base alle autorizzazioni, e visualizzare l'elenco dei cruscotti relativi ai dati della vista. <br> Passo 2: Fare clic sul pulsante Impostazioni, è possibile creare, modificare ed eliminare i grafici in base alle autorizzazioni. È possibile creare quattro stili di grafici, grafico a colonna verticale, grafico a colonna orizzontale, grafico a torta e grafico a imbuto. <br>: Fai clic sul pulsante report per visualizzare i report relativi alla vista corrente. <br> 4. Gestisci i dati nella vista<br>?Nella vista, secondo la tua autorità, puoi aggiungere, modificare, eliminare, e cambiare il proprietario dei dati attraverso i pulsanti in alto a destra della vista, o accanto ad ogni pezzo di dati. <br>Utilizza i tag per aiutare la tua gestione dei dati. Usa il pulsante sulla destra per espandere l'elenco della gestione dei tag, e puoi filtrare i dati nella vista in base ai tag. Dopo aver cliccato su Manage tags, puoi anche mantenere e gestire la tua libreria di tag. Dopo aver selezionato i dati, usa il pulsante Add Tag nell'angolo in alto a destra per aggiungere tag ai dati in batch.`,
"label.app.ismobile":`Visualizzato sull'applicazione mobile`,
"chatter.group.changeTheGroupPicture":`Cambiare la foto di gruppo`,
"label.mr.descreption.reDataList2":`registrazioni di ripetuti`,
"vue_label_chatter_agree_join":`Accettare di aderire`,
"label.planned.nextrun":`Esegui nel prossimo programmato`,
"Homepage.News.003":`Impossibile visualizzare le notizie senza i dati dell'account, si prega di creare un nuovo account e le notizie relative saranno mostrate.`,
"label.summaryreport.selectpictype":`Seleziona il tipo di grafico e altre opzioni grafiche`,
"label.app":`Applicazioni`,
"label.trigger.name":`Nome dell'innesco`,
"vue_label_email_private_template":`Modello privato`,
"label.appointmentpage.wizard.subtitle1":`Scegli la data e l'ora Il fuso orario di Inviter è {0}`,
"label.partnerCloud.orderingPlatform.payment":`Ordine di pagamento`,
"label.stdashbord.xsld.title":`Imbuto di vendita`,
"vue_label_pool_poolname":`Nome del pool di conti`,
"label.ServiceCloud.fuwuyuyue.distributionMap":`Mappa di distribuzione degli appuntamenti di servizio`,
"front-lightning-module-v1-dashborad-target-value":`Valore obiettivo`,
"label.reportsSubscriptionPage.email.keywords":`Ricerca dopo aver inserito la parola chiave`,
"label.appointmentconfirmail.wizard.subtitle1":`Nome dell'evento`,
"label.limited_scanning":`Il biglietto d'ingresso è solo per la scansione di registrarsi sul posto`,
"label.weixin.nomore":`Non di più`,
"february":`Febbraio`,
"label.view.filterbyowner":`Filtrare per proprietario:`,
"label.contentType":`Estensione del documento`,
"label.customobjdel.master.hsiang":`Il campo Master-Detail Relationship viene creato in questo oggetto, quindi non è possibile cancellarlo.`,
"lable.Removal.succeeded":`Rimosso con successo.`,
"label.weixin.end.incorrect":`Data di fine non valida`,
"label.email.cc.recipients":`Destinatari Cc`,
"label.taskevent.list":`Elenco delle attività`,
"label.formula":`Formula`,
"label.h5.new.errorheader":`Rivedere gli errori in questa pagina.`,
"label.emailobject.template.private":`Privato`,
"label.visualpage.component.n4":`4.Variabile. Potete usare le variabili direttamente, e fate attenzione a non avere virgolette singole.`,
"label.newemailnotice.step1":`Passo 1 Selezionare l'oggetto`,
"label.chatter.file":`File`,
"vue_label_checkduplicate_rules":`Impostare regole di controllo dei duplicati`,
"label.appointment.wizard.subtitle1-6":`1.5 h`,
"label.customReportType":`Fonte di dati del rapporto personalizzato`,
"vue_label_email_with_accessories":`Email con allegati`,
"label_efine_assessment_cycle":`Impostare il periodo di valutazione delle prestazioni`,
"label_emailtocloudcc_button_sure":`Confermare`,
"label.forecast.userenablepage.isusing":`Utenti abilitati`,
"lable.goal.description":`Descrizione dell'obiettivo`,
"message.error.serviceresource.relatedrecordid":`Ogni utente può essere aggiunto solo come una risorsa di servizio di tipo {0}`,
"label.weixin.addbus.information":`Aggiungi informazioni sul veicolo`,
"label.emailtocloudcc.button.view":`Vedi`,
"label.detail.workflow":`Visualizza i flussi di lavoro`,
"label.standardfilter":`Filtri standard`,
"label.mobile.phone.results":`Performance`,
"chatter.feed.unavailabled":`Disattivare`,
"label.view.sortview":`Ordina Vista`,
"label.availabilityobject.wizard.title":`Disponibilità`,
"Main_Menu_Mobiledownload":`PRENDETELO`,
"chatter.sticker":`Tracciato`,
"label.workflow.intruduce":`Configura il flusso di lavoro dell'organizzazione creando regole di flusso di lavoro. Ogni regola del flusso di lavoro consiste in:`,
"label.customfields.richtext.tip":`Permette agli utenti di inserire testo formattato, aggiungere immagini e link. Fino a 32.768 caratteri su linee separate.`,
"label.new.cy.select":`Scegli una nuova valuta dalla lista disponibile.`,
"template.chart.schdzqzkhzhqk":`Conversione dei lead nelle campagne`,
"label.forecast.customforecast.cpxl":`Famiglia di prodotti`,
"front-electronic-signature-open-service":`Attiva la firma elettronica`,
"label.datamanage.import.field":`Importazione dei campi`,
"chatter.email.sendMessageToMe":`Mi manda un messaggio`,
"message.cannotusebefore":`Si prega di notare che non sarà possibile utilizzare questo processo di approvazione finché non sarà stato attivato.`,
"label.textmessage.vonage.api.secret":`Segreto API`,
"label_chatter_newEvent":`Nuovo evento`,
"label.ji.year":`{a} anno`,
"label.sendmail.step2":`Passo 2 Selezionare un modello di email`,
"label.console.step5.record":`documenti aperti`,
"label.customfields.totalsummary.gettogetherfield.isnull":`Seleziona il campo da aggregare`,
"vue_label_commonobjects_detail_current_recorder":`Il nuovo proprietario diventerà anche il proprietario delle registrazioni relative a questo progetto, e queste registrazioni sono di proprietà dell'attuale registratore`,
"label.SMS":`Notifiche SMS`,
"label.reconfigure.bundle":`Riconfigurare il pacchetto`,
"front-kefu-select-region":`Seleziona l'area in cui si trova l'istanza`,
"chatter.feed.deletefeeds":`Sei sicuro di voler cancellare questo post e i suoi commenti?`,
"label.customsetting.manage.introduce.h":`Se l'impostazione personalizzata è una gerarchia, puoi aggiungere dati per il livello utente, profilo o organizzazione. Per esempio, potresti volere diversi valori da visualizzare a seconda che un utente specifico stia eseguendo l'applicazione, un profilo specifico o solo un utente generale.`,
"label.product.name":`Nome del prodotto`,
"vue_label_commonobjects_view_saveas":`Salva con nome`,
"label.group.my.archived":`I miei gruppi archiviati`,
"vue_label_pool_coflictmethods":`Conflitto con la modalità di vendita corrente`,
"label.appupload.upload":`Carica`,
"lable.SalesCommitmentKanBan.signedTaskRate":`Tasso di completamento del compito firmato`,
"label.dashboardStandard":`Cruscotti standard`,
"label.niboer.time":`Ora del Nepal`,
"label.emailtocloudcc.filed.email":`Email`,
"market.name.social.post":`Messaggi sociali`,
"evaluation.detail.notfound":`Il dettaglio del commento non è stato trovato`,
"label.layoutoftestobj":`Layout degli oggetti di prova`,
"label.example":`Esempi`,
"label.campaign.channel.step6.remark6":`per favore visita qui`,
"chatter.emailLike":`Mi piace`,
"label.knowledge.category.button.two":`Modifica categoria`,
"label.alluser":`Tutti gli utenti`,
"addadvancedconditions":`Aggiungere condizioni avanzate`,
"message.selectgsummarycondition":`selezionare i criteri di riepilogo`,
"message.duplication.label.sectionremar2":`Note: Tutti i record correlati, incluse le note, gli allegati e le attività, saranno associati al nuovo record unito.`,
"vue_label_helpcenter_product&pricebook":`I prodotti sono il tuo catalogo di base per tutti gli articoli e servizi che vendi e i loro prezzi standard. Il listino prezzi ti permette di creare una collezione personalizzata di prodotti e prezzi di listino associati per utenti specifici.`,
"message.duplication.label.isprofile":`Con il permesso`,
"component_setup_label_milestonesfield":`Campo pietra miliare`,
"setup_layout_label_required":`Richiesto`,
"component_chatter_label_title":`Ultimo messaggio`,
"label.assignment.setup.detail.order":`Ordinamento`,
"vue_label_pool_unassigned":`Non assegnato`,
"UG_Lead_007":`Sincronizzazione con Google`,
"label.knowledge.record":`Non esistono dati rilevanti!`,
"label_tabpage_filetypez":`Tipo di file`,
"label.ccpeak.if.error.message":`Se viene restituito un errore: usare`,
"label.intialsubmitter":`Invianti iniziali`,
"label.wei.icon":`Icona`,
"label.mask.show.last.4":`Maschera gli ultimi quattro caratteri`,
"lable.PowerProcess.time.trigger":`Tempo di innesco (min)`,
"july":`Luglio`,
"label.usestandardwizard":`Utilizzare la procedura guidata di installazione standard`,
"label.two.quarter":`Secondo trimestre`,
"label.size":`Dimensione`,
"label.integrations.mailchimp.massage4":`Mailchimp non è attualmente installato. Si prega di installare Mailchimp in "Integrazioni".`,
"label_emailtocloudcc_step2total3":`Passo 2 di 3`,
"vue_label_chat_customer_group_strategy":`Squadra clienti`,
"label.searchvalue":`Trova i valori`,
"label.sendemail.birthday.title":`Promemoria del compleanno`,
"label.projectManagement.planned.days":`Giorni di pianificazione (giorno)`,
"label.service.gantt.workhours":`Sulla base delle ore di lavoro`,
"label.notification.approval5":`Approvazione delegata:【提交人】 richiede l'approvazione 【对象】`,
"label.service.miniProgram.bindAddressDesc":`Portale del mini programma del servizio clienti ufficiale della CloudCC:`,
"chatter.error.wt":`Errore:Tipo di file non valido.`,
"vue_label_calendar_my_calendar":`Il mio calendario`,
"label.customername":`Nome del conto`,
"label.salescloud.salesdashboard.huikuan.rankings":`Classifiche di pagamento della squadra`,
"message.query.opportunity.contactrole.error":`Interrogazione del ruolo predefinito del contatto dell'opportunità commerciale non riuscita, si prega di contattare l'amministratore!`,
"noequal":`non uguale a`,
"label.document.searchcustominfo":`Inserisci le parole chiave per trovare i documenti corrispondenti.`,
"label.account.PreviousFQ":`Precedente FQ`,
"label.file.f":`File`,
"label.dashboard":`Cruscotti`,
"label.report.folder":`Cartelle`,
"batch.edit.permission.list":`Nessun permesso per modificare l'elenco dei dati`,
"label.file.orderbyowner":`Ordinati per proprietario`,
"label.exchange.sync.account.password":`Password dell'account di servizio:`,
"pagecreator.button.publish":`Pubblica`,
"label.modify":`Modifica`,
"label.exchange.sync4":`Stati`,
"label.remark.information":`Descrizione Informazioni`,
"label.service.without.major.event":`Nessun evento importante da visualizzare`,
"label.knowledgebase.release.status":`Pubblicare lo stato`,
"label.tabpage.ok":`Confermare`,
"label_screening_assessment_content":`Filtrare il contenuto della valutazione`,
"label_partner":`Nuvola dei partner`,
"label.user.detail":`Visualizza gli utenti`,
"front-kefu-moudle-or-this":`o, come questo?`,
"label.unselect.object":`Oggetto Opzionale`,
"label.quote.contactfax":`Fax`,
"label.weixin.appmanage.alert":`Premere {0} per rimuovere l'app da Le mie applicazioni, premere {1} per aggiungere l'app a Le mie applicazioni.`,
"vue_label_dashboard_thisfolder":`Aggiungere la dashboard pubblica a questa cartella`,
"label.delete":`Cancellare`,
"label.appexchange.installedpage.message1":`Puoi visualizzare e scaricare applicazioni direttamente in CloudCC App Store e installarle nel tuo ambiente CloudCC.com.`,
"label.mobile.phone.required.summary":`Il riassunto è richiesto`,
"label.batchadd.newbatchpage.addtr":`Si può aggiungere un massimo di 30 record.`,
"label.partnerCloud.partnerAccount.lockLine":`Importo bloccato`,
"label.emailsync.status.connectstatus":`Stato della connessione`,
"label.campaignmember.main.importmember.lead":`Importazione di membri-Leads`,
"message.username.isnull":`Devi inserire un valore per il nome utente.`,
"label.forecast.tree.enableuser":`Abilitare gli utenti`,
"label.multilang.view.viewmessage":`Questa vista è stata applicata al dispositivo mobile. Si possono scegliere un massimo di 10 campi, ora ci sono {0}:`,
"friday":`Venerdì`,
"label.sendemail.activity.neweventtitle":`Notifica di un nuovo evento`,
"label.page.addtabto.user":`Aggiungere la scheda alle personalizzazioni esistenti`,
"front-kefu-moudle-v1-connect-phone":`Numero di telefono associato`,
"label.wei.pollis":`Vota per`,
"lable.opppdt.editPdt.title":`Modifica prodotti di opportunità`,
"label.permission.objectpermission.recordfenpei":`Assegnazione del tipo di record`,
"pagecreator.layout.message.delete.success":`Layout cancellato con successo`,
"label.dataimport.isdupecatcher":`Eseguire i filtri`,
"label.deletelayout.tip":`Per cancellare un layout di pagina, devi selezionarne un altro con cui sostituirlo.`,
"label.projectManagement.No.matching.data":`Nessun dato corrispondente.`,
"pagecreator_page_message_delete_success":`Pagina cancellata con successo`,
"label_tabpage_equalz":`Uguale a`,
"label.ems.emailsetup":`Impostazione e-mail`,
"label.decimaldigits":`Posizioni decimali`,
"component.chatter.button.delete":`Cancellare`,
"label.isallowreport":`Permettere i rapporti`,
"label.view.appliedMobile.message":`Selezionare questa voce, Passo 3. Seleziona i campi da visualizzare, e puoi selezionare fino a 6 campi`,
"label.must.positive.integer":`Il numero deve essere un intero.`,
"label.preview.print.template":`Anteprima del modello di stampa`,
"label.schedulejob.setup.schedule.start":`Iniziare`,
"UG.Case.04":`Assegnazione del caso`,
"vue_label_pool_move1":`{1}{2}`,
"label.list.userinterface.enableHoverDetails":`Abilita i dettagli di hover`,
"vue_label_email_alltemplates":`Tutti i modelli`,
"label_report_chose_obj":`selezionare la relazione oggetto e l'origine dati del rapporto`,
"label.partnerCloud.productSet.del":`Cancellare la voce`,
"label.quote.shrdz":`Indirizzo del destinatario`,
"page.approval.history":`Storia dell'approvazione`,
"lable.outlook.detail.prefc":`Sempre preferito CloudCC.com`,
"label.translation.unable.display.view":`Impossibile visualizzare la vista`,
"label.encrypt.change":`Convertire tipo crittografato`,
"button.partner.workspace.login.logo.upload":`Carica immagine`,
"label.batchadd.mustinput2":`è richiesto, questo record non può essere salvato se le informazioni richieste sono vuote.`,
"label.dataimport.update.error.check":`Si è verificato un errore nell'aggiornamento dei dati. Si prega di esaminare attentamente questi dati.`,
"label.staticresource.name.already.exists":`Il nome unico della risorsa statica esiste già!`,
"label.appupload.upload.install.success":`Installato con successo`,
"label.conditiontag.lookup.true":`VERO`,
"label.quickbooks.viewlist.customer":`CLIENTE`,
"label.field.edit.change2":`Il punteggio più alto è almeno 1`,
"label.fianalrejectoperate":`Azioni finali di rifiuto`,
"label.ccpeak.wgd":`Classi non compilate`,
"label.reportsSubscriptionPage.condition.emailreport":`Riassunto   rapporto`,
"label.detailinf":`Dettagli`,
"label.eastem.standard.time":`Ora solare orientale`,
"chatter.group.manager":`Manager`,
"label.manage_columns":`Gestire l'intestazione`,
"label.daylight.time":`Ora legale`,
"label.weixin.mycar.information":`I miei veicoli`,
"label.ccpeak.help":`Aiuto per le classi`,
"lable.outlook.detail.match":`Criteri di abbinamento`,
"label.version.nonsupport.approval":`I processi di approvazione non sono supportati temporaneamente.`,
"label.custom-tailor":`Personalizza`,
"label.showoperate":`Mostra azioni`,
"label.view_edit":`Visualizza e modifica`,
"label.lead.score.prompt2":`Seleziona l'intervallo di valutazione e clicca sul pulsante [Lead Scoring] e il sistema assegnerà un punteggio ai lead selezionati in base alla regola di valutazione dei lead attiva.`,
"label.datamanage.savetemplate.error":`Salvataggio del modello non riuscito.`,
"label.source":`Fonte`,
"label.multilang.customfieldsetup.reference":`Questo campo è referenziato da {0}`,
"chatter.poll.option7":`Scelta 7`,
"label.login.access.day":`giorno/i`,
"label.icon.66":`Attrezzatura`,
"label.tabpage.kanbansetup":`Impostazione del tabellone`,
"label_emailtocloudcc_step1_lead2":`Una volta configurato, le mail ricevute in questa casella di posta saranno automaticamente registrate come record di lead in CloudCC. Assicurati che nessun affare vada perso.`,
"label.partnerCloud.partnerAccount.numericValue":`L'importo della ricarica è un valore numerico.`,
"label.permission.detail.app.object.tip":`Oggetti, campi e schede Impostazioni di accesso`,
"label.emailobject.template.subject":`Oggetto`,
"template.report.month.customer":`Conti di questo mese`,
"label.weixin.formerly":`In passato`,
"label.contract":`Contratti`,
"label.help":`Aiuto`,
"vue_label_homepage_setdefault":`Imposta come pagina iniziale predefinita`,
"label.icon.52":`Generazione di energia`,
"label.customfields.file.count":`Il numero di file`,
"UG_Account_07":`Importazione conto`,
"label.addattachment.ntko":`Modifica online`,
"label.service.ganttBaiduMap.assign.service":`Assegnare la nomina di servizio a questa persona`,
"vue_label_file_my_file":`Il mio file`,
"label.custom.page.hide":`Nascondi`,
"label.addexistoperate":`Aggiungere un'operazione esistente`,
"label.already.startdate":`Tempo iniziato`,
"label.partnerCloud.financeSetting.alipay":`È necessario aprire un conto business Alipay. Solo il conto business è supportato come conto di ricezione. Le spese di transazione saranno addebitate da Alipay al beneficiario.`,
"label.dashboard.summary.editPageFooter":`Modifica piè di pagina`,
"label.category.8":`Beni di consumo`,
"label.forecast.customforecast.foretype.best":`Miglior caso`,
"message.validation.isnull":`Inserisci un valore`,
"label.savewxpay.failure":`Impossibile salvare le informazioni del commerciante di pagamenti WeChat`,
"label.file.stop.sharing.desc1":`Smettere di condividere con`,
"label.opportunity.setting.showstage。read.info":`Le fasi di opportunità non possono essere modificate manualmente dopo aver spuntato`,
"UG_Campaign_003":`Creare una campagna`,
"label.edit.field.select.showoptions":`Mostra tutte le opzioni`,
"message.inputplatformpwd":`Inserisci la password dell'amministratore`,
"vue_label_systemSettings_mobel_set":`Configurazione dell'app mobile`,
"label.projectManagement.thefirstone":`Questo è il primo record`,
"label.data.newtemplate":`Creare un modello di esportazione dei dati`,
"label.monitorsys.delete.log":`Registro di controllo delle operazioni chiave`,
"label.template":`Modelli`,
"Lead.Auto.Scoring.Setting.001":`Segnare automaticamente quando si modifica o si salva (eccetto le tracce che sono importate in batch o create dall'interfaccia)`,
"label.operatesuccess":`Operazione riuscita.`,
"label.send":`Invia`,
"chatter.yp":`Nascondi alimentazione`,
"label.overall_responses":`Risposta complessiva`,
"vue_label_systemSettings_server_report":`Rapporto di servizio`,
"label.icon.113":`Casa`,
"label.partnerCloud.basicSetting.domainSet":`Impostare il nome di dominio`,
"label.login.access.text":`Per aiutare il supporto, potete concedere all'amministratore l'accesso per accedere e visitare i vostri dati.`,
"vue_label_report_addrowlevelformula":`Aggiungere una formula a livello di riga`,
"message.duplication.label.mergeTitle":`Unire il mio`,
"label.event.add":`Aggiungi evento`,
"vue_label_homepage_bigscreen_light":`Luce`,
"setup.chatter.enabled":`Non disponibile, contatta l'amministratore per abilitare CCChat.`,
"label.inputreceiver":`Puoi inserire fino a cinque (5) indirizzi e-mail da notificare. Ogni indirizzo e-mail è separato da ";".`,
"label.custom.page.custom.page":`Pagine personalizzate`,
"label.data.exp.csv":`Formato CSV`,
"label.searchlayout.view.example":`Vedi esempio`,
"label_tabpage_fullscreenz":`Schermo intero`,
"label.tabpage.last":`Ultimo passo`,
"lable.outlook.mcto.accepemail":`I miei indirizzi e-mail disponibili`,
"front-electronic-signature-isopen":`Attivo`,
"vue_label_commonobjects_detail_earlier":`Vedi prima`,
"label.name.cannot.greater.str":`Il nome può inserire fino a 255 caratteri.`,
"label.weixin.activity.email":`Attività: Email`,
"label.tabpage.unequalz":`Ineguale a`,
"label_calendar_year":`Anno solare`,
"label.appupload.upload.installor":`Installato da`,
"label.jixiaoswitchon":`Espandi`,
"label.user.congratulations.send.finish":`Congratulazioni, email di massa completata.`,
"label.customsetting.touse.getListCustomSetting2":`Interroga i dati di tipo "list" delle impostazioni personalizzate, restituisce singoli dati corrispondenti a API Name. Map map = cs.getListCustomSetting(String apiName, String Name);`,
"label.recordtype.masterrecordtype.selectedTip":`Il tipo di record principale non può essere assegnato al profilo a cui è già stato assegnato un tipo di record.`,
"label.tippage.li3":`In modo che qualsiasi componente del cruscotto basato sul rapporto del guasto sia stato rimosso`,
"label.weixin.no.name":`Nessun soggetto`,
"label.tabpage.viewz":`Stampa la vista corrente`,
"label.create_contacts":`Creare una lista di contatti`,
"vue_label_homepage_operationitem":`Seleziona il pulsante`,
"label.pc.ui.2018.switch.version":`Passa alla versione`,
"label.salescloud.teamrole.main":`Contatto principale`,
"label.reportsSubscription.format.report":`Rapporto formattato (formato Excel .xlsx)`,
"label.forecast.customforecast.total":`Importo`,
"label.quickbooks.fieldlabel.lastname":`Nome e cognome`,
"label.appointment.wizard.title2":`Dettagli della riunione`,
"label.project.template.one":`La creazione di un progetto da un modello di progetto richiede 2~3 minuti. Grazie per la vostra paziente attesa.`,
"label.timetrigger.workflow":`Quando il flusso di lavoro è attivo.`,
"label.projectManagement.creator":`Creatore`,
"label.customfields.formula.selectreturnfieldtype":`Selezionare il tipo di ritorno della formula`,
"label.list.userinterface.dashboard.enable":`Abilitare i nuovi componenti del cruscotto`,
"label.email.delete.html.format":`Tutti i formati html saranno cancellati. sei sicuro?`,
"label.appupload.install.modifyapi":`Modificare il nome dell'api in conflitto:`,
"label.chat.add.topics":`Aggiungere un argomento`,
"label.savepartner.fail":`Impossibile salvare le impostazioni per Partner Cloud`,
"label.pc.query.new":`Visualizza il tuo ultimo`,
"message.duplication.label.editfiltertitle":`Trova filtro duplicato Modifica`,
"label.task":`Compiti`,
"label.emailobject.emaildetail.title.toaddress":`A:`,
"label.setup.mobile.bottombutton.select":`Selezionate le 4 pagine di primo livello che volete mostrare sull'applicazione mobile`,
"label.loginip.pagecue.invalido":`Indirizzo Internet non valido`,
"label_tabpage_listshow":`L'elenco mostra`,
"component.newrecords.label.10records":`10 registrazioni`,
"label_chatter_file":`File`,
"pagecreator.systemstyle.label.detailcolor":`Dettaglio colore del testo`,
"label.forecast.userenablepage.title":`Previsioni Utenti`,
"front-project-module-v1-actual_working_hours":`Uomoora segnalato`,
"vue_label_systemSettings_Security":`Contenimento della sicurezza`,
"label.processsetting.two.select.key.fields":`Fase 2: Selezionare i campi chiave per ogni fase del processo e fornire una guida`,
"label.page.display1":`Registrazioni per pagina`,
"label.appointmentpage.wizard.subtitle1.2":`Il fuso orario dell'invitante è {0}`,
"label.ggReleaseRange.searchTeam":`Cerca gruppo pubblico`,
"chatter.group.searchGroup":`Digitare un nome di gruppo...`,
"label_card_type":`Layout della carta`,
"label.appupload.managed.tip":`Essere controllati significa che si possono modificare solo certi attributi.`,
"label.changemyshow":`Cambiare il mio display`,
"label.custom.CustomQuarter":`Quartiere personalizzato`,
"label.tobedelete":`Da cancellare`,
"label.newPage.unuse":`La tua pagina è persa.`,
"label.product.pricebooks":`Prezzo Libri`,
"label.mobile.layout":`Layout di pagina per dispositivi mobili`,
"label.multilang.file.items":`{0} progetti:`,
"label.app.step4.tabused":`Schede selezionate`,
"label_ccchat_create_account":`Creare un account`,
"message.startusingprocess":`Dopo aver attivato questo processo di approvazione, non è possibile aggiungere o rimuovere passi di approvazione. Inoltre, alcuni attributi dei passi di approvazione non saranno modificabili. Sei sicuro di voler continuare?`,
"vue_label_email_please_add_a_theme":`Aggiungi un tema prima di salvare come modello`,
"label.please.create.a.target.record.first.":`Per favore, crea prima un record dell'indicatore`,
"label.processsetting.set.objandfile":`Passo 1: Selezionate gli oggetti e i campi che volete impostare il processo`,
"label.newreport.group.data":`gruppo（s）`,
"label.notcreatenew":`Non creare una nuova opportunità al momento della conversione.`,
"lable.custom.CurrentandPreviousCY":`CY attuale e precedente`,
"front-epwechat-module-v1-input-androidschema":`Inserisci lo schema di Android`,
"label.projectManagement.unfinished.quantity":`Numero non completato`,
"label.visualpage.idandname":`L'ID della pagina e il nome della pagina sono:`,
"label.approvingprojects":`Punti da approvare`,
"label.partnerCloud.financeSetting.weChat":`Il servizio WeChat deve essere aperto e l'accordo di servizio di raccolta con Tencent è richiesto. La tassa di transazione sarà addebitata da Tencent al beneficiario.`,
"label.quickbooks.viewlist.view":`Vedi`,
"label.knowledge.category.hint.ten":`Gruppo di categoria inattivo`,
"report_type_label_productPricebooks":`Prodotti e libri dei prezzi`,
"label.fenbeitong.description":`Controllare e attivare FenBeiTong modulo di domanda di viaggio per assistere i dipendenti nella domanda di viaggio d'affari e il rimborso delle spese di viaggio
spese`,
"label.ccchat.upload.change":`Cosa è cambiato? (opzionale)`,
"label.emailsync.status.log":`Registro delle connessioni`,
"label.addnew":`Aggiungi nuovo`,
"UG_contact_05":`Creare un contatto`,
"label.appupload.componet.queryerror":`Si è verificato un errore durante la ricerca di omponent. Per favore contatta il tuo amministratore.`,
"label.salescloud.setting":`Impostazione di vendita a squadre`,
"label.recurrencetimetriggeroperate":`Azioni periodiche a tempo`,
"label.event.moveup.4day":`4 giorni prima`,
"No.Hisitory.Activity":`Nessuna attività storica`,
"label.validate.function.funcFormat.MINUTE":`MINUTO(data)`,
"label.recentview.seloption3":`Modificato di recente`,
"label.login.access.nopermission":`--Nessun accesso--`,
"label.taskmenuandlink":`Pulsanti e collegamenti delle attività`,
"label.forecast.customforecast.foredis.sbw":`Milioni`,
"lable.PowerProcess.created.event":`creare pietra miliare`,
"label.stdashbord.xsld.funnelchat":`Grafico dell'imbuto di vendita`,
"label.step1.total7":`Passo 1 di 7`,
"label.sendsms.batch.chosepersion":`SMS di massa: Seleziona i destinatari`,
"Lead.Scoring.Setting.Rule.Setup.Value":`Punteggio`,
"label.ccdocument.isdel.folder":`Sei sicuro di voler cancellare questa cartella?`,
"label.discard_change":`Sì, scartare le modifiche`,
"label.knowledgebase.assign":`Assegnare`,
"PersonalInfo_LoginHistory_001":`Broswer convalida il link di registrazione nella tua casella di posta elettronica`,
"label.globalselect.deletedvlaue":`Set di valori globali cancellati`,
"label.ems.lookup2":`Cerca`,
"label.dataimport.system.unable.determine":`il sistema non può determinare la perdita del`,
"label.weixin.invitation.consultant":`Consulente invitato`,
"label.salescloud.salesdashboard.phone.rankings":`Classifiche di composizione`,
"label.knowledgebase.plan.release":`Piano di pubblicazione`,
"label.integrations.first.half":`La vista attuale in totale`,
"label.icon.123":`Kit di primo soccorso`,
"label.leadscore.isactivity":`Attivo`,
"front-epwechat-module-v1-corpid":`WeCom ID (Corpld)`,
"label.createnewcustomer":`Nuovo account`,
"front-lightning-module-v1-details-page-chart-tittle":`È possibile inserire moduli di grafici e diagrammi nella pagina di dettaglio, e possono essere inseriti fino a 10 grafici di report. Per esempio, puoi aggiungere un modulo grafico di rapporto per un record con il tipo di record come Agente nell'oggetto Conti, aggiungere i grafici dell'importo delle vendite dell'ordine dell'agente e il rapporto delle vendite trimestrali dell'agente al modulo, e filtrare per il nome del conto per visualizzare i dati relativi direttamente nella pagina di dettaglio del conto dell'agente.`,
"label.customobjects.fieldsrelation":`Campi personalizzati e relazioni`,
"label.dashboardSetup.left":`Sinistra`,
"label.mobile.app.sectionpart":`Sezione App mobile`,
"setup.mainpage.label.welcome25":`Istruzioni: Clicca sul menu a sinistra di questa pagina → Gestisci impostazioni → Controllo sicurezza → Impostazioni di condivisione.`,
"label.custombutton.edit.error":`Errore: Il nome è già in uso o è stato usato in precedenza, scegli un nome diverso.`,
"label.icon.48":`Ventilatore di scarico`,
"label.tabularreport.step2":`Passo 2 Selezionare la colonna del rapporto`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.two":`Due`,
"UG_quota_01":`Gestire le quotazioni dell'account`,
"label.customcomponent.btn.usewhere":`Dove si usa questo?`,
"label.quickbooks.searchresault.email":`Email`,
"label.emailobject.appointment.urltext2":`prenota un tempo qui`,
"label.tianyancha.field.relation.error":`Impostare prima la relazione di mappatura tra il campo tianyancha e il campo cliente`,
"APPIntegration_Social_facebookerror":`Devi inserire un URL valido per facebook.com`,
"label.notification.arketsea.transfer":`{5} ha trasferito {0}：{1} da {2} a {3}`,
"lable.SalesCommitmentKanBan.allreceivingTaskRate":`Entrate totali Tasso di completamento delle attività`,
"UG.Account.04":`Filtraggio passivo dell'account della query`,
"this.week":`Questa settimana`,
"label.email.track.attachment.num.control1":`Il numero di file caricati supera i 10 e non può essere caricato`,
"label.exchange.sync.state.event":`Eventi`,
"vue_label_systemSettings_websitesetting":`Impostazione web`,
"vue_label_file_replace_reason":`Motivo della sostituzione`,
"label.version.feature":`Caratteristiche`,
"E":`Email`,
"label.escalation.setup.entrydetail.escalation.notifyTemplate":`Template`,
"label.chosesubject.meet":`Avere una riunione`,
"UG.ST.003":`Non hai il permesso di creare {0}, contatta l'amministratore, clicca su conferma per andare direttamente all'interfaccia {0}.`,
"label.authorization.failure":`Autorizzazione fallita. Si prega di riautorizzare!`,
"label.newprocessstep3":`Passo 3 Specificare il campo approvatore e le proprietà di modificabilità del record`,
"lable.outlook.mcto.mostrecord":`Record con il maggior numero di attività`,
"vue_label_normal_select":`Seleziona`,
"label.partner.workspace.login.buttontext":`Testo del pulsante`,
"template.chart.ydschdtj":`Statistiche mensili della campagna`,
"label.ServiceCloud.zichanmingcheng":`Nome della risorsa`,
"label.productsales.oppor.nooverdue":`Buon lavoro, nessuna opportunità in ritardo.`,
"label.appointment.wizard.subtitle3-5":`Venerdì`,
"label.payment.the.current.version":`Edizione corrente dell'abbonamento`,
"label.reportlist.top":`Fissato in alto`,
"label.emailobject.emaildetail.prompt":`Prompt`,
"label.weixin.endst":`L'ora di fine non può essere prima dell'ora di inizio.`,
"report_label_knowcreatehighlevelreport":`Come creare un rapporto avanzato?`,
"label.quickbooks.view.openestimates":`Stime aperte`,
"label.url.cannot.empty":`L'URL non può essere nullo!`,
"label.emailnoticetemplate":`Modelli di notifica via e-mail`,
"calendar.tips.task":`Nessun compito oggi`,
"label_partner_all_operate":`Operazione`,
"message.duplication.label.cancelbutton":`Cancella`,
"vue_label_SMS_addcontact":`Aggiungi un contatto`,
"label.martrixreport.setsumfield2":`Seleziona il campo utilizzato come colonna di riepilogo nel tuo rapporto di matrice`,
"approval_request_email_body":`I seguenti articoli stanno richiedendo l'approvazione: clicca sul link sottostante per approvare`,
"label.emailobject.emaildetail.field.record":`Record`,
"label.tab.page":`Pagina`,
"label_tabpage_prepagez":`Visualizzazione su ogni pagina`,
"label.iran.daylight.time":`Ora solare dell'Iran`,
"label.event.nextweek":`La prossima settimana`,
"fliter.lastmonth":`Ultimo mese`,
"label.group.no.recent.search":`Non ci sono gruppi visualizzati di recente che corrispondono.`,
"label.h5.act.confirm":`Confermare`,
"label_tabpage_mypotentialcustomers":`Le mie piste`,
"label.tabpage.queuez":`Coda`,
"label.batch.edit.description":`Seleziona i campi che vuoi modificare, seleziona almeno un campo e fino a 5.`,
"label.batchadd.newbatchpage.deltr":`Tenere in linea almeno.`,
"label.industrialandcommercialverification.instructions2":`La versione che state usando è gratuita, e il numero massimo di interrogazioni è di 10.000 volte al giorno. Se hai bisogno di espandere il numero di query, si consiglia di acquistare il servizio. Dopo aver acquistato il servizio, riceverai il token dal venditore, impostalo su questa pagina. Il venditore continuerà a fornirti il servizio a pagamento corrispondente.`,
"label.rejectrequestbehaviour":`Esegui tutti i rifiuti <strong>e</strong> tutti i rifiuti finali per questo passo. (Rifiuto finale)`,
"label.batchCopy":`Batch Clone`,
"label.service.two":`Alcuni filtri sono definiti ma non referenziati in Filtri avanzati.`,
"label.data.import.setup.detail.remark":`Se spuntate le seguenti opzioni, viene eseguita l'importazione dei dati.`,
"vue_label_file_delete_lib":`Cancellare la libreria di file`,
"label.integerdigit":`Il numero di cifre a sinistra della virgola decimale`,
"label.profile.standardobjcontrol":`Permessi standard per gli oggetti`,
"label.reportrecords":`Record`,
"label.noplan":`Non hai eventi in programma per i prossimi 7 giorni.`,
"label.visualpage.ytype":`Cruscotti`,
"label.branch":`;`,
"label.knowledgebase.new.article":`Nuovo articolo`,
"label.Addressbook":`Contatti`,
"label.delete.reward.groups":`Cancellare il gruppo di linee di quote`,
"label.appexchange.uninstallpage.message1":`Elimina definitivamente tutti i componenti di questo pacchetto (elencati di seguito)`,
"chatter.group.everyone":`Tutti gli utenti`,
"label.cooperation":`Cooperazione`,
"label.uploadfail":`Caricamento fallito`,
"to":`a`,
"button_partner_delete":`Cancellare`,
"attachment_select_warning_001":`L'allegato è archiviato e il pulsante Archivia non è disponibile, per favore riseleziona un allegato.`,
"label.step4.total4":`Passo 4 di 4`,
"label.login.access.avalid":`Scade oggi`,
"label.defaultview2":`Elenco pignorato`,
"vue_label_commonobjects_detail_style":`Stile d'acquisto`,
"label.selectfield":`Seleziona i campi`,
"label.report.select.column.collect":`Seleziona la colonna da riassumere`,
"lable.currencyAdv.newdaterate.existeddate":`La data è già utilizzata per HKD.Si prega di specificare una data di inizio diversa.`,
"pagecreator_systemstyle_button_new":`Nuovo stile`,
"label.ccchat.person.invite":`Invito dei colleghi`,
"label.sendemail.recycle.clear":`Riciclo chiaro`,
"label.usermanage.view.notexist":`La vista non esiste`,
"setup_chatter_enabled":`Non disponibile, contatta l'amministratore per abilitare CCChat.`,
"UG.Contract.01":`Gestire il contratto`,
"label.martrixreport.2018.step4":`Passo 4 Selezionare i criteri del rapporto`,
"message.errorinscript":`Problemi con lo script di esecuzione.`,
"label.knowledgebase.modification.date":`Data modificata`,
"label.projectManagement.the.maximum.number.of.fees.is.10":`Si possono inserire fino a 10 cifre per il costo`,
"label.list.isActiveNewApproval":`Attiva la pagina Nuova approvazione`,
"label.mobile.main.page.icon.setup":`Impostazioni dell'icona dell'applicazione mobile`,
"label.select.customer":`Selezionare l'account`,
"label.sharerule":`Impostazioni di condivisione`,
"label.fiscal.FY":`Anno fiscale`,
"label.appupload.component.type.customfield":`Campo personalizzato`,
"label.emailobject.emailsend.sendindividually":`Invia individualmente`,
"label.new_formname":`Nuovo nome del modulo`,
"label.appointment.wizard.notif1":`L'ora di fine non dovrebbe essere precedente all'ora di inizio`,
"front-console-conversation-evaluate-desc":`Risposta di valutazione da {evaluateInfoName}`,
"homepage.components.lasttime":`Data ultima modifica`,
"vue_label_commonobjects_view_chart_deletechart":`Cancellare il grafico`,
"label.multilang.document.upload.fail":`{0} i file sono stati caricati con successolt e {1} i file sono falliti`,
"UG_contact_03":`Traccia i contatti in un unico posto, segnali di vendita`,
"label.marketsea.istoseafromother":`Consentire il trasferimento da altri pool di piombo`,
"label.datamanage":`Amministrazione dei dati`,
"label.globaloperation.operationtype.create.data":`Creare record`,
"label.customer.tab.step2.see":`Visibilità delle schede`,
"label.wtd.changefields.desc":`Dopo che gli utenti inviano il modulo, saranno portati all'URL di ritorno specificato sul tuo sito web, come una pagina di ringraziamento.`,
"label.ems.eamilinfo":`Informazioni via e-mail`,
"label.recordtypeselect.new":`Nuovo tipo di record`,
"vue_label_report_output":`Tipo di uscita della formula`,
"label.emailnotice":`Allarme e-mail`,
"label.icon.196":`Carta igienica`,
"label.emailsync.status.disabel":`Inattivo`,
"label.tabpage.isdeleterecord":`Se cancella il record selezionato`,
"message.selectoneoftypes":`Si prega di selezionare uno dei seguenti tipi`,
"label.import.index.createid":`Crea ID`,
"vue_label_systemSettings_social2":`Impostazione dell'account dei social media`,
"label.ccpeak.sel.time":`Classi programmate in questa cartella`,
"label.data.downpage.i_list.desc1":`Durante l'importazione, i dati che non sono importati con successo perché i dati non sono formattati correttamente, o perché il trigger o la regola di convalida falliscono, generano il file CSV da visualizzare nella pagina corrente. I dati importati con successo non saranno visualizzati nella pagina corrente.`,
"label_adjust_forecast":`Regolare le previsioni`,
"vue_label_normal_lead_sf":`Piombo`,
"vue_label_report_notice1":`Il rapporto contiene modifiche non salvate. Se chiudi il rapporto, queste modifiche andranno perse. Clicca sotto il pulsante "Salva e chiudi" per salvare le modifiche.`,
"label.notfiledpublicreport":`Rapporti pubblici non depositati`,
"one":`Uno`,
"UG.Lead.008":`Codice di scansione del biglietto da visita`,
"label.archived":`Archiviato`,
"label.standardabstractfield":`Campi di riepilogo standard`,
"vue_label_notice_add_fail":`Aggiungere fallito`,
"label.sendemail.registIMUser.addresserror":`l'indirizzo e-mail del destinatario non è corretto`,
"label.ccdocument.toolbar.switch":`Interruttore della barra degli strumenti`,
"first":`Il primo`,
"label.icon.147":`Mouse`,
"vue_label_jihui_er":`Opportunità 2`,
"label.ccchat.micropost.isedit":`Modifica di post e commenti`,
"label.department.next":`Prossima pagina`,
"front-kefu-moudle-confirm-disable-phone-user":`Sei sicuro di disabilitare le chiamate in uscita per l'utente {0}?`,
"label.reportsSubscription.time.meets.subscription.frequency":`La data di inizio e di fine non corrisponde alla frequenza dell'abbonamento!`,
"lable.account.NextpDays":`I prossimi 120 giorni`,
"UG_opportunity_007":`Ruolo di contatto`,
"label.encrypt":`Crittografato`,
"label.knowledge.category.hint.three":`Elimina o sostituisce la categoria esistente, che rimuove tutte le catetogie associate all'articolo.`,
"label.customcomponent.usewhere.info":`I seguenti sono tutti i riferimenti a questo componente. Fai clic sull'etichetta di riferimento per visualizzare la definizione.`,
"vue_label_import_addandupdate":`Aggiungere e aggiornare`,
"label.email.all.members":`Invia a tutti i membri del gruppo via email`,
"component_task_button_save":`Salva`,
"label.file.deleted.unavailable.desc":`Il file è cancellato, inesistente o non disponibile ora.`,
"label.emailsync.status.viewlog":`Visualizza registro`,
"label.marketsea.othersetup":`Altre impostazioni`,
"label.data.exp.newtemppage":`Template Crea pagina`,
"vue_label_lead_score_successsful":`Segnato con successo`,
"label.sendemail.activity.newtask":`Caro #belongtoidccname, ciao:\r\n il tuo collega #createbyidccname ti ha assegnato un nuovo compito in #createdate, che recita come segue:\r\n subject:#subject\r\n due date:#expireDate\r\n related item: #relatedstr\r\n contenuto: #per maggiori dettagli, per favore visita questo link: #pathr\r\n #orgNameCRM system`,
"component.event.label.soon":`Immediatamente`,
"label.forecast.shrepage.getlist":`Torna a Gerarchia delle previsioni`,
"UG.solution.02":`La soluzione è una soluzione interna dell'istituzione al problema che i conti incontrano.`,
"label.weixin.data.approval":`Il disco è in fase di approvazione`,
"label.build.pagelist":`Elenco delle pagine del costruttore di pagine`,
"label.customsetting.type.hiberarchy":`Gerarchia`,
"label.forecast.ccfh":`Superare`,
"label.Current.Window":`Visualizzato in una finestra esistente`,
"label.appointmentdetail.wizard.title20":`Piano della domenica`,
"label.emailaddress":`Indirizzo di posta`,
"label.qetting_notifications":`Non ricevi le nostre email? Assicurati di aver aggiunto gli indirizzi email CloudCC alla tua allowlist e di aver attivato le notifiche di esportazione.`,
"Homepage.News.001":`Notizie`,
"label.runreport":`Rapporto di esecuzione`,
"label.customer.tab.step3":`Passo 3 Aggiungere alle applicazioni personalizzate`,
"label.dashboard.snapshot.refresh":`Aggiorna`,
"label.approvepagelayout3":`Approvare il layout della pagina`,
"vue_label_SMS_send_messages":`Inviare messaggi`,
"label.executestate.old":`Eseguito`,
"label.approvalstep3":`Passo 3 Selezionare l'approvatore assegnato`,
"label.step3.total6":`Passo 3 di 6`,
"front-kefu-moudle-v1-delete-templete":`Cancellare il modello`,
"label.data.downpage.e.title.num3":`3. Gli utenti possono creare modelli di esportazione secondo le loro esigenze e selezionare la voce "Export By Template", che può rendere l'operazione di esportazione più conveniente.`,
"label.attendance.outer":`Lavoratore mobile`,
"setup_layout_button_selectall":`Seleziona tutto`,
"chatter.photo.img":`La dimensione massima del file è di 2 MB.`,
"front-dynamiclayout-module-v1-required":`Il campo di {required} è impostato come richiesto.`,
"label.mytask":`I miei compiti`,
"label.edit.customerinfo":`Profilo dell'azienda Modifica`,
"label.processsetting.process.explain":`L'impostazione e l'utilizzo del processo permettono agli utenti di concentrarsi sugli elementi più importanti e mostrano loro parole chiave e suggerimenti al momento giusto per aiutarli a completare il processo.`,
"label.emailobject.subject":`Oggetto`,
"label.mobileapp.scansetting.message":`Selezionate se salvare le schede scansionate nel formato immagine nella relativa lista di "Note e Allegati" secondo il vostro scenario d'uso effettivo. <br>Abilita: la scheda scannerizzata viene automaticamente salvata nell'allegato durante il salvataggio del record. <br>Disabilita: salva solo il record.`,
"front-epwechat-module-v1-android-autograph":`Firma dell'app Android`,
"label_component_helper_potentialcustom":`I lead che ti sono stati assegnati oggi`,
"label.projectManagement.nodata.week.work":`Aggiungiamo dei compiti per organizzare meglio il lavoro di questa settimana.`,
"label_tabpage_rolez":`Ruolo`,
"label.importsourcestep4":`Passo 3 Importare i tuoi file`,
"label.icon.50":`Bussola`,
"lable.service.prompt":`Impossibile creare un nuovo campo, il numero di campi ha raggiunto il limite.`,
"label.campaign.channel.input.page":`Specificare una pagina web, generalmente impostando la homepage della campagna come pagina di ringraziamento.`,
"UG.homepage.001":`Vincere più affari in meno tempo`,
"label.step4.total6":`Passo 4 di 6`,
"label.partner.required":`Errore: il dominio non può essere vuoto`,
"label.tag.manage.title":`Gestire- {0}`,
"label.data.downpage.i_title.num1":`1. Il sistema supporta solo il formato comune CSV.`,
"label.custom.quarter.end":`Data di fine trimestre personalizzata`,
"label.layout.distribute":`Assegnazione del layout di pagina`,
"label.version.allsms":`Mas SMS`,
"label.tolead":`Importazione`,
"label.texttemplate.usemergefields":`Usa i campi incorporati nel modello SMS.`,
"label.emailobject.sure":`Certo`,
"lable_setup_mobilesetup_isenbaleh5newandedit":`Se abilitate l'h5 nel vostro lato mobile e modificate`,
"label.tabpage.messagez":`Si prega di inserire un commento`,
"label.mobile.phone.write.day.report":`Nuove note di lavoro giornaliere`,
"label.data.setok.e.desc2":`Esportazione della pagina dell'elenco dei dati`,
"label.emailsync.message":`Prompt`,
"label.sales.page.mubiao":`Raggiungere l'obiettivo`,
"label.ccdocument.list":`Visualizza il tuo ultimo documento`,
"label.tabpage.userGuidez":`Guida per l'utente`,
"label.report.fields":`Campi disponibili per i rapporti`,
"vue_label_checkduplicate_at_same_time":`Soddisfare tutti allo stesso tempo`,
"label.sms.phone":`Telefono di servizio`,
"UG_ST_004":`Non hai il permesso di gestione dei dati - "importazione dei dati, contatta l'amministratore, clicca su conferma e vai direttamente all'interfaccia {0}.`,
"label.mobile.nobindmobile":`Questo numero di cellulare non esiste ora. Si prega di legare il numero di cellulare dalle informazioni dell'utente`,
"label.partnerCloud.basicSetting.intro":`CloudCC supporta la creazione di più siti per i partner di diversi tipi e configura separatamente la pagina di login, i menu e i permessi. Per esempio, i rivenditori possono creare vari siti per agenti locali e partner pubblicitari.`,
"label.trigger.targetobject":`Oggetti di destinazione`,
"label.ems.emailsyncperiod":`Periodo di sincronizzazione delle e-mail`,
"lable.Transformation.mode":`Modalità di trasformazione`,
"label.emailobject.new.template":`Aggiungi nuovo modello`,
"label.System.Setting":`Impostazioni di sistema`,
"label.emailtocloudcc.button.addemailaddress":`Aggiungere una cassetta postale aziendale`,
"lable.a.total.of.invoices":`0 fattura in totale`,
"label.multilang.customforcast.forecasthistory":`Storia delle previsioni di {0}：`,
"label.role":`Ruoli`,
"advancedconditions":`Condizioni di filtro avanzate`,
"label.tabpage.beginz":`Iniziare`,
"label.campagin.roi.khzhsl":`Quantità di conversione del conto`,
"chatter.poll.option5":`Scelta 5`,
"label.weixin.horse.club.registered":`Registrazione degli utenti di Aid-Max`,
"frame_personinfo_label_resizeimage":`Per fare delle modifiche alla tua immagine di anteprima, trascina e ridimensiona le linee tratteggiate nella tua foto del profilo qui sopra.`,
"label.file.share.select.warning":`È stato impostato per la condivisione!`,
"label.event.this.week":`Questa settimana`,
"label.data.import.object.label":`Etichette dell'oggetto`,
"label.visualpage.folder":`Cartelle di pagine non archiviate`,
"vue_label_report_saveandclose":`Salva e chiudi`,
"label.newdashboardpage.saveto":`Salvare a`,
"label.partnerCloud.financeSetting.developerIDTwo":`ID sviluppatore`,
"lable.PowerProcess.created.ago.please":`Prima di creare un processo, per favore`,
"label.chatter.myfollowers":`I miei seguaci`,
"label.campaignmember.main.duplicatelist.title":`Membri della campagna: Scansione del codice per trovare le impostazioni duplicate`,
"label.group.no.recent2":`Trova i gruppi a cui unirsi`,
"label.icon.110":`Libro`,
"label.merge.my.account":`Unire i miei conti`,
"setup.layout.button.quicksave":`Salvataggio rapido`,
"pagecreator.page.message.canntdelete":`La pagina corrente non può essere cancellata`,
"label.report.printable.view":`Vista stampabile`,
"ccchat_fieldtrack_fieldchange":`Cambia da {0} a {1}`,
"label.email.bcc":`Bcc`,
"label.sso.saml.sp.idpcert":`Certificato del fornitore di identità`,
"label.step2.total2":`Passo 2 di 2`,
"lable.product.pricebooks.isn":`Libri a prezzo attivo`,
"labal.emailtemplate.namemassage":`Il nome unico del modello di posta esiste già, per favore riedita`,
"only.one.field":`Si può selezionare solo un campo.`,
"label.weixin.appr.audittime":`Data di approvazione`,
"pagecreator.page.button.delete":`Cancellare`,
"front-kefu-moudle-v1-Session-start-time":`La sessione inizia a:`,
"label_chatter_state":`Stato`,
"vue_label_systemSettings_lightningcustom":`UI personalizzata in Lightning`,
"label.searchs":`Cerca`,
"label.mobile.phone.not.read":`Unrevised`,
"label_chatter_allweather":`Tutto il tempo`,
"label.enter.number":`Inserisci un numero intero tra 0-6.`,
"front-epwechat-module-v1-addressbook-desc":`Se abilitato, i contatti e i reparti in WeCom saranno sincronizzati con gli utenti e i ruoli di CloudCC`,
"label.emailfield":`Campi e-mail`,
"pagecreator_button_next":`Prossimo passo`,
"label.more.select.merge.records":`Si possono selezionare solo fino a 3 dati da unire`,
"lable.edit.queue.selobjct":`Oggetti selezionati`,
"label.reportsSubscription.editsubscribe":`Modifica abbonamento`,
"label.selectfieldtoautotransmit":`Seleziona il campo utilizzato per l'inoltro automatico dell'approvazione`,
"label.ccpeak.need.topass":`Necessità di passare in`,
"label.checkfield.merge":`Unire`,
"front-lighting-module-v1-detail-file-downlaodInfo":`Il record è bloccato e non è disponibile per il download di file. Si prega di contattare l'amministratore per lo sblocco.`,
"vue.please.enter.a.chart.name":`Inserisci il nome del grafico.`,
"label.data.dataexptemplate.desc3":`3. La modalità di esportazione è valida solo per i dati esportati e non è valida per il modello di esportazione. Il formato del file per il modello di esportazione è CSV.`,
"label.setup.mobile.homepageshortcuts.setting":`Impostazioni della funzione swift della homepage`,
"label.ems.connect.success":`Test dell'e-mail riuscito`,
"label.applet.text":``,
"label.knowledgebase.parent.window":`Finestra dei genitori`,
"label_file_size":`Spazio utilizzato`,
"label.allocation.department":`Assegnare gli utenti`,
"label.browser":`Browser`,
"label.reportsSubscriptionPage.schedulereport.weekly.wednesday":`Mercoledì`,
"label.integrations.description1":`Esportare i dati nella vista corrente`,
"label.project360":`Progetto 360`,
"label.choose_formtype":`Scegliere il tipo di modulo`,
"label_emailsync_status_connectstatus":`Stato della connessione`,
"label.bmap.beijing.city":`Pechino`,
"label.mask.encryption.scheme":`Formato crittografato`,
"label.imgfield.type":`Tipo di immagine`,
"label.person.target.responsible":`Seleziona il supervisore dell'obiettivo.`,
"label.appexchange.installedpage.installdate":`Data di installazione`,
"label.partnerCloud.orderingPlatform.partnerUsers":`Questa funzione è disponibile solo per gli utenti partner.`,
"label.profile.customfieldsafety":`Sicurezza personalizzata a livello di campo`,
"label.no.target.models.available.":`Nessun modello di indicatore disponibile. Per favore, crea un modello di indicatore o contatta l'amministratore.`,
"label.process.execute.tip":`La tua richiesta è stata elaborata, l'approvazione o il rifiuto di massa richiederà un po' di tempo, e il sistema ti informerà per posta quando l'elaborazione sarà completata.`,
"label.app.step2.introduce":`Inserisci i seguenti campi per definire l'applicazione personalizzata`,
"label.loginip.cue":`Nessun intervallo IP è specificato e gli utenti da qualsiasi indirizzo IP sono autorizzati ad accedere.`,
"label.step1.select.tablayout":`Passo 1 Scegliere il layout delle schede`,
"mainpage.setup.chosecomponent.leastone":`Devi selezionare almeno un componente nella homepage.`,
"label.custom.quarter.name":`Nome del quartiere personalizzato`,
"chatter.ptup.link":`Pubblica un link`,
"label.compact.layout.frame.error2":`Le informazioni dettagliate e la relativa lista devono essere sullo schermo di sinistra`,
"vue_label_salesfunnel_notice7":`Numero totale di opportunità di business con una probabilità del 100%/numero totale di opportunità di business con una probabilità dello 0% o del 100%`,
"label.multilang.datamanage.dataimport.lostmsg":`La lunghezza del titolo è &nbsp;{0}&nbsp;, ma la lunghezza dei dati è &nbsp;{1}&nbsp;, il sistema non può determinare quali &nbsp;{2}&nbsp; campi sono ridondanti.`,
"label.owner.notnull":`Il proprietario non può essere vuoto`,
"label.logintime.pagecue.invalidt":`L'ora di inizio non può essere maggiore dell'ora di fine.`,
"vue_label_file_checked_num_limit":`Il numero di file selezionati supera il limite`,
"front-email-payment-repayments":`Paga di nuovo`,
"template.report.today.prospects":`Leads di oggi`,
"label.weixin.appr.status":`Stato`,
"label.knowledge.language.japanese":`Giapponese`,
"label.event.reminder.lead.time":`Promemoria`,
"lable.custom.dep":`Clicca sul pulsante Nuovo per definire un nuovo anno personalizzato.`,
"Dashboard_View_Createdbyme":`Cruscotti creati da me`,
"label.file.upload.fail":`Caricamento del file fallito`,
"label.manager":`Manager`,
"label.stdashbord.xsld.business.jine":`Importo`,
"label.tag.manage.tag":`Tag`,
"chatter.nlk":`A differenza di`,
"label.file.search.people":`Cerca persone`,
"message.error.domain.format":`I nomi di dominio possono consistere solo in inglese e in array`,
"label.firstisdefault":`Usa il primo valore come valore predefinito`,
"label.discount":`Sconto`,
"label.mobile.phone.have.read":`Rivisto`,
"label.field_selected":`Questo campo è stato selezionato`,
"label.payment.renew.now":`Rinnovare ora`,
"label.multilang.lookfiltercondition.notsetup":`La condizione della linea {0} non è corretta, nessun operatore è impostato!`,
"label.projectManagement.Selectionday":`Seleziona il giorno`,
"label.user.organization.permit.licensenotstart":`La licenza della tua organizzazione non è stata attivata, riprova dopo aver attivato la licenza`,
"label.download.save.attachment":`Scaricare e salvare in allegato`,
"lable.outlook.mcto.must":`Deve essere in formato e-mail.`,
"vue_label_notice_unfollow_success":`Deselezionare con successo`,
"label.taskinfo":`Passo 2 Configurare l'attività`,
"label.other.SMS":`Altri numeri di telefono`,
"label_partner_workspace_login_logo":`Logo dell'intestazione`,
"label.weixin.data.lock":`Il disco è bloccato.`,
"label.Yaxis":`Asse Y`,
"lable.edit.queue.selobjdes":`Seleziona gli oggetti che vuoi assegnare a questa coda. I record individuali per quegli oggetti possono poi essere posseduti da questa coda.`,
"label.campagin.roi.dcfezb":`Tasso di partecipazione`,
"label.marketseamemset.maximum":`Importo massimo`,
"label.owner":`Proprietario`,
"label.reportsubscribe.error.noview":`Per favore, compila l'utente con cui vuoi eseguire questo rapporto in "Running as" (Esecuzione come)`,
"label.icon.133":`Cartella`,
"vue_label_file_share_files":`documenti condivisi`,
"label.searchlayoutfilterfields.remark":`Seleziona le colonne dei campi filtro da distribuire durante la ricerca nella barra laterale della homepage e la ricerca nella home page della scheda.`,
"vue_label_help_contract":`Contratto e piano di raccolta`,
"component.chatter.button.message":`Commento`,
"label.marketsea.recyclereminddays2":`Giorno di promemoria (deve essere inferiore al numero di giorni senza follow-up dopo l'ottenimento)`,
"label.webtocloudcc.input.information":`Le informazioni sono richieste.`,
"vue_label_chatter_exit_group":`Lasciare il gruppo`,
"vue_label_lead_notcreatetask":`Non creare attività`,
"front-lightning-module-v1-dashborad-date-dimension":`Dimensione della data`,
"setup.layout.label.fieldlist":`Campi disponibili`,
"label.leadscore.charname":`Nome del campo`,
"label.forecast.customforecast.mybest":`Il mio caso migliore`,
"setup_mainpage_label_welcome24":`La piattaforma cloud CloudCC fornisce impostazioni di accesso di sicurezza per tutti i dati degli oggetti nel sistema. La condivisione dei dati e i diritti di accesso possono essere controllati impostando varie regole e condizioni.`,
"label.queue":`Code`,
"label.icon.159":`Chip`,
"label.path":`Percorso di riferimento`,
"label.app.message.failtoget":`Impossibile ottenere l'elenco delle applicazioni`,
"label.returntoprocess":`Torna alla lista: Processi di approvazione`,
"vue_label_commonobjects_detail_more_data":`Non ci sono più dati`,
"label.number":`Numero`,
"label.product.find":`Trova i prezzi dei libri`,
"label.legend":`Leggenda`,
"label.partner.workspace.member.profile":`Profili disponibili`,
"label.service.gantt.sum.appointments":`Appuntamenti di servizio completati/Tutti gli appuntamenti di servizio`,
"label.partnerCloud.financeSetting.paymentAllowed":`Permettere la ricarica online`,
"label.integrations.upgrate":`Aggiornare`,
"label.timzone.tip.info3":`Quando usi la classe calendar per elaborare le date, dovresti impostare il fuso orario per l'istanza del calendario, e puoi selezionare uno dei due metodi seguenti per ottenere gli oggetti del calendario: Calendar cal=Calendar.getInstance(TimeUtil.getUserTimeZone(userInfo))和Calendar cal=TimeUtil.getCalendar(userInfo)`,
"label.ems.addaccount2":`Aggiungi un account di posta elettronica`,
"label.partneruser":`Utente partner`,
"label.validate.globalvariable.user.roleId":`ID del ruolo`,
"pagecreator.layout.button.mergecell":`Unire le celle`,
"label.evacuantvalue":`Escludi valori`,
"label.setup.mini.msg":`Impostazione della storia del marchio/messaggio`,
"label.icon.178":`Persone`,
"vue_label_pricebook_notice_cantbedeleted":`Le voci del listino prezzi non possono essere cancellate perché ci sono già dei record applicati al listino. Puoi invece marcare le voci del listino come inattive.`,
"vue_label_appstore_application_recommendation":`Raccomandazione di applicazione popolare`,
"label.version.createlimit":`La tua attuale edizione di CloudCC è {0}, e puoi creare {1} {2}. Ora, il numero di {2} ha superato il massimo del tuo piano di abbonamento, aggiorna la tua edizione CloudCC.`,
"message.duplication.label.sectionremar1":`Seleziona i valori che vuoi mantenere nel record unito. Le righe evidenziate indicano i campi che contengono dati in conflitto. Il record principale selezionato manterrà i valori dei campi di sola lettura e nascosti.`,
"label.icon.1":`Cloud`,
"label.salescloud.salesdashboard.sales.performance":`Risultati complessivi del contratto di vendita`,
"System_AddressFieldType_Post":`Codice postale`,
"setup_object_field_dependency_label_mustone":`Dovete selezionare almeno 1 valore del campo dipendente.`,
"label.appointmentdetail.wizard.title6":`Posizione`,
"label.layout.testobj2":`Oggetto di prova 2`,
"label.searchlayout.dupcacher.field":`Clicca sul link Find Duplicates and Merge per visualizzare i campi duplicati.`,
"label.attendance.persons.title":`Utenti adatti`,
"template.report.product.sales":`Vendite di prodotti`,
"label.editCustomReportType":`Modifica dell'origine dati del rapporto personalizzato`,
"label.multilang.ui.setup.profile.alltime":`Tutti i tempi sono {0}`,
"label.service.dispatchingUnits.noservice.booking":`Nessun appuntamento di servizio`,
"label.validate.remark4":`Assicurarsi che il numero sia all'interno di un intervallo specifico, come lo sconto inferiore al 30%`,
"front-kefu-moudle-v1-Waiting-time":`Tempo di attesa:`,
"label.weipagelayout.remark":`Usato nell'app mobile o nella pagina WeChat`,
"vue_label_wang_er":`Michael`,
"label.pw.text":`Inserisci la password di {user} e assicurati che contenga almeno`,
"message.error.user.data.null":`Le informazioni dell'utente non possono essere vuote!`,
"chatter.like.p":`Come questo post`,
"label.page.double.column.style.cloudcc":`Lo stile a 2 colonne fornisce utili funzioni di CloudCC.com, come Ricerca e Articoli recenti, sulla stessa pagina del tuo contenuto incorporato.`,
"label.h5.iscloseaccount":`Sei sicuro di voler uscire?`,
"label.dataimport.insertdata.id.error":`Errore di formato, si prega di utilizzare una combinazione di lettere e numeri.`,
"label_tabpage_sum":`Totale`,
"front-epwechat-module-v1-addressbook-sync":`Sincronizzare la rubrica dei contatti`,
"label.setup.mobile.offlinecache.mostsave":`La piattaforma può impostare la scheda offline lato mobile abilitata di default fino a 10`,
"label.weixin.quickcreate":`Creazione rapida`,
"label.forecast.edittotal.de.mubiao":`Quota`,
"label.icon.144":`Garanzia`,
"label.icon.155":`Immagine`,
"label.In.the.search":`Ricerca su`,
"message.validation.isnotdateISO":`Data non valida (ISO)`,
"label.service.appointmentList.send.successfully":`Spedizione avvenuta con successo`,
"label.dynamicpage.error.exist":`I dati del layout di pagina dinamico non esistono`,
"vue_label_SMS_otherpeople":`e {0} altri`,
"label.cloudccsite.url":`URL del sito`,
"label.tabpage.contactsz":`Contatti`,
"vue_label_commonobject_notice_clickthename":`Se hai bisogno di scaricare il file caricato, clicca sul nome del file`,
"vue_label_file_new_lib":`Nuova libreria di file`,
"label.chatter.card":`Scheda`,
"chatter.feed.menutype.user.allusercom":`Tutti i colleghi`,
"label.exchange.sync2":`Impostazioni`,
"template.report.year.income":`Entrate di quest'anno`,
"label.partner.template.detail":`Descrizione delle funzioni`,
"label.setup.service.template":`Modello di rapporto di servizio`,
"label.dataimport.insertdata.id.length":`Errore di formato, si prega di controllare questo record e modificarlo. Si prega di notare che la lunghezza inferiore a 20 caratteri.`,
"label.partnerCloud.financeSetting.collaborator":`ID del cooperatore`,
"label.processskipwizard":`Processo di approvazione Jump Start Wizard`,
"label.weixin.inputbusnumber":`Inserisci il numero di targa`,
"label.dashboardSetup.d1":`Punto di rottura 1`,
"template.report.conversions.number.industry":`Numero di conversioni di lead (per settore)`,
"vue_label_chat_group_chat":`chat di gruppo`,
"label.file.publicview.error":`Il file è cancellato o non esiste o non può essere visualizzato in anteprima`,
"label.customfields.location.locationHelpText":`Si prega di inserire il nome di una località, come ad esempio "sede centrale". Sii descrittivo e specifico, e tieni presente che un record può avere più località come "ufficio vendite della costa occidentale" e "ufficio vendite della costa orientale".`,
"message.duplication.label.blankmatchtip":`Impostare il campo vuoto per corrispondere, l'impostazione predefinita è False`,
"message.appexchange.addtopackage":`Scegli uno o più componenti da aggiungere a questo pacchetto!`,
"label.ems.return2query":`Torna alla pagina di interrogazione degli account e-mail aggiunti`,
"label_model_name":`Nome del modello`,
"label.apiname.retainapi":`Il nome è il nome riservato del sistema, si prega di utilizzare un nome API di campo diverso.`,
"lable.Cancel.the.search":`Annulla la ricerca`,
"label.custom.viewport":`Punto di vista`,
"label.weixin.polls.type":`Tipo`,
"label.opportunity.setting.showstage.label":`Promozione auto`,
"label_component_helper_businesschange_expiredtask":`Opportunità con compiti in ritardo`,
"label.operator":`Operatore`,
"label.ccpeak.use.class.time.listmap":`Accedere passando la collezione List<Map>`,
"component_timeline_label_past":`Attività passate`,
"label.mobile.phone.submit":`Inviato da me`,
"message.recordtype.new.subtip":`Inserite un nome e una descrizione per il nuovo tipo di record. Il nuovo tipo di record includerà tutti i valori dell'elenco di selezione del tipo di record esistente selezionato di seguito. Dopo aver salvato il nuovo tipo di record, sarà possibile personalizzare i valori dell'elenco di selezione.`,
"UG_product_05":`Prodotto d'importazione`,
"label.validate.globalvariable.user.id":`ID utente`,
"label.umeng.activity.distribute":`che assegnate a`,
"label.weixin.avote":`Vota`,
"label.weixin.already.sign":`Già iscritto.`,
"label.emailmerge.mergepage.generator":`Genera`,
"label.batchtransfer.transferto":`Trasferimento a`,
"label.tianyancha.industry":`Industria`,
"label.addattachment.name":`Nome del file`,
"label.customfields.formula.date.tip":`Per calcolare una data, per esempio, aggiungere giorni ad altre date o sottrarre giorni da altre date.`,
"label.partnerCloud.orderingPlatform.noPayment":`Non pagare`,
"label.emailobject.failedtosend":`Fallito l'invio`,
"label.knowledge.setting.data.three":`Si può selezionare un massimo di {conteggio} di dati di gruppi di categorie.`,
"label.weixin.input.maxlength.langtext":`Inserisci qui, fino a 32000 caratteri`,
"vue_label_calendar_delete_calendar":`Cancellare il calendario`,
"vue_label_commonobjects_detail_filter":`Filtro di chiusura`,
"setup.layout.group.custompage":`Personalizza la pagina`,
"component_sendmail_label_subject":`Tema`,
"label_tabpage_maxfilez":`La dimensione massima del file è`,
"label.logintime.pagecue":`Seleziona la data e l'ora in cui gli utenti con questo profilo possono accedere. Nota che l'ora esatta del fuso orario specificato viene usata per tutti gli orari. Anche se l'utente si trova in diversi fusi orari, questi orari esatti sono usati per il tempo di login.`,
"label.salescloud.salesdashboard.datetime":`Data di chiusura`,
"label.format":`Formato`,
"label.newfoundland.daylight.time":`Ora legale di Terranova`,
"front-kefu-moudle-v1-messagetemplate.finishdetailinfo":`Copia e incolla il valore del campo merge nel contenuto dell'SMS`,
"message.chooseatleastoneforshare":`Seleziona almeno un utente da condividere`,
"label.multilang.datamanage.importobjfield":`Colonna {0}`,
"label.denglu":`Accesso`,
"label.popup.infoz":`Prompt`,
"label.schedulejob.setup.schedule.onday":`Ogni mese`,
"label.appointmentdetail.wizard.title16":`Piano del mercoledì`,
"label.userphoto.dragtoadjust":`Trascinare per regolare la miniatura`,
"label.product.series":`Famiglia di prodotti`,
"message.view.kanban.not.set.group.summary.field":`Il cruscotto di visualizzazione non imposta il campo di riepilogo del gruppo`,
"page.un.activities":`Attività non iniziate`,
"label.exchange.sync3":`Configurazioni`,
"label.login.activityExpired":`Il periodo attivo dell'utente è scaduto, contatta l'amministratore del sistema.`,
"component_chatter_file_button_files":`Seleziona un documento`,
"message.onlydelete.type":`Puoi cancellare solo i tipi di record inattivi. Quindi puoi disattivare prima i tipi di record se vuoi eliminarli.`,
"message.recordtype.selectlayouttouse":`Layout di pagina da usare`,
"label.knowledgebase.unable.restore.draft":`Non è possibile recuperare le bozze cancellate.`,
"label.shangqing.name":`Informazioni commerciali`,
"label.weixin.target.payment":`Obiettivo di pagamento`,
"label.chatter.sendEmailToGroupMember.check":`Visualizza i messaggi`,
"front-kefu-moudle-v1-input-single-login-area":`Inserisci il nome del dominio single signon`,
"vue_label_zhang_yi":`Alice`,
"label.icon.190":`Asciugacapelli`,
"label.quickbooks.fieldlabel.company":`Azienda`,
"vue_label_email_are_you_sure_to_delete":`Sei sicuro di cancellare la posta?`,
"Pagelayout.Setup.005":`Il nome deve essere messo al primo posto.`,
"label.object.name.two":`Nome dell'oggetto 2`,
"label.tabpage.completez":`Segna lo stato selezionato per completare`,
"label.setup.mobile.bottombutton.saveerror":`Impossibile salvare le impostazioni della pagina di primo livello`,
"label.report.action.addtodashboard8":`Seleziona la cartella Dashboard`,
"label.data.downpage.i_list.desc3":`Gli utenti possono visualizzare il motivo dell'importazione fallita nell'ultima colonna del file dopo il download.`,
"label.layout":`Layout`,
"label.marketsea.button.assign":`Assegnare`,
"UG.solution.03":`Creare una soluzione`,
"label.ccchat.person.invited":`Invitare i colleghi`,
"label.ccchat.person.invite.address":`Destinatario`,
"label.displaytype1":`Link alla pagina dei dettagli`,
"label.tianyancha.h5.ziranrengudong":`Azionista persona fisica`,
"lable.SalesCommitmentKanBan.targetReceipts":`Obiettivo entrate`,
"message.error.getitems.type":`getItems:type non può essere vuoto`,
"label.addattachment.list":`I seguenti file sono stati caricati`,
"label.datamanage.export.false":`Si è verificato un errore durante l'esportazione.`,
"pagecreator.systemstyle.label.buttonfontcolor":`Testo del pulsante`,
"label.emailtocloudcc.redmessage1":`Indirizzo e-mail non valido`,
"label.weixin.polls.closed":`Il voto è chiuso, la scadenza è`,
"label.icon.165":`Cappello`,
"vue_label_report_detailsonly":`Solo dettagli`,
"component.salesperformance.label.100finish":`Finito`,
"november":`Novembre`,
"label.data.file.generatejwd":`Generare il servizio di latitudine e longitudine secondo l'indirizzo`,
"label.salescloud.opportunity.access":`Opportunità Accesso`,
"label.isremider.remider":`Promemoria`,
"vue_label_total":`Totale`,
"label.email.prompt.using.lightning.link":`Imposta il link email nelle notifiche di sistema in modo che sia coerente con i link Lightning.`,
"label.knowledgebase.cancel.attached.articles":`Cancellare l'articolo allegato`,
"label.version.custom.xslc":`Processo di vendita personalizzabile`,
"component_setup_button_save":`Salva`,
"label.ems.cc":`Cc`,
"label.edit.user":`Utenti Modifica`,
"label.emailtocloudcc.select2":`Si prega di scegliere il tipo`,
"label.industrialandcommercialverification.fieldnumber":`No. di campi mappati:4`,
"label.ccchat.havenot.joined.group":`Non sei in nessun gruppo attivo`,
"pagecreator_page_label_pagename":`Nome della pagina`,
"setup.layout.button.save":`Salva`,
"label.campaignmember.main.updatestatus":`Aggiornamento di massa dello stato dei membri della campagna`,
"label.tab.web.edit":`Modifica scheda web`,
"label.ring_chart":`Grafico della ciambella`,
"label.usermanage.resetpwd.error":`La reimpostazione della password non è riuscita e l'utente non esiste.`,
"label.Xaxisscope":`Portata dell'asse X`,
"label.app.new":`Nuova App personalizzata`,
"message.modifythereport":`Il cruscotto utilizza questo rapporto. Le modifiche possono invalidare la dashboard che fa riferimento a questo rapporto.`,
"label.component.helper.businesschange.0activity":`30 giorni senza alcuna attività`,
"label.weixin.fmu.noon":`{0} PM`,
"label.enter.rule.name":`Inserisci il nome delle regole`,
"lable.Confirm.recovery.potential.customers":`Conferma il recupero della pista {nome}.`,
"lable.PowerProcess.type.created":`Che tipo di processo di diritti volete creare?`,
"front-lightning-module-v1-dashbord-rectangle-size":`Dimensione Ortogon`,
"label.projectManagement.new.service.appointment":`Nuovo appuntamento di servizio`,
"label.multilang.totalpage2":`Un totale di`,
"pagecreator.systemstyle.label.styledesc":`Descrizione dello stile`,
"chatter.up":`Caricamento di`,
"2018UI_Homepage_DataDeleted_Info":`I dati che vuoi visualizzare sono stati cancellati, clicca per tornare al passo precedente.`,
"label.knowledge.draft.recordid":`L'ID della bozza non può essere nullo!`,
"vue_label_pool_recyclecertification":`{0}{1}{2}{3}？`,
"label.setting.intergrationlist.viewall":`Vedi tutta l'integrazione`,
"vue_label_file_num_limit_tip":`Il numero di file supera il numero preimpostato. Se hai bisogno di sostituire i file, cancella prima i file caricati`,
"vue_label_commonobjects_view_refreshat":`Aggiornato a {timeInterval} fa`,
"laebe.data.exp.save.success":`Se avete bisogno di usare questo modello per esportare i dati, tornate alla sezione "Esportazione per modello" per operare.`,
"label.mr.caption.contact":`Trova i duplicati e unisci: Codizioni per la ricerca di duplicati di contatti`,
"label.webtocloudcc.submit.error":`Fallimento della presentazione`,
"label.multilang.datadelete.delmessage":`I record bloccati ({0}) non possono essere cancellati:`,
"label.quickbooks.searchlist.total2":`Ci sono {0} pagamenti non collegati per un valore totale di {1}`,
"label.createnew":`Crea nuovo...`,
"component.milestones.label.choicestate":`Confermare questo stato`,
"lable.outlook.edit.exist":`Questo nome di campo esiste già. Inserisci un nome di campo unico.`,
"vue_label_dashboard_eachother":`Solo le viste dello stesso rapporto o dello stesso oggetto possono essere collegate`,
"label.new.role":`Nuovo ruolo`,
"message.error.operationType":`L'operazione non è definita quando si chiama un servizio.`,
"label.fenbeitong.name":`FenBeiTong`,
"label.choose.person":`Seleziona i destinatari da inviare`,
"label.attendance.thanks":`Grazie per la tua partecipazione !`,
"label.invoice.message.statusupdatefailed":`L'aggiornamento dello stato della fattura non è riuscito, riprova più tardi.`,
"template.chart.yzhqzkhlyfx":`Analisi della fonte del lead convertito`,
"chatter.feed.menutype.user.alluser":`Tutti i colleghi`,
"UG_Forcast_04":`Iniziare il processo`,
"label.appupload.upload.tips.profile":`Nota: il componente "profilo" è stato aggiunto a questo pacchetto e non può essere aggiunto di nuovo (è permesso aggiungere fino a un componente di profilo per pacchetto).`,
"lable.PowerProcess.leave.the.process":`{descrivereNome} Esci dal processo`,
"template.report.sales.cycle.opportunities":`Durata del ciclo di vendita (per tipo di opportunità)`,
"vue_label_calendar_please_fill_in_the_calendar":`Si prega di compilare il nome del calendario`,
"label.salescloud.unit.wanyuan":`unità ( Yuan cinese)`,
"label.fileAPI":`Nome unico del documento`,
"label.weixin.link":`Relativo a`,
"label.service.seconds":`secs`,
"label.encd.visible":`Campo crittografato visibile`,
"label.tianyancha.regstatus":`Stato operativo`,
"label.event.moveup.18hour":`18 ore avanti`,
"label.upper.bound":`Limite superiore`,
"label.please.insertURL":`Inserisci l'URL da inserire.`,
"label.approval.notallowed.reject":`Rifiuto non consentito`,
"label.permission.fieldpermission":`Impostazioni dei permessi di campo`,
"label.customcomponent.page.index.title":`Componenti personalizzati`,
"label.quickbooks.viewlist.number":`NO.`,
"lable.list.queue.sendemail":`Inviare e-mail ai membri`,
"label.productsales.today.noevtadd":`Non ci sono eventi aperti, puoi cliccare su " " nell'angolo in alto a destra per aggiungere un nuovo evento.`,
"label.report.line.daixuan":`Colonna dei rapporti in sospeso`,
"label.reportsSubscription.select.start.endtime":`Si prega di selezionare l'ora di inizio e di fine!`,
"template.chart.schdyscb":`Costo preventivato delle campagne`,
"label.sendemail.chat.addPostatsubject":`Sono stato menzionato nel micropost di CloudCC CCChat`,
"label.RelatedList":`Elenchi correlati`,
"label.knowledgebase.delete.translation.associated.with.draft":`Le bozze di traduzione esistenti saranno collegate all'ultima versione pubblicata dell'articolo in lingua madre. Se non esiste alcuna versione pubblicata, tutte le traduzioni saranno cancellate.`,
"vue_label_chatter_submitted_review":`Hai presentato una domanda di adesione, aspetta che l'amministratore la esamini`,
"label.layout.list2":`Elenco 2`,
"label.manage.area":`Gestire i territori`,
"label.manageapproveprocess":`Gestire i processi di approvazione per`,
"workflow.action.tasks.assignortype.created":`Creato da`,
"label.custombutton.nonsupport.operation":`La versione attuale non supporta il funzionamento dei pulsanti e dei link standard.`,
"label.ip":`Indirizzo IP`,
"label.chat.topic.desc.error.info":`La descrizione del tema non può superare i 1000 caratteri. Prova a usare una descrizione del tema più corta.`,
"label_tabpage_cue":`Promemoria delle informazioni`,
"label.integrations.mailchimp1":`Integrando CloudCC con MailChimp, i tuoi utenti saranno in grado di importare lead e contatti selezionati dal tuo account CloudCC a MailChimp.`,
"label.email.track.required":`Informazioni richieste`,
"label.set.case":`Si prega di impostare prima il proprietario del caso.`,
"label.weixin.newspaper.coverage.number":`Numero della scheda di rischio`,
"vue_label_approve_submitreason":`Motivo della presentazione`,
"message.oppdt.noenabledpricebook":`Nessun libro dei prezzi attivo`,
"label.partner.workspace.setup":`Impostazioni`,
"label.version.nonsupport.feature":`Questa funzione non è temporaneamente supportata, se necessario, si prega di aggiornare la versione di CloudCC.`,
"com.cloudcc.login.error.message.licenseexpired":`La licenza è scaduta`,
"label.emailsync.form.signin":`Accesso`,
"label.campaign.channel.input.to.chooselanguage":`Seleziona una lingua`,
"label.tabpage.gotit":`Capito`,
"front-console-no-contact-tip":`Nessun dato. Si prega di contattare la persona interessata e visualizzare.`,
"label.approval.apiname":`Il nome unico usato dai pacchetti API e Managed deve iniziare con una lettera e usare solo caratteri alfanumerici e underscore. I nomi non possono finire con un trattino basso o avere due trattini bassi consecutivi.`,
"label_emailtocloudcc_filed_ssl":`Connessione sicura`,
"component_sendmail_label_fromuser":`Mittente`,
"front-kefu-moudle-v1-new-online-chats":`Nuovo agente online`,
"label.searchlayout.merge.duplicated.results":`Permettere di trovare duplicati e unire`,
"label.weixin.input.maxlength.remark":`Inserisci qui, fino a 500 caratteri`,
"component.telerecord.label.related":`Articoli correlati`,
"label.note":`Note`,
"message.duplication.label.nletters":`personaggi`,
"label.productsales.payment.phb":`Elenco dei pagamenti`,
"label.forecast.editshrepage.desc":`Previsione:Specifica la condivisione di questo record. Puoi condividere questo record e i relativi dati con un utente, con gli utenti di un particolare ruolo o con gli utenti di un particolare ruolo più tutti gli utenti dei ruoli inferiori a quel ruolo.`,
"vue.dashboard.setPenetrationSuccessful":`Penetrazione riuscita!`,
"label.tabpage.noOperationz":`Questo contenuto è un elemento fisso e non può essere azionato!`,
"label.email.jump":`Reindirizzamento a un sito web di terzi...`,
"label.appointmentpage.wizard.btn1":`Confermare la prenotazione`,
"label.umeng.approval.pass":`#approver ha approvato la tua richiesta di approvazione #obj.`,
"label.project.hit.twelve":`Promemoria della scadenza delle pietre miliari`,
"two":`Due`,
"label.approvedinfo":`Informazioni sull'approvazione`,
"label.import.step1.choosecsv":`Seleziona il file csv`,
"vue.please.select.the.expansion.method":`Si prega di selezionare il modo di espansione.`,
"UG.homepage.005":`Informazioni sulle vendite`,
"Account.News.Setting.003":`Impostazioni generali`,
"label.quickbooks.button.actions":`Azioni`,
"lable.list.queue.email":`Coda e-mail`,
"label.name.lastname":`Nome`,
"message.confirm":`Sei sicuro?`,
"Opportunity.Detailed.Phase.Label.Popup.002":`Data di chiusura della fase attuale`,
"label.knowledge.setting.title":`Impostazioni della conoscenza`,
"label.helptocreateprocess":`Per creare un nuovo processo di approvazione, clicca su "Create New Approval Process" e poi seleziona "Use Jump Start Wizard" per impostare il tuo processo di approvazione in pochi passi. Oppure, seleziona "Usa procedura guidata standard" per configurare tutte le opzioni di approvazione.`,
"label.batcheditor.remark":`Si possono modificare più record.`,
"label.page":`Pagina`,
"label.newfolder":`Creare una nuova cartella`,
"label.version.interceptor.api":`Interfaccia API`,
"label.sms.toaddress":`ha ricevuto un SMS`,
"front-kefu-moudle-noopen-callcenter":`L'organizzazione non ha attivato la funzione di call center, contatta l'amministratore`,
"label.data.exp.zip":`Formato di compressione`,
"lable.account.LastcDays":`Ultimi 60 giorni`,
"label.import.index.starttime":`Tempo di statistica`,
"label.dashboardall":`Tutti i cruscotti`,
"label.create_socialpost":`Nuovo post`,
"label.searchlayoutedit.remark":`Seleziona i campi e i pulsanti visualizzati quando fai clic sulla ricerca della barra laterale nella homepage o fai clic sulla ricerca della scheda.`,
"message.servicecrew.violation":`Violazione dell'assegnazione delle risorse: le risorse di servizio sono i membri della squadra in questo periodo.`,
"label.email.attrach.file":`Allegato`,
"report.label.folderandreport":`Rapporti e cartelle`,
"label.list.userinterface.sales.setup":`Impostazione della pagina iniziale delle vendite`,
"label.martrixreport.2018.step1":`Passo 1 Creare un raggruppamento`,
"label.campaignmember.selectmember.memberstatus":`Stato di membro della campagna`,
"label.textmessage.vonage.api.key":`Chiave API`,
"label.tabpage.next":`Prossimo passo`,
"UG_Lead_006":`Visitatore del sito web`,
"label.salescloud.salesdashboard.visit.rankings":`Visita le classifiche`,
"label.myevent":`I miei eventi`,
"label.activity.history":`Storia`,
"label_tabpage_kanban":`Impostazione del tabellone`,
"label.weixin.allapp":`Tutte le applicazioni`,
"label.query.clone.detail.choose.choosed":`Voci selezionate`,
"message.error.view.errvalid":`Errore: Il campo nome unico della vista può contenere solo caratteri di sottolineatura e alfanumerici. Deve essere unico, inizia con una lettera, esclude gli spazi, non può finire con un trattino basso e non può contenere due trattini bassi consecutivi.`,
"label.customfields.searchrelation.dependobject.tip":`Seleziona un altro oggetto associato a questo oggetto`,
"label.appointment.wizard.subtitle4-4-3":`3 settimane`,
"label.setup.mobile.offlinecache.saveerror":`L'impostazione della cache mobile offline non viene salvata.`,
"label.planned.started":`Iniziato`,
"label.page.step4.of.step5":`Passo 4 di 5`,
"label.tabpage.value":`Valore`,
"label.reportlist.allfolder":`Tutte le cartelle`,
"label.callcenter.sure.disable.center":`Sei sicuro di voler disattivare l'attuale call center?`,
"vue_label_commonobjects_detail_activity_tocalendar":`Vai al calendario`,
"label.setup.mobile.bottombutton.recovery.default":`Ripristinare le impostazioni predefinite`,
"label.appointmentdetail.wizard.title15":`Piano del martedì`,
"label.icon.15":`Ordine di riparazione`,
"component_sendmail_label_touser":`A`,
"template.report.all.owner":`Proprietario dei lead`,
"front-Partner-email-tips":`Inserisci l'email come nome utente`,
"vue_label_systemSettings_mobelhomepagesetting":`Impostazione della homepage dell'applicazione mobile`,
"label.service.newBuildDialog.aswellas":`e`,
"label.name":`Nome`,
"label.tag.search.taglist":`Elenco dei tag`,
"label.partnerCloud.priceOfManual.theOnly":`Si raccomanda di impostare l'unico listino per ogni utente partner. Oppure possono scegliere uno tra più listini durante l'ordine. Il listino standard viene applicato se non è stato impostato un listino specifico.`,
"label.knowledge.field.update":`{1} è cambiato da {2} a {3}`,
"label.emailobject.save":`Salva`,
"label.top.changeVersion":`Orizzontale`,
"label.recordtype.edit.unselected":`Valori esistenti`,
"label.knowledgebase.additional.articles":`Allega un articolo`,
"label.lead.score.confirm":`Seleziona l'intervallo di valutazione e il sistema assegnerà un punteggio ai lead selezionati in base alla regola di valutazione dei lead attiva.<br><br>Questa operazione può durare alcuni minuti.<br>Riceverai un'email di conferma una volta completata.<br><br>`,
"label.projectManagement.pleaseselectadate":`Si prega di selezionare la data`,
"label.appointment.wizard.subtitle5":`Nome della riunione`,
"label_setup_failed":`Impostazione fallita`,
"label.chatter.collect":`Segnalibro`,
"label.appointment.cancelappointment":`Cancella`,
"front-console-response":`Tempo di risposta`,
"message.delete":`Sei sicuro di voler cancellare?`,
"label.dataimport.type.selected":`Selezionare il tipo di importazione`,
"label.new.target":`Nuovo indicatore`,
"vue_label_report_autoupdatepreview":`Anteprima dell'aggiornamento automatico`,
"label.knowledgebase.guidance":`Guida`,
"label.chatter.mail":`Posta`,
"label.login.verification.scan.code.acquisition":`Scansiona il codice per ottenere:`,
"label.customsetting.changefieldtype":`Cambiare il tipo di campo`,
"label.data.dataexpalltype.all_desc2":`2. Ci vuole un po' di tempo per esportare tutti i dati. Quando l'esportazione è completa, riceverai un'e-mail di promemoria che ti informa che l'esportazione dei dati è avvenuta con successo.`,
"label.opportunity.contactisnull":`Nessuna informazione sul cliente, non può essere visualizzata.`,
"pagecreator_layout_button_upload":`Carica il layout`,
"label.dashboard.noRecord":`Nessun record`,
"label.SMS.template":`Nome del modello SMS`,
"label.c.d.without":`I record C possono avere o meno record "D" correlati.`,
"UG.Case.05":`Creare un caso`,
"front-epwechat-module-v1-edit-selfapp":`Modificare l'app creata da Sefl`,
"label.role.createrole.tip":`Puoi costruire sulla gerarchia dei ruoli esistente mostrata in questa pagina. Per inserire un nuovo ruolo, clicca <b> Aggiungi ruolo</b>.`,
"label.grouping":`Gruppo per`,
"vue_label_email_upload_new_file":`Carica un nuovo file`,
"label.notification.event3":`Il tuo evento 【事件名】 inizia a 【开始时间】`,
"labe_benchmark_objects":`Oggetto di riferimento`,
"component.chatter.button.collect":`Segnalibro`,
"front-QBtoCC-sinchronies":`Sincronizzazione...`,
"message.submitpage.sms":`Congratulazioni. SMS inviato con successo.`,
"label.imgfield.width":`Larghezza`,
"label.send_email":`Inviare notifiche email di presentazione a`,
"label.queue.list":`Elenco delle code`,
"label.tabpage.fieldoptions":`Campo tipo record, campo elenco opzioni e campo elenco opzioni (scelta multipla). si raccomanda di inserire al massimo 10 parole chiave, separate da virgole per ottenere "o relazione", come ad esempio: "New York, Toronto, Tokyo".`,
"component.chatter.post.button.save":`Pubblica`,
"chatter.group.groupDescriptionInformation":`Descrizione del gruppo`,
"label_setup_mobilesetup_isenableh5newandedit":`Abilita il nuovo e la modifica di H5 nella tua applicazione mobile.`,
"lable.Confirm.recallpotential.customers":`Confermare per riciclare {num} piste.`,
"label.knowledge.setting.hint.seven":`Seleziona un nome tra i seguenti e concedi l'accesso in scrittura per contribuire ai tuoi sforzi.`,
"label.emailtocloudcc.redmessage2":`Inserisci la password corretta del tuo account di posta elettronica`,
"message.validation.equalTo":`Inserite gli stessi valori.`,
"vue_label_help_golbal":`Navigazione generale`,
"vue_label_chatter_delete_group_title":`Cancellare il gruppo`,
"label.user.login.success":`Successo del login`,
"label.chatham.standard.time":`Ora solare di Chatham`,
"label.vlidaterule.example.percent":`La percentuale di sconto non può superare il 30%.`,
"label.group.field":`Specificare il campo di raggruppamento`,
"label.trigger.operation.sharetab":`Azioni di attivazione Modulo condiviso:`,
"label.mobile.phone.write.month.report":`Note di lavoro mensili`,
"label.statusofconvers":`Stato convertito`,
"label.version.emailtemplate.track":`Modello di e-mail`,
"label.customobjects.onlytrackforupdate":`Traccia solo le modifiche`,
"label_tabpage_enterviewname":`Passo 1 inserire il nome della vista`,
"label.processsetting.three.enable":`Passo 3: Attivare`,
"label.service.show.more.info":`Mostra altre informazioni`,
"front-epwechat-module-v1-input-iosschema":`Inserisci lo schema di iOS`,
"label.dataimport.datatype.error":`Errore nel tipo di dati, controlla attentamente se i dati e il titolo corrispondono uno per uno.`,
"label.staticresource":`Risorsa statica`,
"label.weixin.customize":`Personalizza`,
"label.product.edit.sel":`Modifica selezionata`,
"label.appointmentpage.wizard.notif5":`Formato del telefono non valido`,
"label.marketsea.basicsetup":`Impostazioni di base`,
"label.workflow.supplyintruduce":`1.Criteri che causano l'esecuzione della regola del flusso di lavoro.<br/> 2.Azioni immediate che vengono eseguite quando un record corrisponde ai criteri. Per esempio, CloudCC può inviare automaticamente un'e-mail che notifica il team degli account quando viene creata una nuova opportunità.<br/>3.Azioni dipendenti dal tempo che si mettono in coda quando un record corrisponde ai criteri, ed eseguono secondo i trigger temporali.`,
"label_report_line_tuozhuai":`Si prega di trascinare e rilasciare, o fare doppio clic per selezionare la colonna del rapporto e regolare i loro ordini`,
"label.add.new.rule":`Aggiungere nuove regole di generazione`,
"label.marketing.setting2":`Impostazione`,
"vue_label_chatter_delete_some_group":`Sei sicuro di voler cancellare il gruppo "{groupInfoList}"`,
"label.appupload.uploading.wait":`Si prega di attendere`,
"label.linecondition.error":`Errore di condizione della riga, il tipo di campo non corrisponde!`,
"chatter.group.request":`Richiesta`,
"label.recordtype.tabname.remark":`Usa questa pagina per creare e mantenere i tipi di record per la tua organizzazione. Puoi visualizzare diversi layout di pagina e valori di picklist basati sui tipi di record. Per usare i tipi di record, aggiungi il campo Tipo di record ai tuoi layout di pagina.`,
"setup_mainpage_label_welcome4":`Istruzioni: Fare clic sul menu sul lato sinistro della pagina → Impostazioni applicazione → Crea → Oggetto.`,
"vue_label_salesadvance":`Fase di vendita anticipata`,
"vue_label_campaign_of_existing_campaign_members":`Imposta lo stato dei membri della campagna esistenti`,
"label.report.object.detail.no.permission":`Il tipo di rapporto è cambiato o spostato. Contatta l'amministratore per aiuto.`,
"label.weixin.untreated":`Aprire`,
"label.service.miniProgram.bindSetOwnerDesc":``,
"label.autoassigntoapprover":`Assegnare automaticamente a chi approva.`,
"label.marketseamemset.containself":`Contiene record autocostruiti`,
"vue_label_report_drill":`Trapano`,
"label.order.products.to.assets":`Convertire il prodotto dell'ordine in risorsa`,
"label.recordtype.list":`Tipo di record esistente`,
"lable.outlook.detail.conflict":`Comportamento conflittuale`,
"pagecreator.page.label.layoutpreview":`Anteprima del layout`,
"front-kefu-moudle-v1-zxltyhxzc-buyuser":`La chat dell'agente è supportata da Easemob. Si prega di acquistare prima un account Easemob.`,
"label.convers":`Convertire`,
"serviceappointment.worktype.isnot.father.worktype":`Il tipo di lavoro associato al suo record padre deve essere selezionato per questo appuntamento di servizio.`,
"lable.tianyancha.h5.relatedcom":`Aziende rilevanti`,
"label.reportsSubscriptionPage.schedulereport":`Rapporto di programmazione`,
"label.workbanch.setup.showinworkbanch":`Visualizzazione sul mio banco di lavoro`,
"label_emailsync_connectaccount":`Collegare l'account e-mail`,
"label.usermanage.license.not.qualified":`Il sistema ha rilevato che questa è una licenza non conforme, per favore contatta il venditore per ottenere di nuovo la licenza!`,
"component_setup_label_displayfield":`Campo di visualizzazione`,
"setup_layout_label_buttonarea":`Area dei pulsanti`,
"label.weixin.input.content":`Inserisci il contenuto`,
"label.operatedata.importsuc":`Importazione riuscita, puoi controllare il risultato dell'importazione cliccando sulla scheda dell'oggetto.`,
"label_tabpage_yes1z":`Sì1`,
"front-electronic-signature-describe":`Accedi alla firma elettronica, firma un contratto ovunque e in qualsiasi momento. Firma con un clic, sicuro ed efficiente!`,
"label.event.this.month":`Questo mese`,
"label.document.replaces":`Sostituire`,
"label.email.cc":`Cc`,
"chatter.feed.sticker":`Monitoraggio dei mangimi`,
"vue_label_commonobjects_view_chart_notice_pleaseaddchart":`Si prega di aggiungere il grafico`,
"label.cpq.main.quote.transfer.order":`Solo la quotazione primaria può generare ordini.`,
"label.partnerCloud.partnerAccount.topUpSuccess":`Ricarica con successo`,
"label.appexchange.uninstallpage.uninstall":`Disinstallare`,
"label.campagin.roi.channel":`Canali`,
"label.multilang.versioncontrol.checkversion":`La tua attuale versione di CloudCC è {0} che ti permette di creare {1} {2} che hanno raggiunto il limite! Se necessario, aggiorna la versione di CloudCC!`,
"label.emailobject.my.template":`Solo i miei modelli`,
"label.edittimetrigger":`Modifica dell'innesco del tempo`,
"label.setup.mobile.homepageshortcuts.saveerror":`Le impostazioni della funzione swift della homepage mobile non vengono salvate.`,
"label.address.street":`Via`,
"label.workflow.estimatecondition2":`creato`,
"label.wei.expiresdate":`Data di scadenza`,
"label.quickbooks.viewlist.date":`DATA`,
"label.page.select.field.type":`Seleziona il tipo di campo`,
"label.tabpage.mypotentialcustomers":`Le mie piste`,
"label.file.library.editlib":`Modifica i dettagli della libreria`,
"label.weixin.message.operateexception":`Prompt`,
"label.visualpage.staticresource.p1":`1.Call method.Refference risorse statiche selezionate facendo riferimento a pulsanti di risorse statiche`,
"label.icon.175":`Biglietti aerei`,
"chatter.edit.r":`Scrivi un commento...`,
"label.examinationandapproval.flow":`Processi di approvazione`,
"label.mr.descreption.reDataList5":`serie di dati.`,
"label.edit.field.select.showstyle":`Stile di visualizzazione`,
"label.reportsSubscriptionPage.condition.and":`E`,
"label.please.associations":`Scegliete l'oggetto associato.`,
"label.service.dispatchingUnits.displays.service.appointments":`Mostra gli appuntamenti di servizio che non sono associati a una regione`,
"label.addcurrent":`Aggiungi esistente`,
"label.search.change":`Personalizzare gli oggetti ricercabili`,
"message.schedulejob.error.modify":`Sulla base di una pianificazione configurata, il lavoro dato non verrà mai attivato. Controlla i dati e reinvia.`,
"label.chatter.sendEmailToGroupMember.subject.L":`{0} link pubblicati per tutti in {1}`,
"label.weixin.micro.oldid":`ID originale dell'account ufficiale WeChat`,
"label.employees.only.invitation.code":`Il sistema genererà un codice d'invito unico per il dipendente, che può essere usato per fare inviti e può essere contato come prestazione individuale. Si prega di notare che il proprietario del lead sarà l'attuale proprietario della campagna di marketing o l'invitatore del canale di marketing. È possibile riassegnare i lead attraverso le regole di assegnazione dei lead. Per le regole di assegnazione`,
"lable.PowerProcess.event.msg":`Puoi aggiungere azioni del flusso di lavoro dipendenti dal tempo che si verificano ad ogni passo (milestone) nel processo di autorizzazione. Per esempio, puoi impostare azioni per inviare un'e-mail al proprietario del caso un'ora prima della scadenza di una pietra miliare, o per aggiornare automaticamente campi specifici del caso quando la prima risposta a una pietra miliare è completata.`,
"label.file.share.email.content2":`Premessa: #condividere il ruolo`,
"label.querydetailservice.datalayout.notexist":`Il layout corrispondente del record non esiste.`,
"label.group.items":`Voce del gruppo`,
"label.istouse":`Disponibile`,
"front-electronic-signature-explain":`Fadada Esignature Descrizione:`,
"label.partner.template.thumbnail":`Miniatura`,
"registration.page.selected.fields":`Campi obbligatori della pagina di registrazione`,
"label.reportTypeCategoryLabel":`Fonte dei dati`,
"vue_label_email_You_have_not_activated_the_mailbox":`Non hai attivato la cassetta postale`,
"lable.SalesCommitmentKanBan.taskCompletionRate":`Tasso di completamento del compito`,
"label.forecast.detailforecast.program":`Elementi di previsione`,
"label.page.display":`Visualizza`,
"label.passwordPolicy.setup.minute":`minuti`,
"label.emailtocloudcc.step1total3":`Passo 1 di 3`,
"label.file.title":`Titolo`,
"label.callcenter.private.key":`Chiave segreta di accesso privato`,
"com.cloudcc.login.error.message.loginerror":`Il tuo id o la tua password non sono corretti`,
"UG_Lead_004":`Modulo web`,
"label_tabpage_recordsz":`Record`,
"label.shangqing.discovery":`Scoperta di informazioni commerciali`,
"vue_label_notice_change_success":`Cambiato con successo`,
"label.ems.other":`Altro`,
"loading":`Caricamento...`,
"label.committedtoapprove":`Le richieste di approvazione presentate`,
"label.category.4":`Finanziario`,
"template.report.folder.customer.situation":`Analisi della situazione dei conti`,
"label.quickbooks.searchresault.phone":`Telefono`,
"label.ccpeak.ccobj.save":`Per salvare CCObject nel database, il metodo di chiamata è`,
"label.knowledge.delete.linked":`Errore durante la cancellazione dell'articolo associato`,
"label.forecast.settings.future2":`Futuro 2 cicli`,
"message.error.displaytype.detail":`Il tipo di visualizzazione non può essere vuoto, Giorno: giorno, Mese: mese, Settimana: settimana, Disponibilità: disponibilità!`,
"front-template-V1-search-template-name":`Inserisci il nome dell'oggetto e trova`,
"label.sendsms.batch.step3.introduce":`Memorizza le attività di ogni SMS`,
"UG.Forcast.08":`Passo precedente`,
"label.inputnameandintro":`Inserisci nome e descrizione`,
"label.redistributioned":`Riassegnato`,
"label.service.dispatchingUnits.left.right.total":`{left}-{right} records , {totalCount} records in totale.`,
"label.projectManagement.Pleaseentertheactualworkinghours":`Si prega di inserire le ore di lavoro effettive`,
"label.exporttemplate":`Esportare il modello`,
"label.data.downpage":`Pagina di download dei dati`,
"message.please.choose.contact":`Seleziona un contatto`,
"message.error.dataformat.error":`Errore nel formato dei dati`,
"label.customsetting.changefieldtype.losevalue":`Il passaggio al tipo di dati selezionato causerà la perdita di tutti i dati esistenti nel campo.`,
"label.sendemail.chat.chattype":`Il tipo di post principale:`,
"label.ccdocument.upload.error":`Errore nel caricamento del documento.`,
"label.quickbooks.view.all":`Tutti`,
"label.data.downpage.e_title":`Fasi di esportazione dei dati`,
"lable.data.lock":`I dati sono bloccati, se hai bisogno di modificarli, sbloccali prima.`,
"label.locked":`Bloccato`,
"label.customfields.beforedeletedata":`Per conservare un record di dati per riferimento futuro, esegui un'esportazione di dati prima di eliminare i campi personalizzati cliccando su Setup | Data Management | Data Export.`,
"label.productsales.oppor.noapproach":`Nessuna opportunità con una data di contratto prevista inferiore a 30 giorni`,
"label.input.notmore.than.number":`Inserisci un numero minore o uguale a {0}`,
"label.list.userinterface.isenable":`Abilitare la modifica in linea`,
"label.listofshare":`Elenco delle informazioni sulle azioni`,
"label.emailsync.status.role":`Ruolo`,
"label.staticresource.useful.realtion":`Dove viene usata questa risorsa statica`,
"label.sharerule.tip":`Questa pagina mostra le impostazioni di condivisione della tua organizzazione. Queste impostazioni specificano il livello di accesso dei tuoi utenti ai dati degli altri.`,
"label.qrcodelogin.message.expired":`Il codice QR è scaduto`,
"label.marketing.setting3":`Impostazione dei canali di marketing`,
"vue_label_statistical_field":`Campo statistico`,
"message.view.addtomyhomepage":`Aggiungi alla mia homepage Banco di lavoro`,
"label.customfields.percent.tip":`Permette agli utenti di inserire un numero percentuale, per esempio, "10" e aggiunge automaticamente il segno di percentuale al numero.`,
"component_newrecords_label_10records":`10 registrazioni`,
"Lead_Scoring_Warning_001":`Il punteggio di un singolo lead record viene assegnato automaticamente quando si crea o si modifica. Ma è necessario assegnare manualmente un punteggio a più record di lead, quando si importa in batch o si crea tramite interfaccia.`,
"label.project.planing":`Ore uomo di spedizione e ore uomo dichiarate in quest'anno`,
"label.data.exp.pwdverif":`Le password sono permesse solo per lettere e numeri.`,
"coderules.notEnable":`Contatta l'amministratore per attivare le regole di generazione del codice QR e del codice a barre.`,
"label.weixin.wdyj.jxhk":`Prestazioni personali-vendite-pagamenti`,
"label.data.expnode.e_desc3":`3. Crea modello: l'utente può fare il modello secondo i campi e le condizioni che saranno esportati per soddisfare le vostre esigenze, che è comodo da usare la prossima volta.`,
"chatter.group.join":`Unisciti a`,
"vue_label_systemSettings_monitoring":`Monitorare`,
"front-kefu-moudle-v1-yesorno-delete-folder":`Sei sicuro di voler cancellare questa cartella?`,
"label.exchange.sync.state.info":`Controlla lo stato del sistema per assicurarti che i record siano sincronizzati tra Exchange e CloudCC.`,
"lable.outlook.mcto.emaildes":`Inserisci tutti gli indirizzi e-mail dei lead e dei contatti che hai usato per inviare e-mail, e separati da virgole. solo le e-mail inviate dall'indirizzo e-mail qui sotto possono essere aggiunte alla Cronologia attività se i record correlati.`,
"label.ems.save":`Salva`,
"vue_label_dashboard_maximumvalue":`Inserisci il valore massimo`,
"label.passwordPolicy.setup.norestriction":`Nessuna restrizione`,
"label.multilang.customforcast.total":`Accumulazione di {0}：`,
"label_partner_all_memo":`L'elenco mostra tutte le nuvole partner della tua organizzazione. clicca sull'url per accedere.`,
"Account.News.Setting.002":`Usa le impostazioni dell'account qui sotto per specificare il comportamento predefinito dell'account per la tua organizzazione.`,
"label.essential":`richiesto`,
"label.nonotice":`Niente più promemoria`,
"vue_label_calendar_calendar_deleted_successfully":`Calendario cancellato con successo`,
"message.huanxinagent.disable":`Agente inattivo`,
"label.goto":`Salta a`,
"label.chat.topic.add.favorite":`Aggiungi ai preferiti`,
"label.trigger.targetobj":`Oggetto da colpire`,
"label.form_fields":`Campi del modulo`,
"this.month":`Questo mese`,
"vue_label_homepage_select_view":`Seleziona Vista`,
"label.weixin.input.subject":`Si prega di compilare l'oggetto`,
"label.ems.emailType":`Tipo di cassetta postale`,
"vue_label_file_safe_type_file":`Si prega di confermare che il file non contiene informazioni sensibili. Si prega di considerare la condivisione dei file con utenti o registri specifici`,
"label.version.case.automatic.upgrade":`Regole di escalation e di assegnazione dei casi`,
"label.input.invalid.credit.card.number":`Inserisci il numero di carta di credito valido`,
"component_timeline_label_future":`Prossimo passo`,
"label.emailtemplate.cannotsupporthtml":`Il tipo HTML non è attualmente supportato`,
"label.appupload.install.error.info2":`{1} '{0}' è in conflitto con componenti esistenti.`,
"label.custom.field.maping":`a questo campo.`,
"encd":`Testo crittografato (visualizzazione crittografata)`,
"label.service.newBuildDialog.filter.logic":`Logica del filtro`,
"label.customerinfo":`Profilo dell'azienda`,
"vue_label_applauncher_notice_activepoolsuccess":`Attivato con successo il pool di piombo`,
"label.partner.workspace.member.choicepermission":`Seleziona il set di permessi`,
"front-gantt-module-this-task-of-other-tasks":`Questo compito esiste come sottocompito e non può essere un sottocompito di un altro compito!`,
"label_chatter_publish":`Pubblica`,
"label.forecast.settings.mrfw":`A partire da`,
"label.Named.Filter":`Dare un nome al filtro`,
"label.department.email":`Indirizzo e-mail`,
"label.updatingfield":`Campo da aggiornare`,
"label_partner_template_detail":`Descrizione della funzione`,
"front-epwechat-module-v1-unbound-item":` vincolante per tutte le imprese`,
"vue_label_file_lib_name":`Nome della libreria di file`,
"label.notification.arketsea.distribution":`{5} assegnato {2}{0}：{1} a te`,
"vue_label_norm_removecomponent":`rimuovere il componente`,
"component.event.label.begindate":`*Tempo di inizio`,
"chatter.note":`commento(i) ricevuto(i)`,
"label.forecast.settings.type.all":`Previsione di annullamento`,
"label.compact.layout.frame.full":`Visualizzazione a tutto schermo`,
"label.approvalstep3intro":`Usando le opzioni sottostanti, specificare l'utente a cui assegnare la richiesta di approvazione.`,
"label.notification.approval6":`【被委派人名称】 ha approvato la richiesta di approvazione di 【提交人】 di 【对象】【对象名称】 per te.`,
"setup.object.field.dependency.label.actionfieldvalue":`Campo di controllo`,
"label.multilang.page2":`Pagina`,
"vue_label_email_submitted":`Inviato`,
"label.Standard.button":`Pulsanti standard`,
"vue_label_report_emailchoose":`Opzione e-mail`,
"page.field.masterinput.list":`Elenco dei dati di ingresso master-dettaglio`,
"label.martrixdown":`Matrice giù`,
"vue_label_helpcenter_opportunity":`Nell'angolo in alto a destra della vista, fare clic sull'icona dell'imbuto di vendita per saltare a visualizzare l'imbuto di vendita.<br>.Attraverso l'intuitiva barra di avanzamento, tenere traccia dei progressi di ogni opportunità di business, e fare clic sul pulsante per contrassegnare il completamento della fase corrente, o regolare la fase corrente. Se si incontrano ostacoli nell'avanzamento delle opportunità di business, è anche possibile espandere la barra di avanzamento per visualizzare le informazioni e alcuni suggerimenti caldi che dovrebbero essere prestati più attenzione alla fase corrente.<br>.Attraverso l'elenco correlato del gruppo di opportunità di business, i dati di opportunità di business possono essere condivisi con altre persone che non hanno accesso per visualizzarlo, in modo da facilitare il lavoro collaborativo.<br>?Sulla lista relativa al ruolo di contatto sotto l'opportunità di business, aggiungere rapidamente il ruolo nell'opportunità al contatto nel cliente corrispondente, e quindi visualizzare la relazione superiore e subordinata del contatto correlato attraverso la rete di relazioni, e utilizzare il grafico radar per valutare il contatto corrente Il valore delle opportunità, seguire, individuare le persone chiave, e controllare i contatti. Ruolo, stato di visita, grado di relazione, stile di acquisto e tempi di visita<br>?Attraverso l'elenco correlato di prodotti di opportunità di business, è possibile aggiungere prodotti nello stesso listino prezzi per l'opportunità di business, e modificare il prezzo e la quantità dei prodotti.`,
"label.sso.ssoKeyMan":`Gestione delle chiavi di Single Sign-On`,
"label.forecast.edit.desc":`Imposta la quota di un utente per il seguente periodo`,
"label.weixin.newspaper.coverage.time":`Data del rischio`,
"label.pleaseselectpro":`Si prega di selezionare i prodotti`,
"label.bottonandlink":`Pulsanti e link`,
"label.donot.know.error":`Si è verificato un errore sconosciuto, si prega di contattare l'amministratore.`,
"label.account_noordab":`Il tuo account ha 0 rapporti personalizzati e 2 dashboard.`,
"label.partnerCloud.orderingPlatform.toPay":`Paga per Fondo dei partner`,
"label.many.dayline.nextday":`Giorno successivo`,
"lable.showmorerecords":`Mostra di più`,
"front-lightning-module-v1-details-page-chart-record-type":`Seleziona il tipo di registrazione`,
"label.ccpeak.query.record":`ricerca dei registri`,
"pagecreator.systemstyle.message.save.fail":`Salvataggio stile fallito`,
"label.weixin.share.file":`Condividi file`,
"errormessage.email.relatedorreceivermusthaveone.z":`Devi selezionare almeno un destinatario o un soggetto correlato.`,
"chatter.save.f":`Salvataggio fallito`,
"button.partner.create":`Nuovo`,
"label.marketseamemset.lead.title2":`Si prega di fissare un limite massimo al numero di piste che riguardano tutti i membri. Il limite non ha nulla a che fare con la piscina d'alto mare`,
"label.service.major.event.new":`Nuova pietra miliare`,
"label.version.custom.site":`Sito personalizzato`,
"label.permission.visualpagepermission":`Pagine personalizzate assegnate`,
"lable.product.zongjia":`Prezzo totale`,
"label.viewchart":`Visualizza i grafici`,
"label.alaska.daylight.time":`Ora legale dell'Alaska`,
"front-kefu-moudle-v1-rgdyhcwzx-reply":`Lasciate che più utenti diventino agenti e servano i visitatori, migliorando il servizio clienti.`,
"component_assistant_label_todaylead":`Le piste che ti sono state assegnate oggi`,
"label.sendemail.chat.addComentsfavorite":`Caro #name:\n\n ; ciao! #nomeutente ha risposto al tuo post segnalato.`,
"label.smstemplate.tip":`Tutti i modelli SMS nella cartella selezionata sono elencati qui sotto. Clicca sul pulsante "Nuovo" per creare un nuovo modello SMS di testo o HTML. Puoi usare questi modelli SMS quando invii i messaggi. Fai clic sul link del ruolo per visualizzare informazioni più dettagliate".`,
"label.documentname":`Nome del documento`,
"label.icon.162":`Paesaggio`,
"label.salescloud.wanyuan":`Yuan`,
"label.view.desc1":`Campo tipo record, campo picklist e campo picklist (multiselezione), si raccomanda di inserire fino a 10 parole chiave, separate da virgole. Ad esempio "New York, Toronto, Tokyo".`,
"label.searchlayout.lookup.newfield":`Dialoghi di ricerca che appaiono quando si fa clic sul nuovo pulsante sui campi di ricerca.`,
"label.emailobject.bcc":`Bcc:`,
"label.manageAll.pagenum1":`Questa è la prima pagina.`,
"vue_label_appstore_crm_used_companies":`CRM utilizzato da società quotate in borsa`,
"label.document.replace":`Sostituire`,
"label.assignment.setup.newrule.title":`Nuova regola di assegnazione dei casi`,
"component.chatter.label.mygroup":`Il mio gruppo`,
"lable.currencyAdv.exchangedate":`Intervallo di date`,
"label.quickbooks.button.viewinqb":`Visualizza in QuickBooks`,
"UG.homepage.004":`Automazione`,
"label.currencyName":`Nome della valuta`,
"Homepage_News_001":`Notizie`,
"front-lightning-module-v1-details-page-chart-refresh-button":`Mostra il pulsante di aggiornamento`,
"label.list.projectSetting.isenable":`Abilitare il timer del progetto (includere: pietra miliare, compito, sottocompito, problema)`,
"setup.layout.message.relatedlistbutton":`Selezionare i pulsanti standard da visualizzare sul`,
"vue_label_homepage_homepageassignment":`Applicazione Home Page Assegnazione`,
"label.pending":`In attesa di`,
"component.timeline.label.today":`Oggi`,
"front-kefu-moudle-free-hasexpire":`La tua prova gratuita è scaduta`,
"homepage.layout.customlayout":`Layout di pagina personalizzato`,
"label.service.miniProgram.content":`Si prega di compilare il contenuto.`,
"label.defaultline.must.int":`Il numero predefinito di linee può essere solo un numero intero positivo.`,
"label.mirror_issues":`Se il modulo non rispecchia quello che vedi dalla tua parte, leggi il nostro articolo su come risolvere i problemi comuni di visualizzazione.`,
"label.edit.select.two":`Elenco di caselle a selezione singola`,
"label.emailmerge.mergeFolder.tip":`L'unione dei modelli richiede un po' di tempo, durante l'unione, per favore non cliccare su altri link, chiudi il tuo browser web o aggiorna la pagina.`,
"label.ServiceCloud.zichan.distributionMap":`Mappa di distribuzione delle attività`,
"label.selectfile":`Selezionare i file`,
"vue_label_account_equitymanage":`Gestire il rapporto con l'equity`,
"label.email.clearAll":`Cancella tutto`,
"label.selecting.parent.assets":`Scegliere l'attività del genitore`,
"component.setup.tabs.label.delete":`Cancellare`,
"label.visualpage.top.must.is":`La prima riga dell'intestazione dell'oage deve essere:`,
"label.SalesCommitmentDashboard":`Cruscotti di impegno delle vendite`,
"chatter.group.changeTheRole":`Cambiare il ruolo`,
"label.dataimport.insertdata.error":`Si è verificato un errore durante l'inserimento di nuovi dati. Si prega di controllare attentamente questi dati.`,
"label.partner":`Nuvola dei partner`,
"label.process.async.execute.tip":`La tua richiesta è in fase di elaborazione. L'approvazione richiede un certo tempo e il risultato sarà mostrato nella pagina dei dettagli. Si prega di attendere.`,
"label.service.newBuildDialog.additional.conditions":`Condizioni aggiuntive`,
"label.name_copy":`Stai per clonare questo modulo esistente. Inserisci un nome per la copia.`,
"label.integrations.install":`Installare`,
"label.edit.ccpeakfolder.time":`Classi programmate: Modifica cartella`,
"label.knowledgebase.filing.time":`Tempo archiviato`,
"vue_label_chatter_success_exit_group":`Uscire con successo dal gruppo`,
"font.market.module.v1.save.name":`Si prega di compilare il nome della riunione`,
"label.a.b.without":`I record A possono avere o meno record "B" correlati.`,
"label.chat.topic.desc":`Descrizione`,
"label.field.editoptionlist.introduce":`Inserisci il nome del valore dell'elenco di scelta.`,
"label.versiontype.Enterprise":`Impresa`,
"message.selectrulecondition":`Si prega di specificare i criteri della regola`,
"label.custombutton.unknown.operation":`Azioni non valide`,
"label.pricecannotnull":`Il prezzo è richiesto`,
"component_salesperformance_label_target":`Obiettivo`,
"pagecreator.page.message.delete.success":`Pagina cancellata con successo`,
"label.help.new.features":`Nuove caratteristiche di CloudCC`,
"label.weixin.vehicle.owner.information":`Dettagli del proprietario del veicolo`,
"label.exchange.sync.state.user.info":`Controlla lo stato di sincronizzazione di un utente per assicurarti che i record siano sincronizzati tra Exchange e CloudCC. Se l'utente ha un problema di sincronizzazione tra Exchange e CloudCC, è possibile ripristinare il processo di sincronizzazione. Ripristina le informazioni che CloudCC for Exchange utilizza soltanto e non elimina i dati dal tuo server Microsoft Exchange o da CloudCC.`,
"label.batcheditor":`Modifica di massa`,
"report.label.knowcreatehighlevelreport":`Come creare un rapporto avanzato?`,
"label.dataimport.title.length":`La lunghezza del titolo è`,
"label_model_description":`Descrizione del modello`,
"label.tabpage.ctbtsftcz":`Clicca sul retro per cercare il contenuto`,
"label.channel.activity.member.owner":`Proprietario della campagna membro`,
"label.ems.serverinfo":`Informazioni sul server`,
"tjinvilid":`Condizioni illegali`,
"label.nameofreport":`Nome del rapporto`,
"label.ifapproverreject":`Cosa succede se l'approvatore rifiuta questa richiesta?`,
"label.wtd.changefields.title.desc2":`Se hai bisogno di un record sulla Mobile App "Web to CloudCC" per associare un lead, devi creare un campo dell'oggetto corrente per cercare il lead, e il nome del campo API è "lead_wtd".`,
"label_emailsync_form_connecttime":`Tempo correlato`,
"label.visualpage":`Pagina personalizzata`,
"label.customlink":`Collegamenti personalizzati`,
"label.lead.score.doing.remark":`La tua richiesta è stata elaborata e ci vorrà un certo tempo per il lead scoring. e il sistema ti informerà via email quando sarà completato.`,
"label.h5.act.details":`Dettagli dell'attività`,
"label.profile.setrecordtype":`Impostazioni del tipo di registrazione`,
"label.processsetting.process.enabled.successfully":`Attiva il processo con successo!`,
"label.campaign.url.overtime":`Il link è scaduto.`,
"label.structureChart.notFiled":`Non riempito`,
"label.h5.chatter.something":`Tu dici qualcosa`,
"label.pm":`PM`,
"template.chart.rwlx":`Tipo di compito`,
"label.icon.42":`Cloud`,
"label.project.hit.one":`Avviso di assegnazione del sottocompito`,
"label.martrixreport.2018.step3":`Passo 3 Scegliere le intestazioni di colonna`,
"label.wtd.changefields.newmo":`Generare una pagina mobile`,
"label.downloadTheTemplate":`Scarica il modello`,
"label_chatter_assignPerson":`Persona assegnata`,
"label_emailtocloudcc_license":`Licenza`,
"label.willdeletedlayout":`Layout di pagina che vuoi cancellare`,
"label.projectManagement.delete.question":`Tutte le informazioni relative a questo problema saranno cancellate se si elimina questo problema, e i dati non possono essere recuperati. Sei sicuro di confermare la cancellazione?`,
"lable_setup_mobilesetup_isEnableValidationRulesForScan":`Abilitare le regole di convalida quando si usa Scan`,
"label.salescloud.opportunity.addandedit.contactrole.note":`Nota: doppio clic sui contatti vuoti, può aggiungere un record vuoto`,
"label.step6.total6":`Passo 6 di 6`,
"label.knowledge.setting.hint.one":`Knowledge permette al cliente e al personale di servizio di fare pieno uso degli articoli di Knowledge.`,
"label.usefieldautoassign":`Assegna automaticamente un approvatore usando un campo gerarchia standard o personalizzato:`,
"label.partnerCloud.orderingPlatform.orderAmount":`Importo dell'ordine:`,
"chatter.fieldtrack.operateupdate":`ha cambiato un`,
"chatter.del.com":`Cancella questo commento`,
"report.reportdatasource.label":`Fonte dei dati del rapporto`,
"label.text":`Testo`,
"label.marketsea.select.member":`Membri opzionali`,
"label.typeofreceivers":`Tipo di destinatario`,
"label.knowledgebase.affect.existing.translations":`Sì, le mie modifiche influenzeranno la traduzione esistente. Segna come "Scaduto"`,
"label.marketing.invitationmail":`Benvenuto nella nostra attività, il tuo link di invito è:`,
"label.version.quotation.management":`Gestione dei preventivi`,
"label.dataimport.insertdata.error.unique":`$fieldName$ viola i vincoli di unicità quando si inseriscono nuovi dati.`,
"label.emailmerge.list.newtemplate":`Nuovo modello`,
"label.salescloud.salescloud.allteam":`Tutti i team di opportunità basati su tutti i team`,
"vue_label_commonobjects_detail_record_changes":`Modifiche ai record di campo`,
"label.file.delete.info":`Cancellare i file`,
"vue_label_calendar_name":`Nome del calendario`,
"label.version.support":`Supporto`,
"label.event":`Eventi`,
"label.searchlayout.lookup.searchdialog":`Dialoghi di ricerca che appaiono quando si fa clic sull'icona di ricerca sui campi di ricerca.`,
"label.data.downpage.e_list.desc2":`Dopo il completamento, riceverai un'e-mail che ti ricorderà che i dati sono stati esportati con successo.`,
"label.partnerCloud.productSet.delIsTrue":`Vuoi cancellare questo prodotto?`,
"label.tianyancha.businessverify.msg2":`Questo accordo è un accordo tra l'utente (di seguito denominato utente) e CloudCC per quanto riguarda l'uso della funzione di verifica dei dati aziendali. questo accordo descrive i diritti e gli obblighi dell'uso della funzione di verifica dei dati aziendali e dei servizi correlati tra CloudCC e l'utente. questo accordo può essere aggiornato da CloudCC in qualsiasi momento. i termini aggiornati dell'accordo una volta pubblicati, sostituiranno i termini originali dell'accordo senza preavviso.`,
"label.customobjects.cancleselectallfield":`Annulla tutti i campi selezionati`,
"image.up.maxsize":`Il file caricato è troppo grande, per favore non superare i 2M.`,
"label.icon.8":`File`,
"label.donot.delete":`Non hai il permesso di cancellare`,
"label.version.profile.and.layoutpage":`Profili e layout di pagina`,
"chatter.coll.s":`Rimuovi questo segnalibro`,
"label.icon.163":`Terra`,
"label_chatter_myfollowers":`I miei seguaci`,
"label.multilang.customforecast.refuse":`Rifiuta qualsiasi priorità predittiva di {0}, ma accetta la priorità predittiva di altri subordinati`,
"label.tabpage.findz":`Cerca`,
"label.smstemplate.detailinfo":`Dettagli di SMS Template`,
"label.knowledge.setting.hint.nineteen":`Cominciamo`,
"label.mr.tip":`Completa le regole nella linea {0}.`,
"label.icon.132":`Garanzia`,
"label.customobjects.track.introduce2":`Elenco relativo alla cronologia. Ogni volta che un utente modifica uno dei campi selezionati di seguito, i valori vecchi e nuovi del campo vengono aggiunti alla lista relativa alla cronologia, così come la data, l'ora, la natura della modifica e l'utente che la effettua.`,
"label_emailtocloudcc_redmessage5":`Stato sconosciuto, si prega di contattare l'amministratore.`,
"label.must.select.field":`Errore di condizione della linea, è necessario selezionare un campo.`,
"label.tag.manage.modifiedby":`Modificato da`,
"label.translation.start1":`Seleziona una lingua (se sei un traduttore).`,
"label.ccchat.topic.searchs":`Cerca argomento`,
"label.mask.custom.example":`{AAAA}{****}{AAAA} rappresenta la visualizzazione criptata dal quinto all'ottavo carattere.`,
"setup_object_field_dependency_label_addtolist":`Aggiungere i valori selezionati`,
"label.view.total.record":`Totale selezionato 0 record.`,
"label.service.without.right":`Nessun diritto associato`,
"template.chart.wxqzkhyy":`Motivi per i lead non validi`,
"vue_label_dashboard_pleaseenterabreakpoint1value":`Inserisci un valore di breakpoint 1`,
"message.pleaseinputmouthdistance":`Inserisci l'intervallo di mesi valido.`,
"label.forgetPsd.tip":`Dimentica la password, contatta l'amministratore.`,
"label.projectManagement.planned":`Programmato`,
"lable.Product.conversion.asset.operation":`Trasferire il prodotto all'attività`,
"label.search_forms":`Ricerca di moduli`,
"label.sendemail.chat.addPostmainPagesubject":`Messaggio sulla homepage di CloudCC CCChat`,
"label_tabpage_viewNamez":`Inserisci il nome della vista`,
"label_chatter_addresser":`Mittente`,
"Opportunity_Detailed_Phase_Change_Text_001":`Fase delle opportunità di cambiamento`,
"label.what":`Pagina`,
"vue_label_systemSettings_set_android":`Impostazione di menu e funzioni per Android e IOS per renderlo adatto agli utenti aziendali.`,
"label.sell":`Vendita`,
"template.report.folder.case":`Analisi dei casi`,
"label.customfields.profilefieldsafety":`Sicurezza del profilo a livello di campo`,
"label.industrialandcommercialverification.label.token":`Token`,
"label.finished":`Completato`,
"label.sendmail.step3.introduce1":`Attualmente hai`,
"vue_label_calendar_other_calendars":`Altro calendario`,
"label.donot.know.validate.field":`Campi di convalida non validi`,
"label.exportdetail":`Dettagli di esportazione`,
"label.step.filter":`Specificare le condizioni del filtro`,
"label.campaignmember.main.hasMember":`Membri esistenti`,
"label.updown.suess":`Scaricare con successo`,
"label.ems.browse":`Sfogliare`,
"front-email-payment-Invoice-login-account-describe":`Fare clic su "Continua" per completare il pagamento della fattura mediante la scansione del codice QR di Alipay o il login Alipay.`,
"label.copyCustomReportType":`Clonare l'origine dati del rapporto personalizzato`,
"label.visualpage.write.class":`Modifica il codice della classe nella pagina con la stessa sintassi di Java.`,
"label.setsharerule.tip":`<br>Utilizza le regole di condivisione per fare eccezioni automatiche alle tue impostazioni di condivisione a livello di organizzazione per gruppi definiti di utenti.<br>Nota: "Ruoli e subordinati" include tutti gli utenti in un ruolo, e i ruoli sotto quel ruolo.`,
"label.report.action.addtodashboard9":`Pagina della lista del cruscotto`,
"label.cloudccsite.remark":`Descrizione del sito`,
"label_tabpage_noz":`No`,
"chatter.up.limit":`Il file caricato è troppo grande, per favore non superare`,
"label.leadmarketsea.grouplist.title":`Impostazioni del gruppo Lead Pool`,
"label.pc.user.help":`Guida per l'utente`,
"label.partnerCloud.orderingPlatform.relyOn":`Dipendenza`,
"label.appointmentpage.wizard.subtitle2":`Scegliere il tempo`,
"label.deleteoneormore":`Cancellare uno o più`,
"january":`Gennaio`,
"label.delete.profile":`Cancellare il profilo`,
"label.appointment.wizard.subtitle1-7":`2 h`,
"label.icon.188":`Cosmetico`,
"vue_label_file_already_in_lib":`Esiste già in questa libreria di file`,
"label.icon.151":`VR`,
"label.withvalue":`Per valore`,
"label.tianyancha.businseeverify.opererror":`Impossibile aprire i dati aziendali. riprova o contatta il tuo amministratore di sistema!`,
"label.tabpage.individual":`Scelta individuale`,
"label.layout.editdistribute":`Modifica dell'assegnazione`,
"label.smstemplate.lookup":`Visualizza il modello SMS`,
"pagecreator.systemstyle.button.delete":`Cancellazione dello stile`,
"label.customer.tab.step2.same.option1":`Predefinito On`,
"label.knowledgebase.no.results.knowledge":`Nessun risultato in Conoscenza`,
"label.data.exp.newtemporexp":`Seleziona il metodo di esportazione dei dati o crea un nuovo modello`,
"vue_label_chatter_refuse_join":`Rifiutarsi di aderire`,
"Homepage.News.002":`Il componente notizie non è attualmente disponibile.`,
"label.log.requesttype":`Metodo di richiesta`,
"vue_label_dashboard_generatefromreport":`Generare da un rapporto`,
"label.knowledge.create.version":`Crea versione`,
"label.emailtocloudcc.description2":`Collega la tua email`,
"label.partnerCloud.partnerAccount.recharge":`L'importo della ricarica deve essere compreso tra 0,1 e {limite superiore}.`,
"label.customobjects":`Oggetti personalizzati`,
"label.schedulableprg.endtime":`La data di fine deve essere successiva alla data corrente del sistema`,
"message.error.viewreport.confirmdelete":`Ci sono grafici che usano la vista/report corrente come fonte di dati. Vuoi anche cancellare il grafico?`,
"label.marketing.social.seting":`Impostazione dei social media`,
"chatter.follow.stop":`Smetti di seguire questo utente`,
"label.notification.arketsea.return":`{5} ha restituito {0}：{1} a {2}`,
"label.conditionsofnextapprover":`Ci sono uno o più approvatori successivi specificati nella tua richiesta di approvazione selezionata. Usa la seguente casella di ricerca per specificare il prossimo approvatore.`,
"label.partner.all.state":`Stato`,
"mobel_web_closed":`Chiuso`,
"label.icon.65":`Attrezzatura`,
"label.stdashbord.xsld.business.jinehj":`Importo totale`,
"label.selectobject":`Selezionare l'oggetto`,
"label.account.CurrentFQ":`FQ corrente`,
"label.workflow.estimaterule":`Valutare la regola quando un record è:`,
"label.list.userinterface.shownewrecordssetup":`Impostazioni di registrazione recenti`,
"label.tianyancha.businessverify.msg3":`1. carica`,
"label.weixin..xsld.jieduan":`Fase`,
"label.first.quarter":`Primo trimestre`,
"Opportunity.Detailed.Phase.Label.002":`{0} giorno(i) nella fase attuale`,
"label_tabpage_page":`Pagina`,
"label_emailsync_status_time":`Tempo`,
"label.pleaseselectaapprover":`Seleziona un approvatore`,
"label.emailtocloudcc.redmessage5":`Stato sconosciuto, si prega di contattare l'amministratore.`,
"label.four.quarter":`Quarto trimestre`,
"label_chatter_relateList":`Elenco rilevante`,
"label.customfields.new.step2.opration.exid.info":`Impostare questo campo su un identificatore di record unico per un sistema esterno`,
"label.projectManagement.nodata.overdue.tasks":`Grande! Nessun compito in ritardo`,
"label.sendemail.activity.task.statuscompleted":`Caro #createbyidccname Ciao! \Il compito che hai assegnato a #belongtoidccname su #createdate è il seguente: \Soggetto: #subject\Regolamentazione: #scadenzaData \r\n Elementi correlati: #relatedstr\r\rn Contenuto: #remark\r\n Si prega di visitare il link per maggiori dettagli: #path\r\n Si prega di notare: #belongtoidccname è segnato come completato. \Sistema CRM`,
"label.sso.saml.idp.config.issuer":`Emittente`,
"label.cannot.delete":`non sono autorizzati a cancellare`,
"label.pigeonhole.sel_f":`Scegliere le cartelle da archiviare`,
"label.customfields.text.tip":`Permette agli utenti di inserire qualsiasi combinazione di lettere e numeri.`,
"message.error.user.service.common":`Operazioni fallite, contattare l'amministratore per aiuto.`,
"label.datamanage.account.information":`Informazioni sul conto`,
"vue_label_homepage_deleteprofilepage":`Cancellare la homepage del profilo`,
"label.sendmail.step3.introduce3":`destinatario/i selezionato/i per ricevere questo SMS.`,
"label.pc.ui.2018.recentitem":`Articoli recenti`,
"label.report.loading":`In attesa del carico`,
"vue_label_globalsearch_adjustment":`Metodo di regolazione`,
"label_report_line_yixuan":`Colonna del rapporto selezionato`,
"label.h5.similar.opportunity.only.view":`Solo display`,
"label.marketactivitymember":`Membri della campagna`,
"label.recycle.execute.tip":`La tua richiesta è stata elaborata e ci vorrà un po' di tempo per pulire il cestino. Sarai avvisato via emial una volta completato.`,
"label.permission.detail.system.setting":`Impostazioni dei permessi di sistema`,
"label.RecordType":`Tipi di record`,
"label.custom.error.between":`La data di inizio dell'anno personalizzato o la data di fine dell'anno personalizzato è tra gli anni personalizzati della storia, controlla e ripristina`,
"vue_label_dashboard_selectview":`Seleziona Vista`,
"label.tianyancha.businessverify.cancel":`Disattivare la verifica dei dati aziendali`,
"label.partnerCloud.financeSetting.MD5":`Chiave segreta MD5`,
"label.multilang.messagedetail.new.error":`Non riusciamo a trovare un utente della chat con un nome qualsiasi con {0}:`,
"label.callcenter.pleaseenter.private.key":`Inserisci la chiave segreta di accesso privato`,
"label.umeng.activity.youdistribute":`Sei stato assegnato a`,
"label.weixin.nickname":`Soprannome`,
"label.customerinfo.mailusername":`Nome utente e-mail`,
"label.partnerCloud.orderingPlatform.discountPlan":`Nome del programma di sconto:`,
"lable.account.year":`Anno fiscale`,
"T":`Tempo`,
"System.Email.Template.Title":`Benvenuti nella piattaforma CRM CloudCC`,
"label.login.type":`Tipi di accesso`,
"label.notification.evaluation":`{0} commento a sinistra di {2} per il caso {1}`,
"label.turntolist":`Vai agli elenchi`,
"label.sort":`Ordina`,
"vue_label_commonobject_notice_clickcross":`Se hai bisogno di sostituire il file caricato, clicca sul pulsante [X] e carica di nuovo`,
"label.Select.maximumecords.operate":`Si possono selezionare fino a 200 record da elaborare.`,
"label.submission_rate":`Tasso di presentazione`,
"label.datadelete.record.sucessfully":`record di successfully!`,
"label.version.standard.dashboard":`Cruscotti standard`,
"label.task.postunsolve":`Compiti in ritardo`,
"label.Receivables.name":`Nome del credito`,
"label_tabpage_noOperationz":`Questo contenuto è un elemento fisso e non può essere azionato!`,
"label.attendance.onrecord":`Seleziona un record di almeno`,
"label.partner.error2":`Errore: Il nome del dominio può contenere solo numeri o lettere.`,
"label.account.map":`Mappa dell'account`,
"label.dashboardSetup.reference.legend":`Riferimento del diagramma`,
"label.Yaxisscope":`Portata dell'asse Y`,
"label.hierarchy.tree.tip":`Seleziona un record nel campo di ricerca di ogni scheda per creare una gerarchia. E la gerarchia è la seguente:`,
"label.permission.objlist.columnsize":`Numero di campo totale`,
"label.setup.mobile.bottombutton.savesuccess":`Impostazioni della pagina di primo livello salvate`,
"label.mobile.side.tab.selected":`Già selezionato`,
"label.partner.donotdel.cause":`Perché è collegato con la seguente nuvola partner`,
"label.ccchat.message.new.error4":`Promemoria:`,
"vue_label_systemSettings_setorganization":`Imposta le applicazioni per la tua organizzazione, personalizza diversi menu per le varie divisioni funzionali.`,
"label.umeng.approval.approvalmes4obj1":`Si prega di rivedere l'approvazione in tempo`,
"UG_opportunity_010":`Creare una transazione`,
"label.tag.addtags.public":`Pubblico`,
"System.TAB.SeeViewPageAmount":`Visualizza le pagine`,
"label.filterconditions":`Filtro`,
"front-personalEmailBox-module-v12-clear-not-associated":`Annullare la connessione cancellerà tutte le email non associate, sei sicuro di annullare la connessione?`,
"label.assign":`Assegnare`,
"label.layout.clone.tip":`Si può selezionare un layout esistente da clonare`,
"label.choose.relatedlist":`Seleziona la lista correlata che vuoi trasferire`,
"label_chatter_recordcall":`Chiamata registrata`,
"label.product.proofOne":`In {0}, scegli fino a {1} opzioni di prodotto.`,
"label.layout.availablefield.relatedlist":`Campi disponibili / Elenchi correlati`,
"label.campaignmember.main.updateleadstatus":`Aggiornare lo stato dei lead esistenti`,
"label.custom.buttonandlink":`Pulsanti personalizzati`,
"label.view.manage":`Visualizza Gestione`,
"label.search.exp":`Seleziona gli oggetti per i quali vuoi abilitare le seguenti caratteristiche e clicca su Salva:`,
"vue_label_appstore_apply_to":`Applicare a`,
"label.dashboard.message.refreshfail":`Aggiornamento del cruscotto non riuscito`,
"UG_Case_02":`I casi ti permettono di rispondere e risolvere i problemi degli account. I casi sono un potente record in Cloud CC che non solo tiene traccia dei problemi dell'account, ma mostra anche una visione completa dell'account.`,
"label.project.hit.three":`Promemoria giornaliero dei sottocompiti`,
"label.tianyancha.businessverify.tip":`La funzione di verifica dei dati aziendali è abilitata per aiutare gli utenti a inserire le corrette informazioni di registrazione dell'azienda cliente quando inseriscono i dati del cliente aziendale.`,
"label_emailsync_status_disconnect":`Cancella Conncet`,
"label.rule.disabled.successfully":`Disattivare le regole con successo`,
"label.custombutton.queryerror":`Query fallita, si prega di ripetere l'operazione.`,
"label.customfields.deletecannotresume":`I dati corrispondenti saranno cancellati in modo permanente e non potranno essere recuperati.`,
"label.account.current.M":`Questo mese`,
"label.under.approve.data":`i registri vengono controllati (`,
"vue_label_title_remainingdays":`Giorni rimanenti`,
"label.partnerCloud.orderingPlatform.refundable":`Sconto disponibile`,
"label.lookup.iscover":`Permettere la sincronizzazione durante la modifica`,
"label.recordtype.detail.selectlist":`Picklists disponibili per la modifica`,
"label.sso.isActiveYes":`Sì`,
"label.service.appointmentList.canceltheSuccess":`Cancellato con successo`,
"label.escalation.setup.newentries.createfirst":`Quando il caso viene creato, e disabilitato dopo che il caso è stato modificato per la prima volta`,
"label.new.ccpeakfolder":`Classe: Nuova cartella`,
"lable.currencyAdv.exchagecurrency.after":`e dopo`,
"label.majoranddetailrelation":`Relazioni master-dettaglio`,
"label.appointment.wizard.subtitle4-2-1":`1 h`,
"label.projectManagement.working.hours":`Orario di lavoro`,
"label.forecast.customforecast.button.forehistory":`Storia delle previsioni`,
"label.mymasterplate":`I miei modelli`,
"component.setup.tabs.label.memo":`Imposta il nome dell'etichetta della scheda`,
"label.customfields.longtextarea.tip":`Permette agli utenti di inserire fino a 32.000 caratteri su righe separate. Si possono creare fino a 10 campi Text(Long) per oggetto.`,
"label.service.miniProgram.fillJumpLink":`Si prega di compilare il link di salto.`,
"label.british.summer.time":`Ora media di Greenwich`,
"label.nogreate":`<=Meno o uguale`,
"label.assignment.setup.detail.sameuser":`Stesso utente`,
"mesage.error.profile.delate.user":`Impossibile eliminare il profilo perché l'utente è assegnato al profilo corrente.`,
"label.tabpage.cownerz":`Cambia proprietario`,
"label.multilang.dupicatecheck.processedcount":`Dati duplicati，{0} gruppi sono stati trattati，{1} gruppi di dati non sono stati trattati：`,
"vue_label_report_notice_leavecertification":`Sei sicuro di lasciare questa pagina - i dati che hai inserito potrebbero non essere salvati`,
"label.master.required":`Avere campi obbligatori che mancano nei registri dei bambini`,
"label.chatter.follow":`Segui`,
"label.dataimport.insertdata.error.repeat":`Il record duplica i dati nel database originale e il record è stato ignorato all'importazione.`,
"label.sms.cgid":`Numero della galleria`,
"label.knowledge.article.rator":``,
"label.datamanage.object.field":`Campi oggetto`,
"label.forecast.editshrepage.quanxian":`Condivisione del livello di accesso Peimission`,
"label.weixin.interactive.log":`Registro delle interazioni`,
"label.batchedit.remark":`Modifica di più record`,
"label.user.permissions.message":`Nessun permesso per impostare le informazioni dell'utente.`,
"label.mobile.phone.month":`mese`,
"chatter.sel.u":`Seleziona gli utenti che vuoi @ menzionare, o digita il nome utente che vuoi @`,
"label.service.gantt.assigned.work":`Lavoro assegnato`,
"UG_ST_001":`Prompt`,
"label.edit.select.one":`Elenco a discesa`,
"label.forecast.shrepage.desc0":`Questa pagina elenca gli utenti, i ruoli e le zone che hanno accesso condiviso a {0}.`,
"label.multilingual.confirm.close":`Sei sicuro di disabilitare? Il multilingua non può essere usato dopo la disabilitazione e la lingua dell'utente sarà cambiata nella lingua predefinita.`,
"label.setting.intergrationlist.integration":`Integrazione`,
"label.leadscore.rule.list":`Elenco delle regole di punteggio dei lead`,
"component_telerecord_button_save":`Salva`,
"label.weixin.save.log":`Salva registro`,
"label.validate.function.funcExplain.DAY":`Restituisce un giorno del mese, è necessario inserire un numero compreso tra 1 e 31.`,
"label.appointmentdetail.wizard.title1":`Nome`,
"label.multilang.feedtrack.dealkey":`Modifica {0} da {1} a {2}`,
"label.optional.features":`Caratteristiche opzionali`,
"vue_label_email_no_email":`Nessuna e-mail`,
"label.sendemail.chat.messagecontent":`Il contenuto del messaggio:`,
"label.tabpage.lessequalz":`Inferiore o uguale a`,
"setup.layout.label.setupfield":`Proprietà del campo`,
"label.approved.receiveApprovalEmail.option1":`Se sono un approvatore o un approvatore delegato`,
"label.chatter.relateList":`Elenco rilevante`,
"component.sendmail.label.fromuser":`Mittente`,
"label.projectManagement.problem.status":`Stato della questione`,
"label.weixin.fmu.before.hour":`{0} ora(e) avanti`,
"chatter.feed.menutype.feed.mark":`Bookmarked`,
"label.addQuoteLineGroup":`Aggiungi un gruppo di linee di quote`,
"label.report.action.addtodashboard6":`Aggiungi`,
"label.url":`URL`,
"lable.account.CurrentandPreviousCQ":`CQ attuale e precedente`,
"label.tabpage.emptyz":`Vuoto`,
"less":`Meno di`,
"label.h5.selectmostphotos":`Si possono selezionare al massimo nove foto`,
"UG.activity.04":`Outlook/Gmail mailbox, registrare la posta`,
"template.chart.qbhtje":`Tutto l'importo del contratto`,
"label.tabpage.endz":`Fine`,
"label.partner.workspace.member":`Membro`,
"label.filter.error.filedvaluetoolong":`Errore: Il valore del campo supera il limite massimo.`,
"label.months":`Mese`,
"button.partner.workspace.disable":`Annullare l'attivazione`,
"label.visualpage.checkpinyin.grammar":`Si prega di controllare l'ortografia e la grammatica.`,
"label.dashboardSetup.geshihua":`Formattazione`,
"label.belongto":`Appartenere a`,
"label.upload.cannot.empty":`Devi selezionare un file da caricare.`,
"label.number.MaxCheck":`Il massimo di {0} è {1}. Per favore, modifica la quantità e salva le modifiche.`,
"pagecreator.page.message.save.fail":`Salvataggio della pagina non riuscito`,
"label.edit.SMS":`Modifica della notifica SMS`,
"UG_Lead_002":`Ci sono molti modi per identificare i "lead" per il tuo prodotto o servizio.`,
"label.quickcreate.active.quickcreate":`Abilita la creazione rapida`,
"label.recordtypeselect.tip":`Per saltare questo passaggio in futuro, impostate dei tipi di record predefiniti.`,
"label.form_content":`Modulo`,
"workflow.action.tasks.assignortype.related":`Utente correlato`,
"vue_label_allsearch_set_more_items":`Puoi impostare altri elementi di ricerca nella casella a discesa sul lato sinistro della casella di ricerca per continuare la ricerca`,
"label.tianyancha.businessverify.title":`Verifica del business`,
"label.errormessage.batchedit.norecord":`Nessun dato.`,
"label.permission.appname":`Nome dell'applicazione`,
"label.report.action.addtodashboard7":`Cancella`,
"label.generated.transfer.product":`Generare asset secondo il modo di Conversione degli asset.`,
"vue_label_commonobjects_detail_you":`Tu`,
"label.user.captcha":`Verifica la tua identità`,
"label.notification.event4":`L'evento 【事件名】 che hai assegnato a 【被分配人】 inizia a 【开始时间】`,
"label.version.setup":`Impostazione`,
"setup.object.layout.message.selectedlayoutandrecordtype":`Seleziona il layout e il tipo di registrazione`,
"label.role.add":`Aggiungi ruolo`,
"label.versiontype.Unlimited":`Illimitato`,
"label.partnerCloud.financeSetting.developerID":`Inserisci l'ID dello sviluppatore.`,
"front-invoice-online-payment-setup-global":`Applicare agli account globali`,
"vue_label_commonobjects_view_basis":`Base di classificazione`,
"label.decimaldigits.tip":`Il numero di cifre a destra della virgola decimale`,
"vue_label_commonobjects_detail_selected":`Segna come fase attuale`,
"label.data.export.page":`Vai alla pagina di esportazione`,
"message.error.serviceresource.servicecrewid":`Ogni equipaggio di servizio può essere aggiunto solo come un record di risorsa di servizio del tipo di equipaggio.`,
"label.loginttime.alltime":`Tutto il tempo è`,
"label.requiredinfo":`Informazioni richieste`,
"label.forecast.edit.di":`FY`,
"vue_label_calendar_failed_to_remove_calendar":`Impossibile rimuovere il calendario`,
"pagecreator_systemstyle_button_delete":`Cancellazione dello stile`,
"label.import.page3.continueimport":`Continuare a importare`,
"label.page.width":`Larghezza della pagina intera`,
"label.campaignmember.selectmember.addmember":`Aggiungere membri da`,
"label.finalreject":`Rifiuto finale`,
"label.isend":`È finito`,
"front-console-conversation":`Dialogo`,
"label.mr.theLastGroupOfThisPage":`Questa è l'ultima serie di dati su questa pagina, clicca su [Torna alla lista dei dati duplicati] per visualizzare altri dati duplicati.`,
"label.data.dataexpalltype.all_desc":`Esporta i dati di tutti gli oggetti che l'utente corrente ha accesso alla lettura.`,
"label_emailtocloudcc_redmessage7":`Errore di configurazione, contattare l'amministratore.`,
"label.forecast.shrepage.classdes.all":`Accesso completo - Gli utenti possono visualizzare e sovrascrivere i dati di previsione ed estendere l'accesso ad altri utenti attraverso la condivisione.`,
"market.contacts":`Contatto di mercato`,
"label.weixin.polls.voter":`Elenco dei votati da`,
"template.report.industry.distribution.customers":`Distribuzione settoriale dei conti`,
"front-electronic-signature-setup":`Contratto Infor Autofill e Backfill Setup`,
"vue_label_chatter_removecertification":`Sei sicuro di voler rimuovere il membro "{nome}"?`,
"label.appointment.wizard.subtitle1-2":`15 min`,
"label.sso.saml.idp.config.custattr":`Attributo personalizzato`,
"label_tabpage_totalTeamz":`Un totale di gruppi`,
"lable.outlook.detail.assigned":`Utenti e profili assegnati`,
"label.department.user.delete":`Cancellare`,
"label.customcomponent.check.label.same":`Questa etichetta esiste già.`,
"label.partner.error1":`Errore: la lunghezza del dominio è troppo lunga`,
"label.escalation.setup.entrydetail.escalation.notify":`Notifica`,
"component_todaytask_label_choicestate":`Seleziona lo stato`,
"label.customfields.fielddependency.new.step1":`<b>Step1: </b> Seleziona un campo di controllo e un campo dipendente. Clicca su Continua quando hai finito.`,
"chatter.group.anyoneCanSeeTheUpdateAndJoin":`Tutti possono vedere e chiedere di unirsi a questo gruppo`,
"label.custom.pixel":`pixel`,
"label.quicksave":`Salvataggio rapido`,
"label.approved.persion":`Approvazione delegata`,
"lable.info.queue.member":`Membri della coda`,
"label.addattachment.step2.weixin":`Passo 2 Fare clic su Upload per caricare i file`,
"label.forecast.customforecast.title":`Previsioni`,
"mainpage_setup_chosecomponent_leastone":`Devi selezionare almeno un componente nella homepage.`,
"label.appointmentconfirmpage.wizard.title2":`Un invito al calendario è stato inviato alla tua email.`,
"label.useallselectedapprover":`Richiede che tutti gli approvatori selezionati <strong>approvino all'unanimità </strong>.`,
"label.ccpeak.current.line.return":`Ritorna dalla linea corrente e non viene più eseguito verso il basso.`,
"label_new_target_model":`Nuovo modello di obiettivo`,
"label.saving":`Risparmio...`,
"label.mobile.phone.write":`Scrivere`,
"label.applt.updown.text":`Puoi anche scaricare il codice QR di un mini portale di programmi dedicato alla tua azienda e mettere il codice QR dentro una pagina web o un articolo pubblico, e i clienti possono scansionare il codice QR per usare il mini programma.`,
"label.partner.common.manageSetup":`Impostazioni amministrative della nuvola del partner`,
"label.quickbooks.new":`Nuovo cliente`,
"message.error.color":`il colore non può essere vuoto!`,
"label.project.template.two":`Ci può essere un solo insieme di configurazioni sotto ogni tipo di record per oggetto!`,
"label.approval.input.des1":`Approvare o rifiutare livello per livello, e il livello massimo della gerarchia è:`,
"label.x.axis.cannot.empty":`L'asse X non può essere nullo`,
"label.solomon.isiands.time":`Solomon è. Tempo`,
"label.login.access.duedate":`Durata dell'accesso`,
"label.service.dispatch.booking.order":`Assegnazione dell'appuntamento di servizio`,
"label_shareme_forecast":`Previsioni condivise con me`,
"label.custom.page.cuspage.height":`Altezza(Pixel)`,
"label.quote.line.group.":`Sei sicuro di voler cancellare il gruppo di righe di citazione di {groupName}? Anche le righe di citazione in questo gruppo saranno cancellate dopo l'operazione.`,
"label.data.downpage.i_title.num6":`Si raccomanda di importare un file di prova contenente 5 record prima di importare i dati per assicurarsi che i dati da importare siano corretti.`,
"label.\u2019s":`s`,
"label.version.contact.management":`Gestione dei contratti`,
"label.document.history.user":`Utenti`,
"vue_labenl_commonobjects_opportunity_product_edit_notice1":`Si prega di inserire l'importo corretto, fino a due cifre decimali.`,
"label.weixin.target.contract.jine":`Importo target del contratto`,
"lable.common":`￥0 in totale`,
"front-kefu-moudle-sendemail-success":`L'email è stata inviata e il personale di vendita vi contatterà al più presto`,
"label.service.no.operation.time":`Il record attuale non ha un tempo di funzionamento associato!`,
"label.info":`Informazioni`,
"label.ccchat.zw":`NOON`,
"label.assignment.setup.newentries.title":`Modifica della voce della regola`,
"label.weixin.report.timeline":`Campo data`,
"UG.quota.04":`Stampa preventivo`,
"label.social.user.exception":`Informazioni anormali dell'utente del sociale.`,
"label.import.index.failed":`Fallito`,
"label.common.settings":`Impostazioni generali`,
"label.nullvalue":`Valore nullo`,
"PageLayout_Search_MultiSearch_002":`Abilita la casella di ricerca personalizzata (Ricerca per campo singolo)`,
"message.myselfreport":`I miei rapporti personali personalizzati`,
"label.productsales.today.noevttskaddtsk":`Non ci sono eventi aperti e compiti in scadenza, puoi cliccare " " in alto a destra per aggiungere un nuovo compito.`,
"lable.oppdt.noconditionrecrods":`Nessun record da visualizzare`,
"label.campaignmember.selectmember.deletelead":`Campagna: rimuovere i membri dai lead`,
"label.marketingactivity":`Campagne`,
"vue_label_pool_self-built":`Autocostruito`,
"message.textareamaxlength":`La lunghezza non dovrebbe superare i 4000 caratteri`,
"label.valadate.must.value":`Deve inserire un valore`,
"label.tabpage.groupsVisiblez":`Alcuni gruppi di utenti sono visibili`,
"component.button.cancel":`Cancella`,
"label.emailobject.list.inbox":`Inbox`,
"label.app.step1.error.labelexist":`ERROR: Questa etichetta esiste già o è stata usata in precedenza.`,
"front-calendar-V1-Unable-to-display":`Il record non può essere visualizzato nel calendario perché il campo di fine di uno o più record è precedente al campo di inizio.`,
"label.forecast.settings.prompt1":`È necessario selezionare almeno una misura previsionale: Entrate o Quantità.`,
"front-kefu-moudle-callout-missphone":`Chiamare le chiamate perse`,
"label.tabpage.editz":`Modifica`,
"vue_label_chatter_label_new_team":`Nuovo gruppo`,
"label.version.formulafield":`Campo della formula`,
"label.partner.step1":`Passo 1 selezionare il modello`,
"label.weixin.perfect.url":`Inserisci i dettagli dell'URL`,
"label.appointmentconfirmail.wizard.subtitle4":`Descrizione`,
"label.step7.total7":`Passo 7 di 7`,
"setup.object.layout.label.selectedprofile":`Profili selezionati`,
"label.payments.paytip5":`Inserisci il numero corretto di utenti!`,
"label.visualpage.open.type":`è aperto stile di pagina personalizzato`,
"lable.Sort.field.tips":`Personalizza l'ordine di registrazione nella lista correlata selezionando i campi da ordinare. Puoi ordinare in base a qualsiasi campo numerico o di data degli oggetti.`,
"label.nosharerules":`Nessuna regola di condivisione specificata.`,
"label.service.miniProgram.bindSetOwner":`Impostare i casi Proprietario`,
"report_label_highlevelreport":`I rapporti avanzati permettono di creare le relazioni tra un massimo di 4 oggetti.`,
"S":`Testo`,
"label.lastmodifyby":`Ultimo modificato da`,
"label.customerinfo.mailaddress":`Indirizzo e-mail`,
"vue_label_pool_converted":`Convertito`,
"UG.ST.004":`Non hai il permesso di gestione dei dati - "importazione dei dati, contatta l'amministratore, clicca su conferma e vai direttamente all'interfaccia {0}.`,
"label.view.application.mobile.terminal.filed":`Questa vista è stata applicata nell'applicazione mobile. Sono disponibili un massimo di 10 campi; sono selezionati.`,
"chatter.feed.limitentity500":`Puoi seguire 500 colleghi e record.`,
"label.starttime":`Iniziare`,
"chatter.emailToMe":`Ricordami quando qualcuno:`,
"label.custom.Current.and.PreviousCQ":`CQ attuale e precedente`,
"label.my.logout":`Io`,
"label.quickbooks.searchlist.enddate":`Data di fine`,
"label.ccservice.validate.length":`La lunghezza del valore corrispondente {2} del campo {1} sotto l'oggetto API {0} è superata. Per favore, resettalo!`,
"label.integrations.installed":`Installato`,
"label.integrations.mailchimplist":`Lista Mailchimp`,
"label.checkfield.matchothers":`Corrisponde ad altri record`,
"label.umeng.activity.event.distributewillbegin":`L'evento #evento che hai assegnato a #nome inizia tra #tempo.`,
"pool.notice.gotolightning":`Per favore, vai a Lightning Menu se vuoi usare questa funzione.`,
"label.batchtransfer.pleaseselecttransferreddata":`Seleziona i dati che vuoi trasferire`,
"label.mr.title.mailingAddress":`Indirizzo postale`,
"vue_label_approve_no_response":`Nessuna risposta`,
"component.event.label.title":`Prossimi eventi`,
"label.mobile.setup.confirm":`Stai cambiando la posizione dell'icona della scheda predefinita nell'applicazione mobile. Dopo che la modifica ha avuto successo, tutte le configurazioni precedenti dell'icona della scheda mobile saranno cancellate, è necessario reimpostare l'icona della scheda utilizzata nell'applicazione mobile. Se non selezioni, il sistema selezionerà in modo casuale nel tuo catalogo di impostazioni.`,
"label.tianyancha.approvaltime":`Data di approvazione`,
"label.download_merge_file":`Scaricare il file fuso`,
"label_display_quota":`Mostra quota`,
"label.publishreadonly":`Pubblico di sola lettura`,
"label.campagin.roi.query.roi":`ROI della campagna`,
"label.dashboardSetup.lookup":`Trova i cruscotti`,
"vue_label_notificationcenter_nomessages":`Nessun messaggio non letto`,
"label.create.object":`Creare un oggetto`,
"label.social.campaign.null":`Le informazioni di campagin non possono essere vuote`,
"label.console.step6.left":`Fissa a sinistra e le liste sono sempre visibili.`,
"label.line":`Colonna`,
"label.bottonandlink.introduce":`Ecco una lista di pulsanti e link. Aggiungi pulsanti o link, per favore modifica il layout.<br/>I pulsanti e i link possono essere aggiunti alla pagina dei dettagli, alla lista correlata e alla vista elenco.<br/>`,
"label.layout.list1":`Elenco 1`,
"label.mr.title.customerName":`Nome del conto`,
"label.user.text":`Testo`,
"label.nolastestrecord":`Nessuna registrazione più recente`,
"label.emailobject.appointment.urltext1":`Vedere il mio programma e`,
"label.chat.topic.my.favorites":`Bookmarked`,
"label.select.dashboar.cd0":`Il campo di raggruppamento non può essere vuoto`,
"label.data.downpage.e_title.num2":`2. Se scegli di esportare i dati di un singolo oggetto, devi selezionare come i dati vengono esportati: esportazione personalizzata, esportazione per modello e modello di esportazione.`,
"message.error.user.service.login.unconn":`Rete occupata, riprovare o contattare l'amministratore.`,
"label.escalation.setup.newentries.title":`Modifica della voce della regola`,
"label.import.step1.above2000":`Quando il trigger viene eseguito, è possibile importare un massimo di 2000 record alla volta. Si prega di dividere in più file e importarli in lotti.`,
"label.ccchat.person.allowinvite":`Permettere ai colleghi di invitare`,
"label.input.number.between":`Inserisci un numero tra {0} e {1}`,
"label.forecast.shrepage.wpfmanager":`Responsabile delegato per le previsioni`,
"label_server_is_time_out":`Il server è in time-out. Si prega di riprovare più tardi.`,
"label.indochina.standard.time":`Ora solare dell'India`,
"label.cpq.quote.sync.opportunity.failure":`Solo il preventivo primario può essere sincronizzato con l'opportunità. Seleziona la casella della quotazione primaria, quindi avvia la sincronizzazione.`,
"label.emailobject.send100emails":`Spiacente, puoi inviare solo 100 email al giorno, per favore riseleziona!`,
"label.dashboard.snapshot.end":`A partire da`,
"label.jiandangfenpei.rightlist":`Profili assegnati`,
"label.input.string.length.between":`Inserisci una stringa la cui lunghezza è compresa tra {0} e {1}`,
"label.multilang.lookfiltercondition.select":`La condizione della linea {0} non è corretta. Devi selezionare un campo!`,
"label.datamanage.lead.namenull":`Nota: se il fiel del nome della pista è nullo, il record non sarà importato.`,
"label.forecast.detailforecast.button.saveandfresh":`Salva`,
"label.venezuela.time":`Tempo del Venezuela`,
"label.same.analyze.miaoshu1":`Se hai bisogno di più regole, usa "`,
"label.twomb":`È consentito caricare solo file jpg/png con una dimensione massima di 2 MB.`,
"label.event.moveup.7hour":`7 ore avanti`,
"label.weixin.forgot.password":`Hai dimenticato la tua password?`,
"label.import.page1.diledsizelimited":`2. La dimensione massima consentita del file è 100M`,
"label.file.foldername":`Nome della cartella`,
"label.multilingual.open":`La gestione multilangiatura è abilitata.`,
"label.dashboard.snapshot.refresh.failed":`Aggiornamento dell'istantanea della dashboard non riuscito`,
"label.marketsea.memberfieldselectone":`Visualizza i campi e i membri possono visualizzare i campi Seleziona almeno un campo`,
"label.trigger.createdate":`Data di creazione`,
"label.ccpeak.operation.sharetab":`Operare sulla forma di condivisione:`,
"label.partner.message.admin.access":`Solo gli amministratori possono accedere`,
"label.emailsync.status.email":`Azione eseguita Email`,
"chatter.error":`Errore:Si prega di selezionare un file da caricare!`,
"label.role.viewinlist":`Mostra in vista elenco`,
"label.tag.addtags.title":`Tag`,
"setup.mainpage.label.welcome6":`Gli utenti possono creare vari tipi di campi in tutti gli oggetti del sistema CloudCC senza alcuna conoscenza di programmazione o sviluppo di codice. I tipi di campo includono: relazione di ricerca, campo a selezione singola, selezione a due voci, formula, numerazione automatica. , URL, telefono, fax, email, checkbox, data, ora, numero, testo, area di testo, lista di opzioni (selezione singola/multipla), valuta, ecc.`,
"label.delete.rule.successfully":`Cancellare le regole con successo`,
"label.field.duplicate.error.msg6":`Valore di campo duplicato. Il valore esce nel record:`,
"label.stdashbord.xsld.business.jhzsl":`Opportunità totali (quantità)`,
"label.compact.layout":`Layout delle informazioni chiave`,
"label.checkfield.merge.introduce":`Seleziona il valore che vuoi mantenere nel record unito.`,
"earlieststarttime.duedate.time.illegal":`L'ora effettiva di inizio dell'appuntamento di servizio dovrebbe essere inferiore o uguale all'ora effettiva di fine.`,
"label.dataimport.validate.prompt":`Prompt della regola di convalida`,
"message.setuptip":`Potete cancellare i pacchetti che avete creato.`,
"template.report.customer.collection.statistics":`Statistiche di pagamento del conto`,
"vue_label_homepage_dashboardcomponents":`Modifica dei componenti del cruscotto`,
"setup.mainpage.label.welcome30":`La piattaforma CloudCC è una vera piattaforma di cloud computing. Gli attributi aperti della piattaforma, i metodi di integrazione standard e la personalizzazione flessibile sono applicabili a tutte le industrie, integrando software di terze parti, realizzando l'unificazione in tempo reale dei dati di gestione aziendale e massimizzando le esigenze di gestione complete e approfondite dei nostri clienti. La piattaforma CloudCC può essere integrata con qualsiasi applicazione o sistema aziendale, compresi software di terze parti come SAP, Kingdee e UF. Il metodo standard Web Service sotto l'architettura SOA flessibile non ha alcun distruttivo, dipendenze tecniche o vendor lock-in.`,
"label.SMS.new.det":`Crea una notifica SMS per associare una o più regole del flusso di lavoro, processi di approvazione. Se la notifica SMS viene modificata, qualsiasi modifica viene applicata a tutte le regole e approvazioni ad essa associate.`,
"lable.product.page.previous":`Torna al precedente`,
"label.recordtype.labelname":`Etichetta del tipo di disco`,
"message.error.system.service.failure":`Esecuzione del servizio fallita, si prega di contattare l'amministratore.`,
"label.visualpagefolder":`Cartelle di pagina`,
"label.username":`Nome utente`,
"label.data.downpage.i.title.num5":`5. Si prega di controllare l'accuratezza dei dati.`,
"label.permission.manage":`Gestire le assegnazioni`,
"label_emailsync_status_user":`Utenti`,
"label.weixin.voting.least.two":`Ci sono almeno due opzioni di voto.`,
"label.tabpage.thisrecord":`Questo record`,
"label.icon.119":`Lavagna`,
"label.partner.common.webSit":`Dominio`,
"label.email.form.html2":`[passare al solo testo]`,
"label.appupload.upload.noversion":`Nessuna versione caricata`,
"label.appointmentpage.wizard.subtitle1_2":`Il fuso orario dell'invitante è {0}`,
"MR":`Relazione di ricerca (multiselezione)`,
"label.partnerCloud.orderingPlatform.availableBalance":`Saldo disponibile`,
"label.schedulejob.setup.schedule.st3":`Il 3`,
"label.reportsSubscriptionPage.email.general":`Generale`,
"label.setsharerule.step4":`Passo 4 Selezionare il livello di accesso per gli utenti`,
"front-epwechat-module-v1-info-desc":`Prendi le informazioni dal backend di WeCom e compila qui`,
"message.duplication.label.isactive":`Attivo`,
"pagecreator_systemstyle_label_linkcolor":`Colore del link`,
"label.import.page1.alertfiledsize":`I file caricati non devono superare i 100MB!`,
"tomorrow":`Domani`,
"label.publicdashboard":`Cruscotti pubblici non compilati`,
"label.knowledgebase.same.taborworkspace":`Stessa scheda o spazio di lavoro`,
"homepage.layout":`Layout della home page`,
"label.emailobject.trackemailopening":`Tracciare l'apertura delle e-mail`,
"label.unlock.tip":`Sblocca i record per la modifica`,
"lable.account.NextzDays":`Prossimi 90 giorni`,
"vue_label_report_throw":`Scartare`,
"label.icon.102":`Programma`,
"label.payments.paytip2":`Sei passato alla nostra edizione a pagamento, clicca su Conferma per chiudere la finestra e aggiornare il tuo sistema CRM.`,
"label.customfields.email.tip":`Permette agli utenti di inserire un indirizzo email, che viene convalidato per assicurare il formato corretto. Se questo campo è specificato per un contatto o un lead, gli utenti possono scegliere l'indirizzo quando cliccano su Send an Email. Nota che gli indirizzi email personalizzati non possono essere usati per le email di massa.`,
"label.test_visitors":`Prova come dovrebbe apparire il tuo modulo quando viene visualizzato dai visitatori.`,
"label.workflow.immediatelyoperate":`Azioni immediate del flusso di lavoro`,
"label.approvalstep4.tip":`La pagina di approvazione è dove l'approvatore effettivamente approva o rifiuta la richiesta. utilizzare le seguenti opzioni per selezionare i campi da visualizzare in questa pagina.`,
"label.ccchat.person.invite.failsend":`Il seguente invito non è stato inviato. si prega di contattare l'amministratore.`,
"label.import.index.obj":`Oggetto`,
"label.multilang.leadscore.countnum":`{0} volte:`,
"label.report.error.typefind":`Nessun tipo di rapporto trovato da informazioni di raggruppamento`,
"label.validate.function.funcFormat.SUBSTITUTE":`SUBSTITUTE(testo, vecchio_testo, nuovo_testo)`,
"label_tabpage_unpacketz":`Nessun dato di raggruppamento disponibile!`,
"lable.Create.new.template":`Modello di rapporto sul nuovo servizio`,
"label.knowledgebase.display.error":`Mostra {a} gli errori`,
"label.emailobject.template.message2":`Il campo inserito nell'email corrente non corrisponde al record associato, il che può causare valori nulli.`,
"label.productsales.today.taskcomplete":`Impostato su completato`,
"label.emailobject.selectone":`Seleziona almeno un record come destinatario dell'e-mail`,
"button_partner_workspace_saveas_memo":`Salva l'attuale nuvola di partner come "modello".`,
"vue_label_help_detail":`Dettagli del record`,
"label.tabpage.minutesagoz":`Verbale`,
"label_tabpage_characterz":`Carattere iniziale`,
"message.error.accesstoken.null":`Il gettone non può essere vuoto!`,
"label.textMessageObject.send100":`Spiacente, puoi inviare solo 100 messaggi di testo al giorno, per favore riseleziona!`,
"vue_label_commonobjects_detail_record_call":`Registrare una chiamata`,
"label.campaignmember.main.addlead":`Aggiungere i membri - Leads esistenti`,
"setup_mainpage_label_welcome30":`La piattaforma CloudCC è una vera piattaforma di cloud computing. Gli attributi aperti della piattaforma, i metodi di integrazione standard e la personalizzazione flessibile sono applicabili a tutte le industrie, integrando software di terze parti, realizzando l'unificazione in tempo reale dei dati di gestione aziendale e massimizzando le esigenze di gestione complete e approfondite dei nostri clienti. La piattaforma CloudCC può essere integrata con qualsiasi applicazione o sistema aziendale, compresi software di terze parti come SAP, Kingdee e UF. Il metodo standard Web Service sotto l'architettura SOA flessibile non ha alcun distruttivo, dipendenze tecniche o vendor lock-in.`,
"label.file.library.deleteprompt":`Rimuovere {0} dalla libreria delle risorse ?`,
"label.wtd.changefields.title":`Configurazione da Web a CloudCC`,
"label.sendmail.step1":`Passo 1 Specificare i destinatari da includere`,
"label.cpq.newquote.createorder.checkbox.selected":`La casella di controllo di Crea ordine non può essere selezionata durante la creazione di un nuovo preventivo.`,
"label.emailtocloudcc.name":`Nome`,
"message.error.object.nullbinding":`il legame è vuoto`,
"B":`Checkbox`,
"label.pc.endtime":`La tua licenza scadrà tra meno di 30 giorni. rinnova in tempo per assicurarti un uso continuo.`,
"label.visualpage.section.start":`Usa il tag all'inizio`,
"label.partnerCloud.basicSetting.available":`Il nome del dominio è disponibile.`,
"label.data.exportall.all_desc":`Esporta tutti i dati per tutti gli oggetti che l'utente corrente ha il permesso di visualizzare.`,
"label.editor.layout":`Modifica il layout di ricerca`,
"label.send.chatter":`Invia chiacchiere`,
"label.h5.chatter.reply":`La risposta rapida`,
"component_chatter_post_button_file":`Aggiungere allegati`,
"label.emailobject.emaildetail.button.reply":`Rispondi`,
"label.eidt.queue.title.desc":`Il nome deve essere unico e deve iniziare con una lettera. Deve contenere solo lettere maiuscole e minuscole, numeri e underscore e non deve essere più lungo di 40 caratteri.`,
"label.campaign.channel.input.url":`5.Impostare le informazioni che gli utenti vedranno dopo l'iscrizione, che possono essere una pagina di ringraziamento, un opuscolo o un ticket:`,
"label.compact.layout.assign.tip":`Questa tabella mostra le assegnazioni di layout di informazioni chiave per diversi tipi di record.`,
"vue_label_fall":`Scendere`,
"label.trigger.save.failed":`Salvataggio fallito, i dati non possono essere nulli`,
"label.appupload.upload.tips.report":`NOTA: I report e i vecchi report in "My Custom Reports" e "Unfiled Public Reports" non possono essere aggiunti ai pacchetti e non saranno visualizzati in questa cartella".`,
"label.tianyancha.businessverify.rewriteall":`Riempire tutti i dati`,
"label.campaign.channel.step6.remark4":`Si noti che il proprietario del lead può essere il proprietario della campagna corrente o la persona di sollecitazione del canale di marketing corrente.`,
"front-kefu-moudle-called-num":`Numero chiamato`,
"label.approvalstep4":`Passo 4 Selezionare i campi da visualizzare nel layout della pagina di approvazione`,
"label.login.verification.please.scan":`Scannerizza il codice usando l'applicazione MFA sul tuo smartphone`,
"label.invoice.message.statusupdated":`Stato della fattura aggiornato`,
"label.pc.ui.2018.subject":`Tema`,
"label.area.notexist.userinfo":`Il gruppo di utenti non esiste.`,
"label.newuser":`Nuovo utente`,
"label.chat.micropost.share":`Condividi il post`,
"label.locatedupcurrentvalue":`Il valore superiore a quello corrente`,
"vue_label_systemSettings_course":`Impostazione del percorso del fulmine`,
"chatter.group.public":`Pubblico`,
"label.reportsSubscription.entrance":`Iscriviti`,
"front-kefu-moudle-v1-online-at":`Agente online`,
"label.rejectbehaviourselect":`Esegui <strong>solo</strong> il rifiuto di questo passo e rimanda la richiesta di approvazione all'approvatore più recente. (Torna al passo precedente)`,
"vue_label_commonobjects_view_currentviewset":`Per annullare l'impostazione della vista predefinita corrente, è possibile impostare un'altra vista come predefinita.`,
"lable.currencyAdv.and":`e`,
"label.appexchange.installedpage.publish":`Pubblicato da`,
"label.tab.profile.ismobile":`Applica all'applicazione mobile`,
"label.data.setok.t.desc2":`Torna alla pagina del modello di dati`,
"label.email_required":`L'email è necessaria.`,
"label.tabpage.fullscreenz":`Schermo intero`,
"chatter.sticker.set":`Monitoraggio dei mangimi`,
"label.mobile.phone.year":`anno`,
"label.projectManagement.next.page.before":`Pagina precedente`,
"pagecreator_button_pcpage":`Fine Pc`,
"label.dashboard.xsld.percent":`Percentuale`,
"label.ccpeak.service.checkerror":`Errore nel controllo della sintassi.`,
"label.icon.26":`Cartella`,
"label_partner_common_webSit_memo":`Nome di dominio predefinito:`,
"label.unselectfile":`Nessun file selezionato`,
"label.take.notice":`Avviso`,
"message.error.filename.null":`fileName non può essere vuoto!`,
"vue_label_SMS_nophone":`Nessun numero di telefono`,
"label.area.assignuser":`Assegnare gli utenti`,
"label.icon.176":`Prompt`,
"label.icon.21":`Valuta`,
"message.error.system.service.deletedeny":`Dada è associato e non può essere cancellato.`,
"label.compact.layout.main.tip":`Seleziona il layout delle informazioni chiave da utilizzare quando questo record appare come voce della lista in CloudCC.`,
"label.emailtocloudcc.delete":`Cancellare`,
"label.dashboardSetup.showdw.d2":`10 Milioni`,
"front-kefu-moudle-hqyyjlsb-admin":`Impossibile ottenere la registrazione vocale, contattare l'amministratore per aiuto`,
"label.partnerCloud.basicSetting.userCounts":`Ruoli totali del partner`,
"front-kefu-moudle-calling-num":`Numero di chiamata`,
"label.alldocument":`Tutti i documenti`,
"coderules.nullvalue1":`Impossibile generare. Inserisci il valore di 【{0}】 utilizzato nelle regole di generazione.`,
"lable.automatically.shared":`Condiviso automaticamente`,
"label.batchadd.newbatchpage.save.emptyselect":`Si prega di controllare se ci sono opzioni richieste non selezionate.`,
"vue_label_homepage_card_30dayswithout":`Opportunità non contattate per 30 giorni`,
"label.multilang.dupicatecheck.onegroupnote":`Si prega di scegliere almeno due dati, fare clic sul pulsante [Carica le informazioni selezionate] per entrare nella pagina di combinazione dei dati. Attualmente nel {0}-esimo gruppo di dati aziendali, ci sono un totale di {1}record:`,
"UG.activity.03":`Prenota un programma`,
"label.pc.oldpage":`Vecchia pagina`,
"label.exchange.sync.state.task.m2":`Registrazioni sincronizzate negli ultimi 60 minuti:`,
"label.setmovable":`Impostazioni dell'attività`,
"label.sendemail.send.loginfail":`Impossibile accedere alla casella di posta elettronica, reimposta le tue informazioni e-mail.`,
"label.copy.quote.lines":`Clonare la linea delle citazioni`,
"label.copying.reward.to.groups":`Copiare in gruppi di righe di quotazione`,
"label.ems.connect.error":`Errore di connessione del server, si prega di controllare.`,
"lable.account.Tomorrow":`Domani`,
"label.manageAll.sta2":`Approvato`,
"label.create_form":`Nuovo modulo`,
"label.ems.saveDetail.error.msg":`Salvare il fallimento. si prega di controllare l'account della casella di posta e la password`,
"label.service.gantt.distribution.recommendation":`Assegnazione suggerita`,
"label.email.track.attachment.size.control2":`La dimensione del file caricato supera i 10m e non può essere caricato`,
"lable.product.pricebooks.add":`Aggiungi al listino prezzi`,
"label.login.time":`Tempo di accesso`,
"label.tabpage.yes1z":`Sì1`,
"label.SalesCommitmentKanBan":`Cruscotti di impegno delle vendite`,
"label_partner_workspace_myspace":`Il mio spazio di lavoro`,
"chatter.like":`tipo(i) ricevuto(i)`,
"lable.PowerProcess.number.input":`Si prega di inserire un numero intero.`,
"chatter.coll":`Segnalibro`,
"label.campaign.channel.img.remark":`Nota: 1a La dimensione dell'immagine non dovrebbe superare i 2M`,
"label.field.duplicate.error.msg7":`Dati duplicati`,
"vue_label_pool_discard":`Scartare`,
"label.service.gantt.total.planned.duration":`Somma della durata prevista per gli appuntamenti di servizio`,
"label.weixin.click.loadmore":`Clicca per caricare di più`,
"label.help.new.features.yd":`Guida al funzionamento della nuova interfaccia di Mobile-sade`,
"label":`Etichetta`,
"label.quickbooks.viewlist.total1":`Ci sono {0} fatture per un valore totale di {1}`,
"front-kefu-moudle-v1-input-publicKey":`Inserisci la chiave condivisa`,
"label.approval.allowed.reject":`Rifiuto consentito`,
"label.visualpage.folder.notdel":`Non si può cancellare questa cartella, perché alcuni file in essa si trovano.`,
"label.projectManagement.charging":`Carica`,
"label.ccservice.validate":`Il formato del valore corrispondente {2} del campo {1} sotto l'oggetto API {0} non è corretto. Inserisci il numero corretto!`,
"message.unbind.mfadevice.no.permission":`Non hai la possibilità di scollegare i dispositivi MFA, per favore contatta il tuo amministratore.`,
"label.partner.new.step3.meno":`Non sei sicuro di cosa inserire? Non preoccuparti, puoi cambiarlo in qualsiasi momento.`,
"label.import.page3.importsucceedtip":`Avvia l'importazione con successo. Dopo l'importazione, un'email sarà inviata alla tua casella di posta associata`,
"label.customsetting.visible.protect":`Protetto`,
"label.publishreadandwrite":`Pubblico Lettura/Scrittura`,
"vue_label_file_add_most_once":`Aggiungere al massimo una volta`,
"label.salescloud.teamrole.optionlist.group":`Assegna i ruoli ai membri del team delle opportunità e ai membri del team degli account.`,
"label.appointment.wizard.subtitle7":`Posizione`,
"label.task.dateminus":`Meno`,
"label.data.exp.zippwd":`Inserire manualmente la password del file compresso`,
"UG_Forcast_09":`Prossimo passo`,
"message.duplication.label.allselectlink":`Seleziona tutti]`,
"label.file.ccchat.selectfromcloudcc":`Selezionare un file da CloudCC`,
"label.ems.addaccount3":`Aggiungere un conto`,
"front-epwechat-module-v1-schedule-sync":`Sincronizzazione degli orari`,
"label.h5.manage":`Gestire le applicazioni`,
"setup.layout.label.nobutton":`Nessun pulsante disponibile`,
"label_component_hotdeal":`Offerte calde`,
"template.dashboard.contract.analysis":`Analisi dei contratti e dei crediti`,
"vue_label_dashboard_editcomponent":`Modifica componente`,
"label.quotationInformation":`Preventivo Informazioni`,
"label.data.file.validation_rules":`Eseguire le regole di convalida`,
"label.ccpeak.construction.shareobj":`Per costruire un oggetto modulo di condivisione di un oggetto, dovete passare il nome dell'API e il marchio di condivisione.`,
"label.wei.pollinformation":`Dettagli del micro voto`,
"label.quickbooks.viewlist.total3":`Ci sono {0} pagamenti per un valore totale di {1}`,
"label.paging.totalofpagesnoid":`Un totale di {0} pagine`,
"label.unlock":`Sblocca`,
"front-invoice-online-payment-information":`Informazioni sulla fattura`,
"label.permission.systempermission":`Permessi di sistema assegnati`,
"message.error.object":`Quando si chiama un servizio, si trova che l'oggetto non è definito.`,
"font-trade-module-v1-invoice-intro":`Inserire il numero di fattura o il nome della fattura`,
"label.userinfo.pwdexpired":`La password attuale è scaduta. Per ragioni di sicurezza, devi cambiare la tua password adesso.`,
"label.userphoto.photo":`Foto`,
"label.tabularreport.filterrecord":`Seleziona i criteri per determinare quali record visualizzare`,
"label.partnerCloud.orderingPlatform.rechargeIt":`Il saldo del tuo conto non è sufficiente, per favore ricarica.`,
"label.icon.120":`Computer`,
"label.projectManagement.select.new.type":`Selezionare il tipo di creazione`,
"vue_label_commonobjects_detail_customer_details":`Caricamento dei dettagli del cliente`,
"label.ems.status":`Stato`,
"label.validate.function.description":`Qualsiasi funzione conforme alla sintassi java può essere usata nella regola di validazione, e l'espressione deve restituire un valore booleano.<br>È anche possibile usare una funzione specifica fornita da CloudCC.
Per esempio, isNew(),isChanged(FieldAPIName__c),priorValue(FieldAPIName__c),priorValue() restituisce un oggetto, deve essere convertito nel tipo di campo corrispondente.`,
"label.escalation.setup.newaction.step2":`Passo 2 Selezionare l'utente per riassegnare automaticamente i casi`,
"label.forecast.customforecast.searchforecast":`Trova le previsioni`,
"label.the.upper.bound.of.each.level.of.block.pricing.must.be.greater.than.the.lower.bound.":`Il limite superiore di ogni livello deve essere maggiore del limite inferiore quando si fissano i prezzi per blocchi.`,
"vue_label_commonobjects_view_notice_deletefailreason":`Impossibile cancellare i dati con l'id del record {0}， motivo fallito: {1};`,
"page.field.masterinput.remark":`Enabled Master-Detail Input è usato per creare record di liste correlate nella pagina della scheda.`,
"lable.SalesCommitmentKanBan.contractName":`Nome del contratto`,
"front-gantt-module-add-milestone":`Aggiungi pietra miliare`,
"label.callcenter.save.error":`Per favore non salvare di nuovo`,
"label.workflow.selectobj":`Passo 1 Selezionare l'oggetto`,
"label.validate.function.category.all":`-- Tutte le categorie di funzioni --`,
"label.multilang.uploadifupage.select":`Hai scelto totalmente {0} file:`,
"label.weixin.dragsort":`Trascina le icone in Le mie applicazioni per ordinarle.`,
"N":`Numero`,
"label.knowledge.article.translation.completed":`Traduzione dell'articolo completata`,
"label.weixin.myapp":`Le mie applicazioni`,
"label.icon.138":`Valuta`,
"vue_label_chat_create_discussion_now":`Crea una discussione ora`,
"label.knowledge.recover.article":`Ripristinare l'articolo`,
"label.ccpeak.use.class.time.map":`Accesso per passaggio nella collezione di mappe`,
"front-email-payment-error-tips":`Errore di interfaccia`,
"label.service.gantt.ziyuan":`Solo per`,
"label.upload.error":`Fallito`,
"label.staticresource.upload.error":`Errore nel caricamento delle risorse statiche!`,
"com.cloudcc.login.error.message.loginfail":`Operazione fallita, si prega di contattare l'amministratore`,
"pagecreator_button_back":`Ultimo passo`,
"label_tabpage_skip":`Passa a`,
"label.pw.old":`Inserisci la vecchia password`,
"pagecreator.layout.label.modifylayout":`Editor di layout`,
"vue_label_chatter_share_group":`Condividi con il gruppo`,
"label.app.edit":`Modifica dell'app`,
"label.user.Email.repeat":`Duplicazione dell'email. Questo utente non è supportato per il binding con l'agente`,
"label.field.quilt":`Questo campo è`,
"label.projectManagement.Groupuser":`Raggruppamento per utenti`,
"label.deleteall":`Cancella tutto`,
"label.appexchange.download.tiaoguo.mes":`Ignora di installare i seguenti componenti in conflitto:`,
"label.sendemail.recycle.operatehello":`#username hello:#`,
"label.emailmerge.mergeFolder.max20templates":`Puoi selezionare fino a 20 modelli!`,
"label.campaignmember.main.deleteleaddesc":`Rimuovere in massa tutti i lead da questa campagna`,
"Opportunity_Detailed_Phase_Label_Popup_003":`Giorni nella fase attuale`,
"vue_label_file_no_title":`Nessun titolo`,
"label.data.dataexpalltype.all.desc":`Esporta i dati di tutti gli oggetti che l'utente corrente ha accesso alla lettura.`,
"label.dashboard.unit2":`Unità: milioni`,
"label.list.userinterface.isrelatedlist":`Abilitare i collegamenti Hover della lista correlata`,
"label.role.tree":`Gerarchia dei ruoli della vostra organizzazione`,
"label.campagin.roi.zcsl":`Iscrizione`,
"message.error.forecast.setupchange":`Non è stato possibile trovare i dati a cui hai cercato di accedere. Potrebbe essere stato cancellato da altri utenti o modificato.`,
"label.sendemail.changeowner.dataname":`Il nome del documento è: #dataname file`,
"label.salescloud.opportunity.contactrole.optionlist":`Opportunità Contatti Ruoli Picklist Valori`,
"setup_mainpage_label_welcome1":`Necessita di un permesso corrispondente`,
"UG_activity_02":`Assegnare compiti`,
"label.tabpage.erraddressz":`Formato errato dell'indirizzo e-mail, inserire correttamente l'indirizzo e-mail`,
"label.weixin.nicheng":`Nickname WeChat`,
"label.forecast.settings.mrsz":`Misurazione delle previsioni`,
"label.campaign.channel.download.size3":`Dimensioni ridotte: 300*300 pixel`,
"label.icon.73":`Macchina utensile`,
"label.ServiceCloud.suoxuchanpin":`Prodotti richiesti`,
"label.escalation.setup.newrule.description":`Inserisci il nome della regola e attivala. Attivando questa regola si disattiva la regola di escalation del caso corrente. Per disattivare l'escalation automatica dei casi, disattiva tutte le regole di escalation dei casi.`,
"label.data.import.setup.whichfield.cloudccid":`ID CloudCC`,
"label.validate.function.funcExplain.PRIORVALUE":`Restituisce il tipo di oggetto, il tipo di campo corrispondente deve essere convertito.`,
"Lead.Scoring.Warning.001":`Il punteggio di un singolo lead record viene assegnato automaticamente quando si crea o si modifica. Ma è necessario assegnare manualmente un punteggio a più record di lead, quando si importa in batch o si crea tramite interfaccia.`,
"label.tianyancha.businessverify.msg9":`Il potere di interpretazione del presente accordo spetta a beijing shenzhou yundong science and technology co.`,
"label.compact.layout.tip":`Il layout delle informazioni chiave è usato per visualizzare il campo chiave dei dettagli del record nella pagina dei dettagli.`,
"label.visualpage.btype":`Rapporti`,
"label.textmessage.vonage.settings":`Impostazioni`,
"label.field.not.exites":`non esistere`,
"label.payment.switch.version":`Passare alla nuova edizione`,
"label.ems.hour":`Ora`,
"label.weixin.cannot.edit":`Il tipo di file non può essere modificato`,
"chatter.pt.limit":`La dimensione massima del file è`,
"label.quote.detailinfo.add":`Aggiungere le voci del preventivo`,
"component.setup.label.displayfield":`Campo di visualizzazione`,
"vue_label_report_reportfolder":`Cartella dei rapporti`,
"label.gbkencoding":`Cinese (GBK)`,
"front-kefu-moudle-v1-Transfer-to":`Trasferimento a {TransferName}`,
"label.file.stop.sharing.desc2":`Condividere`,
"label.textmessage.messageCannoutuse":`Unavalible, si prega di contattare l'amministratore per abilitare i messaggi di testo.`,
"component_newrecords_label_type":`Tipo di stoccaggio`,
"label.validate.function.funcFormat.ISNEW":`ISNEW()`,
"lable.product.pricebooks.new":`Nuovo libro dei prezzi`,
"vue_label_newfile":`Nuovo file`,
"label.reportTypcrtB":`Oggetto associato (b) clicca per selezionare l'oggetto correlato`,
"label.knowledgebase.type":`Categoria`,
"label.report.select.format":`Seleziona il formato del rapporto`,
"component.todaytask.label.title":`Oggi`,
"message.undelete":`Sei sicuro di voler cancellare la cancellazione?`,
"label.ccdocument.trace.retention":`Funzione di ritenzione delle tracce`,
"label.publicgroup.tip":`Un gruppo pubblico è un insieme di utenti. Può contenere singoli utenti, altri gruppi, gli utenti di un particolare ruolo o territorio, o gli utenti di un ruolo o territorio più tutti gli utenti sotto quel ruolo o territorio nella gerarchia.`,
"label.forecast.settings.lable2":`Configurare la visualizzazione predefinita delle previsioni`,
"label.projectManagement.positive.integer":`Si prega di inserire un numero intero positivo compreso tra 0 e 24.`,
"label.projectManagement.one.work.list":`Si prega di compilare almeno una lista di lavoro!`,
"label.or":`||o`,
"label.projectManagement.no.person.in.charge":`Nessun supervisore`,
"vue_label_commonobjects_detail_an_email":`una email`,
"front-electronic-signature-field-mapping":`Aggiungere la mappatura dei campi`,
"label.marketsea.name.error":`Il nome del pool di piombo non può essere vuoto`,
"component.setup.button.appurl":`URL del sistema`,
"label.mr.title.button.group1":`Il`,
"chatter.contact":`Contatta`,
"vue_label_pool_hasfixed":`canali di cooperazione fissi`,
"lable.list.queue.des":`Le code permettono a gruppi di utenti di gestire un carico di lavoro condiviso in modo più efficace. Una coda è una posizione in cui i record possono essere indirizzati in attesa di essere elaborati da un membro del gruppo. I record rimangono nella coda finché un utente non li accetta per l'elaborazione o vengono trasferiti in un'altra coda. Puoi specificare l'insieme di oggetti che sono supportati da ogni coda, così come l'insieme di utenti che sono autorizzati a recuperare i record dalla coda.`,
"label.reportsSubscriptionPage.condition":`Condizioni`,
"label.transwork":`Banco di traduzione`,
"label.batch.batchopration.resel":`Riseleziona i dati che vuoi trasferire e clicca su "OK" per passare alla pagina dell'elenco di visualizzazione.`,
"label.cloudccsite.new":`Nuovo sito`,
"label.button.select.page.required.field":`Seleziona i campi richiesti da includere nella tua pagina:`,
"label.pagelayout":`Layout di pagina`,
"label.weixin.trace.record":`Registri delle tracce`,
"label.emailtocloudcc.clear":`Chiaro`,
"label.checkfield.find":`Trova i duplicati`,
"message.view.count.title0":`Riassunto della pagina corrente`,
"label.reportsSubscriptionPage.schedulereport.frequency":`Frequenza`,
"setup.mainpage.label.welcome5":`Campo personalizzato`,
"label.implementation.details":`Eseguire i dettagli`,
"label.attendance.history":`Storia delle presenze`,
"label.is.pigeonhole":`Archivio`,
"lable.account.CurrentandPreviousFYt":`Attuale e precedente 2 FY`,
"label.forecast.customforecast.tab.opportunity":`Opportunità`,
"label.version.business.track":`Monitoraggio delle opportunità`,
"label.profilelayoutedit.selectrecordtype.tip":`Seleziona il tipo di record per questo profilo di utenti. Devi aggiungere il campo del tipo di record al layout di pagina associato a questo profilo in modo che possa essere visualizzato nelle pagine di dettaglio e nelle pagine di modifica.`,
"label.campagin.roi.zclzb":`Tasso di registrazione`,
"label.validate.function.funcFormat.WEEKDAY":`WEEKDAY(data)`,
"label.view.sort.message":`Ordinato da {!sort}`,
"page.field.masterinput.sort":`Gli ingressi Master-Detail sono visualizzati nell'ordine in cui sono stati salvati.`,
"label.selected.field":`Campi di ricerca selezionati`,
"label.product.proofTwo":`In {0}, scegli almeno {1} opzioni di prodotto.`,
"vue_label_report_filtercondition":`Condizione del filtro`,
"label.forecast.shrepage.desc1":`Questa pagina elenca gli utenti, i ruoli e i territori che hanno accesso di condivisione a`,
"label.file.copy.link":`Copiare il link`,
"vue_label_chat_movedto":`{name} ha spostato {label} in {newField}`,
"label.layout.new.built":`Nuova sezione`,
"label_tabpage_crecordtypez":`Cambia tipo di record`,
"label.report.searchcustominfo":`Inserisci le parole chiave per trovare i rapporti personalizzati corrispondenti`,
"chatter.feed.menutype.user":`Colleghi`,
"label.recordtypeselect":`Seleziona il tipo di record`,
"label.partner.new.step3":`Passo 3 Inserire il nome e l'url`,
"label.newCustomReportType":`Nuova fonte di dati del rapporto personalizzato`,
"label.service.gantt.day.timescale":`Scala temporale su Day View:`,
"label.displaytype3":`Pulsante elenco`,
"label.weixin.discharge.rate":`Volume di scarico`,
"label.weixin.menu.message":`Menu`,
"label.mask.show.all.characters":`La maschera visualizza tutti i caratteri`,
"label.quickbooks.fieldlabel.billingaddress":`Indirizzo di fatturazione`,
"Dashboard.View.All":`Tutti i cruscotti`,
"setup_mainpage_label_welcome22":`Istruzioni: Clicca sul menu a sinistra di questa pagina → Gestisci impostazioni → Modello di newsletter → Modello di e-mail.`,
"chatter.group.groupInformation":`Informazioni sul gruppo`,
"front-epwechat-module-v1-input-secret":`Inserisci il Segreto`,
"lable.Set.value.prompt":`Oppure, filtrare i record visualizzati nell'elenco correlato. Scegli la casella di controllo o i campi della lista e i valori che vuoi filtrare. Se inserisci i valori manualmente, separali con delle virgole.`,
"label.appupload.upload.from":`Da`,
"label.weixin.postunsolve":`Scaduto`,
"label.cooperation.all":`Tutta la cooperazione`,
"lable.PowerProcess.close.time":`In base all'orario di chiusura di {detailInterestType}`,
"lable.opppdt.selPdt.leastone.fields":`Si prega di selezionare almeno un campo.`,
"label.emailtocloudcc.help":`Inserisci la password o il codice di autorizzazione corretto. Se il tuo server di posta elettronica ha bisogno di attivare il servizio IMAP/SMTP per accedere con un account di terze parti, devi prima accedere alle impostazioni dell'account di posta elettronica per abilitare il servizio, e copiare il codice di autorizzazione appropriato in questa casella di inserimento password.`,
"label.attendance.offwork.time":`Fine della giornata`,
"front-gantt-module-v1-project-gantt":`Grafico di Gantt del progetto`,
"label.chuangming.description":`Configura le informazioni di Chuangming per soddisfare le esigenze dei servizi di invio e ricezione di SMS della tua organizzazione.`,
"label.custom.lead.notice.account.name":`C'è un lead che, è stato convertito, specifica che sei il proprietario di account, contatto e opportunità. Nome dell'account:`,
"label.emailobject.failedtosend1":`Invio fallito: L'autenticazione dell'e-mail non è valida, si prega di riconnettersi!`,
"vue_label_ccchat_notice_updaterecordsuccess":`Questo record è stato aggiornato`,
"label.dayinmonth":`Mesi`,
"label.sendemail.chat.follow":`Caro #nome:\nell'attesa! #nomeUtente ti segue.`,
"label.emailsync.form.emialpassword":`Password`,
"component_task_label_subject":`Tema`,
"label.projectManagement.please.enter.a.positive.integer":`Si prega di inserire un numero intero positivo.`,
"lable.account.NexteDays":`Prossimi 7 giorni`,
"label.appupload.upload.managed":`Si può creare al massimo un pacchetto controllato!`,
"label.data.dataexpalltype.all.desc1":`1. Si può scegliere se generare automaticamente o inserire manualmente la password del file compresso esportato. La password generata automaticamente sarà inviata alla casella di posta elettronica degli utenti quando i dati vengono esportati con successo. La password inserita manualmente non verrà inviata alla casella di posta, quindi gli utenti devono ricordare la password che hanno inserito. Se non viene inserita, l'impostazione predefinita è nessuna password.`,
"label.step1.total3":`Passo 1 di 3`,
"label.escalation.setup.detail.section":`Dettaglio della regola`,
"front-gantt-module-drag-task-sorting":`Trascinare i compiti nell'ordine`,
"label.isEnableVisualpage.new.title":`Abilitare l'accesso alla pagina personalizzata`,
"label_tabpage_yesz":`Sì`,
"label.emailobject.emaildetail.button.replyall":`Rispondi a tutti`,
"label.knowledge.setting.data.one":`Questo non può aggiungere altre sottocategorie.`,
"label.manageAll.sel.one3":`Articoli che ho approvato`,
"UG_contact_01":`Come sfruttare al massimo i tuoi contatti?`,
"font-trade-module-v1-invoice-name":`Nome della fattura`,
"label.central.daylight.time":`Ora legale centrale`,
"label.chatter.pastThirtyday":`Gli ultimi 30 giorni`,
"vue_label_commonobjects_detail_activity_ownevent":`Evento disponibile`,
"label.user.modify":`Modifica utente`,
"label.uploadTemplate":`Carica il modello`,
"setup_mainpage_label_welcome14":`Gestione dei processi di personalizzazione del flusso di lavoro, approvazione`,
"label.workmate":`Colleghi`,
"label.displaycolumns":`Visualizza colonne`,
"label.emailnoticeintro":`Gli avvisi e-mail sono le e-mail che le regole del flusso di lavoro inviano quando vengono attivate.`,
"label.knowledge.category.button.five":`Cancellare la categoria`,
"template.report.business.opportunities.type":`Opportunità per tipi`,
"vue_labenl_applauncher_moreapp":`Altre applicazioni`,
"label.captcha.expired":`Il codice di verifica è scaduto, si prega di verificare di nuovo.`,
"template.chart.bnqzkhslmb":`Numero target di lead per l'anno`,
"chatter.up.user.pic":`Carica la foto dell'utente`,
"label.timezone.importtimezone.gmt":`Usa il fuso orario gmt`,
"label.step.type":`Seleziona il tipo di membro che vuoi cercare`,
"Dashboard.View.RecentlyView":`Visti di recente`,
"label.reportinthisfolder":`Rapporti in questa cartella`,
"label.product.vies":`Visualizzazioni del prodotto`,
"pagecreator_systemstyle_message_delete_fail":`Cancellazione stile non riuscita`,
"label.multipleactivity.singleUser":`Utente singolo`,
"vue_label_email_enter_subject":`Inserisci il soggetto`,
"label_tabpage_alltabs":`Tutte le schede`,
"label.publicgroup.groupname":`Nome del gruppo`,
"template.report.sales.performance":`Prestazioni dei venditori`,
"label.newWindow":`Nuova finestra`,
"label.forecast.editopp.forecastedit":`Modifica delle previsioni`,
"label.data.import.setup.whichfield":`Quale campo vorresti usare per la corrispondenza?`,
"label.noadd_dashboard":`Non aggiungere al cruscotto`,
"label.subtotal":`Subtotale`,
"front-email-payment-weichat":`Si prega di utilizzare WeChat "Scan"`,
"label.attendance.position.alert":`Si prega di selezionare prima la maschera`,
"chatter.follow.me":`Seguitemi`,
"label.mobile.more.details":`Modifica dettaglio file`,
"Dashboard_SelectBoardToDisplay":`Seleziona i cruscotti che vuoi mostrare nella pagina della scheda dashborad`,
"front-gantt-module-v1-search-project":`Cerca il tuo progetto...`,
"label.paging.totalofpagereport":`Un totale di {0} pagine({1})`,
"label.from.phone":`Da`,
"lable.Signatory":`Signtory:`,
"label.campagin.roi.query.roi2":`Canali di marketing ROI`,
"label.tabpage.selectcontentz":`Seleziona il contenuto`,
"label.multilang.lookfiltercondition.valuetypenotmate":`La condizione della linea {0} non è corretta, il tipo di valore non corrisponde!`,
"label.interfaceconstraint.disabled":`L'interfaccia è stata disabilitata, contattate il vostro amministratore di sistema.`,
"third":`Il terzo`,
"label.quickbooks.viewlist.status":`STATO`,
"label.emailtocloudcc.select3":`Seleziona il proprietario del disco`,
"label.projectManagement.week.work":`Il mio lavoro per questa settimana`,
"vue_label_pool_nodemand":`Nessuna richiesta`,
"label.version.two.developapi":`Sviluppo secondario API`,
"label.icon.82":`Stampante`,
"label.batchadd.newbatchpage.suclist":`i dati dei pezzi aggiunti con successo`,
"label.checkfield.chooseatlast":`Seleziona almeno due`,
"label.quotation.deleteTip":`Seleziona le righe di citazione da cancellare`,
"label.generatepage.title.desc2":`Fare clic su Salva per generare la pagina web e il link URL web a cui si può accedere.`,
"label.licence.total":`Licenze totali`,
"Y":`Relazione di ricerca`,
"label.wuzibiekesitan.time":`Uzbekistan Tempo`,
"label.component.hotdeal.nodata":`Nessun dato relativo alle opportunità commerciali.`,
"label.data.exp.save":`Salvare il modello`,
"label.appupload.upload.tips.dashboard":`NOTA: Le dashbord in "My Custom Dashboards" e "Unfiled Public Dashboards" non possono essere aggiunte ai pacchetti e non saranno mostrate in questo elenco. I relativi vecchi report non possono essere caricati".`,
"lable.PowerProcess.new.PowerProcess":`Nuovo processo di abilitazione`,
"label.loginhis.search.download":`Considerando che ci sono molte cronologie di login, solo la cronologia entro 2 mesi può essere scaricata quando si cercano i download.`,
"label.tabpage.deleteview":`Cancellare la vista`,
"label.chatter.recently":`Recentemente`,
"label.industrialandcommercialverification.title":`Verifica industriale e commerciale`,
"message.nextapproverlost":`Il prossimo approvatore specificato è nullo.`,
"front-kefu-moudle-v1-mfsysy-time":`Giorni rimanenti per il percorso gratuito`,
"label.role.assign.tip":`Scegliere un utente nell'elenco Utenti disponibili e aggiungerlo all'elenco Utenti selezionati per assegnare gli utenti al ruolo`,
"label.addattachment.step2.intruduce":`Ripeti i passi 1 e 2 per aggiungere più file.`,
"vue_label_pool_returnreasondiscription":`Descrizione del motivo della restituzione`,
"label.weixin.report.range":`Gamma`,
"label.wei.weiresearchtab":`Scelta del micro voto`,
"vue_label_report_setdrill":`Set Drill`,
"page_404_button_back":`Ritorna al passo precedente`,
"label.customfields.autonumber.tip":`Un numero di sequenza generato dal sistema che utilizza un formato di visualizzazione definito dall'utente. Il numero viene incrementato automaticamente per ogni nuovo record.`,
"label.ccpeak.return.allrecords":`Restituire tutti i record`,
"label.ccchat.notmember.active.group2":`Non sei nel nome con`,
"label.uniquename":`Nome unico`,
"label.emailtocloudcc.filed.ssl":`Connessione sicura`,
"chatter.emailFollowMe":`Mi segue`,
"label.allrightsreserved.allrightsreserved.customerServiceHotline":`Copyright. Tutti i diritti riservati. Linea diretta del servizio clienti`,
"label.projectManagement.actualworkinghours":`Ore di lavoro effettive`,
"label.quickbooks.fieldlabel.taxresale":`Rivendita fiscale`,
"label.icon.12":`Servizio`,
"label.data.exp.dataexptemp":`Modelli di esportazione dei dati`,
"component_setup_tabs_label_add":`Aggiunto`,
"label.appointmentdetail.wizard.title10":`Data di inizio`,
"label.multilingual.close":`La gestione multilingue non è abilitata.`,
"message.error.username.notexist":`Nome utente non valido, inserire nuovamente.`,
"label.batchadd.newbatchpage.des2":`Se il tipo di campo è Auto Number, il numero viene incrementato automaticamente per ogni nuovo record senza inserimento manuale.`,
"vue_label_SMS_search":`Ricerca di lead o contatti`,
"label.appupload.successWithUrl":`Il tuo pacchetto è ora disponibile per l'installazione utilizzando l'URL di installazione qui sotto.`,
"UG_Forcast_06":`Seleziona gli utenti che sono autorizzati a fare previsioni`,
"vue_label_dashboard_secondarygroup":`Seleziona il gruppo secondario`,
"label.weixin..xsld.total":`Importo totale nel Funnel di vendita`,
"label.setup.mobile.bottombutton.recovery.default.fail":`Impossibile ripristinare le impostazioni predefinite`,
"label.addrecurrencetimetrigger":`Aggiungere un trigger temporale periodico`,
"label.emailsync.connectaccount":`Collegare l'account e-mail`,
"label_fiscal_years":`Anno fiscale`,
"label.icon.164":`Allenatore`,
"label.batchadd.mustinput":`Campo con`,
"message.newtabpage.nokeywords":`Il tuo termine di ricerca deve avere 1 o più caratteri. Oppure puoi aggiungere criteri di ricerca avanzati.`,
"label.login.verification.mfa.desc3":`Se il tuo account è stato condiviso da più persone, altre persone con MFA non vincolata non saranno in grado di accedere dopo che tu hai vincolato con successo l'MFA. La soluzione è quella di avere qualcun altro che installi l'applicazione MFA e scannerizzi il codice QR per questa pagina, o salvare l'immagine del codice QR per la successiva scansione da parte di altri. Tuttavia, in termini di buone pratiche di sicurezza, ti raccomandiamo di cancellare più account condivisi.`,
"label.partnerCloud.basicSetting.initialize":`Non è possibile cambiare il nome del dominio dopo l'inizializzazione.`,
"label.address.county":`Contea`,
"label.validate.function.funcFormat.TODAY":`OGGI()`,
"label.sso.addAKey":`Aggiungi chiavi`,
"label.myusergroup":`I miei gruppi di utenti`,
"label.import.index.time-consuming":`Tempo`,
"label_tabpage_systems":`Ci sono * sistemi`,
"batch.sendemail.s":`, Posta inviata con successo.`,
"label.appointment.wizard.subtitle4-1-1":`15 min`,
"label.projectManagement.delete.milestone":`Tutte le informazioni relative a questa pietra miliare saranno cancellate se elimini questa pietra miliare, e i dati non possono essere recuperati. Sei sicuro di confermare la cancellazione?`,
"label.umeng.chatter.praise":`piaciuto il tuo post.`,
"font-evaluate-module-v1-evdetails":`Dettaglio della valutazione:`,
"label.group.filter.resources.and":`Scegliete un metodo per filtrare la risorsa, relazione AND.`,
"label_emailtocloudcc_description":`Collega il tuo account e-mail aziendale, come sales@company.com, info@company.com, support@company.com. Registra automaticamente le e-mail ricevute come lead e record di casi in CloudCC per garantire un follow-up tempestivo delle lettere dei clienti.`,
"label.chat.topic.delete.prompt2":`Si prega di notare che gli argomenti con lo stesso nome in altre comunità non saranno cancellati.`,
"message.error.group.authorization":`Non hai accesso per impostare questo gruppo`,
"label.attendance.wz":`Posizione`,
"vue_label_activity_notice_logacal_success":`Hai registrato una chiamata`,
"label.emailtocloudcc.step1.case1":`Email al caso`,
"label.h5.chatter.praisenum":`L'elogio ricevuto`,
"label_time_statistics_basis":`Base delle statistiche del tempo`,
"label.onlyadmincanedit":`Gli amministratori <strong>SOLO</strong> possono modificare i record durante il processo di approvazione.`,
"label.fieldtoolongmassage":`Campo`,
"label.sales.team.shared":`Opportunità commerciali condivisione del gruppo`,
"label_emailsync_status_department":`Dipartimento`,
"label.mobile.quickcreate.default.sellingfunnel":`Imbuto di vendita`,
"label.tabpage.closez":`Chiudere`,
"homepage.components.two":`Passo 2 scegliere la posizione in cui vengono visualizzati i componenti personalizzati`,
"label.everyday":`Ogni giorno`,
"lable.Product.to.asset.BOM":`Prodotto alla distinta base delle risorse`,
"label.appointment.wizard.subtitle4-3":`L'invitato è in grado di scegliere un inizio in ogni`,
"label.customobjects.standardfieldslist":`Elenco dei campi standard`,
"label.customfields.suretodelete":`Sì, voglio cancellare il campo personalizzato.`,
"component.chatter.label.to":`A`,
"label.emailsync.form.seversetting":`Impostazione`,
"label.service.gantt.enabled.resources":`Risorsa attivata`,
"label.tianyancha.h5.weibo":`Microblog`,
"template.chart.dddje":`Quantità di ordini persi`,
"label.pc.trigger.apiname":`Il nome dell'API esiste già, riprova.`,
"label.icon.34":`Impostazione`,
"label.schedulejob.setup.schedule.prgname":`Nome dell'applicazione`,
"label.weixin.free.registration":`Iscriviti gratuitamente`,
"label.placeholder":`Ricerca rapida`,
"label.emailobject.manage.template":`Gestire i modelli`,
"label.knowledge.article.existsdata":`Esistono altri dati non qualificati.`,
"label.campaign.channel.lookup.ticket":`Controllare il biglietto`,
"label.searchlayout.relation.searchfield":`Cerca Campi filtro per liste correlate.`,
"label.recordid.cannot.empty":`L'ID del record non può essere nullo`,
"label_partner_workspace_member_choice":`Seleziona il profilo`,
"vue_label_campaign_amount":`Importo del reddito`,
"label.niue.time":`Tempo di Niue`,
"front-homepageobject-module-v1-workload-ranking":`Classifica del carico di lavoro`,
"message.error.datainvalid":`Errore: dati non validi.`,
"vue_label_helpcenter_salesfunnel":`Usa la nuova versione dell'imbuto di vendita per analizzare il follow-up delle opportunità di business e fornire riferimenti di dati per il tuo processo di vendita.<br> Nell'angolo in alto a sinistra, i record saranno filtrati in base a condizioni come il ruolo o il proprietario, e tutte le opportunità di business visibili sotto le condizioni corrispondenti saranno visualizzate e analizzate. Clicca sulla fase del grafico dell'imbuto di vendita per visualizzare tutti i record sotto quella fase.`,
"vue_label_transferownernotice":`Anche il proprietario del record associato a questo elemento sarà cambiato`,
"label.monitorsys.operator":`Recitato da`,
"label.please.codeNorm":`Si prega di scegliere il codice standard.`,
"label.campaign.channel.step6.remark2":`Abilitare la sollecitazione dei dipendenti`,
"market.potential.customers":`Leader del mercato`,
"label.customfields.phone.tip":`Permette agli utenti di inserire qualsiasi numero di telefono. Lo formatta automaticamente come numero di telefono.`,
"label.currency.edit":`Modifica della valuta: cambia la valuta aziendale`,
"label.emailobject.emaildetail.button.markasunread":`Segna come non letto`,
"label_partner_template_memo":`Titolo`,
"label.chat.message.search.all":`Cerca tutte le informazioni`,
"label_tabpage_hoursagoz":`ore`,
"label.customcomponent.developer.help":`Aiuto per lo sviluppatore di componenti personalizzati`,
"setup_mainpage_label_welcome":`Benvenuti nella piattaforma CloudCC PaaS, le funzioni principali della piattaforma sono le seguenti:`,
"label.h5.similar.opportunity.list":`I risultati includono opportunità chiuse e vinte che hanno uno o più campi in comune con la tua opportunità. La creazione di un segnalibro per le opportunità le aggiunge all'elenco delle opportunità simili nella pagina dei dettagli della tua opportunità.`,
"vue_label_record_count":`Conteggio dei record`,
"label.icon.29":`Demo`,
"pagecreator.page.label.pagelayout":`Layout di pagina`,
"label.ggReleaseRange.searchRole":`Cerca un ruolo`,
"label.campagin.member.field.setup":`Impostazioni del campo membro della campagna`,
"augest":`Agosto`,
"label.salescloud.massloss.content":`La disabilitazione dei team di opportunità rimuoverà irreversibilmente i team esistenti da tutte le opportunità e cancellerà i team di opportunità predefiniti degli utenti.`,
"label.customfields.new.step2.opration.unique.info":`I valori duplicati non sono ammessi.`,
"vue_label_email_optional_members":`Membri opzionali`,
"label.emailobject.attachment.download":`Scaricare`,
"label.recordamount":`Conteggio dei record`,
"front-kefu-moudle-call-recorder":`Registrazione delle chiamate`,
"label.more.info":`Dettagli`,
"vue_label_commonobjects_view_secondsbefore":`{secondi} secondi`,
"label.emailsync.status.action":`Azione`,
"label.customfields.totalsummary.collectedfields":`Oggetto riassuntivo`,
"label.knowledge.setting.hint.two":`Attenzione: Non è possibile disattivare la Conoscenza una volta attivata.`,
"label.login.access.yujidao":`Espansione.`,
"label.assignment.setup.detail.description":`Aggiungi le voci delle regole che specificano i criteri utilizzati per assegnare automaticamente i lead agli utenti.`,
"message.error.marketsea.null":`Il pool di piombo non esiste`,
"lable.account.Current.CY":`Corrente CY`,
"vue_label_salesadvance_lost":`Perdita`,
"label.file.ownedbyme":`Di mia proprietà`,
"label.component.helper.nodata":`Non c'è niente che richieda la tua attenzione in questo momento. per favore torna più tardi.`,
"label.weixin.appr.pending.auditor":`Inviato da`,
"UG_opportunity_004":`Tipo di servizio multiplo`,
"label.leadscore.setup":`Impostazioni di punteggio dei lead`,
"label.addtimetrigger":`Aggiungere il trigger del tempo`,
"label.mr.title.match":`Se corrispondenza esatta`,
"label.projectManagement.Newmilestone":`Nuova pietra miliare`,
"label.preview":`Anteprima`,
"label.tabpage.issuez":`Emissione`,
"label.img.max.size":`L'immagine caricata è troppo grande, e la dimensione massima dell'immagine caricata è 500K, si prega di ricaricare.`,
"label.mainpageset":`Configurare i componenti della homepage`,
"label.user.login.false.lock":`Tentativi di accesso superati. L'account è bloccato`,
"UG_solution_02":`La soluzione è una soluzione interna dell'istituzione al problema che i conti incontrano.`,
"vue_label_approve_put_away":`Crollo`,
"label.profile.existing":`Profilo esistente`,
"label.ems.logininfo":`Informazioni di accesso`,
"label.weixin.location.service":`Oggetti che supportano i servizi di localizzazione`,
"label.multilang.datamoveaction.totaldata":`C'è un totale di {1} record che soddisfano la condizione, un massimo di 100 record possono essere trasferiti in una sola volta!`,
"label.ccdocument.cannot.update.set":`Questo documento non appartiene al tipo di file Word o Excel o PPT, non caricato nel modello di cartella rossa.`,
"vue_label_fliter_addfliter":`Aggiungi Fliter`,
"label.custom.page.or.trigger":`(Pagine personalizzate o trigger)`,
"label.tag.filter1":`Filtrare i record che contengono tutti i tag selezionati`,
"UG.homepage.006":`Visibilità a 360 gradi sull'attività del tuo account attraverso sondaggi, chat dal vivo, e-mail, ordini di lavoro, post sui social media e anche attività di vendita (come lead, assistenza e attività).`,
"SCORE":`Punteggio`,
"label.file.library.managemembers2":`Gestire i membri della biblioteca`,
"label.email.template.public.SMS":`Cartella di modelli SMS pubblici`,
"label.leadscore.donot":`Incapace di segnare le piste`,
"label.gaode.map":`Amap`,
"pagecreator_button_preview":`Anteprima`,
"UG_contact_04":`Oppure`,
"label.ccchat.person.invite.eminfo":`{0} ti ha invitato a unirti a {1} su CCChat.Con ccchat puoi chattare con i tuoi colleghi, creare squadre per i tuoi progetti e condividere file.`,
"setup_object_field_dependency_label_actionfieldvalue":`Campo di controllo`,
"lable.Product.options":`Opzioni del prodotto`,
"front-electronic-signature-add-autofill-field":`Aggiungere un campo di riempimento automatico`,
"label.customfields.totalsummary.selectcollectedfields":`Seleziona l'oggetto da riassumere`,
"label.projectManagement.the.maximum.contract.amount.is.10.digits":`Si possono inserire fino a 10 cifre per l'importo del contratto.`,
"label.forecast.shrepage.pagetitle":`Condivisione di utenti, ruoli e territori`,
"label.login.access.mark":`Per assistere con problemi di supporto, puoi concedere al tuo amministratore o al personale di supporto la possibilità di accedere come te e accedere ai tuoi dati.`,
"lable.outlook.edit.zdyout":`Mappatura personalizzata dei campi di Exchange`,
"label.approveoperate":`Azioni di approvazione`,
"label.tabpage.linknamez":`Nome del link`,
"label.report.error.deletehavedashboard":`Questo rapporto ha un nuovo cruscotto e non può essere cancellato`,
"label.summaryreport.2018.step1":`Passo 1 Creare un raggruppamento`,
"label.campaignmember.main.leadtomember.title":`Configurazione della mappatura dei campi`,
"label.select.dashboar.type":`Seleziona il tipo di cruscotto`,
"message.setup.field.picklist.valueexists":`Questo valore della lista di scelta esiste già.`,
"label.loading":`Caricamento...`,
"label.payments.paytip1":`La tua attuale edizione abbonata non è un'edizione gratuita, clicca su Conferma per aggiornare o rifare il login.`,
"label.view.appliedMobile":`Applicare l'applicazione mobile`,
"label.multilang.forcast.financialyear":`{0} anno fiscale：`,
"front-web-module-v1-detail-comment-opinion":`Feedback`,
"UG_Forcast_10":`Completa`,
"label.optionlistset":`Opzioni della lista di scelta`,
"label.visualpage_list.vpname":`Nome della pagina personalizzata`,
"vue_label_calendar_failed_to_delete_calendar":`Impossibile eliminare il calendario`,
"label.json.string.null":`Vuoto`,
"message.serviceappo.time.violation2":`La violazione del tempo disponibile dell'appuntamento di servizio: L'ora di fine dell'appuntamento è anticipata rispetto alla data di scadenza dell'appuntamento di servizio`,
"label.productsales.today.noevttsk":`Non ci sono eventi aperti e compiti in scadenza.`,
"label_tabpage_emptyz":`Vuoto`,
"front-kefu-moudle-no-create":`Non creato`,
"label.wedge.shaped.tail.arrow.cannot.empty":`La freccia della coda del cuneo non può essere nulla`,
"label.continue.shopping":`Continua lo shopping`,
"label.turntomain":`Vai al contenuto principale`,
"component.assistant.label.nodata":`Nessun evento oggi, controlla più tardi.`,
"label.payments.paytip4":`Per favore, inserisca il numero di utenti!`,
"label.appupload.upload.versionName":`Nome della versione`,
"label.chatter.endData":`Data di fine`,
"front-kefu-moudle-buytr-tip":`Speriamo che tu possa avere una grande esperienza con il call center di CloudCC, e che tu possa acquistare un account ufficiale del call center e noi ti forniremo un servizio migliore.`,
"label.repw":`Ripeti la password`,
"label.tabularreport.intro":`Il rapporto tabulare è uno dei modi più semplici e veloci per elencare i dati.`,
"label.selectoperatetype":`Seleziona il tipo di azione`,
"setup.layout.label.required":`Richiesto`,
"label.default.designee":`Predefinito spedito Peron`,
"label.ccdocument.cannotdel.folder":`Non puoi cancellare questa cartella perché alcuni file in questa cartella.`,
"label.escalation.setup.newentries.inputentries":`Inserisci la voce della regola`,
"label.emailobject.addnewtemplate":`Aggiungi un nuovo modello`,
"label_chatter_content":`Contenuto`,
"label.htyj.mubiao":`Obiettivo`,
"label.reportsSubscriptionPage.schedulereport.weekly.friday":`Venerdì`,
"label_tabpage_fieldoptions":`Campo tipo record, campo elenco opzioni e campo elenco opzioni (scelta multipla). si raccomanda di inserire al massimo 10 parole chiave, separate da virgole per ottenere "o relazione", come ad esempio: "New York, Toronto, Tokyo".`,
"label.mobiletablayoutedit.remark2":`Seleziona i campi visualizzati nella pagina iniziale della scheda nella Mobile App.`,
"label.sendemail.chat.addComentsat":`Caro #name:\n\nomeutente ti ha menzionato nel commento.`,
"Z":`Formula`,
"label.multilang.batchdeleteaction.movesuccess":`Un totale di {0} record è stato cancellato con successo!`,
"label.textmessage.vonage.message2":`Configurando gli account API di Vonage, gli utenti permettono a CloudCC di accedere al loro account API di Nexmo per inviare e ricevere messaggi di testo.`,
"label.file.use.document":`Utilizzo dello spazio di archiviazione`,
"UG.Lead.011":`Creare un indizio`,
"label.view.name":`Visualizza nome`,
"label.data.downtemplate":`Scarica il modello`,
"vue_label_appstore_get_now":`Prendilo ora`,
"label.controlfield":`Campo di controllo`,
"label.dataimport.type.insert":`Inserire`,
"label.customfields.multiselect.tip":`Permette agli utenti di selezionare più valori da una lista definita da voi.`,
"label.weixin.approval.qxzjl":`Seleziona il record`,
"component.salesperformance.label.70finish":`Finito - non trasformato (>70%)`,
"Lead_Auto_Scoring_Setting":`Impostazione del punteggio del piombo`,
"pagecreator_layout_message_canntdelete":`Il layout corrente non può essere cancellato`,
"vue_label_report_exprotpage":`Esportare una pagina: Pagina {pagina}`,
"label.campaign.channel.step4":`Step4: Seleziona i campi richiesti da visualizzare nella pagina di registrazione del canale di marketing`,
"label.app.launcher":`Lanciatore di applicazioni`,
"vue_label_campaign_selectedmember":`{member} membri della campagna selezionati`,
"label.mobile.quickcreate.default.approvals":`Approvazioni`,
"label.view.step4":`Passo 4 Limitare la visibilità`,
"label.exchange.sync.state.user":`Stato di sincronizzazione dell'utente`,
"label.forecast.customforecast.tab.forecast":`Previsioni`,
"label.theUserLoginForTheFirstTime":`Primo accesso dell'utente.`,
"label.workflowoperate.tip":`Specifica le azioni del flusso di lavoro che saranno attivate quando i criteri della regola sono soddisfatti.`,
"font-evaluate-module-v1-ten-points":`Voto positivo: 10 punti`,
"label.knowledge.delete":`Errore durante la cancellazione della conoscenza`,
"front-console-see-contacts":`Contatti identificati {num}`,
"label.h5.similar.opportunity.add.to.favorites":`Aggiungi ai preferiti`,
"front-epwechat-module-v1-install-app":`Installare in WeCom`,
"setup_layout_message_relatedlistbutton":`Seleziona i pulsanti standard da visualizzare nella lista correlata.`,
"label.salescloud.massloss.title":`Potrebbe portare a grandi perdite di dati.`,
"front-console-conversation-btn1":`Anello posteriore`,
"label.custom.canvasScale":`Scala di tela`,
"label.lead.score.doing":`Nel processo di lead scoring`,
"message.approval.step.validation.invalid.number":`Numero non valido`,
"chatter.lk":`Come`,
"label.dashboardSetup.showmaxval":`Max visualizzato`,
"label.keywords":`Parole chiave`,
"vue_label_helpcenter_SMS":`Attivare la funzione SMS<br> Se il countrycode del sistema CRM acquistato è USA, allora la funzione SMS è disponibile nel sistema della Sua organizzazione. L'amministratore dell'organizzazione può inserire il numero di telefono acquistato dalla Sua organizzazione nel sistema vonage nel gateway vonage nell'applicazione di integrazione in background, e poi usare la funzione SMS nel menu dell'applicazione sales cloud.<br>Box SMS<br> Il box SMS è diviso in due parti. A sinistra c'è il record di lead o contatti con SMS. Dopo aver cliccato su un record, i dettagli di invio e ricezione saranno visualizzati sulla destra. Puoi visualizzare i record di te stesso e dei tuoi subordinati.<br>Invia messaggio di gruppo<br> Puoi inviare messaggi di testo di gruppo nel menu SMS, l'elenco dei lead o contatti, e il pulsante per inviare messaggi SMS sui membri della campagna. È possibile inviare messaggi di testo solo a potenziali clienti o contatti nel CRM. Dopo aver modificato il messaggio di testo, seleziona "Invia", e verrà generato un record di gruppo indipendentemente dal numero di destinatari, oppure puoi selezionare "Invia separatamente" per inviare i messaggi di testo separatamente Supporto messaggi SMS separati che mostrano i campi uniti inseriti nel modello SMS.`,
"label.emailobject.createnewavailability":`Creare una nuova disponibilità`,
"front-kefu-moudle-buytr-send-email":`Non sei ancora associato alla casella di posta del sistema. Si prega di inviare una email a support@cloudcc.com e scrivere la vostra intenzione, nome della società e informazioni di contatto, il personale di vendita vi contatterà al più presto.`,
"front-kefu-moudle-v1-Put-away-the-chat":`Chiudi i dettagli della chat`,
"label.marketseamemset.lead.maxuser":`Numero massimo di membri di piombo`,
"label.forecast.forecastroleuserpage.shre.manager":`Solo gli amministratori possono condividere questa previsione`,
"label.file.noselect":`Nessun file è selezionato`,
"label.notification.task3":`【被分配人】 cambiare lo stato del compito assegnato a 【新状态】`,
"label.dependfield":`Campo dipendente`,
"lable.SalesCommitmentKanBan.receipts":`Ricevute`,
"label_partner_workspace_member_search":`Cerca`,
"label.share.originally.posted":`Manifesto iniziale`,
"label.autonumber":`Numero di auto`,
"label.view.sortview.name":`Visualizza nome`,
"label.h5.add.activity":`Aggiungi attività`,
"label.textmessage.vonage.phone.number":`Numero di telefono`,
"label.partnerCloud.financeSetting.enterApiKey":`Inserisci la chiave segreta dell'API`,
"label.industrialandcommercialverification.enablestatus":`Abilitare lo stato`,
"label.reportTypeFocusD1":`Specifica quale tipo di record (righe) sarà l'obiettivo dei rapporti generati da questa fonte di dati del rapporto.`,
"vue_label_report_four-levelseriesobjecttree":`Albero degli oggetti in serie a quattro livelli`,
"label.mobile.default.catalogue":`Catalogo predefinito`,
"label.partnerCloud.partnerAccount.again":`Ricarica`,
"label.summaryreport.step2.new":`Passo 2 Selezionare il metodo di raggruppamento dei dati riassunti`,
"label.tabpage.cancel":`Cancella`,
"label.multilang.datamovelist.datamove":`Trasferire diversi {0} da un utente a un altro utente:`,
"label.conferloginandvisitlimit":`Accesso concesso`,
"vue_label_help_viewhelpcenter":`Visualizza il Centro assistenza CloudCC`,
"label.leadscore.norule":`Nessuna regola di lead scoring, per favore crea una regola di lead score o attiva una regola esistente`,
"label.tabpage.exitz":`Uscita`,
"label.DeploymentStatus":`Stato di spiegamento`,
"label.layout.saving":`Salvataggio del layout...`,
"label.emailobject.emaildetail.field.object":`Oggetto`,
"label.customfields.searchrelation.fieldtag.tip":`Inserisci le etichette da usare nella vista di visualizzazione, nella vista del layout di pagina, nella vista dei rapporti e nella vista dell'elenco.`,
"message.huanxin.bindtenant.notfound":`Agente non vincolato`,
"label.referpersonalias":`Inviato da`,
"label.icon.31":`Computer`,
"label.appupload.upload.install.thispackage":`Questo pacchetto`,
"label.appointment.wizard.subtitle1-1":`Personalizzato`,
"pagecreator_page_message_save_fail":`Salvataggio della pagina non riuscito`,
"label.lastset":`Finalmente secondo`,
"label.version.support.limited":`Supporto limitato`,
"vue_label_homepage_kanban":`Kanban`,
"label.layout.editsearchdistribute":`Modifica il layout di ricerca`,
"template.dashboard.customer.analysis":`Analisi dei conti`,
"label.continue_editing":`Continua a modificare`,
"label.version.sum.customtab":`scheda/e personalizzata/e`,
"label.validate.function.funcExplain.TIMEVALUE":`Restituisce il valore dell'ora locale senza la data`,
"label.import.page1.selectobjfromdata":`Seleziona gli oggetti per importare i dati`,
"label.partnerCloud.basicSetting.success":`Inizializzare con successo`,
"label.customfields.fielddependency.cannotcreat":`Il campo selezionato dipende direttamente o indirettamente da se stesso, quindi non è possibile creare una dipendenza.`,
"label.umeng.activity.youhaveatask":`Avete un nuovo compito.`,
"label.file.folder.create":`Nuova cartella`,
"vue_label_campaign_member_status":`Stato membro`,
"lable.opppdt.addpdt.table.date":`Data`,
"label_partner_workspace_login_buttontext":`Testo del pulsante`,
"label_other_mistakes":`Altri errori`,
"label.must.be.configured":`Deve essere configurato`,
"label.customize.memory.function.sorting.enable":`Attivare la memoria dell'ordinamento dell'intestazione`,
"setup.layout.label.areaname":`Nome della sezione`,
"label_chatter_pastThirtyday":`Gli ultimi 30 giorni`,
"setup_mainpage_label_welcome25":`Istruzioni: Clicca sul menu a sinistra di questa pagina → Gestisci impostazioni → Controllo sicurezza → Impostazioni di condivisione.`,
"label.ccchat.person.invite.succsend":`Un invito ad unirsi alla CCChat viene inviato a`,
"label.select.time.range":`Si prega di scegliere l'intervallo di tempo`,
"label.partnerCloud.orderingPlatform.djustQuantity":`Aggiungi i prodotti al carrello, dove puoi regolare la quantità e visualizzare il prezzo.`,
"label.manageAll.sta1":`In attesa di`,
"label.cy.select":`Scegli una nuova valuta dalla lista disponibile.`,
"chatter.lam":`Commento`,
"label.partner.setup.title":`Impostazioni`,
"component.setup.label.displaybutton":`Pulsante di visualizzazione`,
"component.salesperformance.label.target":`Obiettivo`,
"label.campagin.channel":`Inserisci il valore del canale`,
"label.validate.function.funcFormat.ISCHANGED":`ISCHANGED(campo)`,
"UG.homepage.009":`Accesso CRM`,
"label.file.item":`Progetto`,
"label.file.library.addmembprompt":`I seguenti sono già membri.`,
"label.bmap.releasePosition":`Posizione`,
"setup_object_layout_label_selectedprofile":`Profili selezionati`,
"label_emailsync_message":`Prompt`,
"label.view_submissions":`Visualizza le candidature`,
"lable.tianyancha.repeated":`Selezione ripetuta`,
"label.import.index.introduce":`Importa i tuoi dati nel sistema in tre semplici passi`,
"label.time.operation.new":`Nuovo lavoro programmato`,
"label.projectManagement.Pleaseentersettlementtype":`Per favore, inserisci il tipo di accordo`,
"label.icon.169":`Auto da turismo`,
"vue_label_commonobjects_detail_related_listview":`Lista`,
"label.view.step1":`Passo 1 Inserire il nome della vista`,
"label.summaryreport.intro":`I rapporti di riepilogo mostrano sia il subtotale dei dati che altre informazioni di riepilogo.`,
"vue_label_file_input_correct_name":`Si prega di compilare il nome corretto`,
"System_Email_Template_Title":`Benvenuti nella piattaforma CRM CloudCC`,
"label.tianyancha.province":`Abbreviazione provinciale`,
"label.deleteall.sure":`Sei sicuro di voler cancellare tutto?`,
"label.passwordPolicy.setup.uppercasealpandnum":`Deve mescolare numeri e lettere maiuscole e minuscole`,
"front-lightning-module-v1-details-page-chart-select":`Scegliere l'oggetto e visualizzare`,
"setup_mainpage_label_welcome8":`Personalizzazione dell'interfaccia drag-and-drop`,
"lable.outlook.edit.lastupc":`Ultimo aggiornamento Contatto`,
"label.weixin.registered":`Iscriviti`,
"vue_label_file_history_version":`Revisioni`,
"vue_label_campaign_earned":`Importo da raccogliere`,
"label.staticresource.useful.realtion.tip":`Di seguito è riportato un elenco di tutti i riferimenti delle pagine di CloudCC.com a questa risorsa statica.`,
"vue_label_file_libraray":`Biblioteche`,
"label.department.phone":`Numero di cellulare`,
"label.emailtemplate.edit":`Modifica modello di e-mail`,
"label.processsetting.key.information.tips":`Informazioni chiave e suggerimenti`,
"label.summaryreport.step7":`Passo 7 Selezionare il tipo di grafico e l'elemento da evidenziare`,
"label.chat.topic.remove.favorite":`Cancellare dai segnalibri`,
"label.campagin.roi.ksrq":`Data di inizio`,
"label.data.downpage.e_title.e_btn":`Vai alla pagina di esportazione e inizia l'esportazione`,
"label.approvaldatamove.dname":`Approvazione corrente`,
"lable.Partial.attributes":`Attributo parziale`,
"template.report.enabled.products":`Prodotti attivati`,
"lable.outlook.detail.cto":`CloudCC.com a Exchange`,
"label.sendemail.activity.newtasktitle":`Notifica di un nuovo compito`,
"label.validate.function.funcFormat.DAY":`GIORNO (data)`,
"label.log.datetime.value":`Si prega di inserire il tempo di interrogazione`,
"label.import.index.updaterecord":`Aggiornare il record`,
"label.registration.page.invitation":`Invito alla pagina di registrazione`,
"pagecreator_systemstyle_label_detailcolor":`Dettaglio colore del testo`,
"label.tabname.cannot.empty":`Il nome della scheda non può essere nullo`,
"label.data.newtemplate.savetemp":`Puoi salvare come modello e usare i campi e i criteri per questa esportazione di dati come modelli di esportazione di dati. Inserisci il nome e la descrizione del modello con attenzione per facilitarne l'uso.`,
"label.ems.body":`Corpo`,
"enc":`Testo crittografato (memorizzazione crittografata)`,
"label.profile.mobile.setup.commonSaler":`Vendite generali`,
"label.continueselectproduct":`Continuare a scegliere i prodotti`,
"label.event.new":`Nuovo evento`,
"label.renametabandtaglib":`Rinomina scheda ed etichetta`,
"label.qrcodelogin.message.exception":`Eccezione al server, contatta il tuo amministratore.`,
"label.service.gantt.locationToGantt":`Grafico di Gantt`,
"label.mr.theLastGroup":`Questo è l'ultimo gruppo. Clicca su "Torna a visualizzare l'elenco dei record duplicati" per visualizzare i record duplicati.`,
"label.report.export.format.content":`Esporta l'intestazione del rapporto corrente, i gruppi e i dettagli. Il numero massimo di dettagli esportabili è`,
"label.version.accountandcontact":`Conti e contatti`,
"label.partnerCloud.financeSetting.enterMd5Key":`Inserire la chiave segreta MDS.`,
"label.login.access.quater":`Settimana`,
"vue_label_commonobjects_view_searchthisview":`Cerca in questa lista`,
"label.import.step1.allobj":`Tutti gli oggetti`,
"front-efficient-project-management":`Project Cloud fornisce la gestione dell'intero ciclo di vita dal kickoff del progetto, alla pianificazione, all'esecuzione, al controllo fino alla chiusura, ottimizzando il processo di gestione del progetto secondo le vostre esigenze aziendali e aiutandovi a gestire i progetti in modo efficiente.`,
"label.includedvalue":`Includere i valori`,
"label.service.newBuildDialog.past.days":`giorni passati`,
"vue_label_report_sortup":`Ordina in ordine crescente`,
"label.appointment.wizard.subtitle3-2":`Martedì`,
"label.dashboard.trend":`Tendenza`,
"label.schedulejob.setup.schedule.st2":`Il 2`,
"label.view.sortview.number":`Numero di record`,
"lable.Please.enable.order":`L'ordine non è attivato, si prega di attivare.`,
"label.datamanage.immediately.import":`Importazione`,
"label.delete.condition":`Chiaro`,
"label.dashboard.chooseDispalyOnTheHomePage":`Seleziona la homepage da visualizzare`,
"asset.accountid.contactid.required":`Ogni risorsa deve essere associata a un account o a un contatto.`,
"label.mask.character":`Maschera Carattere`,
"lable.account.Previous.FY":`Precedente FY`,
"chatter.attachment":`Aggiungere file`,
"label.view_only":`Visualizza solo`,
"label.tianyancha.name":`Nome dell'azienda`,
"label.service.gantt.avg.traveltime":`Tempo medio di viaggio degli appuntamenti di servizio`,
"vue_label_pool_move":`Spostare`,
"label.import.index.beforeexport":`2. Prima di importare, assicurati di importare tutti i record correlati. Per esempio, se stai importando i record di contatto e vuoi riempire il campo account, che è un campo di ricerca, devi prima creare il record di account che stai compilando, poi importare il record di contatto e riempire il campo account con il nome o l'ID del cliente corrispondente.`,
"label.view.delete":`Cancellare`,
"template.detail.info.link":`Dettagli Link`,
"label.sendemail.send.setfail":`L'impostazione delle informazioni sull'e-mail non è riuscita, per favore inserisci le informazioni corrette per l'e-mail.`,
"label_emailtocloudcc_redmessage11":`l'autenticazione di SMTP è stata completata. Si prega di controllare che l'indirizzo e-mail e la password siano corretti.`,
"label.campaigns.memberalert":`Si prega di selezionare un membro almeno`,
"label.schedulejob.setup.schedule.frequency":`Frequenza`,
"component.newrecords.label.all":`Vedi tutto`,
"label.mr.caption.opportunity":`Trova i duplicati e unisci: Codizioni per la ricerca di duplicati di opportunità`,
"chatter.group.onlyMembers":`Solo i membri possono vedere questo gruppo. E solo il proprietario del gruppo ha il permesso di aggiungere membri della squadra.`,
"label.recordtype.edit.selectvalue.show":`I valori della picklist sono visualizzati nell'ordine in cui sono stati salvati.`,
"message.textmaxlength":`La lunghezza non dovrebbe superare i 255 caratteri`,
"label.reportsSubscriptionPage.visibility":`In esecuzione come`,
"label.umeng.chatter.addcoments":`Il tuo post sulle nuvole ha 1 nuova risposta`,
"chatter.up.f":`Upload Failed, errore sconosciuto.`,
"label.icon.146":`Tastiera`,
"lable.custom.CY.Ago":`2 CY fa`,
"label.tabpage.step3":`Passo 3 selezionare i campi da visualizzare`,
"label.checkfield.introduce":`Imposta i campi dell'oggetto che possono essere usati per controllare i duplicati, e trova i duplicati nella lista dei record secondo i campi che hai impostato.`,
"label.tag.addtags":`Aggiungi Tag`,
"label.service.newBuildDialog.characterlimit":`Il nome supera il limite di 25 caratteri.`,
"font-evaluate-module-v1-evquestions":`Domanda di valutazione`,
"label.knowledge.only.update.draft":`Solo bozza di aggiornamento`,
"label.partnerCloud.basicSetting.defaultCounts":`Numero di ruoli predefinito per l'aggiunta dell'account del partner`,
"label.chat.topic.delete":`Cancellare`,
"label.workflow.contentcondition":`i criteri sono soddisfatti`,
"vue_label_commonobjects_view_sortby":`Ordina per {campo}`,
"label.passwordPolicy.setup.pwdremember24":`Ricorda (0) la password`,
"front-kefu-moudle-free-account":`Conto di prova`,
"label.marketsea.isautorecycle":`Abilitare il riciclaggio automatico`,
"label.addattachment.view":`Visualizza file`,
"vue_label_helpcenter_contact":`Nelle informazioni dettagliate, clicca sul pulsante del diagramma ad albero accanto al contatto, puoi visualizzare il diagramma della gerarchia dei contatti, capire le relazioni leader-membro dei contatti correlati e visualizzare alcune informazioni di campo di ogni contatto.`,
"label.taskevent":`Attività`,
"label.industrialandcommercialverification.message":`Esaurite le richieste gratuite di oggi`,
"label.object.already.delete":`L'oggetto cancellato`,
"label.project.hit.four":`Avviso di aggiornamento del sottocompito`,
"label.taskpagelayout":`Layout delle pagine dei compiti`,
"label.version.sum.locationfield":`Campi di geolocalizzazione`,
"front-sales-button-toQB":`Sincronizzazione con QuickBooks`,
"label.app.oceanblue":`Blu Oceano`,
"label.operating":`Funzionamento...`,
"label.customfields.formula.dateexample":`Reminder Date = CloseDate - 7`,
"label.happen_delete":`Cosa succede se cancello un modulo?`,
"label.service.appointmentList.plansToStart":`Piano d'inizio`,
"label.persmets.operate.licence":`Permesso`,
"label.mobile.quickcreate.default.activities":`Calendario`,
"label.australian.eastem.standard.time":`Australian Eastern Daylight Time (Nuovo Galles del Sud)`,
"label.emailobject.remove":`RIMUOVERE`,
"label.weixin.vote":`Vota`,
"label.reportsSubscriptionPage.condition.aggregate":`Aggregato`,
"front-kefu-moudle-has-unbind":`Sei stato slegato`,
"chatter.group.newGroup":`Nuovo gruppo`,
"label.tabpage.systems":`Ci sono * sistemi`,
"label.textmessage.vonage.connect":`Collegati a Vonage`,
"label.campaign.channel.input.ticket":`Inviare il biglietto d'ingresso`,
"label.ccpeak.query.sharetab":`Ricerca Forme di condivisione`,
"label.reporttype":`Fonte dei dati del rapporto`,
"message.duplication.label.isprofiletip":`Se spuntato, i dati che l'utente corrente può vedere vengono verificati quando si trovano i duplicati. Altrimenti, verifica tutti i dati.`,
"label.tianyancha.businessverify.xieyi":`Contratto di licenza d'uso CloudCC`,
"font-evaluate-module-v1-select-person":`Seleziona il personale del servizio clienti`,
"vue_label_chatter_all_groups":`Tutti i gruppi`,
"label.recordtype.profile.setdefault":`Rendere predefinito`,
"label.mr.descreption.nocondition":`Nessun dato duplicato che soddisfi le condizioni.`,
"label.tabpage.askz":`Cosa vorresti chiedere`,
"label.marketsea.selectMember":`Seleziona un membro`,
"template.report.stage.possibility.analysis":`Analisi delle possibilità della fase`,
"label.data.selectderivedobject":`Selezionare l'oggetto da esportare`,
"label.customfields.formula.explain":`Descrizione: attualmente supporta il numero, la percentuale e altri campi dei quattro principi, così come i valori di riporto del campo lookup. Per esempio: numero calcola: unit*unitprice&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;campo lookup porta valore:contact__r.address`,
"vue_label_notice_change_fail":`Cambiamento fallito`,
"label.customobjects.trackoldandnewvalues":`Tracciare i valori vecchi e nuovi`,
"label.h5.leftprompt":`Hai del contenuto modificato che non è stato inviato, sei sicuro di partire?`,
"label.select.field":`Campi disponibili`,
"label.customobjects.layoutedit":`Assegnazione del layout di pagina`,
"label.false":`FALSO`,
"UG_Forcast_07":`Permettere la previsione`,
"vue_label_chatter_team_member":`membro del gruppo`,
"label.tabpage.retypez":`Quando il tipo di record viene cambiato, i valori dell'elenco delle opzioni esistenti non saranno automaticamente cambiati. si raccomanda di aggiornare il valore dell'elenco delle opzioni esistenti del record nello stesso posto.`,
"front-epwechat-module-v1-single-desc":`Single Sign On altre estremità di CloudCC attraverso WeCom; Swift switch tra tutte le estremità.`,
"label.closeandconverted":`Chiuso-Convertito`,
"label.service.confirmed":`Confermato`,
"label.partner.workspace.member.cloudcc":`Profilo CloudCC`,
"label.star.click":`Clicca per cancellare`,
"label.icon.135":`Valuta`,
"button_partner_workspace_login_logo_upload":`Carica immagine`,
"message.error.sql.constraint.recordnotsingle":`ID esterno impostato con successo. Motivo: questo campo nei dati originali ha dati duplicati.`,
"label.ccchat.person.invite.errorpwd":`Utilizzare almeno 8 caratteri e includere una combinazione di numeri e caratteri`,
"label_tabpage_isdeleterecord":`Se cancella il record selezionato`,
"label.weixin.prompt.message":`Messaggio prompt`,
"vue_label_chatter_view_original_post":`Visualizza il post originale`,
"label.multilingual.tip3":`L'abilitazione del multilinguaggio permette ad ogni utente dell'organizzazione di configurare le lingue che hai abilitato.`,
"label.dataimport.error.datetime":`Errore: Il formato dei dati e dell'ora non è corretto`,
"label_tabpage_addcondition":`Aggiungere la condizione`,
"label.query.detail.manageexcludeuser":`Gestire l'utente esterno`,
"label.tianyancha.creditcode":`Codice di credito sociale unificato`,
"label.cy.enter":`Inserisci il tasso di conversione dalla tua valuta aziendale a questa nuova valuta.`,
"label.textmessage.vonage.message1":`Integrandosi con Vonage, gli utenti possono inviare e ricevere messaggi di testo sulla piattaforma CloudCC tramite Vonage. Tuttavia, gli utenti devono registrare account Vonage e acquistare numeri di telefono prima di poter inviare messaggi di testo.`,
"front-marketing-module-v1-share-invitation":`Condividi Invito del personale`,
"label.file.items":`voce(i)`,
"label.otherwise":`Altrimenti`,
"label.permission.detail.system":`Sistema`,
"message.success.task.emailsend":`Salvare e inviare il messaggio e-mail con successo`,
"label.the.reward.group":`Preventivo Gruppo Line`,
"setup.layout.label.relatedlistsetup":`Impostazioni dell'elenco correlate`,
"label.empty":`Chiaro`,
"label.weixin.cloudcc.user.binding":`Binding utente CloudCC`,
"label.file.what.change":`Cosa è cambiato?(opzionale)`,
"label.search":`Cerca`,
"label.mobile":`Mobile`,
"template.report.month.potential.customer":`Leads di questo mese`,
"lable.setup.mobilesetup.isEnableValidationRulesForScan":`Abilitare le regole di convalida quando si usa Scan`,
"lable.outlook.list.des":`La configurazione di Exchange Sync definisce le impostazioni per CloudCC for Exchange da applicare a un gruppo di utenti specifico.`,
"label.appupload.install.error.info":`{0} "{1}" è stato usato da {2}, per favore rinomina il {0} esistente.`,
"label.tabpage.addoptionsz":`Aggiungere opzioni`,
"label.arabian.standard.time":`Ora solare dell'Arabia`,
"label.thefirst":`La 1a colonna`,
"label_partner_workspace_login_footertext":`Testo a piè di pagina`,
"lable.Disabled.successfully":`Disattivare con successo.`,
"label.confirm.del":`I record di approvazione in sospeso, sei sicuro di volerli cancellare?`,
"vue_label_normal_reregister":`Accedi di nuovo`,
"label_file_img":`Immagine`,
"label.salescloud.salesdashboard.sales.behavior":`Attività di vendita`,
"label.startdate":`Data di inizio`,
"label.field.duplicate.error.msg5":`Si prega di controllare tutti gli errori qui sotto, riprovare dopo la modifica.`,
"setup.main2018.label.managesetup":`Impostazioni di amministrazione`,
"label.forecast.editshrepage.title":`Nuova condivisione`,
"UG.solution.01":`Fornire la soluzione`,
"label.knowledgebase.data.recovery.successfully":`Recuperare i dati {a} con successo`,
"label.pc.ui.2018.myccchat":`Il mio CCChat`,
"label.attachement":`Note`,
"message.mobilechooseatmostten":`Seleziona fino a 10 campi`,
"label.campagin.roi.bhzeywjh":`Opportunità totali`,
"label.autoresponserule":`Regole di risposta automatica`,
"label.attendance.yuyue":`Non ha un appuntamento, si registri ora`,
"label.insert":`Inserire`,
"label.service.ganttBaiduMap.shutDown":`Vuoi chiudere?`,
"label.icon.194":`TV`,
"message.serviceterritory.violation":`Violazione di zona: la zona delle risorse non corrisponde alla zona di servizio dell'appuntamento.`,
"label.appointment.disable.function":`Disattivare la funzione`,
"lable.currencyManage.manageexchangeRate.dis":`Per gestire i tassi di cambio datati per la tua organizzazione, clicca su Gestisci tassi di cambio datati. I tassi di cambio datati sono utilizzati nelle opportunità, nei prodotti di opportunità e nei rapporti associati a questi due oggetti.`,
"vue_label_file_upload_tip_newmsg":`Meno di {size} Si raccomanda di caricare un file di MB, altrimenti possono verificarsi problemi di caricamento lento.`,
"label.event.next.week":`La prossima settimana`,
"label.datamanage.import.contactfield":`Nella seguente tabella, seleziona i campi del file importato che devono essere importati in ogni contatto. Poi clicca su Avanti:`,
"label.projectManagement.time.allocated":`Tempo assegnato`,
"label_tabpage_isdeleteview":`Sei sicuro di voler cancellare questa vista?`,
"label.pc.ui.2018.search":`RICERCA...`,
"label.role.createrolelevel":`Creare la gerarchia dei ruoli`,
"label.tabpage.editview":`Modifica vista`,
"label_partner_common_manageSetup":`Impostazioni amministrative della nuvola del partner`,
"label.service.gantt.noservice.resource":`Non sono state trovate risorse di servizio disponibili nel territorio di servizio selezionato.`,
"message.numbertoolarge":`Il numero è troppo grande`,
"label.sendsms.success":`Il testo è stato inviato con successo`,
"UG.opportunity.009":`Oppure`,
"label.ccpeak.construction.dataobj":`per costruire un oggetto dati, il nome API dell'oggetto deve essere passato in`,
"front-lighting-module-v1-detail-file-uploadInfo":`Il record è bloccato e non è disponibile per il caricamento di file. Contatta l'amministratore per sbloccarlo.`,
"label.import.page2.newnotmatchfiled":`Un totale di {{ csvfiledlength }} campi nel file. {{this.csvfiledlength - this.selectlength}} non mappato.`,
"label.ems.inputmailss":`Ricevere il server di posta elettronica`,
"label.knowledgebase.data.published.successfully":`Pubblica {a} dati con successo`,
"label_emailtocloudcc_position":`Posizione`,
"label.data.exp.customexp":`Esportazione personalizzata`,
"component_chatter_post_button_user":`Aggiungere persone`,
"label.new.visualpagefolder":`Pagina personalizzata: Nuova cartella`,
"label.forecast.shrepage.classdes":`Descrizione dei livelli di accesso`,
"label.task.overdue.unfinished":`Compiti non elaborati in ritardo`,
"label.ccchat.micropost.isedit.setting.info":`L'autore del post o del commento, il proprietario del record, il moderatore di CCChat e il moderatore di questa comunità hanno tutti il permesso di modificare questo testo.`,
"label.recordname":`Nome del record`,
"label.posted_your":`e pubblicato nel tuo`,
"label.globaloperation.operationtype.custom.page":`Pagina personalizzata`,
"label_tabpage_busoppnamez":`Nome dell'opportunità di business`,
"front-epwechat-module-v1-schedule-desc":`Sincronizza gli orari WeCom e gli eventi CloudCC`,
"label.escalation.setup.newentries.lastmodifydate":`In base all'ora dell'ultima modifica`,
"setup_layout_label_nofield":`Nessun campo disponibile`,
"label.sendemail.registIMUser.logininfo":`Il portale partner cloud a cui è possibile accedere è il seguente:<br>`,
"label.weixin..xsld.kehu":`Conti`,
"label.display_thank":`Mostra pagina di ringraziamento`,
"label.group.no.my.group":`Non c'è nessuna corrispondenza con il mio gruppo.`,
"label.partnerCloud.newBuildSite.enterDomain":`Inserisci il nome del dominio`,
"label.step1.total2":`Passo 1 di 2`,
"label.ccpeak.delete.record":`Cancellare i record:`,
"label.customer.tab.step1.introduce":`Scegli l'oggetto personalizzato per questa nuova scheda personalizzata. Compila altri dettagli.`,
"label_tabpage_newInterfacez":`La nuova interfaccia`,
"setup.mainpage.label.manageuser":`Gestire gli utenti`,
"label.partnerCloud.partnerAccount.completed":`Pagamento completato?`,
"label.projectManagement.kanban":`Kanban dei compiti`,
"label.operate":`Azione`,
"label.service.dispatchingUnits.selected.time.range":`Visualizza gli appuntamenti di servizio nell'intervallo di tempo selezionato.`,
"component_setup_label_pagesize":`Numeri visualizzati in ogni pagina`,
"font-evaluate-module-v1-email-evaluation-settings":`Impostazione della valutazione delle email`,
"label.service.dispatchingUnits.skills":`Abilità`,
"label.editrecurrencetimetrigger":`Modifica dell'innesco del tempo periodico`,
"vue_label_file_edit_lib":`Modifica della libreria di file`,
"label.campaignmember.selectmember.deleteconc":`Campagna: rimuovere i membri dai contatti`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.monday":`Lunedì`,
"front-detail-module-v1-by":`da`,
"label.mobile.home.page.date.signed":`Data di chiusura`,
"label.apply.send.success":`Invia successo.`,
"label.app.choseimg":`Scegliere il logo`,
"label.customsetting.visible":`Visibilità`,
"label.sendemail.activity.task.distributetaskcompleted":`Il compito che hai assegnato a #belongtoidccname è stato completato.`,
"label.dashboard.snapshot.refreshing":`Rinfrescante`,
"label.document.name.already.exists":`Questo Document Unique Name esiste già.`,
"label.ccchat.person.invite.needlastname":`Inserisci il tuo cognome`,
"pagecreator_page_button_copy":`Copia`,
"label.appointmentpage.wizard.subtitle1-2":`Settimana precedente`,
"label.validate.function.funcFormat.MILLISECOND":`MILLISECONDO(data)`,
"label.profile.allowtocreateview":`Creare viste`,
"message.error.recordid":`L'id del record non può essere vuoto`,
"lable.SalesCommitmentKanBan.returnToTheSuperiorRole":`Torna al ruolo superiore`,
"label.translation.start3":`Se necessario, seleziona un oggetto. Per esempio, un compito del flusso di lavoro ha un oggetto (Account, Contatto, ecc.) per filtrare i termini traducibili.`,
"label.ccpeak.send.email":`Invia un'e-mail per avvisare:`,
"vue_label_commonobjects_detail_activity_noexpirationdate":`Nessuna data di scadenza`,
"label.permission.objectpermission.objpermission":`Impostazioni dei permessi degli oggetti`,
"label.version.custom.report":`Rapporti standard (pagina personalizzata)`,
"label.title.qrcodeOrbarcode":`Genera codice a barre/codice QR`,
"label.emailtocloudcc.step2.name":`Configura la proprietà delle e-mail`,
"label.reportsSubscription.edited.successfully":`Modifica la sottoscrizione del rapporto con successo!`,
"label_tabpage_kanbansetup":`Impostazione del tabellone`,
"label.tianyancha.regcapital":`Capitale registrato`,
"front-epwechat-module-v1-web-single":`Web Single Sign On:`,
"label.visualpage.display.top":`mostra l'intestazione, false - non mostrare l'intestazione`,
"label.customfields.fielddependency.selectcell":`Seleziona almeno una cella dall'elenco seguente`,
"label.paging.addmember.totalofpages":`Un totale di {0} elemento(i)`,
"label.email.saveing":`I dati stanno salvando...`,
"label.userinfo.doublepwd.notnull":`Devi ripetere la tua password.`,
"label.appointment.wizard.subtitle4-4-2":`2 settimane`,
"label.chatter.BCC":`Bcc (copia di cortesia cieca)`,
"label.emailtocloudcc.description":`Collega il tuo account e-mail aziendale, come sales@company.com, info@company.com, support@company.com. Registra automaticamente le e-mail ricevute come lead e record di casi in CloudCC per garantire un follow-up tempestivo delle lettere dei clienti.`,
"label.sendemail.send.atlastone":`Devi selezionare almeno un destinatario.`,
"label.mobile.phone.subordinate":`Includere i subordinati`,
"label.data.choses.e_desc":`Secondo le vostre esigenze, potete esportare tutti i dati o esportare i dati di un oggetto.`,
"chatter.new":`Notizie`,
"vue_label_help_back":`Indietro`,
"label.skipwizardintro":`Il Jump Start Wizard crea un processo di approvazione in pochi minuti.`,
"label.weixin.fmu.before.week":`{0} settimana(e) avanti`,
"label.sendemail.chat.praiseFeedsubject":`CloudCC CCChat piace il tuo post`,
"lable.currencyAdv.andafterdate":`e dopo`,
"label.sometoprocess":`Se solo certi tipi di registrazioni devono entrare in questo processo di approvazione, inserisci quel criterio qui sotto. Per esempio, solo le note spese dei dipendenti della sede centrale dovrebbero utilizzare questo processo di approvazione.`,
"label.campaignmember.main.updateleaddesc":`Aggiornare lo stato di tutti i lead in una volta sola`,
"label_partner_common_roleSetup":`Impostazioni del ruolo e dell'utente del cloud dei partner`,
"label.console.step5.no":`Scegliere come visualizzare i record`,
"label.salescloud.teamrole.optionlist.account":`Aggiungi un membro del team dell'account a`,
"Report.Delete.Confirm.Title":`Si prega di confermare`,
"label.onclick":`Fare clic su`,
"label.weixin.input.identifying.code":`Inserisci il codice di verifica`,
"label.knowledge.translate":`Solo l'articolo di conoscenza dell'edizione principale nello stato di Bozza o Pubblicato può essere tradotto.`,
"label.log.ip":`IP`,
"front-electronic-export-goResult":`Controlla in Mailchimp`,
"label.escalation.setup.newaction.otheremail.otheremail":`Altre e-mail`,
"label.icon.104":`Programma`,
"label.partnerCloud.exceedTwo":`La foto del profilo caricata non può superare i 2MB!`,
"label_tabpage_thevalurofz":`Il valore di`,
"front-lightning-module-v1-details-page-chart-maximum":`Si possono inserire fino a 50 caratteri.`,
"label.data.downpage.i.title.num6":`Si raccomanda di importare un file di prova contenente 5 record prima di importare i dati per assicurarsi che i dati da importare siano corretti.`,
"label.ccpeak.update.record":`Modificare i record`,
"label.dataimportandexport":`Importazione ed esportazione di dati`,
"label.tabpage.notexceed25":`Il record selezionato non deve superare il 25`,
"label.starting":`In corso`,
"label.knowledge.language.spanish":`Spagnolo`,
"label_emailtocloudcc_set":`Impostare le informazioni della cassetta postale`,
"message.oneormoreneedsreport":`Si prega di eliminare il gruppo del pannello strumenti di riferimento per il rapporto, e poi riprovare.`,
"label.attendance.xccheckin":`Check In`,
"label.emailmerge.editfolder.title":`Cartelle di modelli di Mail Merge`,
"template.report.year.customer":`I leader di quest'anno`,
"label.partner.common.webSit.memo":`Nome di dominio predefinito del cloud partner della tua organizzazione:`,
"label.partnerCloud.financeSetting.onlinePayment":`Pagamento online`,
"Pagelayout.Setup.001":`Seleziona gli elenchi correlati che verrebbero visualizzati sul layout hover.`,
"front-kefu-moudle-time-length":`Durata`,
"label.deleteObject":`L'oggetto viene cancellato.`,
"label.setup.mobile.homepageshortcuts.select":`Seleziona 4 swift fucntions da mostrare nell'area superiore della __ homepage`,
"setup.mainpage.label.welcome26":`Gestione dei dati - Elaborazione batch`,
"label.ServiceCloud.yuyuebainhao":`Appuntamento di servizio n.`,
"label.emailobject.emaildetail.button.addtolead":`Aggiungi ai lead`,
"label.event.single.view":`Vista del singolo utente`,
"lable.product.pricebooks.ustand":`Scegliere il prezzo standard`,
"label.emailtocloudcc.department":`Dipartimento`,
"component_assistant_label_30daysnoact":`30 giorni senza alcuna campagna`,
"label.weixin.no.pending.qzkh.qin":`Spiacente, nessun indizio da mostrare.`,
"label.vlidaterule.formula":`Formula della condizione di errore`,
"label.tianyancha.h5.contact":`Informazioni di contatto`,
"label.button":`Pulsanti`,
"message.checkemail":`<strong>Errore:</strong> c'è un errore nella tua email inserita, per favore controlla.`,
"lable.account.previous.CY":`Precedente CY`,
"label.icon.13":`Servizio`,
"chatter.coll.c":`Rimuovi segnalibro`,
"label.knowledge.category.hint.four":`Assegnazione delle categorie di dati`,
"label.tianyancha.phonenumber":`Numero di telefono`,
"label.tablayoutedit.remark":`Seleziona i campi e le pagine personalizzate visualizzate nella home page della scheda.`,
"label.shareusers":`Condividi con gli utenti`,
"label.endtime":`Fine`,
"label.length":`Lunghezza`,
"label.umeng.activity.event.begin":`iniziare dopo`,
"label.tabpage.alltabs":`Tutte le schede`,
"label.exact.query":`Ricerche migliorate`,
"label.weixin.skip":`Salta a`,
"label.ems.cancel":`Cancella`,
"label.trigger":`Triggers`,
"label.exchange.sync.setting":`Configurazione della sincronizzazione di Exchange`,
"label.product.pricebooks.name":`Prezzo Nome del libro`,
"label.relation.list.total":`Selezionato`,
"label.step2.total7":`Passo 2 di 7`,
"label.martrixreport.2018.step6.new":`Passo 6 Seleziona il tipo di grafico e l'elemento da evidenziare`,
"label.standard.buttonandlink.override":`Sovrascrivere la larghezza`,
"front-console-conversation-btn4":`Separato come nuovo caso`,
"vue_label_dashboard_range":`gamma`,
"label.app.sort.show":`L'applicazione viene visualizzata nell'ordine salvato.`,
"label.salescloud.teamrole.choose.correct":`Utenti duplicati selezionati, si prega di correggere`,
"label.schedule_post":`Pubblicare il post`,
"front-kefu-moudle-server-request-num":`Elenco delle richieste di servizio n.`,
"label.h5.logout":`Disconnettersi`,
"label.weixin.horse.club.member.message":`Informazioni sui membri di Aid-Max`,
"label.field.addoptionlist.introduce":`Inserisci uno o più valori dell'elenco di scelta qui sotto, con ogni valore separato da una nuova riga.`,
"setup_layout_label_setupfield":`Proprietà del campo`,
"label.chatter.nextStep":`Prossimo passo`,
"label.quickbooks.searchlist.total1":`Ci sono {0} fatture non collegate per un valore totale di {1}`,
"label.tianyancha.h5.regcapital":`Capitale registrato`,
"label.icon.184":`Consulenza`,
"label.dashboard.message.refreshtoomush":`L'istantanea della dashboard viene aggiornata troppo frequentemente, per favore aggiorna più tardi`,
"label.umeng.approval.reject":`#approver ha rifiutato la tua richiesta di approvazione #obj.`,
"label.h5.chatter.newmessage":`Inserisci un nuovo messaggio`,
"message.error.relationid":`relationid non può essere vuoto!`,
"label.setup.mobile.offlinecache.selectdefault":`Seleziona le schede come schede predefinite della cache offline`,
"label.setup.mobile.homepageshortcuts.saveprompt":`Si prega di selezionare 4 funzioni rapide.`,
"label.projectManagement.Selectmonth":`Selezionare il mese`,
"label.version.ultimate":`Edizione definitiva`,
"label.validate.remark5":`I campi delle date obbligatorie sono nell'ordine corretto, per esempio: l'ora di inizio deve essere inferiore a quella di fine`,
"label.version.nowis":`La tua attuale versione di CloudCC è`,
"front-kefu-moudle-CRM-set":`Impostazione CRM`,
"label.mr.title.customerAddress":`Indirizzo del conto`,
"label_emailtocloudcc_step1_name":`Scegliere la funzione`,
"label.time.operation.edit":`Modificare i lavori programmati`,
"label_tabpage_operationz":`Campo, l'operazione non può essere vuota`,
"label.translation.start4":`Doppio clic nella colonna della traduzione per inserire nuovi valori.`,
"vue_label_systemSettings_request":`Richiesta di trasferimento del lotto`,
"label.maintenance.notice":`Avviso di manutenzione`,
"label.customfields.txet.textlength.tip":`Inserisci la lunghezza massima di un campo di testo qui sotto E la lunghezza massima è di 255 caratteri.`,
"label.ccdocument.select.template.open":`Seleziona il modello da aprire.`,
"vue_label_display_date_field":`Mostra i campi della data`,
"label_partner_workspace_tab":`Scheda`,
"lable.account.LasthDays":`Ultimi 120 giorni`,
"chatter.using.sticker":`Abilitare il tracciamento dei feed`,
"message.save.dataerror":`Errore: errore di salvataggio causato da una lunga lunghezza dei dati o da altri problemi. Si prega di modificare i dati per salvare di nuovo.`,
"vue_label_commonobjects_view_chart_newchart":`Nuovo grafico`,
"label.chat.micropost.a.group":`Gruppo`,
"lable.currencyManage.advcurrencyunEnabled":`La gestione avanzata della valuta non è abilitata`,
"label.appexchange.workflow":`Regole del flusso di lavoro`,
"vue_label_calendar_show_details_and_add_events":`Mostra i dettagli e aggiungi eventi`,
"label.salescloud.optionlist.inputname":`Inserisci il nome del valore della lista di prelievo`,
"label.dashboard.folder":`Cartelle`,
"label.knowledgebase.permanently.remove.articles":`L'eliminazione dell'articolo archiviato causerà la cancellazione permanente delle altre versioni relative.`,
"label.emailtocloudcc.titel":`Email a CloudCC`,
"label.visualpage.sel":`Pagine personalizzate in questa cartella`,
"label.planned.all.work":`Tutti i lavori pianificati`,
"label.weixin.agree.agreement":`Accettare il relativo accordo`,
"label.forecast.customforecast.qsn":`Anno di inizio`,
"label.appupload.managed":`Controllato`,
"template.report.folder.sale.index":`Analisi degli indicatori di vendita`,
"UG_opportunity_011":`Importazione di transazioni`,
"label.validate.function.funcFormat.SECOND":`SECONDO(data)`,
"UG_homepage_005":`Informazioni sulle vendite`,
"label.clicktoreturn":`Clicca qui per tornare indietro`,
"label.collectionofview":`s View Sets`,
"com.cloudcc.login.error.message.nonuser":`Il tuo id non esiste`,
"vue_label_systemSettings_emailsetting":`Impostazione dell'email`,
"vue_label_email_mark_as":`Segna come`,
"label.tabpage.customernamez":`Nome del cliente`,
"label.appupload.install.apicannotsame":`Il nuovo nome dell'api non può essere lo stesso del valore originale`,
"label.task.all.undealt":`Tutte le attività in ritardo non elaborate`,
"front-lightning-module-v1-dashborad-statistical-indicators":`Indice statistico`,
"UG.quota.02":`Fase delle opportunità di cambiamento`,
"label.approve":`Approvare`,
"vue_label_calendar_remove_calendar":`Rimuovere il calendario`,
"label.mr.title.contactName":`Nome del contatto`,
"label.projectManagement.resource":`Gestione delle risorse`,
"label.rejectbehaviour1":`Permettere all'approvatore di scegliere manualmente di tornare al numero di passo.  (ritorno al passo precedente N)`,
"label.publicgroup.relationship":`Appartenenza al gruppo`,
"Lead.Scoring.DetailedPage.Popup.Title":`Intuizione del piombo`,
"label.owner.edit":`Modifica del proprietario`,
"label.campaign.channel.ticket.mark":`NOTA: Salvare il codice QR nell'album fotografico utilizzando lo screenshot del cellulare o salvarlo sul cellulare ed entrare nella campagna con il codice QR.`,
"label.opportunity.setting.showstage.info":`Se mostrare la fase delle opportunità sull'app CloudCC.`,
"label.emailobject.wizard.desc3":`Risparmiare tempo utilizzando modelli di e-mail`,
"label.cpq.quote.no.product.add":`Nessun prodotto aggiunto nel preventivo. Si prega di aggiungere il prodotto prima di generare gli ordini.`,
"label.customer.tab":`Schede personalizzate`,
"Opportunity_Detailed_Phase_Label_Popup_002":`Data di chiusura della fase attuale`,
"component_telerecord_label_name":`Nomi`,
"label_component_helper_nodata":`Non c'è niente che richieda la tua attenzione in questo momento. per favore torna più tardi.`,
"label.dashboardSetup.d2":`Punto di rottura 2`,
"setup.mainpage.label.welcome4":`Istruzioni: Fare clic sul menu sul lato sinistro della pagina → Impostazioni applicazione → Crea → Oggetto.`,
"label.step4.total5":`Passo 4 di 5`,
"label.payment.the.remaining.days":`La tua licenza scade tra {0} giorni`,
"label.encoding":`Codifica`,
"label.setting.intergrationlist.status2":`Questa integrazione è attualmente installata.`,
"label.new":`Nuovo`,
"label.search.searchsetup":`Impostazioni di ricerca`,
"label_tabpage_printz":`Stampa`,
"report.type.label.customService":`Assistenza clienti`,
"label.notification.addEmailObject.message":`Hai ricevuto un'email da {!fromaddress}, clicca per vedere più dettagli`,
"label.icon.68":`Macchina`,
"UG.Lead.003":`Sociale`,
"label_mobile_default_field_service_home":`Homepage di Service Cloud`,
"label.select.one.group":`Si prega di scegliere almeno un gruppo di linee di citazione.`,
"front-kefu-moudle-trkey-nopower":`La coppia di chiavi di Tianrun non ha permessi assegnati`,
"label.chatter.cancel":`Cancella`,
"label.weixin.report.optiondisplay":`Mostra`,
"front-kefu-moudle-v1-System-version":`Versione del sistema:`,
"lable.product.pricebooks.editall":`Modifica tutto`,
"label.group.no.recent3":`o`,
"label.knowledge.article.delete":`Errore durante la cancellazione dell'articolo di conoscenza.`,
"label.relateobj":`Relativo a`,
"workflow.action.tasks.assignortype.type":`Tipo`,
"label.layout.selectedfields":`Campi selezionati`,
"label.role.assign.operate":`Assegnare altri utenti a questo ruolo:<ul><li>Fare clic sull'elenco a discesa per visualizzare tutti gli utenti disponibili.</li><li>Selezionare un utente nell'elenco di sinistra "Utenti disponibili" e aggiungerlo all'elenco "Utenti selezionati".</li></ul>`,
"label.field.insert":`Inserisci campo`,
"label.icon.11":`Persone`,
"label.group.no.recent4":`iniziare un gruppo.`,
"front-epwechat-module-v1-input-corpid":`Inserisci Corpld`,
"setup_object_field_dependency_label_actionfieldnotnull":`Si prega di selezionare prima un campo di controllo.`,
"setup.mainpage.label.welcome19":`Istruzioni:  Clicca sul menu a sinistra di questa pagina → Gestisci impostazioni → Gestisci utenti → Utenti, ruoli, profili`,
"label.escalation.setup.list.rulename":`Nome della regola`,
"label.ems.addaccount":`Aggiungi un account ora`,
"label.reportsSubscription.details.only":`Solo dettagli (formato Excel .xlsx)`,
"vue_label_commonobjects_view_groupby":`Gruppo per`,
"label.email.form.text":`Solo testo`,
"label.weixin.loginname":`Nome di accesso`,
"label.forecast.settings.sr":`Entrate`,
"label.chatter.sendEmailToGroupMember.subject.F":`{0} post pubblicati per tutti in {1}`,
"label.ccchat.enter.subject":`Inserisci l'oggetto del voto`,
"label.customer.tab.introduce":`Le schede degli oggetti personalizzati appaiono e si comportano come le schede standard fornite con CloudCC.`,
"message.login.mfaverification.wrong":`Errore del codice di sicurezza.`,
"component.newrecords.label.name":`Nome`,
"label.salescloud.opportunity.addandedit.contactrole":`Aggiungere e modificare i ruoli dei contatti`,
"label_emailtocloudcc_button_next":`Prossimo`,
"label.console.step5":`Passo 5 Scegliere come visualizzare i record`,
"setup.main2018.label.norole":`Non hai i permessi amministrativi`,
"template.chart.ywjhqd":`Fase delle opportunità di business`,
"label.instrumentPanel.breakpointOneLabelname":`Questo valore deve essere maggiore del valore minimo.`,
"label.qrcode":`Codice QR`,
"label_tabpage_no2z":`No2`,
"label.log.search.date.range":`Il ciclo di una query non può essere più lungo di {c} mesi.`,
"label.console.step7":`Passo 7 Assegnare il profilo`,
"label.australian.central.standard.time":`Australian Central Standard Time (Territorio del Nord)`,
"label_tabpage_deleteviewfailed":`Cancellazione della vista non riuscita`,
"vue_label_commonobjects_view_searchview":`Cerca in questa vista`,
"message.error.object.notexists":`L'oggetto non esiste.`,
"label.tablecell":`Cellule`,
"vue_label_notice_edit_success":`Modifica con successo`,
"label.customer.language":`Lingua predefinita`,
"label.csrf":`Attivare la protezione di sicurezza csrf`,
"label.forecast.customforecast.submit.zhi":`a`,
"label.sso.saml.idp.config.desc2":`Fai clic su Enable Identity Provider per abilitare la tua organizzazione CloudCC.com come fornitore di identità.`,
"label.export_data":`Dati di esportazione`,
"component.todaytask.label.all":`Vedi tutto`,
"label.h5.chatter.record":`Bilancio di esercizio`,
"front-vew-email-verification":`Visualizza l'email e verifica l'account. Puoi accedere solo dopo aver confermato l'email.`,
"laber.marketsea.del.error":`Il pool di piombo è occupato e non può essere cancellato`,
"vue_label_notice_homepage_entername":`Inserisci il nome modificato`,
"UG.Forcast.01":`Previsione`,
"front-email-payment-tips":`L'importo della fattura è vuoto. Si prega di avviare il pagamento online dopo aver riempito l'importo della fattura.`,
"setup.mainpage.label.welcome2":`Database personalizzato (oggetto)`,
"APPIntegration.Social.facebookerror":`Devi inserire un URL valido per facebook.com`,
"label.profile.mobile.setup.stand":`Pagina iniziale standard`,
"label.custom.CY":`Anno personalizzato`,
"label.knowledgebase.publishing.conditions":`Pulish {a} dati falliti, sono fuori dai criteri di pubblicazione!`,
"label.tianyancha.description":`Abilita TianYanCha alla verifica dei dati industriali e commerciali. Questo servizio supporta i dati commerciali registrati nella Cina continentale.`,
"label.appexchange.uninstallpage.title":`Disinstallare il pacchetto will:`,
"label.currencyRate":`Tasso di conversione`,
"setup_layout_label_areashow":`Visualizza l'intestazione della sezione On`,
"label.setup.case.setting":`Mini programma a caso`,
"vue_label_commonobjects_view_fixed_at_most":`Solo tre colonne possono essere fissate al massimo`,
"template.report.month.income":`Entrate di questo mese`,
"label.sms.companyname":`Nome dell'azienda`,
"label.sendemail.registIMUser.waitmessage":`Purtroppo, non si dispone di un portale cloud partner è possibile accedere. si prega di attendere, il nostro amministratore vi informerà più tardi. è possibile visitare l'indirizzo specificato per entrare nella pagina di accesso. utilizzare il nome utente e la password di cui sopra per accedere.`,
"label.custom.field.task.object":`Un compito assegnato a te. Compito sbject:`,
"message.pleaseselectdayinweek":`Si prega di selezionare un giorno della settimana.`,
"label.chat.topic.favorites":`Segnalibro`,
"UG.Campaign.004":`Campagna di importazione`,
"label.approval.preview":`Anteprima del processo`,
"label.knowledgebase.assign.articles.to.people.or.queues":`Scegliete la lingua di destinazione e assegnate l'articolo alla persona interessata o alla coda. L'esportazione delle traduzioni di solito è assegnata a una coda, e gli articoli interni tradotti vanno a una persona.`,
"pagecreator_systemstyle_message_save_success":`Stile salvato con successo`,
"label.outline":`Contorno`,
"label.read.only.field":`Campi di sola lettura`,
"front-gantt-module-v1-early-warning":`Allarme precoce`,
"label.file.ccchat.selectfrompc":`Seleziona un file dal tuo computer`,
"vue_label_systemSettings_social":`I social media`,
"label_report_year_last_year":`Anno per anno`,
"lable.PowerProcess.Meet.the.conditions":`Devono essere soddisfatti i seguenti criteri:`,
"label.changemydisplay.list.title":`Visualizza`,
"UG_Forcast_03":`Iniziare a pianificare ed eseguire le strategie aziendali. <br>Vi auguro una felice previsione!`,
"label.sendemail.chat.sendmessage":`Caro #nome:\nongiorno! #nomeUtente ti ha inviato un messaggio.`,
"label.huanxinconfig.secretid.lost":`secretid non può essere vuoto`,
"label.icon.49":`Generazione di energia`,
"chatter.feed.button.publish":`Condividi`,
"label.power":`^Potenza`,
"label.partnerCloud.financeSetting.informationThree":`3. Dopo essere entrati nella pagina di gestione delle chiavi segrete, fare clic su mapi Gateway Product Key e acquisire l'ID del partner e la chiave segreta MDS.`,
"label.emailtocloudcc.step1.lead2":`Una volta configurato, le mail ricevute in questa casella di posta saranno automaticamente registrate come record di lead in CloudCC. Assicurati che nessun affare vada perso.`,
"label.knowledgebase.delete.draft.succeeded":`Cancellare la bozza con successo`,
"label.dashboardSetup.title":`Editor di componenti`,
"label.trigger.operation.email.template.map":`Ritorno alle informazioni del modello, Oggetto dell'email: m.get("subject"); Contenuto dell'email: m.get("context"); se il tipo di email è testo: m.get("istext")`,
"label.dependencesearchfilter":`Filtri di ricerca correlati`,
"label.selected.search.length":`Non più di 10 campi di ricerca selezionati`,
"label.profile.commonusercontrol":`Permessi generali dell'utente`,
"lable.Microsoft.YaHei":`Microsoft YaHei`,
"label.appupload.component.type.app":`App`,
"label.customsetting.manage.position":`Posizione`,
"vue_label_systemSettings_bindweb":`Legare il web`,
"label.loginservice.license.notexist":`La licenza non esiste.`,
"label.icon.43":`Campane`,
"UG_homepage_003":`Vista a 360 gradi`,
"label.file_format":`Formato del file`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.sunday":`Domenica`,
"vue_label_chatter_post_has_delete":`Il post è stato cancellato`,
"report_label_searchresult":`Risultati della ricerca`,
"label.tabpage.justsz":`Solo`,
"Lead_Scoring_Setting_LevelSetting":`Impostazioni di popolarità del piombo`,
"setup.object.field.dependency.label.selectedfieldvalue":`Valori di campo disponibili`,
"label.search.morelistview":`Più vista elenco`,
"vue_label_homepage_won":`Chiuso`,
"label.notification.last30days":`Ultimi 30 giorni`,
"vue_label_helpcenter_pool":`Utilizza il lead pool e l'account pool per gestire i tuoi dati di vendita.<br>Imposta l'account pool<br> Crea l'account pool in background, imposta gli amministratori e i membri dell'account pool e configura le regole di riciclaggio automatico dei ritardi, che è conveniente per gestire la situazione del follow-up delle opportunità all'interno del tuo team e incoraggiare i membri del team a seguire attivamente.<br>Gestire manualmente i dati<br> L'amministratore del pool di account può eseguire operazioni come la distribuzione, il riciclaggio, lo scarto e il trasferimento dei record nel pool di account, e gestire i record nel pool di account in modo unificato;<br> I membri del pool di account possono ricevere record non assegnati o visualizzare i record di cui sono responsabili.`,
"label.emailsync.status.export":`Esportazione come file in formato Excel_csv`,
"label.service.miniProgram.slideshowTitle":`Carosello`,
"label.service.miniProgram.slideshowName":`Nome della giostra`,
"label.fieldupdate.selectobj":`Definire l'oggetto associato all'aggiornamento del campo, quindi fare clic su Avanti. Gli aggiornamenti di campo possono essere associati solo a regole di flusso di lavoro e processi di approvazione dello stesso tipo.`,
"label.ccpeak.take.notice.sharetab":`Nota: i campi nell'espressione del modulo condiviso non richiedono l'aggiunta di "__c".`,
"label.log.startdate.after.endate":`L'ora di inizio non deve essere successiva all'ora di fine.`,
"label.rememberme":`Ricordati di me`,
"label.partner.all.maxNum":`I più grandi dati delle nuvole partern:`,
"component.setup.iframe.label.inputurl":`Inserisci l'indirizzo url`,
"label.h5.systemmessage":`Messaggio di sistema`,
"label.delete.date":`Cancellare la data`,
"front-email-payment-select-month-tips":`Scegliere MM`,
"front-kefu-moudle-bind-userinfo":`Vincolare le informazioni dell'utente`,
"label.appointment.wizard.notif2":`您需要在创建日程预约前先设定好一个预约的时长`,
"label.custom.field.maping.number":`Il numero di cifre di piombo non può essere maggiore del numero di cifre di campo mappate.`,
"label.event.dayview":`Vista del giorno`,
"label.replace":`Sostituire`,
"label.knowledgebase.search.knowledge.articles":`Cerca l'articolo sulla conoscenza`,
"component_event_label_soon":`Immediatamente`,
"label.imgfield.upload":`Carica immagine`,
"message.printable.view":`Vista stampabile`,
"vue_label_notice_uploadavatar_notice1":`La dimensione dell'immagine avatar caricata non può superare i 2MB`,
"label.visualpage.developer.help":`Aiuto per lo sviluppatore di pagine personalizzate`,
"label.validate.function.funcFormat.IF":`IF(logical_test, value_if_true, value_if_false)`,
"label.sso.saml.sp.description1":`Impostazioni di accesso singolo`,
"vue_label_calendar_step_1":`Passo 1: dare un nome al calendario`,
"component.telerecord.button.save":`Salva`,
"setup_mainpage_button_manageobject":`Gestione degli oggetti`,
"label.marketingactivityinfluence":`Influenza della campagna`,
"label.quote.bjjsxx":`Informazioni sull'accettazione del preventivo`,
"label.appupload.upload.install.retry":`Reinstallare`,
"label.layout.assignrules":`Regole di assegnazione`,
"UG.Lead.006":`Visitatore del sito web`,
"label.workmate.searchs":`Cerca colleghi`,
"label.visualpage_list.no":`Nessun permesso per accedere alle pagine personalizzate`,
"label.service.miniProgram.slideshowintroduce":`Il nome del carosello è usato solo per identificare le voci multiple dell'annuncio e non viene visualizzato nell'annuncio.`,
"label.multilang.messagedetail.search.desc":`Non possiamo trovare un messaggio con {0}:`,
"label.mobile.phone.read.note":`Inserisci qui le note`,
"label.passwordPolicy.setup.isUsingGotp":`Abilitare la verifica secondaria del login`,
"message.datetypeerror":`<strong>Errore: </strong> Data non valida.`,
"label.searchlayout.listview.button":`Pulsanti visualizzati nelle viste elenco.`,
"label.sectionpart":`Sezione`,
"label.partnerCloud.basicSetting.userSetting":`Impostazione dei ruoli e degli utenti`,
"System_Data_Import_Warning_MaxCount":`La tua organizzazione può importare solo {0} pezzi di dati alla volta, che ora è fuori dal limite, per favore regola e re-importa.`,
"label.datamove.qualified.record":`record qualificato(i), ogni volta può trasferire 100 record al massimo`,
"component_task_label_priority":`Priorità`,
"vue_label_report_me":`Io`,
"label.college.duplicate.option":`Le opzioni non possono essere ripetute!`,
"label.pw.letter":`Lettere`,
"label.file.sharedwithme":`Condiviso con me`,
"label.translation":`Traduci`,
"lable.currencyAdv.exchagecurrency.before":`e prima che`,
"label.file.share":`Condividi`,
"label.page.next":`Prossimo`,
"label.autoRegister.changepwd.setpwd.notmatch":`Due password non sono coerenti`,
"label.tabpage.include":``,
"front-email-payment-thanks":`Grazie`,
"vue_label_help_helponthispage":`Aiuto su questa pagina`,
"label.approvepagelayout":`Layout della pagina di approvazione`,
"vue_lightning_help_zero_distance_communication":`Il supporto online vi aiuterà a risparmiare tempo contattando gli esperti del servizio CloudCC a distanza zero.`,
"vue_label_normal_case_sf":`Caso`,
"label.report.line.tuozhuai":`Si prega di trascinare e rilasciare, o fare doppio clic per selezionare la colonna del rapporto e regolare i loro ordini`,
"template.dashboard.management":`Gestione delle operazioni`,
"label.customcomponent.params.info.n1":`Il valore "args" di "args" nel tag "component" è in formato "json", per esempio: args="name:'zhang',age:26", Nel blocco di codice cc, usate: String myName = name; int myAge = age;`,
"lable.SalesCommitmentKanBan.signedCommitmentRate":`Tasso di impegno firmato`,
"label.add.status":`Aggiungere lo stato`,
"label.loss.customers":`Chiuso / Conto perso`,
"vue_label_chatter_involving_me":`Coinvolto`,
"label.update.input":`Si prega di correggere l'input`,
"label.import.step1.commonobj":`Oggetti generali`,
"label.appupload.upload.tips.document":`Nota: i documenti nelle "cartelle personali" e nelle "cartelle rosse dei modelli" non possono essere aggiunti al pacchetto, né possono essere visualizzati in questa lista.`,
"label.appupload.install.complete":`Completa`,
"label.console.edit":`Modifica della console`,
"setup.object.field.dependency.label.removefromlist":`Rimuovi i valori selezionati`,
"label.textmessage.groupsms.no.phone":`Nessun telefono`,
"label.account.Current.and.NextFQ":`Attuale e prossimo FQ`,
"label.sso.saml.sp.idtype.userid":`L'asserzione contiene l'ID utente dall'oggetto User`,
"label.data.import.setup.operate.update":`Aggiornare i record esistenti, non inserire nuovi record`,
"front-kefu-moudle-v1-jcaws-call-serve":`Call Center integrato con AWS (Amazon Web Service) per fornire servizi SaaS più completi`,
"label.version.bacheditordel":`Modifica/cancellazione/trasferimento di massa`,
"lable.even.higher":`Più alto`,
"label.datetime.error":`Il formato della data non è corretto`,
"vue_label_commonobjects_detail_customer_hierarchy":`Gerarchia dei clienti`,
"label.startuploadfile":`Iniziare il caricamento`,
"label.appointment.wizard.subtitle3-1":`Lunedì`,
"label.weixin.relevance":`Opportunità associata`,
"label.datamanage.field.mapping.information":`Impostazione della mappatura dei campi`,
"label.brief.lastweek":`La settimana scorsa`,
"label.nextstep":`Prossimo passo`,
"label.listtoshow":`Un elenco dei processi di approvazione attivi e inattivi per {0} è visualizzato di seguito.`,
"label.partner.ishave":`Errore: il dominio esiste già`,
"label.service.miniProgram.name":`Si prega di compilare il nome.`,
"label.view.filterbyaddition":`Filtra per campi aggiuntivi (opzionale):`,
"label.projectManagement.nodata.task":`Nessun record per i compiti. Aggiungiamo informazioni sui compiti!`,
"label.chooseemailtemplate":`Seleziona il modello di e-mail`,
"label.page.step4.add.profile":`Passo 4 Aggiungere ai profili`,
"label.ems.mailtype":`Tipo di posta`,
"label.weixin.no.pending.projects.vg":`Buon lavoro, nessuna voce in attesa di approvazione`,
"label.tabpage.saveviewfailed":`Visualizza salvataggio fallito`,
"label.chat.file.upload.cancel":`Annulla il caricamento`,
"com.cloudcc.login.error.message.notenabled":`Il tuo id non abilitato`,
"label.data.import.setup.operate.insertandupdate":`Aggiornare i record esistenti e inserire nuovi record`,
"label_target_type":`Tipo di obiettivo`,
"label.notification.event2":`【被分配人】 visualizzato l'evento che hai assegnato`,
"chatter.feed.menutype.feed.news":`Cosa seguo`,
"label.import.page1.suitedwayofcustomer":`Stile abbinato al cliente`,
"label.import.page2.CloudCCfiled":`Campo CloudCC`,
"label.custom.quarter.start":`Data di inizio del trimestre personalizzato`,
"label.page.including.tab":`Comprese le schede`,
"label.mobile.phone.day.plan2":`Oggi`,
"template.report.lead.conversion.statistics":`Statistiche di conversione dei lead`,
"label.show.type":`Tipo di display`,
"label.weixin.no.pending.wdgz.qin.week":`Nessun lavoro previsto per questa settimana.`,
"2018UI.Homepage.DataDeleted.Info":`I dati che vuoi visualizzare sono stati cancellati, clicca per tornare al passo precedente.`,
"label.vlidaterule.message":`Messaggio di errore`,
"label.approval.remark":`Parere di approvazione`,
"label.field.duplicate1":`Unico`,
"label.batchtransfer":`Trasferimento di massa`,
"label.quickbooks.view.allinvoices":`Tutte le fatture`,
"vue_label_commonobjects_detail_lead_selectedstatus":`Segna come stato attuale`,
"label_home_page_source":`Si prega di selezionare la fonte dei dati.`,
"front-kefu-moudle-v1-opencall-please":`Abilita il call center e poi imposta`,
"setup_layout_label_asc":`Ascendente`,
"label.use_tikect":`Usare il biglietto d'ingresso?`,
"label.tag.setup":`Impostazioni dei tag`,
"label.existinglayout":`Layout di pagina esistente`,
"label.productsales.today.noevt":`Non ci sono eventi aperti.`,
"message.error.view.date.validerr":`Inserisci il formato di data valido (YYYY-MM-DD、MM/DD/YYYY) o i caratteri speciali della data`,
"label.mr.descreption.oneGroupReData3":`ha a che fare con il`,
"label.tianyancha.businessverify.msg1":`Con la funzione di verifica dei dati commerciali abilitata, gli utenti devono leggere attentamente e comprendere appieno i termini del presente "contratto di licenza d'uso" (di seguito denominato "contratto"), compresa l'esenzione da responsabilità di beijing shenzhou yundong customer co., ltd. (di seguito denominata "CloudCC") e le restrizioni del diritto dell'utente. si prega di leggere attentamente e scegliere di accettare o meno questo accordo.`,
"label.custom.CQ":`Quartiere personalizzato`,
"label.version.custom.dashboard":`Cruscotti standard (pagina personalizzata)`,
"vue_label_commonobjects_detail_dragtoupload":`Trascina il tuo file qui, o <em>clicca e carica</em>`,
"label.tabpage.addadvancedoptions":`Aggiungere opzioni avanzate`,
"front-kefu-moudle-v1-Launch-page":`Pagina di atterraggio:`,
"label.emailobject.tabname":`Email`,
"label.weixin.addmore":`Aggiungi altro`,
"message.error.view.operator.validerr":`Operatore non valido`,
"label.another_page":`Reindirizzare ad un'altra pagina`,
"label.reportTypeFocusD2":`Esempio: Se si fa il reporting su "Contatti con opportunità con partner", selezionare "Contatti" come oggetto primario.`,
"label.icon.47":`Barometro`,
"label.task.today":`Oggi`,
"label.service.gantt.weekend.highlight":`Evidenziare il fine settimana`,
"label.customcomponent.referencetagname":`Nome della scheda`,
"label.senderemail":`Indirizzo e-mail del mittente`,
"label.defaultvalue":`Valore predefinito`,
"label_tabpage_Sdfez":`giorni`,
"pagecreator.page.label.pagename":`Nome della pagina`,
"vue_label_report_pagenumber":`Numero di pagina nell'intervallo`,
"label.emailsync.connectaccount.description":`Aggiungi qui la tua casella di posta personale, e il CloudCC abbinerà automaticamente i lead e i contatti nel sistema in base ai loro indirizzi e-mail, sincronizzando il contenuto delle e-mail ai record per facilitare il monitoraggio e la comunicazione.`,
"label.schedulableprg.chooseweek":`Seleziona la data di ogni settimana`,
"lable.edit.queue.membercanuse":`Membri disponibili`,
"lable.Quick.find":`Sguardo rapido`,
"label.daynuminmonth":`Giorno(i) del mese(i)`,
"message.error.state":`non può essere vuoto!`,
"label.introduction.the.form":`Descrizione`,
"label.batchtransfer.pleaseselectcomefromuser":`Trasferimento da`,
"front-dashboard-module-implemented":`Realizzato`,
"label.custombutton.newerror":`Nuovo creato fallito`,
"label.version.allow.size":`Se necessario, si prega di aggiornare la versione di CloudCC.`,
"label.weixin.account.loginpage":`Pagina di accesso alla sicurezza dell'account`,
"message.pleaseselectfieldtype":`Seleziona il tipo di campo`,
"component.setup.label.parentobject":`Oggetto superiore`,
"System.TAB.SeeViewAmount":`Visualizza i totali`,
"label.event.lastmonth":`Ultimo mese`,
"label.taskrecordtype":`Tipi di record di attività`,
"label.layout.selectedpages":`Pagine selezionate`,
"label.appointmentdetail.wizard.title19":`Piano del sabato`,
"label_chatter_endData":`Data di fine`,
"label.appupload":`Pacchetti`,
"label.knowledgebase.article.link":`Articolo collegato`,
"label.licence.enddate":`Data di scadenza`,
"chatter.fieldtrack.record":`record`,
"label.reportsSubscriptionPage.schedulereport.weekly":`Settimanale`,
"label.forecast.editshrepage.title2":`Condivisione Modifica`,
"label.attendance.onwork.time":`Inizio della giornata`,
"label.appointment.wizard.subtitle1-8":`3 h`,
"pagecreator.layout.button.upload":`Carica il layout`,
"label.input.notless.than.number":`Inserisci un numero maggiore o uguale a {0}`,
"setup.mainpage.label.welcome13":`Istruzioni: Clicca sul menu in alto → Rapporti → Nuovo`,
"label.forecast.settings.data.opp":`Data di chiusura dell'opportunità`,
"vue_label_display_checkbox_field":`Mostra i campi delle caselle di controllo`,
"label.summaryreport.2018.step5":`Passo 5 Seleziona il tipo di grafico e l'elemento da evidenziare`,
"front-lightning-module-v1-dashborad-one-statistic":`Scegliere almeno un valore statistico e un tipo di statistica`,
"label.home.standard.dashboard.forcase":`Non sei autorizzato a fare previsioni e non puoi visualizzare il cruscotto degli impegni di vendita.`,
"page.field.track":`Storia della tracciabilità sul campo`,
"label.dataimport.format.datetime.error":`Errore di formato, si prega di utilizzare yyyy/MM/dd HH:mm:ss o yyyy-MM-dd HH:mm:ss.`,
"lable.opppdt.selPbk.title":`Scegli il prezzo Prenota`,
"pagecreator_systemstyle_label_stylename":`Nome dello stile`,
"label.projectManagement.nodata.project":`Nessun dato correlato. Perché non creare progetti relativi a me?`,
"label.start_below":`Inizia a condividere il tuo modulo con i contatti. Il tuo modulo è stato pubblicato in modo sicuro e pronto all'uso all'indirizzo web qui sotto.`,
"label.campaignmember.main.delete":`Rimuovere in massa i membri della campagna`,
"label.modifyall":`Modifica tutto`,
"label.homepage":`Pagina iniziale`,
"vue_label_pool_adoptedbyme":`Ho raccolto`,
"label.email.clearItem":`Solo le e-mail senza elementi associati vengono cancellate.`,
"label.callcenter.login.Amazon.connect":`Accedere ad Amazon Connect`,
"label.import.page1.selectimportfiled":`Selezionare il file da importare`,
"message.error.id":`L'id non può essere vuoto!`,
"label.ggReleaseRange.searchUsers":`Cerca utente partner`,
"label.changemypwd":`Cambiare la mia password`,
"label.ccpeak.reference.parameters":`I parametri che possono essere direttamente referenziati sono:`,
"chatter.share.success.tip":`Successo! hai condiviso questo post a`,
"label.message.checkfailed":`Controllo della sintassi fallito, il nome della classe esiste.`,
"label.shangqing.introduction":`Integrare e analizzare i recenti eventi caldi dei lead o dei clienti per aiutare i venditori a capire i clienti in modo più completo`,
"label.allemailnotice":`Tutti gli avvisi e-mail`,
"vue_label_report_copy":`Copiare il rapporto`,
"label.exchange.sync.state.setting":`Impostazioni di configurazione`,
"label.merge.result.error1":`Il seguente record è bloccato, e nessuna operazione di "merge" è permessa`,
"label.process.des":`Clicca sul link a sinistra per visualizzare i dettagli del record corrente.`,
"label.textmessage.vonage.create.lead.setting":`Creare nuovi lead quando si riceve un testo da numeri non presenti nel sistema`,
"label.views":`Visualizzazioni`,
"label.notification.tip1":`Nessuna notifica`,
"label.forecast.detailforecast.returnforecast":`Torna a Previsioni`,
"label.knowledgebase.target.framework.name":`Nome del telaio di destinazione`,
"label.brief.close.opportunities":`Closed-Win`,
"label.appointment.wizard.subtitle4-2":`Il tempo più breve per notarti`,
"vue_label_systemSettings_set_record":`Impostare la modalità di dispaly della lista correlata, provando a passare dalla modalità scheda alla modalità lista.`,
"pagecreator_page_message_publish_fail":`Pubblicazione della pagina non riuscita`,
"vue_label_homepage_name":`Nome della pagina iniziale`,
"label.weixin.no.pending.wdgz.qin.month":`Non hai nessun programma questa settimana.`,
"label.campagin.register.page":`Pagina di registrazione dei membri della campagna`,
"label.campaign.channel.edit":`Modifica del canale di marketing di Campaigns`,
"label.folder":`Cartella`,
"label.umeng.chatter.follow":`ti ha seguito.`,
"label.sso.theKeyToEdit":`Modifica della chiave`,
"label.deletelayout":`Cancellare i layout di pagina`,
"label.same.analyze.miaoshu":`La relazione tra le condizioni di cui sopra è: "Opportunity Name" o "Account Name" o ("Contact Mobile" e "Contact Email");`,
"label.ccpeak.sel":`Classi in questa cartella`,
"label.tabpage.addtoworkbench":`Aggiungi alla homepage banco di lavoro`,
"label.forecast.shrepage.classdes.r":`Sola lettura - L'utente può leggere i dati di previsione.`,
"homepage.custompagename":`Nome personalizzato della homepage`,
"label.sendemail.batchapprovalinfo":`Ciao #name:\r\n l'operazione di approvazione del lotto che hai eseguito ha avuto successo, con un totale di #successnum approvato con successo e #errornum fallito.`,
"front-email-payment-Invoice-alipay-describe":`Pagamento sicuro e affidabile`,
"setup.object.field.dependency.label.configured":`Layout di pagina assegnati al profilo`,
"label.potentialcustomers":`Porta`,
"label.timetrigger.button":`Il pulsante Add time trigger non è disponibile nei seguenti casi:`,
"label.category.10":`Avvocato`,
"label.selectall":`Seleziona tutto`,
"message.field.id.not.null":`Il campo ID non può essere vuoto.`,
"CloudCCCRM.ST.Info.TypeIn.001":`Si prega di inserire`,
"label.author":`Autore`,
"label.import.step1.csvonly":`1. Solo il file in formato csv è supportato, e fino a {recordnumlimit} i record possono essere importati per una volta. Fino a 2.000 record possono essere importati se è necessario eseguire il trigger. I record che superano il limite saranno automaticamente ignorati dal sistema. Se volete importare più dati, divideteli prima in più file e importateli in tempi diversi. .`,
"label.assignment.setup.newrule.name":`Nome della regola`,
"label.campaignmember.selectmember.chosestatusdesc":`Seleziona la campagna a cui vuoi aggiungere membri e modifica lo Stato membro della campagna. Crea una nuova campagna, devi uscire da questo processo.`,
"label_tabpage_operation":`Operazione`,
"label_tabpage_datatyoez":`Tipo di dati`,
"UG_product_04":`Creare il prodotto`,
"label_emailtocloudcc_step1_case2":`Una volta configurato, le mail ricevute in questa casella di posta saranno automaticamente registrate come record di caso in CloudCC. In base al contatto e all'account corrispondente alla casella di posta, metti in relazione il caso con il contatto e l'account corrispondente, in modo da facilitare l'accettazione e il monitoraggio dei casi.`,
"workflow.action.tasks.assignortype.role":`Ruolo`,
"vue_label_notice_refreshi_success":`Aggiorna con successo`,
"label.notification.arketsea.abandon":`{5} scartato {2} {0}：{1}`,
"label.icon.36":`Computer`,
"chatter.group.cancelToJoin":`Annullare per aderire`,
"label.publicgroups.edit":`Modifica gruppo pubblico`,
"message.duplication.label.letternum":`Bit di caratteri corrispondenti`,
"label.brief.lost.opportunities":`Perso`,
"setup.layout.label.nofield":`Nessun campo disponibile`,
"label.dataimport.isSharingRule":`Applicare le regole di condivisione`,
"vue_label_opportunity_contactrole_synctocontacts":`Sincronizzare le informazioni ai contatti`,
"attachment_button_massdownload":`Scaricare in massa`,
"label.weixin.agreement.remark":`Questo servizio WeChat è lo strumento di aiuto del servizio di consulenza di Aid-Max ai clienti, non è la base definitiva per le compagnie di assicurazione per regolare i reclami, e i reclami dei clienti dovrebbero essere regolati secondo i requisiti acturali delle compagnie di assicurazione.`,
"label.partnerCloud.basicSetting.introTwo":``,
"pagecreator_layout_funcpath":`/ costruttore / libreria di layout`,
"label.ccdocument.online.edit":`Modifica online del documento`,
"label.partner.setup.Enable":`Verifica`,
"label.log.state":`Stato dell'azione`,
"label.lower.bound":`Limite inferiore`,
"label.timezone.isenable":`Abilita il fuso orario multiplo dell'utente, poi permette all'utente di impostare il fuso orario e di visualizzare la data/ora in base al fuso orario dell'utente.`,
"label.martrixreport.setrowtitle":`Specificare le intestazioni di colonna`,
"label.bottom":`In basso`,
"label.multilang.ccchat.groupnotcontainsname":`Non sei membro di nessun gruppo di campagne che ha {0} nel suo nome`,
"label.step1.of.step5":`Passo 1 di 5`,
"message.report.error.FieldListIsAmbiguous":`C'è una formula archiviata a cui si fa riferimento nel rapporto, che causa un'eccezione, si prega di rimuovere l'archivio:&nbsp;`,
"label.monitorsys.operator.ip":`IP`,
"ccchat.fieldtrack.fieldchange":`Cambia da {0} a {1}`,
"label.report.export.print.content":`Esportazione delle intestazioni del rapporto corrente, dei gruppi e dei primi 2000 record`,
"message.thanksusing":`Grazie per aver usato CloudCC.com`,
"label.reportexport.allobject":`Esportare tutti gli oggetti`,
"label.projectManagement.working.hours.per.day":`Orario di lavoro giornaliero`,
"label.partnerCloud.financeSetting.enterCollaborator":`Si prega di inserire l'ID del cooperatore`,
"label.defineReportRecords":`Definire l'insieme dei record del rapporto`,
"greate":`maggiore di`,
"label.sure_discard":`Sei sicuro di rinunciare ai cambiamenti?`,
"label.escalation.setup.newaction.notifyowner":`Notifica al proprietario del caso`,
"label.icon.28":`Cappello da medico`,
"lable.PowerProcess.see.page":`Visualizza le pietre miliari`,
"message.error.object.relogin":`Login fallito, per favore prova ad accedere di nuovo`,
"label.chatter.activity":`Attività`,
"label.query.clone.detail.choose.canChoose":`Voci disponibili`,
"chatter.using.object":`Abilita il tracciamento dei feed per gli oggetti in modo che gli utenti possano seguire i record di quel tipo di oggetto. Seleziona i campi da tracciare in modo che gli utenti possano vedere gli aggiornamenti del feed quando quei campi vengono cambiati nei record che seguono.`,
"UG.opportunity.001":`Come controlla le sue vendite?`,
"label.ServiceCloud.fuwuziyuan.distributionMap":`Mappa di distribuzione delle risorse di servizio`,
"vue_label_email_current_email":`L'inserimento di questo modello sovrascriverà l'email corrente`,
"label.h5.approval.page.layout":`È possibile impostare il layout della pagina di approvazione: <br>Setup>Create>Workflow&Approval>Approval Processes<br>selezionare il processo di approvazione, cliccare sul nome dell'approvazione<br>cliccare Edit>Set the Approval Page Layout`,
"component.hots.label.title":`Offerte calde`,
"mail.foldername.notOnly":`Questo file esiste già`,
"label.customer.tab.step1":`Passo 1 Inserire i dettagli`,
"label.delete.persion":`Soppresso da`,
"chatter.changed0":`Cambia {0} da {1} a {2}`,
"homepage.components.type":`Tipo di componente`,
"label.norfolk.isiands.time":`Tempo di Norfolk`,
"label.product.pricebooks.view":`Visualizzazioni del libro dei prezzi`,
"label.forecast.customforecast.director":`Subordinati diretti`,
"label.emailtocloudcc.step3total3":`Passo 3 di 3`,
"label.cloudccsite.end":`Home page del sito inattivo`,
"label.login.verification.mfa.device":`Verificare il dispositivo MFA virtuale`,
"chatter.follow":`Segui`,
"label.month's":`Mese`,
"label.sendmail.step1.introduce":`Seleziona una vista qui sotto che contiene i destinatari da includere in questa e-mail.`,
"label.shangqing.title":`Impostazione delle informazioni aziendali`,
"label.rejectrecords":`Dischi rifiutati`,
"label.selectupdatevalue":`Valore che cambia da`,
"vue_label_pricebook_disabled":`Il listino prezzi è disabilitato`,
"component.chatter.label.title":`Ultimo messaggio`,
"label.partner.all.workspace":`Spazio di lavoro`,
"label.querydetailservice.delete.message":`Dati cancellati o inesistenti.`,
"label.objectRelationshipWithout":`con o senza registrazioni correlate`,
"nocontain":`non contiene`,
"label.partnerCloud.financeSetting.accountSettings":`Impostazione del fondo per i partner`,
"label.file.sharetype.owner":`Proprietario`,
"label.open.multilingual":`Abilitare il multilingue`,
"label.searchresult.field":`Campi del risultato della ricerca`,
"label.tabpage.selectdate":`Seleziona una data`,
"label.h5.logouting":`Disconnettersi`,
"label.quickbooks.fieldlabel.payment":`Pagamento`,
"label.chatter.leaveword":`Commento`,
"label.customfields.majoranddetailrelation.tip":`Crea una relazione speciale genitore-figlio tra questo oggetto (figlio o dettaglio）e un altro oggetto (genitore o master), dove: <br>● i campi della relazione per tutti i record di dettaglio devono essere compilati. <br>● Una volta che il valore del campo relazionale è salvato, non può essere cambiato. </li><br>● la proprietà e la condivisione del record di dettaglio è determinata dal record master. </li><br>● quando l'utente cancella il record principale, tutti i dettagli vengono cancellati. </li><br>● è possibile creare campi riassuntivi cumulativi sul record master per riassumere i record di dettaglio. </li><br>● Il campo relazione permette all'utente di cliccare sull'icona trova per selezionare un valore dalla lista pop-up. L'oggetto primario è la fonte del valore nella lista. "`,
"label.batchapproveorrefuse":`Approvare/Rifiutare in massa`,
"label.copy.success":`Copiare con successo`,
"vue_label_show_record_count":`Mostra il conteggio dei record`,
"label.ems.delete.false":`Non è riuscito a cancellare`,
"label.new.Product.Goals":`Obiettivo del nuovo prodotto`,
"label_chatter_BCC":`Bcc (copia di cortesia cieca)`,
"label.knowledgebase.data.archived.successfully":`archivio dati {a} con successo`,
"label.chuangming.title":`Chuang Ming SMS`,
"label.notification.arketsea.recovery":`Il tuo {0}:{1} è stato riciclato a {2} da {5}`,
"label.partnerCloud.orderingPlatform.paymentAmount":`Importo del pagamento:`,
"label.martrixreport.2018.step5.new":`Passo 5 Selezionare i criteri del rapporto`,
"label.testing":`Controllo...`,
"chatter.poll.option4":`Scelta 4`,
"lable.outlook.detail.otc":`Scambio a CloudCC.com`,
"label.startuploadfile.batch.step2":`Passo 2 Fare clic sul pulsante "start upload", caricare i file`,
"lable.outlook.edit.outdes":`Inserisci i campi personalizzati che hai già creato in Exchange. Prima di mappare questo campo personalizzato di Exchange in un campo CloudCC.com, CloudCC.com verificherà l'esistenza del campo di Exchange alla prima sincronizzazione.`,
"hour":`Ora`,
"label.appointmentpage.wizard.notif4":`Formato e-mail non valido`,
"label.import.index.state":`Stato`,
"label.integrations.mailchimp.massage6":`I dati selezionati mostrati nella pagina corrente potranno essere esportati nella tua lista Mailchimp`,
"label.file.share.email.subject":`#sharedBy ha condiviso un file con te su #orgname`,
"label.assignment.setup.newentries.noassignment":`Non riassegnare il proprietario`,
"label.dashboard.unit1":`Unità: 10,000`,
"label.forecast.customforecast.foretype.commit":`Impegnato`,
"label.type":`Tipo`,
"label.partner.workspace.login.logo":`Logo dell'intestazione`,
"pagecreator_systemstyle_button_edit":`Modifica stile`,
"label.displaytype2":`Pulsante della pagina dei dettagli`,
"email.one":`Caro utente: \n Benvenuto in CloudCC. Hai richiesto di reimpostare la tua password a {!operatetime}, per favore effettua il login con il codice di verifica qui sotto entro 15 minuti: \n Codice di verifica casuale: {Clicca sul link qui sotto per resettare la tua password: \Importante: se non l'hai richiesto, o pensi che questo messaggio non debba raggiungerti, contatta immediatamente il tuo amministratore!`,
"label.partnerCloud.orderingPlatform.unavailable":`Nessun prodotto disponibile`,
"vue_label_email_save_the_signature_successfully":`Salva la firma con successo`,
"label.reportsSubscriptionPage.email.detailed":`Dettagliato`,
"chatter.group.query":`Interrogare`,
"label.translation.unsupported.format":`Formato non supportato, supporto all'importazione multilingue solo per il formato di proprietà`,
"message.operateexception":`Prompt(Contatta il tuo amministratore).`,
"label.sendemail.chat.praiseFeedcomment":`Caro #nome:\nell'attesa! A #nomeUtente è piaciuto il tuo commento (#href).`,
"label.recycle.clearmy":`Svuota il tuo cestino`,
"label_tabpage_choose":`Seleziona`,
"#label.importstep2tip":`Se vuoi caricare più di un file, puoi comprimere tutti i file insieme e importarli.`,
"label.batchedit":`Mas Modifica`,
"label.integrations.mailchimp.export":`Esportazione a Mailchimp`,
"label.cloudccsite.name":`Nome del sito`,
"serviceterritory.serviceappointment.iscontain.contain":`Non è possibile eliminare il territorio di servizio perché è associato a un appuntamento di servizio. È possibile disattivare questo territorio di servizio.`,
"label.sum":`Somma`,
"setup.mainpage.label.welcome29":`Integrazione API standard con prodotti di terze parti`,
"label.tabpage.nothingz":`Niente`,
"label.weixin.actual.contract.jine":`Importo effettivo del contratto`,
"label.tabpage.emailaddressz":`Da? Indirizzo`,
"label.dashboard.unit4":`Unità: 10 milioni`,
"label.dashboard.data.labels":`Etichette di dati`,
"label.import.page2.oneonone":`Un campo CloudCC può corrispondere solo a campi in un file.`,
"homepage.components.name":`Nome dei componenti`,
"template.report.task.theme":`Compito Soggetto`,
"component.setup.label.setupsaveok":`Impostazioni del componente salvate con successo`,
"front-epwechat-module-v1-add-selfapp":`Aggiungi App creata da Sefl`,
"label.to.save.the.current.page.information.button.":`Se vuoi salvare le informazioni della pagina corrente, clicca su "Quick Save".`,
"vue_label_file_not_support_preview":`Il file non supporta l'anteprima, si prega di scaricare e visualizzare`,
"label.object.reached.limit":`Il numero degli oggetti che puoi creare raggiunge il limite superiore.`,
"label.partnerCloud.basicSetting.online":`Attivare il pagamento online`,
"label.app.step1.error.nameexist":`Questo nome di gruppo esiste già o è stato usato in precedenza. Per favore scegli un nome diverso.`,
"label.workflowandapprove":`Flusso di lavoro e approvazioni`,
"label.recordtypeselect.change.tip":`Quando si cambia il tipo di record di un record, i valori della picklist esistenti non cambiano automaticamente. Si raccomanda di aggiornare i valori della picklist esistente del record nello stesso posto.`,
"label.summaryreport.step6":`Passo 6 Selezionare i criteri del rapporto`,
"Pagelayout.Setup.004":`Si possono impostare fino a 4 campi`,
"label.file.attached":`Allegato`,
"front-invoice-online-payment-setup-configure":`Fare clic su "Configura ora", Configura l'interfaccia di pagamento {nome}.`,
"label.approvaldatamove.submitdate":`Data di presentazione`,
"label.emailobject.time.from":`Da:`,
"label.dataimport.insertdata.error.fieldrepeat.insert":`Il campo $schemefield_name$ nel record esiste già nel database e non viene più inserito. Il record è stato ignorato all'importazione.`,
"assetbom.copy.notpermission":`Non hai l'autorità per clonare la distinta dei beni. Contatta l'amministratore.`,
"lable.outlook.mcto.autoallocation":`Assegnateli automaticamente ai record CloudCC.com correlati.`,
"label.dataimport.but.datalength":`ma la lunghezza dei dati è`,
"label.setuserstocommit":`Usando le opzioni sottostanti, specificare quali utenti sono autorizzati a presentare la richiesta iniziale per l'approvazione.`,
"component_telerecord_label_related":`Articoli correlati`,
"front-lighting-module-v1-detail-file-lockInfo":`Il record è bloccato e non è disponibile per l'aggiunta di file. Contatta l'amministratore per sbloccarlo.`,
"pagecreator_layout_button_edit":`Modifica del layout`,
"label.app.step3.tabcanuse":`Schede disponibili`,
"label.ems.delete.sure":`Sei sicuro di voler cancellare le informazioni di questo account e-mail?`,
"label.email.show":`Mostra`,
"label.checkbox.unchecked":`Unselected`,
"message.error.operation":`Errore di funzionamento, si prega di contattare l'amministratore.`,
"label.template.set.folder.only.upload.type.file":`Le cartelle segnate in rosso nel modello possono essere usate solo per caricare file del tipo Word, Excel e PPT.`,
"label.knowledgebase.select.publish.status":`Scegli uno stato di pubblicazione`,
"label.recordtype.tabname.edit":`Inserisci il nuovo nome per il tipo di record selezionato e poi clicca su "Salva".`,
"label.tabpage.exportview":`Vista dell'esportazione`,
"label.dataimport.insert.sharetab":`Impossibile inserire il modulo di condivisione`,
"vue_label_dashboard_penetrateto":`Penetrare in`,
"label.weixin.group.member":`Personale`,
"vue_label_systemSettings_customadd":`Estensione personalizzata`,
"UG_Account_03":`Controllare e unire proattivamente i conti duplicati`,
"label.singapore.standard.time":`Ora solare di Singapore`,
"label.weixin.captcha":`Codice di verifica`,
"Account_News_Setting_004":`Abilitare le notizie`,
"label_emailtocloudcc_select1":`Si prega di scegliere`,
"label_ring_ratio":`Mese per mese`,
"label.industrialandcommercialverification.button.save":`Salva`,
"label.approvalstep5.tip":`La pagina di approvazione è dove l'approvatore effettivamente approva o rifiuta la richiesta. utilizzare le seguenti opzioni per selezionare le proprietà di modifica dei campi da visualizzare in questa pagina.`,
"label.import.page1.maxrecord{{30000}}":`1. Puoi importare {{30000}} record una volta`,
"setup_object_layout_label_profileoptions":`Profili disponibili`,
"label.emailtemplate.type":`Tipo di modello`,
"label.searchlayout.tab.field":`Campi visualizzati nella pagina iniziale della scheda.`,
"chatter.news":`Messaggi`,
"label.pw.small.letter":`Minuscolo`,
"label.notification.group3":`La tua domanda di adesione al gruppo pubblico è stata rifiutata`,
"label.ccchat.day.before.yesterday":`L'altro ieri`,
"component.chatter.post.label.title":`Pubblica`,
"label.tianyancha.type":`Tipo di rappresentante legale`,
"label.detail.searchlayout":`Visualizza layout di ricerca`,
"vue_label_pool_deleteconfirm":`Sei sicuro di voler cancellare il (1) record selezionato?`,
"label.import.index.maxmb{{100}}，maxitem{{30000}}":`1. Supporta solo i file in formato csv, il supporto massimo è di {{100}}mb, e un massimo di {{30000}} record può essere importato una volta sola; si prega di dividere in più file e importarli in fasi se il limite viene superato,`,
"label.h5.similar.opportunity.lookup":`Trova opportunità simili`,
"template.report.customer.list.opportunity":`Lista dei conti con più opportunità`,
"component_setup_iframe_label_memo":`Cliccate sull'icona delle impostazioni e inserite l'indirizzo dell'url incorporato.`,
"label.version.allemail":`Email di massa`,
"lable.product.editp":`Modifica del prezzo`,
"label.weixin.plate.number":`Numero di targa`,
"font-evaluate-module-v1-disabled-successfully":`Disattivata con successo l'opzione di valutazione "Neutrale".`,
"label.multilingual.tip1":`Usa questa pagina per definire la lingua della tua organizzazione.`,
"label.japan.standard.time":`Ora solare del Giappone`,
"lable.product.notdel.use":`Elimina i tentativi, perché è ancora associato ai seguenti record.`,
"label.appointment.wizard.subtitle4-2-4":`4 h`,
"label.queue.edit":`Modifica`,
"label.partnerCloud.financeSetting.informationTwo":`2. Nel Merchant Center, fare clic su Gestione account  Gestione commercianti  Prodotto PIDIKEY  Gestione chiave segreta`,
"label.partnerCloud.partnerOrdering.permission":`Permesso di ordinazione del partner`,
"vue_label_commonobjects_detail_company_hierarchy":`Gerarchia aziendale`,
"label.forecast.settings.sl":`Quantità`,
"label.partner.workspace.tab.memo":`Selezionare le schede per questo cloud partner. Si possono selezionare schede standard o schede personalizzate.`,
"label.mr.mainRecord":`Record principale`,
"setup_mainpage_label_welcome20":`Posta, modello SMS`,
"front-email-payment-select-date-tips":`Si prega di scegliere YY`,
"label.dependencelisttag":`Etichetta dell'elenco correlato`,
"label.umeng.activity.eventof":`evento di`,
"label.sales.dashboard.collection":`Obiettivo delle entrate`,
"report_label_folder":`Cartelle`,
"label.assignment.setup.newentries.step1":`Passo 1 Impostare l'ordine in cui questa voce di regola sarà processata`,
"label.quote.shrname":`Nome del destinatario`,
"label.newreport.group.sum":`Il numero di raggruppamenti`,
"label.number.MinCheck":`Il minimo di {a} è {0}. Modifica la quantità e salva le modifiche.`,
"label.chatter.save":`Salva`,
"vue_label_email_all_email_templates":`Tutti i modelli di e-mail`,
"message.summaryconditionnototal":`La condizione di condizioni riassuntive non può usare i campi Roll-Up!`,
"label.callboard":`Annunci`,
"label.step2.total5":`Passo 2 di 5`,
"vue_label_homepage_custom_homepage_page":`Home page personalizzata`,
"label.data.newtemplate.e_seltype":`Selezionare il metodo di esportazione dei dati`,
"label.data.dataexpalltype.all.desc2":`2. Ci vuole un po' di tempo per esportare tutti i dati. Quando l'esportazione è completa, riceverai una e-mail di promemoria che l'esportazione dei dati ha avuto successo.`,
"lable.account.CalenderYear":`Anno del calendario`,
"message.error.data":`I dati passati non possono essere vuoti, controlla i parametri passati`,
"label.from_user":`Da utente`,
"label.parentdepartment":`Dipartimento superiore`,
"template.dashboard.product.analysis":`Analisi dei prodotti`,
"label.tabpage.unpacketz":`Nessun dato di raggruppamento disponibile!`,
"label.icon.107":`Comunicazione`,
"label.monitorsys.operator.username":`Utenti`,
"label.serchreport":`Rapporti di ricerca`,
"label.payment.upgrade":`Aggiornare`,
"setup_layout_button_ok":`Confermare`,
"label.please.select.channel":`Si prega di selezionare il supervisore del canale.`,
"template.chart.txdrw":`Promemoria dell'attività`,
"chatter.group.accept":`Accettare`,
"pagecreator_systemstyle_message_canntdelete":`Lo stile attuale non può essere cancellato`,
"label_tabpage_ctbtsftcz":`Clicca sul retro per cercare il contenuto`,
"label.datamanage.select.accountfield":`(Selezionare i campi corrispondenti al conto importato)`,
"label.schedulejob.setup.list.title":`Lavori programmati`,
"label.visualpage_list.title":`Accesso alla pagina personalizzata attiva`,
"label.mr.selectTwoData":`Seleziona almeno due record da unire.`,
"label.customer.tab.step2.different":`Applicare una diversa visibilità delle schede per ogni profilo`,
"label.mobile.side.tab.can":`Disponibile`,
"label.log.url":`URI`,
"label.weixin.cloudccnumber.isgoon":`L'account CloudCC è stato vincolato, se si continua, WeChat che precedentemente era legato a questo account CloudCC non sarà in grado di utilizzare il sistema micro CloudCC. Vuoi continuare?`,
"label.applet.to.case":`Miniprogramma Portale del servizio clienti`,
"lable.outlook.detail.cmaping":`Mappa Campi di contatto`,
"label.theUserActiveTime":`Periodo attivo dell'utente`,
"label.event.moveup.9hour":`9 ore avanti`,
"vue_label_pool_other":`altro`,
"label.fieldname":`Nome del campo`,
"vue_label_notice_add_success":`Aggiunto con successo`,
"label.conditiontag.lookup.insertbutton":`Inserisci Selezionato`,
"label.identifying":`Identificazione`,
"label.tabpage.uploadingz":`Caricamento di`,
"label.view.introduce":`Modifica Vista`,
"vue_label_dashboard_sortingmethod":`Si prega di selezionare il metodo di smistamento`,
"label.quote.number.introduce":`Inserite il numero di e gli sconti e cliccate su Salva.`,
"front-kefu-moudle-which-missphone-case":`Creare casi per i quali le chiamate sono state perse`,
"label.sendemail.chat.response":`Risposta di CCChat:`,
"label.productsales.refreshTime":`Ultimo aggiornamento`,
"lable.SalesCommitmentKanBan.phase":`Fase`,
"label.version.sum.object":`oggetto(i)`,
"label.defineReportStep2":`Passo 2`,
"message.duplication.label.returnDuplications":`Torna alla lista dei filtri di duplicazione`,
"label.lookover":`Vedi`,
"label.quickbooks.button.copy2":`Copiare i dati di CloudCC in QuickBooks`,
"label.checkbox.true":`Sì`,
"label.profilename":`Nome del profilo`,
"label.finalapproveoperate":`Azioni di approvazione finale`,
"label.SMS.detailed":`Gli avvisi SMS sono inviati dalle regole del flusso di lavoro quando sono stati attivati.`,
"label.lasttimemodifier":`Ultimo modificato da`,
"label.sso.summary":`Riassunto`,
"label.customfields.encd.tip":`Permette agli utenti di inserire qualsiasi combinazione di lettere e numeri e memorizzarli in forma di testo chiaro che può essere criptato e cercato.`,
"vue_label_report_formulacolumn":`Colonna della formula a livello di riga`,
"vue_label_systemSettings_transfer":`Record di trasferimento batch`,
"lable.product.ecm":`linea, si prega di inserire l'importo corretto.`,
"label.partner.setup":`Impostazioni della nuvola del partner`,
"label.same.analyze.miaoshu2":`funzione`,
"label.mobile.phone.day.summary":`Riassunto giornaliero`,
"label.ccchat.person.error.illdomain":`Errore: formato di dominio compilato in modo errato`,
"label.knowledgebase.edit.as.draft":`Modifica come bozza`,
"message.duplication.label.newfilterule":`Nuova regola di duplicazione e corrispondenza`,
"vue_label_salesfunnel_notice1":`Riassunto delle opportunità`,
"label.partnerCloud.partnerAccount.order":`Numero d'ordine :`,
"label.account.Current.and.PreviousFQ":`FQ attuale e precedente`,
"label.customfields.formula.dateandtimeexample":`Successivo = ORA() 1`,
"label.area.unassign":`Utenti non assegnati`,
"label.at.my":`Contenuto che ho menzionato (@)`,
"vue_label_calendar_notice_stopsharingfail":`Non è riuscito a fermare la condivisione`,
"label.data.file.validation.rules":`Eseguire le regole di convalida`,
"label.escalation.setup.entrydetail.escalation.hour":`Ore`,
"vue_label_ccchat_notice_pleaseentercontent":`Inserisci il contenuto e le opzioni`,
"label.forecast.edit.error1":`Errore: Valuta inattiva`,
"label_emailtocloudcc_exists1":`Questa casella di posta è stata impostata su Email to Lead. Non ripetere le impostazioni.`,
"label.trigger.send.email":`Notifiche via e-mail tramite trigger`,
"label.setmysafetysignagain":`Ripristina il mio marchio di sicurezza`,
"label.callcenter.pleaseenter.access.keyID":`Inserisci l'ID della chiave segreta`,
"chatter.poll.option10":`Scelta 10`,
"vue_label_systemSettings_mobelbottonsetting2":`Impostazione del menu inferiore unificato`,
"label.quickbooks.searchs":`Cerca`,
"label.section":`Segmento`,
"label.customfields.fielddependency.new.tip":`Crea una relazione di dipendenza che fa sì che i valori in una lista di controllo o in una lista di selezione multipla siano filtrati dinamicamente in base al valore selezionato dall'utente in un altro campo.<ul ><li>Il campo che guida il filtraggio è chiamato "campo di controllo". Caselle di controllo standard e personalizzate e picklist con almeno uno e meno di 300 valori possono essere campi di controllo. </li><li>Il campo che ha i suoi valori filtrati è chiamato "campo dipendente". I picklist personalizzati e i picklist multiselezione possono essere campi dipendenti.</li></ul>`,
"label.customobjects.track.introduce3":`Nota: solo una parte dei campi diaplici sono tracciati e "Edited" sarà mostrato quando si tracciano i campi.`,
"front-kefu-moudle-all-hidden-phone":`Nascondere il numero di telefono a livello globale`,
"vue_label_calendar_share_calendar_with_others":`Condividi il calendario con altri`,
"label.case.copre":`Scaricare Portale Web Codice QR`,
"label.conditiontag.lookup.pagetitle":`Selezionare i valori dell'elenco di scelta`,
"UG.opportunity.004":`Tipo di servizio multiplo`,
"label.event.moveup.1day":`1 giorno prima`,
"label.industrialandcommercialverification.enablestatus1":`Abilita la verifica dei dati industriali e commerciali`,
"label.ccpeak.newrecord.getorpost":`Nuovo record: ci sono due modi per costruire un CCObject usando CCObject.`,
"frame.personinfo.label.resizeimage":`Per fare delle modifiche alla tua immagine di anteprima, trascina e ridimensiona le linee tratteggiate nella tua foto del profilo qui sopra.`,
"label.optional.searchresultfield":`Campi di risultati di ricerca disponibili`,
"UG.Contract.02":`Il contratto è un accordo scritto tra le parti. Molte aziende usano i contratti per definire i termini per fare affari con altre aziende. Usa CloudCC per stabilire e documentare i tuoi contratti esistenti con i tuoi clienti e le tue opportunità commerciali. Traccia il contratto attraverso il processo di approvazione. Usa i promemoria del flusso di lavoro per ricordarti il rinnovo del contratto.`,
"label.group.activity":`Gruppi attivi`,
"label.tabpage.characterz":`Carattere iniziale`,
"label.globalsearch.tip":`Inserisci il contenuto della ricerca`,
"label.campaign.channel.download.size2":`Dimensione media: 500*500 pixel`,
"label.step3.total4":`Passo 3 di 4`,
"label.partnerCloud.payForFailure":`Pagamento fallito`,
"label.ggReleaseRange.editSuccess":`Modifica con successo`,
"label.summaryinforelyon":`Dati riassunti per`,
"label.productsales.htyj":`Prestazioni del contratto`,
"label.newpagelayout":`Nuovo layout di pagina`,
"front-gantt-module-input-task-name":`Inserire il nome del compito!`,
"label.c_d_without":`I record "C" possono avere o meno record "D" correlati.`,
"label.licence":`Licenze`,
"setup.layout.button.selectall":`Seleziona tutto`,
"label.app.step1.error.appnameexist":`Questo nome di app esiste già.`,
"label.cpq.quote.item.no.record":`Solo i prodotti d'ordine con record possono essere trasferiti ai contratti.`,
"label.knowledgebase.noaffect.existing.translations":`No, le mie modifiche non influenzeranno la traduzione esistente.`,
"label.schedulejob.setup.schedule.editjob":`Modifica del lavoro programmato`,
"lable.PowerProcess.Tips":`Il processo di entitlement è una timeline personalizzabile che contiene tutti i passi (milestones) che potrebbero supportare il servizio clienti e altro personale per completare tutti i passi al fine di risolvere un caso supportato o un record di ordine di lavoro. Dopo che l'impostazione è completa, può essere applicata al diritto.`,
"label.campaignmember.selectmember.step2":`Passo 2 Seleziona i membri che vuoi aggiungere`,
"vue_label_calendar_stopsharing":`Sei sicuro di smettere di condividere il calendario`,
"vue_label_notice_savemenu_fail":`Salvataggio del menu non riuscito`,
"message.error.getitems.id":`getItems: l'id non può essere vuoto`,
"label.return.currencylist":`Torna alla lista: Gestione della valuta`,
"label.wtd.detail.p":`PC`,
"label.knowledgebase.publish.now":`Pubblica ora`,
"label.appupload.install.explain":`Istruzioni per l'installazione`,
"label.visualpage.folder.all":`Tutte le cartelle delle pagine`,
"message.passwordPolicy.validate.complexReq2":`Errore: La tua password deve avere un mix di lettere maiuscole e minuscole e numeri.`,
"label.umeng.chatter.at":`menzionato te.`,
"label.mobile.phone.month.report":`Note di lavoro mensili`,
"label.describableEditeSelectedFields":`Seleziona i campi che vengono visualizzati di default nelle colonne del report quando crei un nuovo report personalizzato.`,
"component.event.label.subject":`Tema`,
"label.knowledgebase.edit.draft":`Modificare la bozza?`,
"label.customer.tab.step1.selectoneobject":`Selezionare un oggetto personalizzato esistente`,
"label_partner_step2":`Passo 2 confermare il modello`,
"label_starting_annual":`Anno di inizio`,
"X":`Area di testo`,
"label.customer.tab.style":`Stile scheda`,
"vue_label_commonobjects_detail_book":`Un listino prezzi standard`,
"chatter.email.referredToMe":`Mi menziona in un post`,
"label.enable.both.barcode.qrcode":`Attivare il codice a barre e il codice QR`,
"front-market-form-quired-choose":`Campi richiesti`,
"noinclude":`esclude`,
"label.sms.template.select":`Selezionare il modello di SMS`,
"label.weixin.optionten":`Scelta 10`,
"message.duplication.label.matchlastletters":`Ultimi N caratteri`,
"label.webtocloudcc.submit.success":`Presentazione di successo`,
"label.sales.dashboard.number":`Numero`,
"label.custom.field":`Mappare questo campo personalizzato`,
"label.dataimport.of.field":`campo(i)`,
"label.view.new":`Creare una nuova vista`,
"UG_activity_03":`Prenota un programma`,
"label.customfields.image.tip":`Permette agli utenti di caricare immagini.`,
"label.startexport":`Iniziare l'esportazione`,
"vue_label_commonobjects_view_chart_verticalbar":`Grafico a barre verticali`,
"label.ccchat.person.invite.allexist":`Tutti quelli che inviti stanno già usando CCChat`,
"label.fielddependence":`Dipendenze di campo`,
"label.scan.tip":`Si prega di utilizzare il browser IE7, IE8, Chrome o Firefox, e si raccomanda di utilizzare una risoluzione superiore a 1024×768.`,
"label.wei.weiactor":`Votato da`,
"label.service.miniProgram.quantity":`Si possono creare fino a 20 record di carosello~`,
"vue_label_homepage_new_homepage_page":`Nuova pagina iniziale`,
"label.apply.telphone.validate.error":`Numero di convalida errato.`,
"component.assistant.button.newevent":`Nuovo evento`,
"System_TimeField_Format_Warning":`Tempo non valido`,
"chatter.feed.publishfeed":`Invia`,
"label.setting.intergrationlist":`Lista di integrazione`,
"label.object.prefix":`Prefisso dell'oggetto`,
"label.tippage.confirmed":`Sì, voglio eliminare l'origine dati del rapporto personalizzato e tutti i rapporti dipendenti.`,
"label_emailsync_form_signin":`Accesso`,
"label.delete.cancel":`Undelete`,
"label.dashboard.myHomePage.des":`Seleziona il cruscotto da diaplay in ogni app.`,
"lable.account.FY.Ago":`2 anni fa`,
"label.umeng.approval.reassign":`#approver ha riassegnato la tua richiesta di approvazione #obj.`,
"label.data.exp.zippwd2":`Genera automaticamente la password dei file compressi`,
"label.tabpage.contentz":`Si prega di inserire il contenuto`,
"label.callcenter.batch.add.number":`Aggiungere numeri in Batch`,
"label.tabpage.deleteviewsuccess":`Visualizza il successo della cancellazione`,
"setup_layout_group_field":`Campi`,
"label.appupload.component.addobj.scheme.label.suoshu":`Oggetto`,
"front-project-module-v1-market-is-template":`Segna come modello`,
"label.service.gantt.one.esource.types":`e uno dei seguenti tipi di risorse`,
"label.emailtocloudcc.search":`Cerca`,
"label.mobile.home.page.myyj":`La mia performance`,
"vue_label_normal_invoice_sf":`Fattura`,
"label.permission.detail.app.fenpei.tip":`Specifica quali applicazioni sono visibili nel menu dell'applicazione.`,
"label.login.access.month":`Mese`,
"label_tabpage_retypez":`Quando il tipo di record viene cambiato, i valori dell'elenco delle opzioni esistenti non saranno automaticamente cambiati. si raccomanda di aggiornare il valore dell'elenco delle opzioni esistenti del record nello stesso posto.`,
"label.ems.private.company.message":`Le versioni di cloud privato non supportano la modifica online della casella di posta elettronica dell'azienda.`,
"label.dataimport.length.check":`Lunghezza superiore a 18 bit, si prega di rivedere attentamente il record e modificare.`,
"label.batchtransfer.type1":`Trasferire le opportunità aperte che non appartengono al proprietario del conto corrente`,
"vue_label_calendar_are_you_sure_to_remove":`Sei sicuro di rimuovere questo calendario`,
"label.icon.117":`Borsa della scuola`,
"vue_label_systemSettings_downloadapp":`Scaricare l'applicazione mobile`,
"label.approval.project":`Punti da approvare`,
"template.organization":`Livello organizzativo`,
"label.weixin.return.research":`Torna alla pagina dei dettagli del microsondaggio`,
"label.ccchat.person.invite.addsay":`Aggiungi un messaggio opzionale...`,
"UG.Case.02":`I casi ti permettono di rispondere e risolvere i problemi degli account. I casi sono un potente record in Cloud CC che non solo tiene traccia dei problemi dell'account, ma mostra anche una visione completa dell'account.`,
"label_emailtocloudcc_step1":`Passo 1`,
"workflow.action.tasks.assignortype.owner":`Proprietario`,
"label.data.import.page":`Vai alla pagina di importazione`,
"label.cache":`Cache`,
"label.custom.page.cuspage.width":`Larghezza (pixel)`,
"label.customcomponent.referencetag":`Etichetta di riferimento`,
"label.tabpage.search":`Cerca`,
"label.knowledge.searcharticle.casefields":`Campi di casi per la ricerca di articoli suggeriti`,
"setup_layout_message_relatedlistfield":`Seleziona i campi da visualizzare nella lista correlata. Puoi anche riordinare i campi selezionati.`,
"label.relationobject.type":`Tipo di oggetto correlato`,
"UG_Account_02":`Alcune aziende forniscono servizi ad altre aziende, altre collaborano direttamente con gli utenti finali e altre servono le ONG.`,
"UG_homepage_006":`Visibilità a 360 gradi sull'attività del tuo account attraverso sondaggi, chat dal vivo, e-mail, ordini di lavoro, post sui social media e anche attività di vendita (come lead, assistenza e attività).`,
"chatter.poll.option1":`Scelta 1`,
"label.ccdocument.fieldforld":`Nome della cartella a cui appartengono i documenti`,
"label.wei.result":`Risultato`,
"label.recentview.new":`Ultimo`,
"label.martrixreport.setsumfield":`Seleziona il campo da usare come riga di riepilogo nel tuo rapporto a matrice`,
"label.reportsSubscriptionPage.schedulereport.weekly.monday":`Lunedì`,
"label.marketsea.button.recycle":`Riciclare`,
"label.standard.buttonandlink.info2":`Seleziona la pagina personalizzata CloudCC.com da usare al posto dell'URL CloudCC.com per questo pulsante o link standard.`,
"label.reportsSubscription.select.two.months":`Seleziona un intervallo di date entro due mesi per questa frequenza!`,
"label.standard.buttonandlink.page":`CloudCC Classico`,
"vue_label_commonobjects_view_chart_horizontalbar":`Grafico a barre orizzontale`,
"label.Remove":`Rimuovi`,
"label.mobile.phone.receivable":`Pagamenti`,
"label.appupload.uploaddetail.goback":`Torna al pacchetto`,
"label.select.role":`Per favore scegli un ruolo`,
"label.file.sharetype":`Tipo di azione`,
"label.app.chosetab":`Seleziona le schede`,
"label.case.other.phone":`Altro numero di telefono`,
"chatter.edit.cancel":`Le tue modifiche sono state annullate.`,
"label.html":`HTML`,
"message.auth2cn.acquisition.failed":`Impossibile ottenere auth2cn!`,
"message.error.system.service.permissiondeny":`Siamo spiacenti, non ti è permesso servire questo servizio, per favore contatta il tuo amministratore.`,
"label.chatter.mygroups":`I miei gruppi`,
"label.umeng.approval.approvalpass":`La richiesta di approvazione per l'#obj è approvata. #objname`,
"label.chatter.owner":`Proprietario`,
"vue_label_commonobjects_view_kanban_view":`Vista Kanban`,
"message.please.choose.group.role":`Seleziona il ruolo del gruppo`,
"label.icon.136":`Valuta`,
"label_tabpage_selectdate":`Seleziona una data`,
"chatter.emailInformation":`Informazioni generali`,
"front-lightning-module-v1-dashborad-bubble-size":`Dimensione della bolla`,
"label.stdashbord.xsld.business.wan":`miriade di`,
"label.datamanage.field.notexist":`Il campo corrispondente all'oggetto non esiste.`,
"UG.Forcast.04":`Iniziare il processo`,
"UG.contact.02":`Coinvolgere i contatti attraverso più canali, chiamata, email, social`,
"vue_label_pool_selecttransferinto":`Seleziona il gruppo di piombo in cui trasferirsi`,
"label.quote.xingming":`Nome`,
"label.customerinfo.userlicencenum":`Licenze utente`,
"label.group.no.my.archived":`Nessun gruppo archiviato corrispondente trovato.`,
"label.weixin.add.activity.tel":`Aggiungi attività chiamata`,
"label.partner.setup.address":`Indirizzo della nuvola del partner`,
"label.data.file.i_title.num3":`3.Il sistema pre-legge il file di dati al server, poi avvia l'importatore di massa back-end, i cui risultati saranno notificati agli utenti per posta, e non si dovrà aspettare su questa pagina.`,
"label_sum_up":`SOMMA`,
"label.searchall.title":`Ricerca globale`,
"label.bind.chooseone":`Scegliere il proprietario`,
"label.campaign.channel.input.owner.select1":`Attuale proprietario della campagna`,
"front-kefu-moudle-v1-Expand-chat":`Espandi i dettagli della chat`,
"label.component.hotdeal":`Offerte calde`,
"component_event_label_title":`Prossimi eventi`,
"No.planed.activity":`Nessuna attività pianificata`,
"label.searchlayout.result.field":`Risultati della ricerca Colonne per la ricerca e l'etichettatura.`,
"label.leadscore.value":`Valore`,
"vue.dashboard.linkage.is.set.successfully":`Collegamento impostato con successo!`,
"PersonalInfo.LoginHistory.001":`Broswer convalida il link di registrazione nella tua casella di posta elettronica`,
"front-gantt-module-v1-problem-number":`Numeri del problema`,
"label.page.step5.of.step5":`Passo 5 di 5`,
"label.sendemail.chat.sendmessagesubject":`Allarme messaggio CloudCC CCChat`,
"label.Linkedin_accounts":`Account su LinkedIn`,
"label.qrcode.useful.life":`Data di scadenza del codice QR`,
"deleterow":`Rimuovere la riga`,
"label.forecast.settings.future1":`Futuro 1 ciclo`,
"message.error.group.operation":`Errore di archiviazione del gruppo`,
"label_tabpage_loadz":`Pagina in caricamento, attendere prego...`,
"label.brackets.left":`(Parentesi aperta`,
"label.source.code":`Visualizza il codice sorgente`,
"setup_layout_label_areasetup":`Proprietà della sezione`,
"component.assistant.label.todaylead":`Le piste che ti sono state assegnate oggi`,
"label.qrcode_signin":`Il QR Code è limitato alle applicazioni che richiedono la scansione del codice in loco e l'accesso`,
"label.calendarshare":`Condivisione del calendario`,
"IMG":`Immagine`,
"label.use.rule.when.both":`Applica questa regola quando abiliti il codice a barre e il codice QR allo stesso tempo.`,
"label.ccpeak.addshare.record":`Nuovi record del modulo condiviso:Record aggiunti di recente`,
"label.enable.email.tracking":`Abilitare il monitoraggio delle e-mail`,
"label.top.plsinput":`Cerca questa lista...`,
"vue_label_helpcenter_case":`I casi sono domande, feedback o problemi dei clienti. Gli agenti di supporto possono esaminare i casi per capire come fornire un servizio migliore. I rappresentanti delle vendite possono usare i casi per capire l'impatto sul processo di vendita. Rispondere ai singoli casi può soddisfare i vostri clienti e migliorare l'immagine del vostro marchio.`,
"label.useonly":`Privato`,
"label.displaytype":`Tipo di display`,
"label.most.user.group":`Gli utenti possono unirsi fino a 100 gruppi di utenti, e tu ti sei già unito al 100° gruppo di utenti.`,
"label.umeng.activity.yourevent":`Il tuo evento`,
"label.forecast.shrepage.classdes.w":`Lettura/Scrittura - L'utente può visualizzare e sovrascrivere i dati di previsione.`,
"label.defaultaccess":`Accesso predefinito`,
"label.partner.new.step2":`Passo 2 confermare il modello`,
"component_setup_iframe_label_title":`Personalizza la pagina`,
"label.sso.saml.sp.idenitytype":`Tipo di identità SAML`,
"label.dashboard.this.folder":`Dashboard in questa cartella`,
"label.data.newtemplate.e.seltype.desc":`Ci sono due tipi di dati derivati</li><li class`,
"label.forecast.customforecast.submit.tip1":`Invia la tua previsione da:`,
"label.version.workflow.and.approval":`Flusso di lavoro e automazione del processo di approvazione`,
"label.tianyancha.tip":`Il testo inserito non è corretto, si prega di reinserire!`,
"label.report_details":`Dettagli del rapporto`,
"template.report.folder.contract.product":`Analisi dei contratti e dei prodotti`,
"label.all":`Tutti`,
"label.version.area.long.rich":`{0} campi di testo ricco o di area di testo lunga`,
"label.enc":`Archiviazione crittografata`,
"vue_label_pricebook_enterproductname":`inserire il nome del prodotto`,
"label.edit.quote.line":`Modifica la linea del preventivo`,
"label.edit":`Modifica`,
"M":`Relazione master-dettaglio`,
"front-kefu-phonenumber-exists":`Il posto No.{a} esiste già`,
"label.standardplatformuser":`Utenti della piattaforma standard`,
"label.custom.page.configuration":`Modifica del componente console personalizzato`,
"url.error.contact.null":`L'indirizzo del microservizio è vuoto.`,
"label.sethelp":`Impostazioni di aiuto`,
"setup.mainpage.label.welcome23":`Impostazioni di sicurezza`,
"label.sales.page.dashboard.fenxi":`Cruscotti di analisi delle vendite`,
"label.limit":`Accesso`,
"maintenanceasset.asset.contractlineitem.illegal":`È necessario selezionare il bene sulla voce di contratto prima di associare la voce di contratto al bene di manutenzione.`,
"UG.contact.04":`Oppure`,
"Opportunity.Detailed.Phase.Label.004":`Giorno/i`,
"label.emailobject.receive":`A`,
"label.brief.new":`Recentemente Nuovo`,
"label.marketsea.button.adopt":`per raccogliere`,
"label.select.up.to.three.fields":`Si possono selezionare un massimo di tre campi.`,
"vue_label_allsearch_noresults":`Abbiamo cercato secondo le tue impostazioni di ricerca personalizzate, nessun risultato corrispondente trovato con {userInput}`,
"Report_CantDelete_Info":`Il rapporto {0} è l'origine dei dati per il cruscotto {1} e non può essere cancellato!`,
"label.chile.summer.time":`Ora legale del Cile`,
"label.partnerCloud.menu.selectedMenu":`Menu selezionato (i menu selezionati si sincronizzano con l'App)`,
"vue_label_report_onlysummary":`Solo riassunto`,
"front-template-V1-Applicable-object":`Si prega di scegliere l'oggetto applicabile.`,
"label.invoice.message.sendfailed":`L'invio della fattura non è riuscito, riprova più tardi`,
"front-kefu-moudle-v1-use-free":`PROVA GRATIS`,
"label.rule.updated.successfully":`Aggiornare le regole con successo`,
"label.owner.lastone":`Mantenere almeno una condizione`,
"label.appointment.wizard.subtitle1":`Durata della riunione`,
"template.report.opportunities.closed.month":`Opportunità chiuse di questo mese`,
"label.tabpage.choosecontent":`Selezionare il contenuto del valore`,
"template.chart.jbnddxl":`Vendite di ordini nell'ultimo semestre`,
"label.fieldsecurity.detail":`Dettagli sulla sicurezza del campo`,
"label.knowledgebase.data.deleted.successfully":`{a} dati cancellati con successo`,
"label.sso.saml.idp.config.nameidfmt":`Nome ID Formato`,
"label.emailobject.prompt":`Prompt`,
"label.marketsea.isgetbyself":`Permettere ai membri di auto-raccogliere`,
"label.winxin.cancelprompt":`Sei sicuro di uscire? La tua operazione attuale non viene salvata.`,
"label.appexchange.installedpage.message2":`Le app e i componenti sono installati in pacchetti. Tutte le applicazioni personalizzate, le schede e gli oggetti personalizzati sono inizialmente contrassegnati come "In Development" e non vengono distribuiti agli utenti, il che consente di testare e personalizzare prima di distribuire. Puoi distribuire i componenti individualmente usando le altre funzioni nella configurazione o come gruppo cliccando su Deploy.`,
"vue_label_import_importtype":`Tipo di importazione`,
"label.data.importef.des":`I file che non sono riusciti a importare saranno salvati sul server per 48 ore e saranno automaticamente cancellati dopo 48 ore.`,
"chatter.email.reply":`Commenti ai miei post`,
"label.stdashbord.xsld.business.sdl":`Tasso perso`,
"labal.emailtemplate.namemessage":`Il nome unico del modello di email esiste, per favore reinseriscilo.`,
"vue_label_email_Please_select_file":`Si prega di selezionare il file`,
"label.event.modify":`Modifica evento`,
"label.projectManagement.isnmber":`Si prega di inserire un numero con un massimo di un decimale.`,
"lable.outlook.detail.emailst":`Impostazioni e-mail`,
"label.partnerCloud.priceOfManual.isUsed":`Questa impostazione determina se i partner possono usare questo libro dei prezzi per ordinare o meno.`,
"setup_mainpage_label_welcome26":`Gestione dei dati - Elaborazione batch`,
"label.file.version":`Versione`,
"pagecreator_systemstyle_label_bordercolor":`Colore del bordo`,
"label.approval.isallowed.reject.prompt":`Vuoi permettere il rifiuto quando approvi singoli dati? (L'approvazione di massa può sempre essere rifiutata).`,
"label.myinfo":`Informazioni personali`,
"front-template-V1-fontSize":`Dimensione del carattere`,
"lable.outlook.edit.alpreo":`Scambio sempre preferito`,
"front-email-payment-card-number":`Numero di carta`,
"label.cpq.quote.pricebook.no.change":`Una volta che il listino per un'offerta è stato determinato, non può essere cambiato. Si prega di creare 1 nuovo record di quotazione per l'utilizzo di un nuovo listino.`,
"vue_label_file_size_limit_tip":`La dimensione del file supera il limite`,
"lable.PowerProcess.worktime":`Tempo di lavoro del processo di abilitazione`,
"label.monthly.month.report":`Rapporto mensile YoY e MoM`,
"front-kefu-moudle-v1-sydq-buyuser":`La tua traccia è dovuta. Si prega di acquistare il Easemob per mantenere l'uso`,
"label_tabpage_Rolesz":`Ruoli e subordinati`,
"chatter.f.n":`Segui questo record`,
"UG.Forcast.02":`Le previsioni sono stime delle vendite previste per un dato periodo, e i modelli di previsione possono aiutare a determinare la domanda di prodotti e le entrate delle vendite in un certo periodo. I manager possono usare le previsioni per fissare gli obiettivi e misurare i progressi del team. La previsione generale dell'organizzazione può riflettere il riassunto di tutte le vendite per rappresentante di vendita (indipendentemente dalla fase di completamento delle vendite, dalla fase di pipeline alla fase chiusa).`,
"label.productsales.contract.phb":`Elenco dei contratti`,
"label.umeng.insert.approval.submit":`#Il richiedente presenta un #obj per la tua approvazione`,
"message.duplication.label.matchfirstletters":`Primi N caratteri`,
"label.partnerCloud.partnerAccount.toPay":`Vai a pagare`,
"label.model.un":`No. del modello: UN6786`,
"label.save.c1":`Il nome di "Web To CloudCC" deve essere unico.`,
"week":`Settimana`,
"Pagelayout.Setup.003":`Il campo Nome deve essere selezionato`,
"label.query.detail.openpartnermessage":`Una volta che il cliente è abilitato come partner, appare nei rapporti filtrati e nelle viste elenco sul campo ispartner. inoltre, gli utenti partner possono creare da contatti associati a questo cliente. sei sicuro?`,
"label.validate.function.funcFormat.DATEVALUE":`DATEVALUE(data)`,
"label.apply.send.false":`Inviare fallimento`,
"label.recordtype.edit.selectvalue":`Valori della lista di scelta`,
"label.chosesubject":`Seleziona un argomento qui sotto`,
"label.validate.function.funcExplain.YEAR":`L'anno della data di ritorno è un numero compreso tra 1900 e 9999`,
"component.chatter.button.more":`Vedi altri dettagli`,
"label.top.class.smallest":`Il livello minimo della gerarchia è 1.`,
"label.startingvalue":`Numero di partenza`,
"label.multi.layout.remark":`Layout che si applica a front Master-Detail Input e Mass Add`,
"label.role.availableuser":`Utenti disponibili`,
"label.weixin.iebrowser":`La versione del browser che stai usando attualmente è IE6, che è stato rilasciato da Microsoft nel 2001. Poiché la versione del browser è troppo bassa perché CloudCC possa essere sviluppato con una nuova tecnologia, non è garantito che tutte le funzioni vengano utilizzate correttamente. Per favore, scarica e aggiorna il tuo browser in tempo.`,
"Homepage_News_004":`Nessuna notizia recente.`,
"vue_label_normal_task_sf":`Compito`,
"label.version.nonsupport.trigger":`I trigger non sono supportati per il momento.`,
"pagecreator_page_label_pagelayout":`Layout di pagina`,
"label_tabpage_step3":`Passo 3 selezionare i campi da visualizzare`,
"label.canOnlyUploadCSVFormatFile":`Carica solo file in formato CSV`,
"label.b.c.least":`Ogni record "B" deve avere almeno un record "C" correlato.`,
"label.list.userinterface.sales.enable":`Vendite homepage leaderboards visualizzare i dati abilitare i permessi`,
"label.umeng.approval.approvalreject":`La richiesta di approvazione per l'#obj è respinta. #objname`,
"vue_labenl_normal_notice_share_fail":`Condivisione fallita`,
"label_emailtocloudcc_tip":`Prompt`,
"label.h5.touchselect":`Fare clic per selezionare`,
"label.tabularreport":`Rapporto tabellare`,
"label.app.defaulttab":`Schede predefinite`,
"label.validate.function.category.Datetime":`Data e ora`,
"vue_label_pricebook_editdetail":`Modifica le voci del listino prezzi`,
"vue_label_commonobjects_view_no_selected_record":`Nessun record selezionato`,
"chatter.changed":`Cambiato`,
"label.asset.bom.based":`Generare la distinta dei beni in base alla struttura dei prodotti dell'ordine`,
"label.appointmentdetail.wizard.title8":`Iniziare in ogni`,
"label.area.query.user.error":`I dati utente corrispondenti al territorio della query non sono riusciti, e l'ID del territorio era vuoto.`,
"page.field.masterinput":`Impostazioni di ingresso Master-Detail`,
"chatter.selads":`Seleziona i destinatari`,
"label.data.exp.please.savebutton":`Seleziona "Salva come modello".`,
"label.members.activity":`Membro di attività`,
"label.weixin.click.searchs":`Clicca per cercare il record`,
"label.input.least.two":`Si prega di inserire almeno due caratteri`,
"label.marketing.seting":`Impostazioni di Marketing Cloud`,
"label.approveprocess.tip":`Le approvazioni sono processi aziendali complessi che richiedono la raccolta di informazioni e la pianificazione prima dell'implementazione. Si raccomanda di seguire le istruzioni seguenti prima di iniziare.`,
"front-email-payment-Invoice-login-account":`Conto di accesso`,
"label.selectmulti.mes":`Troppi destinatari selezionati.`,
"label.workflow.gotolist":`Torna alla lista: Flusso di lavoro`,
"label.profile.fieldsafety":`Sicurezza sul campo`,
"front-project-module-v1-no-selectemplat":`Nessun modello disponibile`,
"label.sendemail.queue.assigntitle":`L'e-mail di notifica dell'oggetto assegnato alla coda`,
"label.approval.mobile.comments.placeholder":`Inserisci un commento qui, fino a 1000 parole`,
"vue_label_report_given":`specifico`,
"vue_label_dashboard_groups":`Si prega di selezionare il gruppo`,
"label.service.gantt.popoverTip":`Distanza/tempo di viaggio`,
"label.mr.title.characters":`Secondo la lunghezza dei caratteri`,
"label.passwordPolicy.setup.day":`giorni`,
"label_tabpage_personvisible":`Visibile al personale interessato`,
"ct":`Multi-valuta`,
"label.chatter.newEvent":`Nuovo evento`,
"vue_label_systemSettings_id":`Identità di accesso`,
"label.page.preview.web.tab":`Anteprima scheda web`,
"label_emailsync_button_sure":`Confermare`,
"front-template-V1-Modification-time":`Tempo di modifica`,
"vue_label_homepage_edit_fixed_components":`Modifica dei componenti fissi`,
"label.apply":`Applica`,
"Main.Menu.Mobiledownload":`PRENDETELO`,
"vue_label_salesfunnel_notice6":`La quantità totale di opportunità con una probabilità del 100%`,
"label.chosesubject.sendemail":`Inviare un'e-mail`,
"label.changemydisplay.chagetab.des":`Scegli le schede che verranno visualizzate in ciascuna delle tue app.`,
"label.attendance.setting.checkUser":`esiste già in altre presenze.`,
"label.list.projectSetting.setup":`Impostazioni di gestione del progetto`,
"label.app.introduce2":`Puoi personalizzare le app esistenti per adattarle al tuo modo di lavorare, o costruire nuove app raggruppando schede standard e personalizzate.`,
"label_emailsync_form_emialpassword":`Password`,
"label.Lightning.Setting":`Impostazione del fulmine`,
"label.print.preview":`Vista stampabile`,
"label_vue_create_edit_obj_create_event_dialog_desc_alert":`Vuoi ancora creare l'evento in questo lasso di tempo?`,
"label.mobile.phone.report.type":`Tipo di rapporto`,
"lable.account.CalenderWeek":`Settimana del calendario`,
"label_emailtocloudcc_step3total3":`Passo 3 di 3`,
"label_tabpage_emailaddressz":`Indirizzo e-mail del mittente`,
"label.data.is_woking":`Funzionamento`,
"label.knowledge.cancelattach.case":`Annullare Allegare al caso`,
"label.sendemail.chat.chatcontent":`Il contenuto del post principale:`,
"label.timezone.set":`Impostazioni del territorio`,
"label_tabpage_uploadingz":`Caricamento di`,
"front-epwechat-module-v1-home-url":`Homepage URL:`,
"label.reportsSubscription.select.subscription.frequency":`Seleziona la frequenza dell'abbonamento!`,
"label.validate.function":`funzione`,
"label.partnerCloud.orderingPlatform.quantity":`Quantità`,
"label.compact.layout.chatter":`CCChat`,
"label.sso.saml.sp.description2":`Configurare il single sign-on per autenticare gli utenti in CloudCC da ambienti esterni.`,
"label.ccchat.message.new.error1":`Non riusciamo a trovare nessun utente della chat con {0} nel suo nome.`,
"label.file.share.email.content3":`Per i dettagli, accedi al sistema CRM di CloudCC.`,
"label.file.cancel.sharing":`Annullamento della condivisione`,
"label.changemydisplay.showalltabs.add":`Aggiungere schede alla visualizzazione predefinita`,
"label_chatter_incident":`Evento`,
"label.file.folder.delete3":`Sei sicuro di voler cancellare {foldername}？`,
"label_tabpage_delsuccessz":`Cancellare il successo`,
"label.view_contact":`Visualizza Contatto`,
"label.deactivate":`Disattivare`,
"label.Horizontal.Date":`Filtrare gli appuntamenti di servizio in base alla data di leve.`,
"label.forecast.tree.title":`Gerarchia delle previsioni`,
"vue_label_dashboard_dategruop":`Si prega di selezionare la base di raggruppamento delle date`,
"label.version.nonsupport.custompage":`Le pagine personalizzate non sono temporaneamente supportate.`,
"label.tabpage.personvisible":`Visibile al personale interessato`,
"message.error.unknown":`Errore sconosciuto`,
"label.down":`Giù`,
"label.multilang.customforcast.financialyear":`{0} anno fiscale：`,
"label.dataimport.type.error":`Errore di tipo, controlla il record e modifica.`,
"label.batchadd.newbatchpage.save.num":`Formato numerico errato`,
"front-Dev-V12.2.8-calendar-endField":`Fine campo`,
"label.tabpage.rtemptyz":`Il tipo di record non può essere vuoto`,
"vue_label_dashboard_maximum":`Inserisci il massimo`,
"label.expiredate":`Data di scadenza`,
"label_emailtocloudcc_button_view":`Vedi`,
"label.event.future":`Eventi futuri`,
"label.mobile.app.layout":`Layout dell'app mobile`,
"label.emailobject.contacts":`  contatto/i`,
"label.approvalstep2.tip":`Specifica se un record deve soddisfare certi criteri prima di entrare in questa fase di approvazione.`,
"label.usefollowtoset":`Usando le opzioni sottostanti, specificare l'utente a cui assegnare la richiesta di approvazione.`,
"label.dashboard.summary.editPageHeader":`Modifica dell'intestazione`,
"label_partner_workspace_tab_memo":`Selezionare le schede per questo cloud partner. Si possono selezionare schede standard o schede personalizzate.`,
"front-lightning-module-v1-details-page-chart-title-supports":` Il titolo supporta l'inserimento di un nome di record con un formato di {recordname}, come "Opportunity Amount of {recordname}". Se il nome del record corrente è CloudCC, allora sarà visualizzato come "Opportunity Amount of CloudCC".`,
"label.enable.generate.location.service":`Permette la generazione di servizi di dati di latitudine e longitudine del cliente basati sull'indirizzo del cliente`,
"label.loginsystem":`Accesso`,
"label.email.template.edit.template":`Modifica modello`,
"vue_label_commonobjects_detail_share":`Quota delle entrate`,
"label.icon.142":`Casa`,
"label.maintype":`Master`,
"label.step2.total4":`Passo 2 di 4`,
"label.select.intended.tablayout":`Scegli il layout di pagina della scheda web che vuoi creare.`,
"label.custom.unit":`Unità`,
"label.mr.title.phone":`Telefono`,
"label.compact.layout.frame.showtype":`Metodo di visualizzazione:`,
"label.associations":`Oggetto associato`,
"label.potentialcustomers.name":`Nome del piombo`,
"label.edit.profile":`Modifica il profilo`,
"label.tabpage.allvisible":`Tutti gli utenti sono visibili`,
"label.login.verification.confirmation.enabled":`Confermare per abilitare`,
"vue_label_norm_recordselected":`{selectNum} record selezionati`,
"label.partner.workspace.member.selectedprofile":`Profilo selezionato`,
"label.divide":`/Dividere`,
"label.version.case.control":`Gestione dei casi`,
"label.attendance.nocheckin":`Non Check-In`,
"vue_label_helpcenter_report2.1":`2.Rimuovere il raggruppamento delle righe: <br> A. Dopo aver trovato il campo "raggruppamento riga" che si desidera rimuovere nella lista "riga del gruppo" a sinistra, fare clic su "×" sulla casella del campo. <br> B. Oppure trova il campo "raggruppamento righe" che vuoi rimuovere nell'intestazione del rapporto di anteprima a destra, clicca sul "pulsante a discesa" e clicca su "elimina riga gruppo".<br> Rimuovi raggruppamento colonne: <br> A. Dopo aver trovato il campo "raggruppamento colonne" che vuoi rimuovere nell'elenco "raggruppa colonne" a sinistra, clicca "×" sulla casella del campo. <br> 1. B. Oppure trova il campo "Raggruppamento di riga" che vuoi rimuovere nell'intestazione della tabella del rapporto di anteprima sulla destra, clicca sul pulsante a discesa e clicca su Elimina gruppo di riga. <br> Per rimuovere un raggruppamento di colonna:<br> A. Trova il campo Raggruppamento colonna che vuoi rimuovere nell'elenco Raggruppa colonne a sinistra, e clicca la "x" sulla casella del campo. <br> B. Oppure trova il campo Raggruppamento colonne che vuoi rimuovere nell'intestazione della tabella del rapporto di anteprima sulla destra, clicca sul pulsante a discesa e clicca su Cancella gruppo colonne. <br>? Personalizzare la granularità della data per raggruppare i record<br> Passo 1: Dopo aver raggruppato per campi data, puoi anche personalizzare la granularità della data. Per prima cosa, seleziona il campo data per il quale vuoi raggruppare il report. Poi clicca sul pulsante a discesa accanto a questo campo nell'intestazione del rapporto di anteprima e clicca su Base di raggruppamento della data. <br> Passo 2: Seleziona come vuoi raggruppare: Giorno, Mese, Anno, Trimestre contabile, Anno contabile, Trimestre personalizzato, Anno personalizzato. <br>? Passo 1: Dopo aver trovato la colonna che vuoi riassumere nell'intestazione del rapporto di anteprima, fai clic sul "pulsante a discesa" e clicca su "Riepilogo". <br>`,
"label.payment.renew":`Rinnovare`,
"vue_label_file_wrong_type":`'C'è un errore nel tipo di caricamento del file, il formato del file che stai caricando ora è {tipo}!`,
"UG_opportunity_005":`Processo di vendita multiplo`,
"label.knowledge.language.korean":`Coreano`,
"label.customobjects.inputrecordtagandformat":`Inserire l'etichetta e il formato del nome del record`,
"label.h5.chatter.commentednum":`Ricevere una risposta`,
"label.quickbooks.button.unlink":`Scollegare`,
"label.step5.total5":`Passo 5 di 5`,
"label.projectManagement.Selweek":`Seleziona la settimana`,
"label.optional.searchfield":`Campi ricercabili disponibili`,
"label.mobile.quickcreate.default.signin":`Check in`,
"label.visualpage.unable.parse":`Impossibile risolvere il marcatore.`,
"mesage.error.role.delete":`Non puoi cancellare il ruolo a cui è stato assegnato il ruolo figlio.`,
"label.role.user":`Utenti nel ruolo`,
"button_partner_workspace_saveas":`Salva con nome`,
"label.file.no.public.link.created":`Nessun link pubblico creato`,
"label.login.access.shenyu":`Rimanente`,
"label.ccchat.group.section":`Gruppo`,
"label.weixin.object.notnull":`Il tema non può essere vuoto`,
"label.accmarketsea.add.title":`Nuovo pool di conti`,
"label.sales.funnel.layout":`Layout dell'imbuto di vendita`,
"pagecreator.page.button.edit":`Modifica`,
"label_tabpage_entercontent":`Si prega di inserire il contenuto`,
"component_event_label_begindate":`*Tempo di inizio`,
"label.file.versionhref":`Passa alla nuova versione della pagina`,
"label_chatter_send":`Invia`,
"setup_layout_label_buttonlist":`Seleziona i pulsanti`,
"label.custom.Current.and.NexttCQ":`Corrente e prossimi 3 CQ`,
"pagecreator_page_label_pagedesc":`Descrizione della pagina`,
"label.appupload.upload.uploader":`Caricato da`,
"label.console.step5.tab.primary":`Come scheda primaria`,
"vue_label_globalsearch_expandlist":`Espandi la lista`,
"label.forecast.edit.userqu":`Obiettivo`,
"label.step1.total5":`Passo 1 di 5`,
"label.multilang.dupicatecheck.onegroupredata":`Progresso della verifica del duplicato e della combinazione: un totale di {0} gruppi:`,
"vue_label_systemSettings_repeat":`Gestire le duplicazioni`,
"label.mobile.side.tab.error1":`Seleziona le funzioni comuni e le schede dell'applicazione che devono essere visualizzate.`,
"label.knowledgebase.reduction":`Ripristinare`,
"label.standard.buttonandlink.override.usedefault":`No Override (usa l'impostazione predefinita)`,
"dateandtime":`Data/ora`,
"label.group.activate.info":`Attivare il gruppo`,
"label.triggertotask":`Trigger di attività`,
"label.emailobject.save.template":`Salva la bozza come modello`,
"label.audit.objInfo":`Dettaglio del processo di approvazione`,
"label.callcenter.successfully.logged.account":`Registrato con successo!`,
"label_new_customer_target":`Obiettivo del nuovo conto`,
"label.campaign.channel.step5":`Passo 5: Anteprima della pagina di registrazione del canale di marketing e del codice sorgente.`,
"label.log.type":`Tipi di operazione`,
"front-template-V1-noTemplate":`Non sono stati trovati modelli disponibili sotto l'oggetto commutato.`,
"label_report_line_daixuan":`Colonna dei rapporti in sospeso`,
"label.tianyancha.businessverify.relation.tip":`Scrivere i campi restituiti da tianyancha nei campi del cliente`,
"label.default.value":`Usa questo valore come valore predefinito per la lista di prelievo principale`,
"label.weixin.campaign.attendance":`Partecipazione alla campagna`,
"message.duplication.label.check":`Controlla`,
"label.salescloud.salescloud.yes2forbidden":`Sì, voglio disabilitare la vendita a squadre.`,
"lable.currencyAdv.exchagecurrency.rate":`Tassi di cambio per:`,
"lable.Hide.title":`Nascondi i titoli`,
"label.finishedreport":`Rapporti generati`,
"vue_label_account_business":`Trasferire le opportunità di business chiuse dei proprietari dei clienti`,
"vue_label_pool_assigned":`Assegnato`,
"label.report.export.error":`L'operazione di esportazione ha incontrato un'eccezione. Si prega di riprovare.`,
"label.layout.availablefield":`Campi disponibili`,
"label.licence.remainder":`Licenze rimanenti`,
"label.approval.idea.required":`È necessario un parere di approvazione.`,
"front-kefu-moudle-needhand-createcase":`La conferma manuale è richiesta prima di creare il caso`,
"label.dashboard.snapshot.Data.change":`L'origine dei dati è cambiata, si prega di riconfigurare`,
"label.partner.workspace.login.footertext":`Testo a piè di pagina`,
"vue_label_chatter_upload_link_type":`Post selezionato di tipo link upload`,
"front-dialog-module-v1-error-detail":`Dettagli dell'errore`,
"label.emailobject.sendgroupemail":`Invia un'email di gruppo`,
"lable.newtabpage.allviews":`Tutte le viste`,
"label.khdd":`Posizione dell'account`,
"vue_label_dashboard_sortfield":`Campo di ordinamento`,
"label.form.sample":`Esempio di forma`,
"component_setup_button_cancel":`Cancella`,
"vue_label_salesfunnel_notice5":`Quantità di opportunità di business con una probabilità di 1% - 99% * probabilità`,
"pagecreator_systemstyle_label_modifystyle":`Editore di stile`,
"UG_homepage_001":`Vincere più affari in meno tempo`,
"label.campaign.pc":`PC`,
"label.visualpage.lightning":`Versione con fulmine`,
"label.knowledge.category.hint.two":`Usa questa pagina per selezionare il gruppo per Lightning dopo aver creato il gruppo di categorie.`,
"label.south.africa.standard.time":`Ora solare del Sudafrica`,
"label.service.gantt.reservation.number":`Numero d'ordine`,
"label.weixin.report.period":`Periodo`,
"label.leadtomap.exp":`Usa le schede per mappare ciascuno dei campi lead personalizzati della tua organizzazione a uno dei tuoi campi account, contatti o opportunità personalizzati. Queste mappature sono usate quando converti i lead in account, contatti o opportunità.`,
"label.currency.d":`Puoi cambiare la tua valuta aziendale in un'altra delle valute supportate dalla tua organizzazione. Tutti i tassi di conversione della valuta già definiti in CloudCC.com saranno modificati in modo appropriato per riflettere il cambiamento.`,
"label.forecast.detailforecast.oppyclb":`Categorie di previsioni di opportunità`,
"label.reportsSubscriptionPage.email.selected":`Membri selezionati`,
"vue_label_homepage_componentname":`Inserisci il nome del componente`,
"lable.account.Previous.FYt":`Precedente 2 FY`,
"label.appupload.success":`Carica completo`,
"label.customer.newtab":`Nuova scheda della pagina personalizzata`,
"label.value.notnull":`Dovete inserire un valore.`,
"label.case.miniprogram.layout":`Il layout di pagina della pagina di rapporto dell'applet è il layout di pagina usato per la richiesta di servizio inviata dall'estremità dell'applet, e questo layout di pagina può essere solo modificato e non può essere cancellato.`,
"label.partnerCloud.partnerAccount.twoDecimal":`Si prega di inserire nel formato corretto.  Si possono tenere due decimali.`,
"UG.Lead.004":`Modulo web`,
"label.umeng.activity.event.eventwillbeginnew":`Notifica dell'evento: #l'evento inizia a #begintime`,
"label.projectManagement.subtasks":`Sub-taks`,
"vue_label_checkduplicate_repeat_conditions":`Decidere le condizioni ripetute`,
"label.subject":`Oggetto`,
"label_search_otherusers_forecast":`Cerca le previsioni degli altri utenti`,
"label_tabpage_namemandatory":`Il nome della vista è richiesto`,
"label.timezone.importtimezone":`L'impostazione del fuso orario per l'importazione dei dati`,
"label.mobile.buttom.team.init":`Inizializzazione dell'utente del team`,
"label.checkfield.choosefield":`Seleziona i campi per trovare i duplicati`,
"label.b_c_least":`Ogni record "B" deve avere almeno un record "C" correlato.`,
"label.knowledge.setting.hint.five":`Seleziona un autore di conoscenza`,
"label.h5.similar.opportunity.step2":`Passo 2 Specificare i criteri di corrispondenza`,
"label.page.style.imbedded.cloudcc":`Lo stile pagina intera ti dà il massimo spazio sullo schermo per il contenuto che incorpori nella finestra di CloudCC.com.`,
"label.sendemail.marketactivity.invitecode":`Il codice d'invito della campagna #campaignname`,
"label.block.pricing":`Prezzi per blocchi`,
"message.error.field.number.zero":`Errore nel formato di lunghezza inserito, non può essere 0.`,
"pagecreator.systemstyle.message.save.success":`Stile salvato con successo`,
"pagecreator_systemstyle_label_styledesc":`Descrizione dello stile`,
"APPIntegration_Dropbox_setting_01":`Abilita`,
"label_emailtocloudcc_redmessage2":`Inserisci la password corretta del tuo account di posta elettronica`,
"label.user.special.operations":`Utilizzato solo nel funzionamento, non può essere utilizzato temporaneamente, si prega di contattare l'amministratore!`,
"pagecreator_page_label_layoutpreview":`Anteprima del layout`,
"APPIntegration_Dropbox_setting_03":`Abilita Dropbox per permetterti di selezionare i file da Dropbox e aggiungerli come allegati.`,
"label.sure_leave":`Sei sicuro di partire?`,
"label.applt.copylink":`Copiare il link del miniprogramma`,
"label_tabpage_allpotentialcustomers":`Tutte le piste`,
"label.rulestrikedate":`Tempo di attivazione della regola`,
"label_tabpage_justsz":`Solo`,
"label.customize.memory.function.sorting.title":`Personalizzare la mia memoria Funzione di ordinamento`,
"message.duplication.label.mergebutton":`Unire`,
"chatter.group.cancelRequest":`Annulla la richiesta`,
"label.campaign.channel.step6.remark":`Se hai confermato la pagina di registrazione, clicca sul pulsante Genera per generare la pagina di registrazione.`,
"label.appupload.upload.install.abort":`Annullare l'installazione`,
"label.emailobject.proposetimes":`Proporre tempi`,
"label.probability.cannot.empty":`Devi inserire un numero nella tua possibilità di opportunità.`,
"vue_label_homepage_editkanban":`Modifica Kanban`,
"lable.Related.template":`Modelli rilevanti`,
"label.cloudccclass.list.cls.time":`Classi programmate`,
"component.task.label.enddate":`Data di scadenza`,
"label.sendmail.step3":`Passo 3 Rivedere e confermare`,
"label.projectManagement.Gridview":`Vista a griglia`,
"label.emailobject.time":`Tempo`,
"label.applt.address":`Portale del servizio clienti del miniprogramma`,
"label.searchfield":`Campi di ricerca`,
"vue_label_calendar_please_enter_the_name":`Inserisci il nome`,
"label.list.userinterface.default.page.setup":`Pagina predefinita del sistema`,
"label.detail.2018":`Dettagli`,
"label.webtocloudcc.success":`Le sue informazioni sono state inviate con successo. Grazie mille per la sua partecipazione, la serviremo con tutto il cuore.`,
"component_telerecord_label_title":`Registra il telefono`,
"label.setting.sureDelete.rules":`Sei sicuro di voler cancellare questa regola?`,
"vue_label_email_current_theme":`L'inserimento di questo modello coprirà l'attuale oggetto dell'e-mail.`,
"lable.Order.product":`Ordina prodotto`,
"UG_product_02":`I prodotti si riferiscono a prodotti o servizi che vengono venduti o acquistati.`,
"label.appexchange.task":`Compiti del flusso di lavoro`,
"label.selectprocesscondition":`Specificare le condizioni per il passo`,
"label.mobile.quickcreate.default.scan":`Scansione`,
"label.tabpage.prepagez":`Visualizzazione su ogni pagina`,
"label.query.error":`Errore di query.`,
"label.tabularreport.2018.step1":`Passo 1 Scegliere le colonne del rapporto`,
"pagecreator.systemstyle.label.modifystyle":`Editore di stile`,
"label.app.step3":`Passo 3 Scegliere la fonte dell'immagine per il logo dell'applicazione personalizzata`,
"label_tabpage_rowsz":`Cancellare le righe`,
"label.validate.function.funcExplain.SUBSTITUTE":`Sostituisce new_text con old_text in una stringa di testo. Usate SUBSTITUTE quando volete sostituire un testo specifico in una stringa di testo.`,
"vue_label_checkduplicate_select_data_to_merge":`Seleziona i dati da unire`,
"vue_label_commonobjects_view_chart_displaymode":`Modalità di visualizzazione`,
"label.industrialandcommercialverification.servicesetiings":`Impostazioni di servizio`,
"label.refresh":`Aggiorna`,
"label.taskfield":`Campi di attività`,
"label.notification.approval4":`【提交人】 richiede l'approvazione per 【对象】`,
"label.group.isusing":`Attivo`,
"label.language.settings":`Impostazione della lingua`,
"front-kefu-moudle-please-login":`Per favore, accedi prima`,
"label.page.double.line.cloudcc":`2 colonne con barra laterale CloudCC.com`,
"folder.error.delete":`1. La cartella corrente contiene rapporti e non può essere cancellata! 2. La cartella corrente contiene rapporti nascosti e non può essere cancellata! Il rapporto nascosto è un rapporto creato sulla base di un oggetto logicamente cancellato (impostazioni-creazione-oggetti cancellati sotto l'oggetto), perché l'oggetto non è realmente cancellato, quindi il rapporto è nascosto`,
"eight":`Otto`,
"label.marketseamemset.user":`Membro`,
"label.recordnum":`Numero di registrazione`,
"page.404.button.back":`Torna alla fase precedente`,
"label.mobile.phone.month.plan":`Piani per il prossimo mese`,
"label.marketseamemset.account.title2":`Si prega di impostare un limite superiore al numero di clienti che interessa tutti i membri. Il limite non è correlato al pool di piombo`,
"vue_label_chatter_current_avatar":`Avatar attuale`,
"label.mobile.side.tab.remark3":`Tieni premuto il tasto shift, clicca o fai clic per trascinare per selezionare una serie di elementi adiacenti. tieni premuto il tasto ctrl e clicca per selezionare più elementi non adiacenti.`,
"component.sendmail.label.touser":`Destinatario`,
"label.homeitems.noobject":`Nessun soggetto`,
"template.report.overall.sales":`Periodo complessivo di vendite (per fonte di lead)`,
"label.partner.donotdel":`non può cancellare`,
"label.service.miniProgram.bindCopyDesc":`Dopo aver legato la vostra organizzazione all'aacount ufficiale della vostra azienda o al mini programma, potete usare questo indirizzo come il vostro portale di assistenza clienti copiando e saltando a questo indirizzo con un solo tocco.`,
"UG_Contract_01":`Gestire il contratto`,
"UG_quota_06":`Creare un preventivo`,
"vue_label_report_deletereport":`Cancellare il rapporto`,
"front-epwechat-module-v1-input-appname":`Inserisci il nome dell'applicazione`,
"label_tabpage_deleteviewsuccess":`Visualizza il successo della cancellazione`,
"component_chatter_label_mygroup":`Il mio gruppo`,
"label.campagin.roi.leixing":`Tipo di campagna`,
"label.dashboard.myHomepageDashboard":`Cruscotti della mia homepage`,
"UG_solution_04":`Soluzione di importazione`,
"label.knowledge.setting.hint.four":`Attivare la conoscenza`,
"label.campaign.channel.add.field":`Clicca sul pulsante per aggiungere campi`,
"label.eastem.european.time":`Ora dell'Europa orientale`,
"label.partner.workspace.member.partner":`Profilo del partner CloudCC`,
"label.campaignmember.main.backtocampaign":`Torna a Campagne`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.absolute":`Assoluto`,
"label.task.unsolve":`Tutti i compiti aperti`,
"label.multilang.chatterservice.vote":`{0} biglietto(i)`,
"label.console":`Console`,
"label.emailsync.message1":`Se cancelli la connessione, non sarai in grado di sincronizzare il contenuto della casella di posta con i lead e i contatti, sei sicuro di voler cancellare?`,
"pagecreator.systemstyle.label.stylename":`Nome dello stile`,
"setup_mainpage_label_welcome16":`Istruzioni: Clicca sul menu sul lato sinistro della pagina → Impostazioni applicazione → Crea → Flusso di lavoro, Processo di approvazione, Compiti, Notifica e-mail, Aggiornamento campi e altro.`,
"message.duplication.label.editfilterule":`Trovare regole di filtro duplicate`,
"Account.News.Setting.004":`Abilitare le notizie`,
"label_tabpage_saveviewsuccess":`Vista salvata con successo`,
"label.forecast.forehistory.replacecommit":`Impegnarsi a sovrascrivere`,
"pagecreator_button_cancel":`Cancella`,
"label.knowledge.article.nomatch":`Impossibile archiviare questo articolo per la bozza associata esiste. Per favore cancella la bozza e riprova.`,
"vue_label_combined_field":`Nessun campo da sommare.`,
"label.batchadd.save.prompt":`record(s)`,
"label.tabpage.summaryway":`Riassunto da`,
"label.check.input.condition.two":`SQL non è supportato`,
"mail.apiCode.notOnly":`L'unico nome esiste già`,
"UG.quota.01":`Gestire le quotazioni dell'account`,
"label.approved.receiveApprovalEmail.option3":`Solo se sono un approvatore delegato`,
"label.stdashbord.xsld.business.img5":`Importo totale di probabilità 0%`,
"vue_label_chat_movedfromto":`{name} ha spostato {label} da {vecchio campo} a {nuovo campo}`,
"label.customfields.new.step2.opration":`Opzioni generali`,
"label.dashboardSetup.isurl":`Aggiungi link`,
"label.forecast.settings.mrfwqj":`Ciclo di previsione`,
"label.campaign.channel.field":`Campi`,
"label.weixin.optionthree":`Scelta 3`,
"label.safetystatement":`Dichiarazione di sicurezza`,
"label.useskipwizard":`Utilizzare la procedura guidata Jump Start`,
"label.projectManagement.completion":`Stato di completamento`,
"label.customfields.fielddependency.new.step2":`<b>Passo 2: </b> Nella pagina seguente, modifica le regole del filtro che controllano i valori che appaiono nel campo dipendente per ogni valore nel campo di controllo.`,
"setup.mainpage.label.welcome8":`Personalizzazione dell'interfaccia drag-and-drop`,
"label.emailobject.list.outbox":`Outbox`,
"label.app.default.login.tab":`Scheda di accesso predefinita`,
"label.follow_emails":`L'email di followup è un ottimo modo per contattare rapidamente e facilmente i visitatori dopo l'invio dei moduli.`,
"vue_label_homepage_application_page":`Pagina iniziale dell'applicazione`,
"label.confirm.template":`Confermare`,
"lable.product.not":`Non può essere completo cancellare`,
"label.multilang.feedtrack.dispalyinfo":`Puoi scegliere al massimo {0} campi:`,
"label.weixin.plz.inputsrhkey":`Inserisci una parola chiave di ricerca`,
"label.projectManagement.service.appointment":`Appuntamento di servizio`,
"label.list.userinterface.watermark.enable":`Abilita le filigrane in homepage, viste, pagine di dettaglio, rapporti e dashboard su PC e app mobile.`,
"label.confirmDelete":`Sei sicuro di voler cancellare questi dati?`,
"label.sso.description":`Gli utenti possono accedere al sistema CloudCC.com senza login in base al nome utente e al codice di autorizzazione.<br>Clicca l'URL qui sotto per accedere al sistema CloudCC.com: http://localhost:8080/ssologin.action?userName=admin@dev.com&authCode=dcc5c192facd7c08e124fbe93d8950b9 .<br>Usa i link qui sopra,'http://localhost:8080' sostituisci l'accesso della tua organizzazione al link.'admin@dev.com' sostituisci il nome utente dell'organizzazione.<br>'dcc5c192facd7c08e124fbe93d8950b9' sostituisci il codice di autorizzazione dell'organizzazione.`,
"errormessage_email_atleastonereceiver_z":`Devi selezionare o modificare un indirizzo di ricezione.`,
"C":`Riassunto del roll-up`,
"label.service.major.event.edit":`Modifica pietra miliare`,
"label.icon.9":`Servizio`,
"label.visualpage.notvalidate.check":`Pagine personalizzate non valide, si prega di fare riferimento al testo della Guida per controllare la pagina.`,
"label.audit.todo.from":`da`,
"label.directboss":`Questo ruolo riporta a`,
"label.manageAll.selpage":`Pagina`,
"label.console.step6.all":`A schermo intero, non fissato e le liste sono visibili solo quando la scheda di navigazione è selezionata.`,
"vue_label_pool_expiredate":`Data di scadenza`,
"lable.no.matching.record":`Nessun record corrispondente`,
"label.standard.redirecterror":`Il salto alla pagina personalizzata attraverso i pulsanti standard non è riuscito.`,
"label.Platform.Setting":`Impostazioni della piattaforma`,
"lable.outlook.edit.havenewc":`Contatti con attività create di recente`,
"label.partnerCloud.partnerAccount.choosePayment":`Si prega di selezionare un metodo di pagamento`,
"label.weixin.optionsix":`Scelta 6`,
"lable.SalesCommitmentKanBan.allCommitments":`Pipeline`,
"page_404_button_toknowmore":`Per saperne di più`,
"label.customfields.number.tip":`Permette agli utenti di inserire qualsiasi numero. Gli zeri iniziali vengono rimossi.`,
"label.import.index.processimport":`Importazione di`,
"label.quote.phone":`Telefono`,
"label.insert.approval":`Inserire l'approvazione`,
"label.tabpage.printview":`Stampa la Vista`,
"lable.product.price":`Prezzo`,
"front-kefu-moudle-call-detail":`Chiama i dettagli`,
"label.umeng.approval.apply":`applicare`,
"label.background.the.form":`Sfondo della forma`,
"chatter.f":`Seguaci`,
"label.quickbooks.searchresault.company":`Azienda`,
"vue_label_systemSettings_platformutils":`Strumento della piattaforma`,
"front-quotation-v1-nofilles-tocreate":`Cliccate su Generate Quote e inviate dopo la generazione.`,
"label.category.6":`Trattamento medico`,
"label.attendance.choose.positon":`Seleziona i punti di riferimento`,
"label.batchadd.newbatchpage.save.pho":`Formato del telefono non valido`,
"UG.Account.01":`Chi è il tuo account?`,
"label.marketseamemset.addspecialuser":`Aggiungere membri speciali`,
"label.query.detail.forbidpartneruser":`Vietato l'uso del partner`,
"label.stdashbord.xsld.business.ydzhl":`Tasso Won`,
"vue_label_SMS_mymessagebox":`La mia casella dei messaggi`,
"label.knowledgebase.data.publishing.failed":`Pubblicazione dei dati {a} fallita. Per favore scegli un articolo con stato uguale a Bozza da pubblicare.`,
"label.wholestate":`Stato generale`,
"label.selectedline":`Colonne selezionate`,
"label.validate.function.funcExplain.LEFT":`Restituisce il numero specificato di caratteri dall'inizio di una stringa di testo`,
"label.emailmerge.edittemplate.detail":`Dettagli del modello Mail Merge`,
"vue_label_checkduplicate_checkduplicate":`Controlla i duplicati`,
"label.knowledgebase.assign.articles":`Articoli per il montaggio`,
"label.tabpage.recordsz":`Record`,
"label.field.img.validate.error":`Il nome della variabile dopo $User è scritto male o è un riferimento illegale a $User, controlla l'ortografia.`,
"workorderlineitem.worktype.isnot.father.worktype":`Il tipo di lavoro associato al suo record padre di questo elemento dell'ordine di lavoro deve essere selezionato.`,
"label.ccchat.group.name.noexist":`Il nome del gruppo che hai inserito non esiste, per favore inseriscilo di nuovo.`,
"label.weixin.sign.type":`Errore di tipo Sign in (out).`,
"label.nowvaluereplace":`Sostituire con l'esistente`,
"report_label_report":`Rapporti`,
"label.knowledge.setting.plus":`Più impostazioni di conoscenza`,
"label.event.moveup.2day":`2 giorni prima`,
"label.translation.start":`Per iniziare nel Translation Workbench:`,
"lable.PowerProcess.created.time":`In base al tempo di creazione di {detailInterestType}`,
"label.ems.step2":`Passo 2`,
"label.tabpage.groupingemptyz":`Gli elementi del raggruppamento non possono essere vuoti`,
"pagecreator.layout.button.new":`Nuovo layout`,
"label.tabpage.listshow":`L'elenco mostra`,
"label.partnerCloud.productSet.optionName":`Nome dell'opzione`,
"label.service.without.cycle":`Nessun ciclo`,
"label.chatter.sendEmailToGroupMember.subject.V":`{0} ha pubblicato voti per tutti in {1}`,
"label_target_model_dimension":`Dimensione del modello di destinazione`,
"component.task.label.subject":`Tema`,
"label.custom.field.login.query.information":`Si prega di entrare nel sistema e visualizzare i dettagli.`,
"label.validate.function.funcExplain.NOT":`Cambiare FALSE in TRUE o cambiare TRUE in FALSE`,
"pagecreator_layout_button_horizontal":`Smontaggio laterale`,
"lable.Returned.to.successful":`Ritornare con successo`,
"label.campaign.channel.ticket.title":`Biglietto d'ingresso`,
"label.ruleName.supportMaximum.50Characters":`È supportato un massimo di 50 caratteri per il nome delle regole.`,
"label.email.track.attachment.size.control1":`La dimensione totale dell'allegato supera i 20m, non può essere caricato`,
"template.report.folder.opportunities":`Analisi delle opportunità`,
"label.knowledge.setting.data.eight":`Stai per cancellare il gruppo di categorie {flzmc} e le sue categorie. Questa categoria non sarà disponibile per l'assegnazione ai record. Hai 15 giorni per annullare la cancellazione del gruppo di categorie. Dopo 15 giorni, sarà cancellato definitivamente e non potrà essere recuperato. Sei sicuro di voler cancellare questo gruppo di categorie e le sue categorie?`,
"mail.id.notNull":`L'ID non può essere vuoto quando si cancella il modello`,
"vue_label_normal_product_sf":`Prodotto`,
"vue_label_report_superiortothisrelationship":`La relazione tra l'oggetto superiore e questo oggetto`,
"label.leadscore.operation":`Operatore`,
"label.customfields.formula.percentexample":`Sconto = (Importo - Importo_Sconto__c) / Importo`,
"component.setup.iframe.label.inputurlmemo":`Inserisci l'url della pagina da importare`,
"label.icon.177":`Logo`,
"label.tabpage.myz":`Il mio`,
"label.leadmarketsea.add.title":`Creare un pool di lead`,
"label.partnerCloud.partnerAccount.thePage":`Pagina {skippageNum}`,
"label.visualpage.some.size":`Capacità di codice: supporto massimo di 300KB di caratteri, circa 300.000 byte.`,
"label.setwxpay.null":`Le informazioni necessarie per configurare il pagamento WeChat sono vuote.`,
"label.icon.74":`Macchina utensile`,
"font-evaluate-module-v1-evbad":`Il tipo di valutazione è Negativo`,
"System.TimeField.Format.Warning":`Tempo non valido`,
"label.captcha":`Codice di verifica casuale`,
"label.payment.assessment":`Controlla le altre edizioni`,
"message.error.not.taskevent":`Oggetto evento non compito`,
"font-evaluate-module-v1-evaluation":`Valutazione`,
"vue_label_commonobject_view_updatedago":`Aggiornato {timeInterval} fa`,
"label.sendemail.birthday.newevent":`Caro {!ownerName}: il compleanno di {!objectLable} {!recordName} sarà tra 3 giorni. Per favore, siate consapevoli！rn {!orgName}`,
"label.laststep":`Passo precedente`,
"message.duplication.label.matchoption":`Opzione di abbinamento`,
"label.setupmultplerecordtype":`Tipi di record multipli`,
"vue_label_account_unprocessed_oppprtunities":`Opportunità non elaborate`,
"KeyInformationLayout.DefaultLayout.Name":`Predefinito del sistema`,
"label.partner.all":`Tutti i parter cloud`,
"label.datamanage.export.error":`Esportazione fallita`,
"label.standard.buttonandlink":`Pulsante o collegamento standard`,
"label.reportsSubscriptionPage.email":`Rapporto e-mail`,
"message.nogrammarfaultinformula":`Nessun errore di sintassi.`,
"front-kefu-moudle-nofind-instance":`Nessuna istanza trovata`,
"label.is.delete.data":`I record che vuoi cancellare contengono i record che richiedono l'approvazione, sei sicuro di voler cancellare?`,
"label.partner.error":`Errore: errore nel formato del dominio`,
"label.notification.time2":`{0} minuti fa`,
"label.ccchat.person.invite.needfirstname":`Inserisci il tuo nome`,
"label.mr.title.URL":`URL`,
"chatter.norecord":`Nessun record.`,
"label.readwrite":`Lettura/Scrittura`,
"label.partnerCloud.orderingPlatform.orderPayment":`Ordine di pagamento`,
"label.accesslimittype":`Livello di accesso`,
"label.preciew_tab":`Anteprima del link in una nuova scheda`,
"label.attachment":`Allegato`,
"label_tabpage_helpNavigationz":`Aiuto e navigazione`,
"label.dataimport.select":`Controllare queste informazioni, eseguire i dati di importazione`,
"chatter.en.info":`Inserisci le informazioni in modo che le persone possano saperne di più su di te.`,
"label.ccservice.validate.date":`Il formato del valore corrispondente {2} del campo {1} sotto l'oggetto API {0} non è corretto.`,
"label.social.posts.send":`Non è riuscito a postare`,
"label.emailobject.time.to":`A:`,
"label.defineReportStep1":`Passo 1`,
"savefail":`Salvataggio fallito`,
"label.mr.descreption.title":`Unire i dati duplicati`,
"label.share.info.by":`Da`,
"label.list":`Lista`,
"label.event.select":`Selezionato`,
"message.accountmap.cannotfind":`L'indirizzo del conto non è stato trovato, si prega di aggiornare l'indirizzo del conto.`,
"label.choosefield":`Campi della pagina di approvazione`,
"label.forecast.settings.title":`Impostazioni delle previsioni`,
"label.setup.log.datetime":`Scarica il registro del comportamento all'interno dell'intervallo di tempo di ricerca (Excel.xls)`,
"button_partner_new":`Nuova nuvola di partner`,
"label.umeng.approval.dlsp.reject":`#approvalname ha respinto la richiesta di approvazione di #actorname di #objAPIName #recordname per te.`,
"label.tabpage.totalTeamz":`Un totale di gruppi`,
"label.lead.score.prompt3":`Questo può richiedere diversi minuti. Riceverai un'e-mail di conferma una volta completato.`,
"label.schedulejob.setup.schedule.name":`Nome del lavoro`,
"vue_label_report_advanced":`Quando il filtro avanzato è abilitato, scrivere manualmente la condizione del filtro nella casella del filtro avanzato sottostante; il formato è mostrato nella figura.`,
"label.emailsync.form.connecttime":`Tempo correlato`,
"front-gantt-module-v1-project-status":`Stato del progetto`,
"label.field.for.example":`Per esempio`,
"label.marketsea.manager.notnull":`L'amministratore non può essere vuoto.`,
"label.click.here":`&lt&lt Clicca qui per tornare indietro`,
"UG.solution.04":`Soluzione di importazione`,
"label.validate.function.funcExplain.IF":`Se la condizione è vera o no, e se la condizione è VERA restituisce un valore e la condizione è FALSA, viene restituito un altro valore.`,
"label.profile.settab":`Impostazioni della scheda`,
"front-email-payment-weichat-tips":`Scansione del codice QR per pagare`,
"label.task.next.week":`La prossima settimana`,
"label.operatedata.selectobjectfields.tip":`Seleziona i campi che vuoi esportare, e devi selezionare almeno un campo da esportare.<font color="red">Attenzione: l'area di testo (Rich) non può essere esportata.`,
"label.recalculate.alert":`Seleziona la regola di condivisione che vuoi ricalcolare.`,
"label.marketsea.noopportunitydays":`Giorni senza creare opportunità di business (devono essere maggiori del numero di giorni senza follow-up dopo aver ottenuto)`,
"label.chat.likeperson":` Persona/e`,
"label.selectedFields":`Campi disponibili`,
"label.App":`Applicazioni`,
"label.file.type":`Tipo di file`,
"permissionService.error1":`Licenza di applicazione insufficiente.`,
"front-detail-module-v1-chart-display":`Visualizzazione del grafico`,
"label.audit.status":`Stato di approvazione`,
"UG.activity.05":`Telefono di registrazione`,
"label.connectOtherObject":`( Clicca per mettere in relazione un altro oggetto )`,
"lable.currencyManage.unEnabledadvcurrency":`Disattivare la gestione avanzata della valuta`,
"label.ccpeak.getthree.function":`Ci sono tre funzioni e`,
"label.weixin.new.weitoupiao":`Si prega di creare un nuovo micro voto, gli utenti possono partecipare al voto e accedere ai risultati del voto nei micro eventi su WeChat.`,
"label.tag.manage.prompt":`L'etichetta è già uscita!`,
"label.goon":`Continua`,
"label.addworkflowoperate":`Aggiungi azione del flusso di lavoro`,
"label.weixin.click.search":`Clicca per cercare il record`,
"vue_label_report_deletecolumn":`Cancellare la colonna`,
"label.ordercondition":`Ordina per`,
"message.error.group.notallow":`Il gruppo non permette l'archiviazione`,
"label.unread":`Email non lette`,
"vue_label_report_notice_namerequired":`Il nome della colonna è richiesto`,
"label.tabpage.entercontent":`Si prega di inserire il contenuto`,
"label.schedulejob.setup.schedule.startdate":`Data di inizio`,
"component_assistant_button_newtask":`Nuovo compito`,
"vue_label_report_notice_filter1":`Devi riempire manualmente i filtri avanzati qui sotto come mostrato nell'immagine quando abiliti il filtro avanzato`,
"value":`Valori`,
"label.icon.70":`Servizio`,
"label.knowledgebase.delete.draft.t":`Cancellare la bozza`,
"label.setup.mini.bind":`Rilegare i mini programmi`,
"component_timeline_button_more":`Altri passi`,
"label_emailtocloudcc_redmessage4":`Si prega di inserire i dettagli della porta`,
"label.field.input.number":`Si prega di inserire i numeri validi`,
"front-invoice-online-payment-setup-title":`Iniziare il pagamento online`,
"front-kefu-moudle-called-user":`Persona chiamata`,
"label.currency.disable":`Valute inattive`,
"label.user.alias":`Alias`,
"UG_quota_04":`Stampa preventivo`,
"label.chatter.delete":`Cancellare`,
"label.addtocurrentcustomer":`Allegati a conti esistenti`,
"message.error.recordid.null":`recordid non può essere vuoto!`,
"label.merge.records":`Unire i record`,
"report_label_norole":`Non hai il permesso di farlo, per favore contatta il tuo amministratore.`,
"label.pqrs":`.`,
"label.email.attach.button":`Fare clic sul pulsante "allegare".`,
"label.tabpage.selrecordtypez":`Seleziona il tipo di registrazione`,
"label.ServiceCloud.purchase.date":`Data di acquisto`,
"label.customreporttype.delete.prompt":`Per favore, cancella il seguente rapporto prima di eseguire l'operazione di cancellazione`,
"label.brief.total.page":`Un totale di {totale} pagine`,
"label.reportsSubscription.unsubscribe":`Cancella l'iscrizione a`,
"label.ccpeak.take.notice.exp.order":`Note: deve aggiungere "__c" dopo il nome API dei campi nelle condizioni exp e di ordinazione.`,
"report_type_label_quote":`Citazioni`,
"label.file.norecord":`Nessun elemento da visualizzare`,
"vue_label_checkduplicate_all_processed":`Tutti i dati sono stati elaborati`,
"label.next":`Prossimo`,
"label.icon.10":`Cartella`,
"label.lanxin.title.setting":`Informazioni integrate`,
"label.h5.chatter.business":`Opportunità associate`,
"lable.are.you.sure.to.delete.this.view":`Vuoi cancellare questa vista?`,
"vue_group_no_operation_permission":`Nessun permesso di operare!`,
"label.knowledge.archive.article":`Archivio articoli`,
"vue_label_lead_":`Nessuna regola di punteggio attiva disponibile, si prega di contattare l'amministratore del sistema`,
"label.fiscal.error.between":`La data di inizio dell'anno fiscale o la data di fine dell'anno fiscale è tra gli anni fiscali della storia, si prega di controllare e reimpostare`,
"label.stdashbord.xsld.business.qdzje":`Importo totale (opportunità chiuse e vinte)`,
"label.calendar.day.view":`Vista del giorno`,
"label.emailtocloudcc.tip":`Prompt`,
"label.schedulejob.setup.schedule.st1":`Il 1°`,
"label_tabpage_addtoworkbench":`Aggiungi alla homepage banco di lavoro`,
"label.umeng.approval.waitapproval":`attendere l'approvazione`,
"label.justcheckingwebsite":`Verifica solo il sito web`,
"homepage.components":`Componenti della pagina iniziale`,
"label.audit.remark":`Note di approvazione`,
"label.searchs.labelname":`Cerca {fieldlabelName}`,
"label.remarkofreport":`Relazione Nota`,
"label.weixin.isno":`se`,
"label.currencyCode":`Codice valuta`,
"label.service.resources":`Risorse`,
"label.clone_form":`Forma del clone`,
"label.weixin.view.information":`Visualizza i dettagli`,
"UG_activity_05":`Telefono di registrazione`,
"chatter.feed.menutype.user.recentuser":`Persone che hanno visto di recente`,
"label.marketsea.notfollowdays2":`Giorni senza follow-up`,
"label.tabpage.namemandatory":`Il nome della vista è richiesto`,
"message.demo.nosupport":`Questa caratteristica sarà introdotta nella prossima release.`,
"label.mail.merge.template":`Unire i modelli di e-mail ......`,
"label.sendemail.marketactivity.sign":`Notifica del cartello della campagna`,
"setup_layout_group_relatedlist":`Elenchi correlati`,
"label.pc.ui.2018.all.tabs":`Tutto il menu`,
"label.field.lost.right.bracket":`La staffa di chiusura è persa`,
"label.datamanage.contact.novalue":`Nota: se il campo del nome del contatto è nullo, i record del contatto non saranno importati.`,
"label.version.unlimited.edition":`Edizione illimitata`,
"vue_label_dashboard_selectsortfield":`Si prega di selezionare il campo di selezione`,
"label.partnerCloud.productSet.instructions":``,
"front-kefu-moudle-v1-canuse-obj":`Visibile a`,
"thursday":`Giovedì`,
"label.nextapprover":`Prossimo approvatore`,
"setup_mainpage_label_manageuser":`Gestire gli utenti`,
"label.saveandcontinue":`Salva`,
"label.top.userCenter":`Centro personale`,
"component.chatter.file.button.save":`Pubblica`,
"label_emailsync_setting":`Impostazioni e-mail personali`,
"label.usableshareuser":`Disponibile condiviso a`,
"label.customfields.optionlist.fieldvaluelist.letterrank":`Visualizza i valori in ordine alfabetico, non nell'ordine di inserimento`,
"label.list.button":`Assegnazione del profilo`,
"chatter.up.m":`Errore:I file caricati sono troppo grandi.La dimensione massima del file è 20 MB.`,
"label.knowledgebase.filters":`Filtri {a}`,
"label.sso.saml.sp.idtype.username":`L'asserzione contiene il nome utente CloudCC dell'utente`,
"vue_label_file_size_limit":`La dimensione del file non supera {size}Mb`,
"label.appupload.install.error.choice4":`Saltare i componenti in conflitto, non installare i componenti in conflitto`,
"label.currencyDecimalDigits":`Posizioni decimali`,
"label.weixin.customer.details":`Dettagli del conto`,
"component.timeline.label.7daysahead":`7 giorni prima`,
"label.sendsms.batch.step1":`Passo 1 Specificare i destinatari da includere`,
"label.brief.opportunity1":`Opportunità`,
"label.datamanage.click.importbutton":`Clicca su <b>Importa</b> e i dati saranno importati nel sistema CloudCC.`,
"label_filter_benchmark_objects":`Oggetto di riferimento del filtro`,
"label.area.record.notexist":`Il disco non esiste.`,
"label.event.overdue.unfinished":`Eventi scaduti`,
"label.file.publicview.errortype":`Il tipo di file non supporta l'anteprima`,
"label.setup.mobile.bottombutton.profile.setting":`Personalizzare il menu inferiore del profilo`,
"label.campaignmember.main.addleaddesc":`Aggiungi tutti i lead esistenti a questa campagna`,
"vue_label_approve_actual_operator":`Operatore attuale`,
"label.version.essential":`Edizione essenziale`,
"lable.SalesCommitmentKanBan.commitments":`Pipeline`,
"label.chatter.pastEvents":`Attività passate`,
"vue_label_calendar_choose_calendar_type":`Scegliere il tipo di calendario`,
"label.service.dispatchingUnits.batch.send":`Assegnazione batch`,
"chatter.poll.option8":`Scelta 8`,
"label_tabpage_summaryway":`Metodo riassuntivo`,
"front-kefu-moudle-trindex-copy-num":`Si prega di copiare il numero di impresa nella homepage del sistema Tianrun`,
"lable.quote.syncing.syncfinish":`Sincronizzazione completata`,
"label.home.task.finish":`Compito completato`,
"label.toleadfield":`Mappa Campi di piombo`,
"label.everyone":`Tutti`,
"label.multilang.databatchadd.success":`{0} i dati sono stati aggiunti con successo：`,
"label.quote.createdate":`Creare la data`,
"email.template.nopermission":`Solo gli amministratori possono modificare i modelli in questa cartella`,
"label.report.action.addtodashboard2":`Aggiungere il cruscotto`,
"label.campaign.name":`Nome della campagna`,
"label.check.input.condition":`Errore di sintassi, controlla i criteri di filtraggio inseriti`,
"front-epwechat-module-v1-upload-file":`Caricare il documento di credito:`,
"label.batchadd.newbatchpage.button.add":`Aggiungere una riga`,
"label.partnerCloud.footer":`Piè di pagina`,
"lable.Enter.template.name":`Inserisci il nome del tamplate.`,
"label_tabpage_last":`Ultimo passo`,
"label.setup.mobile.bottombutton.setting":`Impostazioni della pagina di primo livello dell'applicazione mobile`,
"label_emailtocloudcc_filed_emailto":`Email a`,
"label.data.downpage.e_title.num3":`3. Gli utenti possono creare modelli di esportazione secondo le loro esigenze e selezionare la voce "Export By Template", che può rendere l'operazione di esportazione più conveniente.`,
"startwith":`Inizia con`,
"vue_label_normal_cancel":`Cancella`,
"label.reportTypcrtD":`Oggetto associato (d) clicca per selezionare l'oggetto correlato`,
"label.globalselect.disabledvalue":`Valore non valido`,
"vue_label_commonobjects_view_notice_deletecertification":`Sei sicuro di voler cancellare i record { selectNum } selezionati?`,
"front-epwechat-module-v1-bound-role":`Ruoli legati`,
"label.partnerCloud.financeSetting.gaofilter":`Anticipa le condizioni del filtro (ad esempio 1 e 2 o 3)`,
"label.quote.sprname":`Nome della fatturazione`,
"lable.asset.successfully":`Trasferire il prodotto all'attività con successo.`,
"label.projectManagement.service.appointment.work.noedit":`Impossibile modificare l'ora di lavoro dell'appuntamento di servizio`,
"lable.tianyancha.h5.inputandsearch":`Inserisci le parole chiave per cercare aziende rilevanti`,
"label.customcomponent.check.tag.firstrow":`La prima linea deve essere`,
"label.knowledgebase.published.translations":`Anche le traduzioni pubblicate saranno archiviate e la traduzione in stato di Bozza sarà cancellata.`,
"vue_label_wang_yi":`Tom`,
"label.step3.total3":`Passo 3 di 3`,
"label.stdashbord.xsld.business.img6":`Quantità totale di fasi di opportunità con probabilità 100%/(Quantità totale di fasi di opportunità con probabilità 100% Quantità totale di fasi di opportunità con probabilità 0%)`,
"component_button_cancel":`Cancella`,
"label.delete.false.not.exists":`Eliminazione fallita, perché i dati non esistono.`,
"label.appupload.install.error.choice1":`Si prega di non installare`,
"label.Days.After.Horizontal.Date":`livello data dopo`,
"setup_layout_button_additem":`Aggiungere gli elementi selezionati`,
"UG.contact.05":`Creare un contatto`,
"label.form.title":`Titolo del modulo`,
"label.horizontalbar-group":`Raggruppamento linee orizzontali-riga`,
"component_sendmail_label_title":`Inviare e-mail`,
"label.passwordPolicy.setup.neverexpires":`Non scade mai`,
"label.sso.saml.idp.config.desc1":`Abilitare CloudCC.com come provider di identità in modo da poter utilizzare il single sign-on con altri siti web`,
"label.chat.topic.desc.null":`Imparare qualche informazione su questo argomento? Nel menu a tendina in alto a destra, seleziona modifica dettagli.`,
"label.movablecustomerfield":`Campi personalizzati Acitivity`,
"label.trigger.folder":`Cartelle di trigger non archiviate`,
"label.selectuploadfile":`Seleziona un file da caricare.`,
"front-email-payment-card-tips":`Inserire il numero della carta`,
"label.tabpage.addcondition":`Aggiungere la condizione`,
"label.number.MinAndMaxCheck":`Il minimo di {0} è {1}, il massimo è {2}. Modifica la quantità e salva le modifiche.`,
"vue_label_dashboard_dashboard":`Rinominato con successo il cruscotto`,
"label.objectDeleteList":`Elimina l'elenco degli oggetti`,
"lable.service.gantt.and":`E`,
"label.emailtocloudcc.step2":`Passo 2`,
"label.chatter.postup":`Posta in alto`,
"label.personalsetting":`Impostazioni personali`,
"message.please.choose.permission":`Selezionare l'accesso`,
"label.mobile.move":`App mobile`,
"label.Choose":`Scelte`,
"label_chatter_vote":`Sondaggio`,
"label.weixin.user.select.one":`Seleziona un utente`,
"pagecreator.page.label.modifypage":`Editore di pagina`,
"label.select.partOrField":`Scegliere le sezioni o i campi da controllare`,
"vue_label_helpcenter_chat":`1. Instant messaging<br> Team può sostituire WeChat aziendale, ecc., permettendo di inviare messaggi di testo, file, ecc. ai colleghi dell'azienda mentre si lavora nel sistema CRM. Quando ogni reparto dell'organizzazione ha bisogno di stabilire un gruppo di discussione di reparto, il capo reparto può avviare una chat di gruppo in Team e aggiungere i membri del reparto alla chat di gruppo.<br> 2. Crea chat di gruppo per i clienti e i record di opportunità commerciali<br> Apri la pagina dei dettagli del cliente o dell'opportunità commerciale e clicca sul pulsante "Team" nell'angolo in alto a destra per creare una chat di gruppo su questo record nel Team. Se la chat di gruppo non è stata creata dal proprietario del record, il proprietario del record sarà automaticamente tirato nella chat di gruppo. Altri possono entrare nella chat di gruppo cliccando il pulsante "Team" nell'angolo in alto a destra della pagina dei dettagli del record o dopo essere stati aggiunti dal proprietario del gruppo.<br> 3. Traccia i record nella chat di gruppo<br> Crea una chat di gruppo per i clienti e i record di opportunità commerciali secondo il metodo in 4.2, e puoi tracciare la dinamica dei record nella chat di gruppo inviando delle schede. Se l'utente ha l'accesso per visualizzare i record sulla scheda, quando l'utente clicca sulla scheda, può saltare direttamente alla pagina delle informazioni dettagliate dell'oggetto corrispondente.<br>Traccia i cambiamenti di campo dei record nella chat di gruppo<br> Quando il record è configurato con la lista correlata "Tracciamento campo" e i campi che devono essere tracciati sono configurati, quando il campo tracciato cambia, l'assistente della strategia di gruppo nella chat di gruppo invierà una scheda con le informazioni sul cambiamento del campo al gruppo.<br> Tenere traccia di tutti i cambiamenti nelle chat di gruppo<br> Quando il proprietario del record cambia, l'assistente strategico di gruppo nella chat di gruppo invierà una scheda con le informazioni di cambiamento del proprietario al gruppo.<br>Tracciare le attività nelle chat di gruppo<br> Dopo la creazione della chat di gruppo del record, se viene creato un nuovo compito o un evento su questo record, l'assistente strategico di gruppo nella chat di gruppo invierà una scheda con le informazioni di base sul compito o l'evento al gruppo.<br> Tracciare e registrare il nuovo record dell'elenco correlato nella chat di gruppo<br> Dopo che la chat di gruppo record è stata creata, quando il record dell'elenco correlato viene aggiunto, l'assistente del team nella chat di gruppo invierà una scheda con le informazioni di base del record appena aggiunto al gruppo. Per esempio: quando un nuovo contatto viene aggiunto alla lista dei contatti dei record dei clienti, una scheda "Nuovo contatto" sarà ricevuta nella chat di gruppo dei clienti, e le informazioni di base del nuovo record possono essere viste sulla scheda.`,
"label.tianyancha.business":`Informazioni sulla registrazione del business`,
"chatter.group.groupMembersToFind":`Ricerca dei membri del gruppo`,
"label.pc.ui.2018.pin.top":`Spillo in alto`,
"label.forecast.forehistory.submitor":`Inviato da`,
"vue_label_email_send_emails_separately":`Inviare e-mail con successo`,
"vue_label_homepage_select_display_field":`Seleziona il campo`,
"label.partnerCloud.partnerAccount.accountBalance":`Equilibrio`,
"label.sendemail.template":`Seleziona il modello di e-mail`,
"label.service.violated":`Violato`,
"label.manageAll.title":`Centro di approvazione`,
"label.forecast.settings.qy":`Abilitare la condivisione delle previsioni`,
"label.detailofshare":`Condividere i dettagli della regola`,
"label.multilang.passwordpolicy.chechlength":`Errore: La password non deve avere meno di {0} caratteri:`,
"label.visualpage.filesave.error":`File salvato non riuscito, per favore riprova.`,
"vue_label_campaign_please_select_member_status":`Seleziona lo stato di membro`,
"homepage.components.sort":`Ordinare i componenti`,
"label.brief.thismonth":`Questo mese`,
"label_emailsync_connectaccount_description":`Aggiungi qui la tua casella di posta personale, e il CloudCC abbinerà automaticamente i lead e i contatti nel sistema in base ai loro indirizzi e-mail, sincronizzando il contenuto delle e-mail ai record per facilitare il monitoraggio e la comunicazione.`,
"label.sms.csid":`Numero di firma`,
"label.ccdocument.remark":`Descrizione del documento`,
"label.forecast.customforecast.disdw":`Unità di visualizzazione`,
"label_tabpage_field":`Campo`,
"label.logintime.all":`Tutto il giorno`,
"UG_Account_06":`Creare un account`,
"label.login":`Accesso`,
"label.dupicate.data.error":`Trova i record duplicati e l'errore di fusione, per favore controlla.`,
"label.monitorsys.recent.logs":`Gli ultimi 200 log sono visualizzati per impostazione predefinita.`,
"message.chooseatleastonefield":`Scegliere un campo almeno`,
"lable.PowerProcess.name1":`Nome del processo di abilitazione`,
"label.processdetail":`Dettagli sulla definizione del processo`,
"label.upload.file.size.limit":`I file caricati non devono superare i 2MB!`,
"label.forecast.userenablepage.desc":`Gli utenti abilitati per le previsioni appaiono nell'elenco Utenti abilitati. Per abilitare gli utenti disponibili, aggiungili all'elenco Enabled Users. Per disabilitare gli utenti, rimuovili.`,
"label.visualpage.type.detailembed":`Istruzione d'uso della pagina personalizzata (lo stile della pagina è "detailEmbed")`,
"label.textmessage.vonage.configurations":`Configurazioni`,
"label.report.select.chart.and.item":`Seleziona il grafico e la voce in evidenza`,
"label.data.downpage.i.title.num1":`1. Il sistema supporta solo il comune formato CSV.`,
"label.mobileapp.scansetting":`Impostazioni della funzione di scansione dell'app mobile`,
"chatter.emailFollow":`Segue`,
"label.weixin.businformation":`Dettagli del veicolo`,
"label.import.index.recentrecord":`Record di importazioni recenti`,
"label.case.update":`Aggiornamento`,
"label.isEnableVisualpage.new.desc":`Seleziona una pagina personalizzata disponibile da Availble Custom pages e aggiungila a Selected Custom Pages, clicca su Save. Quindi gli utenti con questo profilo hanno accesso alle pagine personalizzate attive.`,
"label.emailobject.wizard.title":`Collega la tua e-mail`,
"vue_label_ccchat_notice_deletepostsuccess":`Post cancellato con successo`,
"label.deleteQuoteLine":`Cancellare la linea delle citazioni`,
"label.integrations.export.failed.Mailchimp":`L'esportazione non è riuscita, controlla la tua connessione di rete e riprova più tardi`,
"label.increase":` Più`,
"label.setup.mobile.homepageshortcuts.setunable":`Il modulo non appare nella homepage`,
"label.ccchat.person.invite.toolong":`Non si può inserire un testo che superi i 255 caratteri`,
"label.knowledge.setting.help":`Aiuto al self-service del cliente`,
"label.is_pigeonhole":`Archivio`,
"message.atleastonecommitter":`Almeno uno presentato da chi`,
"label.emailobject.wizard.desc4":`Inserire un tempo di proposta per facilitare l'appuntamento a più persone`,
"APPIntegration_Dropbox_setting_02":`Disabile`,
"template.report.open.opportunities":`Opportunità non chiuse`,
"label.goonwork":`Continuare a lavorare`,
"label.isiands.time":`Il tempo delle isole`,
"label.enable.rules.enableOnlyOneqrcodeOrbarcode":`Regole abilitate (ogni oggetto supporta solo un QR Code o un codice a barre)`,
"label.summaryreport.2018.step2":`Passo 2 Riassumere le informazioni per:`,
"pagecreator.systemstyle.message.delete.success":`Stile cancellato con successo`,
"label.standarduser":`Utenti standard`,
"label.reportsSubscription.succeeded":`Sottoscrivi il rapporto con successo!`,
"lable.Select.a.template":`Seleziona un modello esistente come base del nuovo modello.`,
"label.file.library.addfile2libsuccess":`{0} file caricati!`,
"label.searchfield.instruction":`Il campo di ricerca è un campo che viene utilizzato per la ricerca globale o la ricerca di un singolo oggetto.`,
"U":`URL`,
"label.Time.slot.overlap":`Una o più fasce orarie si sovrappongono. Si prega di aggiornare a una fascia oraria che non si sovrappone.`,
"vue_label_chat_opportunity_details":`Dettagli dell'opportunità`,
"label.knowledge.category.hint.seven":`Gruppo di categoria selezionato`,
"label.chatter.list":`Lista`,
"front-email-payment-Invoice-preview":`Anteprima della fattura`,
"label_emailsync_message1":`Se cancelli la connessione, non sarai in grado di sincronizzare il contenuto della casella di posta con i lead e i contatti, sei sicuro di voler cancellare?`,
"label.summaryreport.step5":`Passo5 Specificare l'ordine delle colonne nel rapporto`,
"component_newrecords_label_name":`Nome`,
"label.appointment.wizard.subtitle4-4-5":`2 mesi`,
"component_salesperformance_label_title":`Prestazioni di vendita`,
"label.ccchat.person.invite.says":`Dite:`,
"label.fax":`Fax`,
"label.knowledge.modify.article":`Modificare l'articolo`,
"label.componenteditor.Limit.number.components":`Si possono aggiungere fino a 15 componenti in una singola pagina.`,
"label.multilang.forecast.shrepage.desc":`Questa pagina elencherà gli utenti, i ruoli e le regioni che hanno accesso condiviso a {0}.`,
"label.chat.micropost.write.comment":`Scrivere commenti`,
"Lead.Scoring.Setting.Rule.Setup.Active":`Attivo`,
"label.ccpeakfolder.time":`Cartelle di classe programmate`,
"label.partnerCloud.financeSetting.filter":`Condizioni del filtro:`,
"label.knowledge.delete.topicassignment":`Errore durante la cancellazione dell'assegnazione del soggetto`,
"label.file.orderbyname":`Ordina per titolo`,
"vue_label_chat_activelater":`Attivo più tardi`,
"chatter.reply":`commento`,
"label.setup.profile.accordtext":`Secondo il testo`,
"label.encd.plaintext":`Mostra testo chiaro`,
"label.h5.approval.cannotreassignmark":`I progetti di approvazione delegati non possono essere riassegnati, riselezionare i progetti di approvazione`,
"label.version.area.lookup":`{0} area di testo o campi con relazione di ricerca (multiselezione)`,
"approval.request.email.body":`Le seguenti voci stanno richiedendo l'approvazione: cliccare sul link qui sotto per approvare: \n`,
"label.user.mass.emails.select":`Email di massa: Seleziona il modello`,
"lable.quote.syncing.title":`Sincronizzare citazioni e opportunità`,
"vue_label_dashboard_dashboardaccess":`Accesso al cruscotto`,
"label_emailtocloudcc_filed_owner":`Proprietario`,
"label.brief.page":`Pagina`,
"label.isEnableVisualpage_new.desc":`Seleziona una pagina personalizzata disponibile da Availble Custom pages e aggiungila a Selected Custom Pages, clicca su Save. Quindi gli utenti con questo profilo hanno accesso alle pagine personalizzate attive.`,
"label.service.shift.view":`Vista dei turni di lavoro`,
"label.emailsync.addnewaccount":`Aggiungi un nuovo account`,
"label.forecast.settings.prompt":`Disable forecast sharing rimuoverà tutti gli accessi condivisi manualmente.`,
"front-electronic-signature-explain-second":`Quando si lega la firma elettronica, si prega di preparare la foto della licenza aziendale e il codice di credito sociale unificato.`,
"label.emailtocloudcc.redmessage3":`Inserisci l'indirizzo del server`,
"message.confirmgiveupedit":`Se lasci questa pagina, perderai tutte le modifiche non salvate. Vuoi continuare?`,
"label.gantt.plan.success":`Programmato con successo`,
"label.monitorsys.type.error":`Seleziona il tipo di ricerca.`,
"label.industrialandcommercialverification.button.setup":`Impostazione`,
"today":`Oggi`,
"label.attendance.setting.position":`Impostare i punti di riferimento`,
"chatter.mynews":`I miei messaggi`,
"label.recycle.dis.tip1":`Il sistema conserverà i dati nel cestino per 15 giorni, e i record saranno cancellati definitivamente 15 giorni dopo l'inserimento dei record nel cestino.`,
"label.icon.81":`Refrigerazione`,
"label.customer.tab.page.prompt":`Si prega di configurare almeno una pagina!`,
"label.globalselect.use":`Usa il valore dell'elenco delle opzioni globali impostato`,
"template.report.customer.sales.order":`Ordine di vendita di conti con diversi livelli`,
"vue_label_dashboard_lastruntime":`Ultimo tempo di esecuzione`,
"label.edit.ccpeakfolder":`Classi: Modifica cartella`,
"vue_label_lead_be_converted":`È stato convertito e non può essere convertito`,
"label.tabpage.filenamez":`Nome del file`,
"label.please.click.add.products.":`Clicca su "Aggiungi prodotto" per aggiungere il prodotto al listino.`,
"label.followup_emails":`Una volta che un visitatore ha inviato un modulo, seguire con un'email è un modo semplice per connettersi rapidamente con loro`,
"label.indochina.time":`Tempo di Indocina`,
"message.error.task.email":`Anomalia del compito di posta`,
"label.dynamic.copy":`Copiare sincronicamente le regole di layout`,
"label.log.d":`Scarica il registro di audit nell'intervallo di tempo di ricerca (file Excel.csv) >>.`,
"pagecreator_layout_label_layoutname":`Nome del layout`,
"template.chart.htsktj":`Statistiche di raccolta dei contratti`,
"label.appointment.wizard.subtitle4-2-5":`1 giorno`,
"label.view_form":`Visualizza il modulo`,
"label.tablet":`Tablet`,
"label.campaignmember.main.addcontact":`Aggiungi membri - Contatti esistenti`,
"message.get.userinfo.error":`Impossibile ottenere informazioni sull'utente`,
"label.department.username":`Nome utente`,
"label.ems.verifysuccess":`Account e-mail verificato con successo!`,
"label.batchedit.copyValue":`Applica a questa colonna`,
"label.trigger.triggerVersion":`Versione`,
"label.mr.descreption.oneGroupReData5":`gruppi di dati non elaborati.`,
"label.appointmentconfirmpage.wizard.subtitle5":`Descrizione`,
"label.weixin.inbetween":`Multi-Select`,
"label.salescloud.contactrole.relatelist.customnize":`Non è possibile personalizzare questo elenco`,
"label.data.exp.please.nameanddes":`Inserisci il nome e la descrizione del modello.`,
"label_partner_workspace_login":`Pagina di accesso`,
"label.notification.approval7":`【被委派人名称】 ha respinto la richiesta di approvazione di 【提交人】 di 【对象】【对象名称】 per te.`,
"message.send.posts.image.error":`Il caricamento dell'immagine non è riuscito!`,
"message.fieldtrack.operateupdate":`Cambiato`,
"label.sharerule.grantuselevelconstructureaccess":`Concedere l'accesso usando le gerarchie`,
"label.translation.setup":`Impostazione multilingue`,
"PageLayout.Search.MultiSearch.003":`Seleziona almeno un campo.`,
"label.ccchat.person.emaildomain":`Dominio e-mail aziendale`,
"pagecreator.systemstyle.label.bordercolor":`Colore del bordo`,
"label.submit":`Invia`,
"UG.Lead.001":`Come introdurre gli indizi?`,
"label.icon.172":`Mappa`,
"label_chatter_owner":`Proprietario`,
"vue_label_systemSettings_Currency":`Gestione della valuta`,
"page.layout.binfo":`Informazioni essenziali`,
"label.version.date":`{0} campi data`,
"label.data.is.woking":`Funzionamento`,
"label.customfields.searchrelation.dependobjectDefault.tip":`Puoi selezionare un record nell'elemento correlato come valore predefinito per questo campo`,
"label.partnerCloud.orderingPlatform.configuration":`Prodotti Confugure`,
"lable.currencyManage.Enabledadvcurrency":`Abilita la gestione avanzata della valuta`,
"label.event.moveup.3hour":`3 ore avanti`,
"label.reportexport.object":`Esportazione di oggetti`,
"front-dialog-module-v1-requestid":`ID richiesta`,
"label.pw.symol":`Simboli`,
"label_group_field":`Specificare il campo di raggruppamento`,
"label.recallapprove":`Richiesta di approvazione del richiamo`,
"vue_label_pool_deal_done":`Accordo chiuso`,
"label.shangqing.description":`Questa è una descrizione della situazione aziendale`,
"label.view.allcansee":`Visibile a <b>tutti gli utenti</b>`,
"chatter.poll.addOption":`Aggiungi altro`,
"label.icon.112":`Cibo`,
"label.ignorecase":`Trattare "ABC" e "abc" come valori duplicati (case insensitive)`,
"label.email.track.edit":`Modifica email`,
"label_tabpage_erraddressz":`Formato errato dell'indirizzo e-mail, inserire correttamente l'indirizzo e-mail`,
"label_tabpage_viewz":`Stampa la vista corrente`,
"component.timeline.label.future":`Prossimo passo`,
"label.b_c_without":`I record "B" possono avere o meno record "C" correlati.`,
"label.version.autonumberfield":`Campo numero automatico`,
"label.appointmentdetail.wizard.title5":`URL dell'invito`,
"label.weixin.addoption":`Aggiungi opzione`,
"label.b.c":`Relazione da B a C`,
"chatter.group.complete":`Completa`,
"label.must.numeric.value":`Il costo deve essere numerico.`,
"lable.edit.queue.memberdes":`Per aggiungere membri a questa coda, seleziona un tipo di membro, poi scegli il ruolo o l'utente dai "Membri disponibili" e spostali nei "Membri selezionati". Se il modello di condivisione per tutti gli oggetti nella coda è Public Read/Write/Transfer, non è necessario assegnare utenti alla coda, poiché tutti gli utenti hanno già accesso ai record per quegli oggetti.`,
"label.staticresource.chose.limit":`I file in questo formato non sono temporaneamente supportati. Si prega di attendere il miglioramento di questa funzione.`,
"vue_label_commonobjects_view_kanban_unset":`Seleziona la base di raggruppamento nelle impostazioni della vista Kanban`,
"label.appexchange.download.merge.mes":`I seguenti componenti in conflitto sono installati attraverso un merge:`,
"label.sharerule.baseofowner":`In base al proprietario del disco`,
"label.email.template.manage.SMS":`Gestire il modello SMS`,
"label.imgfield.example.tip":`L'icona verde significa approvato e l'icona rossa significa rifiutato.`,
"template.report.potential.customer.industry":`Porta l'industria`,
"component_hots_label_title":`Offerte calde`,
"label_file_use_document":`Utilizzo dello spazio di archiviazione`,
"label.input.path":`Inserisci il percorso del file`,
"label.partnerCloud.financialSetup":`Impostazione finanziaria del partner`,
"label_tabpage_myz":`Il mio`,
"vue_label_pool_discard1":`{1}{2}`,
"label_emailtocloudcc_tip2":`Dopo la cancellazione, non sarai in grado di usare Email to CloudCC, sei sicuro di voler cancellare?`,
"label.customfields.fielddependency.sure":`Il campo di controllo non include il valore del campo dipendente. Vuoi continuare?`,
"label.project.task.date":`La data del compito deve essere all'interno dell'intervallo di date della pietra miliare a cui appartiene.`,
"Report.CantDelete.Info":`Il rapporto {0} è l'origine dei dati per il cruscotto {1} e non può essere cancellato!`,
"label.assignment.setup.title":`Regole di assegnazione`,
"image.pt.most.maxsize":`La dimensione massima del file è di 2 MB.`,
"label.appupload.introduce":`Un pacchetto contiene componenti come app, oggetti, schede, trigger o pagine.Questi pacchetti possono essere pubblicati su CloudCC App Store per condividerli pubblicamente.L'elenco sottostante mostra tutti i pacchetti creati dalla tua organizzazione. Per creare un nuovo pacchetto, fai clic su New.`,
"label.import.page2.confirm":`Confermare`,
"label.console.step2.introduce":`Compila i campi sottostanti per definire la console.`,
"label.extendsfather":`Controllato dal genitore`,
"front-homepageobject-module-v1-year":`Quest'anno`,
"front-grasp-sales-opportunities":`Il CRM ti aiuta a padroneggiare accuratamente le opportunità di vendita, ad acquisire più lead, a fornire preventivi rapidi e a chiudere più affari, mentre realizzi un marketing omnichannel e migliori continuamente il ROI aziendale.`,
"label.tab.oldpage":`Pagina della vecchia versione`,
"label.service.miniProgram.intro":`Introduzione`,
"label.data.import.setup.operate.insert":`Non aggiornare i record esistenti, solo inserire nuovi record.`,
"label.ccpeak.direction.for.use":`Descrizione dell'uso della piattaforma CloudCC [Versione 2.0]`,
"label.sendemail.chat.addComentsmyFeedsubject":`Risposta al micropost di CloudCC CCChat`,
"label.campaignmember.main.importmember.contacts":`Importazione membri-contatti`,
"setup.mainpage.label.welcome20":`Posta, modello SMS`,
"label.newbatcheditor.remark":`Per i diversi record, ci sono diversi tipi di record. Per impostazione predefinita, il layout di riga se il tipo di record del primo record è usato come layout di pafe per la modifica di massa.`,
"label.step4.total7":`Passo 4 di 7`,
"label.campagin.roi.tzhbl":`Ritorno sull'investimento`,
"label.emailmerge.mergepage.step3":`Registra un'attività`,
"label.marketsea.isrecyclecreatebyself":`Vuoi riciclare l'account autocostruito`,
"message.mobilechooseatmost.five":`Un massimo di 5 campi può essere selezionato nel menu sui dispositivi mobili.`,
"label.icon.171":`Casa degli ospiti`,
"label.saveandnext":`Salva & Avanti`,
"label.import.page1.selectcodingtype":`Scegliere il tipo di codifica`,
"label.searchlayout.displaybutton":`Pulsanti visualizzati`,
"label.approvalstep5":`Passo 5 selezionare le proprietà di modifica dei campi da visualizzare nel layout della pagina di approvazione`,
"label.passwordPolicy.setup.enforcePswHis":`Applicare la cronologia delle password`,
"vue_label_commonobjects_detail_contact_hierarchy":`Gerarchia di contatto`,
"front-kefu-moudle-v1-trythjzx-intelligent":`TRRT(tinet) Call Center di servizio intelligente`,
"label.select.statistical.indicators":`Scegliere l'indice statistico`,
"label.callcenter.Tianrun.RONGTONG":`TRRT(tinet)`,
"label.file.library":`Biblioteche`,
"lable.completion.rate.color.setting":`Impostazione del colore del tasso di completamento`,
"label.name.firstname":`Nome`,
"setup_layout_label_readonly":`Di sola lettura`,
"label.chatter.recordcall":`ha registrato una chiamata`,
"label.service.appointmentList.service.empty":`L'appuntamento di servizio è vuoto.`,
"component_milestones_label_choicestate":`Confermare questo stato`,
"label.approved.receiveApprovalEmail.option2":`Solo se sono un approvatore`,
"label.marketseamemset.account.title":`Impostazioni dei membri del pool di piombo`,
"label.changemydisplay.list.custom":`Personalizza le mie schede`,
"label.emailtemplate.selecttype":`Scegli il tipo di modello di e-mail che vuoi creare.`,
"component_timeline_label_title":`Timeline`,
"chatter.group.addRemoveMembers":`Aggiungi/Rimuovi membri`,
"label.console.step6.width":`Larghezza`,
"pagecreator.systemstyle.message.delete.fail":`Cancellazione stile non riuscita`,
"label.partnerCloud.orderingPlatform.productPrice":`{productQuantity}prodotti，{totalCount} pezzi, prezzo originale：{valuta} {originalPrice}，discount：{valuta} {Riduzione}`,
"label.h5.share":`Condividi`,
"label.schedulejob.setup.list.tip":`Impostare lavori programmati da eseguire automaticamente a intervalli settimanali o mensili.`,
"message.intheapproving":`Il record richiede l'approvazione e non può essere ripresentato.`,
"vue_label_commonobjects_detail_real_time":`Dopo l'adesione, la squadra sarà visualizzata nella sua lista, e la dinamica della squadra le sarà inviata in tempo reale.`,
"label.autoRegister.changepwd.setpwd.too.weak":`Troppo corto`,
"label.salescloud.forbiddenteamsales":`Forbidden Sales Team`,
"component.chatter.link.label.title":`Link`,
"label.layout.editsearchdistribute.page":`Seleziona le pagine personalizzate da includere nella home page della scheda`,
"label.dashboard.show.value.percent":`Mostra valori o mostra %, sceglietene almeno uno`,
"label.everymonth":`Al mese`,
"label.campaign.channel.download.size1":`Grande dimensione: 1000*1000 pixel`,
"permissionService.error2":`Impossibile aggiungere i permessi di licenza dell'applicazione.`,
"button.partner.workspace.manage.memo":`Gestisci il tuo cloud partner e configura le proprietà del cloud partner.`,
"label.forecast.forehistory.commit.remark":`Note di presentazione`,
"six":`Sei`,
"label.datamanage.donot.export.object":`Oggetti che non possono esportare dati.`,
"label.schedulejob.setup.schedule.execute":`Eseguire`,
"lable.account.CurrentandPreviousCY":`CY attuale e precedente`,
"label.temp.SMS":`Modelli SMS`,
"label_partner_all_state":`Stato`,
"label.editdocument":`Modifica delle proprietà`,
"front-epwechat-module-v1-ios-single":`iOS Single Sign On`,
"lable.redo":`Redo`,
"vue_label_SMS_alltemplates":`Tutti i modelli`,
"label.allfolderreport":`Tutte le cartelle dei rapporti`,
"label.layout.alltab":`Tutte le schede`,
"lable.account.Yesterday":`Ieri`,
"label.formula.to.evaluate":`Valutazione della formula`,
"component_setup_label_setupsaveok":`Impostazioni del componente salvate con successo`,
"pagecreator_page_message_canntdelete":`La pagina corrente non può essere cancellata`,
"label.tab.message.failtotp":`Non è riuscito a superare il Tab`,
"label.h5.chatter.location":`Inserire la posizione`,
"vue_label_commonobjects_view_chart_gotodashboard":`Vai a Dashboard`,
"label.data.exp.conf":`Sei sicuro di voler esportare i dati?`,
"label.currency.e":`Modifica del tipo di valuta`,
"message.matrixReportSetupStage.column":`Seleziona 【Specifica intestazioni di colonna】 base subtotale, e devi selezionare una base subtotale almeno in due basi subtotali.`,
"font-evaluate-module-v1-have-comment":`Ha lasciato una valutazione`,
"chatter.feed.dao":`A`,
"label.import.index.notice":`Nota:`,
"label.weixin.information":`Dettagli`,
"label.multilingual.tip5":`Lo stato multilingue non è corretto. Si prega di aggiornare e riprovare!`,
"label.appointment.wizard.subtitle3-7":`Domenica`,
"label.emailobject.groupemail.fail.content":`Caro{0}, il seguente è l'indirizzo email che non è riuscito ad essere inviato.{1} CloudCC`,
"vue_label_notice_uploadavatar_fail":`Impossibile caricare l'avatar`,
"chatter.group.myGroup":`I miei gruppi`,
"label.ccpeak.object.fieldapi.name":`è il nome del campo API dell'oggetto`,
"lable.activeCurrency":`Valute attive`,
"label.file.save.to.send":`Salva e invia`,
"label.emailmerge.list.editfolder":`Modifica cartella`,
"label.Path.Setting":`Impostazione del percorso`,
"label.validate.function.funcFormat.DATE":`DATA(anno,mese,giorno)`,
"message.objapiexists":`Questo oggetto API esiste già.`,
"label.sendmail.batch.confirm":`Email di massa: Conferma`,
"message.approval.cannotsubmit.detail":`Questo record non soddisfa le condizioni o la presentazione iniziale per un processo di approvazione valido. Contattare l'amministratore per assistenza.`,
"setup.layout.button.deleteitem":`Rimuovere gli elementi selezionati`,
"label.end.loginipIP":`Indirizzo IP finale`,
"component_event_label_subject":`Tema`,
"message.500":`Si è verificato un errore interno al server`,
"label.wei.polltype":`Tipi`,
"vue_label_norm_duplicate":`Duplicato`,
"label.addcycletrigger":`Aggiungere un trigger periodico`,
"DetailedInfo.Activity.EmailMessage.01":`{0} invia un'email a {1}.`,
"No.Activity":`Nessuna attività`,
"label.chat.topic.add.topic":`Clicca per aggiungere un argomento`,
"label.schedulejob.setup.schedule.morning":`AM`,
"chatter.save.al":`Le tue modifiche sono state salvate.`,
"label.setsharerule.step3":`Passo 3 Selezionare gli utenti con cui condividere`,
"label.tabpage.Sdfez":`Giorni fa`,
"label_submit_forecast":`Inviare la previsione`,
"label.version.sum.formulafield":`campi formula`,
"lable.weixin.you.invitation":`Il tuo invitato`,
"label.stacked.horizontalbar":`Linee orizzontali impilate`,
"label.file.anyone.can.link":`Chiunque abbia il link può visualizzare e scaricare il file.`,
"label.campaignmember.main.importmember.lead.desc":`Importazione di lead da file.`,
"UG_activity_01":`Come rintracciate i vostri record per interagire con i vostri conti/squadre?`,
"label.reason":`Motivo`,
"label.version.free.createmax":`Permette la creazione di 2000 record, il limite superiore è stato raggiunto.`,
"label.brief.thisweek":`Questa settimana`,
"label.deleteobjinapprove":`Inserisci il commento prima di poter eliminare questo oggetto dal processo di approvazione.`,
"calendar.tips.event":`giorno(i) senza eventi`,
"label.customerinfo.mailinfo":`Indirizzo e-mail dell'organizzazione`,
"lable.electronic.signature":`Firma elettronica`,
"label_emailsync_addnewaccount":`Aggiungi un nuovo account`,
"label.layout.exampleoftesgobj":`Esempio di oggetto di test`,
"label.happen_submit":`Cosa dovrebbe succedere dopo che un visitatore ha inviato questo modulo`,
"label.forecast.customforecast.button.submit":`Invia`,
"label_right_click_notice":``,
"font-trade-module-v1-invoice-no-price":`Da rimborsare`,
"lable.opppdt.selPdt.morecondtions":`Più filtri`,
"label_invalid_token":`Token non valido`,
"label_chatter_postup":`Posta in alto`,
"label.escalation.setup.newaction.step1":`Passo 1 Specificare i criteri temporali per questa regola`,
"label.sendmail.step3.dealoption2":`Memorizzare un'attività per ogni messaggio`,
"front-kefu-moudle-v1-yesornoBatch-delete-templete":`Sei sicuro di voler eliminare i modelli in batch?`,
"vue_label_appstore_enter_website":`Entrare nel sito ufficiale`,
"label.when":`Tempo di pubblicazione`,
"label.linellae":`Linee`,
"label_chatter_detailinfo":`Informazioni dettagliate`,
"lable.SalesCommitmentKanBan.receivingTaskRate":`Ricevute Tasso di completamento dell'attività`,
"vue_label_homepage_dashboard_deleted":`Il cruscotto è stato rimosso`,
"pagecreator.layout.button.vertical":`Smontaggio longitudinale`,
"label.redistribution1":`Seleziona fino a 5 articoli`,
"pagecreator_page_label_modifypage":`Editore di pagina`,
"label.Service.Cloud.Setting":`Impostazione della nuvola di servizi`,
"setup_layout_label_pagename":`Nome del layout di pagina`,
"label.ems.send":`Invia`,
"vue_label_commonobjects_view_kanban_notice1":`La vista Kanban visualizza solo i primi 200 record`,
"lable.outlook.detail.maping":`Mappature di campo`,
"vue_label_pool_abandonorrestore":`{1}{2}`,
"label.mobile.side.tab":`Impostazione del cursore laterale mobile`,
"label.trigger.operation.email.template.param":`Passare i parametri: lingua, ID del modello e-mail e ID del record`,
"front-objectTemplate-V1-Select-a-template":`Seleziona un modello esistente come base del nuovo modello.`,
"label.email.template.delete.template":`Sei sicuro di voler cancellare questo modello?`,
"label.reportsSubscription.cancel":`Cancella`,
"lable.quote.syncingfrom.firstsync.description":`I prodotti di opportunità sostituiranno le voci del preventivo`,
"label.weixin.no.pending.xsld.qin":`Spiacente, nessun dato sull'imbuto di vendita da mostrare.`,
"template.dashboard.sales.indicators":`Indicatori di vendita`,
"label.field.new":`Fornire agli utenti operazioni di valutazione e punteggio.`,
"label.generatepage.title.desc1":`Genera la versione mobile o PC del codice HTML in base ai campi selezionati, gli utenti possono modificare il codice come necessario.`,
"template.report.source.potential.customers":`Fonte dei lead`,
"label.mr.title.queryData":`Trova i duplicati`,
"button_partner_workspace_enable":`Abilitare il cloud dei partner`,
"V":`Numero di auto`,
"label.icon.19":`Cartella`,
"vue_label_report_summaryformula":`Formula riassuntiva`,
"label.appointment.wizard.subtitle2":`Intervallo di date disponibili`,
"label.stdashbord.xsld.business.bjdzhl":`Tasso di conversione di fase`,
"label.forecast.forehistory.deopportunity":`Opportunità`,
"chatter.email.referredToMeLeaveMessage":`Mi cita in un commento`,
"label.dategrouprelyon":`Criteri di raggruppamento delle date`,
"label.sendmail.batch.finish":`Email di massa: Completato`,
"label.weixin.allexpired":`Tutti in Ritardo`,
"label.dashboardSetup.showdw.d4":`10 Mila`,
"message.duplication.label.masterRecord":`Record principale`,
"vue_label_calendar_availability":`Disponibilità`,
"vue_label_chat_approval_message":`Messaggio di approvazione`,
"vue_label_zhang_er":`Jenny`,
"label.select.options":`Si prega di selezionare le opzioni`,
"label.israel.daylight.time":`Ora solare di Israele`,
"front-sales-search-QB":`0 dati in totale, se creare un nuovo conto in QuickBooks`,
"vue_label_account_change_customer":`Cambia il proprietario del cliente`,
"label.integrations.mailchimp2":`Vedere di più su CloudCC e Mailchimp`,
"lable.product.pricebooks.onisu":`Libri dei prezzi inattivi`,
"front-electronic-signature-backfill-field":`Campo di riempimento`,
"label.document.myself.folder":`Le mie cartelle personali`,
"label.event.moveup.10hour":`10 ore avanti`,
"report.label.report":`Rapporti`,
"label.validate.function.funcFormat.CONTAINS":`CONTIENE(testo, confronta_testo)`,
"label.usermanage.query.false":`Query fallita, l'utente non esiste.`,
"front-epwechat-module-v1-input-EncodingAESKey":`Si prega di inserire EncodingAESKey`,
"label.event.multi.view":`Vista multiutente`,
"label.h5.similar.opportunity.setup":`Impostazioni di opportunità simili`,
"label.setting.intergrationlist.button.install":`Installare`,
"label.event.monthview":`Vista del mese`,
"label.version.weixin":`Versione WeChat`,
"label_emailtocloudcc_redmessage6":`Autenticazione IMAP/SMTP fallita, controlla che l'indirizzo e-mail e la password siano corretti.`,
"UG.homepage.003":`Vista a 360 gradi`,
"vue_label_calendar_shared_calendar":`Condividere il calendario`,
"label.select.hope.merge.num1.record":`Seleziona i record che vuoi unire in un unico record. Scegli un massimo di 3 record alla volta.`,
"label.createnewprocess":`Creare un nuovo processo di approvazione`,
"font-trade-module-v1-invoice-status":`Stato di pagamento`,
"label.customerinfo.introduce":`Informazioni sull'azienda`,
"label.objectname":`Nome dell'oggetto`,
"label.chosen.field":`Campi selezionati`,
"label_target_name":`Nome del modello di obiettivo:`,
"label.appointment.wizard.subtitle4-4-4":`1 mese`,
"label.emailobject.groupemail.msg1":`Nessun indirizzo e-mail`,
"label_component_hotdeal_nopermission":`Per vedere i dati relativi alle tue opportunità commerciali, contatta il tuo amministratore CloudCC.`,
"label.appointmentdetail.wizard.title13":`Descrizione`,
"front-web-module-v1-detail-comment-title":`Si prega di commentare questo servizio`,
"label.visualpage.component.n1":`1. Metodo di chiamata.  `,
"lable.outlook.mcto.erecord":`i primi record creati`,
"label.weixin.del.log":`Registro delle cancellazioni`,
"setup_mainpage_label_welcome23":`Impostazioni di sicurezza`,
"label.selectreportline":`Seleziona le colonne del rapporto`,
"label.chatter.following":`Seguendo`,
"seven":`Sette`,
"message.error":`Errore_suffliciente1a`,
"label.mobile.phone.reporter":`Inviato da`,
"label.valadate.telphone.false":`Numero di telefono inserito errore, si prega di reinserire`,
"label.linkedin.setting":`Integrare LinkedIn H5 MiniApp`,
"label.mobile.side.tab.success":`Salva con successo l'impostazione del cursore lato mobile.`,
"label.notification.approval3":`La richiesta di approvazione di 【对象】 è riassegnata a 【重新审批人】`,
"label.channel.invites.employees":`Invitare il personale di questo canale`,
"label.assignment.setup.detail.assigner":`Assegnare a`,
"label.campaignmember.main.updatecontactdesc":`Aggiornare lo stato di tutti i contatti in una sola volta`,
"label.permission.detail.app.fenpei":`Assegnare le applicazioni`,
"label.copydown":`Copiare giù`,
"label_emailsync_status_action":`Azione`,
"lable.Please.switch":`Si prega di passare al menu orizzontale o verticale per utilizzare questa funzione.`,
"label_adjust_remark":`Osservazioni sulla regolazione`,
"label.weixin.newspaper.coverage.list":`Schede di rischio`,
"label.datamanage.contact.field":`Campi di contatto`,
"label.partner.workspace.login.headerfooter":`Intestazione e piè di pagina`,
"lable.account.quarter.ovdate":`Giorno della fine del trimestre fiscale`,
"pagecreator.systemstyle.label.textcolor":`Colore del testo`,
"label.industrialandcommercialverification.fieldmappingsettings":`Impostazioni di mappatura dei campi`,
"component_chatter_button_message":`Commento`,
"label.partnerCloud.enterAddress":`Inserisci l'indirizzo`,
"label.email.template.recently.used":`Usato di recente`,
"component.event.label.calendar":`Visualizza Calendario`,
"label.setup.mobile.offlinecache.setting":`Impostazioni della cache offline sul lato mobile`,
"label.custom.PreviousCQ":`Precedente CQ`,
"lable.total.of.payments":`0 pagamento in totale`,
"label.ccpeak.use.class.time.trigger":`Se il trigger chiama la classe, potete usare direttamente i metodi del CCService.`,
"label_tabpage_addresswrongz":`Il formato dell'indirizzo della casella di posta è sbagliato, inserisci correttamente l'indirizzo della casella di posta!`,
"vue_label_homepage_select_components":`Seleziona i componenti`,
"front-kefu-moudle-v1-secretID-reinput":`Inserisci il secretID`,
"label.ccdocument.select.template.red":`Si prega di selezionare un set di modelli.`,
"vue_label_email_public_template":`Modello pubblico`,
"label.eowechat.openid":`ID WeCom`,
"label.user.ip.notlogin.range":`Questo IP non è nell'intervallo IP.`,
"chatter.email.reply.collection":`Commenti su un articolo che ho messo nei preferiti`,
"label.integrations":`Integrazioni`,
"label.permission.modifyAppPermission.selectedapp":`Applicazioni selezionate`,
"label.privacystatement":`Dichiarazione sulla privacy`,
"label.specificvalue":`Un valore specifico`,
"label.appointmentconfirmpage.wizard.subtitle2":`Data e ora`,
"label.message.ispartner.delete":`Poiché il contatto è già associato all'utente partner, il cliente non può essere eliminato`,
"report_button_go":`Vai a`,
"label.h5.similar.opportunity":`Opportunità simili`,
"UG_Lead_005":`Mailbox`,
"label.num.length.not.overstep":`la lunghezza del valore non può superare i 18 bit`,
"label.profile.mobile.setup.CEOandDirector":`Ceo e direttore delle vendite`,
"label.addfield":`Aggiungi campo`,
"template.dashboard.institutional.overview":`Panoramica dell'agenzia`,
"label_tabpage_datefield":`Quando il campo data è uguale, può usare il formato "ieri", "oggi", "domani", "mese scorso", "questo mese", "mese prossimo", "settimana scorsa", "questa settimana", "settimana prossima" o "YYYY-MM-DD、MM/DD/YYYY".`,
"label.category.7":`Turismo`,
"UG_contact_02":`Coinvolgere i contatti attraverso più canali, chiamata, email, social`,
"chatter.feed.menutype.feed.mecom":`Nuovo post per me`,
"vue_label_systemSettings_calltemplate":`Modello di lettera`,
"approval_process_errore":`Si è verificato un errore durante il salvataggio, contatta l'amministratore.`,
"label.tabpage.choosefilez":`Selezionare il file`,
"label.changemydisplay.chagetab.cusapp":`Applicazioni personalizzate`,
"clearadvancedoption":`Cancella la logica del filtro`,
"front-epwechat-module-v1-binding-user":`Utenti vincolati`,
"label.customfields.fielddependency.null":`Nessuna dipendenza definita.`,
"label.enterprise":`Edizione Impresa`,
"font-evaluate-module-v1-five-points":`Marchio neutro: 5 punti`,
"lable.Synchronize.from.QuickBook":`Sincronizzazione da QuickBook`,
"front-gantt-module-v1-task-number":`Importo del compito`,
"label.currency.edit.newexchagecurrency":`Tassi di cambio datati`,
"label.partnerCloud.partnerSite":`Sito partner`,
"label_tabpage_unequalz":`Ineguale a`,
"label.version.solutions":`Soluzioni`,
"label.setting.intergrationlist.button.installed":`Installato`,
"label.h5.chatter.share":`Condividere i file`,
"front-epwechat-module-v1-unbound-item4":` legatura di conti esterni`,
"label.textmessage.vonage.accessibility.setting":`Impostazione dell'accessibilità`,
"font-evaluate-module-v1-evaluation-set":`Impostazioni di valutazione`,
"message.servicecrew.time.violation2":`Fuori dal tempo di lavoro`,
"label.processinfo":`Informazioni sul processo di approvazione`,
"label.knowledgebase.last.modified":`Ultima modifica`,
"label.to.phone":`A`,
"label.baseoffirsttimereply":`Approvare o rifiutare in base alla<strong> prima </strong>risposta`,
"label.projectManagement.startingEndingTime":`Tempo`,
"label.licence.enable":`Attivo`,
"label.partnerCloud.basicSetting.cshua":`Inizializzare il cloud dei partner`,
"APPIntegration.Dropbox.setting.03":`Abilita Dropbox per permetterti di selezionare i file da Dropbox e aggiungerli come allegati.`,
"label.account.contact":`Contatto AI`,
"label.many.dayline.tab":`Mark`,
"label.weixin.input.username":`Inserisci il tuo nome`,
"label.logintime.pagecue.invalido":`L'ora della fine deve essere tutto il giorno.`,
"label.icon.30":`Libro`,
"label_tabpage_advancedscreening":`Filtro avanzato`,
"lable.currencyManage.unEnabledadvcurrency.agree":`Sì, voglio disabilitare la gestione avanzata della valuta.`,
"label.tab.web.new":`Nuova scheda web`,
"label.bmap.tiananmen":`Tiananmen`,
"label.disabled":`Disabile`,
"error.currencyAdv.deleteprecodedate":`Impossibile cancellare il tasso di cambio della data di una valuta.`,
"message.error.view.checkbox.validerr":`Errore: si prega di usare vero o falso`,
"UG_ST_006":`Entrare direttamente`,
"label.dongshifang.title":`DongShiFang SMS`,
"label.data.dataexpalltype.all.desc3":`3. I dati esportati con successo genereranno un file compresso che gli utenti possono scaricare dalla pagina dell'elenco di successo dell'esportazione secondo le informazioni nella posta.`,
"vue_label_pool_returnreason":`Motivo della restituzione`,
"label.list.userinterface.des":`Modificare l'interfaccia utente con le seguenti impostazioni:`,
"label.notification.approval2":`La richiesta di approvazione del【对象】 è respinta da 【审批人】`,
"label.service.dispatchingUnits.the.level":`Livello`,
"front-email-payment-Invoice-preview-tips":`Tutti i modelli di fattura sono attualmente disabilitati. Contatta l'amministratore per abilitare il modello prima di generare le fatture.`,
"label.dashboard.isAvailableFieldOfComponentGroupInTheReport":`Errore: uno o più campi selezionati nel componente non è più disponibile nel report. <br>utilizza l'editor del componente dashboard per selezionare uno dei campi disponibili.`,
"label.import.step2.chooseidorother":`2. È possibile scegliere di utilizzare l'ID o il nome per abbinare il record e compilare il campo di ricerca. Se hai bisogno di acquisire l'ID del record corrispondente e altre informazioni, puoi creare un rapporto e impostare il nome del record e l'ID del record come colonne del gruppo, quindi esportare il rapporto.`,
"label.customobjects.introduce":`Gli oggetti personalizzati sono tabelle di database che ti permettono di memorizzare dati specifici della tua organizzazione in CloudCC. Puoi usare gli oggetti personalizzati per estendere le funzionalità di CloudCC o per costruire nuove funzionalità applicative.`,
"label.visualpage.oldsystem":`Vecchia versione`,
"label.icon.94":`Libro`,
"label.setup.log.desctiption":`Puoi scaricare la traccia del comportamento della tua organizzazione (Excel.xls)`,
"label.dynamicpage.layout":`Regole di layout`,
"lable.list.queue.objct":`Oggetti supportati`,
"label.customfields.placeholder.tip":`Il testo di esempio sarà visualizzato nella casella di input e scomparirà dopo aver ottenuto il focus`,
"label.ems.activationtime":`Tempo di attivazione`,
"label.detailinfo":`Dettagli`,
"label.icon.17":`Segnala`,
"label_emailtocloudcc_button_complete":`Finitura`,
"label.visualpage.component.n2":`2. Si noti che i "tag componente" non possono essere annidati dentro "<cc>tags".`,
"label.object.name.one":`Nome dell'oggetto 1`,
"label.summaryreport.step2":`Passo 2 Scegliere i dati riassunti`,
"thisisanew":`Novità!`,
"label.query.detail.editpartneruser":`Modifica utente partner`,
"label.tabpage.newview":`Creare una nuova vista`,
"label.partnerCloud.productSet.addNew":`Nuova opzione`,
"label.appupload.upload.new.remark":`Questo è un nuovo componente`,
"label.case.ptext":`Abbiamo collegato la tua azienda alla versione web del portale. Copia l'indirizzo della versione web del portale del servizio clienti dedicato alla tua azienda e aggiungi il portale sul tuo sito ufficiale.`,
"lable.PowerProcess.name":`Processo di abilitazione`,
"label_tabpage_choosefilez":`Selezionare il file`,
"homepage.components.place":`Posizione del componente:`,
"lable.Synchronization.failure":`Mancata sincronizzazione`,
"label.dashboard.snapshot.get.data":`Ottieni i tuoi dati`,
"label.input.invalid.format":`Inserisci il formato valido`,
"label.quickbooks.view.openinvoices":`Fatture aperte`,
"label.weixin.seating":`Posti a sedere`,
"label.searchlayout.remark":`I layout di ricerca ti permettono di selezionare i campi standard e personalizzati che vengono visualizzati nelle seguenti funzioni di ricerca:`,
"label.escalation.setup.entrydetail.escalation.assiner":`Assegnare a`,
"vue_label_calendar_availability_view":`Vista calendario-disponibilità`,
"label.country":`Paese`,
"label.campagin.roi.zl":`Panoramica`,
"lable.currencyManage.advcurrencyEnabled":`La gestione avanzata della valuta è abilitata`,
"label.projectManagement.project.task":`Compito del progetto`,
"label.appointmentpage.wizard.subtitle3-2":`Email`,
"label.input.invalid.date":`Inserisci le date valide`,
"vue_label_chatter_my_followers":`I miei seguaci`,
"label.setupdevelop":`Sviluppare`,
"label.sendemail.send.checksend":`Controlla se l'email è stata inviata con successo`,
"label.eventfield":`Campi di eventi`,
"label.ccpeak.ccobject.put":`usare put per assegnare a CCobject, per esempio:`,
"label.campaignmember.main.addMemberDesc":`Puoi cercare i lead e i contatti esistenti, aggiungerli a questa campagna o gestire i membri della campagna esistenti.`,
"label.knowledge.setting.hint.eleven":`Inserisci la categoria dei dati`,
"label.knowledge.category.button.four":`Aggiungi la categoria dei fratelli`,
"label.icon.27":`Impara`,
"vue_label_chatter_certification":`Siete sicuri di voler {isStatus} "{titleName}"?`,
"label.data.downpage.i.title.btn":`Vai alla pagina di importazione e inizia l'importazione`,
"label.campaign.channel.step6.pc":`Generare la pagina del PC`,
"label.mr.caption.rule":`Regole: è necessario selezionare una o più regole per trovare i duplicati`,
"label.service.gantt.resourcestype":`Tipo di risorsa`,
"label.searchfitconditions":`Trova quelli che corrispondono ai seguenti criteri:`,
"label.partner.template.name":`Nome del modello`,
"setup.mainpage.label.welcome15":`Le regole del flusso di lavoro della piattaforma CloudCC automatizzano il processo di supporto per le vendite, il marketing e altro. In base a una serie di regole predefinite, i record possono essere assegnati automaticamente agli utenti o convertiti da un utente a un altro. Il vantaggio principale della gestione del flusso di lavoro è quello di migliorare l'efficienza del lavoro eliminando molte operazioni inutili quando si aggiornano i record, e di migliorare i livelli di elaborazione aziendale e ottimizzare i processi di controllo standardizzando i metodi di lavoro e riducendo i costi operativi. Supporta l'approvazione infinita illimitata per qualsiasi oggetto, e può innescare e-mail di promemoria, promemoria SMS, compito, aggiornamento del campo e altre funzioni.`,
"vue_label_commonobjects_view_chart":`Grafico`,
"label.salescloud.teamrole.choose":`Seleziona il ruolo della squadra`,
"lable.outlook.mcto.emailrel":`Associazioni di e-mail`,
"front-invoice-online-payment-setup-describe":`Accesso veloce, accesso con un solo clic. Servizio di pagamento online semplice, sicuro e rapido.`,
"label.korean.standard.time":`Ora solare della Corea`,
"label.lord.howe.standard.time":`Ora legale di Lord Howe`,
"setup_layout_group_button":`Pulsanti`,
"label.editdefaultshare":`Impostazioni predefinite di condivisione a livello di organizzazione Modifica`,
"label_fiscal_year":`Anno fiscale`,
"label.appointmentdetail.wizard.title2":`Proprietario`,
"label.email":`Email`,
"label.city":`Città`,
"label.knowledgebase.data.recovery.failed":`Recupero dei dati {a} fallito`,
"setup_mainpage_label_welcome6":`Gli utenti possono creare vari tipi di campi in tutti gli oggetti del sistema CloudCC senza alcuna conoscenza di programmazione o sviluppo di codice. I tipi di campo includono: relazione di ricerca, campo a selezione singola, selezione a due voci, formula, numerazione automatica. , URL, telefono, fax, email, checkbox, data, ora, numero, testo, area di testo, lista di opzioni (selezione singola/multipla), valuta, ecc.`,
"label_emailtocloudcc_button_enable":`Attivo`,
"label.account.custom":`Trimestre fiscale personalizzato`,
"label.custompublish_time":`Tempo di pubblicazione del cliente`,
"label.dashboardSetup.selwz":`Posizione visualizzata`,
"component_todaytask_label_all":`Vedi Tutto`,
"label.service.resource.group.tip":`Le risorse di servizio che riguardano i tipi di equipaggio usano il tipo di equipaggio.`,
"label.tianyancha.legalpersonname":`Nome della persona giuridica`,
"component.setup.label.titlefield":`Campo titolo`,
"label.email.template.public.mail":`Cartella pubblica di modelli di email`,
"front-template-V1-DeleteTempalte":`Sei sicuro di voler cancellare "{currentTelmplateName}"?`,
"pagecreator.layout.label.layoutdesc":`Descrizione del layout`,
"vue_label_file_singel_upload":`Può essere caricato un solo file. Se hai bisogno di sostituire il file, cancella prima il file caricato`,
"label.view.hierarchy":`Visualizza le gerarchie`,
"label.file.owner.settings":`Impostazioni del proprietario`,
"label.sales.dashboard.name":`Nome`,
"label.offfer.filer.name":`Citazione Nome del file`,
"label.quickbooks.view.recentlypaid":`Pagato di recente`,
"label.step1.select.merge.records":`Passo 1 selezionare i record da unire`,
"message.recordtype.assignprofile.tip":`Selezionate la casella Enable for Profile per rendere il nuovo tipo di record disponibile per un profilo. Gli utenti assegnati a questo profilo potranno creare record di questo tipo di record o assegnare questo tipo di record ai record esistenti. Per rendere il nuovo tipo di record il predefinito per un profilo, selezionate la casella di controllo Make Default.`,
"label.appointmentdetail.wizard.title9":`Tempo di viaggio`,
"label.group":`Gruppi`,
"label.deltorecycle":`Cancellare nel cestino`,
"label.import.index.numlimit":`1. Solo i file in formato csv sono supportati, e fino a 30.000 record possono essere importati per una volta (<span style="color: red">fino a 2.000 record possono essere importati se è necessario eseguire il trigger</span>). I record che superano il limite saranno automaticamente ignorati dal sistema. Se volete importare più dati, dividete prima in più file e importateli in tempi diversi. .`,
"label.file.delete.desc":`L'eliminazione di un file lo rimuove anche da qualsiasi altro record o post.`,
"UG_activity_04":`Outlook/Gmail mailbox, registrare la posta`,
"label.event.all.undealt":`Tutti gli eventi non elaborati`,
"label.appupload.upload.install.error":`Questa applicazione non può essere installata. per favore termina l'installazione o modifica le api di sistema e reinstalla!`,
"template.chart.yqydcpsl":`Numero di prodotti attivati`,
"label.import.index.advancepreparation":`Preparativi preliminari`,
"label.eowechat.epdeptnamee":`Nome del dipartimento WeCom`,
"front-kefu-moudle-please-input-servernum":`Inserire il numero dell'elenco delle richieste di servizio.`,
"label.lookup.autocmp.nodata":`Nessun dato di corrispondenza`,
"vue_label_pool_assign":`Assegnare`,
"label.knowledge.timing.publish":`La pubblicazione temporizzata non è riuscita`,
"label.selected.groups":`Gruppi di linee di quote selezionate`,
"front-epwechat-module-v1-removesele-desc":`Dopo l'eliminazione, tutte le impostazioni di questa applicazione saranno rimosse. Sei sicuro di voler cancellare?`,
"label.batchtransfer.type2":`Trasferimento di opportunità chiuse`,
"label.richtext":`Area di testo (ricca)`,
"label.icon.174":`Aerei`,
"vue.please.select.grouping.basis":`Si prega di selezionare Gruppo per opzioni.`,
"label.matrixreport":`Rapporto di matrice`,
"label.jiandangfenpei.leftlist":`Profili non assegnati`,
"label_chatter_card":`Scheda`,
"label.file.enter.title":`Inserisci il titolo`,
"label.the.record.is.locked.and.cannot.be.selected.":`Questo record è bloccato, non selezionabile.`,
"label.partner.success":`Il dominio di successo è disponibile`,
"label.selectreporttype":`Selezionare l'origine dei dati del report`,
"report.type.label.productPricebooks":`Prodotti e libri dei prezzi`,
"label.texttemplate.mergefields.tip":`Aggiungi campi incorporati mentre modifichi il contenuto dell'SMS. Quando l'SMS viene inviato, i campi incorporati possono essere sostituiti dal testo corrispondente. Per esempio, {!Contact.name} può essere sostituito dal nome del contatto quando si invia l'SMS.`,
"label.publicgroup.detail.showallusers":`Visualizza tutti gli utenti`,
"label.brief.follow":`Follow Up`,
"label.forecast.settings.qijian.p":`Previsione trimestrale`,
"label.sms.url":`URL`,
"setup_layout_group_custompage":`Personalizza la pagina`,
"label.validate.function.funcFormat.BEGINS":`INIZIA(testo, confronta_testo)`,
"label.umeng.chatter.sendmessage":`ti ha mandato un messaggio`,
"label.pc.layout":`Layout del PC`,
"label.currency.v":`Inserire le posizioni decimali (numero di cifre a destra della virgola) consentite quando si visualizzano i dati in questa nuova valuta. Deve essere un numero intero con valore compreso tra 0 e 6.`,
"label.projectManagement.kanbantask":`Compito Kanban`,
"component_recdetail_label_title":`Informazioni dettagliate`,
"label.isremider":`Promemoria`,
"front-epwechat-module-v1-input-home-url":`Inserisci l'URL della homepage`,
"label.usefullife":`Periodo di scadenza`,
"label.visualpage.ptype":`Comune`,
"label.quote.name":`Cita il nome`,
"vue_label_report_addtocomponent":`Sei sicuro di voler aggiungere { nome } alla libreria dei componenti?`,
"label.dashboardSetup.showdw.d1":`100 Milioni`,
"label.validate.function.funcFormat.OR":`OR(logico1,logico2,...)`,
"label.component.helper.potentialcustom":`I lead che ti sono stati assegnati oggi`,
"label.autoRegister.changepwd.setpwd.tip.number":`Almeno un numero`,
"label.data.setok.e.desc3":`， scaricare i dati esportati.`,
"label.data.downpage.e.title.num4":`4. I file di esportazione hanno due formati: Il formato CSV e il formato di compressione. Il formato di compressione è diviso in due tipi: uno è di generare automaticamente la password del file compresso, l'altro è di inserire manualmente la password del file compresso.`,
"lable.quote.editqtpdt.description":`Seleziona un listino per questo preventivo. Puoi aggiungere solo un prodotto da un solo listino, e cambiando il listino selezionato, tutti i prodotti esistenti verranno rimossi dal preventivo.`,
"front-kefu-moudle-edit-userinfo":`Modifica informazioni utente`,
"label.please.ChooseMinAndMax":`Si prega di scegliere almeno {0} opzioni di prodotto, e fino a {1} può essere selezionato.`,
"label.knowledgebase.archive.an.article":`Archiviare un articolo?`,
"label.multilang.customforcast.submit":`Presentate una previsione dal {0}anno fiscale{1} al {2}anno fiscale{3}?`,
"label.import.index.filename":`Nome del file`,
"front-console-no-reco-contact":`Il contatto non può essere identificato`,
"label.quantity.greater.than0":`La quantità deve essere maggiore di 0.`,
"label.codeNorm":`Codice Standard`,
"label.average":`Media`,
"label.multilang.page1":`Pagina`,
"label.data.exp.save.ok":`Salva il modello con successo`,
"message.error.delete.record":`Il record da cancellare non è stato trovato!`,
"label.newvaluereplaceoldvalue":`Sostituisci globalmente un valore esistente in una lista di scelta con un nuovo valore. Assicurati di aver creato prima il nuovo valore sul campo picklist.`,
"label.tabpage.saveviewsuccess":`Vista salvata con successo`,
"label.partnerCloud.productSet.parentOptions":`Opzione per i genitori`,
"label.emailtemplate.availablemergefields":`Campi di fusione disponibili`,
"label.data.import.setup":`Impostazioni di importazione dei dati`,
"label.escalation.setup.entrydetail.escalation.action":`Azioni di escalation`,
"System.TimeField.Description":`Permette agli utenti di inserire un'ora locale. Per esempio, "2:40 PM", "14:40" e "14:40:00" sono tutti orari validi per questo campo.`,
"front-additional-products":`Acquista altri prodotti`,
"label.appointment.wizard.subtitle4-4-1":`1 settimana`,
"label.chatter.colleagues.list":`Elenco dei colleghi`,
"label.log.invalid.data":`Data non valida`,
"label.file.preview.unconvert":`Non viene generata alcuna informazione di anteprima, si prega di fare clic su dettagli di anteprima`,
"label.customer.detailed":`Scegli la pagina per questa nuova scheda. Inserisci altri dettagli.`,
"label.sendsms.content":`Il contenuto è il seguente:`,
"label.exported_to":`Il file esportato sarà inviato per email a`,
"label.attendance.checkin":`Check In`,
"Dashboard.NoAccessRightToSee.Warning":`Non hai il permesso di visualizzare i dashboad {0} che sono impostati come aperti di default, per favore ripristinali.`,
"message.choosedelete":`Seleziona i dati che vuoi cancellare`,
"label_tabpage_choosecontent":`Selezionare il contenuto del valore`,
"label.no_responses":`Nessuna risposta`,
"report_type_label_customService":`Assistenza clienti`,
"label.report.select.condition":`Condizioni`,
"label.umeng.activity.distributeevent":`ti ha assegnato un evento.`,
"label.knowledge.language.portuguese":`Portoghese`,
"label.knowledgebase.published":`Pubblicato`,
"UG_opportunity_001":`Come controlla le sue vendite?`,
"label.mr.caption.scope":`Ambito: interroga tutti i dati se non è selezionato`,
"message.login.mfaverification.to.pclogin":`La tua organizzazione ha abilitato la verifica secondaria del login, il primo login richiede l'associazione al dispositivo mobile, per favore usa il lato PC per l'associazione del login`,
"vue_label_dashboard_pleaseenterthecolorrange":`Inserisci la gamma di colori`,
"label.emailsync.status.time":`Tempo`,
"chatter.putup":`Condividere un file`,
"vue_label_report_drillcondition":`Condizione di perforazione`,
"label.emailobject.list.myemail":`La mia e-mail`,
"label_tabpage_andz":`E`,
"label.share_link":`Condividi link`,
"label.emailtocloudcc.exists2":`Questa casella di posta è stata impostata su Email to Case. Non ripetere le impostazioni.`,
"label.icon.89":`Consulenza`,
"front-kefu-moudle-v1-qdygbzx-chat":`Sei sicuro di disattivare la chat online?`,
"label.approval.selectone":`Seleziona almeno un'azione.`,
"chatter.group.groupName":`Nome del gruppo`,
"label_chatter_relateitem":`Relativo a`,
"label.file.folder.delete1":`Cancellare la cartella?`,
"Pagelayout_Setup_003":`Il campo Nome deve essere selezionato`,
"setup_mainpage_label_welcome2":`Database personalizzato (oggetto)`,
"pagecreator.systemstyle.label.linkcolor":`Colore del link`,
"label.task.this.week":`Questa settimana`,
"message.custom.field.donotdelete.report":`Il campo è referenziato dal rapporto`,
"pagecreator.layout.button.delete":`Cancellare il layout`,
"label.reportsSubscriptionPage.condition.operator":`Operatore`,
"label.location.display.type.degrees":`Gradi, minuti, secondi`,
"label.appupload.upload.url":`URL di installazione`,
"label.logical.relation":`Relazione logica`,
"label.knowledge.publish.article":`Pubblicare l'articolo`,
"vue_label_commonobjects_detail_activity_commingtask":`Compito imminente disponibile`,
"vue_label_pool_reason":`{0} motivo`,
"front-gantt-module-subtasks-cannot-subtasks":`Le sottoattività non possono apparire sotto le sottoattività!`,
"label_tabpage_filesizez":`Dimensione del file`,
"label.customfields.formula.returntype.monry.tip":`Calcola un dollaro o un altro importo in valuta e formatta automaticamente il campo come importo in valuta.`,
"label.tabpage.allapplications":`Tutte le applicazioni`,
"message.duplication.label.matchcontainletters":`Contenere`,
"maintenanceplan.workorder.type.asset.workorderlineitem":`Scegliete "Una voce di ordine di lavoro per ogni bene" come tipo di generazione di ordine di lavoro.`,
"label.preview_post":`Anteprima del post`,
"chatter.p.data":`Data di invio`,
"label.isnot.right.number":`Numero non valido`,
"label.contentsource":`Fonte del contenuto`,
"message.groupandsummaryconditionsame":`Le condizioni usate per il raggruppamento non possono essere le stesse delle condizioni riassuntive`,
"label.weixin.wdyj.nodata.qin":`Spiacente, {0} non ha dati.`,
"chatter.vote":`Voto(i)`,
"label_partner_workspace_tab_option":`Schede disponibili`,
"chatter.changeVote":`Cambia voto`,
"label.data.file.i_title.num2":`2. Si raccomanda di esportare i dati quando i dati vengono importati, in modo che il documento di esportazione sia usato come modello per collazionare i dati da importare, e poi importare. (Se i dati importati contengono una virgola, sostituirla con il simbolo @).`,
"label.relation.list.error":`Errore`,
"label.validate.function.funcExplain.MILLISECOND":`Restituisce i millisecondi del giorno (dai campi data/ora)`,
"label.emailobject.emaildetail.button.relateto":`Relativo a`,
"label.dashboard.dataSource":`Mostra la fonte dei dati`,
"label.marketseamemset.lead.title":`Impostazioni dei membri del pool di piombo`,
"label.appupload.addobj":`Aggiungi al pacchetto`,
"lable.outlook.mcto.domain":`Aggiungi il mio dominio (gmail.com) alla lista dei domini esclusi.`,
"label.input.right.url":`Inserisci l'URL valido`,
"label.newprocessstep5.tip":`La pagina di approvazione è dove un approvatore approverà o rifiuterà effettivamente una richiesta. Usando le opzioni qui sotto, scegli i campi da visualizzare in questa pagina.`,
"label.schedulejob.setup.schedule.st4":`Il 4`,
"label.emailsync.status.user":`Utenti`,
"front-kefu-moudle-v1-jymm-reinput":`Inserisci una password di 12 cifre, combinando due o più tra maiuscole, minuscole, numeriche e caratteri`,
"Lead_Scoring_Setting_Rule_Setup_RuleName":`Nome della regola di punteggio`,
"label.mr.title.fieldName":`Nome del campo`,
"label.data.deriall":`Esportare tutto`,
"label.tianyancha.businessverify.step2":`Abilitare la verifica dei dati aziendali passo 2`,
"label.submissions":`Invii`,
"vue_label_calendar_removed_successfully":`Calendario rimosso con successo`,
"label.eventrecordtype":`Tipi di record di eventi`,
"lable.outlook.detail.syndire":`Direzione di sincronizzazione`,
"label.mobile.bind.fail":`Collegamento non riuscito, riprova più tardi`,
"label.notification.task2":`【被分配人】 visto il compito che hai assegnato`,
"label.partnerCloud.orderingPlatform.paymentMethod":`Paga da:`,
"label.escalation.setup.newaction.step3":`Passo 3 Selezionare l'utente da notificare`,
"label.summaryreport.selectsum":`Scegliere i dati riassunti e il tipo di riassunto`,
"label.components.setup":`Impostazioni dei componenti`,
"label.taskevent.introduce":`La tua lista di attività`,
"label.assignment.setup.detail.conditon":`Criteri`,
"front-lightning-module-v1-details-page-chart-select-statements":`Seleziona il rapporto`,
"lable.Song.typeface":`SimSun`,
"label.formulassesstrue":`la formula valuta a vero`,
"label_partner_common_setup":`Impostazione generale`,
"label_chatter_dateRange":`Intervallo di date`,
"label.partner.workspace.tab.mobile.using":`Visualizzazione sull'applicazione mobile`,
"message.servicecrew.time.violation1":`Violazione del tempo di assegnazione: c'è un membro della squadra.`,
"report_label_projectcount":`elementi, ordinati per nome del rapporto`,
"label.file.uploadfile":`Caricare i file`,
"vue_label_commonobjects_detail_correct_email_address":`Inserisci l'indirizzo email corretto`,
"lable.account.CurrentandNextCQr":`Corrente e prossimi 3 CQ`,
"setup.layout.label.order":`Ordina per`,
"label.service.major.event.independent":`Indipendente`,
"label.icon.38":`Posizionamento`,
"label.knowledge.draft.record":`Il record che stai cercando di cancellare non è stato trovato.`,
"label_quota_percentage":`Mostra il completamento Percentuale della quota`,
"label.escalation.setup.entrydetail.escalation.minute":`Verbale`,
"label.knowledgebase.edit.article.category":`Modifica la categoria dell'articolo`,
"Homepage_News_003":`Impossibile visualizzare le notizie senza i dati dell'account, si prega di creare un nuovo account e le notizie relative saranno mostrate.`,
"label.mr.descreption.oneGroupNote3":`documenti.`,
"label.customsetting.touse.getListCustomSetting":`Interroga i dati di tipo "list" delle impostazioni personalizzate, restituisce tutti i dati corrispondenti a API Name. Map map = cs.getListCustomSetting(String apiName);`,
"message.error.view.cannotbenull":`Errore: devi inserire un valore`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.friday":`Venerdì`,
"message.error.view.badprevilege.qin":`Spiacente, non hai accesso a {1}, quindi nessun dato mostrato</br>`,
"label.dashboard.distribution":`Distribuzione`,
"label.field.value.save":`Serve sempre un valore in questo campo per salvare il record.`,
"label_custom_year":`Anno personalizzato`,
"label.code.error":`Il codice contiene comandi o funzioni che non sono permessi come segue:`,
"label.appexchange.uninstallpage.message2":`Rimuovere definitivamente tutte le impostazioni personalizzate per questi componenti`,
"label.global.search.obj":`Oggetto di ricerca globale`,
"label.emailobject.from":`Da`,
"lable.opppdt.selPdt.byconditions":`Per campo`,
"chatter.p.note":`Note di questo post`,
"label.hiddenformulaedit":`Editor di formule nascosto`,
"label.editQuotation":`Modifica preventivo`,
"label.notification.arketsea.collection":`{5} raccolto{2}{0}{0}:{1}`,
"label.timzone.tip.info1":`Quando si tratta di salvare dati di tipo java. util.Date （inserire e aggiornare） in un database, per esempio, Quando si tratta di salvare database (inserire e aggiornare) di tipo java.util.Date, per esempio, TpSysTask task=new TpSysTask () ；task.setBeginTime (new Date () ）；......dbman.insert (task) o dbman.update (task); si dovrebbe cambiare new date () per chiamare TimeUtil.getNowDate (userInfo), quindi la relativa dichiarazione nell'esempio sopra dovrebbe essere modificata in task.setBeginTime (TimeUtil.getNowDate (userInfo);)`,
"label_tabpage_transformationsz":`Convertire`,
"front-kefu-moudle-IP-phone":`Telefono IP`,
"label.emailobject.list.draft":`Bozze`,
"label.tianyancha.businessverify.readandconfirm":`Ho letto l'accordo e sono d'accordo`,
"label.win.customers":`Conti chiusi`,
"vue_label_commonobjects_view_switch_display":`I tuoi record sono raggruppati per tipo di record, puoi cliccare sul nome del tipo di record corrispondente per cambiare visualizzazione.`,
"pagecreator_systemstyle_label_textcolor":`Colore del testo`,
"label.autosearch.keywords":`Completa automaticamente la ricerca delle parole chiave`,
"label.knowledge.setting.data.six":`Stai per cancellare la categoria {lbmc}, sei sicuro di continuare?`,
"front-console-sort-field":`Caso n.`,
"label.bangladesh.time":`Tempo del Bangladesh`,
"label.dashboardSetup.number":`Valori numerici`,
"lable.account.LastbDays":`Ultimi 30 giorni`,
"label.layout.searchdialog":`Finestra di dialogo di ricerca`,
"label.newprocessstep4.tip":`Seleziona il modello di email che sarà usato per notificare agli approvatori che una richiesta di approvazione è stata loro assegnata. Nota che questo modello sarà usato per tutti i passi di questo processo.`,
"label.nousing":`Inattivo`,
"vue_label_report_detailline":`Linea di dettaglio`,
"label.emailobject.template.message3":`Il massimo di modelli di posta è stato raggiunto!`,
"label.c.d":`Relazione da C a D`,
"message.report.error.fail":`Caricamento fallito, riprova per favore`,
"label.edit.ccdocument.content":`ha modificato l'attecchimento.`,
"label.textmessage.exceeded":`Il numero dei tuoi modelli di testo ha superato il limite!`,
"label.saveas":`Salva con nome`,
"label.visualpage.an.inline.style":`Incorpora il tipo di pagina personalizzata nella pagina dei dettagli e nella home page della scheda`,
"label.pagelayout.remark2":`dati. Dopo aver creato i layout di pagina, clicca sul pulsante Assegnazione layout di pagina per controllare quale layout di pagina gli utenti vedono di default.`,
"label.notification.approval1":`La richiesta di approvazione del【对象】 è approvata da【审批人】`,
"label.h5.chatter.image":`Caricare il formato dell'immagine non è corretto`,
"vue_label_dashboard_displayunit":`Si prega di selezionare un'unità di visualizzazione`,
"label.knowledge.default.language":`Linguaggio predefinito della conoscenza`,
"label.chatter.publish":`Pubblica`,
"label.companyprofile.serveraddress":`Questa sincronizzazione sincronizza solo il server corrente.`,
"label.chatter.groups":`Gruppo`,
"label_set_successfully":`Impostato con successo!`,
"label.quote.zongjia":`Prezzo totale`,
"label.project.notice.endingdatelater":`La data di fine dovrebbe essere successiva o uguale alla data di inizio.`,
"label.customfields.fielddependency.info":`Questa pagina permette di definire le dipendenze tra i campi (per esempio, picklist dipendenti).`,
"vue_label_lead_successful_conversion":`Conversione riuscita`,
"label.icon.93":`Libro`,
"shift.serviceresource.illegal":`La risorsa di servizio non è pertinente al membro del territorio di servizio o la data di spostamento non è all'interno della gamma di appartenenza.`,
"label.integrations.action.addnewlead":`Aggiungi nuovi contatti`,
"label_display_all_zeros":`Mostra tutte le righe con valori zero`,
"canlendaryear":`Anno solare`,
"label_tabpage_selrecordtypez":`Seleziona il tipo di registrazione`,
"vue_label_commonobjects_view_chart_funnel":`Grafico a imbuto`,
"label.layout3":`Layout 3`,
"label.logintime.cue":`Nessun tempo di accesso specificato.`,
"label.service.miniProgram.lastDate":`Data ultima modifica`,
"label.emailobject.view.fromcrm":`Email da contatti/lead`,
"pagecreator.button.mobilepage":`Lato mobile`,
"lable.oppt.jieduan.signcur":`Contrassegnato come la fase attuale`,
"label.fullaccess":`Accesso completo`,
"homepage.layout.pagename":`Nome del layout di pagina`,
"label.appointment.wizard.subtitle4-2-3":`3 h`,
"label.knowledgebase.please.check.record":`Si prega di selezionare almeno un record.`,
"label.view.sortview.closepage":`Chiudere la finestra`,
"label_forecast_type":`Tipo di previsione`,
"all.day":`Tutto il giorno`,
"label.view.sortview.printpage":`Stampa questa pagina`,
"message.integration.configure":`La configurazione integrata è vuota!`,
"label.forecast.customforecast.foretype.close":`Chiuso-Vittoria`,
"label_chatter_like":`Come`,
"template.report.folder.customer.potential":`Analisi dei lead`,
"label.umeng.approval.dlsp.approve":`#approvalname ha approvato la richiesta di approvazione di #actorname di #objAPIName #recordname per te.`,
"vue_label_normal_movedown":`Spostarsi verso il basso`,
"chatter.group.groupAccessPermissions":`Accesso di gruppo`,
"label.visualpage.tip":`Puoi creare la tua pagina qui`,
"message.validation.isnotdate":`Data non valida`,
"label.icon.173":`Barca a vela`,
"label.icon.124":`Iniezione`,
"label.import.page2.csvfiled":`Campo CSV`,
"setup_layout_component_area":`Area`,
"label.visualpage.workability.standard":`Classi standard disponibili sulla pagina`,
"label_emailtocloudcc_redmessage9":`Errore del database, si prega di contattare l'amministratore.`,
"label_tabpage_contactsz":`Contatti`,
"label.multilang.workflow.everydayinmonth":`{1} giorni ogni {0} mesi`,
"APPIntegration.Social.linkedinerror":`Devi inserire un URL valido per linkedin.com`,
"button_partner_workspace_manage_memo":`Gestisci il tuo cloud partner e configura le proprietà del cloud partner.`,
"template.chart.bnsrmb":`Obiettivo di entrate per l'anno`,
"chatter.follow.now":`Seguendo`,
"label.entitlement.process.condition.repeat":`Impostare la ripetizione della pietra miliare`,
"label.relationobject.isdl":`Delegato`,
"label.lasttimemodifieralias":`Ultimo alias del modificatore`,
"vue_label_commonobjects_detail_task_name":`Modifica il nome del compito`,
"vue_label_homepage_quarterlyperformance":`Performance trimestrale`,
"pagecreator.layout.message.delete":`Elimina il layout correntemente selezionato?`,
"component_sendmail_label_cc":`Cc`,
"vue_label_email_enable_signature":`Abilita la firma`,
"label.partnerCloud.financeSetting.create":`Crea automaticamente un fondo per gli utenti idonei quando vengono attivati nuovi parters.`,
"label.data.file.i.title.num1":`1. Il file importato deve essere un file in formato CSV. Il file deve contenere un titolo e non può essere importato senza titolo.`,
"label_efine_assessment":`Ciclo di valutazione`,
"message.duplication.label.sectionTitle":`Selezionare il valore da conservare`,
"front-electronic-export-buttonExport":`Continuare a esportare`,
"message.submitpage.email":`Congratulazioni, e-mail inviata con successo.`,
"after":`Dopo`,
"label.version.nonsupport":`Unsupport`,
"label.icon.105":`Programma`,
"label.quickcreate.titledesc":`Abilita Quick Create per permettere agli utenti di creare record dall'interno della finestra di ricerca.`,
"label.quote.number":`Inserisci la quantità`,
"label.view.sortview.setdefault.prompt":`Appunta questa lista di vista`,
"label.refertime":`Data di presentazione`,
"frame.personinfo.label.minipic":`Immagine in miniatura`,
"label.mobile.home.page.newopp":`Leads creati di recente`,
"label.address":`Indirizzo`,
"front-pay":`Paga`,
"label.chat.serviceAppointment":`Avviso di servizio`,
"label.umeng.activity.eventviewed":`L'evento che hai assegnato a #nome viene visualizzato`,
"label.validate.function.funcExplain.DATE":`Creare la data attraverso l'anno, il mese e il giorno`,
"label.commiterselectapprover":`Lasciate che chi invia scelga manualmente l'approvatore.`,
"label.appointmentconfirmpage.wizard.subtitle3":`Posizione`,
"vue_label_display_text_field":`Mostra campi di testo`,
"label.salescloud.teamrole":`Ruolo di squadra`,
"maintenanceplan.workorder.generate.limit":`L'ordine di lavoro deve rientrare nella gamma del programma di manutenzione.`,
"label.campaignmember.selectmember.description":`selezionare una vista, poi aggiungere i membri alla campagna, e lo stato del menmeber della campagna è`,
"label.ismodify":`Consentire la modifica`,
"label.height":`Alto`,
"label.tabpage.thevalurofz":`Il valore di`,
"label.create_successful":`Creare il modulo con successo`,
"front-invoice-online-payment-setup-configure-dialog":`Configurare l'interfaccia di pagamento`,
"label.customerinfo.smsEid":`Gateway SMS EID`,
"label.visualpage.list.no":`Nessun permesso per accedere alle pagine personalizzate`,
"look.trigger.in":`Visualizza le istruzioni`,
"label.setting.disable":`Disattivare`,
"chatter.group.name":`Gruppi`,
"label.solutionadministrator":`Responsabile delle soluzioni`,
"label.vlidaterule.top":`Inizio pagina`,
"pagecreator.layout.message.save.fail":`Salvataggio del layout non riuscito`,
"label.partnerCloud.orderingPlatform.noZero":`La quantità non può essere 0.`,
"label.customfields.suretodeleteprompt":`Confermare le richieste di cancellazione del campo personalizzato`,
"button_partner_viewdetail":`Vedi`,
"label.icon.122":`Casa`,
"label.customer.tab.step2.introduce":`Scegli i profili utente per i quali la nuova scheda personalizzata sarà disponibile. Puoi anche esaminare o modificare la visibilità delle schede dalle pagine di dettaglio e di modifica di ogni profilo.`,
"label.task.delegated":`Delegato`,
"vue_label_salesadvance_averageamount":`Per transazione del cliente`,
"vue_label_chat_invitedtojoin":`{invito} ti ha invitato a partecipare alla chat di gruppo`,
"label.data.downpage.e_title.num1":`1. Seleziona gli oggetti che vuoi esportare, o scegli di esportare tutti.`,
"label_display_options":`Opzioni di visualizzazione`,
"vue_label_chatter_more_comments":`Altri commenti`,
"label.ggReleaseRange.publish":`Pubblica elenco`,
"label.valuetype.notmate":`Errore di condizione della linea, il tipo di valore non corrisponde.`,
"label.chatter.chatter":`CCChat`,
"label.exchange.sync.state.contact.m1":`Ultima attività sincronizzata:`,
"label.dataimport.duplication.filter":`Trova i prompt dei filtri duplicati`,
"label.appdownload.uninstall":`Disinstallare`,
"message.error.task.add":`Nuova anomalia del compito`,
"UG.Account.07":`Importazione conto`,
"label_tabpage_lastone":`Seleziona almeno un'operazione`,
"front-console-holdTime":`Tempo di ritardo`,
"label.emailobject.schedule":`Vedi il mio programma e prenota un orario qui.`,
"label.lookup.locked.data":`Questo record è bloccato, non elettivo`,
"label.assignment.setup.newentries.ifcondtions":`Esegui questa regola se il`,
"label.magadan.time":`Tempo di Pietro Pavlov`,
"message.error.serviceterritorymember":`Definisci la risorsa di servizio selezionata come un membro del territorio di servizio all'interno dell'intervallo di tempo del piano di appuntamenti di servizio.`,
"label_chatter_delete":`Cancellare`,
"label.partner.workspace.member.permission":`Permessi disponibili impostati`,
"label.notification.task5":`Il tuo compito è stato in ritardo`,
"mary":`Maggio`,
"label.homepagemodule":`Componenti della pagina iniziale`,
"label.compact.layout.frame.error1":`Lo schermo destro non può non avere contenuto`,
"chatter.error.refresherror":`Refresh fallito, per favore riprova.`,
"label.login.rememberPsd":`Ricordati di me`,
"Lead.Scoring.Setting.Rule.Setup.01":`Elenco di regole per il punteggio del piombo`,
"label.reportsSubscriptionPage.schedulereport.weekly.sunday":`Domenica`,
"label.visible":`Visibile`,
"label.console.new":`Nuova console`,
"label.mr.descreption.reDataList4":`millisecondi. per pagina.`,
"vue_label_notice_uploadavatar_notice2":`L'immagine avatar caricata può essere solo in formato JPG/PNG/GIF`,
"label.operation.error":`Operazione fallita, per favore riprova.`,
"label.sendsms.context":`Contenuto degli SMS`,
"label.least.show.line":`(visualizzare almeno 4 righe)`,
"label.tabpage.newWizardz":`Nuova funzione aggiunta guidata`,
"label.tippage.li2":`Elimina tutti i rapporti basati sull'origine dati del rapporto personalizzato`,
"label.customfields.new.step2.opration.unique":`Unico`,
"label.listofshare.remark":`I seguenti utenti possono visualizzare i record`,
"label.address_information":`Informazioni sull'indirizzo`,
"label.projectManagement.overdue.tasks":`Compito scaduto`,
"lable.account.PreviousCQ":`Precedente CQ`,
"label.service.miniProgram.advertising":`Il nome dell'annuncio viene utilizzato solo per identificare le voci di annunci multipli e non viene visualizzato nell'annuncio.`,
"label.integrations.mailchimp.exportlead":`Esportazione di lead selezionati su Mailchimp`,
"label.payments.paytip3":`Si prega di selezionare un indirizzo di fatturazione`,
"label.mobile.phone.screen":`Filtro`,
"label.h5.tome":`Su di me`,
"label.mobile.side.tab.remark1":`Aggiungete la scheda e l'oggetto CloudCC al menu di navigazione del cursore lato mobile.`,
"vue_label_calendar_choose_a_custom_color":`Scegli il colore personalizzato di questo calendario`,
"label.lastname":`Nome`,
"vue_label_dashboard_selectreport":`Si prega di selezionare il rapporto`,
"label.lanxin.setting.appid":`AppID`,
"vue_label_report_information":`Esporta il rapporto come visualizzato in Cloud CC, includendo l'intestazione del rapporto, le informazioni del gruppo e del filtro.`,
"label_chatter_default":`Default`,
"label.globalSearch.info":`Cerca tutti gli oggetti selezionati`,
"label.integrations.mailchimp.massage2":`Esportare i lead selezionati in Mailchimp e sarai in grado di visualizzare i lead nella lista di Mailchimp in seguito`,
"label.tabpage.addresswrongz":`Il formato dell'indirizzo della casella di posta è sbagliato, inserisci correttamente l'indirizzo della casella di posta!`,
"label.mobile.phone.customer.call":`Visita il cliente`,
"vue_label_email_linkrecordfail":`Record non collegati`,
"lable.account.LastfDays":`Ultimi 90 giorni`,
"label.cpq.order.status.delete":`Questo ordine è attivo e non può essere cancellato`,
"label.ccchat.notmember.active.group":`Non sei membro`,
"label.savepayset.failure":`Impossibile salvare il conto di pagamento online`,
"label.version.createlimitbyobject":`La tua attuale edizione di CloudCC è {0}, e puoi creare {1} {2} per ogni oggetto. Ora, il numero di {2} ha superato il massimo del tuo piano di abbonamento, aggiorna la tua edizione CloudCC.`,
"approval.process.errore":`Si è verificato un errore durante il salvataggio, contatta l'amministratore.`,
"label.stdashbord.xsld.business.reportanalysis":`Analisi dei grafici`,
"label.login.verification.please.enter":`Inserisci il codice di sicurezza che ottieni dall'applicazione MFA`,
"label.tabpage.cue":`Promemoria delle informazioni`,
"vue_label_salesadvance_converserate":`Convertire il rapporto`,
"label.marketsea.recyclereminddays1":`Prima del riciclaggio automatico`,
"label.import.page1.update":`Aggiornamento`,
"label.document.folder":`Cartelle di documenti`,
"label.h5.similar.opportunity.feature":`Questa funzione permette all'utente di cercare opportunità che condividono campi comuni con l'opportunità. Una volta attivata, un elenco di opportunità simili appare sul record dell'opportunità.`,
"label.myanmar.time":`Tempo del Myanmar`,
"monday":`Lunedì`,
"vue_label_account_shareholder":`Azionista`,
"button.partner.search":`Informatevi su`,
"label.partnerCloud.partnerAccount.topUpAmount":`Importo di ricarica`,
"label.tabpage.refreshz":`Aggiorna`,
"lable.PowerProcess.complete":`Milestone Completamento Mins`,
"front-kefu-moudle- normal-phone":`Telefono generale`,
"label.user.unauthorized.organization":`Organizzazione non autorizzata, si prega di contattare l'amministratore.`,
"label.area.canot.save.nulldata":`Impossibile salvare i dati nulli`,
"label.version.role.management":`Gestione dei ruoli`,
"label.recordtype.batchaddattachments.batch.remark":`Passo 1 Scegliere il file, Passo 2 Fare clic sul pulsante "start upload", caricare i file, Passo 3 Fare clic sul pulsante per finire.`,
"label_tabpage_contentz":`Si prega di inserire il contenuto`,
"label.partner.workspace.member.all":`Tutti`,
"label.validate.function.funcFormat.LEFT":`LEFT(testo, num_chars)`,
"vue_label_SMS_notice_selectatleastone":`Seleziona almeno una traccia o un contatto`,
"label.appupload.install.error.choice5":`Interrompere immediatamente l'installazione ed eliminare i componenti in conflitto`,
"label.version.lookupmdfield":`Campo di relazione Master-Detail`,
"setup.layout.label.desc":`Discendente`,
"vue_label_report_addsummaryformula":`Aggiungi una formula di riepilogo`,
"label.done":`Fatto`,
"label.input.samevalue":`Inserisci lo stesso valore`,
"label.SMS.next":`Seleziona gli oggetti per le notifiche SMS e clicca su "Avanti". Le notifiche SMS possono essere associate solo allo stesso tipo di regole del flusso di lavoro e processi di approvazione.`,
"label.role.allunselectuser":`Tutti gli utenti non assegnati`,
"label.loginhistory":`Storia di accesso`,
"vue_label_report_addpublicreportstofolder":`Aggiungi i rapporti pubblici a questa cartella`,
"label.email.track.no.attachment":`Nessun allegato`,
"label_network_connection_failure":`La connessione di rete non è riuscita.`,
"vue_label_file_delete_lib_member":`Elimina il membro della libreria dei file`,
"label_partner_step1":`Passo 1 selezionare il modello`,
"label.password":`Password`,
"label.select.the.fields.around.code":`Scegliere i campi da visualizzare intorno al codice QR/codice a barre.`,
"label.file.share.limit":`Oltre il limite di azioni, nessuna nuova azione può essere aggiunta!`,
"label.desktop":`Desktop`,
"label.sendmail":`Inviare un'e-mail`,
"label.quote.detail":`Voci del preventivo`,
"label.approvalstep2":`Passo 2 Specificare i criteri del passo`,
"label_component_hotdeal_nodata":`Nessun dato relativo alle opportunità commerciali.`,
"lable.reset":`Azzerare`,
"label.eventpagelayout":`Layout della pagina dell'evento`,
"label.icon.100":`Cartoleria`,
"UG.quota.03":`Modello di citazione`,
"label.calendar.week.view":`Vista della settimana`,
"component_chatter_file_button_save":`Pubblica`,
"label.as":`Come`,
"template.chart.yqxypjz":`Risposta media attesa`,
"UG.Contract.03":`Creare un contratto`,
"label.projectManagement.gantt":`Grafico di Gantt`,
"label.forecast.edit.error0":`Errore: È necessario selezionare almeno una valuta aziendale.`,
"label.ccpeak.delete.sharetab":`Cancellare il modulo di condivisione`,
"label.account.contact.goback":`Torna a Conti`,
"vue_label_email_insert_field":`Si prega di selezionare il campo di inserimento`,
"setup_object_field_dependency_label_fieldvalueoptions":`Valori di campo disponibili`,
"label.salescloud.opportunity.contactrole.optionlist.main":`La seguente è la lista principale dei valori dell'elenco di opzioni per il campo ruoli di contatto sulle opportunità`,
"label.huanxinconfig.tenantid.lost":`tenantid non può essere vuoto`,
"label.mask.show.last_4":`Maschera gli ultimi quattro caratteri`,
"label.targer.name":`Nome dell'indicatore`,
"vue_label_commonobjects_detail_unlocksuccess":`Sbloccato con successo`,
"front-kefu-moudle-length-min":`Lunghezza (minuti)`,
"label.chat.topic.my.favorite":`I miei argomenti preferiti`,
"chatter.upload":`Carica`,
"message.cannotapproveit":`La richiesta di approvazione non può essere elaborata.`,
"label.weixin..xsld.order.by.jine":`Ordina per importo del contratto`,
"label.projectManagement.wait.test":`In attesa di test.`,
"template.report.customer.contact.list":`Elenco dei contatti dei conti`,
"label.empty.recycle.bin":`Cancellare il cestino`,
"label.detail.approveprocess":`Visualizza i processi di approvazione`,
"label.appexchange.uninstallpage.message4":`Elimina definitivamente tutti i rapporti, le viste e le schede personalizzate degli oggetti personalizzati in questo pacchetto`,
"label.weixin.linkreport":`Relativo a→Rapporto`,
"label.tianyancha.orgnumber":`Codice di organizzazione`,
"Q":`Lista di scelta (multi-selezione)`,
"pagecreator_systemstyle_message_save_fail":`Salvataggio stile fallito`,
"label.partner.new":`Nuvola dei partner: nuovo`,
"label.ems.accounttype":`Tipo di conto (a)`,
"label.weixin.next":`Prossimo`,
"label.weixin.coach.interpret":`Aid-Max si riserva il diritto di revisione e di interpretazione finale nell'ambito della legge sul servizio WeChat.`,
"label.some":`record(s)`,
"label.currency.rate":`Modifica della valuta: tassi di conversione`,
"label.emailobject.template.name":`Nome del modello`,
"UG.Campaign.001":`Pianificazione di campagne`,
"label.mr.descreption.reDataList3":`gruppi di dati, tempo di interrogazione`,
"label.project.hit.nine":`Promemoria del problema quotidiano`,
"lable.PowerProcess.golist":`<<Lista posteriore: Processo di autorizzazione`,
"label.viewbuttonedit.remark":`Seleziona i pulsanti standard e personalizzati visualizzati nella vista in primo piano.`,
"label.component.helper":`Assistente`,
"lable.SalesCommitmentKanBan.contractAndReceipts":`Pagamento firmato`,
"chatter.group.userName":`Nome utente`,
"label.mobile.phone.business":`Opportunità`,
"label.quickbooks.payments":`PAGARE`,
"label.step6.total7":`Passo 6 di 7`,
"label.forecast.detailforecast.revenue":`Previsione delle entrate`,
"vue_label_commonobjects_view_chart_displayas":`Visualizza come`,
"label.recordeditoption":`Proprietà di modificabilità dei record`,
"label.sendemail.send.sendfailstandby":`L'invio di e-mail non è riuscito, si prega di contattare l'amministratore (posta in uscita di riserva).(codice di errore:`,
"label.knowledgebase.reset.filter":`Azzera il filtro`,
"label.icon.111":`Cibo`,
"label.standard.buttonandlink.firstsetting":`Sovrascrivere le proprietà`,
"front-filter-module-v1-filter-description":`Il filtro flash non può essere salvato. Si applica solo all'operazione corrente senza alcuna influenza sulle visualizzazioni o su altri utenti.`,
"label.showmore":`Vedi altro`,
"UG_Lead_001":`Come introdurre gli indizi?`,
"label.exchange.sync.state.setting.m1":`Account di servizio Miscrosoft Exchange fornito:`,
"label.please.enter.channel.name":`Inserisci il nome del canale.`,
"label.emailtocloudcc.edit":`Modifica`,
"label.layout.tabdialog":`schede`,
"label.Emoji":`Emoji`,
"template.report.completed.tasks":`Compiti completati`,
"label.tabpage.enterviewname":`Passo 1 inserire il nome della vista`,
"label.mobile.phone.not.to.choose":`Nessuna selezionata`,
"label.datamanage.contact.namenull":`Nota: Nota: se il campo del nome del contatto è nullo, il record non sarà importato.`,
"LT":`Geolocalizzazione`,
"label.exchange.sync.state.task.m3":`Registrazioni sincronizzate nelle ultime 24 ore:`,
"lable.SalesCommitmentKanBan.contractOwner":`Proprietario del contratto`,
"vue_label_chatter_write_review":`Scrivi un commento`,
"label.h5.approval.enter.content":`Inserisci le note di approvazione`,
"label.location.display.type":`Metodo di visualizzazione di latitudine e longitudine`,
"label.numberscannotnull":`Il numero non può essere vuoto`,
"label.icon.3":`Valuta`,
"setup_object_field_dependency_label_linkedfieldvalue":`Campo dipendente`,
"label.task.future":`Compiti futuri`,
"label.look.more.record":`Mostra di più`,
"vue_label_account_cases":`Trasferire tutti i casi di proprietari di clienti`,
"label.emailobject.emaildetail.title.ccaddress":`CC:`,
"label.setHistoryTrack":`Impostare la tracciabilità della storia`,
"ObjectDetailed.ViewKeyInformation.Layout":`Modifica delle informazioni chiave`,
"label.layout.editsearchdistribute.tip":`Seleziona i campi da includere in questo layout di ricerca. Nota che le tue scelte determinano solo la visualizzazione dei risultati della ricerca e non influenzano i campi che vengono effettivamente ricercati.`,
"label.emailtoall":`Invia email a tutti gli utenti.`,
"label_partner_new":`Nuvola dei partner: nuovo`,
"label.direct.dashboard.me.not.approval":`I miei articoli da approvare`,
"label.platform.customize.customizeui":`UI personalizzata`,
"label.userinfo.pwderror.againinput":`La password inserita due volte non è la stessa. Si prega di reinserirla.`,
"label.customsetting.introduce":`Usa le impostazioni personalizzate per creare e gestire dati personalizzati a livello di organizzazione, profilo e utente. I dati delle impostazioni personalizzate sono memorizzati nella cache dell'applicazione. Questo significa che è possibile accedervi in modo efficiente, senza il costo di query ripetute.`,
"label.file.owner":`Proprietario`,
"label.icon.7":`Persone`,
"label.document.query.button":`Fare clic su sfoglia per trovare il file`,
"label.tabpage.turnoffsz":`Chiuso  Convertito`,
"message.error.appid.appsecret.failed":`Non è riuscito a ottenere le chiavi di sicurezza!`,
"vue_label_commonobjects_view_to_display_fields":`Seleziona fino a 10 campi di visualizzazione`,
"label.martrixreport.setlinetitle":`Specificare le intestazioni di riga`,
"vue_label_chatter_applycertification":`Accettare "{nome}" per unirsi alla chat di gruppo?`,
"front-electronic-export-success":`Esportare con successo, controlla nella lista Mailchimp`,
"label.emailsync.status.enable":`Collegamento attivo`,
"label.c_d":`Relazione da C a D:`,
"PageLayout_Search_MultiSearch_003":`Seleziona almeno un campo.`,
"label.tabpage.newInterfacez":`La nuova interfaccia`,
"label.cutomsummaryfieldedit":`Modifica del campo di riepilogo personalizzato`,
"label.usermanage.view.field.notexist":`Il campo corrispondente alla vista non esiste.`,
"label.list.userinterface.dashboard.setup":`Impostazione del cruscotto`,
"label.knowledgebase.delete.article":`Cancellare l'articolo`,
"label.dataimport.type.update":`Aggiornamento`,
"label.marketsea.new":`Nuova piscina`,
"label_tabpage_newlybuildz":`Nuovo`,
"vue_label_helpcenter_report1":`1.Costruisci un rapporto<br> Il rapporto Lightning nel sistema di gestione delle vendite Cloud CC è un potente strumento di analisi dei dati. Molti problemi di vendita possono essere risolti raggruppando, filtrando e riassumendo i record. Per esempio: "Quante entrate hanno creato le nuove opportunità commerciali dell'azienda nell'ultimo trimestre?" I grafici del rapporto possono essere aggiunti sulla base del completamento della panoramica dei dati. Dopo che il rapporto è completato, clicca su Run per visualizzare i risultati completi dei dati. <br> Passo 1: Dalla scheda del rapporto, fare clic su "Nuovo rapporto";<br> Passo 2: Selezionare l'origine dati del rapporto, quindi fare clic su "Avanti";<br> L'origine dati del rapporto scelto può determinare quali record o campi possono essere utilizzati nel rapporto. Seleziona o cerca un oggetto come oggetto principale. Puoi selezionare fino a 4 oggetti che hanno una corelazione con l'oggetto principale, e puoi selezionare la relazione tra gli oggetti. <br> Passo 3: Entrare nella pagina di modifica del rapporto e visualizzare l'anteprima dei dati<br> Nella modalità di modifica, è possibile personalizzare il rapporto, aggiungere campi come colonne al rapporto, raggruppare righe e colonne, e utilizzare filtri per filtrare i dati del rapporto fino a quando i dati necessari vengono visualizzati accuratamente<br> Aggiungi o rimuovi colonne e regola l'ordine<br> Aggiungi colonna: Nella modalità di modifica del rapporto, clicca sulla casella di input "Colonna" nel "Riepilogo" sul lato sinistro della pagina, e aggiungi le colonne del rapporto dopo aver cercato il campo o scorrendo l'elenco a discesa dei campi e selezionando il campo di destinazione. <br> Rimuovere la colonna: <br> A. Dopo aver trovato la "colonna" che vuoi rimuovere nell'elenco "colonna" a sinistra, clicca la "×" sulla casella del campo. <br> B. Oppure trova la "colonna" che vuoi rimuovere nell'intestazione della vista di anteprima del report sulla destra, clicca sul "pulsante a discesa" e clicca su "delete column".<br> Rimuovere la colonna dal report non cancella il campo. Se vuoi ripristinare la colonna dopo averla rimossa, basta aggiungerla di nuovo. <br> Regola l'ordine della colonna: Trascinate il campo "Colonna" nella lista "Colonna" a sinistra su e giù per regolare l'ordine di disposizione delle "Colonne". <br>Aggiungi e rimuovi il raggruppamento delle righe e il raggruppamento delle colonne<br> Aggiungi il raggruppamento delle righe: Fai clic sulla casella di input "Raggruppa riga" nel "Riepilogo" sul lato sinistro della pagina, e aggiungi i campi di raggruppamento delle righe del report per filtrare i dati dopo aver cercato il campo o scorrendo l'elenco dei campi a discesa e quindi selezionando il campo di destinazione. <br> Senza aggiungere il raggruppamento di colonna, puoi aggiungere fino a tre raggruppamenti di riga. <br> Aggiungi raggruppamento di colonna: quando il raggruppamento di riga esiste, puoi aggiungere il raggruppamento di colonna. Fai clic sulla casella di input "Group Column" nel "Summary" sul lato sinistro della pagina, seleziona il campo dopo la ricerca o scorri l'elenco a discesa dei campi e seleziona il campo desiderato Modi per aggiungere campi di raggruppamento colonna del report per filtrare i dati. <br> Puoi aggiungere fino a due gruppi di colonne. Nel caso dell'aggiunta di gruppi di colonne, puoi aggiungere fino a due gruppi di righe. I campi aggiunti come gruppi di righe non possono essere aggiunti come gruppi di colonne. <br>`,
"label.notification.event1":`【分配人】 ti ha assegnato un evento`,
"chatter.field":`Campo(i)`,
"chatter.feed.menutype.feed.newscom":`Tutto ciò che seguo`,
"label.attendance.range":`Intervallo di frequenza`,
"vue_label_calendar_deleteconfirm":`Sei sicuro di voler cancellare il calendario {nome}`,
"label.ems.createTask":`Nuovo {taskName}`,
"label.visualpage.wgd":`Pagine personalizzate non archiviate`,
"label.multilang.product.deleterederect1":`Il tuo tentativo di cancellare <font style="font-weight:bold;">{0}</font> non può essere completato perché è ancora associato al seguente record. In questo caso, ti consigliamo di disabilitarlo.`,
"label_emailtocloudcc_filed_servertype":`Server di posta elettronica`,
"label.umeng.insert.approval.dlsp.approvenew":`#actorname presenta #objAPIName#recordname per la tua approvazione`,
"label.tabpage.queue":`Coda`,
"label.approval.step":`Fasi di approvazione`,
"label.approvaldatamove.approvalprocessname":`Nome del processo`,
"label.actualapprovedpeople":`Approvatore effettivo`,
"label.systemlog.f":`GUASTO`,
"front-template-V1-addText":`Aggiungi testo`,
"label.chat.like":`Come`,
"label.userinfo.oldpwd.notnull":`La vecchia password non può essere vuota.`,
"label.service.all.done.major.event":`Hai completato tutte le pietre miliari.`,
"label_chatter_to":`A`,
"message.toomuchlinecannotoutput":`Sono state selezionate troppe colonne del rapporto e il rapporto non può essere emesso.`,
"maintenanceasset.assetid.maintenanceplanid.unique":`Il piano di manutenzione è stato assegnato alla risorsa. Si prega di non assegnare ripetutamente.`,
"lable.quote.syncing.firstsync.description":`Le voci di preventivo sostituiranno i prodotti di opportunità`,
"lable.outlook.mcto.saveemail":`Assicurati di salvare gli allegati dell'email`,
"label.passwordPolicy.setup.pwdremember2":`2 password ricordate`,
"label.project.hit.five":`Avviso di aggiornamento dei compiti`,
"label.linkedin.setting.appid":`Chiave segreta`,
"label.dataimport.error.name.notnull":`Errore: il nome non può essere nullo`,
"label.knowledge.case.field.selected":`Campi di casi selezionati`,
"label.version.datetime":`{0} campi data/ora`,
"Dashboard_NoAccessRightToSee_Warning":`Non hai il permesso di visualizzare i dashboad {0} che sono impostati come aperti di default, per favore ripristinali.`,
"label.login.access.permission":`Concedere l'accesso a`,
"label.operatedata.import.tip":`1. Il file importato deve essere un file in formato CSV. Il file deve contenere un titolo e non può essere importato senza titolo. 2. Si raccomanda di esportare prima di importare, di raggruppare i dati che si vogliono importare per il modello di dati con il documento di esportazione, e poi di importare.`,
"workflow.action.tasks.assignortype.rolename":`Nome del ruolo`,
"vue_label_account_quotations":`Trasferire tutte le quotazioni del proprietario del cliente`,
"lable.account.CurrentCQ":`CQ corrente`,
"label.user.database.error":`Errore del database!`,
"label_emailtocloudcc_titel":`Email a CloudCC`,
"label_file_content":`Contenuto del testo`,
"label.button.behavior":`Comportamento`,
"message.recordtype.new.tip":`Inserisci i dettagli`,
"label.ccchat.message.new.error3":`Errore: non è possibile selezionare più di 9 destinatari`,
"vue_label_commonobject_notice_lessthanwords":`Il nome del file deve essere inferiore a {FILE_NAME_COUNT} parole!`,
"label.stacked.verticalline":`Colonne verticali impilate`,
"vue_label_SMS_messagebox":`Casella dei messaggi`,
"label.appexchange.installedpage.message3":`</b>A seconda dei collegamenti accanto a un pacchetto installato, puoi intraprendere diverse azioni da questa pagina. Per eliminare un pacchetto, fai clic su <b>Disinstalla</b>. Per gestire le licenze del pacchetto, fai clic su <b>Gestisci licenze</b>.`,
"label.unusedapproveprocess":`Processi di approvazione inattivi`,
"label.onlywithspecificconditions":`Solo i record che soddisfano determinati criteri dovrebbero essere inclusi nel calcolo`,
"lable.outlook.mcto.formaterror":`Errore di formato`,
"label.area.parent":`Territorio genitore`,
"vue_label_chat_activesuccess":`Attivato con successo`,
"label.setting.intergrationlist.button.upgrade":`Aggiornare`,
"label.page_hidden":`Campi nascosti per la pagina di registrazione`,
"label.customsetting.manage.belong":`Proprietario dell'installazione`,
"label.appointment.wizard.subtitle4-2-8":`7 giorni`,
"template.chart.ydywjhxsje":`Importo mensile delle vendite di opportunità commerciali`,
"label.multilang.currencylist.after":`Dopo {0}`,
"vue_label_commonobjects_view_chart_countby":`Contare per`,
"label.week":`Settimana`,
"label.emailtemplate.name":`Nome del modello`,
"label.umeng.sign":`firmato in`,
"label.appupload.upload.details":`Dettagli`,
"label.file.loading":`Caricamento`,
"label.newdetail.orgTitle":`Ruoli di contatto`,
"label.salescloud.field.addoptionlist":`Aggiungere valori della lista di scelta`,
"pagecreator.page.funcpath":`/ costruttore / elenco delle pagine`,
"Account.News.Setting.001":`Impostazioni dell'account`,
"label.marketsea.getnoconversiondays":`Giorni non convertiti (deve essere più del numero di giorni senza follow-up dopo aver ottenuto)`,
"message.error.event.add":`Nuovo evento anomalo`,
"front-electronic-export-choseChimp":`Seleziona la lista Mailchimp esportata`,
"vue_label_report_personothers":`Altri`,
"label.hierarchy.diagram":`Struttura gerarchica`,
"label.stdashbord.xsld.business.yqsr":`Entrate previste`,
"label.chat.topic.max.count":`Hai raggiunto il numero massimo di argomenti.`,
"label.sendemail.send.sendfail":`L'invio dell'e-mail non è riuscito, per favore contatta il tuo amministratore.`,
"registration.page.body.title":`Pagina di registrazione`,
"label.userphoto.back":`Indietro`,
"label.service.without.timeslot":`Sembra che non ci siano fasce orarie, aggiungiamo!`,
"label.processsetting.remaining.quantity":`Si possono inserire fino a 255 caratteri, rimanendo:`,
"label.sure.delete":`Confermare per cancellare`,
"front-epwechat-module-v1-callback":`Configurazione di callback`,
"front-email-payment-failed":`Spiacente, pagamento fallito!`,
"label.icon.67":`Macchina`,
"UG_Forcast_01":`Previsione`,
"label.escalation.setup.newentries.step3":`Passo 3 Specificare come sono impostati i tempi di escalation`,
"lable.account.NextCY":`Prossimo CY`,
"report.type.label.quote":`Citazioni`,
"label.area.name":`Nome del territorio`,
"component.setup.label.object":`Oggetti`,
"label.customsetting.type":`Tipo di impostazione`,
"label.showdetail":`Mostra dettagli`,
"label.department.prev":`Pagina precedente`,
"label.select.data.source.report":`Seleziona la fonte dei dati Rapporto`,
"UG_homepage_002":`Gestisci i tuoi indizi, i lead, i funnel delle transazioni di vendita e le informazioni sugli account con strumenti di business integrati`,
"vue_label_report_notice_exprot1":`Vengono esportate solo le righe di dettaglio. Usa questi dati per altri calcoli o per caricarli in altri sistemi. Esportazione a pagine, fino a 5000 articoli su una pagina`,
"message.error.task.phonecreate":`Anomalia nella creazione di un'attività telefonica`,
"label_chatter_day":`Giorno`,
"label.setinitialcommiter":`Passo 6 Specificare i mittenti iniziali`,
"message.huanxinconfig.notfound":`La configurazione di Easemob non è stata trovata`,
"label.customfields.file.count.tip":`Inserisci il numero di file che possono essere inseriti in questo campo, il valore predefinito è 1`,
"label.weixin.appmanage":`Gestione delle applicazioni`,
"label.approverautoconfirm":`Approvazione automatica Determinato da`,
"vue_label_CCChat_followers":`Seguaci`,
"label.usermanage.notselect":`Nessun utente è selezionato.`,
"label.item":`Articolo(i)`,
"label.sendemail.chat.linkurl":`L'URL del link:`,
"label.sendmail.step3.deliveroptions":`Opzioni di consegna`,
"homepage.components.creationtime":`Data di creazione`,
"label.pc.ui.2018.ccchat.setting":`Impostazione CCChat`,
"label.knowledge.search.result.highlight":`Evidenzia gli articoli rilevanti nei risultati della ricerca`,
"label.data.downpage.e.title.num2":`2. Se si sceglie di esportare i dati di un singolo oggetto, è necessario selezionare come i dati vengono esportati: esportazione personalizzata, esportazione per modello e modello di esportazione.`,
"label.field.duplicate.error.msg1":`Qui ci sono dati duplicati, si prega di controllare il duplicato prima, e poi impostare la proprietà unica.`,
"label.campaign.channel.input.number.error":`Errore nel formato del numero`,
"label.goto.dashboard":`Vai a Dashboard`,
"com.cloudcc.login.error.message.invalid.ip":`Il tuo IP non è nell'intervallo IP.`,
"label.selectnewfieldvalue":`Specificare il valore del nuovo campo`,
"label.appointmentdetail.wizard.title11":`Data di fine`,
"Opportunity_Detailed_Phase_Label_Popup_001":`Data di inizio della fase attuale`,
"front-dynamiclayout-module-v1-readonly":`Il campo di {required} è impostato come di sola lettura.`,
"vue_label_calendar_start_field":`Campo per l'inizio`,
"label.weixin.recalculate.shared.failed":`Il ricalcolo delle regole di condivisione degli oggetti non è riuscito.`,
"label.sendmail.step3.dealoptions":`Opzioni di elaborazione`,
"setup_layout_label_modifypage":`Modifica il layout della pagina`,
"homepage.components.select.wide":`Seleziona i componenti ampi da mostrare`,
"label.import.page1.laststep":`Precedente`,
"label.weixin.donot.permission":`Non hai il permesso di eseguire questa operazione.`,
"message.error.name.null":`il nome non può essere vuoto!`,
"label.salescloud.teamrole.optionlist":`Valori della lista dei ruoli di squadra`,
"component_setup_label_titlefield":`Campo titolo`,
"vue_label_commonobjects_detail_have_been":`Sei stato`,
"label.textmessage.vonage.setup":`Configurazione di Vonage`,
"label.recordtype.profile.enableit":`Abilita per il profilo`,
"UG.product.04":`Creare il prodotto`,
"label.knowledge.No.related.articles":`Nessun articolo correlato...`,
"label.chat.muted":`Non disturbare`,
"registration.page.field.selection":`Seleziona il campo della pagina di registrazione`,
"label.project.hit.eleven":`Emettere l'avviso di assegnazione`,
"lable.newtabpage.advsearch":`Ricerca avanzata`,
"label.report.share.roleandsub":`Ruoli e subordinati interni`,
"component.salesperformance.label.nodata":`Aggiungi la tua opportunità di business e torna qui per visualizzare il grafico delle prestazioni.`,
"label.submitted_on":`Presentato il`,
"label.file.create.link":`Crea collegamento`,
"label.contact":`Contatti`,
"label.tab.message.failtoopenleft":`L'operazione di unione non è riuscita ad aprire la colonna di sinistra`,
"label.replaces":`Sostituire`,
"label.customcomponent.check.tag.startwith":`Il componente deve iniziare con l'etichetta &lt;cc:component&gt;.`,
"label.tab.web":`Schede web`,
"message.success.task.add":`Salvare con successo le informazioni del nuovo compito`,
"label.chatter.addresser":`Mittente`,
"label.mobile.homepage":`Homepage`,
"label.data.imp.su.ok":`Importazione di`,
"label.knowledge.category.hint.one":`Il gruppo di categorie è la gerarchia delle categorie di dati. Per esempio, un gruppo di categorie chiamato "Località" può contenere la gerarchia geografica di continente, paese, regione e stato. Usa questa pagina per gestire i gruppi di categorie e le sottocategorie.`,
"label.schedulejob.setup.schedule.weekly":`Settimanale`,
"label.tag.manage.description":`Tutti i tag di {0} sono i seguenti. Puoi rinominare o cancellare i tag disponibili.`,
"label.tabcontrol":`Schede`,
"label.field.duplicate3":`Trattare "ABC" e "abc" come valori duplicati __(case insensitive)`,
"label.customsetting.type.list":`Lista`,
"lable.account.ovdate":`Data di fine del trimestre fiscale`,
"label_chatter_pastSevenday":`Gli ultimi 7 giorni`,
"front-kefu-moudle-v1-lxndxsdb-free":`Contattate il vostro rappresentante di vendita e abilitate il free agent servicer`,
"label.termsforusage":`Condizioni d'uso`,
"label.forecast.settings.qijian.m":`Previsione del mese`,
"label_tabpage_viewname":`Visualizza il nome`,
"label.report.action.addtodashboard1":`Aggiungi al cruscotto`,
"label_vue_create_edit_obj_create_event_dialog_desc":`L'utente che hai assegnato è già impegnato in programmi:`,
"vue_label_report_standardfilter":`Filtro Standard`,
"label.umeng.approval.submit":`#Il richiedente ha presentato un record #obj per l'approvazione.`,
"label.tab.mobile.sign":`Icona lato mobile`,
"vue_label_commonobjects_detail_check_the_content":`C'è un errore di verifica, controlla il contenuto`,
"UG_Campaign_001":`Pianificazione di campagne`,
"chatter.group.baseInformation":`Informazioni di base`,
"label.sendemail.send.noreceiver":`Nessun destinatario o l'indirizzo del destinatario è vuoto.`,
"template.chart.yskje":`Importo del credito`,
"label.textarea":`Area di testo`,
"vue_label_statistics_value":`Valore statistico`,
"font-evaluate-module-v1-select-img":`Seleziona immagine`,
"label.totalof":`Sei un totale di`,
"label.hangye":`Industrie`,
"label.partner.common.setup":`Impostazioni comuni`,
"label.icon.78":`Agricoltura`,
"lable.outlook.detail.addemail":`Aggiungi e-mail`,
"label.ServiceCloud.fuwuquyu":`Territorio di servizio`,
"label.gb2312encoding":`Cinese (GB2312)`,
"label.appointment.wizard.subtitle4-3-1":`10 min`,
"label_emailtocloudcc_reauthorization":`Reauthorization`,
"label.approval.message":`I pareri di approvazione possono essere inseriti fino a 1000 caratteri.`,
"label_component_helper":`Assistente`,
"label.editRate":`modificare i tassi di cambio`,
"label.setuptemplate":`Modelli di automazione`,
"label_emailsync_button_cancel":`Cancella`,
"label.marketseamemset.account.maxuser":`Numero massimo di clienti`,
"label.someerror":`Per ragioni di sicurezza, la tua sessione CloudCC sta per scadere.<br><br>Cosa farai adesso?`,
"label_person_in_charge":`Supervisore`,
"label.visualpage.reference.standard.style":`Richiamare lo stile standard di Platform, stile personalizzato`,
"errormessage_email_relatedorreceivermusthaveone_z":`Devi selezionare almeno un destinatario o un soggetto correlato.`,
"label.insert.field.empty.continue":`I record con valore nullo di 【{resDataField}】 esistono, quindi il codice non può essere generato. Vuoi continuare a generare?`,
"component.newrecords.label.title":`Record recenti`,
"template.detail_info_link":`Dettagli Link`,
"component_setup_tabs_label_default":`Pagina predefinita`,
"label.emailobject.template.name.null":`Il nome del modello di posta non può essere vuoto!`,
"label.knowledge.field.changed":`{1} è cambiato`,
"homepage.components.select.narrow":`Seleziona i componenti ristretti da mostrare`,
"label.mobile.phone.week":`Settimana`,
"component_chatter_button_like":`Come`,
"label.brief.won":`Won`,
"label.setup.profile.replaceme":`Sostituire le cose su di me`,
"label.knowledge.setting.enable.lightning":`Attivare la conoscenza del fulmine`,
"label.middle":`Medio`,
"label.icon.109":`Persone`,
"vue_label_normal_activity_sf":`Attività`,
"chatter.poll.option6":`Scelta 6`,
"label.lanxin.setting":`Integrare Lanxin H5 MiniApp`,
"label.stdashbord.xsld.business.totals":`Opportunità totali`,
"label.emailobject.emaildetail.promptbutton1":`Confermare`,
"Opportunity.Detailed.Phase.Label.001":`Fase`,
"label.customcomponent.params.info":`Come usare i parametri.`,
"label.emailtocloudcc.button.next":`Prossimo`,
"front-email-payment-billing-date":`Data della fattura`,
"label.ems.with3day":`Entro 3 giorni`,
"label.project.subtask.date":`La data del sottocompito deve essere all'interno dell'intervallo di date del compito a cui appartiene.`,
"label.role.allunselectanduseduser":`Tutti gli utenti attivi e non assegnati`,
"front-kefu-moudle-yes-wantbuy":`Sì, voglio acquistare`,
"label.looking_for":`Hai ottenuto quello che stavi cercando?`,
"page.404.label.noresource":`Spiacente, la risorsa a cui vuoi accedere non esiste.`,
"vue_label_ccchat_notice_deletecommentcertification":`Sei sicuro di voler cancellare questo commento?`,
"label.data.setok.e.desc1":`Esportazione di successo, si riceverà un messaggio di sistema avvisi, i dati derivati sono temporaneamente memorizzati nel server, il sistema solo per voi per salvare 48 ore, per favore il più presto possibile per`,
"label.weixin.confirm.delete":`Sei sicuro di voler cancellare questi dati?`,
"A":`Area di testo (testo ricco)`,
"template.report.sales.cycle":`Durata del ciclo di vendita`,
"label.service.shift":`Turni di lavoro`,
"label.visualpage.display.side.bar":`mostra la barra laterale, false - non mostrare la barra laterale`,
"label.list.userinterface.chatter.showall":`La homepage di CCChat mostra tutti i messaggi per impostazione predefinita`,
"vue_label_systemSettings_set_course":`Impostate il percorso aggiungendo suggerimenti per ogni fase, in modo da guidare gli utenti passo dopo passo.`,
"label.icon.156":`Persone`,
"label.marketsea.button.move":`Spostare`,
"front-email-payment-select-email":`Si prega di inserire il codice postale`,
"front-electronic-signature-service-provider":`Fornitore di servizi`,
"label.h5.add.checkin":`Check in`,
"vue_label_amount_total":`Importo totale`,
"label.campaign.channel.new":`Campagne: un nuovo canale di marketing`,
"label.knowledgebase.restore.creates.draft":`Restore genererà una bozza dalla versione corrente. È necessario pubblicare la bozza per farla vedere a tutti.`,
"UG_Case_01":`Caso`,
"label.validate.function.funcExplain.CONTAINS":`Controlla se il testo contiene un carattere specifico, e in tal caso restituisce TRUE, altrimenti restituisce FALSE`,
"label.data.exp.savetemp":`Salva come modello`,
"front-project-module-v1-template-newcreate":`Creare un progetto da un modello di progetto`,
"label.field.default.count":`Numero di righe predefinito`,
"page.note.acc":`Note`,
"label.close":`Chiudere`,
"label.app.detailbeforeedit":`Dettagli delle app personalizzate qui sotto. Clicca su "Modifica" per modificare le app personalizzate.`,
"label.profile.standardfieldsafety":`Sicurezza standard a livello di campo`,
"vue_label_report_notice_deletefilter":`Elimina prima il filtro avanzato`,
"label.multilang.datamoveaction.movesuccess":`Un totale di {0} record è stato trasferito con successo!`,
"label.emailmerge.edittemplate.descirption":`Nota che la descrizione viene visualizzata solo in CloudCC.com, non in Word.`,
"label.visualpage.at.the.end":`Usa il tag alla fine`,
"label.exchange.sync.state":`Stato di sincronizzazione di Exchange`,
"label.newdashboardpage.new":`Aggiungere una riga`,
"label.querydetailservice.profile.notsetup":`Il profilo del tuo account non è impostato.`,
"label.escalation.setup.detail.description":`Aggiungi le voci delle regole che specificano i criteri utilizzati per l'escalation dei casi. Puoi riordinare le voci delle regole in questa pagina dopo averle create.`,
"lable.setup.mobilesetup.isenbaleh5newandedit":`Se abilitate l'h5 nel vostro lato mobile e modificate`,
"vue_label_file_upload_tip_msg":`Raccomandiamo che il file caricato sia inferiore a 30MB, altrimenti potrebbe causare un caricamento lento della pagina`,
"label.eowechat.epdeptid":`ID Dipartimento WeCom`,
"label.adminorapprover":`Gli amministratori <strong>o</strong> l'approvatore attualmente assegnato possono modificare i record durante il processo di approvazione.`,
"label_emailtocloudcc_email":`Email`,
"setup_main2018_label_norole":`Non hai i permessi amministrativi`,
"label.onlyone":`Unico`,
"label.sso.saml.idp.config.nameidtype":`Tipo di soggetto`,
"vue_label_normal_campaign_sf":`Campagne`,
"label.icon.61":`Gru`,
"label.datatype":`Tipo di dati`,
"label.mobile.home.page.today.work":`Il mio lavoro`,
"label.sendemail.chat.praiseFeedcommentsubject":`A CloudCC CCChat è piaciuto il tuo commento`,
"chatter.sel.p":`0 selezionato.`,
"label.b_c":`Relazione da B a C:`,
"label.tabcontrolnameandtaglib":`Nomi ed etichette delle schede`,
"label.globaloperation.tip":`Crea, modifica e visualizza l'operazione globale, che può essere utilizzata per le pagine di dettaglio.`,
"R":`Tipi di record`,
"label.initcommiteoperate":`Azioni di presentazione iniziale`,
"front-kefu-moudle-v1-Operation-without0-permission":`Nessun permesso per operare su questo disco, si prega di contattare l'amministratore`,
"button_partner_create":`Nuovo`,
"label.document.name.length.cannot.than":`La lunghezza del nome del documento non può superare i 255 caratteri.`,
"label.area.donot.delete":`Impossibile eliminare questo territorio, perché il territorio attuale ha un sottoterritorio.`,
"label.currency.activation":`Attivare`,
"label.connect":`&Concatenare`,
"button.partner.viewdetail":`Vedi`,
"setup_object_field_dependency_label_mustsetup":`Impostare prima la dipendenza del campo e salvare.`,
"label.SalesCommitmentKanBan.task":`Crediti Importo del compito`,
"lable.quote.syncing.finishbutton":`Fatto`,
"label.weixin.group.type":`Tipo di accesso`,
"vue_label_commonobjects_detail_relationship":`Grado di relazione`,
"vue_label_email_cc":`Bcc`,
"setup.object.field.dependency.label.fieldvalueoptions":`Valori di campo disponibili`,
"label.sso.lookAtTheKey":`Visualizza chiave`,
"UG.opportunity.008":`Squadra di opportunità`,
"label.customfields.new.step1":`Passo 1 Scegliere il tipo di campo`,
"lable.qrcodeOrbarcode.rule":`Generare regole per codici QR e codici a barre`,
"vue_label_notice_nopermission_delete":`Spiacente, non hai l'accesso per cancellare questo record, per favore contatta l'amministratore.`,
"label.customerobj.tab":`Schede oggetto personalizzate`,
"com.cloudcc.login.error.message.nolicens":`La licenza non esiste`,
"label.sendsms.batch.confirm":`SMS di massa: Conferma`,
"label.forecast.settings.sos":`Entrate e quantità`,
"label.calendar.addevent.notice.opencalendarfirst":`Si prega di aprire il mio calendario o altri calendari prima di aggiungere eventi`,
"message.success.task.phonerecord":`Salvare con successo i registri telefonici`,
"label.knowledgebase.create.new.subtab":`Nuova scheda secondaria`,
"label.knowledge.article.recordid":`L'ID dell'articolo sulla conoscenza non può essere nullo`,
"Opportunity.Detailed.Phase.Label.Popup.003":`Giorni nella fase attuale`,
"homepage.layout.nowpage":`Layout di pagina esistente`,
"template.chart.khslph":`Numero di conti Classifica`,
"front-epwechat-module-v1-android-single":`Android Single Sign On:`,
"serviceresource.assignedresource.islacksr.lack":`Non potete cancellare la risorsa di servizio perché le è stato assegnato un servizio appointtmen. Puoi disabilitare questa risorsa di servizio.`,
"label.email.only.display.info":`Solo i contatti o i colleghi con indirizzi e-mail memorizzati sono visualizzati nella casella sottostante`,
"label.weixin..xsld.yjhtje":`Importo previsto del contratto`,
"label.permission.delete.permsets.error.prompt":`Il set di permessi non può essere cancellato perché ha degli utenti assegnati.`,
"label.ccchat.enter.two.choices":`Inserisci almeno due scelte`,
"label.edit.field.select.style2":`Un'opzione per linea`,
"vue_label_email_please_enter_email_subject":`Inserisci l'oggetto dell'email`,
"batch.sendemail.f":`, posta non riuscita.`,
"label.sms.senderr":`Invio di SMS non riuscito`,
"label.batchadd.newbatchpage.save.em":`Formato e-mail non valido`,
"label.icon.96":`Bussola`,
"message.recordtype.deleterecord.tip":`Usa questa pagina per sostituire tutti i tipi di pecord esistenti con nuovi tipi di record. Selezionate il tipo di record qui sotto per sostituire tutti i record che contengono i tipi di record cancellati. Se volete solo cancellare il tipo di record da un tipo di record esistente senza sostituirlo con un nuovo tipo di record, selezionate "Nessuno".`,
"label.field.edit.max":`Punteggio massimo`,
"label.partnerCloud.orderingPlatform.preferential":`Sconto`,
"label.callcenter.login.later":`Accedi più tardi`,
"batch.change.owner":`Si prega di selezionare il proprietario`,
"label.version.allow.upload.size":`edizione, file massimo consentito per l'upload`,
"setup.mainpage.label.welcome17":`Impostazioni dei permessi`,
"label.tag.sectionname":`Informazioni sull'etichetta`,
"label_partner_workspace_setup":`Impostazioni`,
"label.managecontrol":`Permessi amministrativi`,
"label.timetrigger.condition":`La condizione di valutazione è impostata su ogni volta che il record viene creato o modificato.`,
"label.reportsSubscriptionPage.schedulereport.monthly.week":`Settimana`,
"front-verkoop-bywerking-error":`Aggiornamento fallito`,
"label.allowcommittercallback":`Permettere a chi presenta le richieste di approvazione di richiamarle`,
"vue_label_commonobjects_detail_lead_finishistatus":`Segna lo stato come completo`,
"message.error.object.lookupmd":`il campo di relazione Mater-Detail è creato in questo oggetto`,
"label.stdashbord.xsld.business.img7":`Numero di fasi con probabilità 0% / (Numero di fasi con probabilità 100%   Numero di fasi con probabilità 0%)`,
"label.checkruleofevent":`Regole di convalida degli eventi`,
"front-epwechat-module-v1-single":`Accesso singolo`,
"label.tabpage.save":`Salva`,
"label_emailtocloudcc_search":`Cerca`,
"label.tianyancha.h5.registeredPlace":`Posto registrato (accorciamento)`,
"label.field.addoptionlist":`Aggiungere un valore alla lista di scelta: Picklist`,
"label.schedule_anotherpost":`Pianifica altri messaggi`,
"label.customfields.searchrelation.tip":`Crea una relazione che collega questo oggetto ad un altro oggetto. Il campo di relazione permette agli utenti di cliccare su un'icona di ricerca per selezionare un valore da una lista a comparsa. L'altro oggetto è la fonte dei valori nella lista.`,
"label.partnerCloud.partnerAccount.prepaidPhone":`Ricarica del conto`,
"label.projectManagement.view.details":`Visualizza i dettagli`,
"label.sendemail.chat.praiseFeed":`Caro #nome:\non ciao! A #nomeUtente è piaciuto il tuo micropost.`,
"label.validate.function.category.Text":`Testo`,
"component.task.label.newevent":`Nuovo compito`,
"label.data.import.setup.operate":`Cosa vuoi fare se trovi un record\uff1f esistente`,
"label.salescloud.salesdashboard.clear.option":`Opzioni chiare`,
"lable.account.PreviousCY":`Precedente 2 CY`,
"label.appointment.wizard.subtitle8":`Nome della società visibile per l'invitato`,
"label_emailsync_status_viewlog":`Visualizza registro`,
"message.duplication.label.filtertitle":`Trova i filtri duplicati`,
"label.custom.quarter.description":`Questa pagina ti permette di definire e modificare il trimestre personalizzato. La data del trimestre personalizzato sarà generata in base alle scelte che fai qui sotto.`,
"label_tabpage_filenamez":`Nome del file`,
"lable.currencyAdv.andbefordate":`e prima che`,
"label.version.nonsupport.sharerule":`Le regole di condivisione non sono supportate temporaneamente.`,
"front-epwechat-module-v1-unbound":`Sblocca`,
"label.division":`Divisione`,
"label.data.import.setup.repeat":`Vuoi evitare che vengano creati record duplicati?`,
"label.callcenter.makesure.Amazon.connect":`Nota: assicurati di aver creato un'istanza di Amazon Connect`,
"label.version.lead.control":`Gestione del piombo`,
"label.copying.reward.groups":`Gruppo di linee di quote clonate`,
"#label.severalorone":`Zip o file individuale#`,
"label.mailinginfo":`Indirizzo postale`,
"component.telerecord.label.title":`Registrare una chiamata`,
"label.godocumentlist":`Torna alla lista: Documenti`,
"APPIntegration.Dropbox.setting.01":`Abilita`,
"label.tianyancha.website":`Sito web`,
"label_tabpage_greaterequalz":`Maggiore o uguale a`,
"vue_label_campaign_influencedopportunity":`Opportunità di business influenzato`,
"message.save.param.null":`Il parametro è vuoto, salvataggio fallito`,
"front-epwechat-module-v1-domain":`Nome di dominio di fiduciaJSSDK:`,
"label.allowreport":`Consentire i rapporti`,
"label.service.major.event":`Pietra miliare`,
"label.import.index.selectobjectandfiles":`Selezionare l'oggetto e il file`,
"label.chatter.task":`Compito`,
"label.knowledge.setting.hint.twelve":`Inserisci la categoria dei dati`,
"lable.account.CurrentandPreviousFY":`Esercizio corrente e precedente`,
"label.martrixreport.step3":`Passo 3 Selezionare i dati riassunti`,
"front-console-select-cases":`Il numero di casi selezionati non può superare il 10`,
"label.partnerCloud.partnerAccount.backHome":`Torna alla pagina iniziale`,
"label.me.assign":`Assegnato da me`,
"label.appointment.wizard.subtitle3":`Ora della riunione`,
"label.edit_columns":`Modifica colonne`,
"label.partnerCloud.orderingPlatform.useRebates:":`Utilizzare il rimborso:`,
"label.projectManagement.enter.up.to.10.digits":`Si possono inserire fino a 10 cifre.`,
"label.integrations.description.mailchimp":`Integrando CloudCC con MailChimp, sarai in grado di importare lead e contatti selezionati dal tuo account CloudCC a MailChimp e inviare l'email ai destinatari previsti.`,
"label.ccchat.person.error.requiredomain":`Errore: è richiesto almeno un dominio`,
"label.projectManagement.Pleaseselectitem":`Seleziona il progetto`,
"label.netaccess":`Accesso alla rete`,
"vue_label_SMS_searchobject":`Oggetto di ricerca`,
"label.role.viewintree":`Mostra nella vista ad albero`,
"lable.SalesCommitmentKanBan.accountName":`Nome del conto`,
"label.please.contact.your.administrator":`Si prega di contattare l'amministratore per attivare le regole per la generazione di QR code/Bar code`,
"label.sso.saml.sp.idenitysource":`Posizione dell'identità SAML`,
"label.queue.delete":`Cancellare`,
"label.service.miniProgram.jumpLink":`Saltare il link`,
"label_set_ forecast_scope":`Impostare la gamma di previsioni`,
"label.weixin.success.sign":`Si è registrato con successo, per favore sappiate.`,
"front-dialog-module-v1-error-code":`Codice di errore`,
"label.projectManagement.nodata.problem":`Grande! Non c'è nessun problema complicato da risolvere.`,
"label.myhomepage":`La mia Home Page`,
"label.exchange.sync.state.task.m1":`Ultima attività sincronizzata:`,
"label.pw.config":`Per favore, conferma la tua password`,
"front-console-new-contact":`Nuovo contatto`,
"label.customfields.fielddependency.editexplain":`<li>Doppio click su una cella per attivare la sua visibilità per il valore del campo di controllo mostrato nell'intestazione della colonna.</li><li>Per cambiare più celle in una volta, seleziona più celle e poi clicca sul pulsante Includi valori o Escludi valori per cambiare la visibilità di tutte le celle selezionate in una volta.</li><li>Usa SHIFT   click per selezionare un intervallo di celle adiacenti. Usa CTRL   click per selezionare più celle che non sono adiacenti.</li><li>Utilizza il pulsante Anteprima per testare i risultati.</li>`,
"setup_mainpage_label_welcome7":`Istruzioni: Fare clic sul menu sul lato sinistro della pagina → Impostazioni applicazione → Crea → Oggetto → Nome oggetto → Campo personalizzato.`,
"message.validation.sum":`Ci sono troppi campi mostrati nella pagina di approvazione, puoi selezionare fino a 190 campi.`,
"label.knowledge.attach.case":`Fissare al caso`,
"front-electronic-signature-custom-field-type":`Tipi di campo personalizzati`,
"vue_label_pricebook_activated":`Il listino prezzi è attivato`,
"vue.schedule.pre":`Questo è il mio programma, per favore`,
"Lead_Tools_BatchScoring":`Punteggio dei lotti di piombo`,
"front-lightning-module-v1-details-page-chart-screening-based-on":`Filtrare per`,
"label.report.no.recently":`Nessun record recente.`,
"label.service.gantt.dangerous.sum":`Numero di appuntamenti di servizio in pericolo.`,
"label.main.field":`Campo primario`,
"label.weixin.optionfive":`Scelta 5`,
"homepage.wide":`Colonna larga (destra)`,
"vue_label_notice_confirmdelatehomepage":`Sei sicuro di cancellare la home page?`,
"vue_label_report_exportpages":`Pagine di esportazione: No.`,
"label.select_compaign":`Scegliere una campagna`,
"attachment.button.massdownload":`Scaricare in massa`,
"label.chatter.incident":`Evento`,
"label_partner_new_step1":`Passo 1 Selezionare il modello che ti piace`,
"button.partner.workspace.saveas.memo":`Salva l'attuale nuvola di partner come "modello".`,
"vue_label_pricebook_edit":`Modifica listino prezzi`,
"label.weixin.privacy.rights":`Permessi di privacy: Posizione approssimativa (basata sul web), Posizione precisa (GPS).`,
"label.please.codeType":`Si prega di scegliere il tipo di codice.`,
"label.approveorrefuserequest":`Approvare / Rifiutare`,
"message.error.sharemember":`Lo sharemember passato non può essere vuoto, controlla i parametri passati!`,
"label.file.folder.edit":`Modifica cartella`,
"label.data.import.setup.repeat.yes":`Sì: evita che vengano creati record duplicati. Nota: se vuoi aggiornare un record esistente, devi selezionare questa opzione.`,
"label.approveBeforeTheOperation":`Operare prima di approvare`,
"vue_label_file_already_checked_file":`Sono stati selezionati i file {CheckedWork}, possono essere aggiunti fino a 10 file alla volta`,
"vue_label_hidden_record_count":`Nascondi il conteggio dei record`,
"UG_product_01":`Elencare i prodotti/servizi`,
"label.tabpage.clearoptionsz":`Cancella le opzioni avanzate`,
"label.partnercloud.num.overstep":`Superato il numero massimo di partner cloud.`,
"label.tianyancha.businessverify.msg8":`Al momento, questa funzione supporta solo l'interrogazione delle imprese registrate per il business in Cina continentale, e ha un certo ritardo.`,
"Lead_Scoring_DetailedPage_Popup_Title":`Intuizione del piombo`,
"label.emailtocloudcc.email":`Email`,
"vue_label_pool_highcost":`Alto costo del prodotto`,
"label.callcenter.enterprise.configuration":`Copia la coppia di chiavi in Enterprise ConfigurationSystem Interconnection nel sistema di Tianrun`,
"label.view.edit.search.prompt":`Inserisci le parole chiave`,
"label.ems.sms":`Invia un testo`,
"label.emailobject.list.new":`Comporre`,
"label.salescloud.forenableteamsales":`Abilitare il team di vendita`,
"pagecreator.systemstyle.funcpath":`/ costruttore / libreria di stile di marca`,
"label.partnerCloud.basicSetting.domain":`Il dominio di primo livello non può essere vuoto`,
"label.projectManagement.Posttask":`Post-task`,
"label.tianyancha.businessverify":`Abilitare la verifica dei dati aziendali`,
"label.tianyancha.h5.info":`Informazioni di base`,
"september":`Settembre`,
"chatter.poll.option9":`Scelta 9`,
"label.department.firstpage":`È la prima pagina`,
"label.reportsSubscriptionPage.condition.button":`Aggiungi condizione`,
"label.exchange.sync.state.task":`Compiti`,
"pagecreator.layout.button.splitall":`Dividere tutti`,
"vue_label_calendar_please_select_the_start":`Si prega di selezionare il campo per l'inizio`,
"label.tab.message.failtogettop":`Impossibile ottenere la scheda superiore`,
"label.sharerule.organizationscopesetshare":`Default a livello di organizzazione`,
"label.delete.rules":`Cancellare le regole`,
"label.recordtype.tabname.detail":`Clicca su "Modifica" per cambiare le proprietà di questo tipo di record. Seleziona i valori dell'elenco di selezione disponibili per questo tipo di registrazione cliccando sul link di modifica nell'elenco dei valori dell'elenco di selezione.`,
"label.knowledge.setting.hint.ten":`Incerto sulla modalità di orgnizzazione? Nessun problema. Potete eseguire più tardi.`,
"vue_label_norm_undone":`Questa operazione non può essere ritirata`,
"label.trigger.line":`linea:`,
"lable.info.queue.reason":`Motivo per diventare un membro`,
"label.validate.function.funcExplain.HOUR":`Reutrn restituisce l'ora del giorno (dai campi Data/Ora), che va da 0 a 11`,
"label.update.document.content":`ha motivato il contenuto del documento`,
"lable.Existing.template":`Modelli disponibili`,
"label.summaryreport.step3":`Passo 3 Selezionare il metodo di raggruppamento dei dati riassunti`,
"label.emailmerge.list.filetype":`Tipo di documento`,
"label.customfields.helptext.tip":`Il testo viene visualizzato nella pagina dei dettagli e nella pagina di modifica quando l'utente passa sopra l'icona delle informazioni accanto a questo campo.`,
"label.setting.intergrationlist.description":`Le integrazioni CloudCC ti permettono di visualizzare e condividere i dati tra le applicazioni aziendali senza lasciare il tuo CRM. Alcune integrazioni, come QuickBooks e Zapier, richiedono autorizzazioni per renderle disponibili ai tuoi utenti. Altre integrazioni, come Gmail, Outlook possono essere configurate da ogni singolo utente sul proprio account.`,
"component_milestones_label_title":`Pietra miliare`,
"label.custom.AntiRevocation":`Annulla Annulla`,
"label.mobile.app.new.task":`Permettere di creare nuovi compiti ed eventi sull'app mobile`,
"vue_label_opportunity_related_chooseproduct":`Scegliere almeno un prodotto`,
"label.standardguest":`Ospite standard`,
"label.icon.125":`Strumento`,
"label.skipsomeset":`Poiché questo è il Jump Start Wizard, CloudCC sceglie automaticamente alcune impostazioni per te.`,
"label.forecast.shrepage.fmanager":`Responsabile delle previsioni`,
"label.mobile.quickcreate.default.work":`Ufficio`,
"label.projectManagement.nodata.team.members":`Impossibile trovare il membro del mio progetto`,
"label_social_media_account_settings":`Impostazione dell'account dei social media`,
"UG.quota.05":`Bisync con le opportunità`,
"label.partner.workspace.tab.selectedoption":`Schede selezionate`,
"front-kefu-moudle-v1-clientID-reinput":`Inserisci il clientID`,
"label.mobile.home.page.contract.value":`Importo previsto del contratto`,
"december":`Dicembre`,
"label.campagin.roi.dcrs":`Partecipazione`,
"label.currency.edits":`Modifica della valuta`,
"label.currency.company":`Valuta aziendale`,
"label.customfields.newformula.nogrammererror":`Nessun errore di sintassi nei campi o nelle funzioni di fusione.`,
"label.version.nonsupport.api":`Interfate API non è temporaneamente supportato.`,
"label.data.file.i.title.num2":`2. Si raccomanda di esportare i dati quando i dati vengono importati, in modo che il documento di esportazione sia usato come modello per collazionare i dati da importare, e poi importare. (Se i dati importati contengono una virgola, sostituirla con il simbolo @).`,
"front-console-conversation-title":`Valutazione del servizio`,
"front-kefu-moudle-call":`Chiama`,
"vue_label_systemSettings_pagefooter":`Impostazione del piè di pagina`,
"label.newRule.successfully.added":`Nuove regole aggiunte con successo.`,
"label.trigger.direction.for.use":`Istruzioni per i trigger di piattaforma [Versione 2.0]`,
"label.instrumentPanel.maxLabelname":`Questo valore deve essere maggiore del valore minimo, del valore del breakpoint 1 e del valore del breakpoint 2.`,
"label.same.month.report":`Rapporto YoY e MoM`,
"label.knowledge.language.american":`Americano`,
"label.paging.totalof":`Un totale di {0}`,
"label.tianyancha.businessverify.enable.error":`Ottenere se la verifica dei dati aziendali è abilitata non riesce, si prega di contattare l'amministratore del sistema!`,
"vue_label_commonobjects_detail_email_template":`Utilizzare il modello di e-mail`,
"message.error.save.failed":`Salvataggio fallito!`,
"advancedoptions":`Aggiungere la logica del filtro...`,
"setup_object_layout_message_selectedlayoutandrecordtype":`Seleziona il layout e il tipo di registrazione`,
"label.sendemail.recycle.operatesuccess":`avete svuotato con successo il vostro cestino, cancellando i dati #size.`,
"J":`Area di testo (lunga)`,
"message.validation.isnotmail":`Si prega di inserire l'indirizzo e-mail non valido.`,
"label.timetrigger.before.lasttime":`1 ora prima dell'ultima data modificata`,
"label.tabpage.arecordtypez":`Tipo di record disponibile`,
"label.reportoption":`Opzioni del rapporto`,
"pagecreator.button.next":`Prossimo passo`,
"assetbom.transferowner.notpermission":`Non hai l'autorità per trasferire la distinta dei beni. Contatta l'amministratore.`,
"label.toptitle.lightning":`Fulmine`,
"label.copy.target":`Valore dell'indicatore di clonazione`,
"label.productsales.oppor.approach":`Opportunità imminenti`,
"label.email.template.select":`Si prega di selezionare un modello di e-mail.`,
"label.edit.lower.bound.of.discount.per.tier.is.required.":`Il limite inferiore per la modifica di ogni livello di sconto è richiesto.`,
"label.tabularreport.step3":`Fase 3 Definire l'ordine delle colonne nel rapporto`,
"label.multilang.cchttpservice.signin":`Caro {0}, il tuo ospite invitato {1} di {2} è stato registrato con successo.`,
"label.appexchange.uninstallpage.message3":`Elimina definitivamente tutti i dati degli oggetti personalizzati in questo pacchetto`,
"label_tabpage_ownedz":`Totalmente`,
"label.tabularreport.2018.step2":`Passo 2 Selezionare i criteri del rapporto`,
"label.object":`Oggetto`,
"template.report.contracted.customers":`Analisi del settore dei conti a contratto`,
"label.field.remark3":`Nota che l'eliminazione di un campo personalizzato cancellerà tutti i filtri che utilizzano il campo personalizzato. Può anche cambiare il risultato delle regole di assegnazione o di escalation che si basano sui dati del campo personalizzato.`,
"label.eventview.issms":`Avviso SMS`,
"label.knowledge.language.brazilian":`Portoghese (Brasile)`,
"vue_label_norm_viewfilter":`Applicare un filtro`,
"label.forecast.settings.qijian":`Periodo di previsione`,
"label.startuploadfile.step.intruduce":`Clicca "Select File" per trovare il file e visualizzare i file selezionati nella regione inferiore.`,
"label.smstemplate":`Modello SMS`,
"vue_label_chatter_no_permission":`Non hai accesso a questo file`,
"label.callcenter.Incorrect.data.filling":`C'è un errore nel riempimento dei dati`,
"label.tag.search.button":`Ricerca per tag`,
"label.multiplyselectoptions":`Opzioni della casella di controllo`,
"lable.outlook.detail.mutual":`Sincronizzazione bidirezionale`,
"label.workflow.estimatecondition1":`creato, e ogni volta che viene modificato per soddisfare successivamente i criteri`,
"label.validate.globalvariable.user.profileId":`ID profilo`,
"UG.Campaign.003":`Creare una campagna`,
"label.validate.function.funcExplain.ISNULL":`L'espressione è nulla e restituisce TRUE, altrimenti contiene un valore e restituisce FALSE.`,
"label.setting.intergrationlist.status0":`STATO DI INTEGRAZIONE`,
"label.copy_error":`Impossibile copiare`,
"label.connectOtherNone":`L'oggetto selezionato non ha altri oggetti relazionabili.`,
"label.bmap.beijing":`Pechino`,
"front-kefu-moudle-v1-hxzxybsc-again":`Easemob è stato cancellato. Per favore, riconnettiti!`,
"label.wei.pollsubject":`Voto Soggetto`,
"APPIntegration_Social_twittererror":`Devi inserire un URL valido per twitter.com`,
"label.appupload.install.apicannotuse":`Il nome dell'api non è ancora disponibile`,
"label.returntolist":`Torna alla lista`,
"label.translation.start2":`Seleziona un componente di impostazione.`,
"lable.edit.queue.alter":`Seleziona gli oggetti che vuoi assegnare a questa coda.`,
"label.campaign.channel.step3":`Step3: Seleziona i campi da visualizzare nella pagina di registrazione del canale di marketing`,
"label.data.newtemplate.e.seltype":`Selezionare il metodo di esportazione dei dati`,
"front-kefu-moudle-hangup":`Riagganciare`,
"label.forecast.forecastroleuserpage.shre.managerandother":`Gli amministratori e i responsabili delle previsioni possono condividere questa previsione`,
"label.knowledgebase.mark.as.new.version":`Segna come nuova uscita`,
"label.conditiontag.lookup":`Cercare`,
"label.import.page3.importsucceed":`Importare con successo`,
"label.stdashbord.xsld.condtion":`Impostazioni delle condizioni`,
"label_emailtocloudcc_redmessage10":`L'informazione è scaduta, si prega di effettuare nuovamente il login.`,
"label.event.moveup.1hour":`1 ora avanti`,
"label.chat.topic.page.add.favorite":`Salva come segnalibro sulla pagina CCChat`,
"label.icon.88":`Consulenza`,
"page_404_label_noresource":`Spiacente, la risorsa a cui vuoi accedere non esiste.`,
"label.quickbooks.refresh":`Aggiorna`,
"front-kefu-moudle-which-getphone-case":`Regole per la creazione di casi dopo aver risposto a una chiamata`,
"label.objecttab.edit":`Scheda Oggetto Modifica`,
"label.data.file.the.trigger":`Eseguire l'innesco`,
"frame.personinfo.label.personimage":`Foto del profilo`,
"label_tabpage_turnoffsz":`Spegnere - convertito`,
"label.sendmail.batch.chose":`Email di massa: Seleziona i destinatari`,
"label.data.downpage.i_title":`Fasi di importazione dei dati:`,
"label.recycle.clearconfirm":`Sei sicuro?`,
"chatter.using":`Questo utente`,
"label.batchadd.newbatchpage.list":`Aggiunta di massa dell'elenco di dati`,
"pagecreator.systemstyle.button.new":`Nuovo stile`,
"label.notification.serviceappointment.changestate":`Stato di {1}{0} cambiato in{2}{3}`,
"label.weixin.weipollname":`Nome del micro voto`,
"label.tabpage.skip":`Passa a`,
"label.edit.field":`Modifica dei campi`,
"label.edit.new.rule":`Modifica delle regole di generazione`,
"label.approved.receiveApprovalEmail":`Ricevere e-mail di richiesta di approvazione`,
"label.dashboard.refreshNow":`Aggiorna ora`,
"label.lookup.introduce":`Si prega di inserire almeno 1 carattere per la ricerca confusa.`,
"homepage.components.newdes":`Assicurati che il codice HTML inserito qui sotto sia valido e ben formato. Scrivere codice HTML inappropriato in un componente può causare la visualizzazione errata dell'intera scheda della home page.`,
"label.role.giveuserrole":`Assegnare ruoli agli utenti`,
"lable.opppdt.selPbk.subtitle":`Libro dei prezzi`,
"setup_mainpage_label_welcome19":`Istruzioni:  Clicca sul menu a sinistra di questa pagina → Gestisci impostazioni → Gestisci utenti → Utenti, ruoli, profili`,
"setup.mainpage.label.welcome22":`Istruzioni: Clicca sul menu a sinistra di questa pagina → Gestisci impostazioni → Modello di newsletter → Modello di e-mail.`,
"label.tianyancha.h5.zipcode":`Codice postale`,
"label_tabpage_allapplications":`Tutte le applicazioni`,
"label.chatter.like":`Come`,
"label.licence.noremainder":`Numero insufficiente di licenze`,
"lable.outlook.edit.dataset":`Impostazioni dei dati`,
"D":`Data`,
"label.detail":`Leggi`,
"label.globaloperation.operationtype.custom_page":`Pagina personalizzata`,
"label.addattachment.down":`Scaricare il file`,
"label.data.exportall.all_btn":`Esportare tutti i dati`,
"label.recordtypeselect.current":`Tipo di record corrente`,
"label.tabpage.entercusnamez":`Inserisci il nome del cliente`,
"label.location.valunit.km":`Km`,
"label.mobile.phone.week.plan":`La prossima settimana`,
"vue_label_report_everyday":`Ogni giorno`,
"label.weixin.broadcasting":`Invio...`,
"label.input.search.string":`Inserisci la stringa di ricerca`,
"label.picandreporttype":`Tipo di grafico`,
"label.setmulti":`Trasferimento multiplo`,
"label.visualpage.component.t":`Come usare i componenti?`,
"label.knowledge.designate":`Solo l'articolo di conoscenza con uno stato di Bozza può essere assegnato.`,
"label.enable.barcode.only":`Attivare solo il codice a barre`,
"vue_label_commonobjects_detail_a_group_strategy":`Questi dati non hanno un proprietario e non possono creare un Team`,
"setup.layout.group.button":`Pulsanti`,
"label.mini.layout.remark":`è il layout utilizzato nella finestra di hovering sulla pagina.`,
"setup.mainpage.label.welcome3":`La creazione di moduli nella piattaforma cloud CloudCC si basa su database personalizzati (oggetto), gli oggetti definiti dall'utente sono tabelle di database che memorizzano dati specifici della tua organizzazione. Le relazioni da tabella a tabella possono essere facilmente stabilite senza lo sviluppo di alcun programma.`,
"label.knowledge.draft.status":`Lo stato del post degli articoli di conoscenza è Bozza!`,
"label.manageAll.sel.one1":`Punti da approvare`,
"label.campagin.roi.bhydkhywjh":`Quantità di opportunità chiuse`,
"label_partner_template_thumbnail":`Miniatura`,
"label.loginip.setup":`Intervallo IP di accesso`,
"label.data.downpage.e.title.e.btn":`Vai alla pagina di esportazione e inizia l'esportazione`,
"vue_label_appstore_project_management":`Gestione del progetto`,
"assetbom.delete.notpermission":`Non hai l'autorità per cancellare la distinta di beni. Contatta l'amministratore.`,
"vue.dashboard.setdrill.inThe":`soggetto a`,
"label.mobile.more.savephoto":`Salva foto`,
"label.customerinfo.PageTriggerFag":`Sync`,
"label.commonobjects.Nopermission":`Spiacente, non hai il permesso di modificare questi dati, contatta l'amministratore del sistema.`,
"label.searchlayout.opperationtab.xsldfield":`I campi visualizzati quando si fa clic sul link Sales Funnel nella home page della scheda opportunità.`,
"label.emailsync.form.disconnect":`Cancella Conncet`,
"label.document.nofile.upload":`Nessun caricamento di file.`,
"label.appointmentpage.wizard.subtitle3-3":`Telefono`,
"message.custom.field.donotdelete":`Il campo è usato e non può essere cancellato.`,
"chatter.using0":`{0}ms è stato usato a questo punto`,
"label.tabpage.multiple":`Scelta multipla`,
"label.attendance.setting.sy.alert":`È necessario selezionare gli utenti adatti per la partecipazione.`,
"label.refuse":`Rifiuta`,
"label.log.button":`ricerca per nome utente`,
"component_chatter_link_label_title":`Link`,
"template.report.contract.collection":`Pagamento del contratto`,
"label.campaignmember.selectmember.step1":`Passo 1 Selezionare lo stato della campagna e dei membri della campagna`,
"label.datamanage.warn.owner":`Attenzione: se continui questa importazione, tutti i record saranno importati con te come proprietario del record.`,
"label.a.b":`Relazione da A a B`,
"label.app.step3.homeisfrist":`La homepage deve essere la prima.`,
"UG_Lead_003":`Sociale`,
"label.partner.workspace.member.choice":`Seleziona il profilo`,
"lable.outlook.detail.emaping":`Mappa dei campi evento`,
"label.service.appointmentList.gantt.chart.shows":`Mostra la data di Gantt`,
"label.mr.caption.account.result":`Trova i duplicati e unisci: Risultati per la ricerca di duplicati di conti`,
"vue_label_chatter_approve_members_join":`Approvare i membri che si uniscono al gruppo`,
"label.reportsSubscriptionPage.schedulereport.monthly.day":`Giorno`,
"pagecreator.systemstyle.label.modifycolor":`Modifica colore`,
"label.tabpage.yesz":`Sì`,
"label.fieldtoolongmessage":`Il campo supera il limite`,
"lable.account.year.name":`Anno fiscale Nome`,
"label.mini.layout":`Layout Hover`,
"label.icon.97":`Insegnare`,
"vue_label_chat_smart_assistant":`Assistente intelligente`,
"label.marketingmanagementuser":`Utente di marketing`,
"label_emailtocloudcc_description2":`Collega la tua email`,
"label.campaign.channel.input.name":`1.Inserire il nome del canale di marketing`,
"UG.homepage.007":`Dall'invio di email di follow-up all'automazione delle campagne di vendita, dalla creazione di flussi di lavoro utilizzando la nostra tecnologia Blueprint all'attivazione di macro personalizzate, automatizza i compiti quotidiani e concentrati maggiormente sulla costruzione di relazioni.`,
"label.share":`Condividere`,
"label.step2.total6":`Passo 2 di 6`,
"label.sendemail.chat.addComentspraise":`Caro #nome:\nell'attesa! #nomeutente ha risposto al micropost che ti è piaciuto`,
"label.icon.20":`File`,
"label.service.gantt.absenteeism":`Assenteismo`,
"message.error.color.nagatice":`Il numero di pagine correnti non può essere negativo.`,
"chatter.group.applyToJoin":`Candidarsi per entrare a far parte`,
"pagecreator_layout_message_delete":`Elimina il layout correntemente selezionato?`,
"label.multilang.viewlist.count":`Un totale di {0} record：`,
"message.notdesable.type":`Questo tipo di record non può essere cancellato perché il seguente profilo usa questo tipo di record come valore predefinito.`,
"label.standard.time":`Tempo standard`,
"label_chatter_newpost":`Ultimo messaggio`,
"front-epwechat-module-v1-binding":`Legare WeCom`,
"label.recent":`Recente`,
"label.globaloperation.createfeeditem":`Creare un progetto riassuntivo`,
"label_partner_common_roleNum":`Numero di ruoli`,
"front-template-V1-quikSearch":`Inserisci il nome del campo e trova`,
"label_tabpage_haschangedz":`Questa pista è stata convertita`,
"label.service.work.order.line":`Elementi dell'ordine di lavoro`,
"label.lead.score.ok":`OK`,
"Account_News_Setting_003":`Impostazioni generali`,
"label.event.moveup.15minutes":`15 minuti prima`,
"vue_label_all_selected_objects":`Tutti`,
"label.visualpage.an.inline.style.relatedlist":`Incorporare il tipo di pagina personalizzata negli elenchi correlati`,
"label.umeng.approval.approvaling":`#Il richiedente richiede l'approvazione per #obj #objname #owner`,
"lable.SalesCommitmentKanBan.digital":`Cifra`,
"label.appupload.img.max.size":`L'immagine che hai caricato è troppo grande, la dimensione massima dell'immagine non dovrebbe superare i 20K, per favore carica di nuovo.`,
"vue_label_normal_top":`Top`,
"label.knowledge.language.traditional":`Cinese tradizionale`,
"homepage.layout.edit":`Modifica il layout della casa`,
"label.campagin.qrcode":`Codice QR Campagin`,
"label.emailmerge.merge.emailmerge":`Unire le e-mail`,
"label.icon.18":`Orologio`,
"vue_label_homepage_taskview":`Vista del compito`,
"label.search.related.record":`Non sono state trovate registrazioni.`,
"label.report.reports":`Rapporti`,
"label.appointment.wizard.subtitle4-3-2":`15 min`,
"label.forecast.condition":`Criteri di previsione`,
"label.westem.indonesia.time":`Ora dell'Indonesia occidentale`,
"front-epwechat-module-v1-callback-desc":`Copia le seguenti informazioni nel backend di WeCom.`,
"label.version.group":`Edizione della squadra`,
"label.allReportType":`Tutte le fonti di dati dei rapporti personalizzati`,
"label.trigger.lastmodifydate":`Data ultima modifica`,
"message.layout.unique.sectionfield":`Il vincolo di unicità del campo nel layout di pagina è stato violato. Per favore controlla e salva di nuovo.`,
"vue_label_systemSettings_mobelbottonsetting":`Impostazione del menu in basso per l'applicazione mobile`,
"label.recordtype.selectonefield":`Seleziona almeno un campo che vuoi aggiungere`,
"label.notification.group1":`【申请人】 sta chiedendo di unirsi al tuo gruppo pubblico`,
"component_todaytask_label_title":`Oggi`,
"label.assignment.setup.list.description":`Assegna automaticamente i lead agli utenti in base ai criteri che definisci. Puoi creare più regole con condizioni diverse.`,
"label.project.resource.data":`Questa risorsa di servizio è stata assegnata a un appuntamento di servizio, per favore non aggiungere più volte.`,
"label.emailmerge.newtemplate.file":`file`,
"label.notification.task1":`【分配】 ti ha assegnato un compito`,
"label.ServiceCloud.Overlapping":`Visualizzare gli invii in sovrapposizione`,
"label.globalselect.used":`La posizione dell'uso del campo`,
"setup_layout_button_layoutprop":`Proprietà`,
"label.quickbooks.retrivingdata":`Recuperare i dati...`,
"component.button.ok":`Confermare`,
"message.pleaseinputformula":`Inserisci la formula`,
"label.h5.whatifollow":`Cosa seguo`,
"label.new.crew.target":`Nuovo obiettivo del personale`,
"label_chatter_task":`Compito`,
"label.knowledge.setting.data.four":`Si può selezionare un massimo di {count} gruppi di categorie.`,
"label.rule.not.enabled":``,
"label_in_scope":`All'interno della gamma`,
"label.partnerCloud.orderingPlatform.bundle":`Pacchetto`,
"label.emailtocloudcc.redmessage10":`L'informazione è scaduta, si prega di effettuare nuovamente il login.`,
"label.knowledgebase.data.assignment.succeeded":`{a} dati assegnati con successo`,
"vue_label_commonobjects_view_nokanban":`Nessuna vista kanban è stata ancora creata`,
"label.knowledgebase.article.cancelled.attaching.case":`L'articolo {nome} è stato cancellato per allegarlo al caso!`,
"label.brief":`Riassunto`,
"label.version.sum.app":`applicazioni`,
"label.commoninfo":`Informazioni comuni`,
"vue_label_SMS_nodata":`Nessun dato`,
"label.icon.153":`Informazioni`,
"label.conditiontag.lookup.false":`FALSO`,
"label.emailobject.view.unread":`Email non lette`,
"label.staticresource.useful":`Dove si usa questo?`,
"label.ems.connect.test":`Test`,
"vue_label_chat_group_assistant_notification":`Notifica dell'assistente di gruppo`,
"label.multipleactivity.total":`Un totale di`,
"vue_label_report_addtocomponentlibrary":`Aggiungere alla libreria dei componenti`,
"font-evaluate-module-v1-following-personnel":`Informare i seguenti utenti quando ricevono una valutazione inferiore a 3:`,
"label.setup.mobile.bottombutton.change.fail":`Non è riuscito a cambiare`,
"front-epwechat-module-v1-unbound-item5":`e i dati non possono essere recuperati, siete sicuri di scollegarvi?`,
"label.customerinfo.smsUid":`UID del gateway SMS`,
"label.list.isOpenApprovalQueue":`Attivare la coda di approvazione (non disponibile in Manual Select Approver)`,
"label.leadscore.setup.scorenumber":`Tempo(i)`,
"label.workflow.selectobj.introduce":`Seleziona l'oggetto a cui si applica questa regola del flusso di lavoro.`,
"label.visualpage.label.for.example":`Etichette di pagina come:`,
"label.appointmentdetail.wizard.title17":`Piano del giovedì`,
"label.projectManagement.timeFrame":`L'ora di inizio e di fine del compito dovrebbe essere all'interno dell'intervallo di tempo della pietra miliare.`,
"lable.product.pricebooks.list":`Price Book è un elenco di prodotti con un prezzo speciale e una valuta definita. Il Price Book può essere impostato per più valute. Quando si inserisce un prodotto in un listino, le opportunità o i preventivi possono includere solo prodotti in un singolo listino. Per modificare il prodotto nel listino, clicca sul nome del listino.`,
"font-trade-module-v1-delete-invoice":`Verificare la fattura`,
"vue_label_salesadvance_winamount":`Importo lordo di Won`,
"component.salesperformance.label.nopermission":`Per visualizzare i dati relativi alle opportunità commerciali, contatta il tuo amministratore di sistema.`,
"vue_label_report_formatreport_desc":`Esporta il rapporto con le intestazioni, i gruppi e le impostazioni dei filtri.`,
"label.enable.qrcode.only":`Attivare solo il codice QR`,
"label.smstemplate.edit":`Modifica modello SMS`,
"label.qrcodeSetting.detailed.information":`Il codice QR può memorizzare più dati rispetto al codice a barre e la scansione lineare non è richiesta. Quindi il codice QR è ampiamente applicato tra cui il monitoraggio dei prodotti, l'identificazione degli articoli, la gestione della documentazione e il marketing, ecc.`,
"label.event.moveup.1week":`1 settimana prima`,
"label.customize.memory.function.sorting.disable":`Disattivare la memoria dell'ordinamento dell'intestazione`,
"label.icon.195":`Vasca da bagno`,
"label.compact.layout.assign":`Assegnazione del layout delle informazioni chiave`,
"label.icon.183":`Casa`,
"front-kefu-moudle-v1-jchxzxzi-chat":`Integrare la chat online di Easemob per fornire un servizio SaaS più completo.`,
"label.mycontact":`I miei contatti`,
"label.tabularreport.2018.step3":`Passo 3 Selezionare i criteri del rapporto`,
"chatter.group.uploadGroupPicture":`Carica una foto di gruppo`,
"label.total.forecast.setup":`forecast at first and set it to be`,
"label.weixin.group.description":`Nota`,
"label.edit_emailfooter":`Modifica piè di pagina delle email`,
"label.ems.create":`Nuovo`,
"label.weixin.optionseven":`Scelta 7`,
"font-evaluate-module-v1-continue-work":`La vostra valutazione ci ha incoraggiato! Continueremo gli sforzi per fare meglio!`,
"label.close.multilingual":`Disattivare il multilingue`,
"component.chatter.post.button.user":`Aggiungere persone`,
"label.use_QRcode":`Usa il codice QR`,
"label.operatedata.exportsuc":`L'esportazione è riuscita. Si prega di visualizzare l'e-mail per ottenere il link per il download. Si prega di scaricare i file esportati entro 48 ore. Si raccomanda di cancellare l'e-mail che contiene il link per il download dei file esportati.`,
"label.page.step2.define.content":`Passo 2 Definire il contenuto e le proprietà di visualizzazione`,
"label_tabpage_groupingitem":`Voce di raggruppamento`,
"label.customfields.placeholder":`Compilare il campione`,
"vue_label_commonobjects_detail_enter_subject":`Inserisci il tema`,
"label.multilang.workflow.everyotherdayinmonth":`{1} giorni ogni {0} mesi`,
"label.knowledgebase.data.archiving.failed":`archivio dati {a} fallito`,
"vue_label_notice_nopermission_view":`Mi dispiace che tu non abbia l'accesso per visualizzare questo record, per favore contatta l'amministratore.`,
"vue_label_calendar_calendar_view":`Vista calendario`,
"lable.outlook.edit.des":`Se un contatto Exchange corrisponde a più contatti CloudCC.com, sincronizzalo con un contatto CloudCC.com che soddisfa i seguenti criteri.`,
"label.custom.NextCQ":`Prossimo CQ`,
"label.emailsync.form.stutas":`Stato`,
"label.nameandintro":`Nome e descrizione`,
"label.dashboardSetup.showdw":`Unità di visualizzazione`,
"label.tianyancha.actualcapital":`Capitale ricevuto`,
"front-kefu-moudle-info-delete-calluser":`Le informazioni sono state modificate, si prega di contattare l'amministratore`,
"label.emailobject.list.all":`Tutti`,
"label.campaign.channel.step7.send":`Seleziona gli utenti che devono ricevere l'email`,
"label.formulafield.type":`Formula Tipo di ritorno`,
"label.reportsSubscriptionPage.schedulereport.weekly.thursday":`Giovedì`,
"label.chosesubject.eat":`Programma Cena`,
"label.back":`Indietro`,
"label.h5.allcompany":`Tutti i messaggi sulle nuvole`,
"label.location.display.type.digital":`Digitale`,
"label.datamanage.error.csv":`Formato di file non valido, il sistema supporta solo il comune formato CSV, per favore riprova.`,
"label.emailobject.mark":`Mark`,
"setup_mainpage_label_welcome9":`Gli utenti possono realizzare la visualizzazione della classificazione e la regolazione del layout di tutti gli elementi della pagina e l'impostazione dei campi di sola lettura e richiesti dei campi sulla pagina trascinando e rilasciando il mouse senza sviluppo di codice.`,
"label.icon.56":`Strumento di misura`,
"label.forecast.edit.fwcd":`Gamma Lunghezza`,
"vue_label_email_Please_select_related_items_first":`Si prega di selezionare prima gli articoli correlati`,
"label.icon.87":`Libro`,
"label.knowledgebase.recovery.was.successful":`Il recupero ha avuto successo`,
"label.emailobject.emaildetail.promptcontent":`Sei sicuro di voler cancellare questa e-mail?`,
"label.delete.role":`Cancellare i ruoli`,
"label.multiselect":`Lista di scelta (multi-selezione)`,
"label.customerinfo.mailisnull":`Nessun indirizzo e-mail aziendale impostato.`,
"label.waitforamoment":`Pagina in caricamento, attendere prego...`,
"lable.edit.queue.tip":`Inserisci il nome della coda e l'indirizzo email da utilizzare per l'invio delle notifiche (per esempio, quando un caso è stato messo in coda). L'indirizzo email può essere per un individuo o una lista di distribuzione. Quando un oggetto viene assegnato a una coda, solo i membri della coda riceveranno una notifica.`,
"lable.custom.y.d":`Questa pagina ti permette di definire un record di anno personalizzato. Le date per l'anno personalizzato saranno generate in base alle scelte fatte qui sotto.`,
"chatter.feed.content.user.searchbutton":`Cerca`,
"label.data.downpage.i.list.desc3":`Gli utenti possono visualizzare il motivo dell'importazione fallita nell'ultima colonna del file dopo il download.`,
"label.tag.manage.createdby":`Creato da`,
"label.h5.similar.opportunity.last.months3":`Ultimi 3 mesi`,
"chatter.group.members":`Membri`,
"label.knowledgebase.data.translation.failed":`Tradurre i dati {a] non è riuscito`,
"label.log.look":`Controlla gli indizi di controllo delle impostazioni`,
"label.service.gantt.week.timescale":`Scala temporale su Week View:`,
"label.userLicence":`Licenza utente`,
"label.file.library.managemembers.permission":`Accesso`,
"label_emailtocloudcc_name":`Nome`,
"label.mr.mrSuccess":`Fusione completata`,
"vue_label_commonobject_view_notice_selectadd":`Seleziona i dati da aggiungere`,
"vue_label_commonobjects_detail_level":`Livello`,
"CloudCCCRM_ST_Info_TypeIn_001":`Si prega di inserire`,
"label_chatter_list":`Lista`,
"label_tabpage_optionsz":`Opzioni`,
"UG_homepage_008":`Comprendere lo stato attuale del business (briefing di vendita, classifiche, funnel di vendita, ecc.), visualizzare le opportunità di business che possono essere problematiche, prevedere le prestazioni future, accettare tempestivamente e assegnare questioni importanti e prendere decisioni informate.`,
"label.myselfdashboard":`I miei cruscotti personali`,
"label.globaloperation.operationtype.record_phone":`Registra il telefono`,
"label.field.standard":`Campi standard`,
"label.changemydisplay.appedit.check":`Sovrascrivere le impostazioni personali delle app personalizzate`,
"label.tianyancha.h5.legalpersonnames":`Rappresentante legale`,
"label.tabpage.sorttypez":`Tipo di ordinamento`,
"label.newdashboard.folder":`Nuova cartella Dashboard`,
"label.campaign.channel.step6":`Passo 6: Generare la pagina di registrazione del canale di marketing`,
"label.ems.composeemail":`Inviare e-mail`,
"label.app.step4.tabcanuse":`Schede disponibili`,
"label.sendmail.batch":`Email di massa`,
"label.process.execute.title":`In attesa di`,
"lable.outlook.detail.lastup":`Ultimo aggiornamento`,
"label_emailtocloudcc_delete":`Cancellare`,
"lable.opppdt.selPdt.leastone":`Seleziona almeno una riga`,
"label.customfields.new.step2.opration.exid":`ID esterno`,
"label.assignment.setup.newrule.description":`Inserisci il nome della regola e poi seleziona la casella di controllo abilitata per utilizzare questa regola per l'assegnazione automatica. Abilitando questa regola si disabilita la regola di assegnazione corrente.`,
"label.campaign.channel.input.to.isactivity":`7. Attiva il canale di marketing`,
"label.document.return":`Torna ai documenti`,
"label.data.downpage.i_title.num5":`5. Si prega di controllare l'esattezza dei dati.`,
"label.taskinto":`I compiti sono i modelli che le regole del flusso di lavoro usano quando assegnano automaticamente i compiti agli utenti.`,
"label.customfields.formula.textexample":`Nome completo = Cognome`,
"label.appointmentpage.wizard.subtitle1-1":`La prossima settimana`,
"label.weixin.radio":`Single-Select`,
"vue_label_file_replace_reason_check":`Motivo della sostituzione (opzionale)`,
"label.sendemail.recycle.operateexception":`svuotare il tuo cestino non è riuscito, per favore riprova.`,
"label.vlidaterule.formulaerror":`Visualizza un errore se lo sconto è superiore al 30%`,
"vue_label_campaign_existing_member_status":`Mantenere lo stato di membro esistente`,
"label.service.miniProgram.fillSlideshowName":`Si prega di compilare il nome del carosello.`,
"label_partner_workspace_login_headerfooter":`Intestazione e piè di pagina`,
"label.quickbooks.viewlist.total2":`Ci sono {0} stime per un valore totale di {1}`,
"chatter.viewingResults":`Vedere i risultati`,
"label_tabpage_allvisible":`Tutti gli utenti sono visibili`,
"label.quote":`Citazioni`,
"label.changemydisplay.list.des":`Personalizza le schede secondo le tue esigenze`,
"label.leadscore.notimes":`Non ci sono più tempi per segnare le piste`,
"label.icon.51":`Generazione di energia`,
"component.assistant.label.title":`Assistente`,
"label.emailobject.emailsent":`Email inviata!`,
"label.group.nofile":`Nessun file è stato inviato a questo gruppo.`,
"label.foldervisitlimit2":`Tutti gli utenti non possono accedere a questa cartella`,
"label.dataoperate":`Funzionamento dei dati`,
"label.addattachment.size":`Dimensione`,
"label.not.double":`I valori duplicati non sono ammessi.`,
"label.customfields.formula.number.tip":`Calcola un valore numerico.`,
"lable.opppdt.addpdt.table.description":`Descrizione della linea`,
"label.sms.isactivity":`Attivo`,
"label.campaign.channel.input.owner":`4.Chi sarà il proprietario dei lead di questo canale:`,
"label.visualpage.notfound.error":`Si è verificato un errore sconosciuto, si prega di contattare l'amministratore.`,
"label.mr.title.button.group3":`registri`,
"label_tabpage_beginz":`Iniziare`,
"label_tabpage_queue":`Coda`,
"label.tabpage.advancedscreening":`Filtro avanzato`,
"nogreate":`meno o uguale`,
"chatter.fields":`Campi in`,
"button_partner_workspace_manage":`Gestione`,
"label.partnerCloud.orderingPlatform.search":`Cerca prodotti`,
"message.password.isnull":`Inserisci la tua password.`,
"label.fenbeitong.title":`Impostazione FenBeiTong`,
"label.salescloud.contactrole.message.chooseatleastone":`Si prega di selezionare almeno un contatto.`,
"label.knowledge.delete.election":`Errore durante la cancellazione della selezione delle categorie di dati`,
"front-console-status-hoided":`Disporre`,
"label.lastmodifydate":`Data ultima modifica`,
"vue_label_chat_deleting_chat":`Dopo la cancellazione, la cronologia della chat sarà cancellata e rimossa dalla lista della Squadra. Quando riceverà un nuovo messaggio, apparirà di nuovo nella lista della Squadra.`,
"label.timeframe":`Tempo`,
"UG.opportunity.002":`Definisci il tuo ciclo di vendita, configura la fase`,
"label.templates.merge":`Seleziona i modelli da unire. È possibile selezionarne un massimo di 20.`,
"label.generatepage.c2":`La lunghezza massima è 30.`,
"label.appointment.wizard.subtitle4-1-6":`2 h`,
"label.passwordPolicy.setup.pwdremember3":`3 password ricordate`,
"button.partner.workspace.enable":`Abilitare il cloud dei partner`,
"vue_label_pool_nopool_notice":`Non hai ancora aderito a nessun pool, contatta l'amministratore per creare o unirti a un pool.`,
"label.layout.required.field.select":`Campi richiesti selezionati`,
"label.loginhis.date":`Inserisci la data di inizio e la data di fine.`,
"vue_label_commonobjects_detail_and_overdue":`Prossimi e in ritardo`,
"label_tabpage_advancedsearch":`Ricerca avanzata`,
"label.custom.field.login.home.query":`Per favore, vai alla homepage e visualizza i dettagli del compito.`,
"page":`Pagina`,
"label_tabpage_onlymevisible":`È visibile solo a me`,
"label.weixin.optionfour":`Scelta 4`,
"label.confirm.to.remove":`Confermare per rimuovere`,
"label.event.moveup.30minutes":`30 minuti prima`,
"label.mail.merge.template.finish":`Unire i modelli di e-mail completati`,
"label.multilang.currencylist.before":`Prima di {0}`,
"label.goback":`per andare al precedente`,
"label.unknown.prefix":`Prefisso non valido, inserire nuovamente.`,
"lable.account.CurrentandPreviousCYt":`Attuale e precedente 2 CY`,
"label.product.dent":`Inserisci la tua parola chiave e i criteri del filtro, poi clicca su Cerca per iniziare la ricerca, clicca su Più filtri per usare più di un filtro e i risultati della ricerca includono tutti i record che corrispondono sia alla parola chiave che al filtro.`,
"label.ems.bcc":`Bcc`,
"label.import.index.operation":`Operazione`,
"label.knowledge.setting.hint.eight":`Mantenere tutto in perfetto ordine!`,
"label.sso.saml.sp.idtype.fid":`L'asserzione contiene l'ID della Federazione dall'oggetto User`,
"vue_label_chat_voice":`Voce`,
"label.config.pw":`Conferma la nuova password`,
"lable.newtabpage.closesearchresult":`Risultati della ricerca`,
"lable.account.NextWeek":`La prossima settimana`,
"label.ems.username":`Nome utente (u)`,
"vue_label_email_emails_from_potential":`Le e-mail dai lead e dai contatti nel tuo CRM, e le e-mail che li contengono nei destinatari, saranno categorizzate qui`,
"lable.approval.shared":`Quota di approvazione`,
"label.tabpage.allz":`Tutti`,
"label.file.uploadfiles":`Caricare i file`,
"label.emailobject.text":`Testo:`,
"label.version.allow.create":`Permettere di creare nuovi`,
"label.empty.field":`Il campo non può essere vuoto.`,
"label.emailsync.status.department":`Dipartimento`,
"label.pw.str":`5 caratteri`,
"label.attendance":`Presenze`,
"label_mobile_buttom_team":`Squadra`,
"label.campaignmember.main.addcontactdesc":`Aggiungi tutti i contatti esistenti a questa campagna`,
"label.search.result":`Risultati della ricerca`,
"label.weixin.activity.account":`Ospiti di attività`,
"label_tabpage_clearoptionsz":`Cancella le opzioni avanzate`,
"UG.activity.01":`Come rintracciate i vostri record per interagire con i vostri conti/squadre?`,
"serviceappointment.new.status.limit":`Impossibile creare un nuovo appuntamento di servizio con uno stato di programmato o spedito.`,
"label.notice.higher":`Invia un'e-mail al manager`,
"label.passwordPolicy.setup.gletters":`personaggio(i)`,
"label.data.exportsf.des":`I file esportati con successo saranno automaticamente cancellati dopo 48 ore dal salvataggio sul derver.`,
"label.view.onlymecansee":`Visibile solo a<b> me</b>`,
"UG.Lead.005":`Mailbox`,
"label.umeng.approval.approvalfail":`presentato faild.`,
"label.huanxinconfig.clientid.lost":`clientid non può essere vuoto`,
"label.campaignmember.main.updatecontactstatus":`Aggiornare lo stato dei contatti esistenti`,
"component_chatter_button_delete":`Cancellare`,
"label.weixin.no.pending.projects.qin":`Nessun punto da approvare.`,
"front-electronic-signature-auto-fill-field":`Campo di riempimento automatico`,
"message.resetpw":`Sei sicuro di voler resettare la tua password?`,
"label.service.ganttBaiduMap.service.resourname":`Nome del servizio Risorse`,
"vue_label_pricebook_deleted":`Listino prezzi cancellato`,
"label.icon.193":`Vasca da bagno`,
"label.validate.function.funcFormat.NOT":`NOT(logico)`,
"label.address.city":`Città`,
"label.pc.ui.2018.searchs":`RICERCA...`,
"label.yard":`Codice d'invito`,
"label.data.downpage.i_title.btn":`Vai alla pagina di importazione e inizia l'importazione`,
"label.useablereceivers":`Destinatari disponibili`,
"label.cloudccsite.name.length":`Permette agli utenti di inserire fino a 255 caratteri`,
"label.secrecy":`Confidenziale`,
"label.campagin.roi.ydkhywjhzz":`Importo totale delle opportunità chiuse e vinte`,
"vue_label_report_conditiondesc_one":`A parte la sottoscrizione, puoi impostare delle condizioni per questo rapporto. Sarai avvisato se tutte le condizioni sono soddisfatte. Questo è opzionale`,
"label.datamanage.select.contactfield":`(Selezionare il campo corrispondente al contatto da importare)`,
"label.emailtocloudcc.filed.action":`Azione`,
"label.smstemplate.new":`Nuovo modello SMS`,
"label.mobile.side.tab.app":`Applicazioni`,
"label.icon.118":`Orologio`,
"label.customfields.selectcontainfieldlayout.tip":`Il campo sarà aggiunto come ultimo campo nella prima sezione a 2 colonne di questi layout di pagina. Il campo non apparirà in nessuna pagina se non si seleziona un layout.Per cambiare la posizione di questo campo nella pagina, è necessario personalizzare il layout di pagina.`,
"Lead_Homepage_Tools_BatchScoring":`Punteggio del lotto`,
"lable.quote.syncing.quote":`Citazioni`,
"pagecreator.button.preview":`Anteprima`,
"label.ccchat.am":`AM`,
"chatter.feed.menutype.user.nullrecent":`Nessun record recente`,
"lable.info.queue.showallmember":`Visualizza i membri della coda`,
"label.multilang.campaign.selelctmember.desc":`Seleziona una vista e seleziona il membro da aggiungere alla campagna. Lo stato del membro è {0}`,
"label.notification.ccchat3":`【评论用户名】 ha commentato il tuo post.`,
"UG.product.03":`Manuale dei prezzi supportato da più valute`,
"label.sso.saml.idp.config.pksize":`Dimensione della chiave`,
"label.defineCustomReportType":`Definire l'origine dati del rapporto personalizzato`,
"component.timeline.button.filter":`Filtro`,
"label.mr.nextGroup":`Salta il gruppo e passa al gruppo successivo`,
"label.quote.sprdz":`Indirizzo di fatturazione`,
"label.total.refuse.forecast.have.priority":`Rifiuta tutte le previsioni Priorità`,
"lable.product.peep":`Si prega di inserire un prezzo valido.`,
"label.file.who.can.access":`Chi può accedere`,
"label.page.last":`Ultima pagina`,
"label.icon.180":`Persone`,
"font-evaluate-module-v1-enabled-successfully":`Attivare con successo l'opzione di valutazione "Neural".`,
"label.appointment.wizard.subtitle4-2-2":`2 h`,
"label.passwordPolicy.setup.oneyear":`Un anno`,
"label.login.bound.mfadevice.title":`Abilitare i dispositivi MFA virtuali`,
"vue_label_dashboard_statisticalvalue":`Selezionare il valore statistico`,
"label.ishistory":`Storia`,
"component.timeline.label.title":`Timeline`,
"label.page.step3.of.step5":`Passo 3 di 5`,
"label.assignment.setup.detail.section":`Dettaglio della regola`,
"label.salescloud.opportunity.nothave.main.contactrole":`Nessun contatto importante`,
"label.import.page1.limitedcsv":`Formato CSV SOLO per il caricamento dei file`,
"label.icon.187":`Martello`,
"label.emailobject.wizard.desc5":`Personalizza la tua firma per rendere la tua posta più bella.`,
"vue_label_report_notice_copy_success":`Copia il rapporto con successo!`,
"label.dupicatecheck.repeatcondition.chooserulemsg":`Non avete scelto la regola del controllo dei duplicati.`,
"label.componentEditor.upper.limit":`Fino al 100`,
"label.validate.function.funcExplain.ISNEW":`Controlla se il record è nuovo e restituisce TRUE se è nuovo, altrimenti restituisce FALSE`,
"label.postalCode":`Codice postale`,
"label.dashboard.snapshot.enable.flag":`Abilitare le istantanee della dashboard`,
"vue_label_file_upload_type_size":`Solo i file di {fileType} possono essere caricati, e non più di {size}Mb`,
"label.appointment.wizard.subtitle3-6":`Sabato`,
"homepage.narrow":`Colonna stretta (sinistra)`,
"chatter.addmute.confirm":`Sei sicuro di voler mantenere questo post "non disturbare"?`,
"label.lookup.account":`Ricerca Conti`,
"message.lostthemanager":`Questo invio richiede l'approvazione del manager dell'utente, e il valore del manager dell'utente è nullo. Contatta il tuo amministratore per saperne di più.`,
"label.exchange.sync.state.contact.m3":`Registrazioni sincronizzate nelle ultime 24 ore:`,
"label.version.phone.app":`App mobile`,
"label_tabpage_search":`Cerca`,
"vue_label_helpcenter_campaign":`Nelle informazioni dettagliate, clicca sul pulsante del diagramma ad albero accanto alla campagna per visualizzare il diagramma della struttura gerarchica della campagna e capire la gerarchia genitore-figlio della campagna.<br>Gestisci i contatti o i lead coinvolti nella campagna attraverso la relativa lista dei membri della campagna.`,
"front-lightning-module-v1-dashborad-last-year":`L'anno scorso`,
"label.campaign.channel.value":`Valori`,
"vue_label_opportunity_contactrole_primarycontact_notice":`Per selezionare il tuo contatto principale, salva questo passo e scegli da Gestione`,
"label.biaoqingfaxian.title":`Scoperta di offerte e gare d'appalto`,
"label.approved":`Approvato`,
"label.hong.kong.time":`Ora di Hong Kong`,
"label.customfields.file.cannotopen":`Impossibile aprire il file`,
"lable.New.tips":`Fare clic su "Nuovo" per creare un nuovo modello di rapporto di servizio sulla base di un modello standard o uno qualsiasi selezionato. Attivare il modello e iniziare a usarlo.`,
"component.setup.tabs.label.add":`Aggiunto`,
"label.forecast.forehistory.replacebest":`Miglior caso superato`,
"front-kefu-moudle-v1-jctrrt-call-serve":`Call Center integrato con TRRT per fornire servizi SaaS più completi`,
"label.workflow.configrule":`Passo 2 Configurare la regola del flusso di lavoro`,
"label.dashboard.snapshot.refresh.frequently":`Le istantanee del cruscotto si aggiornano troppo frequentemente, riprova più tardi`,
"label.ems.editsetting":`Modifica impostazioni e-mail`,
"message.confirmdeleteAPP":`Sei sicuro di voler eliminare questa app?`,
"label_chatter_activity":`Attività`,
"label.editsharerules":`Regole di condivisione Modifica`,
"label.loginservice.license.notuse.must":`La licenza non è attualmente disponibile, è necessario`,
"label.import.step2.beforeexport":`1. Prima di importare, assicurati di importare tutti i record correlati. Per esempio, se stai importando i record di contatto e vuoi compilare il campo account, che è un campo di ricerca, è necessario creare prima il record di account che stai compilando, poi importare il record di contatto e compilare il campo account con il nome o l'ID dell'account corrispondente.`,
"label.chat.mute":`Non disturbare`,
"label.icon.128":`Casa`,
"label.give":`&&e`,
"label.hide":`Non mostrare`,
"label.relationobject.wpr":`Approvazione delegata`,
"label.summation":`Somma`,
"label.layout.availabletab.details":`Dettagli`,
"label.circle":`Grafico della ciambella`,
"vue_label_opportunity_contactrole_add":`Aggiungere ruoli di contatto`,
"label.file.library.file2libsuccess":`Aggiunto con successo!`,
"label.weixin.report.reportgenerated":`Rapporto generato`,
"label.icon.91":`Persone`,
"report.label.pleaseinput":`Inserisci ciò che vuoi cercare`,
"label.escalation.setup.newaction.otheremail.tip":`Puoi inserire fino a cinque (5) indirizzi e-mail da notificare. Ogni indirizzo e-mail è separato da ",".`,
"label.area.donot.have.data":`Nessun dato`,
"label.customcomponent.btn.reference":`Riferimento del componente`,
"label.appointmentdetail.wizard.title7":`Tempo di promemoria`,
"label.ccchat.with":`Avere`,
"label.file.size":`Dimensione`,
"label.product.sort.beyond":`È possibile impostare un massimo di 10 livelli!`,
"label.ccchat.2018":`CCChat`,
"label.report.select.column":`Seleziona le colonne`,
"label.appointmentpage.wizard.subtitle1_1":`Scegliere data e ora`,
"label.passwordPolicy.setup.uppercasealpandnumsymbol":`Deve mescolare numeri e lettere maiuscole e minuscole, e caratteri speciali`,
"label_chatter_addressee":`Destinatario`,
"label.profile.remark2":`Se la tua organizzazione usa Tipi di record, usa i collegamenti Modifica nella sezione Impostazioni del tipo di record qui sotto per rendere uno o più tipi di record disponibili agli utenti con questo profilo.`,
"UG_Account_01":`Chi è il tuo account?`,
"label.dataimport.error.contact.notnull":`Errore: il nome del contatto non può essere nullo.`,
"lable.account.CalenderQuarter":`Trimestre del calendario`,
"vue_label_commonobjects_detail_empty":`Il prezzo di vendita non può essere vuoto`,
"label.approveassigntemplate":`Approvato per assegnare i modelli di e-mail.`,
"label.objectRelationshipDescription1":`Questa fonte di dati per i rapporti genererà rapporti su`,
"vue_label_email_insertmergefield":`Inserisci campo di unione`,
"label.mobile.home.page.check.team":`Squadra`,
"lable.edit.queue.edit":`Modifica della coda`,
"label.campagin.roi.query":`Visualizza il ROI della campagna`,
"label.dataimport.field.allow.access.to":`L'accesso ai campi di dati non è consentito, si prega di cancellare manualmente il record corrispondente e riprovare.`,
"pagecreator.systemstyle.message.canntdelete":`Lo stile attuale non può essere cancellato`,
"label.searchkey":`Inserisci le parole chiave`,
"chatter.showall":`Mostra tutto`,
"show":`Mostra`,
"label.quote.choseproduct":`Seleziona il prodotto`,
"label.report.selected.field":`Campi selezionati`,
"label.globaloperation.operationtype.create_data":`Creare record`,
"label.knowledge.setting.data.seven":`Elimina il gruppo di categorie: {flzmc}`,
"chatter.email.mentionOrMessage":`Menzioni o messaggi`,
"label_tabpage_exclusivez":`Escludi`,
"chatter.en.userinfo":`Inserisci le informazioni su di te.`,
"label.log.orgid":`Organizzazione`,
"label.dataimport.insertdata.error.fieldrepeat.update":`Il campo $schemefield_name$ nel record non può essere trovato nel database e non può essere aggiornato. Il record ha ignorato l'importazione.`,
"vue_label_chatter_add_link_success":`Link aggiunto con successo`,
"label.sender_details":`Per aggiungere nuovi dettagli sul mittente, crea un utente nel tuo`,
"label.ccpeak.addwhere.condition":`Un criterio "dove" può essere aggiunto`,
"label.datamove.total":`Totale`,
"label.tianyancha.businessverify.warning":`Si prega di notare che questa verifica supporta solo i dati aziendali registrati in Cina continentale.`,
"label.emailmainbody":`Corpo dell'e-mail`,
"label.justadmin":`Solo amministratori`,
"label.data.downpage.e.list.desc1":`Questa pagina mostra i file esportati con successo. Per favore scarica i file esportati in tempo secondo il link di download nella tua email.`,
"label.reportsSubscriptionPage.email.value":`Valori esistenti`,
"message.error.serviceappointment":`Si prega di compilare l'ora di inizio e di fine prevista sull'appuntamento di servizio.`,
"label.textMessageObject.selectone":`Seleziona almeno un record come destinatario del messaggio di testo`,
"label.schedulejob.setup.schedule.plan":`Programma`,
"label.assignment.layout.field.isassigned":`Assegna secondo le regole di assegnazione attive.`,
"label.captcha.error":`Errore di verifica!`,
"mobel_web_not_more_data":`Non ci sono più dati`,
"label.emailsync.form.emailaddress":`Indirizzo e-mail`,
"label.loginservice.error":`Errore di accesso, si prega di contattare l'amministratore.`,
"label.integrations.description":`Collega il tuo account CloudCC ad altre applicazioni`,
"vue_label_homepage_notice_selectone":`Seleziona almeno una traccia o un contatto`,
"label.chatter.default":`Default`,
"label.tabpage.datefield":`Quando il campo data è uguale, può usare il formato "ieri", "oggi", "domani", "mese scorso", "questo mese", "mese prossimo", "settimana scorsa", "questa settimana", "settimana prossima" o "YYYY-MM-DD、MM/DD/YYYY".`,
"front-kefu-moudle-myzdhsc-file":`File di registrazione non trovato o non generato`,
"label.createname":`Creatore`,
"label.mobile.phone.enter.plan":`Inserisci il tuo piano`,
"report.label.highlevelreport":`I rapporti avanzati permettono di creare le relazioni tra un massimo di 4 oggetti.`,
"label.edit.select.label":`Modalità di modifica`,
"label.partnerCloud.financeSetting.deduction":`Dopo l'attivazione, i funs saranno aggiunti al conto di sconto, al reddito di sconto e all'oggetto di spesa di sconto. Gli utenti partner possono utilizzare il conto di sconto per dedurre l'importo da pagare.`,
"message.duplication.label.updateoption":`Azione sull'aggiornamento`,
"label.custom.CurrentCQ":`CQ corrente`,
"front-kefu-moudle-wait":`In attesa`,
"sunday":`Domenica`,
"label.service.timezone":`Fuso orario`,
"setup.layout.label.selectfield":`Seleziona i campi`,
"label_emailtocloudcc_filed_action":`Azione`,
"label.forecast.customforecast.mycommit":`Il mio impegno`,
"label.uploadsuc":`Caricamento riuscito`,
"vue_label_commonobjects_view_notice_atleast1field":`Seleziona almeno 1 campo di visualizzazione`,
"label.dataimport.khmc.length":`Errore: la lunghezza dell'account è troppo lunga.`,
"label.isemailnotification":`Invia un'e-mail di notifica`,
"label.addAPPexchange":`Aggiungere applicazioni da CloudCC App Store`,
"label.partnerCloud.orderingPlatform.currency":`Valuta:`,
"UG_quota_02":`Fase delle opportunità di cambiamento`,
"label.customer.tab.step2.same.option3":`Scheda Nascosto`,
"H":`Telefono`,
"label_tabpage_searchz":`Cerca`,
"vue_label_homepage_deleted":`Cancellato`,
"label.weixin.recent.view":`Visualizzazioni recenti`,
"template.report.opportunity.sales":`Volume delle vendite di opportunità`,
"label.customfields.new.step2.opration.unique.info.v1":`Trattare "ABC" e "abc" come valori duplicati (case insensitive)`,
"savesuccess":`Salvato con successo`,
"label.partner.workspace.member.memo":`Tutti gli utenti con il profilo e i permessi selezionati possono accedere a questo cloud partner.`,
"label.icon.23":`Droga`,
"lable.batchadd.service.cfq.before":`Trigger (prima dell'inserimento)`,
"label.instrumentPanel.breakpointTwoLabelname":`Questo valore deve essere maggiore del valore minimo e del valore del breakpoint 1.`,
"message.selectgsummaryinformation":`Seleziona i dati che vuoi riassumere`,
"label.tianyancha.businessverify.msg6":`Questa funzione utilizza servizi di terze parti e può avere prestazioni instabili o un servizio impossibile a causa di un elevato utilizzo simultaneo. CloudCC non è responsabile di alcuna responsabilità.`,
"vue_label_helpcenter_report3":`3.A. Cliccate sulla casella di ricerca dei campi, selezionate il campo desiderato cercandolo o scorrendo la lista dei campi, selezionate l'operatore del campo, inserite o selezionate un valore, cliccate su Apply e il filtro del campo avrà effetto. <br> B. Clicca il segno " " sopra la casella di ricerca del campo e inserisci una condizione di filtraggio avanzata composta da numeri e lettere nella "Filter Condition Input Box". Per esempio, (1 e 2) o3.<br>? Modifica i filtri<br> Per modificare i filtri, includi i filtri standard e clicca sui filtri. <br>? Rimuovere i filtri<br> Clicca l'icona "x" su un filtro per rimuoverlo. <br>? Esegui il rapporto<br> Clicca il pulsante Esegui nell'angolo in alto a destra della pagina di modifica per vedere i risultati completi del rapporto. <br>? Salva il rapporto<br> Clicca il pulsante "Salva" nell'angolo in alto a destra della pagina di modifica, inserisci il nome del rapporto, seleziona la cartella del rapporto e salvalo. <br>2. Creare la cartella del rapporto<br> Prima di creare una cartella del rapporto, il sistema genera per default My Custom Report Folder e Unarchived Public Report Folder. <br> Passo 1: Dalla scheda Reports, clicca su New Reports Folder<br> Passo 2: Nel pop-up New Reports Folder, puoi scegliere di trasferire i report dalla cartella Unarchived Public Reports a questa cartella. Puoi selezionare quali utenti possono accedere a questa cartella e i diritti di accesso. <br>3. Visualizzare i rapporti<br> Passo 1: Dalla scheda Rapporti, vai alla pagina dell'elenco Rapporti e trova il rapporto che vuoi visualizzare selezionando "Visualizzato di recente", "Ho creato", "Tutti i rapporti", o la cartella Rapporti. o cartella Rapporti per trovare il rapporto che vuoi visualizzare. <br> Passo 2: Clicca sul nome del rapporto per visualizzarlo. Oppure clicca sul pulsante a discesa all'estrema destra del rapporto e seleziona Esegui per visualizzare il rapporto. <br>Se sei un profilo amministratore, dalla scheda Rapporti, vai alla pagina Elenco rapporti e clicca sull'icona dell'ingranaggio accanto al pulsante Nuova cartella per selezionare i campi da visualizzare nell'intestazione della tabella dell'elenco rapporti in ogni cartella. <br>4. Esportazione dei rapporti<br> Passo 1: Dalla scheda Rapporti, vai alla pagina dell'elenco Rapporti, trova il rapporto che vuoi esportare e clicca sul pulsante a discesa all'estrema destra del rapporto. <br> Passo 2: Seleziona il tipo<br> Rapporto formato: contiene intestazioni del rapporto, raggruppamento, filtraggio dei dettagli. <br> Rapporto di solo dettaglio: Righe di dettaglio non formattate. <br> Passo 3: Clicca su Esporta. Il rapporto di solo dettaglio deve essere esportato in pagine, con un massimo di 2000 dati per pagina.  `,
"label.batchdelete.success":`Eliminazione di massa con successo`,
"label.newprocess5.seq":`Ordina`,
"label.knowledgebase.data.translated.successfully":`Tradurre i dati {a] con successo`,
"label_enable_range":`Attivare la gamma`,
"label.ccchat.and":`E`,
"label.assignment.setup.list.norule":`Nessuna regola specificata.`,
"vue_label_report_summaryformulacolumn":`Colonna della formula di riepilogo`,
"label.field.edit.change1":`Il punteggio massimo non dovrebbe superare il 100`,
"syntaxerror":`Errore di sintassi, controlla i criteri che hai inserito.`,
"label.icon.116":`Casa`,
"lable.asset.BOM.according.to.product":`Generare la distinta dei beni in base alla struttura del prodotto`,
"chatter.like.post":`Alle persone è piaciuto questo post`,
"label.trigger.page":`Pagine di trigger`,
"vue_label_email_contact_adminstrator":`Il sistema è anomalo, contattare l'amministratore.`,
"label.workreport":`Note sul lavoro`,
"vue_label_homepage_edit_card_view":`Modifica vista scheda`,
"label_emailsync_status_disabel":`Inattivo`,
"label.icon.54":`Escavatore`,
"message.error.view.validerr.common":`Verifica fallita.`,
"label.exchange.sync.account.username":`Nome utente dell'account di servizio (nome utente del dominio o UPN):`,
"label.dataimport.error.date":`Errore: Data`,
"label.orgname":`Organizzazione`,
"label.weixin.group.owner":`Proprietario`,
"vue_label_dashboard_colorrange":`Gamma di colori`,
"label.forecast.shrepage.tableth":`Accesso alle previsioni`,
"label.related.disabled":`Le liste correlate non sono abilitate, contatta l'amministratore di sistema per abilitare le liste correlate nei layout di pagina.`,
"label.version.product.management":`Gestione dei prodotti`,
"label.knowledge.new.article.published":`L'articolo è pubblicato come un nuovo articolo.`,
"label.sendsms.batch.step4":`Passo 4 I tuoi SMS sono stati inviati.`,
"vue_label_commonobjects_detail_and_tasks":`Congratulazioni, tutti gli eventi e i compiti sono stati elaborati`,
"label.salescloud.ci":`tempo(i)`,
"label.ccpeak.getapi.name.time":`Se volete usare i metodi della classe CCService, dovete istanziarli.`,
"label.escalation.setup.detail.conditon":`Criteri`,
"label.lbs.isUseLbs":`Abilitare i servizi di localizzazione`,
"front-lightning-module-v1-dashborad-color-depth":`Profondità di colore`,
"date":`Data`,
"label.select.personnel":`Seleziona il personale`,
"label.appointmentpage.wizard.notif3":`L'e-mail è necessaria!`,
"label.import.page1.pleaseselectwayofdealdata":`Selezionare la modalità di elaborazione`,
"label.partner.all.memo":`L'elenco mostra tutte le nuvole partner della tua organizzazione. clicca sull'url per accedere.`,
"label.appointment.wizard.subtitle4-3-3":`30 min`,
"component_telerecord_label_subject":`Oggetto`,
"label.sendsms.batch.finish":`SMS di massa: Completato`,
"label.login.access.myusername":`Il mio nome utente`,
"label.weixin.wechatnumber":`ID WeChat`,
"label.eowechat.status":`Stato dell'utente`,
"Lead_Scoring_Setting_Rule_Setup_Value":`Punteggio`,
"label.appexchange.oldreport.noupload":`Vecchi rapporti - non caricare`,
"label.approverfieldediting":`Campo approvatore e modificabilità dei record`,
"label_tabpage_customernamez":`Nome del cliente`,
"vue_label_dashboard_linkagesettings":`Impostazione del collegamento`,
"vue_label_ccchart_notice_deletecomment":`Sei sicuro di voler cancellare questo commento?`,
"label.allprofile":`Tutti i profili`,
"label.campaignmember.main.addMember":`Aggiungere membri - Ricerca`,
"label.projectManagement.subtask.list":`Elenco dei sottocompiti`,
"label.code.some.size":`Capacità del codice: massimo 200KB caratteri, circa 20.0000 byte.`,
"front-custom-service":`Service Cloud fornisce servizi personalizzati efficienti e agili per i clienti, riduce i tempi di risoluzione dei servizi e aumenta i tassi di risoluzione con il sistema intelligente di ordini di lavoro, migliora la fedeltà dei clienti e aumenta i tassi di riacquisto.`,
"label.SMS.det":`Dettagli della notifica SMS`,
"setup_layout_label_nobutton":`Nessun pulsante disponibile`,
"vue_label_email_Could_not_save_template":`Impossibile salvare il modello`,
"label.imgfield.height":`Altezza`,
"label.leadscore":`Punteggio di piombo`,
"setup_object_field_dependency_label_removefromlist":`Rimuovi i valori selezionati`,
"message.error.code.null":`Il codice di autorizzazione non può essere nullo!`,
"label.tianyancha.businessscope":`Portata del business`,
"vue_label_chat_empty_message":`Messaggio vuoto`,
"label.total":`Totale`,
"label.delerror.list":`Elenco dei file non cancellati`,
"label.selectedreceivers":`Destinatari selezionati`,
"label.layout.availablepages":`Pagine disponibili`,
"label.pc.ui.2018.personalinfo":`Informazioni personali`,
"label.chat.topic.edit.detial":`Modifica i dettagli`,
"label.mr.descreption.reDataList1":`Nella query per soddisfare le condizioni di un totale di`,
"label.document.value.too.long":`Questo file misura più di 5M!`,
"lable.opppdt.addpdt.table.listprice":`Prezzo di listino`,
"label.selectoperate":`Selezionare l'azione`,
"label.icon.5":`Valuta`,
"label.icon.126":`Letto d'ospedale`,
"label.hiddensearch":`Ricerca nascosta`,
"label.view.sortview.exportble":`Esportabile`,
"vue_label_homepage_noassignee":`Nessun cessionario`,
"label.knowledgebase.close.and.resolve":`Chiuso e risolto`,
"label.licence.used":`Licenze usate`,
"label.newprocessstep5":`Passo 5 Selezionare i campi da visualizzare nel layout della pagina di approvazione`,
"vue_label_appstore_all_applications":`Tutte le applicazioni`,
"label.no.edit.permission":`Impossibile selezionare. Nessun permesso per modificare i record selezionati.`,
"vue_label_calendar_calendar_added_successfully":`Calendario aggiunto con successo`,
"report_line":`Campo dati`,
"component.chatter.link.label.name":`Nome del link`,
"label.data.expnode.e_desc1":`1. Esportazione personalizzata: gli utenti possono selezionare i campi da esportare e impostare le condizioni del filtro secondo le loro esigenze.`,
"label.tabularreport.step4":`Passo 4 Scegliere i criteri del rapporto`,
"Opportunity.Detailed.Phase.Change.Text.001":`Fase delle opportunità di cambiamento`,
"label.quickbooks.searchresault.action":`Azione`,
"component_timeline_label_today":`Oggi`,
"label.callboard.remark":`Inserisci qui sotto il tuo annuncio aziendale.`,
"label.campagin.field.choose":`Seleziona i campi da includere nella pagina di registrazione dei membri della campagna`,
"front-gantt-module-rolling-temporary-tasks":`Rotolamento al compito temporaneo`,
"label.file.des":`Descrizione`,
"Dashboard_View_RecentlyView":`Visti di recente`,
"UG_Account_04":`Filtraggio passivo dell'account della query`,
"chatter.refresh":`Aggiorna`,
"label.tianyancha.companyorgtype":`Tipo di azienda`,
"label.chatter.dateRange":`Intervallo di date`,
"label.campagin.step3":`Passo 3: Generare pagine`,
"label.appointmentdetail.wizard.title14":`Piano del lunedì`,
"setup.object.field.dependency.button.setdependency":`Impostazioni di dipendenza dal campo`,
"serviceterritorymember.serviceterritory.isactive.notactive":`Questo territorio di servizio non è abilitato. Puoi aggiungere membri solo sotto un territorio di servizio abilitato.`,
"template.chart.ygydyj":`Performance dell'ordine di vittoria dei dipendenti`,
"label.tag.edittags":`Modifica dei tag`,
"label.clone":`Clone`,
"front-electronic-signature-setting-intro1":`Prima di vincolare il proprio account, si consiglia di registrarsi e autenticarsi sulla piattaforma DocuSign.`,
"label_reach":`Performance`,
"label.tabpage.havez":`Allegato`,
"label.email.clearCase":`Solo email vuote non associate a casi`,
"label.customer.tab.all":`Tutte le schede`,
"label.direct.dashboard.day.report":`Nuova nota di lavoro giornaliera`,
"label_tabpage_exportview":`Vista dell'esportazione`,
"label.passwordPolicy.setup.maxFailTimes":`Massimo di tentativi di accesso non validi`,
"label.processsetting.complete.enable":`Completare e attivare`,
"label.marketsea.memberfield":`I campi possono essere contesi dai membri`,
"label.report.export.format.title":`Formato Rapporti`,
"label.recycle.execute.title":`Cancellare il cestino.`,
"label.file.use.most.user":`Utenti con il maggior spazio di archiviazione utilizzato`,
"report_type_label_systemReport":`Rapporti di sistema`,
"label.customobjects.majorobject":`Oggetto primario`,
"label.file.delete.public.link":`Cancellare il link pubblico`,
"front-epwechat-module-v1-id":`ID WeCom`,
"label.partner.common.roleNum":`Numero di ruoli`,
"label.sendtonextapprover":`Inviato al prossimo approvatore`,
"label.notification.tip3":`Carica altre 10 notifiche`,
"label.tabpage.placeenterz":`Si prega di entrare?`,
"label.mobile.phone.cc.people":`Cc`,
"component_setup_iframe_label_inputurlmemo":`Inserisci l'url della pagina da importare`,
"label.umeng.activity.statuschange":`Lo stato del compito che hai assegnato a #nome è cambiato in #newstatus`,
"label.step3.restricted.visibility":`Passo 3 Limitare la visibilità`,
"label.multilang.datadelete.approvedata":`Registrazioni in corso di approvazione ({0}):`,
"label.reportsSubscription.save":`Salva`,
"label.emailobject.template.visibility":`Visibilità`,
"label_partner_step3":`Passo 3 Informazioni di base`,
"label.product.across":`Libri Accross Price`,
"label.same.analyze.opportunity.name":`Nome dell'opportunità`,
"label.chatter.memotel":`Memo-telefono`,
"label.recentview.seloption2":`Creati di recente`,
"label.ccchat.message.search.desc1":`Non siamo riusciti a trovare nessuna notizia con`,
"label.reportexport":`Esportazione`,
"label.service.gantt.drop.tip":`Permesso negato: Non hai abbastanza permessi per operare. Contatta l'amministratore.`,
"label.australian.westem.standard.time":`Australian Western Standard Time （Australia）`,
"label.emailobject.email":`Email`,
"Homepage_Contract_FieldMissed_DoesntSupport":`Non ci sono campi "qdrq" e "htje" nell'oggetto contratto, quindi i dati non possono essere mostrati.`,
"label.email.cancel.upload.info":`Questo annullerà il processo di caricamento in corso`,
"label.page.copy.merged.field.value":`Copiare il valore del campo Merge`,
"UG.ST.006":`Entrare direttamente`,
"label.trigger.service.connot.access":`Dichiarazione inaccessibile`,
"label.projectManagement.new.tasks":`Nuovo compito`,
"lable.SalesCommitmentKanBan.receiptsRate":`Ricevute Tasso di completamento`,
"label.productsales.oppor.overdue":`Opportunità scadute`,
"vue_label_pool_convertedbyme":`Convertito da me`,
"label.loginip.pagecue.invalidt":`L'indirizzo Internet iniziale è più lontano dell'indirizzo Internet finale o l'indirizzo Internet non è valido.`,
"label.campagin.roi.xyzj":`Risposta totale`,
"label.visualpage.list.title":`Accesso alla pagina personalizzata attiva`,
"chatter.feed.searchinitvalue":`Inserisci il nome...`,
"label.export_submission":`Esportazione dei dati inviati`,
"this.season":`Questo trimestre`,
"label.forecast.settings.gx":`Condivisione dei dati previsionali`,
"label.tag.addtags.tagcolour":`Colore dell'etichetta`,
"label.api":`Nome API`,
"label.bulk.delete":`Eliminazione di massa (in modo permanente)`,
"label.reportsSubscriptionPage.condition.emailoption":`Opzioni e-mail`,
"vue_label_dashboard_newdashboardsuccessfully":`Creare un nuovo cruscotto con successo`,
"three":`Tre`,
"label.prompt":`Prompt`,
"label.same.analyze.contact.phone":`Mobile`,
"label.icon.62":`Pipeline`,
"label.forecast.shrepage.tableth.isnable":`Consentire l'invio`,
"label.multilang.polloption.vote":`{0} biglietto(i)`,
"label.customfields.totalsummary.selecttotaltype":`Seleziona il tipo di roll-up`,
"lable.SalesCommitmentKanBan.receivingCommitmentRate":`Entrate Tasso di impegno`,
"label.areaAndSub":`Territorio e Sotto-Territorio`,
"vue_label_pool_recycle":`Riciclare`,
"lable.outlook.detail.synset":`Impostazioni di sincronizzazione`,
"label.quote.detail.introduce":`Inserisci le parole chiave, clicca "Cerca" per cercare, quando la ricerca è completa, clicca "Seleziona" per passare al passo successivo.`,
"label.profile.customappset":`Impostazioni personalizzate dell'app`,
"label.changemylanguage":`Cambiare la lingua`,
"message.approval.plzcapppor":`Scegliere l'approvatore`,
"vue_label_pool_operatecertification2":`{0}{1}{2}{3}？`,
"label.publiccalendarandresource":`Calendari e risorse pubbliche`,
"label.wtd.changefields.title.desc1":`Seleziona i campi da includere nel tuo modulo Web-to-CloudCC, inserisci l'URL di ritorno specificato, poi clicca su "Generate".`,
"label.weixin.voting.not.empty":`Le opzioni di voto non possono essere vuote`,
"label.campaign.channel.equal":`Uguale a`,
"label.emailobject.emaildetail.button.back":`Indietro`,
"label.ccchat.person.invite.allowemails":`Per sicurezza, si prega di inserire l'indirizzo e-mail solo finito con il seguente`,
"label.notEdit.message":`Spiacente, non hai l'accesso per modificare questi dati, contatta l'amministratore del sistema.`,
"label.layout.selectedfields.relatedlist":`Campi selezionati / Elenchi correlati`,
"label.weixin.voting.deadline":`Scadenza`,
"label.document.upload":`File da caricare`,
"label.import.page2.notmatchfiled":`{csvfiledlength} campi nel file in totale. I campi {difflength} non sono mappati.`,
"label.data.exp.selzippwd":`Se non si compila, non c'è una password compressa di default.`,
"label.user.step2.select.email.template":`Passo 2 Selezionare il modello di email`,
"label.currency.effective":`Valute attive`,
"label.version.control.type":`Edizione dell'organizzazione`,
"label.projectManagement.Taskorproblem":`Compito / Problema`,
"label.everyweek":`Settimanale`,
"label.passwordPolicy.setup.pwdremember4":`4 password ricordate`,
"label.emailobject.groupemail":`Gruppo Email`,
"label.approvepagelayout1":`Tutti hanno la stessa disposizione`,
"label.integrations.mailchimp.massage5":`Importa i lead e i contatti selezionati dal tuo account CloudCC a MailChimp e invia l'email ai destinatari`,
"label.icon.22":`Aggiungi a`,
"Dashboard_View_All":`Tutti i cruscotti`,
"label.import.page2.example":`Esempio`,
"label.send.letter":`Inviare lettera d'invito`,
"label.mobilesectionpart":`Parte mobile`,
"component_setup_tabs_label_title":`Paginazione a schede`,
"label.knowledgebase.results":`{a} risultati`,
"label.field.remark":`Questa pagina permette di specificare i campi che possono apparire sul`,
"vue_label_systemSettings_url":`Impostazione del nome di dominio`,
"vue_label_SMS_failed_find_view_list":`Impossibile trovare l'elenco delle viste`,
"setup_layout_label_order":`Ordina per`,
"label.customsetting.touse":`Utilizzare le impostazioni personalizzate`,
"label.product.enter":`Inserisci le parole chiave per trovare i prodotti corrispondenti.`,
"label.email.template.private.SMS":`Cartella di modelli SMS esclusivi`,
"vue_label_homepage_chart_deleted":`Il grafico o il cruscotto è stato rimosso`,
"label.conversion_pages":`Pagina di conversione`,
"label.compact.layout.select":`Seleziona i campi del layout delle informazioni chiave`,
"report_label_folderandreport":`Rapporti e cartelle`,
"label.product.entry":`Listino prezzi`,
"label.campaignmember.main.manageMember":`Gestire i membri`,
"front-QBtoCC-changing":`Aggiornamento...`,
"vue_label_pool_abandonreason":`Motivo dello scarto`,
"template.report.customer.contract.statistics":`Analisi contrattuale dei conti`,
"label.invoice.message.sendsuccessully":`Fattura inviata con successo`,
"label.addcurrentoperate":`Aggiungere un'azione in uscita`,
"label.customerinfo.mailpwd":`Password della casella postale`,
"batch.nochange.owner":`Nessun permesso per cambiare il proprietario del disco!`,
"label_tabpage_uploadfailez":`Caricamento fallito, si prega di ricaricare.`,
"vue_label_systemSettings_mobelqrsetting":`Impostazione della scansione dell'app mobile`,
"label.regular_field":`Dominio della forma`,
"label.tabpage.delsuccessz":`Cancellare il successo`,
"label.Days.Before.Horizontal.Date":`livello data prima`,
"label.evaluation.general":`Ok`,
"chatter.notlike.p":`Smetti di apprezzare questo post`,
"label.chatter.send":`Invia`,
"label.emailsync.button.cancel":`Cancella`,
"label.notification.task4":`Il tuo compito sta per scadere oggi`,
"vue_label_helpcenter_detail1.2":`Cambia rapidamente lo stato dell'attività: spunta la casella di controllo davanti all'attività nel modulo "in ritardo e imminente", e clicca sul pulsante di aggiornamento per cambiare rapidamente lo stato dell'attività in "finito".<br> Prima di aggiornare, annulla la spunta e lo stato dell'attività non cambierà.<br> Le attività con alta priorità saranno contrassegnate da un'icona "bandiera rossa" nella timeline dell'attività.<br>La sequenza di visualizzazione della timeline dell'attività<br> Disponi in ordine inverso secondo la data di scadenza dell'attività, la data di scadenza della chiamata registrata, la data di inizio dell'evento, la data di invio e ricezione delle e-mail e la data di invio e ricezione degli SMS. Se le date di cui sopra sono uguali, saranno ordinate nell'ordine inverso rispetto al tempo di creazione del record.<br>"Filtro timeline attività<br> Usa i filtri nella timeline dell'evento per restringere la portata degli elementi visibili, concentrarsi sugli elementi importanti e trovare gli elementi di destinazione. Il filtro della timeline include tre tipi di filtri: intervallo di date, attività da visualizzare e tipo di attività.<br> Attività da visualizzare: tutte le attività, le mie attività<br> Nel filtro della timeline dell'evento, questa opzione può restringere l'intervallo di visualizzazione dell'evento.<br> Le mie attività: Mostra le attività a cui hai partecipato, sia come proprietario che come partecipante. Per esempio, sei il proprietario che invia le email o organizza gli eventi. Per esempio, quando sei il destinatario del campo Cc o Bcc dell'email, significa che stai partecipando all'evento.<br>`,
"component_chatter_post_label_title":`Pubblica`,
"label.data.dataexptemplate.desc":`Il modello di esportazione dei dati creato dagli utenti viene utilizzato per esportare i dati, e può rendere l'esportazione dei dati più conveniente.`,
"label.helptext":`Testo di aiuto`,
"vue_label_norm_removecomponent_certify":`Conferma l'eliminazione del componente`,
"front-template-V1-Click-new-template":`Clicca su "Nuovo" per creare un nuovo modello. Attiva e inizia a usare questo modello`,
"label.optional_fields":`Campi opzionali`,
"label.delete_about":`Stai per cancellare`,
"chatter.feed.initvalue":`A cosa stai lavorando?`,
"label.mail.configure":`Configura il tuo indirizzo email personale e abilita l'invio e la ricezione di messaggi sulla home page di CloudCC, e sincronizza la tua cronologia email con i lead e i contatti.`,
"label.project.hit.seven":`Promemoria della scadenza del compito`,
"label.button.upgrade":`AGGIORNARE o CAMBIARE EDIZIONE`,
"lable.PowerProcess.event.name":`Nome della pietra miliare`,
"label.weixin.confirm":`Confermare`,
"label.customfields.new.inputformula":`Inserisci la formula`,
"label.standard.buttonandlink.edit":`Sovrascrivere il pulsante o il collegamento standard`,
"workflow.action.tasks.assignortype.createdtype":`Tipo di creatore`,
"front-email-payment-paypal-describe":`Fare clic su "Continua", è possibile accedere al sito PayPal o creare un conto PayPal per completare il pagamento della fattura.`,
"label.selectexistingoperate":`Seleziona le azioni esistenti`,
"label.workflow":`Flusso di lavoro`,
"label.assignment.setup.detail.ruleentries":`Voci della regola`,
"label.data.file.i.title.num3":`3.Il sistema pre-legge il file di dati al server, poi avvia l'importatore di massa back-end, i cui risultati saranno notificati agli utenti per posta, e non si dovrà aspettare su questa pagina.`,
"label.use.view":`Utilizzare le viste esistenti`,
"label.forecast.settings.moren":`Famiglia di prodotti predefinita`,
"vue_label_calendar_add_share":`Aggiungi quota`,
"label_tabpage_newview":`Creare una nuova vista`,
"label.recycle":`Cestino`,
"UG_solution_03":`Creare una soluzione`,
"label.customfields.formula.text.tip":`Crea una stringa di testo, per esempio, concatenando altri campi di testo.`,
"vue_label_file_single_file_size":`Massimo supporto di un singolo file`,
"label.a.b.least":`Ogni record "A" deve avere almeno un record "B" correlato.`,
"label.validate.function.addtoformula":`Inserisci funzione selezionata`,
"label_tabpage_pleaseSelectz":`Si prega di selezionare`,
"label.account.NextFQ":`Prossimo FQ`,
"label.project.project.name":`Il nome del progetto non può essere ripetuto.`,
"label.emailtocloudcc.filed.owner":`Proprietario`,
"label.textmessage.template.message2":`Il campo inserito nell'email corrente non corrisponde al record associato, il che può causare valori nulli.`,
"label.icon.92":`Libro`,
"label.trailerpage":`Pagina di coda`,
"component_event_label_noevent":`Sembra che tu abbia completato il tuo lavoro oggi.`,
"label.trigger.tip":`Informazioni su Triggers`,
"label.knowledge.case.field.usable":`Campi caso disponibili`,
"label.group.isusing.success":`Attivare con successo`,
"label.marketsea.nextnotfollowdays":`Dall'ultimo follow-up`,
"component.todaytask.label.choicestate":`Seleziona lo stato`,
"label.recordtype.main":`--Master--`,
"label.sendletter.step1":`Passo1: Specificare i destinatari dell'invito`,
"label_tabpage_saveviewfailed":`Visualizza salvataggio fallito`,
"vue_label_report_notiec_selectone":`Ogni record di oggetto padre deve avere almeno un record di oggetto correlato`,
"UG_opportunity_003":`Traccia i tuoi canali di vendita, crea dashboard`,
"#label.importsourcestep4":`Passo 4 Importazione dei file#`,
"front-kefu-moudle-v1-trrt-tip":`È necessario associare gli utenti (agenti del servizio clienti) agli interni di TRRT per ottenere la funzione "Click to Dial".`,
"UG.Forcast.09":`Prossimo passo`,
"label.ggReleaseRange.subordinates":`Cerca ruolo e subordinato`,
"label.log.desctiption":`Potete scaricare la traccia di audit che contiene più informazioni (file Excel.csv).`,
"label.submitted":`Inviato`,
"label.validate.function.funcExplain.BEGINS":`Controlla se il testo inizia con un carattere specificato, e in tal caso restituisce TRUE, altrimenti restituisce FALSE.`,
"label.campaign.channel.code":`Codice QR del canale di marketing`,
"chatter.group.theLastActivityDate":`Data dell'ultima attività`,
"vue_label_dashboard_pleaseenterabreakpoint2value":`Inserisci un valore di breakpoint 2`,
"label.labeltranslation":`Traduci etichetta`,
"label.multilang.product.deleterederect":`La tua cancellazione di {0} non può essere completata perché è ancora associata a record in altri registri dei prezzi. Il record associato è il seguente.`,
"lable.currencyManage.manageRate.dis":`Per gestire i tassi di cambio per altri oggetti, per aggiungere nuove valute, per attivare o disattivare le valute, o per cambiare la valuta aziendale clicca su Gestisci valute.`,
"setup.layout.label.modifypage":`Modifica il layout della pagina`,
"label.import.page2.editforname":`Si prega di modificare la mappatura per il campo {necessarioNome} .`,
"label.searchlayout":`Layout di ricerca`,
"label.chatter.loadmore":`Caricare di più`,
"label.trigger.folder.all":`Tutte le cartelle di trigger`,
"label.export_submissions":`Esportazione di invii di moduli`,
"lable.SalesCommitmentKanBan.allsignedTaskRate":`Tasso di completamento del compito totale firmato`,
"KeyInformationLayout_DefaultLayout_Name":`Predefinito del sistema`,
"label.h5.chatter.great":`tipo(i)`,
"label.call.center.configuration.enable":`Utilizzare le seguenti impostazioni per abilitare la funzione di chiamata del centro dell'organizzazione`,
"label.overdate":`Data di fine`,
"chatter.poll":`Sondaggio`,
"label.login.input.verification.code":`Inserisci il codice di sicurezza:`,
"label.file.sharetype.cooperation":`Collaboratore`,
"label.app.step5":`Passo 5 Assegnare ai profili`,
"front-gantt-module-save-order":`Salvare l'ordine`,
"label.globalselect.toallrecord":`Aggiungere nuovi valori dell'elenco delle opzioni a tutti i tipi di record che usano questo set di valori globali`,
"setup.mainpage.label.welcome24":`La piattaforma cloud CloudCC fornisce impostazioni di accesso di sicurezza per tutti i dati degli oggetti nel sistema. La condivisione dei dati e i diritti di accesso possono essere controllati impostando varie regole e condizioni.`,
"homepage.layout.desctiption":`Questa pagina ti permette di creare diversi layout di schede per la scheda Home.`,
"vue_label_SMS_notice_send_sussess":`SMS inviato`,
"label.projectManagement.overdue":`Scaduto`,
"label.assignment.setup.list.lead.description":`Assegna automaticamente i lead agli utenti in base alle regole di assegnazione dei lead che definisci, puoi creare più regole con condizioni diverse.`,
"label.list.projectSetting.des":`Vuoi inviare le email con le impostazioni qui sotto:`,
"setup.mainpage.label.welcome18":`Le impostazioni dei permessi a livello aziendale di CloudCC ti permettono di controllare i diritti d'uso dei singoli utenti mentre lavorano con i dati e i moduli. Le impostazioni dei permessi basati sui ruoli includono anche posizioni utente, gruppi, ruoli, regole di condivisione dei dati e controlli di sicurezza a livello di campo per consentire la condivisione dei dati tra diverse persone e reparti dell'azienda.`,
"label.ratio":`YoY e MoM`,
"label.Xaxis":`Asse X`,
"label.google.map":`Mappa Google`,
"Dashboard.SelectBoardToDisplay":`Seleziona i cruscotti che vuoi mostrare nella pagina della scheda dashborad`,
"label.data.newtemplate.e_conditions":`Condizioni di esportazione`,
"label.emailtocloudcc.description3":`Collega il tuo account e-mail aziendale, come sales@company.com, info@company.com, support@company.com. Registra automaticamente le e-mail ricevute come lead e record di casi in CloudCC per garantire un follow-up tempestivo delle lettere dei clienti.`,
"label.page.select.profile":`Scegli i profili utente per i quali la nuova scheda personalizzata sarà disponibile. Puoi anche esaminare o modificare la visibilità delle schede dalle pagine di dettaglio e di modifica di ogni profilo.`,
"label.chosen.button":`Pulsanti selezionati`,
"front-epwechat-module-v1-info":`Informazioni di backend di WeCom`,
"label.translation.select":`Criteri di filtro`,
"ten":`Dieci`,
"label.barcode":`Codice a barre`,
"lable.product.nextdel":`Continua e cancella il record visualizzato， o clicca su`,
"label.default":`Default`,
"label.chatter.theme":`Argomenti`,
"vue_label_commonobjects_view_split_screen_view":`Visualizzazione a schermo diviso`,
"label.ems.myemails":`Le mie e-mail`,
"label.email.clearPersonalEmail":`Vuoi svuotare tutte le e-mail sincronizzate dalla casella e-mail personale?`,
"label.login.access.admin":`L'amministratore della sua azienda`,
"label.emailobject.wizard.desc":`Dopo aver collegato l'account di posta elettronica a CloudCC, è possibile inviare email direttamente da CloudCC, collegandole automaticamente a lead, contatti e opportunità correlate. La cronologia delle comunicazioni è organizzata in modo chiaro per cronologia.`,
"label.passwordPolicy.setup.minpwdlength":`Lunghezza minima della password`,
"choserow":`Scegliere le colonne da visualizzare`,
"front-epwechat-module-v1-role-binding":`Ruoli vincolanti`,
"lable.outlook.edit.newdata":`Ha la data di creazione più vecchia`,
"label.schedulejob.setup.schedule.enddate":`Data di fine`,
"label.quickbooks.view":`Vedi`,
"font-evaluate-module-v1-not-inform":`Nessuna notifica`,
"chatter.poll.option3":`Scelta 3`,
"setup_layout_label_selectfield":`Seleziona i campi`,
"label.partner.common.roleSetup":`Impostazioni del ruolo e dell'utente del partner`,
"label_partner_new_step3":`Passo 3 inserire nome e url`,
"label.transfer":`Trasferimento`,
"label.bmap.myaddress":`La mia posizione`,
"label_tabpage_individual":`Scelta individuale`,
"label.autoRegister.changepwd.setpwd.repassword":`Inserisci di nuovo la password`,
"vue_label_commonobjects_detail_and_before":`Prima`,
"front-kefu-moudle-v1-single-Login-area":`Nome di dominio ad accesso singolo`,
"label.replacedocument":`Sostituire il documento`,
"label.validate.function.category.Logical":`Logica`,
"label.companyprofile.syncsuccess":`Sincronizzazione riuscita`,
"template.chart.rwzthyxj":`Oggetto del compito e priorità`,
"label.product.clearcondition":`Condizioni chiare`,
"component_task_label_person":`* Persona assegnata`,
"label.tabpage.as":`Come`,
"message.error.calendar.add":`Il calendario è già stato aggiunto`,
"label.marketsea.isrecycleleadcreatebyself":`Vuoi riciclare le piste autocostruite`,
"label.icon.57":`Barometro`,
"UG.Lead.010":`Oppure`,
"setup_object_field_dependency_label_configured":`Layout di pagina assegnati al profilo`,
"label.tianyancha.regnumber":`Codice registrato`,
"front-kefu-moudle-v1-Opened-chats":`Abilita la chat`,
"label_tabpage_converstatez":`Stato convertito`,
"label.bmap.beijing.haidianqu":`Shangdi 10 Street, distretto di Haidian, Pechino`,
"label.startimport":`Iniziare l'importazione`,
"label.knowledgebase.application.default.settings":`Impostazione predefinita di Lightning App`,
"lable.account.year.custom":`Anni fiscali personalizzati`,
"label.event.nextmonth":`Mese successivo`,
"label.email.body":`Corpo`,
"setup.object.field.dependency.label.mustsetup":`Impostare prima la dipendenza del campo e salvare.`,
"label_tabpage_multiple":`Scelta multipla`,
"label.task.this.month":`Questo mese`,
"label.customfields.formula.moneyexample":`Margine lordo = Importo - Costo__c`,
"label.tonewemailnotice":`Seleziona l'oggetto per questo compito e clicca su Avanti. I compiti possono essere associati solo a regole di flusso di lavoro e processi di approvazione dello stesso tipo.`,
"setup.mainpage.label.welcome11":`Rapporto personalizzato`,
"label.layout.availabletab":`Schede disponibili`,
"label.data.importef":`Importazione di file non riuscita`,
"label.appupload.upload.alert":`Queste impostazioni determinano quali requisiti devono essere soddisfatti per installare questo pacchetto.`,
"label.sales.accountteam.shared":`Condivisione del team di account`,
"lable.currency.addexchageRate":`Aggiungere i tassi di cambio`,
"label.page.simplified.chinese":`Cinese (semplificato)`,
"label.service.dispatchingUnits.search.service.area":`Cerca il territorio di servizio`,
"lable.list.queue.name":`Nome della coda`,
"pagecreator.button.save":`Salva`,
"label.ccpeak.support.function":`Sostenere tutti i tipi di funzioni in un unico modulo`,
"label.tianyancha.legalpersonid":`Id della persona giuridica`,
"label.sendemail.chat.addPostmainPage":`Caro #nome:\nell'attesa! #nomeutente pubblica sulla tua home page di CCChat.`,
"batch.no.change":`Nessun permesso per trasferire i dati.`,
"label.the.referenced":`invocato in`,
"label.input.webtab.information":`Compilare le informazioni sulla scheda web.`,
"vue_label_systemSettings_subscription":`Tipo di abbonamento`,
"label.login.access.title":`Concedere l'accesso all'account`,
"label.schedulejob.setup.schedule.lastday":`l'ultimo giorno`,
"label.synchronize.department":`Sincronizzare gli utenti`,
"label_tabpage_lessequalz":`Inferiore o uguale a`,
"label.file.library.successmanagemember":`Salvato con successo`,
"label.service.major.event.oreder":`Sequenza`,
"label.desktopintegration":`Integrazione del desktop`,
"label.a_b":`Relazione da A a B`,
"every":`Ogni`,
"label.tabpage.bar":`Bar`,
"label.filecontentsnotnull":`Il contenuto del file non può essere vuoto.`,
"label.layout.detailoftestobj":`Dettagli dell'oggetto del test`,
"label.summaryreport.2018.step3":`Passo 3 Scegliere le intestazioni di colonna`,
"UG.Lead.002":`Ci sono molti modi per identificare i "lead" per il tuo prodotto o servizio.`,
"label_partner_workspace_member_selectedprofile":`Profilo selezionato`,
"label.newdescription":`Nuova nota`,
"vue_label_normal_moveup":`Salire`,
"label.mobile.quickcreate.default.logacall":`Cronologia delle chiamate`,
"userterritory.serviceterritory.user.unique":`A questo utente è già stato assegnato questo territorio di servizio. Si prega di non riassegnare.`,
"label.weixin.record":`Record`,
"front-kefu-moudle-connecting":`Collegare`,
"label.monitorsys.recent.operation.log":`Registro delle operazioni recenti`,
"lable.outlook.detail.lmaping":`Mappa Campi di piombo`,
"lable.account.year.ovdate":`Data di fine anno fiscale`,
"vue.homepage.auditcard.record":`{recordTotal} record`,
"label.processsetting.delete.process.succeeded":`Elimina il processo con successo!`,
"label.customerinfo.smsPwd":`Password del gateway SMS`,
"label.tolead.object":`Importazione di oggetti`,
"label.data.downpage.i.list.desc2":`Dopo aver importato i dati, riceverai un'e-mail che ti ricorderà che l'importazione è avvenuta con successo.`,
"label.sharerule.ruletype":`Tipo di regola`,
"label.reportsSubscriptionPage.email.toothers":`Invia a me e a certi gruppi di utenti`,
"label.emailobject.templates":`Modelli`,
"vue_label_checkduplicate_":`Analisi delle collisioni`,
"label.campaign.channel.lookup.example":`Visualizza campione`,
"label.login.verification.please.note":`Si prega di notare:`,
"label.version.charge":`Carica`,
"label.ccdocument.show.trace":`Mostra la traccia`,
"label.sendemail.approval.submit":`Ciao, #name:\n #actorname il #objLabel-#recordname presentato da #actordate è in attesa della tua approvazione. per favore clicca il seguente link o accedi al sistema crm per entrare nel centro di approvazione per l'approvazione:\n #path#appPath/query.action?id=#recordid&m=query\n#orgName`,
"setup.mainpage.label.welcome12":`L'utente può completare la definizione del rapporto cliccando con il mouse, senza programmare, e seguendo i passi del sistema. Il sistema può scegliere tra un rapporto a lista, un rapporto di riepilogo e un rapporto a matrice. Sono anche disponibili opzioni di visualizzazione per tutti i campi. Rimuove le informazioni di campo non necessarie. Allo stesso tempo, fornisce una varietà di visualizzazioni grafiche tra cui strisce, linee di piegatura, anelli, imbuti e torte, in modo che gli utenti possano vedere a colpo d'occhio.`,
"UG_contact_06":`Importazione di contatti`,
"message.success.event.add":`Salvare con successo le informazioni del nuovo evento`,
"report.line":`Campo dati`,
"label.approvepagelayout2":`Ognuno ha un layout diverso`,
"vue_label_normal_contract_sf":`Contratto`,
"label.tabpage.tpcustomersz":`Convertire i lead`,
"label.ccchat.message.new.error5":`Errore, il tuo messaggio non può superare i 10000 caratteri.`,
"label.severalorone":`File individuale`,
"pagecreator_systemstyle_label_buttonfontcolor":`Testo del pulsante`,
"label.customer.tab.step3.introduce":`Scegli le app personalizzate per le quali la nuova scheda personalizzata sarà disponibile. Puoi anche esaminare o modificare la visibilità delle schede dalle pagine di dettaglio e di modifica di ogni app personalizzata.`,
"chatter.group.groupEdit":`Modifica del gruppo`,
"label.partnerCloud.partnerAccount.spending":`Spese di rimborso`,
"label.slip":`voce)`,
"label.field.master.class":`Il livello di relazione principale-dettaglio è oltre il livello 3`,
"label.sendemail.chat.addComentsmyFeed":`Caro #nome:\nell'attesa! #nomeutente ha risposto al tuo micropost.`,
"label.service.ganttBaiduMap.selectingDispatchTime":`Seleziona l'intervallo di invio`,
"label.knowledgebase.remove.article":`Sei sicuro di cancellare l'archivio degli articoli?`,
"label.appupload.notmanaged":`incontrollato`,
"label.report.goto.step":`Vai al passo`,
"label.publicgroup.save.mustbeselect":`È necessario selezionare i membri`,
"label.data.expnode.e.desc2":`2. Esportazione per modello: gli utenti possono selezionare il modello per esportare i dati.`,
"UG.product.02":`I prodotti si riferiscono a prodotti o servizi che vengono venduti o acquistati.`,
"label.sendemailtouser":`Sei sicuro di voler inviare email agli utenti selezionati?`,
"label.knowledge.setting.hint.nine":`Se non lo sai come ti avvantaggia la Conoscenza? Ordina articoli simili come una sola categoria di dati e accumula in una categoria più ampia. Ora, aggiungiamo una categoria di dati. Puoi aggiungere altre categorie in seguito.`,
"front-asset-module-v1-view-asset-bom":`Visualizza la distinta dei beni`,
"label_partner_all_enable":`Abilita`,
"label.processsetting.disable.process.successfully":`Disattivare il processo con successo`,
"label.call.center.enable":`Abilitare il call center`,
"message.recordtype.applyitseparatly":`Applica un layout di pagina diverso per ogni profilo.`,
"label.weixin.report.customize":`Personalizza`,
"label.file.mongdb.file.is.not.exist":`Il file non esiste`,
"label.chat.edit.topics":`Modifica argomento`,
"label.knowledge.delete.searchterm":`Errore durante l'eliminazione del termine di ricerca promosso`,
"label_emailtocloudcc_redmessage3":`Inserisci l'indirizzo del server`,
"use":`Usa`,
"label.batchtransfer.transferfrom":`Trasferimento da`,
"label.recycle.my":`Il mio cestino`,
"label_json_string_null":`Vuoto`,
"label.version.lookupfield":`Campo di relazione di ricerca`,
"lable.tianyancha.h5.searchf":`Non trovato`,
"label.validate.globalvariable.description":`$User.[Field API] eg: $User.id <br>I valori che puoi usare sono: id,name,roleId,roleName,profileId,profileName,department,title,email`,
"UG.opportunity.006":`Genio dell'opportunità`,
"label.applt.copy":`Clone con un solo tocco`,
"chatter.emailMessageOrReply":`Messaggi o commenti sul mio post`,
"label.newreport.self":`Campi selezionati`,
"label.visualpage.checkpinxie":`Si prega di controllare l'ortografia della pagina.`,
"label.knowledgebase.article.attaching.case":`L'articolo {nome} è stato allegato al caso!`,
"label.dialogbox":`Finestra di dialogo`,
"label.summaryreport.step3.new":`Passo 3 Selezionare i dati da riassumere`,
"label.confirm":`Confermare`,
"label.mobile.buttom.team":`Squadra`,
"label.quickbooks.action.link":`Link`,
"vue_label_commonobjects_view_support_to_datas":`L'operazione supporta fino a 10 dati`,
"vue_label_helpcenter_homepage":`Ogni utente ha due homepage dall'inizio, una homepage standard e una homepage personale. L'amministratore può assegnare all'utente una homepage di profilo corrispondente in base al profilo dell'utente. Si noti che la homepage della versione Lightning e la homepage della vecchia versione non sono interoperabili.<br> 1. Homepage standard<br> Il contenuto della homepage standard è uniforme e non modificabile. Compreso il componente delle prestazioni trimestrali, il componente delle visualizzazioni recenti, il componente del centro di approvazione, il componente dell'evento di oggi, il componente delle attività, il componente delle opportunità commerciali in ritardo, il componente delle opportunità commerciali fuori dai 30 giorni e il componente delle opportunità commerciali in arrivo<br> Componente delle prestazioni trimestrali: ognuno può impostare i propri obiettivi trimestrali<br> Componente delle visualizzazioni recenti: Visualizza i 10 record di oggetti visti più di recente<br> Componente opportunità commerciali senza contatto da 30 giorni: Mostra 5 opportunità di business i cui giorni di non contatto sono maggiori di 30 giorni e la probabilità non è 0 o 100<br> 2. Homepage personale<br> Ognuno ha una homepage personale, e il contenuto della homepage personale può essere personalizzato per aggiungere o eliminare componenti, o trascinare e rilasciare per regolare la posizione e la dimensione dei componenti<br> Ci sarà un componente briefing, un componente centro di approvazione, un componente opportunità commerciali in ritardo e un componente opportunità commerciali in arrivo per impostazione predefinita quando si apre un account sulla homepage personale<br> La homepage personale permette fino a 15 componenti<br> 3. Home page del profilo<br> Gli amministratori possono creare/modificare/cancellare homepage del profilo personalizzando la homepage e possono assegnare diverse homepage a diversi profili, in modo che gli utenti con diversi profili possano vedere diverse homepage<br> Fino a 15 componenti per homepage del profilo<br> 4. Aggiungere componenti<br> La homepage personale e la homepage del profilo possono essere personalizzate per aggiungere componenti, è possibile aggiungere componenti dashboard, componenti grafico dashboard e componenti vista scheda<br> Componente dashboard: aggiungere l'intero dashboard del sistema alla homepage. Il numero di sottocomponenti nel dashboard rappresenta quanti componenti occupa il componente dashboard (la homepage supporta fino a 15 componenti), e i dati del componente dashboard dopo l'aggiunta non saranno associati al dashboard originale (cioè, se il dashboard originale viene cancellato, il componente dashboard può ancora funzionare) <br> Componente grafico nel dashboard: È possibile aggiungere un componente grafico specifico nella dashboard nel sistema alla home page, e la funzione di collegamento del componente non sarà valida in questo momento<br> Componente di vista della carta: È possibile scegliere di aggiungere una certa vista di un oggetto come fonte di dati alla home page, e i campi e gli elementi dell'operazione possono essere personalizzati. Ma si noti che se la vista di origine dati della vista scheda viene eliminata, la vista scheda non avrà dati`,
"label.usersandlimit":`Utenti e autorizzazioni`,
"label.sendmail.step3.introduce2":`destinatario(i) selezionato(i) per ricevere questa e-mail.`,
"label.setupcustomfield":`Campi personalizzati`,
"label.layout.last.notdel":`L'ultimo non può cancellare il layout.`,
"label.emailtocloudcc.redmessage7":`Errore di configurazione, contattare l'amministratore.`,
"label.includedIn":`Contenuto in {parentproductname}`,
"label.permission.detail.app.pagesetting":`Impostazioni di pagina personalizzate`,
"label.addfile.tips":`Sono stati selezionati {selectedNum} file. Possono essere aggiunti fino a {originNum} file per una sola volta.`,
"label.fieldinformation":`Dettagli del campo`,
"label.campagin.roi.sjcb":`Costo effettivo`,
"label.email.all.works.company":`Tutti i colleghi dell'azienda`,
"label.currencyDesc":`Usa questa pagina per definire tutte le valute usate dalla tua organizzazione. La valuta aziendale dovrebbe essere impostata sulla valuta in cui la tua sede centrale riporta le entrate. Se si designa una valuta diversa come corporate, tutti i tassi di conversione saranno modificati per riflettere il cambiamento.`,
"label.file.details":`Dettagli`,
"label.foldervisitlimit3":`Solo i seguenti utenti possono accedere a questa cartella:`,
"label.account.next.M":`Mese successivo`,
"label.oweralias":`Alias del proprietario`,
"label.projectManagement.entryname":`Nome del progetto`,
"label.customcomponent.page.add.title1":`Informazioni sui componenti`,
"label.projectManagement.PleaseenterCreator":`Inserisci un creatore`,
"label.multipleactivity.memberselected":`Membri selezionati`,
"label_chatter_memotel":`Memo-telefono`,
"lable.Confirm.customers":`Conferma il recupero di {num} piste.`,
"front-email-payment-Invoice-number":`Fattura No.`,
"label.not.appoint.validation":`Nessun oggetto è specificato per la regola di convalida, specificare.`,
"label.peru.time":`Tempo del Perù`,
"label.setting.intergrationlist.status3":`Accesso a QuickBooks richiesto`,
"vue_label_display_number_field":`Mostra i campi numerici`,
"label_productline_count":`Serie di prodotti Importo`,
"label.data.downpage.i_title.num2":`2. Prima di iniziare l'importazione, assicurati che il nome del campo nel file che vuoi importare corrisponda al nome del campo dell'oggetto in CloudCC.`,
"label.field.duplicate4":`Trattare "ABC" e "abc" come valori diversi __(case sensitive)`,
"message.approval.step.validation.invalid.levels":`Almeno 1 livello`,
"label.tianyancha.businessverify.step1":`Abilitare la verifica dei dati aziendali passo 1`,
"label.hidedetail":`Nascondi dettagli`,
"UG_Lead_009":`Cronologia delle chiamate APP`,
"label.partnerCloud.newProductSeries":`Nuova famiglia di prodotti`,
"label.brief.opportunities":`Totale`,
"label.user.mfa.unbind.remind":`Stai per scollegare l'MFA agli utenti selezionati e hai bisogno di ri-collegare il dispositivo MFA dopo il prossimo login, sei sicuro?`,
"vue_label_report_grouprow":`Riga di gruppo`,
"setup.layout.label.newarea":`Nuova area`,
"label.nostart":`Non iniziato`,
"UG_Lead_010":`Oppure`,
"label.emailmerge.mergepage.record.requeired":`Seleziona i record che vuoi unire.`,
"label.appointmentpage.wizard.notif1btn1":`Confermare`,
"UG.Account.02":`Alcune aziende forniscono servizi ad altre aziende, altre collaborano direttamente con gli utenti finali e altre servono le ONG.`,
"label.address.country":`Paese`,
"label.userinfo.updatepwd":`Cambiare la password`,
"label.salescloud.teamrole.optionlist.opportunity":`Aggiungi un membro del team di opportunità a`,
"lable.account.Current.FY":`Anno corrente`,
"chatter.coll.p":`Segnalibro questo post`,
"label.setupsms":`SMS`,
"label.atlantic.daylight.time":`Ora legale atlantica`,
"label.recordslock":`Blocco dei record`,
"button_partner_search":`Informatevi su`,
"vue_label_salesfunnel_notice4":`Quantità di opportunità di business con una probabilità dell'1% - 99%`,
"vue_label_report_statistics":`Statistiche`,
"label.ccchat.notmember.active.group0":`Non sei membro di nessun gruppo di attività con {0} nel loro nome`,
"label.tag.manage.newtag":`Nuovo Tag`,
"label.customfileds.formula.dateandtime.tip":`Calcolare una data/ora, per esempio, aggiungendo un numero di ore o di giorni a un'altra data/ora.`,
"label.weixin.mobile.fly.ios":`Condividi da dispositivo mobile (IOS)`,
"vue_label_file_over_file_size":`La dimensione del file di file.name  'supera il preset di sistema!`,
"label.schedulejob.setup.schedule.last":`ultimo`,
"label.ccchat.whose.name.contains":`di qualsiasi gruppo attivo il cui nome contiene`,
"label.project.milestone.name":`Non puoi avere due pietre miliari con lo stesso nome in un progetto.`,
"message.passwordPolicy.validate.reuse":`Errore: Non puoi riutilizzare questa vecchia password.`,
"label.stdashbord.xsld.business.img3":`La quantità di probabilità di 1%-99% * Probabilità`,
"label.event.view.list":`Visualizza elenco`,
"label.workflow.ruletriggertime":`Tempo di attivazione della regola`,
"label.campaign.channel":`Canali di marketing`,
"label.appexchange.emailnotice":`Allarme e-mail del flusso di lavoro`,
"label.icon.77":`Agricoltura`,
"label.visualpage.display.value":`Inserisci i valori da visualizzare, e nota che non ci sono spazi prima o dopo.`,
"label.forecast.customforecast.type.user":`Per utente`,
"label_tabpage_lessz":`Meno di`,
"label.same.analyze.contact.email":`Email`,
"vue_label_report_range":`gamma`,
"lable.product.pricebooks.nr":`Puoi clonare i contenuti dai libri dei prezzi esistenti selezionando dalla lista di scelta qui sotto.`,
"label_mobile_buttom_team_setUp":`Impostazioni della squadra`,
"label.email.bcc.recipients":`Destinatari Bcc`,
"vue_label_ccchat_notice_deletepostfail":`Non è riuscito a cancellare il post`,
"label_file_type":`Tipo di file`,
"label.multilang.feedtrack.operateupdate":`Un record {0} è stato modificato：`,
"label.contractmanager":`Responsabile del contratto`,
"front-gantt-module-drag-one-task-sorting":`I compiti possono essere ordinati solo all'interno della stessa pietra miliare!`,
"label.partner.step2":`Passo 2 confermare il modello`,
"front-epwechat-module-v1-again-binding":`Rilegare`,
"label.service.miniProgram.imageSize":`Non si possono caricare più di 2MB di foto!`,
"setup_main2018_label_managesetup":`Impostazioni di amministrazione`,
"component_salesperformance_label_nopermission":`Per visualizzare i dati relativi alle opportunità commerciali, contatta il tuo amministratore di sistema.`,
"lable.account.stadate":`Data di inizio del trimestre fiscale`,
"label.service.gantt.and.resourcestype":`e il tipo di risorsa è`,
"label.ems.attachfiles":`Aggiungi allegato`,
"label.data.expnode.e.desc1":`1. Esportazione personalizzata: gli utenti possono selezionare i campi da esportare e impostare le condizioni del filtro secondo le loro esigenze.`,
"vue_label_systemSettings_analyse":`Analizzare`,
"label.project.all.date":`La data di fine deve essere successiva o uguale alla data di inizio!`,
"vue_label_commonobjects_view_summary_basis":`Base di aggregazione`,
"template.chart.yywjhdschd":`Campagne con opportunità`,
"vue_label_pool_notmeet":`Non soddisfa i requisiti del cliente`,
"label.attendance.manager":`Gestire le presenze`,
"vue_labenl_normal_current":`Corrente`,
"label.projectManagement.completed.quantity":`Quantità di completamento`,
"label.layout.testfield":`Campi di prova`,
"label.customfields.selectcontainrelatelistlayout":`Seleziona i layout di pagina che dovrebbero includere questo elenco correlato`,
"label.fiji.time":`Ora delle Figi`,
"message.error.domain.already.exists":`Il nome del dominio esiste già.`,
"label.accountandcontact":`Conti/Contatti`,
"label.dashboardSetup.right":`A destra`,
"label.view.appliedMobile.xgry":`Controlla questa voce, gli utenti interessati possono vedere la vista sul banco di lavoro della homepage`,
"label.file.share.all":`Qualsiasi utente della sua azienda`,
"vue_label_pool_summary":`Totale {0} record(s), aggiornato a {1}`,
"label.emailtemplate.new":`Nuovo modello di e-mail`,
"label.tag.manage.button1":`Crea un nuovo tag`,
"label.data.exp.tempexppage":`Pagina del modello di esportazione dei dati`,
"font-trade-module-v1-invoice-total":`Importo totale della fattura`,
"label.folder.sort":`Ordina cartella`,
"label.multilang.campaign.countnum":`{0} tempo(i)`,
"label.homepagelayout":`Layout della home page`,
"setup_layout_button_cancel":`Cancella`,
"lable.Search.in.QuickBook":`Cerca in QuickBook`,
"setup_fielddependency_label_pleaseclick":`Clicca sul valore del campo di controllo da modificare`,
"setup.fielddependency.label.pleaseclick":`Clicca sul valore del campo di controllo da modificare`,
"label.version.sum.field":`campo(i) personalizzato(i)`,
"label.form.is.submitted.successful":`Prompt di invio del modulo con successo`,
"label.campaignmember.main.batchaddmember":`Aggiungere in massa membri della campagna`,
"label.sendemail.activity.newevent":`Caro #belongtoidccname, ciao:\r\n tuo collega #createbyidccname ti ha assegnato un nuovo evento in #createdate, che recita come segue:\r\n soggetto: #subject\n ora di inizio: #begintime \r \n ora di fine: #endtime\r\n elementi correlati: #relatedstr\r\n contenuto: #per maggiori dettagli, visita questo link:\r\n #path\r\n #orgNameCRM system`,
"label.knowledgebase.select.target":`Scegliere un obiettivo`,
"setup.layout.label.buttonlist":`Seleziona i pulsanti`,
"pagecreator.page.label.pagedesc":`Descrizione della pagina`,
"label.version.professional":`Edizione professionale`,
"UG.Forcast.10":`Completa`,
"template.chart.schdyqsr":`Entrate previste dalle campagne`,
"front-filter-module-v1-quick-filter":`Filtro Flash`,
"label.notification.group2":`Sei entrato con successo nella squadra pubblica`,
"label.ServiceCloud.statistics.by.serviceArea":`Statistiche per territorio di servizio`,
"label.validate.function.funcExplain.TIMENOW":`Restituisce un tempo che rappresenta il momento corrente`,
"label.brief.lastmonth":`Ultimo mese`,
"label.weixin.member.states":`Stato del membro`,
"template.chart.ljxsje":`Importo cumulativo delle vendite`,
"label.eidt.queue.label.hasused2":`Questo nome di coda esiste già o è stato usato in precedenza.`,
"label.textmessage.nophonenumber":`Questo contatto non ha un numero di cellulare registrato!`,
"label.task.new":`Nuovo compito`,
"label.tabpage.grid":`Il display a griglia`,
"label.workbanch.setup.viewname":`Visualizza nome`,
"front-gantt-module-temporary-tasks":`Compito temporaneo`,
"label.reportTypeDescripe":`Con l'origine dati dei report personalizzati, puoi permettere agli utenti di creare report dagli oggetti predefiniti, dalle relazioni tra oggetti e dai campi che specifichi.`,
"setup_layout_label_fieldlist":`Campi disponibili`,
"label.ggReleaseRange.searchforRole":`Ruolo di partner di ricerca`,
"label.datamanage.account.field":`Campi dell'account`,
"label_tabpage_groupingemptyz":`Gli elementi del raggruppamento non possono essere vuoti`,
"label.permission.edit.insertinfo":`Inserisci le informazioni del set di autorizzazioni`,
"label.back_forms":`Torna all'elenco dei moduli`,
"vue_label_calendar_step_2":`Passo 2: Creare un calendario da un oggetto standard o personalizzato.`,
"lable.outlook.mcto.out":`Domini esclusi`,
"label.workflow.accessnext":`Utilizzare questo processo di approvazione se`,
"label.data.exp.temppage":`Esportazione dei dati e pagina di creazione del modello`,
"label_tabpage_printview":`Stampa la Vista`,
"vue_label_report_preview":`Per visualizzare le ultime modifiche, aggiorna l'anteprima.`,
"frame_personinfo_label_personimage":`Foto del profilo`,
"component.chatter.button.like":`Come`,
"label.ems.drafts":`Bozze`,
"front-lightning-module-v1-details-page-chart-report-name":`Nome del rapporto`,
"label.partner.workspace.login":`Pagina di accesso`,
"include":`include`,
"label_length_20":`Limitare la lunghezza a 20 caratteri.`,
"component_event_button_save":`Salva`,
"label.weixin.recalculate.shared.success":`Ricalcolo delle regole di condivisione degli oggetti riuscito.`,
"message.duplication.errorinscript.lessthan2":`Devi selezionare almeno due record da unire.`,
"label_my_forecast":`La mia previsione`,
"label.ems.to":`Destinatario`,
"label_mobile_buttom_team_init":`Inizializzazione dell'utente del team`,
"label.sendemail.send.codeerror":`La conversione del codice non è riuscita, inserisci la codifica corretta.`,
"lable.quote.syncing.and":`e`,
"label.campaignmember.selectmember.step1oftotal":`Passo 1 di 2`,
"label.ems.step3":`Passo 3`,
"lable.PowerProcess.detail.message":`Informazioni sul processo Milestone`,
"chatter.poll.option2":`Scelta 2`,
"front-view-module-v12-verify-number":`Errore di formato numerico. Si prega di controllare i dati di input.`,
"label.setup.mobile.homepageshortcuts.savesuccess":`Le impostazioni della funzione swift salvate.`,
"lable.outlook.edit.zdyoutfi":`Nome del campo di scambio personalizzato`,
"label.assignment.setup.newentries.inputentries":`Inserisci la voce della regola`,
"label.customfields.money.tip":`Permette agli utenti di inserire un dollaro o un altro importo in valuta e formatta automaticamente il campo come un importo in valuta. Questo può essere utile se si esportano dati in Excel o in un altro foglio di calcolo.`,
"label.service.appointmentList.cancelThePlan":`Annullare il piano`,
"label.chat.topic.suggest.add.topic":`Nessun suggerimento, aggiungi il tuo argomento.`,
"vue_label_commonobjects_detail_tips":`Suggerimenti`,
"message.error.view.nameexists":`Errore: Il nome unico della vista esiste già.`,
"label_emailtocloudcc_step2_name":`Configura la proprietà delle e-mail`,
"label.field.validation.apiname":`Deve iniziare con una lettera, deve contenere solo lettere maiuscole e minuscole, numeri e underscore e la lunghezza massima è di 50 caratteri, la lunghezza minima è di 2 caratteri. Si prega di notare che non può essere una parola chiave del database.`,
"page.field.masterinput.remark2":`Per esempio, quando si crea un nuovo ordine, è necessario abilitare questa funzione per inserire le voci della riga dell'ordine nella stessa pagina. (questa caratteristica è adatta agli oggetti nella relazione master-detail).`,
"label.rule.enabled.successfully":`Abilitare le regole con successo`,
"label.role.createrolelist.tip":`Qui sotto c'è un elenco dei ruoli per la tua organizzazione. Puoi visualizzare maggiori informazioni cliccando sul link del ruolo.`,
"label.multilang.datamanage.dataimport.redundantmsg":`La lunghezza del titolo è &nbsp;{0}&nbsp;, ma la lunghezza dei dati è &nbsp;{1}&nbsp;, il sistema non può determinare quali &nbsp;{2}&nbsp; campi sono ridondanti.`,
"label.visualpage.staticresource":`Introdurre la risorsa statica`,
"chatter.group.members01":`Membri`,
"label.planned.workname":`Nome del lavoro`,
"label.service.dispatchingUnits.gantt.data":`Corrisponde alla data di Gantt`,
"label.data.newtemplate.t.conditions":`Condizioni del modello`,
"label.accmarketsea.edit.title":`Modifica del pool di conti`,
"label_chatter_priority":`Priorità`,
"label_mobile_buttom_team_open":`Abilita Team su PC e App`,
"front-gantt-module-no-tasks-available":`Nessun compito disponibile`,
"component.newrecords.label.type":`Tipo di stoccaggio`,
"label.version.ccdocument.and.remark":`Note e allegati`,
"label.martrixreport.step2":`Seleziona la modalità di raggruppamento usata per calcolare i dati che vuoi arrotolare`,
"label.projectManagement.Scheduleinformation":`Informazioni sugli orari`,
"label.emailmerge.mergeFolder.description":`In questa pagina puoi creare un documento Microsoft Word contenente i dati dei tuoi contatti. Seleziona i modelli di mail merge, fino a 20.`,
"label.autoRegister.changepwd.setpwd.tip":`La password deve soddisfare le seguenti condizioni`,
"label.partnerCloud.orderingPlatform.shoppingEmpty":`Il carrello è vuoto, clicca su "Aggiungi prodotti" per aggiungere.`,
"label.marketcloud_seminar":`Seminario sulla nuvola di marketing`,
"label.knowledgebase.no.results.knowledge.search":`Nessun risultato su "{a}" in Conoscenza`,
"label.createdate":`Data di creazione`,
"vue_label_systemSettings_bazaar":`Mercato`,
"report_type_label_contractPayment":`Contratti e crediti`,
"label.myemailset":`Le mie impostazioni e-mail`,
"label.emailtype":`Tipo di e-mail`,
"label.appexchange.uninstallpage.message5":`Elimina definitivamente tutte le relazioni e gli elenchi correlati associati agli oggetti personalizzati in questo pacchetto`,
"label.customerinfo.applicationlicencenum":`Numero di licenze di funzioni`,
"label.product":`Prodotti`,
"lable.opppdt.selPdt.subtitle":`Selezione del prodotto per`,
"label_emailtocloudcc_step1_lead1":`Email al leader`,
"label.multilang.recentview.query":`Vedi il tuo ultimo {0}`,
"label.cumstom":`Personalizzato`,
"lable.product.pep":`Si prega di inserire il prezzo.`,
"label.suggestion":`Idee`,
"vue_label_email_sentto":`inviato`,
"label.email.cancel":`Dopo che l'associazione è stata annullata, la casella di posta non può essere utilizzata per inviare o ricevere email. Sei sicuro di voler annullare l'associazione?`,
"component_timeline_label_1monthahead":`1 mese prima`,
"setup_mainpage_label_welcome31":`Istruzioni: Clicca sul menu a sinistra di questa pagina → Gestisci impostazioni → Crea → Applicazione`,
"label.weixin.settlement.rate":`Tasso di realizzazione dell'insediamento`,
"front-lightning-module-v1-details-page-chart-add-report":` Si possono aggiungere un massimo di 4 grafici di rapporto.`,
"label_related_list_types":`Elenco correlato tipo di versione Lightning`,
"label.tabpage.converstatez":`Stato convertito`,
"label.chatter.ok":`Confermare`,
"lable.SalesCommitmentKanBan.contractRate":`Tasso firmato`,
"component.setup.label.setupsavefail":`Impossibile salvare le impostazioni del componente`,
"label.email.form.text2":`[passare a html]`,
"UG.Lead.009":`Cronologia delle chiamate APP`,
"label.escalation.setup.newrule.title":`Regola di escalation del caso`,
"label.field.available.value":`Valori di campo disponibili`,
"label.cannotuseaddtimetrigger":`<b>`,
"vue_label_chat_activefail":`Fallimento attivato`,
"label.dashboard.show.total.percent":`Mostra il totale o mostra la %, sceglierne almeno uno`,
"label.schedulejob.setup.schedule.jobprg":`Programmi di lavoro`,
"label.select.email.type":`Si prega di selezionare il tipo di email!`,
"chatter.group.allTheMembers":`Tutti i membri`,
"label.webtab.validation.apiname":`Deve iniziare con una lettera, deve contenere solo lettere maiuscole e minuscole, numeri e underscore e la lunghezza massima è di 20 caratteri, la lunghezza minima è di 2 caratteri.`,
"label_partner_new_step3_name":`Nome`,
"vue_label_chatter_remove_member":`Rimuovere il membro`,
"label.customobjects.majorobject.tip":`Se si seleziona un oggetto di relazione non principio-dettagliato, i dati di riepilogo non prendono i permessi`,
"label.forecast.edit.kjjd":`FQ`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.three":`Tre`,
"label.weixin.senderror":`Invio fallito`,
"label.visiturl":`Visita l'URL`,
"label.apply.img.error":`Il carattere inserito nel gragh non è corretto`,
"label.been.detained":`Sconto Reset`,
"vue_label_helpcenter_dashboard2":`<br> Nella dashboard appena creata, è necessario aggiungere prima i componenti e selezionare l'origine dati del report o l'origine dati della vista elenco. Quindi determinare il tipo di grafico utilizzato e selezionare il raggruppamento corrispondente e i dati statistici per creare il grafico<br> Dopo aver aggiunto i componenti, è possibile fare clic sul pulsante "Riordina" sulla dashboard per regolare la posizione e le dimensioni dei componenti. <br> Se hai bisogno di impostare condizioni di filtro temporale per alcuni componenti, puoi cliccare su "Impostazioni condizioni di filtro" per selezionare il componente e impostare il campo temporale che il componente deve filtrare. Dopo l'impostazione, è possibile filtrare per tempo sul dashboard e selezionare l'intervallo di tempo corrispondente per aggiornare i dati selezionati. <br>Nota: Un dashboard supporta fino a 10 componenti. <br> 2. Penetrazione e collegamento dei componenti<br> Nella stessa dashboard, il componente A può impostare il componente B e C dalla stessa fonte di dati come suoi oggetti di collegamento. Dopo che l'impostazione è stata completata, cliccando su un'area dati del componente A, il componente B e il componente C eseguiranno simultaneamente il riconteggio dei dati in base alle condizioni dell'area dati del componente A. <br> Si noti che cliccando sull'area dati del componente B o del componente C non causerà il riconteggio del componente A. Se avete bisogno di ottenere questo effetto, dovete impostare il componente A come oggetto di collegamento sul componente B/C. <br> Per ogni componente del grafico nel cruscotto, i dati provengono dalla vista o dal rapporto. Pertanto, viene fornita una funzione di penetrazione, cioè, facendo clic sull'area dati del componente può saltare al rapporto corrispondente e alla vista elenco. Si noti che se la fonte di dati originale fallisce, il componente non avrà dati e anche la funzione di penetrazione fallirà. <br> Poiché sia la penetrazione che il collegamento sono l'area dati del componente per il clic, non possono avere entrambi effetto allo stesso tempo. Se il componente ha sia la penetrazione che il collegamento impostati, allora il componente può avere solo una funzione in vigore allo stesso tempo, e si può scegliere la funzione in vigore commutando gli stati di collegamento e penetrazione.`,
"vue_label_commonobject_view_notice_delete_false":`I dati {0} non sono stati cancellati, il motivo è {1};`,
"label.weixin.newspaper.coverage.information":`Dettagli della scheda di rischio`,
"label.you.do.not.have.permission.to.operate.":`Non hai l'accesso per operare.`,
"label.checkfield.match":`Partita`,
"message.custom.field.donotdelete.ref":`Questo campo è referenziato da altri campi`,
"label.version.maxsum":`ha raggiunto il limite superiore.`,
"System.ChangeUser.Info.001":`Proprietario cambiato e clicca per tornare alla pagina precedente.`,
"label.target":`Obiettivo`,
"template.dashboard.behavior.analysis":`Analisi delle azioni`,
"label.login.verification.enter.prompt":`Inserisci un codice di sicurezza digitale di 6 cifre`,
"label.am":`AM`,
"chatter.emailSetUp.remark":`Consenti agli utenti di ricevere e-mail CCChat quando qualcuno ti segue, commenta il tuo post e altro ancora.`,
"label.accmarketsea.grouplist.title":`Impostazione del gruppo del pool di conti`,
"label.stdashbord.xsld.business.danwei":`Unità: 10 Migliaia`,
"label.app.step1.error.namenull":`Devi inserire il nome del gruppo pubblico.`,
"label.login.button.verification":`Invia per verificare`,
"label_tabpage_newWizardz":`Nuova funzione aggiunta guidata`,
"label.addattachment.step1.intruduce":`Inserisci il percorso del file o clicca sul pulsante per trovare il file.`,
"pagecreator.layout.funcpath":`/ costruttore / libreria di layout`,
"fourth":`Il quarto`,
"label.timetrigger.after.lasttime":`Un giorno dopo l'ultima data di modifica.`,
"vue_label_report_showme":`Mostrami`,
"label.h5.similar.opportunity.end.date.in":`La data di fine è entro il seguente periodo`,
"label.turntonextstep":`Passare alla fase successiva`,
"label.icon.106":`Programma`,
"label.user.receivenewsbulletin":`Ricevere la trasmissione di notizie`,
"label.mask.card.number":`Numero di carta di credito`,
"setup.object.layout.label.profileoptions":`Profili disponibili`,
"vue_label_systemSettings_obj":`Oggetti e campi`,
"label.call.center.history.open":`Aprire automaticamente la pagina della cronologia delle chiamate`,
"label.attendance.cityname":`Inserisci il nome della città`,
"label.newemailnotice.tip":`Crea un avviso e-mail da associare a una o più regole del flusso di lavoro o processi di approvazione. Quando si modifica un avviso e-mail, qualsiasi modifica verrà applicata a tutte le regole o approvazioni ad esso associate.`,
"label.app.step1.error.labelnull":`Error: Label non può essere vuoto.`,
"front-kefu-moudle-connect-free-account":`Associare gli utenti CloudCC agli account di prova di TRRT`,
"label.biaoqingfaxian.description":`Con il bid&tender discovery abilitato, un menu di bid&tender discovery può essere aggiunto al front-end, dove gli utenti possono visualizzare le informazioni sulle offerte dei settori rilevanti e convertire i dati delle offerte in lead nel sistema.`,
"label.filter":`Filtro`,
"label.data.downpage.e.title.num1":`1. Seleziona gli oggetti che vuoi esportare, o scegli di esportare tutti.`,
"label.h5.similar.opportunity.last.months12":`Recenti 9-12 mesi`,
"label.chatter.name":`Nome`,
"vue_label_helpcenter_email":`1. Inviare posta<br> Lasciare il sistema per andare alla tua casella di posta per comunicare con i contatti è stato superato. Su Cloud CC, puoi collegare il tuo indirizzo email personale per inviare email direttamente da Cloud CC. Quando inserisci l'indirizzo email o il nome del destinatario, può corrispondere al tuo record di contatto o di lead per te. Puoi anche associare i record di posta con i relativi record che sono stati configurati, e le mail che invii saranno sincronizzate nella pagina dei dettagli del record.<br> 2. 4 funzioni comuni durante l'invio di email<br> Quando invii un'email, puoi utilizzare le 4 funzioni sotto il testo dell'email per assistere il tuo lavoro.<br>Mail tracking<br> Quando attivi l'email tracking, ti aiuteremo a monitorare il numero di volte che questa email è stata aperta e quando è stata aperta l'ultima volta. Puoi passare il mouse sull'icona "occhio" nella lista della posta in uscita per visualizzarla.<br>Carica allegato<br> Clicca su Carica allegato, puoi selezionare il file che è stato caricato nel sistema, oppure puoi scegliere di caricare il file. Puoi selezionare più allegati, purché la dimensione dell'allegato sia inferiore a 20M.<br>Inserisci campi uniti<br> Quando l'email è associata a un record di oggetto, puoi cliccare per inserire il campo unito, selezionare l'oggetto associato, selezionare il campo che vuoi inserire, e inserire il testo di sostituzione dopo la virgola nel campo unito, come {!Contact.FirstName,Sir or Madam }. Quando salvi il modello, i campi uniti saranno visualizzati nel testo dell'email del modello. Usa i campi uniti per personalizzare il contenuto delle email. Puoi aggiungere del testo sostitutivo a qualsiasi campo unito. Il testo sostitutivo viene visualizzato solo quando il record unito non contiene i dati del campo.<br>Modifica e attiva la firma<br> Quando invii email di lavoro, una firma che possa rappresentare la tua identità aiuterà a migliorare la tua professionalità lavorativa. Fai clic sul pulsante "Modifica firma", è possibile modificare le informazioni di base, e ti supporta per inserire immagini. Se selezioni "Enable Signature", la tua firma sarà allegata al corpo del messaggio ogni volta che componi un'email. Puoi disattivare la firma in qualsiasi momento.<br> 3. Filtrare la posta in arrivo<br> Puoi filtrare tutte le mail non lette nella tua posta in arrivo per facilitare il tuo lavoro. Quando vuoi scaricare file via e-mail, puoi filtrare tutte le e-mail con allegati nella tua casella di posta, in modo da poter individuare rapidamente l'e-mail di cui hai bisogno. Inoltre, è possibile vedere rapidamente i record dei clienti nel sistema che si rintracciano attraverso le e-mail, selezionando le e-mail contenenti opportunità di business aperte o selezionando le e-mail inviate da lead o contatti.<br> 4. Mailing di massa<br> C'è un pulsante per il mailing di gruppo nell'angolo in alto a destra della lista di lead e contatti. Puoi inviare mail di massa ai potenziali clienti o ai record di contatti con indirizzi email. Quando hai un record di attività di marketing, puoi inviare email ai membri delle attività di marketing in batch, che è anche conveniente per te per inviare inviti ad eventi.`,
"front-kefu-moudle-auto-callphone":`Creazione automatica di nuovi casi per le chiamate connesse`,
"label.fiscal.FQ":`Trimestre fiscale`,
"label_tabpage_groupsVisiblez":`Alcuni gruppi di utenti sono visibili`,
"UG.product.01":`Elencare i prodotti/servizi`,
"vue_label_commonobjects_view_members":`Membri opzionali`,
"label.organization.id":`ID dell'organizzazione`,
"label.tyle_preview":`Anteprima di stile`,
"label.campaign.channel.input.to.owner":`6. Si prega di impostare se notificare i loro proprietari quando i membri della campagna si registrano:`,
"label.appointmentconfirmpage.wizard.notif1":`L'appuntamento è stato cancellato!`,
"lable.tianyancha.maping":`Mappatura del campo`,
"front-kefu-moudle-v1-noadd-online-chats":`L'agente online non viene aggiunto`,
"vue_label_commonobjects_detail_group_strategy":`Sei sicuro di inserire il cliente Team?`,
"vue_label_report_deletegrouprow":`Elimina la riga del gruppo`,
"lable.account.y.d":`Questa pagina permette di definire un record di anno fiscale personalizzato. Le date per l'anno fiscale personalizzato saranno generate in base alle scelte fatte di seguito.`,
"label.visualpage.lllegal.definitions":`Definizione non valida`,
"label.tabpage.enterrecordnamez":`Inserisci il proprietario del record`,
"vue_label_report_howmuchlines":`{lunghezza} linee`,
"homepage.components.custom":`Componenti personalizzati`,
"label.campaign.channel.upload.img":`Carica immagine`,
"UG_Case_03":`Aggiornamento automatico della cassa`,
"label.approved.receiveApprovalEmail.option4":`Mai`,
"System.Data.Import.Warning.MaxCount":`La tua organizzazione può importare solo {0} pezzi di dati alla volta, che ora è fuori dal limite, per favore regola e re-importa.`,
"label.sent.sms":`ha inviato un SMS`,
"vue_label_dashboard_statistictype":`Tipo di statistica`,
"label_report_last_year_same":`Stesso periodo dell'anno scorso`,
"lable.Examle":`Esempi`,
"label.customerinfo.PageTriggerFagTitle":`Ci vogliono due ore per sincronizzarsi.`,
"label.mobile.phone.read":`Rivedere`,
"label.product.gopage":`Vai alla pagina`,
"label.a_b_without":`I record "A" possono avere o meno record "B" correlati.`,
"front-kefu-moudle-callin-missphone":`Chiamare le chiamate perse`,
"label.sso.saml.sp.idsource.attrname":`Nome dell'attributo`,
"label.h5.chatter.colleagues2":`Colleghi`,
"label.approveprocess":`Processi di approvazione`,
"label.dataimport.error.name.null":`Errore: il nome è nullo`,
"label.paging.countitems":`{0}`,
"vue_label_report_notice_filter":`Quando il filtraggio avanzato non è abilitato, le diverse condizioni di filtraggio sono "e", cioè i record che soddisfano le caratteristiche comuni di 1 e 2 vengono visualizzati nel rapporto. Per esempio: 1 è un'opportunità di business con un importo superiore a 1 milione, e 2 è una data di contratto stimata uguale a questo mese, quindi il risultato del report è più di 1 milione di opportunità di business questo mese.`,
"front-lightning-module-v1-dashborad-export-picture":`Esportazione dell'immagine`,
"label.activity.disabled":`Nessuna attività abilitata, contatta il tuo amministratore di sistema per abilitare la cronologia delle attività e le attività non elaborate sul layout della pagina.`,
"message_chooseatleastonefield":`Seleziona almeno un campo da visualizzare.`,
"label.case.text":`I moduli di richiesta di servizio inviati attraverso il sito web possono generare record di casi nel sistema. Si prega di selezionare l'utente come creatore del record del caso, e l'utente selezionato deve avere il permesso di creazione per l'oggetto del caso. La pagina web è disponibile per computer e telefoni cellulari.`,
"label.sendmail.step3.dealoption1":`BCC me su un messaggio`,
"label.forecast.settings.title.remark":`La migliore stima delle entrate stimate per l'utente, che fornisce una visione completa del business per gli utenti`,
"label.apply.youxiaotime.finish.opperation":`Hai 5 minuti per completare le azioni. Si prega di ignorare questo messaggio se l'operazione non è di persona.`,
"label.user":`Utente`,
"pagecreator.page.button.copy":`Copia`,
"label.userinfo.pwdupdate.or.reset":`La tua password è stata cambiata o resettata l'ultima volta il`,
"label.fieldupdata":`Aggiornamenti sul campo`,
"label.sendemail.chat.followsubject":`CloudCC CCChat ha qualcuno che segue`,
"component_task_label_enddate":`Data di scadenza`,
"label.campaign.channel.step6.remark5":`Puoi riassegnarlo attraverso le Regole di assegnazione dei lead. Per saperne di più sulle Regole di assegnazione dei lead.`,
"label.mr.title.mobilePhone":`Mobile`,
"label.notice":`Promemoria`,
"message.serviceappo.time.violation":`Violazione del tempo disponibile dell'appuntamento di servizio: L'orario d'inizio dell'appuntamento di servizio è più tardivo del primo orario disponibile.`,
"label.account":`Conti`,
"front-kefu-moudle-callcenter-user":`Utenti del call center`,
"label.usermanage.query.notexist":`L'utente da interrogare non esiste.`,
"label.forecast.userinfo.isnable":`Permettere la previsione`,
"label_partner_workspace_member":`Membro`,
"vue_label_dashboard_penetrationsetting":`Impostazione della penetrazione`,
"chatter.fieldtrack.operatecreate":`ha creato un`,
"label_tabpage_tpcustomersz":`Convertire i lead`,
"label.emailtocloudcc.redmessage6":`Autenticazione IMAP/SMTP fallita, controlla che l'indirizzo e-mail e la password siano corretti.`,
"label.customfields.file.upload":`Carica`,
"label.forecast.isforecast":`Nessuna previsione abilitata`,
"label_benchmark":`Riferimento`,
"label.exchange.sync.state.system":`Stato di sincronizzazione del sistema`,
"UG.opportunity.003":`Traccia i tuoi canali di vendita, crea dashboard`,
"label.campaign.matchway.select.error":`Per aggiornare i dati, selezionare il metodo di corrispondenza`,
"vue_label_dashboard_located":`Cartella del cruscotto`,
"front-electronic-signature-enter-object":`Inserisci l'oggetto`,
"vue_label_systemSettings_mobelquick":`Configurazione rapida delle applicazioni mobili`,
"lable.outlook.list":`Configurazioni di sincronizzazione di Exchange`,
"label.sendemail.approval.dlsp":`Ciao, #dlspr:\n #actorname#objapiname-#recordname presentato da #actordate è stato impostato come tuo approvatore proxy dall'approvatore originale #spr ed è in attesa della tua approvazione.\nper favore clicca sul link sottostante o accedi al sistema crm per entrare nel centro di approvazione per l'approvazione:\n#url\n grazie! \n#orgname`,
"label.service.deleteCustomView.wanttoremove.filter":`Sei sicuro di voler rimuovere il filtro "{nome}"?`,
"component_task_label_newevent":`Nuovo compito`,
"vue_label_commonobjects_view_chart_groupby":`Gruppo per`,
"front-kefu-moudle-v1-edit-chats":`Modifica agente`,
"pagecreator_page_message_delete_fail":`Cancellazione della pagina non riuscita`,
"label.file.search":`Cerca file...`,
"label.projectManagement.Addpredecessors":`Aggiungere il pre-compito`,
"label_tabpage_norecordtypez":`Tipo di record inutilizzabile`,
"label.come.recycle.bin":`Vai al Cestino`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.relative":`Relativo`,
"label.customfields.address.tip":`Permette all'utente di selezionare i campi provincia, città, contea e di inserire informazioni specifiche sull'indirizzo che possono essere usate per calcolare la latitudine e la longitudine.`,
"label.weixin.optioneight":`Scelta 8`,
"label.recordtypeselect.modify":`Modifica del tipo di record`,
"label.forecast.settings.future3":`Futuro 3 cicli`,
"label.rename":`Rinominare`,
"label.emailtocloudcc.button.complete":`Finitura`,
"chatter.new.at":`Attività più recenti`,
"component.setup.label.milestonesfield":`Campo pietra miliare`,
"vue_label_commonobjects_detail_email_newaddress":`Invia a`,
"lable.PowerProcess.big.event":`Pietra miliare:`,
"label.appexchange.uninstallpage.confirm":`Sì, voglio disinstallare questo pacchetto ed eliminare definitivamente tutti i componenti associati`,
"label_mobile_buttom_homepage":`Homepage`,
"label.sso.saml.idp.config.logouturl":`URL di logout singolo`,
"lable.quote.pdf.button.savetoquote":`Salva per quotare`,
"label.page.select.application":`Seleziona le app personalizzate in cui vuoi usare le nuove schede personalizzate. Puoi anche vedere o modificare se una scheda appare nella pagina dei dettagli e nella pagina di modifica di ogni app personalizzata.`,
"chatter.down":`Scaricare`,
"label.tabpage.searchz":`Cerca`,
"label.emailsync.form.action":`Azione`,
"label.campaignmember.setup.campaignmember.field":`Campi di membri della campagna`,
"label.version.remark":`Nota: la Free Edition permette di creare solo 5 utenti, 2000 record e non si possono importare o esportare dati.`,
"label.selectoperateobject":`Selezionare l'oggetto.`,
"label.appointmentdetail.wizard.title12":`Tempo di libri`,
"label.submitforapproval":`Presentare per l'approvazione`,
"label.the.lower.bound.of.each.layer.of.editing.discount.must.be.equal.to.the.upper.bound.of.the.upper.level.":`Il limite inferiore per la modifica di ogni livello di sconto è uguale al limite superiore dell'ultimo livello.`,
"label.appupload.install.component.view":`Componenti delle viste`,
"label.profile.customobjcontrol":`Permessi per gli oggetti personalizzati`,
"label.customfields.configprofilefieldsafety.tip":`Seleziona i profili a cui vuoi concedere l'accesso di modifica a questo campo tramite la sicurezza a livello di campo. Il campo sarà nascosto da tutti i profili se non lo aggiungi alla sicurezza a livello di campo.`,
"label.service.gantt.service.resources":`Risorse di servizio`,
"label.input.right.emailaddress":`Si prega di inserire l'indirizzo e-mail non valido.`,
"label.ccdocument.folder.notedit":`La cartella non è modificabile.`,
"label.data.choses.i.desc":`Secondo le vostre esigenze, importate i dati da un singolo oggetto.`,
"label.icon.75":`Auto`,
"label.summaryreport.step4":`Passo 4 Scegliere le colonne del rapporto`,
"label.appupload.upload.install":`Installare`,
"label.reportlist.newfolder":`Nuova cartella dei rapporti`,
"label.projectManagement.myproject":`Il mio progetto`,
"label.true":`VERO`,
"label.tabpage.reallproplez":`Proprietario del disco`,
"label.change.lead.share.error":`Nessun diritto di modificare il cliente`,
"F":`Data/ora`,
"lable.account.CurrentandNextCQ":`CQ attuale e prossimo`,
"UG.activity.06":`Vuoi seguire i conti`,
"UG.contact.03":`Traccia i contatti in un unico posto, segnali di vendita`,
"label.field.duplicate.error.msg2":`Impostazione della proprietà unica non riuscita`,
"label.sales.dashboard.reality":`Pagamenti effettivi`,
"lable.PowerProcess.type":`Tipi di processo di abilitazione`,
"batch.selected.data":`Dati selezionati:`,
"#label.importsourcefilestep2":`Passo 2 Comprimere il tuo file (opzionale)`,
"label.emailtemplate.select":`Scegli il modello di e-mail che vuoi utilizzare.`,
"chatter.most.w":`Puoi inserire fino a 500 caratteri`,
"vue_label_calendar_new_object_calendar":`Calendario dei nuovi oggetti`,
"label.aggregated_formsdata":`Dati aggregati dei moduli`,
"label.knowledge.language.french":`Francese`,
"label.customfields.enc.tip":`Permette agli utenti di inserire qualsiasi combinazione di lettere e numeri e memorizzarli in forma criptata. E non possono essere ricercati.`,
"label.icon.158":`Cloud`,
"font-evaluate-module-v1-bad-review ":`Quando il tipo di valutazione è Negativo`,
"UG_quota_03":`Modello di citazione`,
"label.eidt.queue.label.hasused":`L'etichetta è già in uso`,
"label.lookupfilter":`Filtri di ricerca`,
"label.callcenter.Instance.name":`Nome dell'istanza`,
"label.commitertype":`Tipo di presentatore`,
"vue_label_checkduplicate_any_one":`Incontrare uno qualsiasi`,
"label.campaign.channel.input.img":`Seleziona l'immagine dal tuo computer locale come pagina di ringraziamento`,
"vue_label_dashboard_pleaseenterafoldername":`Inserisci il nome di una cartella`,
"label.tianyancha.look":`Vedi`,
"label.tabpage.lastone":`Seleziona almeno un'operazione`,
"label.sendemail.approval.submit.title":`{!objLabel} - {!recordName} sta aspettando la tua approvazione`,
"label.chat.topic.delete.prompt1":`Cancellare un argomento richiede tempo, l'argomento continuerà ad essere conservato nei post e nelle registrazioni fino a quando il processo non sarà completato.`,
"component_setup_label_displaybutton":`Pulsante di visualizzazione`,
"label.partnerCloud.backgroundImage":`Immagine di sfondo`,
"label.mobile.phone.time.range":`Intervallo di tempo`,
"label.page.url.address.remark":`Inserisci l'indirizzo della pagina web nel campo "Link URL". Puoi inserire un semplice URL così come appare nella barra degli indirizzi del browser, oppure puoi usare uno o più campi di unione per inserire dati specifici dell'organizzazione da CloudCC.com nei parametri dell'URL. Alcuni siti potrebbero non funzionare in una scheda web a causa delle impostazioni di sicurezza del browser, o perché il sito ha impedito di essere visualizzato in un frame.`,
"label.h5.copyemail":`L'e-mail è stata copiata`,
"label.view.step3":`Passo 3 Selezionare i campi da visualizzare`,
"label.quickbooks.view.moneyreceived":``,
"label.emailobject.attachment.preview":`Anteprima`,
"label.selectapprover":`Seleziona l'approvatore`,
"vue_label_normal_opportunity_sf":`Opportunità`,
"label_emailtocloudcc_filed_port":`Porto`,
"mesage.errorinsaving":`Si è verificato un errore durante il salvataggio. Per favore contatta il tuo amministratore.`,
"label.partnerCloud.partnerCloudName":`Inserisci il nome della nuvola partner`,
"lable.edit.queue.checkemail":`Errore: Indirizzo e-mail non valido.`,
"label_builder":`Costruttore di pagine`,
"component_setup_label_setupsavefail":`Impossibile salvare le impostazioni del componente`,
"label.icon.76":`Auto`,
"label.reportsSubscriptionPage.schedulereport.monthly":`Mensile`,
"message.nopermession":`Nessun permesso`,
"label.view.groupscansee":`Visibile a <b>certi gruppi di utenti</b>`,
"label.leadscore.rule.new":`Regola di valutazione dei lead: Nuova regola`,
"label.new.ccpeakfolder.time":`Classi programmate: Nuova cartella`,
"label.record":`Record`,
"message.error.flabel":`Le etichette di campo che hai fornito non possono contenere virgolette inglesi singole o doppie.`,
"label.emailobject.emaildetail.promptbutton2":`Cancella`,
"label.h5.phone":`Chiama`,
"label.visualpage.error.deal.with":`Si è verificato un errore, per favore contatta il tuo amministratore`,
"label.button.step1.select.field":`Passo 1 Selezionare i campi`,
"label.setsharerule.step1":`Passo 1 Selezionare il tipo di regola`,
"component.chatter.file.label.title":`Caricamento dei file`,
"front-epwechat-module-v1-appname":`Nome dell'applicazione`,
"chatter.error.notsel":`Errore:Si prega di selezionare un'immagine da caricare.`,
"label.updatevalue":`Valore esatto che cambia da`,
"label.chatter.sendEmailToGroupMember.subject.D":`{0} ha pubblicato documenti per tutti in {1}`,
"label_tabpage_grid":`Il display a griglia`,
"homepage.components.standard":`Componenti standard`,
"label.movable":`Attività`,
"label.report.selected.field.cannot":`I campi selezionati non possono superare i 50.`,
"label.projectManagement.distribution.by.excess":`Assegnare in base allo straordinario`,
"addrow":`Aggiungi riga`,
"label.approvaldatamove.p":`Usa le seguenti opzioni per gestire più richieste di approvazione. Clicca su "Trova" per filtrare le richieste di approvazione. Quando i risultati vengono visualizzati in una vista elenco, specifica l'azione.`,
"label.passwordPolicy.setup.title":`Politiche sulle password`,
"label.appointmentpage.wizard.title1":`{0} ({1}) vi invita a`,
"label.tippage.li1":`Cancellare definitivamente l'origine dati del rapporto personalizzato`,
"label.campagin.roi.dcl":`Tasso di partecipazione`,
"label.h5.new.errorbody":`Questi campi obbligatori con * devono essere completati.`,
"label.cy.enable":`Abilitare la valuta`,
"label.currency.rate.e":`Modifica i tassi di conversione per le valute della tua organizzazione.`,
"or":`Oppure`,
"lable.custom.Previous.CYt":`Precedente 2 CY`,
"front-epwechat-module-v1-unbound-desc":`Remove binding cancellerà l'account vincolato. Sei sicuro di voler togliere il vincolo?`,
"pagecreator_button_publish":`Pubblica`,
"font-evaluate-module-v1-case-owners":`Notifica al proprietario del caso:`,
"label.pw.new":`Inserisci una nuova password`,
"message.tabsearch.nokeywords":`Inserisci una parola chiave di almeno un carattere`,
"label.sendemail.send.erroruser":`Utente errato`,
"label.personalinfo":`Le mie informazioni personali`,
"label.case":`Casi`,
"lable.product.pricebooks.now":`Libri dei prezzi esistenti`,
"label.ccpeak.take.notice":`Nota: ID, Auto Number, Created By, Created Date e altri campi di sistema non hanno bisogno di inserire i valori.`,
"label.page.first":`La 1a pagina`,
"label.icon.168":`Mire`,
"label.choices":`Seleziona`,
"label.is.delete.document":`Sei sicuro di voler cancellare questo file?`,
"homepage.layout.custom":`Layout personalizzati`,
"label.emailobject.template.insert.field":`Campi`,
"label.ccpeak.folder.all":`Tutte le cartelle di classe`,
"front-console-conversation-btn3":`Inoltrare l'email`,
"label.ems.port":`Porto`,
"label.app.introduce":`Un'app è un gruppo di schede che lavorano come un'unità per fornire funzionalità. Gli utenti possono passare da un'app all'altra usando il menu a tendina delle app nell'angolo in alto a destra di ogni pagina.`,
"label.file.library.managemembers.admin":`Amministratore della biblioteca`,
"vue_label_salesadvance_win":`Won`,
"label.email.click.complete.info":`Clicca sul pulsante "fine" per tornare alla pagina precedente.`,
"label.umeng.activity.event.willbegin":`Il tuo evento #evento inizia nel #tempo.`,
"label.mobile.phone.week.summary":`Riassunto settimanale`,
"label.quickbooks.fieldlabel.terms":`Termini`,
"lable.currencyManage.advcurrencyEnabled.dis":`Permette di gestire i tassi di cambio datati che mappano un tasso di conversione della valuta ad un intervallo di date specifico. I tassi di cambio datati sono applicati ai campi di valuta sulle opportunità, sui prodotti di opportunità e sui rapporti associati a questi due oggetti.`,
"label.weixin.data.save.failed":`Mancato salvataggio dei dati.`,
"label.service.gantt.filter.logic":`Logica del filtro:`,
"vue_label_pool_adopt":`raccogliere`,
"label.emailobject.markasunread":`Segna come non letto`,
"label_please_select_a_member":`Si prega di selezionare i membri.`,
"label.salescloud.unit.ci":`Unità (tempo)`,
"vue_label_pool_obsolete":`scartato`,
"label.cancelall":`Deseleziona tutto`,
"label.exchange.sync.state.setting.m2":`Utenti nelle configurazioni attive di CloudCC Exchange:`,
"vue_label_pool_claimtime":`Tempo di reclamo`,
"label.forecast.forehistory.history":`Storia delle previsioni`,
"label.knowledge.article.record":`L'articolo sulla conoscenza non è qualificato.`,
"label.setting.intergrationlist.button.uninstall":`Disinstallare l'integrazione`,
"label_tabpage_gotit":`Capito`,
"label.data.exp.csvform":`Valido solo per i dati esportati.`,
"UG.Forcast.06":`Seleziona gli utenti che sono autorizzati a fare previsioni`,
"vue_label_report_savereport":`Salvare il rapporto`,
"setup.object.field.dependency.label.mustone":`Dovete selezionare almeno 1 valore del campo dipendente.`,
"label.batchadd.newbatchpage.des1":`Il campo Name del record è richiesto, e se non lo è, il record non viene salvato.`,
"lable.custom.CurrentandPreviousCYt":`Attuale e precedente 2 CY`,
"label.versiontype.Professional":`Edizione professionale`,
"label.customfields.configprofilefieldsafety":`Stabilire la sicurezza a livello di campo`,
"label.ccpeak.wgd.time":`Classi programmate non compilate`,
"component.telerecord.label.subject":`Tema`,
"label_year":`Anno`,
"pagecreator_layout_label_modifylayout":`Editor di layout`,
"label.compact.layout.frame.splitline":`Linea di separazione dello schermo destro e dello schermo sinistro`,
"lable.PowerProcess.enter.the.process":`{descrivereNome} Processo di ingresso`,
"label.emailobject.cc":`Cc:`,
"front-electronic-export-choseCount":`Seleziona i dati importati`,
"label.setup.mobile.bottombutton.recovery.default.success":`Ripristinato con successo lo stato di default`,
"label.datamanage.import.accountfield":`Seleziona i campi del file di importazione che devono essere importati in ogni account dalla lista sottostante. Poi clicca su "Next Step":`,
"vue_label_opportunity_related_list":`Aggiungi alla lista correlata`,
"label.group.recent":`Gruppi visti di recente`,
"vue_label_pool_finalclaimtime":`Tempo di reclamo finale`,
"vue_label_homepage_30daysnocontact":`Opportunità di business senza contatto per 30 giorni`,
"label.tianyancha.field.error":`I dati di Tianyancha non sono stati trovati, si prega di contattare l'amministratore di sistema per eseguire l'inizializzazione`,
"label.product.go":`Vai ai rapporti`,
"label.customsetting.manage.introduce":`Se l'impostazione personalizzata è un elenco, fare clic su Nuovo per aggiungere un nuovo set di dati. Ad esempio, se l'applicazione ha un'impostazione per i codici paese, ogni set potrebbe includere il nome del paese e il codice di composizione.`,
"label.task.dateadd":`Più`,
"label.email.recipients.select":`Seleziona i destinatari`,
"chatter.emailListMyChat":`Mi piace un post o un commento che ho fatto`,
"label.batchadd.newbatchpage.save.name":`Se il nome è nullo, il sistema non aggiungerà questo record per default, assicurati che il nome non sia nullo e poi salva.`,
"UG_Lead_011":`Creare un indizio`,
"vue_label_salesfunnel_notice2":`Totale delle opportunità in corso`,
"APPIntegration_Social_linkedinerror":`Devi inserire un URL valido per linkedin.com`,
"label.industrialandcommercialverification.enablestatus2":`Query in tempo reale Nome del conto`,
"label.stdashbord.xsld.business.ajssx":`Per ruolo`,
"lable.info.queue.showalluser":`Visualizza tutti gli utenti`,
"label.generatepage.c1":`Deve iniziare con una lettera e contenere solo lettere maiuscole e minuscole, numeri e underscore.`,
"label.thenset":`E poi secondo`,
"label.salescloud.salescloud.defaultteam":`Gruppo di opportunità predefinito di utenti`,
"label_partner_workspace_tab_selectedoption":`Schede selezionate`,
"label.tippage.li":`Elimina l'origine dati del rapporto personalizzato:`,
"lable.quote.syncingfrom.syncingto":`I prodotti di opportunità sono stati sincronizzati con le voci di preventivo`,
"label.emailobject.delete":`Cancellare`,
"label.data.selectimportobject":`Seleziona gli oggetti da importare`,
"label.knowledge.language.dutch":`Olandese`,
"message.campaign.page.overtime":`La pagina è scaduta.`,
"label.ccchat.message.search.desc4":`Controlla l'ortografia delle parole di ricerca.`,
"label.login.forgetPsd":`Dimenticare la password`,
"vue_label_title_order":`Ordina`,
"template.report.contract.follow.status":`Followup Stato del contratto`,
"label.forecast.edit.kjnd":`Anno fiscale`,
"front-electronic-export-listTitle":`Lista Mailchimp`,
"label.dataimport.error.khmc.notnull":`Errore: è necessario inserire il nome dell'account`,
"label.testobject":`Oggetto del test`,
"label_chatter_nextStep":`Prossimo passo`,
"label.file.public.link.share":`Condivisione pubblica dei link`,
"label.weixin.organization.name":`Nome dell'organizzazione`,
"label.quote.email":`Email`,
"label.reg_field":`Campo regolare`,
"font-evaluate-module-v1-response":`Risposta dopo la valutazione:`,
"label.chatter.sendmail":`Inviare e-mail`,
"label.weixin.start.incorrect":`Formato non valido della data di inizio`,
"component_chatter_link_label_url":`Link url`,
"vue_label_pool_operatecertification1":`{0}{1}{2}`,
"lable.currencyManage.Enabledadvcurrency.agree":`Sì, voglio abilitare la gestione avanzata della valuta.`,
"label.east.africa.time":`Ora dell'Africa orientale`,
"label.product.proof.Three":`In {0}, scegli un minimo di {1} opzioni di prodotto, ma fino a {2}.`,
"label_emailtocloudcc_filed_password":`Password`,
"component.task.label.person":`* Persona assegnata`,
"pagecreator_systemstyle_label_buttonareacolor":`Colore dell'area operativa`,
"label.clearrule":`Regole chiare`,
"lable.customer.access":`Permesso di accesso all'account`,
"label.finish.wait":`La tua richiesta è stata elaborata, fai attenzione a controllare la notifica di completamento nella tua casella di posta elettronica.`,
"label.weixin.appr.auditor":`Approver`,
"label.tabpage.systemz":`Sistema/i`,
"label.file.nocan.process.desc":`Impossibile elaborare la richiesta. non possiamo gestire la consegna del contenuto`,
"label.relationobject.name":`Nome dell'oggetto correlato`,
"setup.layout.group.relatedlist":`Elenchi correlati`,
"label.generatepage.title":`Da web a pagina CloudCC`,
"label.page.step3.input.url.information":`Passo 3 Inserire i dettagli dell'URL`,
"label.change.to":`Cambia lo stato di membro della campagna a`,
"label.validate.function.funcFormat.TIMEVALUE":`VALORE DEL TEMPO(data)`,
"label.partnerCloud.seriesSettings":`Impostazione della famiglia di prodotti`,
"component.timeline.label.1monthahead":`1 mese prima`,
"label.batchadd.senumberpage.selnum":`Seleziona il numero di record da aggiungere`,
"label.downloadapp":`DISPONIBILE SU`,
"label.dashboardSetup.showmainpage":`Visualizzato sulla Homepage`,
"label.h5.nophoneprompt":`Il collega non ha inserito il numero di contatto`,
"label.service.deleteCustomView.wanttoremove.theFilter":`Vuoi cancellare il filtro "{nome}"?`,
"label.appupload.state1":`Caricato`,
"component_timeline_button_filter":`Filtro`,
"label.passwordPolicy.setup.subtitle":`Imposta le restrizioni della password e le politiche di blocco del login per tutti gli utenti.`,
"vue_label_normal_quote_sf":`Cita`,
"label.productsales.today.noevttskaddall":`Non ci sono eventi aperti e compiti in scadenza, puoi cliccare su " " in alto a destra per aggiungere nuovi eventi e compiti.`,
"label.projectManagement.no.end.date":`Nessuna data di fine`,
"label.sendmail.batch.chosetemplate":`Email di massa: Seleziona un modello`,
"serviceterritorymember.serviceresource.isactive.notactive":`Questa risorsa di servizio non è abilitata. Puoi assegnare i territori di servizio a una risorsa di servizio abilitata.`,
"label.notification.event.overlapEvent.continue":`Continua`,
"label.appupload.component.type.obj":`Oggetto personalizzato`,
"label.partnerCloud.financeSetting.basicConfiguration":`Percorso di accesso: Piattaforma pubblica  Sviluppo  Configurazione di base`,
"lable.outlook.detail.info":`Dettagli della configurazione della sincronizzazione di Exchange`,
"vue_label_commonobjects_detail_activity_commingevents":`Prossimo evento disponibile`,
"coderules.nullvalue2":`Impossibile generare. Inserisci il valore per 【{0}】,【{1}】 usato nelle regole di generazione.`,
"label.version.sum.workflowrule":`regola(e) del flusso di lavoro`,
"label.sso.saml.idp.config.enable":`Abilitare il fornitore di identità`,
"label.temp.exp.conf":`Sei sicuro di voler esportare il modello?`,
"label.department":`Dipartimento`,
"label.trigger.operation.email.template":`Ottenere informazioni sui modelli di e-mail`,
"label.page.content.frame.height":`Altezza della cornice del contenuto (pixel)`,
"label.ServiceCloud.jinengyaoqiu":`Competenze richieste`,
"PageLayout.Search.MultiSearch.001":`Seleziona fino a 3 campi.`,
"label.error500":`Oops! Errore...<br />Per favore contratta l'amministratore...`,
"label.appexchange.download.stop":`Fermare l'installazione con conflitto`,
"label.service.dispatchingUnits.left.right.totalAll":`Attualmente {left}-{right} record, {totalCount} record in totale.`,
"label.tabpage.haschangedz":`Questa pista è stata convertita`,
"label.industrialandcommercialverification.button.cancel":`Cancella`,
"label.edit.role":`Modifica del ruolo`,
"label.mr.descreption.condition2":`Regole in base ai primi caratteri: inserire un numero, trovare i duplicati in base ai primi caratteri del numero inserito.`,
"label.testgrammer":`Controllare la sintassi`,
"label.age":`Età`,
"lable.real.time.chat":`Il supporto tecnico della chat in tempo reale è fornito da Easemob. Si prega di configurare la configurazione avanzata in Easmob.`,
"vue_label_opportunity_selected":`{sum} selezionato`,
"label.weixin.optionone":`Scelta 1`,
"label.file.delete.public.link.desc":`Cancellare il link pubblico significa che nessuno può accedere al file con quell'url.Se ne crei uno nuovo, sarà un URL diverso.`,
"label_tabpage_cancel":`Cancella`,
"template.report.opportunity.analysis":`Analisi della fase di opportunità`,
"label.escalation.setup.newrule.inputrule":`Inserisci il nome della regola`,
"label.ccpeak.getapi.name":`Indirizza il nome API del campo mentre ottiene il valore del record:`,
"second":`Il secondo`,
"label_tabpage_uploadsz":`Carica`,
"label.description":`Note`,
"label.ccchat.person.invite.notsamepwd":`Password incoerente`,
"label.mobile.app.isEnableAblumWatermark":`Aggiungere la filigrana alla foto selezionata dagli album mobili al momento del checkin`,
"vue_label_allsearch_searchable_items":`Elementi Ricercabili`,
"lable.outlook.detail.react":`Attività recenti`,
"label.sales.team":`Squadra delle opportunità`,
"label.guif.standard.time":`Ora solare del Golfo`,
"label.emailobject.emaildetail.button.forward":`Avanti`,
"label.refused":`Rifiutato`,
"homepage.components.one":`Passo 1 Inserire il nome del componente personalizzato`,
"day":`Giorno`,
"label.dataimport.error.number":`Errore: Numero`,
"label.customer.tab.step2.same.option2":`Predefinito Off`,
"component_button_ok":`Confermare`,
"label.allrecordmeetprocess":`Tutti i record dovrebbero entrare in questa fase`,
"label.version.onefile.size":`Dimensione di ogni allegato caricato`,
"label.partnerCloud.orderingPlatform.allProducts":`Tutti i prodotti`,
"pagecreator.page.message.publish.success":`Pagina pubblicata con successo`,
"lable.currencyAdv.exchagecurrency.rate.pro":`Gamma precedente`,
"label.attendance.persons":`Utenti adatti`,
"label.send.an.email":`Invia un'e-mail`,
"registration.page.browser.title":`Registrazione del canale marketing di Campagin`,
"label.importfilestep3":`Passo 2 Selezionare e caricare i file`,
"lable.currencyAdv.exchagecurrency.rate.next":`Prossima gamma`,
"label.ems.no.sync.msg":`Non hai ancora configurato le informazioni sulla sincronizzazione della posta.`,
"label.total_views":`Anteprima di presentazione del modulo`,
"label.knowledge.article.notnull":`Si prega di scegliere almeno un articolo.`,
"message.error.view.lastview.delete":`Impossibile eliminare l'ultima vista di lista pubblica</br>Non è possibile eliminare l'ultima vista di lista pubblica visibile a tutti gli utenti.<br><br>`,
"label.integrations.second.half":`di dati, selezionare i dati importati`,
"vue_label_systemSettings_mobelparams":`Impostazione dei parametri dell'applicazione mobile`,
"message.choose.maximum":`Puoi scegliere fino a 150 record da condividere, ora`,
"vue_label_homepage_won&unprocessed":`Aperto Non elaborato`,
"UG.contact.01":`Come sfruttare al massimo i tuoi contatti?`,
"label.data.import.setup.remark":`L'amministratore può impostare le regole da eseguire durante l'importazione dei dati, incluso se eseguire le regole di convalida, i trigger e le regole di duplicazione e corrispondenza.`,
"pagecreator_layout_message_delete_success":`Layout cancellato con successo`,
"lable.account.name":`Nome del trimestre fiscale`,
"label.userinfo.must.updatepwd":`Per sicurezza, devi cambiare la tua password.`,
"label.mobile.phone.subordinate.setup":`Non può essere impostato per contenere i subordinati, per favore seleziona tutti e impostali per consentire le previsioni.`,
"label.monitorsys.delete.date":`Cancellare la data`,
"label_emailsync_form_emailaddress":`Indirizzo e-mail`,
"label.projectManagement.cancelled":`Annullato`,
"label.partnerCloud.partnerAccount.rechargeAmount":`L'importo della ricarica deve essere compreso tra 0,1 e 100000000.`,
"label.select.relatedlist.approval.layout":`Seleziona gli elenchi correlati da visualizzare nel layout della pagina di approvazione`,
"label.userphoto.thumbnail":`Miniatura`,
"label.assignment.setup.list.rulename":`Nome della regola`,
"label.emailtemplate.usemergefields":`Unire i campi in un modello di e-mail`,
"label.tabpage.enabletomobile":`Se abilitare il lato mobile`,
"setup_layout_label_desc":`Discendente`,
"vue_label_pool_abandonreasondiscription":`Descrizione del motivo di scarto`,
"label.ems.outputmails":`Inviare il server di posta elettronica (smtp)`,
"font-evaluate-module-v1-evall":`Tutta la valutazione`,
"front-epwechat-module-v1-unbound-tips":`I seguenti dati saranno cancellati dopo lo scollegamento:`,
"label.weixin.number.data":`Dati`,
"front-objectTemplate-V1-UseObject":`Oggetto applicabile`,
"label.call.center.configuration":`Impostazioni del call center`,
"vue_label_systemSettings_website":`Portale web del servizio clienti`,
"lable.currencyAdv.foreverdate":`Data permanente`,
"label.globalselect.view":`Visualizza il set di valori dell'elenco delle opzioni`,
"component_newrecords_label_title":`Record recenti`,
"component_assistant_label_title":`Assistente`,
"label.equals.deletebut.bulk.delete":`Include il pulsante di cancellazione, la cancellazione di massa (nel Cestino)`,
"label.field.duplicate.error.msg4":`Errore:Dati non validi.`,
"label.input.right.date":`Inserisci il formato di data valido`,
"file.error.notsel":`Errore: selezionare il file da caricare`,
"label.customcomponent.page.add.title":`Nuovo componente personalizzato`,
"message.chooseatleastthreefield":`Scegliere almeno 3 campi`,
"label.dataimport.system.unnecessary":`il sistema non può determinare diversi`,
"message.login.wrong":`Nome utente o password errati.`,
"label.appupload.install.recheck":`Controlla di nuovo`,
"label.ems.option":`Opzione`,
"label.wei.subject.img":`Oggetto lcon`,
"chatter.emailReceiveOrNotAccept":`Seleziona questa opzione per consentire il promemoria di CCChat, deselezionando questa opzione si impedisce di ricevere il promemoria di CCChat.`,
"label.icon.46":`Forno`,
"label.newpw":`Nuova password`,
"font-evaluate-module-v1-praise":`Il tipo di valutazione è Positivo`,
"label.help.user":`Guida per l'utente`,
"label.callcenter.no.searchs":`Nessuna domanda pertinente alle informazioni`,
"UG_homepage_007":`Dall'invio di email di follow-up all'automazione delle campagne di vendita, dalla creazione di flussi di lavoro utilizzando la nostra tecnologia Blueprint all'attivazione di macro personalizzate, automatizza i compiti quotidiani e concentrati maggiormente sulla costruzione di relazioni.`,
"label.saveandnew":`Salva`,
"component_salesperformance_label_70finish":`Finito - non trasformato (>70%)`,
"lable.account.dp":`Questa pagina permette di definire anni fiscali personalizzati.`,
"label.notification.serviceappointment.injeopardy":`{1}{0} è in stato critico. Si prega di processare il prima possibile`,
"label.workflow.edit.esimaterule":`Errore: non puoi cambiare il criterio di valutazione in "ogni volta quando crei o modifichi un record" mentre hai dei trigger temporali associati a questa regola.`,
"label.partnerCloud.basicSetting.feature":`Impostazioni funzionali`,
"label.sms.companyname.gm.infor":`C.M.W.L.SMS Info (Questo servizio supporta solo la Cina continentale)`,
"vue_label_homepage_components":`Selezionare i componenti`,
"label_chatter_allactivity":`Tutte le attività`,
"label.quickcreate.title":`Creazione rapida di layout`,
"label.tabpage.exclusivez":`Escludi`,
"front-service-cloud-transfer-desc":`Quando si trasferisce il proprietario della distinta dei beni, il bene corrente e i beni propri sotto il bene saranno cambiati proprietario`,
"label.data.downpage.i.list.desc1":`Durante l'importazione, i dati che non sono importati con successo perché i dati non sono formattati correttamente, o perché il trigger o la regola di convalida non riescono, generano il file CSV da visualizzare nella pagina corrente. I dati importati con successo non saranno visualizzati nella pagina corrente.`,
"template.report.individual.case.status":`Stato dei casi`,
"label.report.export.file.format":`Formato: Formato Excel .csv`,
"vue_label_filternotice1":`Cioè, ogni condizione di filtro è soddisfatta allo stesso tempo, per esempio: 1 opportunità di business con un importo maggiore di 1 milione di opportunità di business, 2 è un'opportunità di business con una data di contratto stimata uguale a questo mese, e il risultato dello screening mostra opportunità di business maggiori di 1 milione questo mese; quando <span style="color: red">il filtro avanzato è attivato</span> Quando è necessario filtrare manualmente le condizioni nella casella del filtro avanzato`,
"label.lead.score.confirm1":`Questo può richiedere diversi minuti. Riceverai un'e-mail di conferma una volta completato.`,
"label.scores":`Punteggi`,
"label.dashboard.message.mainnoset":`Il cruscotto di casa non è configurato`,
"label.customfields.optionlist.fieldvaluelist":`Inserisci i valori, con ogni valore separato da una nuova linea`,
"label.autosearch.title":`Completa la ricerca del titolo automaticamente`,
"label.knowledge.setting.hint.seventeen":`Creare alcuni articoli`,
"label_tabpage_closez":`Chiudere`,
"label.partnerCloud.orderingPlatform.shoppingCart":`Carrello`,
"label.recalculate":`Ricalcolare`,
"label.umeng.approval.approvalmes4obj":`#numsucc records sono stati approvati in #obj, #numfailed reocrds non sono stati approvati.`,
"label.appointment.wizard.subtitle2-2":`A`,
"label.validate.function.funcExplain.AND":`Controlla se tutti i parametri sono veri. Restituisce TRUE se tutti i parametri sono veri.`,
"label.recordtype.batchaddattachments.remark":`Passo 1 Scegliere il file, Passo 2 Archivio, Passo 3 Fare clic sul pulsante "start upload", caricare i file, Passo 4 Fare clic sul pulsante per finire.`,
"label.reportlist.findreport":`Trova rapporti`,
"label.partnerCloud.financeSetting.enterAppsecret":`Inserisci l'Appsecret`,
"label.campagin.roi.query2":`Visualizza il ROI dei canali di marketing`,
"label.sendmail.notice.immediately":`Inviare notifiche via e-mail`,
"label.file.library.managemembers1":`Gestire i membri`,
"label.forecast.customforecast.foredis.yclb":`Categoria di previsione`,
"label.no.target.model.available.":`Nessun modello di indicatore disponibile. Si prega di creare prima il modello di indicatore o di contattare l'amministratore del sistema.`,
"label.quote.contactname":`Nome del contatto`,
"label.customer.tab.step2.same":`Applica la visibilità di una scheda a tutti i profili`,
"UG_product_03":`Manuale dei prezzi supportato da più valute`,
"label.pc.system.prompt":`Prompt di sistema`,
"homepage.components.description":`Descrizione del componente`,
"front-email-payment-safety-code":`Codice di sicurezza`,
"label.the.extra.reward.group.describes":`Aggiungere la descrizione del gruppo di linee di citazione`,
"label.isEnableVisualpage.new.rightlist":`Pagine personalizzate attive`,
"label.icon.84":`Trasformatore`,
"label.chat.message.to":`Destinatario`,
"lable.product.pricebooks.edit":`Modifica del libro dei prezzi`,
"label.partner.workspace.member.belong":`Appartiene a`,
"pagecreator_systemstyle_message_delete_success":`Stile cancellato con successo`,
"label.salescloud.teamrole.message.chooseatleastone":`Si prega di selezionare almeno un utente.`,
"label.knowledgebase.self.window":`Finestra identica`,
"label.product.cost":`Costo`,
"label.imgfield.remove":`Immagini chiare`,
"label.event.lastweek":`La settimana scorsa`,
"template.report.today.statistics":`Vendite di oggi`,
"label.emailobject.recipients":`Destinatari({0})`,
"vue_label_commonobjects_view_successfully":`Impostare la vista predefinita con successo`,
"label.uploadfail.typeerror":`Caricamento fallito, il tipo di file non è valido.`,
"vue_label_lead_required_fields":`Si prega di compilare i campi richiesti`,
"front-console-reopen":`Riaprire`,
"message.layout.unique.relatedlist":`Ritornate ai vincoli unici della lista correlata nel layout della pagina, confermate e salvate di nuovo.`,
"label.emailobject.emaildetail.nextactivity":`Prossime attività`,
"label.publicgroup.save.error":`Errore: uno dei seguenti gruppi è già il gruppo padre di questo gruppo`,
"label.editdefaultshare.tip":`Modifica le impostazioni predefinite di condivisione a livello di organizzazione qui sotto. La modifica di queste impostazioni predefinite causerà il ricalcolo di tutte le regole di condivisione. Questo potrebbe richiedere notevoli risorse di sistema e tempo a seconda della quantità di dati nella tua organizzazione.`,
"label.icon.53":`Auto`,
"label.exchange.sync.state.setting.m3":`Utenti con indirizzi e-mail Microsoft Exchange e CloudCC collegati:`,
"label.currency.enable":`Valute: Abilita valuta`,
"component.timeline.label.past":`Attività passate`,
"workflow.action.tasks.assignortype.user":`Utente`,
"setup_layout_label_relatedlistsetup":`Impostazioni dell'elenco correlate`,
"label.systemadmin":`Amministratore di sistema`,
"label_tabpage_allz":`Tutti`,
"label.ems.subject":`Oggetto`,
"message.recordtype.selectlayout.tip":`Seleziona il layout di pagina che gli utenti con questo profilo vedono per i record con questo tipo di record. Dopo aver salvato, scegli i valori dell'elenco di scelta che sono disponibili con questo tipo di record.`,
"label.current.version":`Versione attuale del programma`,
"label.sourceoffile":`Untranslated - produce un insieme di file, per lingua, con testo non ancora tradotto`,
"label.file.versionerror":`Si prega di utilizzare la scheda della funzione file nella nuova versione dell'interfaccia`,
"label.validate.function.funcExplain.MINUTE":`Restituire il minuto del giorno (dai campi data/ora)`,
"abel.setup.mobile.bottombutton.profile.setting":`Personalizzare il menu inferiore del profilo`,
"label.recycle.dis.tip3":`Seleziona My Recycle Bin dall'elenco a discesa per visualizzare gli elementi che hai eliminato. L'amministratore può selezionare All Recycle Bin per visualizzare tutti i dati dell'organizzazione che sono stati eliminati.`,
"message.selectnothing":`Nessuna selezionata`,
"label.develop":`Sviluppare`,
"label.tab.lightningpage":`pagina versione fulminea`,
"label.chat.micropost.share.info":`Condividi`,
"label.block.pricing.editor":`Editor di prezzi a blocchi`,
"label.ccchat.file.unavailable":`Questo file non è disponibile`,
"label_component_helper_businesschange_0UntreatActivity":`Opportunità senza attività non elaborate`,
"label.search.setup.obj":`Può impostare al massimo 100 oggetti.`,
"component.setup.button.cancel":`Cancella`,
"message.longtextareamaxlength":`La lunghezza non può superare i 32.000 caratteri`,
"vue_label_chat_removedby":`Sei stato rimosso dalla chat di gruppo dall'"Amministratore".`,
"label.autoRegister.changepwd.setpwd.tip.morechar":`Non può essere inferiore a 8 caratteri`,
"label.informassigner":`Informare la persona assegnata`,
"font-evaluate-module-v1-not-received":`Mai ricevere una valutazione di soddisfazione dai contatti`,
"label.trigger.triggertime":`Tempo di innesco`,
"label.attendance.cannot.make":`Impossibile segnare`,
"label.shouldallrecords":`Tutti i record dovrebbero essere inclusi nel calcolo`,
"label.eidt.queue.alter1":`Selezionare i membri della coda`,
"L":`Picklist`,
"label_emailtocloudcc_filed_email":`Email`,
"label.productsales.contract.badversion":`La tua edizione attuale non supporta la visualizzazione dell'oggetto del contratto, quindi non puoi visualizzare gli importi del contratto.`,
"label.tabpage.operation":`Operazione`,
"label.file.copy.public.link":`Il link pubblico è stato copiato`,
"label.all.SMS":`Tutti gli avvisi SMS`,
"UG_opportunity_008":`Squadra di opportunità`,
"UG.Campaign.002":`Pianificare, eseguire e monitorare l'efficacia delle attività di mercato.`,
"label.jiandangfenpei.title":`Assegnazione del profilo`,
"pagecreator.systemstyle.message.delete":`Elimina lo stile correntemente selezionato?`,
"lable.outlook.mcto.repeat":`Se vengono trovati record duplicati, l'email è associata al`,
"label.user.field":`Campi utente`,
"vue_label_commonobjects_detail_market_hierarchy":`Gerarchia del mercato`,
"label.ems.emails":`Email`,
"label.tabpage.deleteviewfailed":`Cancellazione della vista non riuscita`,
"label.data.exp.new.expobjtemp":`Creare il modello esportato dell'oggetto`,
"label.useformulassetval":`Usare le formule per impostare nuovi valori`,
"label.service.newBuildDialog.six.fields":`Si possono selezionare fino a 6 campi.`,
"error":`Errore`,
"template.chart.sdyyfx":`Analisi della ragione persa`,
"label.icon.191":`Baffi`,
"label.app.step3.tabused":`Schede selezionate`,
"label.user.level":`Livello utente`,
"label.custombutton.querydata.notexist":`I dati non esistono.`,
"label.executestate.calculating":`Calcolo...`,
"label.visualpage.folder.notdel2":`1.Questa cartella contiene file e non può essere cancellata.2.Questa cartella contiene file nascosti e non può essere cancellata. Un file nascosto è liberato da un oggetto logico di cancellazione (cancellazione da Setup-Create-Obkects), che è nascosto perché l'oggetto non è effettivamente cancellato.`,
"vue_label_report_conditiondesc_three":`Sarai avvisato se tutte le condizioni sono soddisfatte`,
"approval.request.email.subect":`Richiesta di approvazione`,
"label.log.user.value":`Inserisci il nome utente per la ricerca!`,
"label.isCompanyCurrency":`Corporate`,
"label.related.2018":`Elenchi correlati`,
"label.tonga.time":`Tempo di Tonga`,
"message.actionfailed":`Azione fallita`,
"label.’s":`'s`,
"label.custombutton.queryobj.notnull":`L'ID dell'oggetto della query non può essere nullo.`,
"label.list.userinterface.setup":`Interfaccia utente`,
"front-kefu-moudle-v1-yxgsbzq-reinput":`Il formato dell'email non è corretto. Si prega di reinserire`,
"label.chatter.content":`Contenuto`,
"label.projectManagement.Addnotes":`Aggiungere note`,
"label.service.newBuildDialog.reservation":`Mostra ordinato`,
"label.ccchat.pm":`PM`,
"vue_label_chat_cannot_invite_users":`Chi non possiede un gruppo non può invitare gli utenti a partecipare alle chat di gruppo`,
"label_partner_workspace_member_belong":`Appartiene a`,
"label.task.modify":`Modifica del compito`,
"label.tabpage.transformationsz":`Convertire`,
"label.new.password.no.indexof":`La nuova password non può contenere caratteri cinesi e spazi.`,
"label.ji.quarter":`No. {a} Quartiere`,
"label.sso.isActiveNo":`No`,
"label.mobile.phone.week.report":`Note di lavoro settimanali`,
"label.email.template.please.select.folder":`Scegli una cartella`,
"label.pc.ui.2018.tab.groups":`Gruppo di menu`,
"label.h5.approval.status":`Stato di approvazione`,
"setup.mainpage.label.welcome27":`La piattaforma cloud CloudCC fornisce funzioni come l'importazione, l'esportazione, la cancellazione in batch e il trasferimento in batch di tutti i dati degli oggetti nel sistema.`,
"vue_label_systemSettings_setHomePage":`Configurazione Home`,
"label.select.button":`Pulsanti disponibili`,
"label_emailsync_status_enable":`Collegamento attivo`,
"label.trigger.triggerVersion.detail":`Questo campo non è modificabile. Ci sono attualmente due versioni di trigger, 1.0 e 2.0, e tutti i nuovi trigger sono 2.0, la versione 1.0 non può essere creata.`,
"pagecreator_layout_message_save_fail":`Salvataggio del layout non riuscito`,
"label.salescloud.salesdashboard.10big":`Le 10 migliori opportunità nei prossimi 3 mesi`,
"label.file.share.size":`La quota massima e il link pubblico di ogni file sono`,
"label.page.simple":`Semplice`,
"pagecreator.page.message.delete":`Elimina la pagina correntemente selezionata?`,
"label.weixin.newspaper.coverage.detailinfo":`Informazioni dettagliate sulla scheda di rischio`,
"label.list.userinterface.chattersetup":`Impostazioni CCChat`,
"lable.opppdt.addpdt.table.quantity":`Quantità`,
"label.product.description":`Descrizione del prodotto`,
"button_partner_back":`Ritorna`,
"label.user.current.loginuser.sessionid":`Il SessionID dell'utente attualmente loggato è:`,
"label.otherreport":`Altri rapporti`,
"pagecreator_button_mobilepage":`Lato mobile`,
"label.mobile.phone.state":`Stato`,
"lable.currencyManage.unenableCurrencyAdv":`Disabilita la gestione avanzata della valuta.`,
"lable.product.addp":`Aggiungi prezzo`,
"label.field.validate.notpass":`Nessun errore di sintassi.`,
"label.app.global.search.obj":`Fino a 10 oggetti che puoi impostare per usarli nella ricerca globale.`,
"label.group.archived":`Archivio`,
"vue_label_approve_to_submit":`Per presentare`,
"showfrom":`Mostra da`,
"chatter.emailNotification":`Notifiche via e-mail`,
"label.callcenter.pleaseenter.enterprise.number":`Si prega di inserire il numero dell'impresa.`,
"label.forecast.customforecast.forecastnumber":`Numeri di previsione`,
"label.vlidaterule.messagelocation":`Posizione di errore`,
"label.h5.similar.opportunity.step3.conment":`La colonna Pertinenza, che rappresenta il numero di campi corrispondenti, sarà sempre visualizzata.`,
"label.ccchat.group.gd.setting.info":`Modificare le impostazioni del gruppo CCChat`,
"label.knowledgebase.delete.article.succeeded":`Cancellare l'articolo con successo`,
"message.layout.edit":`La gestione del layout di pagina è una funzione a valore aggiunto separata. Se la tua organizzazione conferma di aver acquistato il modulo di funzione, chiedi la password all'amministratore di sistema. Contatta CloudCC.com per saperne di più.`,
"label.case.create":`Viene creato il caso ({0})`,
"label.icon.170":`Shopping`,
"message.error.contact.null":`Il contatto non può essere vuoto`,
"label.appupload.install.error.hasinstalled":`Questo pacchetto software è già installato nella tua organizzazione. prima di installare la nuova versione, devi prima disinstallare la versione installata.`,
"label.service.miniProgram.imageType":`Sono supportati i formati PNG, JPG e JPEG. Le immagini di 750*349 pixel sono raccomandate. Passa il mouse sull'immagine per ricaricarla o cancellarla.`,
"label.leadscore.rule.edit":`Regola del punteggio dei lead: Modifica regola`,
"vue_label_commonobject_anytime":`In qualsiasi momento`,
"label.clearing.conditions":`Condizioni chiare`,
"label.campagin.roi.ydkhjhze":`Quantità totale di opportunità di clienti vinte`,
"Lead_Auto_Scoring_Setting_001":`Segnare automaticamente quando si modifica o si salva (eccetto le tracce che sono importate in batch o create dall'interfaccia)`,
"pagecreator.systemstyle.label.buttonareacolor":`Colore dell'area operativa`,
"label.batchregist.huanxinuser.finish":`La registrazione di massa degli utenti è stata completata`,
"UG_opportunity_006":`Genio dell'opportunità`,
"message.serviceappo.violation":`Violazione del periodo di assegnazione: è in conflitto con un altro appuntamento di servizio.`,
"label.recordtypeselect.selectnew":`Seleziona il nuovo tipo di record`,
"Lead.Tools.BatchScoring":`Punteggio dei lotti di piombo`,
"label.partnerCloud.financeSetting.enterWechat":`Si prega di inserire l'account mercantile WeChat.`,
"label.philippine.time":`Ora delle Filippine`,
"five":`Cinque`,
"label_average_value":`MEDIA`,
"message.realdelete":`Sei sicuro?`,
"label.currency.note":`Inserire le informazioni per la nuova valuta. Si noti che non è possibile cancellare una valuta una volta attivata.`,
"label.projectManagement.delete.prompt":`Cancellare il Prompt`,
"label.approval.present":`(Corrente)`,
"label.escalation.setup.newrule.name":`Nome della regola`,
"label.edit.list":`Elenco di dati modificabile`,
"label.partnerCloud.financeSetting.informationOne":`1. Visita il centro commercianti Alipay (b.alipay.com) e accedi con l'abbonato Alipay.`,
"label.customfields.numberText":`2.La somma della lunghezza del numero inserito e il numero di decimali non deve superare i 18 posti.`,
"label.biaoqing.businessverify.relation.tip":`Scrive il valore restituito di bid&tender sul campo lead`,
"label.icon.149":`Robot`,
"System.btn.SaveAndCommit":`Salva e invia`,
"label.calendar.many":`Multiutente`,
"label.ccchat.create.email":`L'email è stata creata`,
"template.report.income.marketing.activities":`Rapporto sulle entrate della campagna`,
"label.ccchat.person.invite.needemail":`Inserisci un indirizzo e-mail.`,
"template.report.open.amount":`Importo non chiuso`,
"label.currentoperate":`Azioni selezionate`,
"label.finalapprove":`Approvare finale`,
"label.emailmerge.mergepage.step2":`2. Seleziona il modello di mail merge, fino a 20:`,
"label_tabpage_sorttypez":`Tipo di ordinamento`,
"label.workbanch":`Il mio banco da lavoro`,
"font-evaluate-module-v1-disable":`Sei sicuro di disattivare questo？`,
"label.ServiceCloud.distributionMap":`Mappa di distribuzione`,
"lable.Confirm.potential.customers":`Conferma la raccolta di {num} lead.`,
"label.mobile.quickcreate.default.nearby":`Nelle vicinanze`,
"label.isremider.noremider":`Nessun promemoria`,
"label.approval.select.step":`Selezionare quale fase di approvazione da restituire`,
"chatter.error.pm":`Errore: La dimensione del file è troppo grande.`,
"UG_activity_08":`Prenota un programma`,
"label.marketsea.notwinopportunitydays":`Numero di giorni senza un accordo (deve essere maggiore del numero di giorni senza creare un'opportunità di business)`,
"label.selectpage":`Seleziona una pagina esistente`,
"label.dashboard.dispalyOnTheHomePage":`Dispalyed Homepage`,
"front-lightning-module-v1-details-page-chart-set-report":`Impostare il rapporto`,
"vue_label_pool_mydeal":`Il mio accordo`,
"vue_label_report_lastone":`L'ultimo`,
"label.tabpage.potentialcustomersz":`Porta`,
"font-evaluate-module-v1-more-satisfied":`Non siamo abbastanza buoni。 Vi renderemo più soddisfatti la prossima volta!`,
"label.trigger.instructions":`<p>Istruzioni per l'uso：</p><p><li>I parametri possono essere direttamente citati:(DataContext)context,(UserInfo)userInfo,(Map)record_old,(Map)record_new</li><li>Quando si vuole ottenere il valore del record, si prega di "ottenere" direttamente il nome API del campo</li><li>Se si crea un nuovo record, usare "String id = IDGenerator.generateID("ID Prefix")"</li><li>Se hai bisogno di restituire un messaggio di errore: usa "trigger.addErrorMessage("")"; il trigger tornerà alla riga corrente, non più in esecuzione</li></p><font color="red">Nota:Supporto massimo 200KB caratteri, circa 200,000 Bytes.</font><font size=3 color="red">【Key：deve aggiungere note!】</font>`,
"lable.SalesCommitmentKanBan.commitmentToCompletionRate":`Tasso di completamento dell'impegno`,
"label.umeng.approval.dlsp.approvenew":`Approvazione delegata: #actorname richiede l'approvazione #objapiname#recordname`,
"label.edit.visualpagefolder":`Pagina personalizzata: Modifica cartella`,
"label.pc.flash.teach":`Video Insegnamento`,
"label.showsearch":`Mostra ricerca`,
"label.reportsSubscriptionPage.condition.title1":`Riceverai una notifica quando tutte le condizioni sono soddisfatte (AND)`,
"label.h5.search.result":`Conta`,
"vue_label_commonobjects_view_chart_pie":`Grafico a torta`,
"label_please_enter_currency":`Inserisci la valuta`,
"chatter.share.to.profile":`Il tuo profilo`,
"label.mykeeptouchset":`Le mie impostazioni di Keep In Touch`,
"label.profile.mustcopyaprofile":`Devi selezionare un profilo esistente da cui clonare.`,
"label.managereport":`Gestire i rapporti`,
"label.total.choice":`file, selezionato`,
"label_emailtocloudcc_help":`Inserisci la password o il codice di autorizzazione corretto. Se il tuo server di posta elettronica ha bisogno di attivare il servizio IMAP/SMTP per accedere con un account di terze parti, devi prima accedere alle impostazioni dell'account di posta elettronica per abilitare il servizio, e copiare il codice di autorizzazione appropriato in questa casella di inserimento password.`,
"label.trigger.sel":`Trigger in questa cartella`,
"label.dashboardLookUp":`Visualizza i cruscotti`,
"label.batchadd.newbatchpage.save.emptytext":`Si prega di controllare se ci sono informazioni richieste non compilate.`,
"setup.mainpage.label.welcome16":`Istruzioni: Clicca sul menu sul lato sinistro della pagina → Impostazioni applicazione → Crea → Flusso di lavoro, Processo di approvazione, Compiti, Notifica e-mail, Aggiornamento campi e altro.`,
"vue_label_email_mark as":`Segna come`,
"label.customobjdel.cannot.delete.try":`L'oggetto non può essere cancellato perché è associato alla seguente relazione di altri oggetti.`,
"label.customsetting.visible.public":`Pubblico`,
"label.log.bit":`Bit`,
"label.data.exportall.all.desc":`Esporta tutti i dati per tutti gli oggetti che l'utente corrente ha il permesso di visualizzare.`,
"message.login.mfadevice.already.bound":`L'utente ha già vincolato il dispositivo MFA.`,
"label.campaign.channel.please.img":`Si prega di caricare l'immagine`,
"assetbom.manage.notpermission":`Contatta il tuo amministratore per abilitare l'accesso alla gestione della distinta dei beni.`,
"schedstarttime.schedendtime.time.illegal":`L'ora di inizio programmata dell'appuntamento di servizio dovrebbe essere inferiore o uguale all'ora di fine effettiva.`,
"label.referperson":`Proprietario`,
"front-email-payment-area":`Distretto`,
"label.c.d.least":`Ogni record "C" deve avere almeno un record "D" correlato.`,
"label.weixin.longitude.isnull":`La longitudine e la latitudine sono vuote o non valide`,
"setup.layout.button.ok":`Confermare`,
"vue_label_fiter_component_date_customdate":`Data personalizzata`,
"label.enable.case.createarticle":`Permettere agli utenti di creare articoli dai casi.`,
"label.event.moveup.8hour":`8 ore avanti`,
"label.input.most.string":`Inserisci fino a {0} caratteri`,
"lable.SalesCommitmentKanBan.contractEndDate":`Data di fine contratto`,
"label.visualpage.function.name":`Dare un nome alla funzione che deve essere:`,
"label_emailtocloudcc_redmessage1":`Indirizzo e-mail non valido`,
"message.aliasnameinput":`Errore: Il nome deve essere unico e iniziare con una lettera. Deve contenere solo lettere e numeri.`,
"label.data.exp.selectedtemp":`Seleziona il modello utilizzato per l'esportazione dei dati`,
"label.import.page1.suitedwayoflinkman":`Contatto stile corrispondente`,
"label.customsetting":`Impostazioni personalizzate`,
"label.versiontype.Free":`Piano gratuito`,
"setup.layout.label.norelatedlist":`Nessuna lista correlata`,
"label.forecast.edittotal.de.leiji":`Rollup da`,
"label.customfields.file.max":`Il file caricato è troppo grande, per favore non superare i 5m`,
"label_partner_all_workspace":`Spazio di lavoro`,
"label.searchrelation":`Relazione di ricerca`,
"label.icon.185":`Consulenza`,
"label.service.gantt.effective":`Valido`,
"label.newreportstp1":`Passo 1 Selezionare il formato tabulare`,
"label.category.9":`Produzione`,
"label.zuowei":`Come`,
"front-quotation-v1-select-quota":`Seleziona Preventivo`,
"label.dashboard.refresh":`Aggiorna`,
"label.weixin.saveandnew.log":`Salva`,
"label.report.list":`Elenchi di rapporti`,
"FL":`File`,
"label.h5.followingcolleagues":`Colleghi caduti`,
"template.report.conversions.number":`Numero di conversioni di lead (per proprietario)`,
"label.validate.function.funcFormat.MONTH":`MESE(data)`,
"front-kefu-moudle-v1-tenant-ID":`ID locatario`,
"label.reportsSubscriptionPage.schedulereport.monthly.time":`Tempo`,
"label.multilang.workflow.everyotherday":`Ogni {0} giorni`,
"label.chat.message.send.message":`Inviare informazioni`,
"label.knowledgebase.fast.operation.error":`Errore di funzionamento rapido`,
"label.multilang.dupicatecheck.dumplicatedata":`Nei {0} record, è stato trovato un totale di {1} gruppi di dati duplicati che soddisfano la condizione, e l'interrogazione ha richiesto {2} millisecondi. Ogni pagina mostra {3} gruppi di dati.`,
"vue_label_report_addFile_detail_Information":`Esporta solo 2000 righe di dettaglio. Usa questi dati per ulteriori calcoli o caricali in altri sistemi.`,
"label.ccchat.message.search.desc3":`Suggerimenti per la ricerca`,
"message.deletereport.prompt":`Impossibile cancellare questo rapporto`,
"pagecreator.page.message.save.success":`Pagina salvata con successo`,
"vue_label_rise":`Ascend`,
"label.appupload.install.error.choicehead":`Come comportarsi se i componenti esistenti nel sistema sono in conflitto con i componenti da installare?`,
"message.dispatch.violation":`Violazione del tempo di assegnazione: il periodo di assegnazione non rientra nell'intervallo di tempo di lavoro delle risorse.`,
"label.tool":`Strumenti`,
"label.sso.saml.idp.downloadcert":`Scaricare il certificato`,
"label.chatter.detailinfo":`Informazioni dettagliate`,
"label.area.tree":`Territori Ierachia Vista ad albero`,
"label.partnerCloud.priceOfManual.notEnabled":`Non attivare`,
"label.chosesubject.call":`Chiama`,
"label.leadscore.rule.detail":`Punteggio dei lead: Dettaglio delle regole`,
"front-welcome-to-try":`Accogliere il processo`,
"label.umeng.activity.event.willbegin1":`L'evento #evento inizia tra #tempo.`,
"component.event.label.noevent":`Sembra che tu abbia completato il tuo lavoro oggi.`,
"label.document.templatesetof.folder":`Set di modelli di cartelle`,
"label.quickbooks.none":`Nessuna corrispondenza trovata, si prega di digitare un nome per la ricerca o creare un nuovo cliente`,
"label.assignment.setup.newrule.inputrule":`Inserire il nome della regola di assegnazione`,
"label.appointmentdetail.wizard.title4":`Nome dell'azienda`,
"label.malaysia.time":`Ora della Malesia`,
"label.partnerCloud.partnerAccount.way":`Metodo di ricarica`,
"label.roleoflinkman":` Ruolo di contatto`,
"mesage.error.role.delate.user":`Il ruolo non può essere cancellato perché ha assegnato gli utenti.`,
"chatter.warning":`Attenzione: Se selezioni un oggetto diverso, le tue modifiche non saranno salvate. Sei sicuro di volerlo fare?`,
"label.service.gantt.violations.sum":`Appuntamenti di servizio con violazioni`,
"label.permission.objectpermission.recordfenpei1":`Tipi di record assegnati`,
"label.mobile.phone.required.plan":`Il piano è richiesto`,
"label.after_leaving":`I dati attuali non saranno salvati dopo aver lasciato`,
"label.cpq.opportunity.mainquote.trasnfer.order":`C'è stata una citazione primaria sotto l'opportunità e trasferita all'ordine.`,
"component.setup.iframe.label.title":`Personalizza la pagina`,
"visit.dispatchplatform.nopermission":`Permesso negato: Non sei autorizzato ad accedere alla console di spedizione. Per favore contatta l'amministratore.`,
"label.validate.function.funcExplain.RIGHT":`Restituisce il numero specificato di caratteri dalla fine di un testo`,
"component.chatter.link.button.save":`Pubblica`,
"label.knowledge.selection":`Ogni conoscenza ha un massimo di 8 gruppi di dati selezionabili.`,
"chatter.email.homePage":`Mandami un messaggio sulla mia homepage CCChat`,
"vue_label_commonobjects_view_copy_view":`Copia vista`,
"label.documentmessage":`Dettagli del documento`,
"label.emailtocloudcc.step1":`Passo 1`,
"label.user.mfa.unbind":`Sblocca l'MFA agli utenti selezionati`,
"label.stdashbord.xsld.business.sdzje":`Importo totale (opportunità chiuse/perse)`,
"vue.please.select.the.total.method":`Si prega di selezionare il modo di riassumere.`,
"label.stdashbord.xsld.business.img1":`Numero di fasi con una probabilità dell'1%  99%`,
"label.reportsSubscriptionPage.condition.title":`Oltre alla sottoscrizione, puoi impostare delle condizioni su questo rapporto. Sarai avvisato quando le condizioni sono soddisfatte. Questo è opzionale.`,
"chatter.sel.field":`Errore: Sono stati selezionati più di 20 campi.`,
"label.login.access.year":`Anno`,
"label.dashboard.all":`Tutti i cruscotti`,
"label.approver":`Approver`,
"Lead.Homepage.Tools.BatchScoring":`Punteggio del lotto`,
"lable.opppdt.selPdt.lesscondtions":`Meno filtri`,
"label.integrations.action.export":`Esportazione`,
"label.datamanage.lookupandsure":`(Visualizza e conferma)`,
"label.email.attach.to.mail":`Allegare all'e-mail`,
"message.nodataordeleted":`I dati non esistono o sono stati cancellati`,
"component_newrecords_label_all":`Vedi tutto`,
"lable.currencyAdv.startdate.rate":`Mostra tutti i tassi definiti per la data di inizio nel seguente intervallo`,
"label.callbackoperate":`Azioni di richiamo`,
"label.knowledge.setting.hint.eighteen":`Iniziare a creare un articolo per la conoscenza`,
"label.user.step4.submit.email":`Passo 4 La tua richiesta di invio e-mail è stata presentata`,
"label.appointment.wizard.subtitle4-1":`Tempo di viaggio tra gli eventi`,
"component.assistant.button.newtask":`Nuovo compito`,
"label.icon.129":`Scheda`,
"label.relatedlist":`elenchi correlati`,
"label.report.recently":`Visti di recente`,
"label.batchadd":`Aggiunta di massa`,
"front-template-V1-Delete-succeeded":`"{currentTelmplateName}" è stato cancellato con successo`,
"label.appupload.upload.otherdetail":`Dettagli aggiuntivi`,
"label.emailobject.link":`Link:`,
"label.quickbooks.createcustomer":`Creare un cliente in QuickBooks`,
"report.label.projectcount":`elementi, ordinati per nome del rapporto`,
"vue_label_normal_contact_sf":`Contatta`,
"chatter.group.groupActivities":`Tutti i gruppi`,
"label_tabpage_addoptionsz":`Aggiungere opzioni`,
"label.knowledgebase.submit.for.translation":`Invia per la traduzione`,
"vue_label_pool_notallowed":`La natura dell'attività non è consentita`,
"label.icon.80":`Produzione di carta`,
"label.readonlys":`Solamente lettura`,
"label.recordsediting":`Modificabilità del record`,
"label.mr.title.email":`Email`,
"label.partner.all.enable":`Abilita`,
"label.customsetting.manage.errmessage":`Mantenete i campi personalizzati prima di gestire i dati.`,
"label.cloudccclass.list.cls":`Classe`,
"label.weixin.click.loadall":`Clicca per caricare tutti`,
"label.weixin.appr.initialtime":`Tempo inviato`,
"UG_ST_002":`Determinare`,
"setup_mainpage_label_welcome17":`Impostazioni dei permessi`,
"label.appupload.state0":`Non caricato`,
"label.icon.115":`Casa`,
"setup_mainpage_label_welcome5":`Campo personalizzato`,
"lable.custom.year.ovdate":`Data di fine anno personalizzata`,
"label_tabpage_findz":`Cerca`,
"label.appupload.uploading":`Caricamento...`,
"setup.mainpage.label.welcome1":`Necessita di un permesso corrispondente`,
"label.file.folder.delete2":`Cancellare la biblioteca?`,
"2018UI_Homepage_DataNoAccess_Info":`Non hai il permesso di visualizzare questo record, clicca per tornare al passo precedente.`,
"label.ems.google":`Google`,
"label.hawaii.aleutian.standard.time":`Hawaii-Aleutian Standard Time`,
"template.report.unfinished.tasks":`Compiti non completati`,
"vue_label_calendar_add_calendar":`Aggiungi calendario`,
"label.button.sel.useremail":`Inviare e-mail a utenti selezionati`,
"user.email.template":`Caro{username}：<br>Il codice d'invito di [{campagna.nome}] mostra come segue<br>{Campagna.CollegaInvitoLetter}<br>e l'URL è:<br>{Campagna.CollegaInvitoLetterLink}<br>La registrazione del codice QR e la registrazione del link URL sono supportate per questa campagna! Grazie per il vostro supporto! <br>Responsabile marketing:{Campagna.Proprietario}`,
"label.forecast.settings.shouru":`Entrate`,
"label.casesensitive":`Trattare "ABC" e "abc" come valori diversi (case sensitive)`,
"message.pleaseinputrightdistanceweek":`Si prega di compilare la settimana di intervallo corretta.`,
"label.linellae-group":`raggruppamento di colonne`,
"label.showdefault_times":`Mostra l'ora di pubblicazione predefinita`,
"label.smstemplate.finishmessagedetailinfo":`Completa i dettagli del modello SMS`,
"label.service.miniProgram.backgroundImage":`Immagine di sfondo`,
"label.recentview.news":`Ultimi record`,
"label.reportType.chose.and.form":`Seleziona l'origine dati del rapporto e un formato di rapporto`,
"setup.layout.button.additem":`Aggiungere gli elementi selezionati`,
"front-epwechat-module-v1-auto-mate":`Automatch`,
"vue_label_helpcenter_contract&plan":`? Un contratto è un accordo scritto tra le parti. Molte aziende usano i contratti per definire i termini per fare affari con altre aziende. Usa Cloud CC per stabilire e documentare i tuoi contratti esistenti con i tuoi clienti e le tue opportunità commerciali. Traccia il contratto attraverso il processo di approvazione.<br>Assisti la funzione di contratto e gestisci le tue transazioni attraverso il piano di incasso.`,
"label_mobile_version_nonsupport_feature":`Questa funzione non è supportata nella versione attuale. Si prega di aggiornare all'ultima versione.`,
"label.icon.44":`Fuoco`,
"label.data.downpage.i.title.num3":`3. Prima di importare, assicurati di importare tutti i record correlati. Per esempio: se c'è una relazione di ricerca tra gli oggetti che stai importando e i contatti, dovresti importare prima i contatti e poi importare i dati.`,
"label.mr.object.customer":`Conti`,
"label.social.user.null":`Le informazioni utente di Social non possono essere vuote`,
"front-epwechat-module-v1-unbound-item2":` tutti i dati delle impostazioni dell'applicazione`,
"label.partnerCloud.partnerAccount.noempty":`L'importo della ricarica non può essere vuoto.`,
"label.weixin.myapproval":`Le mie approvazioni`,
"label.data.setok.e_desc1":`Esportazione di successo, si riceverà un messaggio di sistema avvisi, i dati derivati sono temporaneamente memorizzati nel server, il sistema solo per voi per salvare 48 ore, per favore il più presto possibile per`,
"lable.batchadd.service.cfq.after":`Trigger (dopo l'inserimento)`,
"label.umeng.activity.youhaveanevent":`Avete un nuovo evento.`,
"label_emailsync_status_connectaccounts":`Account e-mail collegato`,
"label.multilang.shenpi.count":`Un totale di {0} record：`,
"pagecreator.page.message.delete.fail":`Cancellazione della pagina non riuscita`,
"label.version.sum.lookupmdfield":`Campi di relazione master-dettaglio`,
"vue_label_pool_clueduplication":`Indizio duplicato`,
"label.system.setup.log":`Registro del comportamento del sistema`,
"label.globaloperation.operationtype.send.e-mail":`Inviare e-mail`,
"vue_label_pricebook_entry":`Nuova voce del listino prezzi`,
"label.forecast.forehistory.submit.date":`Data/ora di presentazione`,
"chatter.handle":`A cosa stai lavorando?`,
"lable.SalesCommitmentKanBan.complete":`Importo completato`,
"label.weixin.upload.pictures":`Carica immagine`,
"label.create.document":`Nuovo documento`,
"vue_label_commonobjects_detail_unlockconfirm":`Confermare per sbloccare?`,
"label.customer.page":`Schede di pagina personalizzate`,
"button.partner.workspace.saveas":`Salva con nome`,
"setup.layout.label.asc":`Ascendente`,
"label.ccpeak.folder.time":`Cartelle di classe non compilate e programmate`,
"label_tabpage_includez":`Includere`,
"label.custom.button":`Pulsanti personalizzati`,
"label.weixin.binding":`Legare`,
"P":`Percentuale`,
"chatter.stop.n":`Smetti di seguire questo disco`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.wednesday":`Mercoledì`,
"template.report.revenue.marketing.activities":`Entrate della campagna`,
"lable.SalesCommitmentKanBan.theActualReceipts":`Entrate effettive`,
"vue_label_popularresults":`Risultati Popolari`,
"label.log.belongs":`Parte subordinata`,
"label.profile.remark":`Gli utenti con questo profilo hanno i permessi e i layout di pagina elencati qui sotto. Gli amministratori possono cambiare il loro profilo modificando le informazioni personali degli utenti.`,
"label.appupload.component.type.button":`Pulsante`,
"label.partner.all.operate":`Operazione`,
"vue_label_notice_modify_fail":`Non riuscire a modificare`,
"label.icon.137":`Terra`,
"front-dialog-module-v1-nosupport-copy":`Il clone non è supportato`,
"label.integrations.mailchimp.massage3":`Integrazione disinstallata con successo`,
"UG.opportunity.010":`Creare una transazione`,
"front-lightning-module-v1-details-page-chart-selecting-reports":` Puoi scegliere solo rapporti pubblici, cioè rapporti con accesso per tutti gli utenti, e rapporti pubblici non compilati.`,
"System_btn_SaveAndCommit":`Salvare e inviare`,
"vue_label_dashboard_statisticaltype":`Selezionare il tipo di statistica`,
"label.mr.object.opportunity":`Opportunità`,
"label.area.detail.remark":`Visualizza gli utenti in questo territorio`,
"label.view.sortview.index":`Ordina`,
"label.mobile.quickcreate.default.events":`Eventi`,
"label.product.price":`Prezzo di vendita`,
"label.leadmarketsea.edit.title":`Modifica della piscina di piombo`,
"pagecreator.layout.button.edit":`Modifica del layout`,
"label.addressee":`Destinatari`,
"label.movablesearchlayout":`Layout di ricerca delle attività`,
"label.ems.confirm":`Confermare`,
"vue_label_file_save_to_file":`Salva su file`,
"component_chatter_button_more":`Vedi altri dettagli`,
"label.ccdocument.hidden.trace":`Traccia nascosta`,
"label.partnerCloud.maximumTwo":`È supportato un massimo di 2M di file.`,
"label.event.moveup.4hour":`4 ore avanti`,
"label.batchadd.save":`Aggiungere il fallimento della condivisione`,
"label.passwordPolicy.setup.expireDate":`La password dell'utente scade in`,
"label.workflowrule":`Regole del flusso di lavoro`,
"vue_label_notice_pleaseselecview":`Seleziona una vista`,
"label.h5.chatter.colleagues":`I colleghi`,
"lable.opppdt.addpdt.subtitle":`Aggiungi prodotto a`,
"label.data.import.setup.repeat.no":`No-Inserisci tutti i record nel mio file di importazione.`,
"label.changeCorporate":`Cambiare la valuta dell'azienda`,
"label.customfields.dateandtime.tip":`Permette agli utenti di inserire una data e un'ora, o di scegliere una data da un calendario a comparsa. Quando gli utenti cliccano su una data nel popup, quella data e l'ora corrente vengono inserite nel campo Data/Ora.`,
"label.integrations.mailchimp.massage1":`Seleziona almeno 1 record da esportare`,
"lable.PowerProcess.custom":`Basato su condizioni personalizzate`,
"label.service.editDialog.displays.service.appointmentsFordays":`Mostra gli appuntamenti di servizio di {} giorni prima della data del livello e {} giorni dopo la data del livello.`,
"label.Receivables.ActualMoneyTime":`Data di ricezione effettiva`,
"label.matrixreport.intro":`I rapporti di matrice mostrano i dati riassuntivi calcolati in termini orizzontali e verticali in forma di griglia.`,
"message.validation.isnotnumber":`Si prega di inserire il numero non valido.`,
"label.partner.workspace.member.search":`Cerca`,
"label.customfields.deletewill":`Cancellare un campo personalizzato:`,
"label.content":`Contenuto`,
"component.setup.button.weburl":`URL esterno`,
"setup.mainpage.label.welcome28":`Istruzioni: Clicca sul menu sul lato sinistro di questa pagina → Gestisci impostazioni → Gestione dati → Importazione ed esportazione dati, Trasferimento batch, Eliminazione batch.`,
"label.related.setup":`Impostazione dei compiti e degli eventi`,
"label.weixin.sign":`Caro, ti sei già registrato, non c'è bisogno di farlo di nuovo`,
"label.norecord":`Nessun record`,
"label.emailmerge.detail.emailtempldatemerge":`Modelli di Mail Merge`,
"label_emailsync_status_role":`Ruolo`,
"label.mobileapp.modelsetting2":`Seleziona i moduli che soddisfano le tue esigenze aziendali<br>Attiva: permette ai moduli selezionati di essere mostrati in Più  Funzione Standard<br> Disattiva: i moduli selezionati non potranno essere mostrati in Più  Funzione Standard.`,
"component.sendmail.label.title":`Inviare e-mail`,
"component_assistant_button_newevent":`Nuovo evento`,
"label.chatter.input":`Si prega di inserire il contenuto`,
"message.error.view.operate.rtnlink":`Clicca<a href='javascript:history.back();'>qui</a> per tornare indietro.`,
"lable.new.profile":`Nuovo profilo`,
"label.custom.field.null":`Non c'è nessuna disponibilità`,
"label.reportsSubscriptionPage.schedulereport.weekly.saturday":`Sabato`,
"label.stdashbord.xsld.business.img4":`Quantità totale di stadi con probabilità del 100%`,
"pagecreator_layout_button_splitall":`Dividere tutti`,
"label.mobile.phone.total.amount":`Importo totale (diecimila)`,
"label.ratifyhistory":`Storia dell'approvazione`,
"label.projectManagement.Antecedents":`Pre-task`,
"label.projectManagement.Newserviceappointment":`Nuovo appuntamento di servizio`,
"label.delete.record.is.approval":`I record che vuoi cancellare richiedono l'approvazione, sei sicuro di voler cancellare?`,
"front-gantt-module-no-tasks-describe":`È possibile vedere come le voci di lavoro sono organizzate nel tempo, come si sovrappongono e come sono correlate nel diagramma di Gantt.`,
"vue_label_visualize_data":`I dati di TianYanCha sono compilati. Si prega di salvare le modifiche.`,
"UG.activity.02":`Assegnare compiti`,
"label.field.duplicate2":`Non sono ammessi valori duplicati`,
"label.cloudccclass.list.tip":`Permette agli sviluppatori di sviluppare classi sulla piattaforma CloudCC.com che possono essere utilizzate per personalizzare pagine e trigger.`,
"before":`Prima di`,
"UG.ST.001":`Prompt`,
"label_tabpage_userGuidez":`Guida per l'utente`,
"vue_label_account_looking_for":`Inserisci quello che stai cercando`,
"vue_label_calendar_notice_timecantmove":`L'ora del calendario non può essere cambiata trascinando`,
"label.mobile.phone.enter.summary":`Inserisci il tuo riassunto`,
"label.object.api.existed":`Questo nome API dell'oggetto esiste già, per favore cambia un altro nome API.`,
"label.weixin..xsld.order.by.time":`Ordina per data di chiusura`,
"label.h5.chatter.whether":`Se o non`,
"label.file.delete.success":`File cancellato con successo`,
"label.imgfield.type.url.tip1":`L'utente può inserire il link che fa riferimento all'immagine, e impostare le dimensioni dell'immagine aggiungendo`,
"label.tomanyrecords":`Più di 5.000 articoli nel modulo.`,
"label.save.partnercloud":`Errore durante il salvataggio di Partner Cloud`,
"vue_label_homepage_fliteritems":`Filtrare gli elementi di configurazione`,
"pagecreator_page_button_new":`Nuova pagina`,
"label.sharerule.baseofcondition":`Sulla base di criteri`,
"label.dashboard.snapshot":`Istantanee del cruscotto`,
"label.appointmentpage.wizard.subtitle1.1":`Scegliere data e ora`,
"label.reportsSubscriptionPage.condition.emailsummary":`Solo riassunto`,
"chatter.group.showAll":`Mostra tutto`,
"label.tabpage.helpNavigationz":`Aiuto e navigazione`,
"label.emailtocloudcc.button.back":`Cancella`,
"approval_request_email_subect":`Richiesta di approvazione`,
"label.lookup.error":`Si è verificato un errore durante la ricerca`,
"label.publicgroup.save.groupisnull":`I dati del gruppo sono nulli durante il salvataggio. Per favore salva di nuovo. Se c'è ancora un errore, contatta il tuo amministratore.`,
"label.pie":`Grafico a torta`,
"chatter.feed.is":`è una rete aziendale che consente ai vostri utenti di lavorare insieme, di parlare tra loro e di condividere informazioni, il tutto in tempo reale.`,
"label.customfields.file.max5m":`La dimensione massima del file è di 5m`,
"com.cloudcc.login.error.message.vaildauthfail":`Autenticazione di accesso non valida`,
"label.profile.appsetuppermission":`Gestione delle impostazioni delle app`,
"label.customfields.file.totalmax":`Il file caricato è troppo grande, per favore non superare i 500m`,
"label.sms.list":`Elenco delle interfacce SMS`,
"message.error.referencedcolumnIdnotexist":`I campi di riferimento del rapporto sono stati cancellati e non possono essere visualizzati correttamente. Contatta il tuo amministratore per aiuto.`,
"front-lightning-module-v1-details-page-chart-setting-chart":`Impostare il grafico del rapporto`,
"label.recordtype.profile.enables":`Tipi di record attualmente disponibili`,
"chatter.this.n":`questo disco`,
"label.only.upload.file":`È permesso caricare solo file jpg/png e non più di 500kb.`,
"vue_label_lead_conversion_failed":`Conversione fallita`,
"label.file.share.file.success":`Condividere i file con successo`,
"label.processsetting.delete.process":`Sei sicuro di voler eliminare il processo?`,
"message.uniquenamevalidate":`Deve iniziare con una lettera.Deve iniziare con una lettera.Deve contenere solo lettere, numeri e underscore.`,
"label.group.archived.desc.info":`Questo gruppo è stato archiviato quindi non puoi creare nuovi messaggi o condividere file con questo gruppo.`,
"label.customer.maincontact":`Contatto principale`,
"label.appointment.wizard.subtitle1-9":`4 h`,
"label_productline_income":`Serie di prodotti Entrate`,
"label.dashboardSetup.tz.ybb":`Vai ai cruscotti`,
"label.recordowner":`Proprietario del disco`,
"message.approval.othersdoing":`Qualcun altro sta lavorando su questo processo, si prega di aggiornare per ottenere gli ultimi dati.`,
"Opportunity_Detailed_Phase_Label_002":`{0} giorno(i) nella fase attuale`,
"label.field.validating.rule.isnot.passed":`Compilazione della regola di convalida fallita, controlla la sintassi.`,
"label.textmessage.fieldskong":`Alcuni dei campi inseriti nel messaggio sono nulli, per favore modifica e reinvia!`,
"com.cloudcc.login.error.message.islocked":`Il tuo id è bloccato`,
"label.forecast.customforecast.foredis.debfb":`% Quota`,
"lable.opppdt.selPbk.changepbk.worning":`Modificando il listino prezzi di questa opportunità, il prodotto associato a questa opportunità sarà cancellato. Sei sicuro?`,
"label.mr.backLookReData":`indietro, Visualizza l'elenco dei dati duplicati`,
"label.quickbooks.searchqb":`Cerca QuickBooks`,
"label.service.gantt.searchSkills":`Capacità di ricerca`,
"label.account.Current.and.NexttFQ":`Attuale e prossimi 3 FQ`,
"customer.notopen.chat":`L'organizzazione non ha attivato la funzione di chat, contatta l'amministratore`,
"vue_label_commonobjects_view_sum":`Totale {totale} record`,
"label.partnerCloud.orderingPlatform.adjust":`Regolare l'ordine del prodotto`,
"label.emailmerge.mergeFolder.tips":`Un file Microsoft Word con i dati di contatto può essere generato in questa pagina. Si prega di scegliere i modelli di email da unire, e si può selezionare un massimo di 20 modelli.`,
"vue_label_ccchat_notice_deletecommentfail":`Non è riuscito a cancellare il commento`,
"label.emailsync.status":`Stato dell'e-mail dell'utente`,
"label.forecast.forecastroleuserpage.desc":`Assegnate un responsabile delle previsioni a questo ruolo. Le previsioni dei suoi subordinati saranno aggregate nelle previsioni del suo manager.`,
"label.step1.total4":`Passo 1 di 4`,
"front-kefu-moudle-confirm-fjcase":`Sei sicuro di dividere questo caso`,
"label.icon.60":`Gru`,
"label.appointmentpage.wizard.subtitle3":`Inserisci le tue informazioni`,
"label.loginservice.license.exceed.time":`La licenza è scaduta.`,
"label.customcomponent.check.tag.lastrow":`L'ultima riga deve essere`,
"label.product.code":`Codice prodotto`,
"label.salescloud.salesdashboard.phone":`Telefono`,
"label_please_input_price_list_price":`Si prega di inserire il prezzo di listino.`,
"label.multilang.page3":`pagina(e)`,
"label.file.lastmodifydate":`Tempo modificato`,
"label.icon.121":`Computer`,
"message.error.system.service.unknow":`Servizi sconosciuti, contatta il tuo amministratore.`,
"label.thesecond":`La seconda colonna`,
"vue_label_report_conditiondesc_two":`Aggiungere condizioni a questo rapporto`,
"label.exchange.serverUrl":`Indirizzo del server`,
"RL":`riferimento`,
"label.emailobject.emailsend.sendindividuallyprompt":`Ogni ricevuta riceverà un messaggio inviato solo a lui. Sei sicuro?`,
"label.appointmentconfirmpage.wizard.subtitle4":`Partecipanti`,
"message.save.opportunity.team.save.failed":`Gruppo di opportunità commerciali fallito`,
"vue_labenl_normal_notice_share_success":`Condiviso con successo`,
"label.triggerfolder":`Cartelle di trigger`,
"label.more":`Più`,
"label.file.num":`Quantità`,
"label.dashboard.list.sortBy":`voce(i), ordinati per tempo di accesso`,
"c":`Valute`,
"label.weixin.detail.edit":`Modifica`,
"label.escalation.setup.newentries.step2":`Passo 2 Selezionare i criteri per questa voce di regola`,
"label.report.error.prompt":`Configurazione fallita. Sono supportati solo i rapporti in serie con set di righe. Assicurati che sia un rapporto pubblico e non cancellato!`,
"label.notification.new":`Nuovo`,
"label_tabpage_releaseTourz":`Pubblicare la guida`,
"label.icon.41":`Posizionamento`,
"label.sendsms.hello.new":`Ciao, hai un nuovo`,
"label.custom.combination":`Combina`,
"label.project.hit.fifteen":`Avviso di assegnazione della pietra miliare`,
"label.campaign.channel.step6.mobile":`Generare una pagina mobile`,
"label.goback.N.step":`Ritorno al passo precedente N`,
"label_partner_all_name":`Nome della nuvola del partner`,
"label.usermanage.loginusername.exist":`Il nome utente esiste già.`,
"template.chart.cpxse":`Vendite di prodotti`,
"chatter.feed.deletecomments":`Sei sicuro di voler cancellare questo commento?`,
"label.list.userinterface.show.newrcords.enable":`Disattivare l'ultimo record`,
"label.sso.saml.idp.config.enablelogout":`Abilitare il logout singolo`,
"label.file.library.create":`Nuova biblioteca`,
"label.event.moveup.half.day":`0,5 giorni avanti`,
"label.stdashbord.xsld.business.jhzje":`Quantità totale di opportunità`,
"label.partnerCloud.orderingPlatform.unitPrice":`Costo unitario`,
"label.recordtype.edit.attribute":`Proprietà generali`,
"front-template-V1-TemplatePreview":`Anteprima del modello`,
"label.tabpage.personalCenterz":`Centro personale`,
"label.setuplookuplayout":`Layout di ricerca`,
"label.no.merge.records":`Nessun record può essere unito`,
"label.attachementNew.set2":`Passo 2 Archivio`,
"label.publicgroup.detail.showmembers":`Visualizza i membri del gruppo`,
"UG.Forcast.03":`Iniziare a pianificare ed eseguire le strategie aziendali. <br>Vi auguro una felice previsione!`,
"label.h5.manageprompt":`Seleziona una scheda per aggiungere la homepage, o clicca sulla scheda per aprirla.`,
"label.icon.145":`Correlato`,
"label.select":`Seleziona`,
"label.publicgroup":`Gruppi pubblici`,
"label.customcomponent.usewhere.title":`Dove si usa questo componente:`,
"label.custom.page.button.name":`Nome del pulsante`,
"pagecreator_layout_button_vertical":`Smontaggio longitudinale`,
"label.marketsea.autorecyclerule":`Regole di riciclaggio automatico`,
"label.reportsSubscription.entrance.attachment":`Formato Excel .xlsx`,
"component_chatter_button_collect":`Segnalibro`,
"label.page.step2.of.step5":`Passo 2 di 5`,
"label.reportsSubscription.addfile.helptext":`È possibile impostare se aggiungere l'allegato del rapporto nelle e-mail di sottoscrizione, e il formato dei rapporti allegati.`,
"label.oldpw":`Vecchia password`,
"lable.SalesCommitmentKanBan.contractAmount":`Importo firmato`,
"lable.Bundle":`Pacchetto Superior`,
"label.weixin.unit.million":`Unità (diecimila yuan)`,
"label.app.choseprofile":`Assegnare il profilo`,
"label_tabpage_editz":`Modifica`,
"label.email.attachement.size.info":`Il file non può essere più grande di`,
"label.chatter.pastSevenday":`Gli ultimi 7 giorni`,
"label.weixin.end.later.start":`La data di fine deve essere successiva alla data di inizio.`,
"label.passwordPolicy.setup.lockoutPeriod":`Periodo di blocco effettivo`,
"pagecreator_page_funcpath":`/ costruttore / elenco delle pagine`,
"label.emailobject.apperror":`Nessun servizio di posta disponibile, si prega di contattare l'amministratore.`,
"label.custom.page.button.broadband":`Dimensione del pulsante (Pixel)`,
"label.weixin.contract.rate":`Tasso di realizzazione del contratto`,
"label.brief.payments":`Pagamenti`,
"lable.approvaldatamove.transfermsg":`Trasferimento di massa di tutte le richieste di approvazione in sospeso a un nuovo utente`,
"label.datamanage.account.namenull":`Nota: se il campo del nome del conto è nullo, il record non sarà importato.`,
"lable.SalesCommitmentKanBan.allTotalPaymentAmount":`Importo totale delle ricevute di rollup`,
"Opportunity_Detailed_Phase_Label_001":`Fase`,
"vue_label_helpcenter_calendar2":`<br> Calendari di oggetti: I calendari che crei con gli oggetti visualizzano i dati del record come voci di calendario nel campo della data nella vista calendario. Puoi modificare o cancellare i calendari degli oggetti e personalizzare il colore per ogni calendario degli oggetti. <br> Nuovo evento<br> Puoi creare un nuovo evento nella vista calendario in due modi. <br> (1) Clicca sul pulsante Nuovo evento nell'angolo in alto a destra della vista calendario per creare un nuovo evento. In un nuovo evento puoi associare l'evento ad altri oggetti, come le opportunità commerciali, selezionando altri oggetti nei campi Elementi correlati e Nome. I record degli eventi che sono associati ad altri oggetti sono sincronizzati nel modulo Attività della pagina dei dettagli degli altri oggetti. <br> (2) Oppure puoi creare un nuovo evento cliccando sulla griglia del calendario. <br> Nuovo oggetto Calendario<br> Passo 1: Clicca sulla scheda Calendario nel menu di navigazione per andare alla pagina di visualizzazione Calendario. <br> Passo 2: Trova I miei calendari sul lato destro della vista, clicca sull'icona accanto a I miei calendari, e procedi nella finestra pop-up Nuovo oggetto calendario. <br> Passo 3: Inizia a dare un nome al calendario oggetto creato. Seleziona l'oggetto che è la base del calendario, e seleziona i campi che determinano il contenuto della visualizzazione del calendario, "Campo inizio", "Filtro vista", "Campo visualizzazione". Il campo Start determina l'intervallo di tempo in cui vengono visualizzati i dati, è possibile filtrare i dati tramite i filtri di visualizzazione, e il campo Display determina ciò che viene visualizzato sulla voce del calendario. <br> Altri calendari<br> Altri calendari contengono i calendari di altri utenti aggiunti. Puoi aggiungere calendari di persone che sono subordinate a te e calendario condiviso con te. <br> Condividi il mio calendario eventi<br> Passo 1: Clicca sulla scheda Calendario del menu di navigazione per andare alla pagina di visualizzazione Calendario. <br> Passo 2: Trova I miei eventi sul lato destro della vista calendario sotto I miei calendari, fai clic sul pulsante a discesa a destra di I miei eventi e seleziona Condividi calendario. <br> Passo 3: Nel pop-up Calendario condiviso, seleziona gli utenti e i diritti di accesso con cui vuoi condividere il calendario. Inoltre, puoi anche visualizzare i record del calendario condiviso cliccando su "Chi ha attualmente accesso" e rimuovere i record condivisi cliccando sull'icona "x" a destra dei record condivisi. <br> Una volta che il calendario è condiviso, i tuoi colleghi subordinati possono aggiungere il tuo calendario degli eventi ad altri calendari e quindi visualizzare il tuo calendario degli eventi. <br> Aggiungere un calendario<br> Passo 1: Clicca sulla scheda Calendario nel menu di navigazione per andare alla pagina di visualizzazione del calendario. <br> Passo 2: Fai clic sul pulsante a discesa per altri calendari sul lato destro della vista calendario e seleziona Aggiungi calendario. <br> Passo 3: Nel pop-up Calendari condivisi, seleziona i calendari degli eventi delle persone che vuoi aggiungere. Puoi selezionare i calendari degli eventi dei tuoi subordinati così come i calendari degli eventi che sono condivisi con te. Clicca su Aggiungi per aggiungere con successo. <br> Rimuovi il calendario aggiunto<br> Clicca sul pulsante a discesa a destra del calendario che vuoi rimuovere sotto gli altri calendari e seleziona Rimuovi.`,
"label.callcenter.Seat.number":`Numero di posti a sedere`,
"vue_label_commonobjects_view_change_all_selected_records":`Cambia tutti i record selezionati`,
"label.user.notinuse":`L'utente è inattivo, contatta il tuo amministratore.`,
"label.usermanage.hasbeen.reached":`Il numero massimo di utenti con licenza è stato raggiunto, si prega di contattare il fornitore di servizi per altre licenze.`,
"vue_label_help_list":`Vista elenco`,
"label.infomation.edit":`Informazioni essenziali Modifica`,
"label.ccchat.person.setting.info":``,
"label.sso.isDelete":`È cancellare`,
"label.unique.identification.number":`Codice di identificazione unico`,
"label.weixin.no.pending.projects":`Nessun punto da approvare`,
"label.projectManagement.Pleaseenteramember":`Inserisci un membro`,
"label.salescloud.salesdashboard.visit":`Visita`,
"label.weixin.user.registered":`Registrazione utente`,
"message.loginhistory.downloadcsv":`Scarica la cronologia di accesso degli ultimi sei mesi. ( CSV )`,
"label.icon.37":`Posizionamento`,
"template.chart.schdyqyx":`Risposta attesa dalle campagne`,
"label.tel.ten":`È possibile inserire fino a 10 numeri di telefono da notificare via SMS, e ogni numero di telefono è separato da un ";".`,
"label.data.exp.objdata":`Esporterete i dati di questo oggetto secondo le seguenti condizioni`,
"label.loginservice.after.use":`dopo di che, potete usare il.`,
"pagecreator_systemstyle_message_delete":`Elimina lo stile correntemente selezionato?`,
"label.globalselect.deleteerror":`Poiché questo set di valori dell'elenco delle opzioni è usato dai campi seguenti, non può essere cancellato temporaneamente.`,
"label.department.add":`Aggiungere un nuovo dipartimento`,
"label.attendance.dingwei":`Posizione`,
"label.workflow.editrule":`Modifica Regola`,
"lable.product.pecm":`Si prega di inserire l'importo corretto.`,
"label.icon.182":`Cartella`,
"label.help.release.notes":`Note di rilascio di CloudCC R7.1`,
"UG.product.05":`Prodotto d'importazione`,
"label.email2":`Email`,
"label.weekrepeat":`Ripetizione della settimana`,
"label.mr.descreption.oneGroupReData2":`set(s)`,
"chatter.at.d":`Contributo`,
"label.mr.descreption.oneGroupReData1":`Trova i duplicati e unisci il processo: un totale di`,
"label.weixin.mobile.fly.android":`Condividi sull'applicazione mobile Android`,
"label.brackets.right":`)Chiudere la parentesi`,
"message.recordtype.applytoAllProfiles":`Applica un layout di pagina a tutti i profili`,
"label.customcomponent.page.index.tip":`Simile al modo in cui la funzione funziona in un linguaggio di programmazione, i componenti personalizzati permettono di incapsulare modelli di progettazione comuni e poi riutilizzarli in una o più pagine personalizzate.`,
"lable.List.properties":`Elenco degli attributi`,
"label.fieldinfo":`Dettagli del campo`,
"label.ems.error.fail":`Caricamento fallito, riprova o contatta l'amministratore di sistema.`,
"label_emailsync_form_email":`Email`,
"lable.currencyManage.button.manageRate":`Gestire le valute`,
"component_salesperformance_label_100finish":`Finito`,
"label.knowledgebase.data.assignment.failed":`{a} assegnazione dei dati fallita`,
"label.custom.buttonandlink.remark":`Seleziona il comportamento: Display in existing window/Display in new window (Existing window:dispaly in current window. Nuova finestra: visualizzazione in una nuova finestra)`,
"label.list.userinterface.watermark.setup":`Impostazione della filigrana`,
"component_timeline_label_7daysahead":`7 giorni prima`,
"label.sendemail.chat.replyinchat":`Commenti del post:`,
"component.salesperformance.label.title":`Prestazioni di vendita`,
"label.data.downpage.e.list.desc2":`Dopo il completamento, riceverai un'e-mail che ti ricorderà che i dati sono stati esportati con successo.`,
"vue_label_campaign_fromclosedopprotunities":`Da {sjcb} opportunità commerciali chiuse`,
"label.umeng.activity.taskviewed":`Il compito che hai assegnato a #nome viene visualizzato`,
"vue_label_salesadvance_retentions":`Numero di conservazione`,
"label.fieldtag":`Etichetta del campo`,
"label.quickbooks.button.searchinquickbooks":`Cerca in QuickBooks`,
"label.quickbooks.viewlist.action":`AZIONE`,
"label.weixin.sysapp":`App di sistema`,
"label.approval.examine.level":`Approvare e rifiutare per livello utente, il livello utente massimo è`,
"label.appupload.upload.error":`Questa App non può essere installata. Si prega di annullare l'installazione o modificare l'API all'interno del tuo sistema, e installare di nuovo.`,
"label.emailtemplate":`Modello di e-mail`,
"front-email-payment-Invoice-amount":`Importo della fattura`,
"label.viewselectedproducts":`Visualizza i prodotti selezionati`,
"label.tianyancha.businessverify.openfirst":`Si prega di abilitare la verifica dei dati aziendali`,
"lable.SalesCommitmentKanBan.returnAList":`Torna alla lista: Colleghi`,
"label.knowledgebase.nopublished.draft.translations":`Nessuna versione pubblicata o progetto di traduzione`,
"vue_label_calendar_day_view":`Vista giorno-calendario`,
"label.globalselect.remark":`Il set di valori dell'elenco delle opzioni globali permette di condividere i valori tra gli oggetti.`,
"label.orderby":`Ordina per`,
"lable.weixin.LastaDaysFinished":`Completato negli ultimi 7 giorni`,
"lable.currencyManage.Enabledadvcurrency.discripation":`Permette di gestire i tassi di cambio datati che mappano un tasso di conversione della valuta ad un intervallo di date specifico. I tassi di cambio datati sono applicati ai campi di valuta sulle opportunità, sui prodotti di opportunità e sui rapporti associati a questi due oggetti. Non sono applicati ai campi di altri oggetti o ad altri tipi di report. Per esempio, il tasso di cambio al 1° gennaio era di 1 USD per 6,68 CNY, ma il 6 febbraio è cambiato in 1 USD per 6,70 CNY. Le tue opportunità chiuse tra il 1 gennaio e il 6 febbraio usano il primo tasso di cambio (1 = 1,68), mentre le opportunità chiuse dopo il 6 febbraio usano il secondo tasso di cambio (1 = 6,70).`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.one":`Uno`,
"label.leadtoobjectfield":`Mappa dei campi lead personalizzati`,
"label.dashboardSetup.shujuyuan":`Fonti di dati`,
"label.tabpage.userz":`Utenti`,
"label.sms.companyname.dsf":`Impostazione SMS-1`,
"label.step2.total3":`Passo 2 di 3`,
"front-gantt-module-Drag-dropt- reorder-tasks":`Trascina per riordinare i compiti!`,
"label.dashboard.snapshot.no.enabled":`Funzione snapshot della dashboard non abilitata`,
"label.dashboard.unit3":`Unità: unità intera`,
"label.forecast.shrepage.desc2":`Utenti, ruoli e territori con accesso di condivisione.`,
"label.commonobjects.new":`Nuovo {eventName}`,
"label.view.nameonlyone":`Visualizza Nome Unico`,
"label.assignment.setup.newentries.user":`Utenti`,
"label.otheremails":`Altre e-mail`,
"component_sendmail_button_send":`Invia`,
"vue_label_accountpool":`Pool di conti`,
"label.h5.approval.actortime":`Data di presentazione`,
"message.approval.cannotsubmit":`Impossibile inviare per l'approvazione`,
"vue_label_pool_createdbyme":`Creato da me`,
"label.change.event":`Vista dell'evento`,
"vue_label_homepage_personalpage":`Homepage personale`,
"label.new.collect.target":`Nuovo indicatore aggregato`,
"label.ServiceCloud.zichanxuhao":`No.`,
"label.product.userl":`Colonne per tutti gli utenti`,
"label.syslog":`Registro di sistema`,
"label.reportcreatestatus":`Stato di generazione del rapporto`,
"label.datamanage.account.novalue":`Nota: se il campo nome del conto è nullo, i record del conto non saranno importati.`,
"label.letter.body":`Testo dell'invito`,
"label.select.please":`Si prega di selezionare`,
"label.escalation.setup.entrydetail.description":`1.Fare clic su Modifica per modificare le voci della regola. <br/>2.Fare clic su New per aggiungere un'operazione di aggiornamento.`,
"label.component.salesDashboard.nodata":`Aggiungi l'opportunità di business che stai usando, poi torna qui per vedere le prestazioni.`,
"vue_label_helpcenter_account":`Nelle informazioni dettagliate, fare clic sul pulsante del diagramma ad albero accanto al cliente per visualizzare il diagramma della gerarchia del cliente, capire la relazione figlio-genitore dei clienti correlati, e visualizzare alcune informazioni di campo di ogni cliente.<br> Quando si cambia il proprietario di un cliente, è possibile scegliere di cambiare il proprietario delle opportunità di business legate al cliente, casi e altre informazioni allo stesso tempo.`,
"front-kefu-moudle-v1-awshjzx-intelligent":`AWS Intelligent Service Call Center`,
"label.productby":`Generato da`,
"label.operation.date":`Operato Data`,
"label.name.donot.delete":`Il nome non può essere rimosso`,
"label.validate.function.funcFormat.DATETIMEVALUE":`DATETIMEVALUE(data)`,
"label.escalation.setup.entrydetail.howescalationtime":`Come vengono stabiliti i tempi di escalation`,
"label.view.step2":`Passo 2 Specificare i criteri di filtro`,
"lable.outlook.edit.notnull":`Dovete inserire il nome del campo.`,
"label.knowledgebase.createnewbrowser":`Nuova scheda del browser`,
"label.partner.all.name":`Nome della nuvola del partner`,
"chatter.group.groupSetUp":`Impostazioni del gruppo`,
"label.reportlist.findfolder":`Trova una cartella...`,
"component.setup.tabs.label.title":`Paginazione a schede`,
"label.passwordPolicy.setup.pswComplexReq":`Requisito di complessità della password`,
"label.emaildocument":`Inviare un documento sotto forma di emai`,
"message.selectgsummaryconditon":`selezionare i criteri di riepilogo`,
"component_todaytask_label_notask":`Non c'è nessun compito di scadenza oggi, prendete un caffè.`,
"label.user.organization.notexists":`L'organizzazione non viene trovata.`,
"label.isEnableVisualpage.new.leftlist":`Pagine personalizzate disponibili`,
"label.mobile.phone.write.week.report":`Nuove note di lavoro settimanali`,
"label.emailmerge.edittemplate.edit":`Modifica del modello di Mail Merge`,
"template.dashboard.folder.sales.manage":`Gestione delle vendite`,
"label.confirm.order.productsToassets":`Sei sicuro di voler convertire il prodotto dell'ordine in asset?`,
"label.service.dispatchingUnits.leftRight.total":`Attualmente {{ left }}-{{ right }} record, {{ totalCount }} record in totale.`,
"label.import.step1.chooseidorother":`2. È possibile scegliere di utilizzare l'ID o il nome per abbinare il record e compilare il campo di ricerca. Se hai bisogno dell'ID del record corrispondente e di altre informazioni, puoi creare un rapporto e impostare il nome del record e l'ID del record come colonne del gruppo, e poi esportare il rapporto.`,
"label_tabpage_completez":`Segna lo stato selezionato per completare`,
"chatter.c.adr":`Indirizzo`,
"label.account.d":`Questa pagina permette di definire e modificare il trimestre fiscale personalizzato. La data del trimestre fiscale personalizzato sarà generata in base alle scelte che fai qui sotto.`,
"label.tag.more50":`Crea fino a 50 tag`,
"setup.layout.label.areashow":`Visualizza l'intestazione della sezione On`,
"label.partnerCloud.basicSetting.rebate":`Attivare il rimborso`,
"label.tabpage.greaterequalz":`Maggiore o uguale a`,
"vue.please.select.the.aggregate.basis":`Selezionare le opzioni SUM BY.`,
"label.form":`Moduli`,
"label.chatter.colleagues.list.beizhu":`Abilita`,
"label.priority":`Priorità`,
"vue_label_checkduplicate_set_repeat_rules":`Impostare regole di ripetizione`,
"label.share_form":`Condividi il tuo modulo`,
"label_relation_shareholder":`Azionisti e filiali non possono essere la stessa cosa.`,
"label.project.hit.sixteen":`Promemoria della scadenza dell'emissione`,
"label.service.miniProgram.imageFormat":`Solo le immagini PNG, JPG e JPEG sono supportate per il caricamento.`,
"label.summary.mode":`Metodo riassuntivo`,
"vue_label_beforeverification":``,
"label.data.newtemplate.desc":`Salva i campi e i criteri selezionati dagli utenti come modello e gli utenti possono esportare i dati direttamente dal modello di esportazione dei dati.`,
"lable.evaluation.badreview":`Cattivo`,
"label.total.tabs":`{0} Totale {1}`,
"label.emailmerge.mergeFolder.foldertemplate":`Modelli in questa cartella`,
"vue_label_normal_notice_repeated":`Per favore non aggiungere ripetutamente`,
"label.icon.140":`Dati`,
"label.fromonetoanother":`da un utente all'altro`,
"label.user.list":`Tutti gli utenti`,
"label.file.prevent.share.operate":`Impedire agli altri di condividere e non condividere`,
"label.app.detail":`Dettagli dell'applicazione`,
"label.h5.similar.opportunity.correlation":`Relatività`,
"label_emailtocloudcc_filed_username":`Indirizzo e-mail`,
"vue_labe_account_shareholdingratio":`Rapporto di partecipazione`,
"label.data.dataexpalltype.all_desc3":`3. I dati esportati con successo genereranno un file compresso che gli utenti possono scaricare dalla pagina della lista di successo dell'esportazione secondo le informazioni contenute nella mail.`,
"label.callcenter.please.select .seatID":`Si prega di scegliere il numero di posto`,
"label.remark.length.cannot.than":`La descrizione non può includere più di 255 personaggi.`,
"label.batchtransfer.dateandtimetype.tip":`Per i campi data/ora, inserite il valore nel seguente formato:`,
"label.component.helper.businesschange.0UntreatActivity":`Opportunità senza attività non elaborate`,
"front-project-module-v1-plase-input-start-time":`Inserisci la data di inizio`,
"label.event.moveup.6hour":`6 ore avanti`,
"label.data.exp.tempexp":`Esportazione per modello`,
"label.schedulejob.setup.schedule.afternoon":`PM`,
"label.ems.format":`Formato`,
"label.objectHasBeenDeleted":`Oggetti cancellati`,
"label.ServiceCloud.chaxunchenggong":`Cercato con successo`,
"label.campaign.channel.input.notice.owner":`Avvisare il proprietario`,
"label.bajisitan.time":`Ora del Pakistan`,
"label.warnMes":`Oggetto referenziato, cancellazione fallita.`,
"lable.Up.to.ten.fields":`Scegli un oggetto e aggiungi fino a 10 campi al grafico. Clicca sulle frecce su e giù per ordinare i campi.`,
"label.approverule":`Regole di approvazione`,
"message.error.specific":`Restituire un messaggio di errore specifico`,
"front-template-V1-saveUse":`Salva & Anteprima`,
"label.uploadfile.success":`caricato con successo`,
"label.tabname.donot.database.key":`Il nome della scheda non può essere una parola chiave del database`,
"message.recordtype.selectlayout.select":`-Selezionare il layout della pagina--`,
"front-detail-module-v1-list-cardview":`Vista elenco/scheda`,
"label.product.maintenance":`Manutenzione`,
"vue_label_helpcenter_approve":`1. Elementi da approvare<br> Elenca tutti gli elementi che hanno bisogno della tua approvazione. Puoi cercare i record da approvare in base alla data di inizio, alla data di fine, al presentatore, al tipo di record e agli elementi correlati del record di approvazione.<br> Elabora un singolo record: Fai clic sul pulsante sinistro di ogni record.<br> A. Approvazione<br> Passo 1: Fai clic su "Approva" per aprire la pagina della richiesta di approvazione<br> Passo 2: Fai clic su "Approva" o "Rifiuta" per completare l'operazione di approvazione.<br> Se il passo successivo nella configurazione del processo di approvazione ha bisogno di selezionare manualmente un approvatore, il passo 3 viene eseguito dopo "Approvazione".<br> Passo 3: Seleziona il prossimo approvatore per completare l'operazione di approvazione.<br> Se devi selezionare il passo di ritorno dopo che l'approvazione è rifiutata nella configurazione del processo d'approvazione, vai al passo 4 dopo "Rifiuta".<br> Passo 4: seleziona il passo di approvazione da restituire per completare l'operazione di approvazione.<br> B. Ridistribuzione<br> Passo 1: Fare clic su "Riassegna"<br> Passo 2: Trovare il riassegnatario<br> Passo 3: Fare clic su "Riassegna richiesta di approvazione" per completare la riassegnazione degli approvatori.<br>Nota: Se sei il vice approvatore di un record, non puoi eseguire l'operazione di riassegnazione.<br> Elabora in batch più record: Dopo aver selezionato più elementi da approvare, clicca sul pulsante dell'operazione sopra la lista.<br> C. Approvazione<br> Passo 1: Seleziona più record da approvare<br> Passo 2: Clicca "Approva"<br> Passo 3: Clicca "Approva" o "Rifiuta" per completare l'operazione di approvazione.<br> Se hai bisogno di selezionare il passo di ritorno dopo che l'approvazione è rifiutata nella configurazione del processo di approvazione, vai al passo 4 dopo "Rifiuta".<br> Passo 4: Seleziona il passo di approvazione da restituire per completare l'operazione di approvazione.<br> D. Ridistribuzione<br> Passo 1: Seleziona più record da approvare<br> Passo 2: Clicca su "Riassegna"<br> Passo 3: Trova i riassegnatari<br> Passo 4: Clicca su "Riassegna richiesta di approvazione" per completare la riassegnazione degli approvatori.<br> 2. Progetti inviati<br>. Progetti inviati<br> Elenca tutti gli articoli approvati che hai inviato. Puoi cercare rapidamente il record che vuoi visualizzare attraverso la data di inizio, la data di fine, il presentatore, il tipo di record, gli elementi correlati e lo stato di approvazione del record di approvazione.<br> 3. I miei progetti approvati<br> Elenca tutti gli elementi approvati che hai approvato. Puoi cercare rapidamente il record che vuoi visualizzare attraverso la data di inizio, la data di fine, il presentatore, il tipo di record, gli elementi correlati e lo stato di approvazione del record di approvazione.<br> 4. Articoli rifiutati <br> Elenca tutti gli articoli approvati che hai rifiutato. Puoi cercare rapidamente il record che vuoi visualizzare attraverso la data d'inizio, la data di fine, il presentatore, il tipo di record, gli elementi correlati e lo stato di approvazione del record di approvazione.`,
"label.knowledgebase.knowledge.article":`Articolo sulla conoscenza`,
"march":`Marzo`,
"label.accraditation":`Approvare`,
"vue_label_pool_cantreach":`Non riesce a raggiungere il cliente`,
"label.service.appointmentList.startOf.maturityPeriod":`Inizio del periodo di scadenza`,
"message.huanxin.closed":`Funzione chat inattiva`,
"label.implementation.time.operation":`Eseguire i lavori programmati`,
"label.setting.intergrationlist.permissions":`PERMESSI DI INTEGRAZIONE`,
"label.translation.norecord":`Nessun record`,
"label.lack.expression":`L'espressione è persa`,
"setup.layout.message.relatedlistfield":`Seleziona i campi da visualizzare nella lista correlata.`,
"label.group.file":`File di gruppo`,
"message.error.id.null":`Nessuna informazione id di questo tipo`,
"label.a_b_least":`Ogni record "A" deve avere almeno un record "B" correlato.`,
"label.addattachment.step3":`Passo 4 Fare clic su "Completa" per tornare alla pagina precedente.`,
"label.data.exportsf":`File esportati`,
"label.callcenter.call.out":`Chiamare`,
"front-electronic-export-exportIntro":`I dati selezionati saranno esportati nella lista Mailchimp che hai selezionato`,
"label.custombutton.deletedata.notnull":`I dati cancellati non possono essere vuoti.`,
"UG.homepage.002":`Gestisci i tuoi indizi, i lead, i funnel delle transazioni di vendita e le informazioni sugli account con strumenti di business integrati`,
"label.globaloperation":`Operazione globale`,
"label.icon.58":`Lavoratore`,
"vue_label_salesadvance_lostrate":`Tasso di abbandono`,
"chatter.from":`da`,
"front-epwechat-module-v1-account-binding":`Vincolare sul conto`,
"label.list.userinterface.old.page.setup":`Vecchia pagina`,
"label.forecast.settings.periods":`&nbsp;ciclo(i)`,
"label.file.share.email.content":`#sharedBy ha condiviso un file con te su #orgname`,
"label.knowledge.category.hint.five":`Impostazione della categoria dei dati`,
"setup.layout.label.selectedfield":`Seleziona i campi`,
"label_business_income":`Reddito da opportunità di business`,
"vue_label_display_options_field":`Mostra i campi della lista di scelta`,
"label.emailtocloudcc.set":`Impostare le informazioni della cassetta postale`,
"label.knowledge.setting.data.five":`Elimina la categoria: {lbmc}`,
"front-epwechat-module-v1-bound-enterprise":`Impresa vincolata`,
"label.ccpeak.delete.recycle":`Il record sarà rimosso nel cestino`,
"label.leadconvers.tip":`I lead non possono essere convertiti in account, contatti, opportunità e attività di follow-up. Dovresti convertire un lead solo dopo averlo identificato come qualificato.`,
"label.rsa.key.invalid":`La chiave pubblica non è valida, effettua nuovamente il login.`,
"label.mobile.bind.success":`Legare con successo`,
"label.emailtocloudcc.filed.servertype":`Server di posta elettronica`,
"label.user.new":`Nuovo utente`,
"label.setup.mobile.homepageshortcuts.remark":`Le organizzazioni possono impostare le funzioni swift a livello di organizzazione mostrate nell'area superiore della homepage in base allo scenario aziendale.`,
"label_emailtocloudcc_select2":`Seleziona il tipo di display`,
"page.send.email":`Inviare un'e-mail`,
"label.service.newBuildDialog.field.display":`Campi da visualizzare`,
"vue_label_homepage_card_impending":`Opportunità imminenti`,
"label.message.contactispartner.delete":`Un utente partner è associato a questo contatto, non può essere cancellato`,
"label.attendance.checkout":`Check Out`,
"label.emailmerge.newtemplate.description":`Nota che la descrizione viene visualizzata solo in CloudCC.com, non in Word.`,
"laebe.data.exp.success":`Dopo aver esportato con successo, riceverai un promemoria via e-mail. I dati esportati saranno salvati sul server per 48 ore. Si prega di scaricare dalla pagina dell'elenco dei dati esportati il più presto possibile.`,
"lable.Maximum.number":`È consentito un massimo di 50 caratteri per il nome del modello.`,
"label.projectManagement.drag.and.drop.existing.tasks":`Trascinare un compito esistente nella categoria corrente`,
"label.forecast.tree.desc":`La gerarchia delle previsioni determina come le previsioni si arrotolano all'interno dell'organizzazione e chi può visualizzarle e modificarle. Viene generata automaticamente in base alla gerarchia dei ruoli, ma potrebbe essere necessario aggiungere o modificare manager, rappresentanti di vendita o altri utenti.`,
"vue_label_chatter_upload_file_type":`Post selezionato per il caricamento del tipo di file`,
"front-lightning-module-v1-dashborad-analysis-dimension":`Dimensione di analisi`,
"vue_label_homepage_custom_homepage":`Homepage personalizzata`,
"label.icon.39":`Posizionamento`,
"label.appointmentpage.wizard.notif1":`Per favore, scegliete prima un'ora!`,
"vue_label_report_filterby":`Filtra per {screenCondition}`,
"label.argentina.time":`Tempo argentino`,
"label.role.assign.notremove":`Impossibile rimuovere gli utenti da <b>Utenti selezionati</b> a "Tutti gli utenti attivi e non assegnati" o "Tutti gli utenti non assegnati".`,
"label.sharerule.detailsetshare":`Condividere i dettagli della regola`,
"label.file.publicview.error1":`Il file è cancellato o il link pubblico non è abilitato`,
"label.data.downpage.e_title.num4":`4. I file di esportazione hanno due formati: Il formato CSV e il formato di compressione. Il formato di compressione è diviso in due tipi: uno è quello di generare automaticamente la password del file compresso, l'altro è quello di inserire manualmente la password del file compresso.`,
"label.knowledge.case.article":`Caso Articolo`,
"label.data.newtemplate.e.conditions":`Condizioni di esportazione`,
"front-object-change-owner":`Il proprietario del record degli elenchi correlati che corrisponde a questo proprietario dell'account sarà anche cambiato al nuovo proprietario`,
"label.newdashboardpage.edittitle":`Modifica del titolo`,
"label.datamove.end.query.no.record":`Fine della query, nessun record qualificato.`,
"lable.SalesCommitmentKanBan.receiptsTarget":`Obiettivo delle entrate`,
"label.orderagain":`Riordina`,
"vue_report_dashboard_transfer":`Spostare la cartella`,
"label.view.sortview.default":`Vista predefinita`,
"label.brasilia.time":`Ora legale di Brasilia`,
"label.industrialandcommercialverification.instructions":`Abilita la verifica dei dati industriali e commerciali per aiutare l'utente a inserire correttamente le informazioni di registrazione industriale e commerciale del cliente. Si prega di notare che questa funzione supporta solo l'interrogazione delle informazioni di registrazione industriale e commerciale nella Cina continentale.`,
"label.chatter":`Messaggio sulla nuvola`,
"label.sso.goBackToList":`Ritorna alla gestione della lista1akey`,
"label.mobile.side.tab.state":`Avviare il cursore personalizzato`,
"label.weixin.addbus":`Aggiungere veicoli`,
"label.dropbox.description":`Collega il tuo account DropBox per utilizzarlo in CloudCC.`,
"label.service.newBuildDialog.available.tousers":`Imposta questo filtro disponibile per tutti gli utenti.`,
"label.knowledge.language.thai":`Thai`,
"label.passwordPolicy.setup.foreverlock":`Per sempre (deve essere resettato dall'amministratore)`,
"label.bmap.unreported.location":`Non hai condiviso le informazioni sulla tua posizione. Si prega di impostare l'account ufficiale WeChat.`,
"label.tag.field":`Tags`,
"label.addyourlanguage":`Clicca su Aggiungi per aggiungere le lingue supportate dalla tua organizzazione.`,
"label.chat.topic.my.use":`Argomenti che uso`,
"UG.contact.06":`Importazione di contatti`,
"label.embed_code":`Incorporare il codice`,
"label.campaign.channel.input.chenben":`3. Costo effettivo:`,
"label.quickbooks.estimates":`Stime`,
"label.report.items.i.created":`Rapporti che ho creato`,
"label.forecast.edit.fwqd":`Inizio gamma`,
"label.validate.function.funcExplain.DATEVALUE":`Creare una data dal suo datetime`,
"vue_label_helpcenter_calendar1.1":`Gli eventi sono uno strumento potente per assicurarsi di capire sempre le relazioni con i clienti e chiudere gli affari. Puoi associare gli eventi a opportunità, lead, clienti e contatti. La vista calendario visualizza principalmente i record degli eventi.<br> 1. Vista calendario e vista elenco<br>Visualizza calendario<br> Clicca sulla scheda calendario del menu di navigazione per accedere alla pagina del calendario. <br>Vista calendario<br> Classificazione delle viste calendario: Le viste del calendario sono divise in vista del mese, vista della settimana, vista del giorno e vista della disponibilità. I dati registrati di diversi intervalli di tempo possono essere visualizzati separatamente attraverso diversi stili di griglia. La vista disponibilità visualizza i dati registrati giornalmente con ogni calendario come dimensione, incluso il mio calendario e altri calendari. Fare clic sull'icona "pulsante del calendario" in alto a destra della pagina del calendario per cambiare vista. <br> Cosa può essere visualizzato nella vista calendario: Calendario include il mio calendario e altri calendari. Puoi visualizzare il mio calendario nella vista calendario, inclusi tutti i dati registrati del mio calendario eventi e del calendario oggetti. Ci riferiamo a queste registrazioni come "voci del calendario". <br> Puoi vedere tutti gli eventi che hai nella vista calendario. Il calendario che crei con l'oggetto mostrerà i dati come voci di calendario nella vista calendario nel campo data. Puoi anche visualizzare altri calendari nella vista calendario, cioè puoi visualizzare tutte le voci di calendario condivise dai tuoi colleghi che hai aggiunto alla vista. <br>`,
"label.tabpage.rowsz":`Cancellare le righe`,
"label.file.library.managemembers.memberlist":`Membri attuali`,
"label.report.action.addtodashboard4":`Aggiungi a Exsiting Dshboard`,
"label.chat.send.voice":`Inviare un messaggio vocale`,
"label.home.dashboard.add":`Aggiungi ai cruscotti della homepage`,
"front-dialog-module-v1-copied-requestid":`L'ID della richiesta è clonato`,
"label.customfields.exportdata":`Esportazione di dati`,
"label.emailobject.signature":`Firma`,
"label.hide.source":`Nascondere il codice sorgente`,
"label.icon.71":`Servizio`,
"vue_label_help_whatslightning":`Cos'è il fulmine`,
"report.type.label.systemReport":`Rapporti di sistema`,
"front-kefu-moudle-v1-input-email":`Inserisci l'indirizzo email`,
"label.event.moveup.5minutes":`5 minuti avanti`,
"message.error.postsid.null":`L'ID del post non può essere vuoto!`,
"UG.Account.05":`Diagramma della struttura di contatto`,
"label_emailtocloudcc_description3":`Collega il tuo account e-mail aziendale, come sales@company.com, info@company.com, support@company.com. Registra automaticamente le e-mail ricevute come lead e record di casi in CloudCC per garantire un follow-up tempestivo delle lettere dei clienti.`,
"report.label.searchresult":`Risultati della ricerca`,
"vue_label_report_detailsonly_desc":`Esporta solo le righe di dettaglio. Usa questi dati per ulteriori calcoli o per caricarli in altri sistemi.`,
"label.partnerCloud.partnerAccount.payment":`Importo del pagamento:`,
"vue_label_commonobjects_view_select_member":`Seleziona il membro`,
"label.emailtocloudcc.step1.lead1":`Email al leader`,
"label.forecast.settings.current":`Periodo corrente`,
"label.canceluploadfile":`Annulla il caricamento`,
"label.manual.shared":`Condivisione manuale`,
"label.document.uniquename.length.cannot.than":`La lunghezza del nome unico del documento non può superare i 255 caratteri.`,
"vue_label_lead_notcreateopportunity":`Non creare opportunità`,
"APPIntegration.Social.twittererror":`Devi inserire un URL valido per twitter.com`,
"message.duplication.label.errormessage":`Messaggio di errore`,
"label.file.img":`Immagine`,
"label.tabpage.sum":`Conteggio totale?`,
"label.permission.systempermission.fenpei":`Assegnazione del permesso`,
"template.dashboard.folder.data":`Analisi dei dati`,
"label.sms.account":`Account utente`,
"label.product.filter":`Filtro prodotti`,
"label.file.content":`Contenuto del testo`,
"label.percent":`Percentuale`,
"label.single.attachment":`Singolo`,
"label.processsetting.failed.enable.process":`Impossibile attivare il processo`,
"label.view.modify":`Modifica`,
"label.knowledgebase.enter.keywords.filter":`Inserisci le parole chiave per filtrare`,
"label.tabpage.uploadfailez":`Caricamento fallito, si prega di ricaricare.`,
"label.please.enter.the.target.model.name":`Inserisci il nome del modello di destinazione.`,
"label.layout.availabletab.related":`relativo`,
"label.label":`Etichetta`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.saturday":`Sabato`,
"label.addattachment.unit":`byte`,
"vue_label_commonobjects_view_selected":`{checkedLength} record selezionato`,
"label.view.sortview.printble":`Stampabile`,
"label.umeng.insert.approval.approvaling":`#Il richiedente presenta #obj #objname per la tua approvazione`,
"label.forecast.customforecast.tztotal":`Importo totale rettificato`,
"label.ccchat.failtoset":`errore di impostazione di ccchat`,
"label.ccchat.message.new.error2":`Utente CCChat`,
"label.validate.function.category.Advanced":`Avanzato`,
"label.projectManagement.team.members":`Membri della squadra`,
"vue_label_report_clickcrosstofliter":`Clicca sulle intersezioni nella tabella qui sopra per filtrare i dettagli.`,
"lable.opppdt.selPdt.leasttwenty":`È possibile selezionare fino a 25 linee`,
"label.campaign.channel.download":`Scaricare HD QR Code`,
"component_event_label_person":`Persona assegnata`,
"vue_label_homepage_new_homepage":`Nuova pagina iniziale`,
"label.version.sum.vlidaterule":`Regole di convalida`,
"vue_label_chat_click_for_details":`Clicca per i dettagli`,
"label.fold":`Piegare`,
"label.readonly":`Solamente lettura`,
"label.h5.similar.opportunity.result":`Opportunità simili`,
"label.yourimportsuc":`La tua richiesta di importazione è stata elaborata, per favore visualizza la tua email.`,
"label.report.line.yixuan":`Colonna del rapporto selezionato`,
"setup_layout_label_areaname":`Nome della sezione`,
"label.forecast.edit.title":`Obiettivo`,
"label.chatter.allweather":`Tutto il tempo`,
"label.service.ganttBaiduMap.scheduled.endtime":`Data di fine prevista`,
"lable.create.new.list":`Nuovo elenco`,
"label.emailobject.groupemail.msg3":`{0}mail`,
"lable.opppdt.selPdt.description":`Inserisci la tua parola chiave e i criteri del filtro.poi clicca su Cerca per iniziare la ricerca Clicca su Più filtri per usare più di un filtro.I risultati della ricerca includono tutti i record che corrispondono sia alla tua parola chiave che alle voci del filtro.`,
"label.file.versionerror1":`Puoi cliccare il link qui sotto per passare direttamente alla scheda file della nuova interfaccia, oppure puoi usare la funzione scheda file dopo essere passato manualmente alla nuova interfaccia`,
"label.under.approve.record":`In attesa di`,
"front-epwechat-module-v1-open":`Abilita`,
"label.projectManagement.delete.task":`Tutte le informazioni relative a questo compito saranno cancellate se si elimina questo compito, e i dati non possono essere recuperati. Sei sicuro di confermare la cancellazione?`,
"label.reportforms":`Rapporti`,
"label.tabpage.onlymevisible":`È visibile solo a me`,
"label.customer.tab.please.name":`Inserisci il nome della scheda`,
"label_emailsync_form_stutas":`Stato`,
"message.recordtype.nolist":`Nessun tipo di record definito.`,
"label.version.forecasting.sales":`Previsioni`,
"chatter.sel.mostfield":`È possibile selezionare fino a`,
"label.data.derived":`Esportazione di dati`,
"label.component.helper.businesschange.expiredtask":`Opportunità con compiti in ritardo`,
"label.cycle":`Ciclo`,
"lable.product.standp":`Prezzo standard`,
"label.sendemail.batchapproval":`Operazione di approvazione dei lotti`,
"message.organization.not.open.mffverification":`L'organizzazione non abilita la certificazione secondaria.`,
"label.icon.131":`Ombrello`,
"UG.activity.08":`Prenota un programma`,
"label_partner_workspace_member_choicepermission":`Seleziona il set di permessi`,
"label.reportTypeCategory":`Fonte dei dati del rapporto`,
"label.exporttwotype":`È possibile esportare due tipi di testo`,
"message.oppdt.selectpricebook":`Si prega di selezionare il prezzo del libro`,
"vue_label_dashboard_generatefromlistview":`Generare dalla vista elenco`,
"label.quote.title":`Titolo`,
"label.tianyancha.businessverify.cancel.sure":`Dopo aver disabilitato la verifica dei dati aziendali, è impossibile riempire nuovamente le informazioni di registrazione dell'azienda quando si crea/modifica un cliente. è confermato?`,
"label.save":`Salva`,
"label.mobile.quickcreate.default.appstore":`Applicazioni`,
"label.partnerCloud.orderingPlatform.configure":`{a} i prodotti non sono configurati, salva dopo la configurazione.`,
"front-epwechat-module-v1-unbound-role":`Ruoli non vincolati`,
"label.partnerCloud.financeSetting.enterAlipay":`Si prega di inserire l'acocunt aziendale di Alipay.`,
"label.validate.function.funcExplain.TODAY":`Torna alla data corrente`,
"label.visualpage.parameter.values":`Visualizza i valori dei parametri direttamente sulla pagina:`,
"label.version.task.and.activity":`Compiti e attività`,
"label.audit.history":`Storia dell'approvazione`,
"setup.object.field.dependency.label.addtolist":`Aggiungere i valori selezionati`,
"vue_label_report_exportquantity":`Quantità di esportazione:`,
"label_tabpage_havez":`Allegato`,
"label.partnerCloud.partnerAccount.amountOfRebate":`Importo del rimborso disponibile`,
"label.createralias":`Creato da Alias`,
"label.created_followup":`Creare email di followup`,
"label_chatter_mygroups":`I miei gruppi`,
"label.chat.topic.no.display":`Nessun argomento visualizzabile`,
"vue_label_calendar_month_view":`Vista calendario-mese`,
"label.service.gantt.resources.assigned.work":`Risorsa con lavoro assegnato`,
"UG_activity_07":`Creare un compito`,
"label.quote.xsjg":`Prezzo di vendita`,
"message.toomanyrows":`Troppi record da interrogare.`,
"label.importsourcestep1":`Passo 1 Preparare il file separato per schede tradotto`,
"vue_label_normal_appointment_sf":`Appuntamento`,
"lable.list.queue.message":`La coda non può essere cancellata, perché ci sono record di oggetti che appartengono alla coda.`,
"label.service.major.event.desc":`La pietra miliare rappresenta i passi dipendenti dal tempo nel processo di supporto. Può essere aggiunta all'inizio del processo di autorizzazione. Puoi poi applicare il processo agli account entitlement e creare casi o ordini di lavoro da essi.`,
"label.ems.hostorport.null":`Sia il server che la porta non possono essere vuoti.`,
"chatter.group.private":`Privato`,
"label.icon.192":`Barretta di sapone`,
"vue_label_systemSettings_list":`Impostazione del display della lista correlata`,
"label.activity.saveobj.notnull":`L'oggetto salvato non può essere vuoto.`,
"vue_label_chatter_current_no_people_approval":`Attualmente nessuna persona che richiede l'approvazione`,
"label.tianyancha.reglocation":`Indirizzo registrato`,
"UG_ST_005":`Ho capito, non mostrarmi più questa pagina e accedi direttamente la prossima volta.`,
"label.vlidaterule.example.truetodisplay":`Questo messaggio apparirà quando la formula Error Condition è vera`,
"label.icon.99":`Note`,
"label.whenselectmoreapprover":`Quando si seleziona più di un approvatore`,
"label.forecast.customforecast.directorbest":`Il miglior caso di subordinazione diretta`,
"label.customsetting.view.introduce":`Fornisci i valori per i campi che hai creato. Questi dati vengono memorizzati nella cache dell'applicazione.`,
"label.there.are.no.unenabled.rules":`Tutte le regole sono abilitate.`,
"front-project-module-v1-plase-selectemplat":`Seleziona il modello del progetto`,
"label.campaignmember.selectmember.from":`Da`,
"setup_layout_button_quicksave":`Salvataggio rapido`,
"label.setup.service.report":`Impostazione del modello di rapporto di servizio`,
"label.visualpage.direction.for.use":`Istruzione delle pagine Custome [versione 2.0]`,
"message.modify":`Sei sicuro di voler modificare?`,
"label.sms.inside":`Interno`,
"label.category.3":`Educazione`,
"label.login.mfadevice.verification.title":`Verifica dei dispositivi MFA`,
"UG_Forcast_08":`Passo precedente`,
"label.projectManagement.unable.to.complete":`Impossibile completare`,
"front-kefu-moudle-all-missphone":`Tutte le chiamate perse`,
"font-evaluate-module-v1-emergency":`Attenzione`,
"label.sso.saml.sp.idsource.attr":`L'identità è in un elemento Attributo`,
"chatter.not.meg":`Impossibile inviare un messaggio vuoto.`,
"label.chatter.startDate":`Dati di partenza`,
"label.emailobject.track.times":`Totale aperture: {0}`,
"label.customsetting.fieldhasbeendeleted":`Campi cancellati`,
"label.knowledge.setting.hint.thirteen":`Aggiungi un'altra categoria di dati`,
"message.duplication.label.newfiltertitle":`Nuova regola dei duplicati`,
"setup_object_field_dependency_label_selectedfieldvalue":`Valori di campo disponibili`,
"vue_label_calendar_who_currently_has_access":`Chi ha attualmente accesso`,
"message.passwordPolicy.validate.minlengthe":`personaggio(i)`,
"label.emailsync.status.disconnect":`Cancella Conncet`,
"label.applt.down.one":`Scaricare con un solo tocco`,
"label.manageAll.sel.one2":`Articoli che ho presentato`,
"message.error.SQLTimeout":`A causa di una configurazione impropria del sistema o di query SQL personalizzate non ottimizzate, il sistema ha superato la capacità di query consentita, causando il fallimento della query. Contatta l'amministratore di sistema per la messa a punto del sistema.`,
"label.global.search.obj.setup":`Impostazioni globali degli oggetti ricercabili`,
"vue_label_commonobjects_view_chat":`Squadra`,
"vue_label_systemSettings_startSet":`Impostazione dell'avvio`,
"label.quickbooks.viewlist.balance":`BILANCIA`,
"message.error.fieldid.null":`fieldid non può essere vuoto! Id del contenuto del file`,
"label.replaceallnullvalue":`Sostituisci tutti i valori vuoti`,
"label.georgia.time":`Tempo della Georgia`,
"label.hastransfer":`Contiene Convertito`,
"label.partner.all.description":`Descrizione`,
"font-evaluate-module-v1-following-peopple":`Quando hai ricevuto la recensione negativa, informa i seguenti utenti`,
"label_business_count":`Importo dell'opportunità di business`,
"vue_label_ccchat_closedetail":`Chiudere`,
"label.partner.all.disable":`Disattivare`,
"label.view.relationship":`Relazioni tra oggetti`,
"label.noless":`>=Maggiore o uguale`,
"label.sendsms.batch.step2":`Passo 2 Seleziona un modello o personalizza il contenuto del tuo SMS`,
"label.stdashbord.xsld.business.jieduan":`Nome della fase`,
"label.appupload.component.type.trigger":`Trigger`,
"label.knowledge.setting.data.two":`Il nome della categoria è richiesto.`,
"label.color.display.of.completion.rate":`Visualizzazione a colori del tasso di adempimento`,
"label.loginhis.default":`Elenca le ultime 200 cronologie per impostazione predefinita`,
"vue_label_pricebook_book":`Listino prezzi attuale`,
"label.knowledgebase.data.deletion.failed":`{a} cancellazione dei dati fallita`,
"label_partner_workspace_member_permission":`Permessi disponibili impostati`,
"label.list.userinterface.approval.setup":`Impostazione dell'approvazione`,
"label.weixin.binding.effect":`Il legame non è valido, si prega di effettuare nuovamente il login.`,
"label.appupload.install.newapicannotnull":`Il nome della nuova api non può essere vuoto`,
"chatter.feed.menutype.feed.company":`Tutta l'azienda`,
"label.assignment.setup.detail.email":`Email`,
"label_tabpage_selectcontentz":`Seleziona il contenuto`,
"template.report.converted.leads.campaign":`Leads convertiti dalle campagne`,
"label.forecast.season":`Questo trimestre`,
"label.post":`Invia`,
"label.knowledge.setting.hint.fifteen":`Le fondamenta sono state gettate. Ora tu e il tuo team potete scrivere e organizzare i vostri articoli di Knowledge.`,
"front-kefu-moudle-v1-Seats-name":`Soprannome dell'agente`,
"label.weixin.leadname":`Nome del piombo`,
"label.account.quarter":`Trimestre`,
"label.detail.field":`Visualizza i campi`,
"label.icon.189":`Cosmetico`,
"label.appointment.disable.reappointment":`Disattivare Riprogrammare`,
"label.appointmentconfirmpage.wizard.subtitle1":`Nome dell'evento`,
"label.campaign.channel.step6.remark3":`Il sistema genererà un codice QR unico per la sollecitazione, che può essere utilizzato dai dipendenti e le sollecitazioni realizzate possono essere contate per le loro prestazioni personali.`,
"System.AddressFieldType.Post":`Codice postale`,
"label_partner_new_step2":`Passo 2 Confermare il modello`,
"vue_label_helpcenter_file":`Visualizza e gestisci i tuoi file<br> Usa la nuova versione dell'oggetto file per visualizzare e gestire i file di tua proprietà o condivisi da altri. Puoi vedere in anteprima i file in alcuni formati online. <br>Libreria di file<br> Usa la funzione di libreria di file per stabilire una base di conoscenza del team, impostare diversi amministratori e membri per una gestione conveniente; usa la funzione di cartella per classificare i file.`,
"label.locateddowncurrentvalue":`Il valore inferiore a quello corrente`,
"label.tianyancha.businessverify.msg5":`2. affidabilità del servizio`,
"label.setup.mobile.bottombutton.change.success":`Cambiato con successo`,
"label.appointmentconfirmail.wizard.subtitle2":`Tempo`,
"label.email.address.lookup":`Cerca indirizzo e-mail`,
"setup.mainpage.label.welcome":`Benvenuti nella piattaforma CloudCC PaaS, le funzioni principali della piattaforma sono le seguenti:`,
"label.icon.55":`Bulldozer`,
"label_tabpage_enterrecordnamez":`Inserisci il proprietario del record`,
"label.tabpage.andz":`E`,
"label.selectfiletoimport":`Seleziona il file da importare`,
"label.version.sum.trigger":`grilletto(i)`,
"label.multi.layout":`Layout compatti`,
"pagecreator.button.back":`Ultimo passo`,
"label.imgfield.truetype":`Si prega di caricare il tipo di immagine corretto`,
"front-kefu-moudle-v1-publicKey":`Chiave condivisa`,
"label.data.exp.newtemp":`Creare un modello`,
"label.martrixreport.2018.step4.new":`Passo 4 Scegliere le intestazioni di colonna`,
"label.sendemail.chat.addComentsatsubject":`Sono stato menzionato nel messaggio di CloudCC CCChat`,
"vue_label_applauncher_description_leadpool":`Usate il Lead Pool per gestire comodamente lo stato di follow-up all'interno dell'organizzazione e motivare il personale a completare le transazioni.`,
"label.knowledgebase.archive.published.articles.without.drafts":`Puoi archiviare solo gli articoli pubblicati che non hanno bozze.`,
"label.projectManagement.bar.chart":`Grafico a barre`,
"label.ccpeak.condition.return.sort":`Ritorno e ordinamento per condizioni`,
"label.salescloud.opportunity.contactrole":`Opportunità Contatto Ruolo`,
"label.language":`Lingua`,
"message.error.view.badprevilege":`Siamo spiacenti, non ti è permesso servire questo servizio, per favore contatta il tuo amministratore.`,
"label.textmessage.managetemplates":`Gestire i modelli`,
"message.error.type.null":`Il tipo non può essere nullo!`,
"setup.mainpage.label.welcome9":`Gli utenti possono realizzare la visualizzazione della classificazione e la regolazione del layout di tutti gli elementi della pagina e l'impostazione dei campi di sola lettura e richiesti dei campi sulla pagina trascinando e rilasciando il mouse senza sviluppo di codice.`,
"label.appupload.component.type.page":`Pagine personalizzate`,
"label.textmessage.bookschedule":`Clicca il link qui sotto per vedere e prenotare il mio programma:`,
"component_chatter_post_button_save":`Pubblica`,
"lable.oppt.jieduan.signcomplete":`Segna la tappa come completata`,
"label.help.notes":`AIUTO E GUIDA`,
"label_tabpage_reallproplez":`Registra tutte le persone`,
"label.obtain.authorization.failure":`Impossibile acquisire il codice di autorizzazione. Si prega di riautorizzare.`,
"label.account.FiscalQuarter":`Trimestre fiscale`,
"label.customsetting.savecustomvalue":`I dati per questa posizione esistono già, per favore modificali e salvali di nuovo.`,
"label.maximum":`Massimo`,
"component_chatter_file_label_maxsize":`La dimensione massima del file è di 20m`,
"c218":`Il tuo post è stato salvato come bozza`,
"c875":`Nuovo post per la conversazione`,
"c183":`Filtro Tag`,
"c366":`Configurare il pool`,
"c91":`Punteggio di interazione email`,
"c184":`Avanzamento di fase`,
"c750":`Iniziatore:`,
"c619":`I post su Twitter devono avere 280 caratteri o meno. Prova a usare le contrazioni per accorciare le cose.`,
"c69":`Pagabile`,
"c675":`Allineato a sinistra`,
"c533":`Conteggio dei casi aggiornati`,
"c167":`La lunghezza dell'ordine è richiesta`,
"c682":`Piazza`,
"c960":`Edizione Super`,
"c850":`Questo mostra il numero attuale di seguaci per ciascuno dei tuoi account sociali, ad eccezione di Facebook che mostra il numero attuale di "mi piace" della pagina.`,
"c343":`Aggiungere i membri del progetto`,
"c8":`Scegliere la forma`,
"c157":`Modalità di presa dell'ordine aperta`,
"c397":`Equipaggio di servizio`,
"c556":`le immagini non sono riuscite ad essere pubblicate`,
"c563":`Tempo attivo`,
"c179":`Logo del partner`,
"c147":`Regole per la presa dell'ordine`,
"c303":`Obbligo legale`,
"c885":`Nascondi la barra laterale`,
"c808":`Inserisci immagine`,
"c718":`Continuare a impostare`,
"c414":`Grazie per il vostro tempo nel completarlo.`,
"c9":`Sollecitazione dei dipendenti`,
"c15":`È stato fatturato. Si prega di riselezionare`,
"c59":`Per favore, fai il bind come sede dell'amministratore di Easemob prima e poi entra nella configurazione avanzata.`,
"c504":`Pianificate i progetti, assegnate il lavoro, gestite le risorse e collaborate con il vostro team per raggiungere gli obiettivi del progetto, controllarne l'avanzamento e consegnare il progetto nei tempi e nei costi previsti.`,
"c836":`Vincolare il conto Fadada`,
"c187":`Pagina di ringraziamento`,
"c208":`Scarica il pacchetto`,
"c952":`Brasile`,
"c104":`Rispondi una volta`,
"c346":`Calcolo delle risorse del compito`,
"c913":`Espandi la barra laterale`,
"c571":`Il modulo {selectnumber} è stato selezionato`,
"c44":`Scegliere una rete a cui connettersi`,
"label.social.posts.content.null":`Il contenuto del post è vuoto`,
"c852":`Nome dell'azienda (non compilato)`,
"c561":`Applicare il filtro`,
"obtain.contract.envelopeid.fail":`Impossibile ottenere informazioni sulla busta o sul messaggio non vincolato`,
"c465":`Solo gli ordini che utilizzano la stessa valuta possono generare una fattura`,
"c982":``,
"c350":`Ordinamento dei compiti`,
"c352":`Calendario delle risorse del personale`,
"c670":`Icone grafiche`,
"front-electronic-signature-given":`Consegna`,
"c542":`Valutazione della soddisfazione`,
"c314":`Generare il file della fattura`,
"c148":`Impostazione della notifica via email`,
"c47":`Collegare il dominio`,
"c754":`Compilare`,
"c326":`Distinta dei beni`,
"c289":`Preferenza`,
"c196":``,
"c63":`Aprire {objName}`,
"c769":`Il documento d'incarico firmato iniziato sarà cancellato dopo la revoca. Continuare ad annullare?`,
"c216":`Il tuo post è stato programmato`,
"c842":`Inviare una notifica di presentazione via email`,
"c389":`Territorio di servizio del genitore`,
"c7":`Proprietario della promozione`,
"c981":``,
"c143":`Seleziona l'utente che deve ricevere le notifiche. Questa impostazione può essere cambiata in tutte le landing page in cui il modulo viene utilizzato.`,
"c930":`Interruttore di posizionamento dei dipendenti`,
"c515":`Aggiungi il riepilogo del lavoro`,
"c393":`Membro del territorio di servizio`,
"c357":`Vota`,
"c597":`Calibro del bersaglio`,
"front-electronic-signature-cancelIntro1":`La firma elettronica di DocuSign non sarà disponibile dopo lo scollegamento. Sei sicuro di voler scollegare?`,
"c271":`Hai un timeout di accettazione dell'ordine, numero: {0}. Si prega di occuparsene prontamente e di essere consapevoli del ritardo del lavoro. Clicca per vedere di più >`,
"label.gaode.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`Amap non funziona correttamente. Si prega di controllare se la chiave segreta è corretta!`,
"c424":`Gestione del territorio di servizio`,
"c711":`Collega i tuoi account sociali e raggiungi un intero nuovo mondo di fan.`,
"c197":`Hai raggiunto il numero massimo di invii. Grazie per la vostra partecipazione!`,
"front-electronic-signature-save-success":`Salva la mappatura con successo`,
"c765":`Bloccato`,
"c286":`Non conformità`,
"c145":`Le ore di lavoro presentate per uno o più compiti per persona al giorno non possono superare le 24 ore.`,
"c264":`Gestire i campi personali`,
"label.china":`Cina`,
"label.no.bind.mobile":`Nessun cellulare. Si prega di andare a informazioni personali e legare`,
"c95":`Elimina i prodotti selezionati`,
"front-electronic-signature-open-signInfo1":`La firma elettronica e il timbro di DocuSign sono abilitati. Disattivatelo e poi abilitate l'Esignature&stamp di Fadada.`,
"c391":`Visualizza Commento`,
"c106":`Interazioni`,
"c519":`Tutte le informazioni relative a questo timesheet saranno cancellate se elimini questo timesheet, e i dati non possono essere recuperati. Sei sicuro di confermare la cancellazione?`,
"c528":`Registra il foglio presenze`,
"c78":`Numero d'ordine`,
"c41":`Sciogliere con successo`,
"c517":`Inserisci un'aliquota fiscale valida`,
"c774":`Segno di progresso`,
"c296":`Si prega di compilare il nome del campo`,
"c757":`Accettare`,
"front-electronic-signature-confirmintro":`Legare con successo. Ora è possibile avviare la firma dall'oggetto Contracts.`,
"c446":`Stato del compito`,
"c238":`{!ServiceResource.name} ha accettato l'ordine. Account: "{!ServiceAppointment.accountid.name}", Oggetto: "{!ServiceAppointment.subject}", Numero: "{!ServiceAppointment.name}"`,
"c980":``,
"c802":`Ogni utente può essere aggiunto solo come risorsa di servizio`,
"c387":`Competenze delle risorse di servizio`,
"c965":`Il servizio EaseMob non è abilitato`,
"c480":`A quale lista dobbiamo inviare?`,
"c937":`Modifica del numero di telefono`,
"c632":`Vedi su Facebook`,
"c131":`Il campo conto della fattura è vuoto, si prega di aggiungere le informazioni.`,
"c680":`Bianco`,
"c806":`Quando`,
"c649":`Hai letto tutto quello che c'è nella tua casella di posta.`,
"c797":`Contatti recenti`,
"c616":`Aprire il link in una nuova finestra`,
"c169":`Spiacente, non hai il permesso di visualizzare questo grafico`,
"c21":`Il numero del prodotto non può essere inferiore all'importo fatturato`,
"c231":`Non può essere inferiore al numero di prodotti che ha confezionato`,
"c555":`L'immagine del tuo post non è stata pubblicata.`,
"c583":`Mappa della Cina`,
"front-electronic-signature-open-signInfo2":`La Esignature&stamp di Fadada è abilitata. Disattivatelo e poi abilitate la Esignature&stamp di DocuSign`,
"c822":`Nuovi contatti esterni`,
"c600":`Grafico numerico`,
"c442":`Sistema di gestione dei progetti a tutto tondo`,
"c762":`Per firmare`,
"label.user.not.permission":`L'utente attuale non ha il permesso di operare`,
"c35":`Nome dell'abbonamento`,
"c921":`ruolo/i`,
"c305":`Interessi pubblici`,
"c730":`Non puoi riutilizzare la vecchia password`,
"c525":`Disattivare l'utente del portale`,
"c942":`America`,
"c780":`Processo di firma`,
"c447":`Fonte del canale finale`,
"c369":`Inviare il file del preventivo`,
"c702":`Fai una bozza`,
"c22":`L'importo pagato sulla fattura sarà maggiore del valore totale se continui a creare questo dettaglio di pagamento. Per favore riaggiusta l'importo e salva di nuovo.`,
"c79":`Data dell'ordine`,
"c785":`Nome reale (opzionale)`,
"label.insert.approval.reassign.error":`L'approvazione nello stato di approvazione inserente non può essere riassegnata`,
"c273":`Timeout dell'ordine di accettazione. Annullare la spedizione.`,
"c3":`Cancellare il grafico con successo`,
"c448":`Sessione di chat`,
"c495":`Tutto ciò di cui hai bisogno per vendere più velocemente e in modo più intelligente`,
"c429":`KPI di spedizione`,
"c16":`Esiste più di un ordine fatturato. Si prega di riselezionare`,
"c128":`Si possono aggiungere fino a 5 file`,
"c955":`La larghezza minima di {label} è {minWidth}px`,
"c716":`Sei pronto per iniziare a postare direttamente da CloudCC`,
"c638":`Opzioni di pubblicazione`,
"c746":`Revocare la richiesta di distruggere`,
"c534":`Conteggio dei casi chiusi`,
"c948":`Italia`,
"c317":`Inviare il file dell'ordine di acquisto`,
"c426":`Gestione delle risorse di servizio`,
"c457":`Importo aggregato del contratto Classifica`,
"c263":`Campi personali`,
"c372":`Generare l'ordine`,
"c907":`Disponibile solo in versione lightning`,
"c771":`Riempire il progresso`,
"c408":`Applicazione di servizio sul campo personalizzabile`,
"c12":`Tasso di crescita`,
"c379":`Dettagli di pagamento`,
"c410":`Tipo di lavoro`,
"c510":`Ordinazione dei partner`,
"c701":`Assegnazione della campagna`,
"c617":`Il testo è necessario per pubblicare un post`,
"c213":`Formato EPS`,
"c473":`Il sistema genererà un codice d'invito unico per i dipendenti, che possono usare il codice d'invito per fare inviti e contare come prestazione personale. Si prega di notare che il proprietario del lead sarà l'attuale proprietario della campagna o l'invitatore del canale di marketing`,
"c975":``,
"c168":`Per favore, scegli un grafico!`,
"c121":`Uncategorized`,
"label.send.invoice":`Inviare la fattura`,
"c792":`Confermare l'avvio`,
"c686":`Dimensione`,
"c652":`Questo mostra il numero di post che sono stati pubblicati sui tuoi account nel periodo selezionato. Questo include anche i post che sono stati pubblicati sui tuoi account collegati al di fuori di CloudCC.`,
"c136":`Inserisci una breve introduzione qui`,
"c662":`Icona personalizzata`,
"label.invoice.customer.is.error":`La generazione di fatture è supportata solo per gli ordini effettuati dallo stesso cliente.`,
"c580":`Grafico a bolle`,
"c894":`Assegna la campagna per il post e puoi rivedere tutti i post correlati nella stessa campagna. Questo è usato per uno sforzo di marketing anlyazing.`,
"c570":`Design`,
"c133":`superare`,
"c564":`Caro utente: \n Benvenuto nel sistema CloudCC. Hai richiesto di reimpostare la tua password a {!operatetime}, per favore effettua il login con il codice di verifica qui sotto entro 15 minuti: \Codice di verifica casuale: {!authcode}\n Importante: Se non hai richiesto questa operazione, o pensi che questo messaggio non debba raggiungerti, per favore contatta immediatamente il tuo amministratore!`,
"c854":`Sembra che non ci sia nulla di pubblicato.`,
"c775":`Discontinued`,
"c105":`Riprodurre più di una volta`,
"c729":`Si prega di confermare che avete configurato la piattaforma sociale o no. Vai alle impostazioni del backend  Integrazioni  Abilita (Twitter/Facebook/LinkedIn)`,
"c491":`Disattivato`,
"c609":`Marchio commerciale`,
"c611":`Collegamento a`,
"c843":`Visualizza presentazione`,
"c933":`Pagina di conversione`,
"c383":`Prodotti di opportunità`,
"c186":`L'ID unico esiste già. Si prega di non aggiungere ripetutamente`,
"c608":`Sostituire`,
"c149":`Attivare la notifica da Outlook (supporta solo una parte dei servizi di posta elettronica)`,
"c486":`Rispondi all'indirizzo email:`,
"c598":`Grafico della ciambella`,
"c726":`Richiesta distrutta con successo`,
"c645":`Approvare la bozza`,
"label.verificationCode.is.invalid":`Il codice di verifica non era valido. Si prega di riacquisirlo`,
"c904":`Tra`,
"c594":`Grafico a linee 2D`,
"c103":`Clicca più di una volta`,
"c188":`commento/i`,
"c891":`Il record non può essere un contatto, un'opportunità, un lead o un account`,
"c902":`Distanza tra l'indirizzo di accesso e il visitatore`,
"c484":`Email:`,
"c421":`Metodo di generazione dell'ordine di lavoro`,
"c406":`Gestione automatizzata delle vendite`,
"c739":`Campagna: Sollecitazione dei dipendenti`,
"c329":`Sostituzione di beni`,
"c351":`Frequenza di ricorrenza`,
"c622":`Statistiche di rete aggiornate l'ultima volta a`,
"2":`Configurare con successo le opzioni di filtraggio`,
"c463":`Le mie opportunità`,
"c268":`Unire le informazioni con successo`,
"label.mobile.no.letter.blankcharacter":`Il numero di telefono non può contenere lettere e caratteri vuoti`,
"c438":`Trasferimento`,
"c581":`Tabella MoM&YoY`,
"c953":`Corea del Sud`,
"c90":`Oggetto`,
"c2":`Elimina il cruscotto con successo!`,
"c897":``,
"c444":`Sorgente del primo canale`,
"c242":`{!ServiceResource.name} ha rifiutato l'ordine. Account: "{!ServiceAppointment.accountid.name}", Numero: "{!ServiceAppointment.name}"`,
"c135":`Modello vuoto`,
"c659":`Seguitemi`,
"c773":`Finalizzazione di`,
"c11":`Promozione del Form Marketing`,
"c799":`Contatti esterni`,
"c880":`modificare i post sui social`,
"c890":`Invia l'email di invito con successo`,
"c846":`Seleziona un appuntamento di servizio idoneo`,
"front-electronic-signature-sucessSign":`Iniziare a firmare con successo`,
"c472":`Scegli un modulo su cui applicare il poster`,
"c963":`Il campo Nome è obbligatorio`,
"c390":`Territorio di servizio per l'infanzia`,
"c248":`L'accettazione del trasferimento dell'ordine è in attesa`,
"c646":`Flusso di posta in arrivo`,
"c308":`Selezionare almeno un dato`,
"c858":`Sei sicuro di voler salvare i post {a} come bozze? Questi post non verranno pubblicati a meno che tu non li programmi di nuovo.`,
"c152":`Numero di appuntamenti di servizio completati nell'intervallo di tempo attualmente selezionato / Numero di tutti gli appuntamenti di servizio nell'intervallo di tempo attualmente selezionato`,
"c316":`Visualizza lo stato di avanzamento del caso`,
"c435":`Visualizza Versione`,
"c362":`Vincoli di prodotto allegati`,
"c800":`Si prega di inserire il nome o il nome della società`,
"c415":`Inizio programmato`,
"c735":`Il nome non può essere ripetuto`,
"c903":`Seleziona l'icona dell'applicazione`,
"label.insert.approval.massreassign.error":`Le approvazioni batch esistenti Inserendo l'approvazione non possono essere riassegnate. Il sistema filtrerà automaticamente per te`,
"c354":`Modifica del foglio di lavoro`,
"c409":`Piattaforma unica per il servizio clienti`,
"c651":`Questo mostra il numero di seguaci attuali per ciascuno dei tuoi account sociali, ad eccezione di Facebook, che mostra il numero di Mi piace attuali della pagina.`,
"c582":`Mappa del mondo`,
"c826":`Sei sicuro di voler scartare le tue modifiche?`,
"c781":`Impresa: Si prega di inserire il nome dell'azienda sulla licenza commerciale. Il controllo sarà fatto al momento della firma.`,
"c873":`Più dettagli`,
"c837":`Dopo l'unbinding, la funzione Fadada Esignature non può essere utilizzata, e la funzione di autofill e backfill del campo che sono stati impostati saranno cancellati. Sei sicuro di scollegare l'account?`,
"label.diedirect.sale":`Riduzioni di prezzo dirette`,
"c798":`Contatti interni`,
"c368":`Generare un file di preventivo`,
"c770":`Iniziato`,
"c882":`Condizioni di servizio`,
"front-setting-dialog-title-two":`Impostare dalla pagina delle informazioni personali se non si inserisce questa volta. Legare mentre si inserisce il numero`,
"c535":`Irrisolto`,
"front-electronic-signature-look-account":`Visualizza l'account`,
"c19":`Modalità di visualizzazione dei dettagli di registrazione`,
"c52":`Nome della tassa`,
"c388":`Associato e diritto d'uso`,
"c18":`Esiste più di un ordine inattivo, riselezionare`,
"c820":`Si prega di inserire il numero di telefono/casella postale`,
"c285":`Panoramica`,
"c478":`Autenticare Mailchimp`,
"c164":`Inserisci un valore intero da 060`,
"label.tip.excess.quota":`L'utilizzo di questa risorsa è stato superato`,
"c318":`Generare il file dell'ordine di acquisto`,
"c698":`Rete sociale`,
"c312":`Gli ordini multipli non sono ancora effettivi, per favore seleziona di nuovo`,
"c110":`Raggruppare per progetti`,
"c549":`L'intervallo di date non può superare i 31 giorni!`,
"c845":`Si prega di selezionare almeno un appuntamento di servizio`,
"c282":`Gestire i dati personali dei clienti nel CRM`,
"c270":`Timeout dell'ordine di accettazione`,
"c288":`Modifica della base di elaborazione dei dati`,
"c878":`Indirizzo attuale`,
"c324":`Aggiungere code ai casi`,
"c129":`Questa azione cancellerà permanentemente il file. Vuoi continuare?`,
"c339":`Distruzione dei dati GDPR`,
"c405":`Dimensione dell'equipaggio`,
"c848":`Conti Linkedin`,
"c345":`Modello di progetto`,
"c591":`Mappa di Australia`,
"c180":`Lingua nella pagina di accesso`,
"c126":`Consegnato`,
"c311":`Non efficace, per favore seleziona di nuovo`,
"c587":`Mappa di Messico`,
"c37":`Questo è il testo da vedere nella pagina di preferenza della comunicazione da parte del tuo cliente`,
"c840":`Evviva! Nessun post senza successo.`,
"c241":`{!ServiceResource.name} ha rifiutato l'ordine. Account: "{!ServiceAppointment.accountid.name}", Oggetto: "{!ServiceAppointment.subject}", Numero: "{!ServiceAppointment.name}"`,
"c141":`Il messaggio di ringraziamento è richiesto`,
"obtain.contract.fail":`Mancata acquisizione di informazioni sul contratto`,
"c945":`Russia`,
"c454":`Importo del contratto mensile`,
"c34":`Hai 100 prodotti nel tuo carrello. Si prega di cancellare almeno un articolo prima di aggiungere un nuovo prodotto.`,
"c243":`{!ServiceResource.name} ha rifiutato l'ordine. Oggetto: "{!ServiceAppointment.subject}", Numero: "{!ServiceAppointment.name}"`,
"c548":`Task/Issue, subtask e progetto non possono essere modificati da un timesheet`,
"c807":`Invia ora`,
"c590":`Mappa di Germania`,
"c831":`Certificare`,
"c198":`Il tuo modulo è pubblicato in modo sicuro e può essere utilizzato al seguente URL per condividere il tuo modulo come link pubblico.`,
"c977":``,
"c66":`Le informazioni logistiche del prodotto sono aggiornate a Consegnato`,
"label.twitter.title.setting":`Informazioni integrate su Twitter`,
"c922":`Contattare l'amministratore per abilitare il Team`,
"front-email-payment-Invoice-Tips":`Si prega di contattare l'amministratore per abilitare PayPal o VISA e poi avviare il pagamento online`,
"c605":`	
Indirizzo di fatturazione predefinito`,
"c403":`Progetti`,
"c156":`Regole di presa dell'ordine per il lato mobile`,
"c635":`Programmare un altro post`,
"c753":`Partecipante`,
"c647":`Tutte le attività`,
"c295":`Dopo la disattivazione, tutti i campi personali di marcatura, la base di trattamento dei dati e altre informazioni per conformarsi al DGPR saranno rimossi tranne la cronologia delle operazioni per i record. Sei sicuro di spegnere?`,
"c915":`Piscina aperta`,
"front-electronic-signature-signStatus":`Hai iniziato la firma online. Lo stato del contratto è {signStauts}`,
"c568":`Regolare il layout`,
"c744":`Inserisci un numero valido tra 0 e 100`,
"c464":`i post vengono cancellati`,
"c385":`Riassunto del lavoro`,
"c392":`Scegli la soluzione di cui hai bisogno`,
"c418":`Risorse di servizio assegnate`,
"c256":`Cambiando account si cancella l'ordine con gli articoli selezionati. Sei sicuro di voler cambiare?`,
"c690":`Caricamento immagini`,
"c261":`Distruggere i dati`,
"c62":`Sollecitazione dei dipendenti`,
"c892":`Il record corrente non è stato trovato`,
"c909":`Le definizioni dei prezzi per questa valuta sono state aggiunte. Si prega di non aggiungere di nuovo!`,
"c883":`&`,
"c134":`Limite superiore dei membri del pool`,
"c896":`Il record è bloccato e non supporta l'aggiunta di file. Si prega di contattare l'amministratore per sbloccare`,
"c974":``,
"c209":`Dimensione media`,
"c185":`Statistica su questa pagina`,
"c796":`Si prega di contattare l'amministratore per impostare un modello di contratto sulla piattaforma Fadada prima di iniziare la firma.`,
"c60":`Conteggio del progetto`,
"c866":`Impostazione dell'applicazione`,
"c666":`Visualizza`,
"c219":`Il tuo post è stato cancellato`,
"c732":`Poster`,
"c155":`{Nome`,
"c511":`Econtratto`,
"c240":`Rifiutato`,
"c468":`Il tipo di ordinamento è vuoto`,
"c961":`Q{trimestre} {anno}`,
"c404":`Uno strumento per il marketing e la generazione di lead`,
"c586":`Mappa di Singapore`,
"c694":`Larghezza/altezza`,
"c297":`Inserisci il tipo di dati personali`,
"c860":`Cambia indirizzo`,
"c58":`Homepage del progetto`,
"c920":`Se si configurano regole di riciclo automatico, il sistema ricicla automaticamente i record nel pool quando il lead non è stato convertito dopo il limite di tempo. Questo migliora l'efficienza del followup dei lead.`,
"c27":`Inserite l'importo fluttuante per regolare l'importo lordo, per esempio,  10 o 10.`,
"c94":`3 volte su`,
"c1":`Solo mobile`,
"c557":`Casi ricevuti`,
"c294":`Disattivare le impostazioni di conformità al GDPR`,
"c970":``,
"c565":`Assegnare questo compito a`,
"c668":`Allineamento`,
"c972":``,
"c660":`Copyright`,
"c433":`Monitoraggio del campo del pool di piombo`,
"c443":`Archivio Tutti`,
"c275":`{0} ha un timeout di accettazione dell'ordine, e la spedizione viene annullata. Numero: {1}. Clicca per vedere di più >`,
"c691":`Collegamento (opzionale)`,
"c956":`Non hai ancora attivato il tuo account Mailchimp. Vai su impostazioni>integrazione>elenco delle integrazioni per attivare il tuo account Mailchimp o contatta l'amministratore.`,
"c910":`Nuovo ordine di lavoro`,
"c692":`Browser predefinito`,
"c355":`Aggiungere fogli di presenza in batch`,
"c122":`Immagine del prodotto`,
"c395":`Tipo di territorio`,
"c689":`Altezza massima`,
"c344":`Visualizzare il progetto con il diagramma di Gantt`,
"c656":`Tempo di aggiornamento`,
"c943":`Giappone`,
"front-electronic-signature-outerSinger":`Firmatario esterno`,
"front-generate-v1-invoiceDetail":`Dettaglio della fattura`,
"front-electronic-signature-open-vertify":`Si prega di inserire il codice di verifica`,
"c291":`Tipo di dati personali`,
"front-setting-phone-message":`Si prega di inserire il numero di telefono`,
"c559":`Casi aggravati`,
"label.google.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`Google map non funziona correttamente. Si prega di controllare se la chiave segreta è corretta!`,
"c259":`Nozioni di base sull'elaborazione dei dati`,
"c488":`Tempo invitato`,
"c6":`Nome della promozione`,
"front-electronic-signature-signerInfo":`Impostare le informazioni del firmatario`,
"c512":`Membri del progetto`,
"c507":`Coltivazione di piombo`,
"c760":`Rifiutato`,
"c756":`Nessun invio`,
"c321":`Richiesto o no`,
"c817":`Visualizza le impostazioni di autorizzazione del menu della pagina personalizzata`,
"c949":`Spagna`,
"label.biaoqing.field.relation.tip":`Bid&tender discovery field`,
"c382":`Punteggio netto di relazione`,
"c265":`Questo ordine non può essere cambiato perché non è ancora effettivo`,
"c417":`Informazioni sul lavoro delle risorse di servizio`,
"c847":`Conti Facebook`,
"c494":`Ottenete una gestione unificata di tutti i canali in CloudCC Marketing Cloud. Costruite connessioni e fiducia duratura con i vostri clienti, guidate il ROI con le analisi e trasformate la portata in ricavi.`,
"c86":`Campagna: Modifica del riferimento del dipendente`,
"c776":`Annullare con successo`,
"c709":`Scegliere una rete a cui connettersi`,
"label.mobile.orVerificationCode.is.error":`Il numero di telefono o l'errore del codice di verifica`,
"c579":`Grafico radar`,
"c413":`Stato dell'appuntamento di servizio`,
"c950":`Paesi Bassi`,
"c573":`Grafico a barre 2D`,
"label.choose.is.tax":`Scegliere il tipo di tassa`,
"c768":`Il compito di firma del contratto iniziato non è stato completato. Si prega di scaricare il documento dopo la firma del contratto.`,
"c604":`L'indirizzo di fatturazione esiste già, salvare l'attuale come nuovo indirizzo di fatturazione`,
"c160":`Trattamento in ritardo`,
"c239":`Accettato`,
"c834":`Preliminare Passato`,
"c113":`Invia {nome}`,
"c146":`I prodotti rilevanti saranno cancellati dopo aver cambiato la valuta. Vuoi continuare a cambiare?`,
"c313":`Inviare il file della fattura`,
"c140":`Scegliere l'oggetto e il modello`,
"c298":`Non conforme`,
"c681":`Cerchio`,
"c870":`Sei sicuro di cancellare in batch?`,
"c551":`<span style="fontsize: 16px; fontweight: bold; color: #fe8a14"> {days} </span> giorni rimanenti nel processo`,
"c88":`Giorni rimasti nel processo`,
"c175":`Impossibile ottenere informazioni dettagliate`,
"c64":`Se aprire o meno {objName}`,
"c319":`Impostazione dello stile del modulo`,
"label.pay.online":`Avviare il pagamento online`,
"c941":`Cina  Taiwan`,
"c550":`Scegli la data di inizio o di fine`,
"c365":`Sincronizzare la linea di quotazione con il prodotto di opportunità`,
"c908":`Selezionare l'icona`,
"c260":`Richiesta di distruzione`,
"c50":`Aliquota fiscale`,
"c869":`Sei sicuro di archiviare tutti i dati`,
"c93":`Aprire ripetutamente`,
"c280":`Cancellare l'email`,
"c23":`L'importo pagato sulla fattura sarà maggiore dell'importo dell'ordine se continui a creare questo dettaglio di pagamento. Per favore, regola l'importo e salva di nuovo.`,
"front-console-v1-see-contacts":`Ha identificato più contatti. Per favore seleziona`,
"c607":`L'indirizzo di spedizione esiste già, salvare l'attuale come nuovo indirizzo di fatturazione`,
"c229":`Cancellare la pietra miliare`,
"front-filter-v1-filter-by-name":`Filtra per '{nome}'`,
"c125":`In transito`,
"c513":`Fogli di presenza`,
"c80":`Indirizzo di fatturazione`,
"c648":`Conversazioni`,
"c521":`Conteggio degli ordinati`,
"c560":`Casi chiusi`,
"c973":``,
"c509":`Lista di imballaggio`,
"c685":`Aggiungi un nuovo indirizzo`,
"c178":`Il formato dell'immagine caricata non è supportato. Si prega di caricare immagini nel formato png, jpg e jpeg.`,
"c436":`Dettagli del visitatore`,
"front-electronic-signature-prepareTemplate":`Si prega di contattare l'amministratore per preimpostare il modello di contratto nel sistema prima di iniziare a firmare.`,
"c749":`Processo di firma`,
"c114":`Per favore, clicca sul pulsante Genera {nome} per generare {nome} prima dell'invio.`,
"c898":``,
"c279":`Vendite`,
"c232":`Non può superare il numero di prodotti da imballare`,
"c911":`Spedizione annullata`,
"c901":`Il tuo numero di invii ha raggiunto il limite.`,
"c663":`Testo alternativo`,
"c541":`Statistiche del caso attuale`,
"c536":`Ricevuto`,
"front-project-v1-batch-deletion-confirmation-information":`La cancellazione in blocco dei record selezionati cancellerà anche tutte le informazioni associate a quelli selezionati, e i dati non potranno essere recuperati. Sei sicuro di voler cancellare?`,
"c893":`L'utente attuale non può avere accesso alla modifica del campo dell'indirizzo di dettaglio dell'account`,
"c623":`Monitorare`,
"c493":`Dare forma al marketing digitale, cogliere tutte le opportunità`,
"c327":`Gerarchia delle risorse`,
"c747":`Il tuo numero totale di prodotti è pieno. Per favore cancella prima alcuni prodotti e poi continua ad aggiungere prodotti.`,
"c728":`Privacy dei dati`,
"front-reportlist-v1-optimizedReport":`i rapporti sono ottimizzati dopo la query. Si prega di non modificare in modo casuale.`,
"c741":`Si prega di compilare il contenuto della posta!`,
"c643":`Dettagli del post`,
"c537":`Tempo medio di risposta`,
"front-electronic-signature-add-field":`Aggiungere il campo di riempimento`,
"c626":`Tutti gli utenti`,
"c199":`Collegamento al modulo`,
"c917":`Utilizzate il pool per stimolare il potenziale del team e migliorare l'efficienza del followup degli account. L'amministratore del pool effettua una gestione unificata degli account e delle assegnazioni dei lotti. Il personale di vendita può anche vagliare i lead e ricevere i followup.`,
"c159":`La lunghezza dell'ordine non supera un massimo di`,
"c640":`Programma Posta`,
"c192":`Layout di pagina corrente:`,
"c978":``,
"c969":``,
"c871":`Questo è il modo in cui il tuo post verrà visualizzato su {a}. Lievi differenze possono verificarsi se {a} fa delle modifiche al layout.`,
"c814":`1{0} selezionato`,
"c235":`{!ServiceResource.name} ha accettato l'ordine. Oggetto: "{!ServiceAppointment.subject}", Numero: "{!ServiceAppointment.name}"`,
"c215":`Il tuo post è stato pubblicato`,
"c425":`Gestione degli appuntamenti di servizio`,
"c182":`L'ordine di lavoro e il record del caso non possono essere collegati contemporaneamente`,
"c194":`Limitare il numero di invii`,
"c657":`Nessun permesso di operare, si prega di contattare l'amministratore`,
"c855":`Sembra che non ci sia niente in programma.`,
"c333":`Costo del bilancio`,
"c338":`Fornitore  Distruggere`,
"c431":`Gerarchia della campagna`,
"c374":`Prezzo Libro Prodotto`,
"c506":`Programma automatizzato`,
"font-trade-module-invoice-totalMoney":`Totale crediti per fatture`,
"c203":`Condividi i tuoi moduli attraverso Mailchimp`,
"c962":`{mese} {anno}`,
"c786":`Numero di telefono/casella postale`,
"c469":`La pagina è in stato di modifica. I dati attuali non possono essere salvati se si lascia la pagina`,
"c137":`Scegliere un modello per il modulo`,
"c483":`Informazioni sulla campagna`,
"c947":`Francia`,
"c190":`La valuta delle voci di pagamento dovrebbe essere coerente con la valuta dell'ordine, della fattura e del pagamento. Per favore perfeziona la valuta e salva di nuovo.`,
"c386":`Realizzato`,
"c803":`Conti: Tutti i conti`,
"c759":`Per riempire`,
"c823":`Impostazione dell'ordine`,
"c422":`Metodo di generazione degli appuntamenti di servizio`,
"c782":`Come partecipare`,
"c416":`Rapporto di servizio Record di spinta`,
"c758":`Accettato`,
"c407":`Membro dell'equipaggio di servizio`,
"c51":`Nuova tassa`,
"c844":`Vincolare l'account DocuSign`,
"c361":`Menu Modifica`,
"c602":`Grafico a matrice`,
"c191":`È richiesto il permesso di modifica della vista corrente`,
"c299":`Seleziona almeno un oggetto`,
"c432":`Storia della campagna`,
"c650":`Pubblica un nuovo post per iniziare una nuova conversazione`,
"c531":`Conteggio dei casi ricevuti`,
"c13":`L'utente attuale non ha il permesso di modificare`,
"c162":`Informare simultaneamente il cedente e il cessionario`,
"c171":`Partecipazione azionaria`,
"c230":`Cancellare il compito`,
"c470":`Campi a riempimento automatico`,
"c367":`Generare il contratto`,
"c26":`Impostazione dello sconto`,
"c705":`Messaggi pubblicati`,
"c613":`Pagina esterna`,
"front-electronic-signature-openSign":`Iniziare a firmare`,
"c349":`Trascinare e rilasciare`,
"c683":`Caricare di più`,
"c679":`Grigio`,
"c914":`Barra laterale chiusa`,
"c224":`Vai alla pietra miliare`,
"c220":`Il tuo post è stato pubblicato senza successo`,
"c498":`CloudCC Inventory supporta efficacemente il business omnicanale online e offline, realizzando il flusso e la gestione di merci e fondi. I moduli multipli sono combinati in modo efficace e gli utenti possono ottenere una gestione raffinata degli ordini per creare situazioni vantaggiose per tutti con i partner.`,
"c566":`Recupera automaticamente l'indirizzo dell'account dopo il salvataggio`,
"front-electronic-signature-ContractTemplate":`Scegliere il modello di contratto`,
"c540":`Risolvere il tempo per canali`,
"c793":`Modelli di documenti`,
"c293":`Impostare gli oggetti per consentire la conformità al GDPR`,
"front-invoice-online-pay-again":`Hai già iniziato un pagamento online. Per favore, non provare di nuovo.`,
"front-electronic-signature-open-password":`Inserisci la password`,
"front-v1-partner-background-tooltip":`È supportato un massimo di 2M di file. Si raccomanda di caricare immagini chiare.`,
"c449":`Storia della chat`,
"c30":`Classico`,
"c245":`{!oldServiceResource.name} ha trasferito l'ordine di lavoro numerato {!ServiceAppointment.name} a {!newServiceResource.name}`,
"c923":`Ecco la vostra squadra`,
"c24":`Mostra mappa`,
"c872":`Nome (non compilato)`,
"c886":`Aprire la barra laterale`,
"c485":`Nome della forma:`,
"c101":`pc(s)`,
"c816":`Guarda il post`,
"c445":`Ruolo del progetto`,
"c853":`Questo mostra il numero di "mi piace" e di commenti per i tuoi post pubblicati.`,
"c398":`Inizia ora`,
"c522":`Conteggio delle fatture`,
"c287":`Conformità`,
"c578":`Grafico numerico MoM&YoY`,
"c40":`Inserisci la password`,
"c631":`Vedi su Twitter`,
"c489":`Tempo di disattivazione`,
"c819":`Numero di telefono/casella postale`,
"c935":`Tipo di modulo`,
"c625":`Tutte le campagne`,
"c471":`Campagna: Referral dei dipendenti`,
"front-electronic-signature-writen":`Riempito`,
"c889":`Disattivare l'account utente con successo`,
"c201":`Condividi questo modulo attraverso i tuoi social media`,
"c467":`Il campo di ordinamento è vuoto`,
"label.mobile.no.null":`Il numero di telefono non può essere vuoto`,
"c307":`Diritti`,
"front-kefu-moudle-wait-calling":`Chiamata in corso, si prega di riprovare più tardi`,
"c784":`Inserisci il nome dell'azienda sulla licenza commerciale`,
"c490":`Ultimo tempo di accesso`,
"c790":`Firma scritta a mano`,
"c336":`Conduttori  Distruggere`,
"c453":`Homepage Kanban`,
"c530":`Si prega di impostare prima la casella di posta elettronica aziendale`,
"c610":`L'icona si collegherà al dominio principale se non hai specificato l'URL`,
"c359":`Grafico`,
"c193":`Limitazioni`,
"label.mobile.verificationCode.exceeded.times":`Numero di tentativi superato. Si prega di richiedere nuovamente`,
"c138":`Modello di azienda`,
"c821":`Nuovi contatti interni`,
"c381":`Richiesta di pagamento online`,
"c761":`Firma`,
"c964":`Il campo della relazione masterdetail è obbligatorio`,
"c585":`Mappa di Regno Unito`,
"c500":`Fornite soluzioni di assistenza clienti onestop con processi standardizzati e gestione efficiente, coordinando le risorse di assistenza per fornire il miglior supporto ai vostri clienti.`,
"c214":`Includere bitmap in tre dimensioni e grafica vettoriale in tutti i formati`,
"c714":`Programma i post per pubblicarli al momento giusto.`,
"c552":`Rifiutato`,
"c684":`{sumTotalCount} di più`,
"c54":`Si prega di compilare il tipo di tassa`,
"c320":`Seleziona i campi del modulo`,
"c236":`{!ServiceResource.name} ha accettato l'ordine. Conto: "{!ServiceAppointment.accountid.name}", Numero: "{!ServiceAppointment.name}"`,
"c123":`Informazioni logistiche`,
"c654":`Torna alla lista dei cruscotti`,
"c335":`Margine di profitto`,
"c267":`Fallito il commit delle modifiche per il criterio non soddisfatto`,
"c226":`Vai al sottocompito`,
"c102":`Cliccare una volta`,
"c637":`Salvare come bozze`,
"c633":`Creare nuovi post sociali`,
"c777":`Impostare le informazioni del partecipante`,
"c223":`Aggiungi al progetto`,
"c592":`Grafico a cascata`,
"c315":`Solo gli ordini validi possono generare fatture`,
"c89":`Nome dell'evento email`,
"c108":`Automatch con successo`,
"c402":`Campo`,
"c748":`Seleziona un listino prezzi per {titolo}. Puoi aggiungere solo prodotti da un singolo listino. Cambiare il listino selezionato comporterà la cancellazione di tutti i prodotti esistenti.`,
"c501":`Fornire un servizio sul campo di qualità ai vostri clienti`,
"c269":`Impossibile unire le informazioni`,
"front-electronic-signature-open-confirm":`Vincolare l'account`,
"c584":`Mappa di Stati Uniti`,
"c437":`Unsuccessful`,
"c738":`Data di invio`,
"c274":`Si ha un timeout di accettazione dell'ordine, e l'invio viene annullato. Numero: {0}. Clicca per vedere di più >`,
"c83":`Dati di ricerca`,
"c206":`Formato PNG`,
"c309":`Inviare il file dell'ordine`,
"c539":`La più alta percentuale di fonti`,
"c304":`Interessi principali`,
"c151":`Descrivere brevemente il contenuto principale del modulo`,
"c639":`Invia ora`,
"c720":`No, grazie`,
"c801":`Nuovi contatti`,
"c900":`Nessuna informazione sull'indirizzo è disponibile per il visitatore, quindi la distanza del checkin non può essere calcolata.`,
"c695":`Dimensione originale`,
"c864":`Scegliere un modulo`,
"c881":`Ho letto e accettato`,
"c794":`Modello di firma`,
"c543":`Valutazioni ricevute`,
"c466":`Solo gli ordini che utilizzano lo stesso libro dei prezzi possono generare una fattura`,
"c867":`{userName} riceverà un'email di invito che richiederà di creare una password per accedere al tuo Centro assistenza.
Continuare?`,
"c529":`Nessun modo disponibile per ricaricare, si prega di contattare l'amministratore`,
"c742":`Si possono selezionare un massimo di 4 immagini e ognuna di esse non può superare i 200K. Clicca sull'immagine per selezionarla.`,
"c430":`Termine di ricerca delle prestazioni`,
"c553":`Ultimo tempo invitato`,
"c575":`Grafico a colonne`,
"c124":`Consegna in sospeso`,
"c629":`Unsuccessful`,
"c554":`Primo tempo invitato`,
"c547":`Ultimi 7 giorni`,
"c599":`Tabella dei grafici`,
"c588":`Mappa di Canada`,
"c703":`Via`,
"c713":`Crea post sociali dall'interno di CloudCC.`,
"c142":`Questa è l'azione che sarà intrapresa dopo che un visitatore invia il modulo sul tuo sito`,
"c153":`Dopo aver cancellato i prodotti associati al record corrente, puoi cambiare la valuta.`,
"c253":`Conformità GDPR`,
"c612":`Pagina interna`,
"c400":`Posizione delle risorse di servizio`,
"c671":`Icona e parola`,
"c20":`Non può superare la quantità da fatturare del relativo ordine.`,
"c514":`Grafici del rapporto`,
"c946":`Regno Unito`,
"c717":`Nuovo post`,
"c174":`Tutti modificati con successo`,
"c940":`Cina  Hong Kong`,
"c743":`Si prega di inserire numeri validi`,
"c441":`Gestione aziendale e finanziaria intelligente`,
"c423":`Piattaforma di spedizione`,
"c723":`Confermare per richiedere la distruzione`,
"c664":`Nessun social network`,
"c859":`Si prega di inserire {0}`,
"c356":`Costo previsto`,
"c221":`Vai al progetto`,
"front-email-payment-Invoice-Tips1":`Si prega di contattare l'amministratore per abilitare WeChat, Alipay, PayPal o VISA e poi avviare il pagamento online`,
"c99":`Prodotto QTY`,
"c278":`Vuoi cancellare le seguenti email?`,
"c364":`Linea di citazione`,
"c572":`I campi selezionati non possono essere vuoti, per favore aggiungi campo(i)`,
"c310":`Generare il file dell'ordine`,
"c247":`Trasferito`,
"c158":`Assegnazione della soglia temporale`,
"c325":`Modello di notifica di assegnazione del caso`,
"c877":`Riempire Nonordinato`,
"front-filter-v1-press":`Premere`,
"c505":`Monitoraggio dei visitatori`,
"c523":`Aggiungi come utente del portale`,
"c727":`Distruggere i dati con successo`,
"front-electronic-signature-sended":`Inviato`,
"c150":`Si prega di compilare le informazioni richieste`,
"c700":`ULTIMO TEMPO AGGIORNATO`,
"c824":`Firma in ordine`,
"c710":`Una casa per gestire tutti i tuoi social media`,
"c358":`Bilancio`,
"c544":`Canali`,
"c212":`Formato SVG`,
"c165":`Inserisci un valore intero da 024`,
"c932":`Spam`,
"c888":`Attivare l'account utente con successo`,
"c838":`Operatore`,
"c98":`Categoria di prodotto`,
"c830":`CREATO DA`,
"c661":`Rete`,
"c818":`Impostazioni del menu della pagina personalizzata`,
"c861":`Scegliere dalla mappa`,
"c736":`Inviato da`,
"c204":`Standard`,
"c839":`Sembra che non ci sia niente in programma.`,
"c456":`Importo pagato`,
"c341":`Conti finali`,
"c724":`Confermare la distruzione dei dati`,
"c865":`Ho letto e accetto {0} e {1}`,
"c332":`L'importo non può superare l'ordine da fatturare`,
"c520":`Pagamento fallito. Lo sconto disponibile non è sufficiente`,
"c906":`Meno`,
"c482":`Dai un nome al tuo Compagin:`,
"c49":`Aggiornare la configurazione di sicurezza del dominio`,
"c725":`Revocare la richiesta di distruggere con successo`,
"c76":`PAGARE`,
"c558":`Casi in attesa`,
"c876":`Segno Nonordinato`,
"front-invoices-v1-nofilles-tocreate":`Per favore, clicchi sul pulsante Generate Invoice per generare una fattura e poi inviarla.`,
"c779":`Termine ultimo per la firma`,
"c603":`Grafico biassiale MoM&YoY`,
"c455":`Obiettivo del contratto`,
"c428":`Spedizione in modalità mappa`,
"c55":`Si prega di compilare il valore fiscale`,
"c899":`Distanza del checkin`,
"label.facebook.title":`FacebookH5 MiniApp`,
"c487":`Nome del destinatario:`,
"label.social.posts.info":`Non è stato trovato alcun contenuto del post`,
"c704":`Pubblico`,
"c673":`Immagine web`,
"front-electronic-signature-singed":`Firma iniziata`,
"c722":`1 conto collegato`,
"c595":`Grafico dell'area`,
"c120":`tipo/i`,
"c68":`Ordine di pagamento`,
"c479":`CloudCC Forms Mailchimp`,
"front-electronic-signature-explain-mainTitle":`Firma elettronica e timbro`,
"c5":`Tassa`,
"c976":``,
"c812":`COMMENTI`,
"c532":`Conteggio dei casi di riposo`,
"c330":`Voce di contratto`,
"c249":`il post sta uscendo ora`,
"c630":`Vedi su LinkedIn`,
"c958":`L'ID del post Like non può essere vuoto`,
"c170":`Impossibile creare dati con l'id del record {0}, motivo fallito: {1};`,
"c810":`REPLIES`,
"c783":`Requisiti per la firma`,
"c968":``,
"c752":`Avviare l'attività di firma`,
"c439":`Visitatore`,
"c67":`Invia l'ordine con successo!`,
"front-generate-v1-invoice":`Generare la fattura`,
"c477":`Devi autenticarti con il tuo account MailChimp. Clicca su "Autentica MailChimp" e sarai reindirizzato a Mail Chimp per inviare le campagne.`,
"c966":`Contattare l'amministratore`,
"c764":`Rifiutato`,
"c301":`Si possono inserire fino a 200 caratteri`,
"c61":`Per favore, aprite prima la Conoscenza e poi usatela`,
"c815":`Archivia tutti`,
"c827":`Hai delle modifiche non salvate in questa pagina che andranno perse se continui.`,
"c688":`Larghezza massima`,
"c33":`Modifica il tipo di abbonamento`,
"c217":`il post sta uscendo {data}`,
"c721":`Scollegare un conto`,
"c284":`Elaborare la richiesta di dati dai clienti all'interno del CRM`,
"c939":`Cina  Macao`,
"c503":`Tenere traccia dell'avanzamento del progetto`,
"c492":`Invitato`,
"c73":`Saldo corrente`,
"label.the.peoples.republic.of.china":`Repubblica Popolare Cinese`,
"c828":`POST`,
"c36":`Anteprima`,
"c954":`Nuovo numero di telefono`,
"front-electronic-signature-innerSinger":`Firmatario interno`,
"c508":`Analisi del ROI`,
"c833":`Certificazione superata`,
"c207":`Formato vettoriale`,
"c31":`Metà schermo`,
"c71":`Si prega di scegliere un'opzione di pagamento`,
"c373":`Libro dei prezzi standard`,
"c545":`Tempo di risoluzione (h)`,
"c77":`Impostare il modulo`,
"label.lastcompiledate":`Ultimo tempo di compilazione`,
"c119":`Confermare la ricezione`,
"c281":`Elaborazione dei dati`,
"c715":`Monitorare le menzioni del marchio e rispondere rapidamente.`,
"c127":`Gestire le colonne`,
"c283":`Richiesta di dati`,
"c919":`Utilizzate il pool per stimolare il potenziale del team e migliorare il tasso di conversione dei lead. L'amministratore del pool effettua una gestione unificata dei lead e delle assegnazioni dei lotti. Il personale di vendita può anche vagliare i lead e ricevere followup.`,
"c82":`Solo per i fulmini`,
"front-file-delete-intro":`Il file è stato rimosso`,
"c606":`Indirizzo di spedizione predefinito`,
"c905":`Aggiungi`,
"c644":`TEMPO PUBBLICATO`,
"c75":`Saldo del rimborso`,
"c884":`Politica sulla privacy`,
"c538":`Tempo medio di risoluzione`,
"c322":`Nuova fattura`,
"c461":`Tendenza al pagamento`,
"c825":`Imprese`,
"c56":`Il totale dei crediti in fattura e l'importo del credito non sono coerenti. Si prega di riempire di nuovo.`,
"c931":`L'interruttore di posizionamento dei dipendenti non è stato abilitato e non è possibile utilizzare l'intervallo di condivisione della posizione. Continuare?`,
"c276":`Abilitare la conformità al GDPR`,
"c334":`Importo del bilancio`,
"c733":`Campagna: Nuovo poster`,
"c384":`Nuova lista di imballaggio`,
"c139":`Modello di riunione`,
"c957":`L'ID del commento del post non può essere vuoto`,
"front-electronic-signature-nosign":`Nessun fornitore di servizi di firma elettronica è stato scelto dalla tua organizzazione. Contatta l'amministratore per abilitare questo servizio.`,
"c419":`Piano di manutenzione`,
"c934":`Titolo della conversione`,
"c677":`Allineato a destra`,
"c593":`Grafico a linee`,
"c272":`{0} ha un timeout di accettazione dell'ordine. Conto: {1}, Oggetto: {2}, Numero: {3}. Clicca per vedere di più >`,
"c811":`RETWEETS`,
"c451":`Caso diviso`,
"c277":`Una volta cancellata l'email, anche le email seguenti saranno cancellate e non saranno inviate ai contatti futuri. Questo è irreversibile.`,
"c244":`{!ServiceResource.name} ha rifiutato l'ordine. Numero: "{!ServiceAppointment.name}"`,
"c627":`Pubblicato`,
"c601":`Grafico dell'obiettivo`,
"c251":`la pubblicazione di post è fallita`,
"c202":`Condividi in Mailchimp`,
"font-social-prohibit-create":`Non puoi creare un nuovo post mentre modifichi`,
"c394":`CloudCC vi aiuta a gestire l'attività online e a migliorare l'efficienza. Scegliete l'applicazione che desiderate utilizzare e seguite l'introduzione e la guida.`,
"c323":`Formato PDF`,
"front-setting-dialog-title-one":`Al fine di prevenire la perdita del conto, accedere rapidamente e recuperare facilmente, si prega di legare il numero di telefono`,
"front-electronic-signature-cancelIntro2":`Se questa è la prima volta che colleghi l'account, clicca su Continua per andare al passo successivo. Se stai rifacendo il binding dopo l'unbind, si raccomanda di fare clic su Annulla e rifare il binding dopo aver cancellato i dati di navigazione.`,
"c353":`Visualizzazione dei fogli di lavoro`,
"c621":`Contenuto ricco di testo`,
"front-v1-partner-image-tooltip":`È supportato un massimo di 2M di file. L'immagine sarà ridimensionata a {size}. Si raccomanda di caricare immagini chiare con proporzioni simili.`,
"c772":`Finalizzato`,
"c734":`Nome del canale del poster`,
"c380":`Nuovo pagamento`,
"c979":``,
"c233":`Non si può cancellare la lista di imballaggio dello stato spedito`,
"c458":`Mappa di distribuzione dei conti`,
"c697":`Scegliere l'indirizzo dell'account{nome}`,
"c476":`Scegliere il dipendente a cui inviare il codice d'invito`,
"c634":`Crea un post coinvolgente e connettiti con il mondo`,
"c144":`Il tempo di fine non può superare il 2038. Si prega di selezionare un nuovo tempo di fine.`,
"c474":`È possibile riassegnare usando le regole di assegnazione dei lead. Per le regole di assegnazione vedi`,
"c371":`Sincronizzazione con l'opportunità`,
"c420":`Attività di manutenzione`,
"c620":`Questo è usato per raggruppare più pezzi di contenuto per l'analisi di un singolo sforzo di marketing.`,
"c708":`Unificare la scala o no`,
"c100":`Sconto`,
"c576":`Grafico a colonne 2D`,
"c751":`Scadenza per la firma:`,
"c252":`Impostazioni di conformità`,
"c699":`Solo nuovo`,
"c74":`Paga per rimborso`,
"c805":`Scegli un social network per iniziare:`,
"c452":`Storia di un caso`,
"c740":`Seleziona un dipendente a cui inviare l'invito`,
"c596":`Grafico biassiale`,
"c832":`Revisione di`,
"c971":``,
"c262":`Storia`,
"c363":`Sensibile`,
"label.singleSignOn.is.invalid":`Loginfree non era valido`,
"c72":`Pagamento da parte di terzi`,
"c292":`Marketing`,
"c499":`Un servizio clienti efficiente per impressionare i clienti`,
"c574":`Grafico a barre impilate`,
"c618":`Cambia il contenuto o il tempo di pubblicazione di questo post.  Twitter non permette di pubblicare più di un post con lo stesso contenuto entro 24 ore.`,
"front-setting-phone-format":`Si prega di inserire il numero di telefono nel formato corretto`,
"c460":`Classifica delle dimensioni del conto`,
"c189":`La valuta della fattura dovrebbe essere coerente con la valuta dell'ordine. Per favore perfeziona la valuta e salva di nuovo.`,
"label.exe.supported.request.rejected":`Il file exe. non è supportato per essere inviato. La richiesta è rifiutata!`,
"c835":`Esiste già una fattura per questo preventivo. Continuare o no?`,
"c655":`Inviato da`,
"c45":`Collegati da`,
"c43":`Collegare l'account`,
"c481":`Accedi come un altro utente`,
"c674":`Indirizzo esterno`,
"c266":`Questo ordine non può essere cambiato perché è stato completato`,
"c967":``,
"c154":`Cerca i libri dei prezzi dopo aver selezionato i prodotti`,
"c841":`Hai delle idee? Abbozza pure.   `,
"c615":`Nessun account è stato selezionato`,
"c84":`Scegliere il dipendente per inviare il codice d'invito`,
"c401":`Servizio`,
"c290":`Oggetti abilitati`,
"c205":`Scaricare il codice QR`,
"c928":`È possibile selezionare fino a 10 campi.`,
"c195":`Limite di presentazione`,
"1":`Nessuna azione disponibile`,
"c46":`Autorizzare con successo`,
"c459":`Importo del contratto firmato`,
"c250":`i messaggi sono salvati come bozze`,
"c399":`Inventario`,
"c518":`Il #recordName di #label non ha superato l'approvazione per #failReason`,
"c396":`Scegliere diverse soluzioni`,
"c300":`Distruggere richiesto da`,
"c789":`Metodo di firma senza restrizioni`,
"c874":`Hai letto tutto quello che c'è nella tua casella di posta.`,
"c38":`Numero del blocco comunitario`,
"c228":`Aggiungi sottocompito`,
"c342":`Profitto`,
"c879":`Clonare i post sui social`,
"c173":`Rilegare con successo`,
"c778":`Iniziatore`,
"c211":`Dimensioni ridotte`,
"c496":`CloudCC Sales Cloud: un CRM intelligente per tutti gli scenari, che vi aiuterà a raggiungere i vostri obiettivi di vendita.`,
"c427":`Spedizione in modalità diagramma di Gantt`,
"c851":`Questo mostra il numero di post che sono stati pubblicati nei tuoi account nel periodo selezionato.`,
"c32":`Nuovo tipo di abbonamento`,
"c28":`Crescita anno su anno`,
"c163":`Informare e annullare simultaneamente la spedizione`,
"c225":`Vai al compito`,
"c569":`Scegliere prima l'account`,
"c92":`Aprire una volta`,
"c412":`Creazione automatica di un appuntamento di servizio`,
"c81":`Aggiungi al carrello`,
"c653":`Questo mostra il numero di like, reazioni e commenti per i tuoi post pubblicati. Questo include anche i post che sono stati pubblicati sui tuoi account collegati al di fuori di CloudCC Se stai cercando i retweet di Twitter, li troverai in Shares.`,
"c516":`Partecipazione`,
"c918":`Se si configurano regole di riciclo automatico, il sistema ricicla automaticamente i record nel pool quando l'account non ha chiuso l'affare dopo il limite di tempo. Questo migliora l'efficienza del followup degli account.`,
"c809":`LIKES`,
"c181":`Si prega di compilare l'ordine di lavoro o il fascicolo del caso`,
"c745":`Si prega di inserire fino a 2 cifre decimali`,
"c669":`Colore`,
"c929":`Controllare la connessione di rete`,
"c117":`Salvare e pagare`,
"c938":`Cina continentale`,
"c112":`Tutti i modelli {nome} sono attualmente disabilitati. Contatta l'amministratore per abilitare il modello prima di generare {nome}.`,
"c347":`Modifica delle ore di lavoro del compito del progetto`,
"c795":`Scegliere il modello di contratto`,
"c17":`Inattivo. Si prega di riselezionare`,
"c787":`Firmato dall'operatore`,
"c829":`CAMPAGNA`,
"c161":`Informare anche`,
"c65":`Vuoi cambiare lo stato logistico del prodotto in Consegnato`,
"c665":`Aggiungere un altro`,
"c767":`Controllare l'avanzamento della firma`,
"c87":`Codice QR del modulo della campagna`,
"c589":`Mappa di Francia`,
"front-electronic-signature-newTime":`Ultimo aggiornamento al`,
"c813":`CONDIVIDI`,
"c85":`{member} invitato selezionato`,
"c951":`Polonia`,
"c29":`Crescita mese per mese`,
"c210":`Grande dimensione`,
"c39":`Archiviato`,
"c672":`Parola`,
"c97":`Questo elenco dovrebbe contenere almeno un'opzione "Convertito".`,
"c687":`Dimensione massima`,
"c916":`Chiudere la piscina`,
"c475":`Si prega di compilare il proprietario della campagna`,
"c628":`Programmato`,
"c788":`Il listino prezzi per questa opportunità è attualmente disabilitato. Si prega di abilitare il libro dei prezzi prima di creare un nuovo ordine.`,
"c177":`Dimensione suggerita: 390*210`,
"c856":`Evviva! Nessun post senza successo.`,
"c70":`Informazioni sull'ordine`,
"c546":`Ultime 24 ore`,
"c331":`Convertire le attività`,
"label.order.paidamount.greater.than.total":`Dopo la creazione dei nuovi dettagli di pagamento, l'importo rimborsato dell'ordine sarà maggiore dell'importo dell'ordine. Si prega di riadattare il pagamento e poi salvarlo.`,
"c524":`Reinvitare`,
"c246":`{!oldServiceResource.name} ti ha trasferito l'ordine di lavoro numerato {!ServiceAppointment.name}.`,
"label.parameter.is.incorrect":`Parametri sbagliati`,
"c667":`Spaziatura delle icone`,
"c737":`Piattaforma sociale`,
"c48":`Scollegare`,
"c111":`Genera {nome}`,
"c755":`In sequenza`,
"c526":`Abilitare l'utente del portale`,
"c450":`Unire i casi`,
"front-electronic-export-reChoseChimp":`La vista attuale non ha record di dati e non può essere esportata. Si prega di selezionare una nuova vista`,
"label.invoice.paidamount.greater.than.total":`Dopo la creazione dei nuovi dettagli di pagamento, l'importo rimborsato della fattura sarà maggiore del valore totale. Per favore, riadatta il pagamento e poi salvalo.`,
"c222":`Modifica progetto`,
"c849":`Conti Twitter`,
"c678":`Bianco e nero`,
"c502":`Offriamo soluzioni complete per la gestione di tutti i processi coinvolti nei servizi sul campo per snellire le operazioni, migliorare la produttività, aumentare la fedeltà e la soddisfazione dei clienti.`,
"c497":`Inventario più intelligente, business più forte e gestione finanziaria`,
"c200":`Condividi sui social media`,
"c658":`Testo ricco`,
"c434":`Nuovo contatto correlato`,
"c641":`Puoi scegliere solo non più di 4 immagini, clicca sull'immagine selezionata per deselezionarla. La dimensione dell'immagine caricata dovrebbe essere inferiore a 200kb`,
"c944":`Germania`,
"c411":`Data di scadenza Offset`,
"c624":` Tutti i conti`,
"label.twitter.title":`TwitterH5 MiniApp`,
"c791":`Firma standard`,
"c306":`Sono d'accordo`,
"c14":`L'utente attuale non ha il permesso di cancellare`,
"c176":`Solo le immagini png, jpg e jpeg sono supportate per il caricamento. L'immagine caricata non può superare i 2M.`,
"c166":`Inserisci la lunghezza massima dell'ordine secondo le regole`,
"c731":`Cambiare il listino selezionato cancellerà anche tutti i prodotti esistenti. Sei sicuro di voler passare al nuovo listino?`,
"c237":`{!ServiceResource.name} ha accettato l'ordine. Numero: "{!ServiceAppointment.name}"`,
"c887":`Reinvitare l'utente con successo`,
"c227":`Modifica sottocompito`,
"c257":`Contatto disponibile`,
"c712":`Segnalare e confrontare le prestazioni tra le reti, i post e le campagne.`,
"c107":`Cerca gli utenti per nome, account e numero di cellulare`,
"c370":`Contratto`,
"c895":`Il calcolo della distanza non è riuscito, inserisci l'indirizzo completo`,
"c693":`Autoregolazione`,
"c763":`Firmato`,
"c302":`Interessi legittimi`,
"c577":`Grafico a colonne impilate`,
"c258":`Fare un reclamo`,
"c676":`Centro`,
"c868":`Dopo aver disattivato questo account, il sistema ne limiterà l'accesso o le operazioni nel portale. Continuare?`,
"c53":`Rapporto (%)`,
"c527":`#userName ti ha assegnato un compito di approvazione`,
"label.facebook.title.setting":`Informazioni integrate su Facebook`,
"c340":`Cambiare il proprietario del piano del progetto`,
"c706":`Informazioni sui grafici`,
"label.mobile.used":`Il numero di cellulare è stato usato`,
"c328":`Codice QR delle attività`,
"c337":`Contatti  Distruggere`,
"c642":`Immagini recenti`
}